// @ts-nocheck

export enum NCContext {
    Machine = "Machine",
    MaterialItem = "MaterialItem",
    Tool = "Tool",
    WorkOrderOperation = "WorkOrderOperation"
}

export enum ProductionTypeEnum {
    None = "None",
    Serialized = "Serialized",
    FlexibleSerialized = "FlexibleSerialized",
    FullQuantity = "FullQuantity",
    FullSerialized = "FullSerialized",
    TransferBatch = "TransferBatch",
    FlexibleBatch = "FlexibleBatch"
}

export enum DocumentRepositoryType {
    Local = "Local",
    Remote = "Remote"
}

export enum SupportedTypes {
    String = "String",
    Tinyint = "Tinyint",
    Smallint = "Smallint",
    Int = "Int",
    Bigint = "Bigint",
    Decimal = "Decimal",
    Bool = "Bool",
    Datetime = "Datetime",
    GUID = "GUID",
    Timespan = "Timespan",
    Quantity = "Quantity"
}

export enum StatusesOutcome {
    NoOutcome = "NoOutcome",
    Success = "Success",
    Failure = "Failure",
    Skip = "Skip"
}

export enum AMSerialNumberManagement {
    None = "None",
    Pending = "Pending",
    Assigned = "Assigned"
}

export enum ItlkCheckParameterDataTypeEnum {
    string_ = "string_",
    int_ = "int_",
    smallint_ = "smallint_",
    tinyint_ = "tinyint_",
    bigint_ = "bigint_",
    decimal_ = "decimal_",
    timespan_ = "timespan_",
    datetime_ = "datetime_",
    guid_ = "guid_",
    bool_ = "bool_"
}

export enum WorkInstructionDefinitionParameterDirection {
    Input_Output = "Input_Output",
    Input = "Input",
    Output = "Output"
}

export enum CharacteristicContext {
    Process = "Process",
    Product = "Product"
}

export enum TimeBasedUoM {
    minute = "minute",
    hour = "hour",
    day = "day"
}

export enum CharacteristicType {
    Attributive = "Attributive",
    Variable = "Variable",
    Visual = "Visual"
}

export enum MTUCodeType {
    BatchId = "BatchId",
    SerialNumber = "SerialNumber",
    None = "None"
}

export enum GF_MessageToHALPLevels {
    Info = "Info",
    Warning = "Warning",
    Error = "Error"
}

export enum ValidationPolicyEnum {
    Unordered = "Unordered",
    Sequential = "Sequential"
}

export enum SignatureTypeEnum {
    Role = "Role",
    SpecificUser = "SpecificUser"
}

export enum TagAcquisitionMode {
    CyclicContinuous = "CyclicContinuous",
    Undefined = "Undefined",
    OnChange = "OnChange"
}

export enum TagSmoothingMode {
    Value = "Value",
    None = "None"
}

export enum DataType {
    Bool = "Bool",
    Int = "Int",
    DInt = "DInt",
    LInt = "LInt",
    LReal = "LReal",
    Datetime = "Datetime",
    String = "String",
    Byte = "Byte",
    SInt = "SInt",
    Real = "Real",
    UInt = "UInt",
    UDInt = "UDInt",
    ULInt = "ULInt"
}

export enum TagDateTimeKind {
    Unspecified = "Unspecified",
    Local = "Local",
    Utc = "Utc"
}

export enum TagAddressType {
    NodeId = "NodeId",
    BrowsePath = "BrowsePath"
}

export enum ConnectionType {
    OPCUA = "OPCUA"
}

export enum SecurityPolicy {
    None = "None",
    Basic128Rsa15 = "Basic128Rsa15",
    Basic256 = "Basic256",
    Basic256Sha256 = "Basic256Sha256"
}

export enum MessageSecurityMode {
    None = "None",
    Sign = "Sign",
    SignAndEncrypt = "SignAndEncrypt"
}

export enum ConnectionFamilyType {
    Undefined = "Undefined",
    S7_1200 = "S7_1200",
    S7_1500 = "S7_1500"
}

export enum IdentityTokenType {
    Anonymous = "Anonymous",
    UsernamePassword = "UsernamePassword"
}

export enum ActivationFamilyType {
    TypesAndInstances = "TypesAndInstances",
    Channels = "Channels",
    ResetConfiguration = "ResetConfiguration"
}

export enum ImportMode {
    Reset = "Reset",
    Replace = "Replace",
    Preserve = "Preserve"
}

export enum TimeStampMode {
    None = "None",
    Source = "Source",
    Server = "Server",
    Both = "Both"
}

export enum ParameterType {
    Scalar = "Scalar",
    Array = "Array"
}

export enum ServerRedundancyFailoverMode {
    None = "None",
    HotA = "HotA"
}

export enum WorkInstructionDefinitionParameterDirection2 {
    Input_Output = "Input_Output",
    Input = "Input",
    Output = "Output"
}

export enum ErrorSeverityType {
    Error = "Error",
    Warning = "Warning"
}

export enum AlternativeOperationMTUStatus {
    Available = "Available",
    Unavailable = "Unavailable",
    Booked = "Booked",
    Consumed = "Consumed",
    Skipped = "Skipped"
}

export enum NCContext2 {
    Machine = "Machine",
    MaterialItem = "MaterialItem",
    Tool = "Tool",
    WorkOrderOperation = "WorkOrderOperation"
}

export enum ProductionTypeEnum2 {
    Serialized = "Serialized",
    FlexibleSerialized = "FlexibleSerialized",
    FullQuantity = "FullQuantity",
    FullSerialized = "FullSerialized",
    TransferBatch = "TransferBatch",
    FlexibleBatch = "FlexibleBatch",
    None = "None"
}

export enum SupportedTypes2 {
    String = "String",
    Tinyint = "Tinyint",
    Smallint = "Smallint",
    Int = "Int",
    Bigint = "Bigint",
    Decimal = "Decimal",
    Bool = "Bool",
    Datetime = "Datetime",
    GUID = "GUID",
    Timespan = "Timespan",
    Quantity = "Quantity"
}

export enum StatusesOutcome2 {
    NoOutcome = "NoOutcome",
    Success = "Success",
    Failure = "Failure",
    Skip = "Skip"
}

export enum LinkType {
    Never = "Never",
    IfAvailable = "IfAvailable",
    Always = "Always"
}

export enum MigrationLogLevel {
    Critical = "Critical",
    Error = "Error",
    Warning = "Warning",
    Informational = "Informational",
    Verbose = "Verbose"
}

export enum ValidationModeEnum {
    ApproveOrReject = "ApproveOrReject",
    Approve = "Approve"
}

export enum StatusScenarioEnum {
    Initial = "Initial",
    InProgress = "InProgress",
    Rejected = "Rejected",
    Approved = "Approved",
    Aborted = "Aborted"
}

export enum SignatureActionEnum {
    Approved = "Approved",
    Rejected = "Rejected"
}

export enum ESTicketStatus {
    Active = "Active",
    Used = "Used",
    Aborted = "Aborted"
}

export enum TaskDefinitionParameterDirections {
    Input_Output = "Input_Output",
    Input = "Input",
    Output = "Output"
}

export enum QualityActionType {
    GeneralQualityAction = "GeneralQualityAction"
}

export enum DocumentType {
    Local = "Local",
    Remote = "Remote"
}

export enum UrlSourceEnum {
    TCEWI = "TCEWI",
    Other = "Other"
}

export enum CharacteristicContext2 {
    Process = "Process",
    Product = "Product"
}

export enum CharacteristicType2 {
    Attributive = "Attributive",
    Variable = "Variable",
    Visual = "Visual"
}

export enum TimeBasedUoM2 {
    minute = "minute",
    hour = "hour",
    day = "day"
}

export enum ItlkCheckParameterDataTypeEnum2 {
    string_ = "string_",
    int_ = "int_",
    smallint_ = "smallint_",
    tinyint_ = "tinyint_",
    bigint_ = "bigint_",
    decimal_ = "decimal_",
    timespan_ = "timespan_",
    datetime_ = "datetime_",
    guid_ = "guid_",
    bool_ = "bool_"
}

export enum AMSerialNumberManagement2 {
    None = "None",
    Pending = "Pending",
    Assigned = "Assigned"
}

export enum MTUCodeType2 {
    BatchId = "BatchId",
    SerialNumber = "SerialNumber",
    None = "None"
}

export enum WorkInstructionStepType {
    Acknowledge = "Acknowledge",
    DataCollection = "DataCollection"
}

export enum AcquisitionType {
    Manual = "Manual",
    SemiAutomatic = "SemiAutomatic"
}

export enum AcquisitionBehaviour {
    Manual = "Manual",
    SemiAutomatic = "SemiAutomatic"
}

export enum PrimitiveTypes {
    String = "String",
    Tinyint = "Tinyint",
    Smallint = "Smallint",
    Int = "Int",
    Bigint = "Bigint",
    Decimal = "Decimal",
    Bool = "Bool",
    Datetime = "Datetime",
    GUID = "GUID",
    Timespan = "Timespan"
}

export enum ApplicationLogLevelType {
    Critical = "Critical",
    Error = "Error",
    Warning = "Warning",
    Informational = "Informational",
    Verbose = "Verbose"
}

export enum AutomationDataTypeEnum {
    Bool = "Bool",
    Int = "Int",
    DInt = "DInt",
    LInt = "LInt",
    LReal = "LReal",
    Datetime = "Datetime",
    String = "String",
    Byte = "Byte",
    SInt = "SInt",
    Real = "Real",
    UInt = "UInt",
    UDInt = "UDInt",
    ULInt = "ULInt"
}

export enum SegregationTagStatus {
    Available = "Available",
    Locked = "Locked"
}

export enum TimerModeEnum {
    OneShot = "OneShot",
    Periodic = "Periodic"
}

export enum TimerTypeEnum {
    Delay = "Delay",
    SpecificTime = "SpecificTime"
}

export interface LogMessageCatalog {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Owner` |
     * | Type | `Edm.String` |
     */
    Owner: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LanguageCode` |
     * | Type | `Edm.String` |
     */
    LanguageCode: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ShortMessage` |
     * | Type | `Edm.String` |
     */
    ShortMessage: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LongMessage` |
     * | Type | `Edm.String` |
     */
    LongMessage: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MessageId` |
     * | Type | `Edm.Int32` |
     */
    MessageId: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Level` |
     * | Type | `Siemens.SimaticIT.SystemData.Foundation.Types.ReadingModel.ApplicationLogLevelType` |
     */
    Level: ApplicationLogLevelType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogMessageCatalogParameters` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.LogMessageCatalogParameters)` |
     */
    LogMessageCatalogParameters?: Array<LogMessageCatalogParameters>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogMessageCatalogLanguages` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.LogMessageCatalogLanguages)` |
     */
    LogMessageCatalogLanguages?: Array<LogMessageCatalogLanguages>;
}

export type LogMessageCatalogId = string | {Id: string};

export interface LogMessageCatalogParameters {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterKey` |
     * | Type | `Edm.String` |
     */
    ParameterKey: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterType` |
     * | Type | `Edm.String` |
     */
    ParameterType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogMessageCatalog_Id` |
     * | Type | `Edm.Guid` |
     */
    LogMessageCatalog_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogMessageCatalog` |
     * | Type | `Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.LogMessageCatalog` |
     */
    LogMessageCatalog?: LogMessageCatalog | null;
}

export type LogMessageCatalogParametersId = string | {Id: string};

export interface LogMessageCatalogLanguages {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LanguageCode` |
     * | Type | `Edm.String` |
     */
    LanguageCode: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ShortMessage` |
     * | Type | `Edm.String` |
     */
    ShortMessage: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LongMessage` |
     * | Type | `Edm.String` |
     */
    LongMessage: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogMessageCatalog_Id` |
     * | Type | `Edm.Guid` |
     */
    LogMessageCatalog_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogMessageCatalog` |
     * | Type | `Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.LogMessageCatalog` |
     */
    LogMessageCatalog?: LogMessageCatalog | null;
}

export type LogMessageCatalogLanguagesId = string | {Id: string};

export interface File {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Type` |
     * | Type | `Edm.String` |
     */
    Type: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PayloadSize` |
     * | Type | `Edm.Int64` |
     */
    PayloadSize: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedBy` |
     * | Type | `Edm.String` |
     */
    CreatedBy: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedBy` |
     * | Type | `Edm.String` |
     */
    LastUpdatedBy: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Folder_Id` |
     * | Type | `Edm.Guid` |
     */
    Folder_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Folder` |
     * | Type | `Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.Folder` |
     */
    Folder?: Folder | null;
}

export type FileId = string | {Id: string};

export interface Folder {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentFolder_Id` |
     * | Type | `Edm.Guid` |
     */
    ParentFolder_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentFolder` |
     * | Type | `Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.Folder` |
     */
    ParentFolder?: Folder | null;
}

export type FolderId = string | {Id: string};

export interface SegregationTag {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Color` |
     * | Type | `Edm.String` |
     */
    Color: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TagStatus` |
     * | Type | `Siemens.SimaticIT.SystemData.Foundation.Types.ReadingModel.SegregationTagStatus` |
     */
    TagStatus: SegregationTagStatus | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLogRelevant` |
     * | Type | `Edm.Boolean` |
     */
    IsLogRelevant: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
}

export type SegregationTagId = string | {Id: string};

export interface WorkOrderFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrder_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrder_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrder` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrder` |
     */
    WorkOrder?: WorkOrder | null;
}

export type WorkOrderFacetId = string | {Id: string};

export interface OperationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Operation_Id` |
     * | Type | `Edm.Guid` |
     */
    Operation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Operation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Operation` |
     */
    Operation?: Operation | null;
}

export type OperationFacetId = string | {Id: string};

export interface APSOrderOperationStatus {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Int32` |
     * | Nullable | `false` |
     */
    Id: number;
}

export type APSOrderOperationStatusId = number | {Id: number};

export interface APSOrderStatus {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Int32` |
     * | Nullable | `false` |
     */
    Id: number;
}

export type APSOrderStatusId = number | {Id: number};

export interface APSResource {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResourceName` |
     * | Type | `Edm.String` |
     */
    ResourceName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResourceNId` |
     * | Type | `Edm.String` |
     */
    ResourceNId: string | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export type APSResourceId = string | {Id: string};

export interface APSOperationRelation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationNId` |
     * | Type | `Edm.String` |
     */
    OperationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PredecessorOperationNId` |
     * | Type | `Edm.String` |
     */
    PredecessorOperationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Type` |
     * | Type | `Edm.String` |
     */
    Type: string | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DependencyType` |
     * | Type | `Edm.Int32` |
     */
    DependencyType: number | null;
}

export type APSOperationRelationId = string | {Id: string};

export interface APSOperationResource {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationNId` |
     * | Type | `Edm.String` |
     */
    OperationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResourceNId` |
     * | Type | `Edm.String` |
     */
    ResourceNId: string | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Type` |
     * | Type | `Edm.Int32` |
     */
    Type: number | null;
}

export type APSOperationResourceId = string | {Id: string};

export interface APSOrder {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DueDate` |
     * | Type | `Edm.DateTimeOffset` |
     */
    DueDate: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OrderNId` |
     * | Type | `Edm.String` |
     */
    OrderNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OrderNote` |
     * | Type | `Edm.String` |
     */
    OrderNote: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Priority` |
     * | Type | `Edm.Int32` |
     */
    Priority: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProductName` |
     * | Type | `Edm.String` |
     */
    ProductName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProductNId` |
     * | Type | `Edm.String` |
     */
    ProductNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OrderStatus` |
     * | Type | `Edm.String` |
     */
    OrderStatus: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Type` |
     * | Type | `Edm.String` |
     */
    Type: string | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProductionType` |
     * | Type | `Edm.Int32` |
     */
    ProductionType: number | null;
}

export type APSOrderId = string | {Id: string};

export interface APSOrderOperation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualEndTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    ActualEndTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualResourceNId` |
     * | Type | `Edm.String` |
     */
    ActualResourceNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualStartTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    ActualStartTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Locked` |
     * | Type | `Edm.Int32` |
     */
    Locked: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationName` |
     * | Type | `Edm.String` |
     */
    OperationName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationNId` |
     * | Type | `Edm.String` |
     */
    OperationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationSequence` |
     * | Type | `Edm.Int32` |
     */
    OperationSequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OrderNId` |
     * | Type | `Edm.String` |
     */
    OrderNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessRate` |
     * | Type | `Edm.Decimal` |
     */
    ProcessRate: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessTime` |
     * | Type | `Edm.Int64` |
     */
    ProcessTime: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessTimeType` |
     * | Type | `Edm.Int32` |
     */
    ProcessTimeType: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationStatus` |
     * | Type | `Edm.String` |
     */
    OperationStatus: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Type` |
     * | Type | `Edm.String` |
     */
    Type: string | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export type APSOrderOperationId = string | {Id: string};

export interface EXDSOpLandingEGSearch {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WONId` |
     * | Type | `Edm.String` |
     */
    WONId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOName` |
     * | Type | `Edm.String` |
     */
    WOName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WODueDate` |
     * | Type | `Edm.DateTimeOffset` |
     */
    WODueDate: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOEstimatedStartTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    WOEstimatedStartTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOEstimatedEndTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    WOEstimatedEndTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOERPOrder` |
     * | Type | `Edm.String` |
     */
    WOERPOrder: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOInitialQuantity` |
     * | Type | `Edm.Decimal` |
     */
    WOInitialQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOActualTargetQuantity` |
     * | Type | `Edm.Decimal` |
     */
    WOActualTargetQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOPlannedTargetQuantity` |
     * | Type | `Edm.Decimal` |
     */
    WOPlannedTargetQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOTargetQuantity` |
     * | Type | `Edm.Decimal` |
     */
    WOTargetQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOEnterprise` |
     * | Type | `Edm.String` |
     */
    WOEnterprise: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOPlant` |
     * | Type | `Edm.String` |
     */
    WOPlant: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOPriority` |
     * | Type | `Edm.Int32` |
     */
    WOPriority: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WODMFinalMaterialId` |
     * | Type | `Edm.Guid` |
     */
    WODMFinalMaterialId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOStatusNId` |
     * | Type | `Edm.String` |
     */
    WOStatusNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FinalMaterialId` |
     * | Type | `Edm.Guid` |
     */
    FinalMaterialId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FinalMaterialNId` |
     * | Type | `Edm.String` |
     */
    FinalMaterialNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FinalMaterialName` |
     * | Type | `Edm.String` |
     */
    FinalMaterialName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOONId` |
     * | Type | `Edm.String` |
     */
    WOONId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOName` |
     * | Type | `Edm.String` |
     */
    WOOName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOODescription` |
     * | Type | `Edm.String` |
     */
    WOODescription: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOElectronicSignatureStart` |
     * | Type | `Edm.Boolean` |
     */
    WOOElectronicSignatureStart: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOEstimatedStartTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    WOOEstimatedStartTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOEstimatedEndTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    WOOEstimatedEndTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOActualStartTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    WOOActualStartTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOActualEndTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    WOOActualEndTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOEstimatedDurationTicks` |
     * | Type | `Edm.Int64` |
     */
    WOOEstimatedDurationTicks: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOPriority` |
     * | Type | `Edm.Int32` |
     */
    WOOPriority: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOSequence` |
     * | Type | `Edm.Int32` |
     */
    WOOSequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOIsReady` |
     * | Type | `Edm.Boolean` |
     */
    WOOIsReady: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOExecutionDurationTicks` |
     * | Type | `Edm.Int64` |
     */
    WOOExecutionDurationTicks: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOOptional` |
     * | Type | `Edm.Boolean` |
     */
    WOOOptional: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOSkippable` |
     * | Type | `Edm.Boolean` |
     */
    WOOSkippable: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOPauseDurationTicks` |
     * | Type | `Edm.Int64` |
     */
    WOOPauseDurationTicks: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOStatus` |
     * | Type | `Edm.String` |
     */
    WOOStatus: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOAvailableQuantity` |
     * | Type | `Edm.Decimal` |
     */
    WOOAvailableQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOTargetQuantity` |
     * | Type | `Edm.Decimal` |
     */
    WOOTargetQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOProducedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    WOOProducedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOPartialWorkedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    WOOPartialWorkedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOReworkedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    WOOReworkedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOActiveNonConformanceNr` |
     * | Type | `Edm.Int32` |
     */
    WOOActiveNonConformanceNr: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProductionTypeNId` |
     * | Type | `Edm.String` |
     */
    ProductionTypeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `wooTypeNId` |
     * | Type | `Edm.String` |
     */
    wooTypeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AM` |
     * | Type | `Edm.Boolean` |
     */
    AM: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutoStart` |
     * | Type | `Edm.Boolean` |
     */
    AutoStart: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutoComplete` |
     * | Type | `Edm.Boolean` |
     */
    AutoComplete: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOStateMachineNId` |
     * | Type | `Edm.String` |
     */
    WOStateMachineNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOStateMachineNId` |
     * | Type | `Edm.String` |
     */
    WOOStateMachineNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `egPhaseId` |
     * | Type | `Edm.Guid` |
     */
    egPhaseId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `egWOOId` |
     * | Type | `Edm.Guid` |
     */
    egWOOId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `egPhaseStatus` |
     * | Type | `Edm.String` |
     */
    egPhaseStatus: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `egPhaseSequence` |
     * | Type | `Edm.Int32` |
     */
    egPhaseSequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `egPhaseEstimatedDurationTicks` |
     * | Type | `Edm.Int64` |
     */
    egPhaseEstimatedDurationTicks: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `egPhaseEstimatedStartTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    egPhaseEstimatedStartTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `egPhaseEstimatedEndTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    egPhaseEstimatedEndTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `egPhaseStateMachineNId` |
     * | Type | `Edm.String` |
     */
    egPhaseStateMachineNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PreferredMachineNId` |
     * | Type | `Edm.String` |
     */
    PreferredMachineNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `egNId` |
     * | Type | `Edm.String` |
     */
    egNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `egName` |
     * | Type | `Edm.String` |
     */
    egName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `egDescription` |
     * | Type | `Edm.String` |
     */
    egDescription: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `egEstimatedDuration` |
     * | Type | `Edm.Int64` |
     */
    egEstimatedDuration: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `egEstimatedStartTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    egEstimatedStartTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `egEstimatedEndTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    egEstimatedEndTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `egIsUnderScheduling` |
     * | Type | `Edm.Boolean` |
     */
    egIsUnderScheduling: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `egSchedulingDate` |
     * | Type | `Edm.DateTimeOffset` |
     */
    egSchedulingDate: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `egStatus` |
     * | Type | `Edm.String` |
     */
    egStatus: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `egStateMachineNId` |
     * | Type | `Edm.String` |
     */
    egStateMachineNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `egAssociationId` |
     * | Type | `Edm.Guid` |
     */
    egAssociationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOKoQuantity` |
     * | Type | `Edm.Decimal` |
     */
    WOOKoQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOOkQuantity` |
     * | Type | `Edm.Decimal` |
     */
    WOOOkQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `egPhaseName` |
     * | Type | `Edm.String` |
     */
    egPhaseName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `egDueDate` |
     * | Type | `Edm.DateTimeOffset` |
     */
    egDueDate: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOId` |
     * | Type | `Edm.Guid` |
     */
    WOId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOId` |
     * | Type | `Edm.Guid` |
     */
    WOOId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `egId` |
     * | Type | `Edm.Guid` |
     */
    egId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `egCreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    egCreatedOn: string | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedMachines` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EXDSOpLandingMachineEGSearch)` |
     */
    ToBeUsedMachines?: Array<EXDSOpLandingMachineEGSearch>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedMaterials` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EXDSOpLandingProducedMaterialsEGSearch)` |
     */
    ProducedMaterials?: Array<EXDSOpLandingProducedMaterialsEGSearch>;
}

export type EXDSOpLandingEGSearchId = string | {Id: string};

export interface EXDSOpLandingWOOSearch {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WONId` |
     * | Type | `Edm.String` |
     */
    WONId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOName` |
     * | Type | `Edm.String` |
     */
    WOName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WODueDate` |
     * | Type | `Edm.DateTimeOffset` |
     */
    WODueDate: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOEstimatedStartTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    WOEstimatedStartTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOEstimatedEndTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    WOEstimatedEndTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOERPOrder` |
     * | Type | `Edm.String` |
     */
    WOERPOrder: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOInitialQuantity` |
     * | Type | `Edm.Decimal` |
     */
    WOInitialQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOActualTargetQuantity` |
     * | Type | `Edm.Decimal` |
     */
    WOActualTargetQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOPlannedTargetQuantity` |
     * | Type | `Edm.Decimal` |
     */
    WOPlannedTargetQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOTargetQuantity` |
     * | Type | `Edm.Decimal` |
     */
    WOTargetQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOEnterprise` |
     * | Type | `Edm.String` |
     */
    WOEnterprise: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOPlant` |
     * | Type | `Edm.String` |
     */
    WOPlant: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOPriority` |
     * | Type | `Edm.Int32` |
     */
    WOPriority: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WODMFinalMaterialId` |
     * | Type | `Edm.Guid` |
     */
    WODMFinalMaterialId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOStatusNId` |
     * | Type | `Edm.String` |
     */
    WOStatusNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FinalMaterialId` |
     * | Type | `Edm.Guid` |
     */
    FinalMaterialId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FinalMaterialNId` |
     * | Type | `Edm.String` |
     */
    FinalMaterialNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FinalMaterialName` |
     * | Type | `Edm.String` |
     */
    FinalMaterialName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOONId` |
     * | Type | `Edm.String` |
     */
    WOONId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOName` |
     * | Type | `Edm.String` |
     */
    WOOName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOODescription` |
     * | Type | `Edm.String` |
     */
    WOODescription: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOElectronicSignatureStart` |
     * | Type | `Edm.Boolean` |
     */
    WOOElectronicSignatureStart: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOEstimatedStartTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    WOOEstimatedStartTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOEstimatedEndTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    WOOEstimatedEndTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOActualStartTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    WOOActualStartTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOActualEndTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    WOOActualEndTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOEstimatedDurationTicks` |
     * | Type | `Edm.Int64` |
     */
    WOOEstimatedDurationTicks: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOPriority` |
     * | Type | `Edm.Int32` |
     */
    WOOPriority: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOSequence` |
     * | Type | `Edm.Int32` |
     */
    WOOSequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOIsReady` |
     * | Type | `Edm.Boolean` |
     */
    WOOIsReady: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOExecutionDurationTicks` |
     * | Type | `Edm.Int64` |
     */
    WOOExecutionDurationTicks: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOOptional` |
     * | Type | `Edm.Boolean` |
     */
    WOOOptional: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOSkippable` |
     * | Type | `Edm.Boolean` |
     */
    WOOSkippable: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOPauseDurationTicks` |
     * | Type | `Edm.Int64` |
     */
    WOOPauseDurationTicks: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOStatus` |
     * | Type | `Edm.String` |
     */
    WOOStatus: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOAvailableQuantity` |
     * | Type | `Edm.Decimal` |
     */
    WOOAvailableQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOTargetQuantity` |
     * | Type | `Edm.Decimal` |
     */
    WOOTargetQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOProducedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    WOOProducedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOPartialWorkedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    WOOPartialWorkedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOReworkedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    WOOReworkedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOActiveNonConformanceNr` |
     * | Type | `Edm.Int32` |
     */
    WOOActiveNonConformanceNr: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProductionTypeNId` |
     * | Type | `Edm.String` |
     */
    ProductionTypeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `wooTypeNId` |
     * | Type | `Edm.String` |
     */
    wooTypeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AM` |
     * | Type | `Edm.Boolean` |
     */
    AM: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutoStart` |
     * | Type | `Edm.Boolean` |
     */
    AutoStart: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutoComplete` |
     * | Type | `Edm.Boolean` |
     */
    AutoComplete: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOStateMachineNId` |
     * | Type | `Edm.String` |
     */
    WOStateMachineNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOStateMachineNId` |
     * | Type | `Edm.String` |
     */
    WOOStateMachineNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FacetId` |
     * | Type | `Edm.Guid` |
     */
    FacetId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FacetCheckedOutOffline` |
     * | Type | `Edm.Boolean` |
     */
    FacetCheckedOutOffline: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExistsContainer` |
     * | Type | `Edm.Int32` |
     */
    ExistsContainer: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOScrappedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    WOOScrappedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOElectronicSignaturePause` |
     * | Type | `Edm.Boolean` |
     */
    WOOElectronicSignaturePause: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOElectronicSignatureComplete` |
     * | Type | `Edm.Boolean` |
     */
    WOOElectronicSignatureComplete: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOToBeCollectedDocument` |
     * | Type | `Edm.Boolean` |
     */
    WOOToBeCollectedDocument: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RealInitialQty` |
     * | Type | `Edm.Decimal` |
     */
    RealInitialQty: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOScrappedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    WOScrappedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExistsExecutionGroup` |
     * | Type | `Edm.Int32` |
     */
    ExistsExecutionGroup: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationStepCategoryId` |
     * | Type | `Edm.Guid` |
     */
    OperationStepCategoryId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PreferredMachineNId` |
     * | Type | `Edm.String` |
     */
    PreferredMachineNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOId` |
     * | Type | `Edm.Guid` |
     */
    WOId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOId` |
     * | Type | `Edm.Guid` |
     */
    WOOId: string | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOKoQuantity` |
     * | Type | `Edm.Decimal` |
     */
    WOOKoQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOOkQuantity` |
     * | Type | `Edm.Decimal` |
     */
    WOOOkQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Frequency` |
     * | Type | `Edm.Decimal` |
     */
    Frequency: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EngineCounter` |
     * | Type | `Edm.Decimal` |
     */
    EngineCounter: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedMachines` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EXDSOpLandingMachineSearch)` |
     */
    ToBeUsedMachines?: Array<EXDSOpLandingMachineSearch>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedMaterials` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EXDSOpLandingProducedMaterialsSearch)` |
     */
    ProducedMaterials?: Array<EXDSOpLandingProducedMaterialsSearch>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedMaterialsContainer` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EXDSOpLandingProducedMaterialsContainerSearch)` |
     */
    ProducedMaterialsContainer?: Array<EXDSOpLandingProducedMaterialsContainerSearch>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AssignedUsers` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EXDSOpLandingAssignedUsersSearch)` |
     */
    AssignedUsers?: Array<EXDSOpLandingAssignedUsersSearch>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TimeBasedInspectionEngines` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EXDSOpLandingTimeBasedInspection)` |
     */
    TimeBasedInspectionEngines?: Array<EXDSOpLandingTimeBasedInspection>;
}

export type EXDSOpLandingWOOSearchId = string | {Id: string};

export interface EXDSAsBuiltMaterials {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WONId` |
     * | Type | `Edm.String` |
     */
    WONId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOpName` |
     * | Type | `Edm.String` |
     */
    WOOpName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOpSequence` |
     * | Type | `Edm.Int32` |
     */
    WOOpSequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOpStatusNId` |
     * | Type | `Edm.String` |
     */
    WOOpStatusNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOStepId` |
     * | Type | `Edm.Guid` |
     */
    WOStepId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOStepName` |
     * | Type | `Edm.String` |
     */
    WOStepName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOStepSequence` |
     * | Type | `Edm.Int32` |
     */
    WOStepSequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOStepStatusNId` |
     * | Type | `Edm.String` |
     */
    WOStepStatusNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MTUNId` |
     * | Type | `Edm.String` |
     */
    MTUNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Code` |
     * | Type | `Edm.String` |
     */
    Code: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoMNId` |
     * | Type | `Edm.String` |
     */
    UoMNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialSpecificationType` |
     * | Type | `Edm.String` |
     */
    MaterialSpecificationType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialNId` |
     * | Type | `Edm.String` |
     */
    MaterialNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialClassNId` |
     * | Type | `Edm.String` |
     */
    MaterialClassNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RecycleCount` |
     * | Type | `Edm.Int32` |
     */
    RecycleCount: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaxRecycleCount` |
     * | Type | `Edm.Int32` |
     */
    MaxRecycleCount: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MinQuantity` |
     * | Type | `Edm.Decimal` |
     */
    MinQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `HistoryAction` |
     * | Type | `Edm.String` |
     */
    HistoryAction: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetCode` |
     * | Type | `Edm.String` |
     */
    TargetCode: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `QuantityAssembled` |
     * | Type | `Edm.Decimal` |
     */
    QuantityAssembled: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `QuantityDisassembled` |
     * | Type | `Edm.Decimal` |
     */
    QuantityDisassembled: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserId` |
     * | Type | `Edm.String` |
     */
    UserId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EgPhaseNId` |
     * | Type | `Edm.String` |
     */
    EgPhaseNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EgNId` |
     * | Type | `Edm.String` |
     */
    EgNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ConsumptionDateTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    ConsumptionDateTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogicalPosition` |
     * | Type | `Edm.String` |
     */
    LogicalPosition: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OccurenceId` |
     * | Type | `Edm.String` |
     */
    OccurenceId: string | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOId` |
     * | Type | `Edm.Guid` |
     */
    WOId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOpId` |
     * | Type | `Edm.Guid` |
     */
    WOOpId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MTUId` |
     * | Type | `Edm.Guid` |
     */
    DM_MTUId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
}

export type EXDSAsBuiltMaterialsId = string | {Id: string};

export interface EXDSOpLandingMachineSearch {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Machine` |
     * | Type | `Edm.String` |
     */
    Machine: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Preferred` |
     * | Type | `Edm.Boolean` |
     */
    Preferred: boolean | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOSearchId_Id` |
     * | Type | `Edm.Guid` |
     */
    WOOSearchId_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOSearchId` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EXDSOpLandingWOOSearch` |
     */
    WOOSearchId?: EXDSOpLandingWOOSearch | null;
}

export type EXDSOpLandingMachineSearchId = string | {Id: string};

export interface EXDSOpLandingProducedMaterialsSearch {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `mtuCode` |
     * | Type | `Edm.String` |
     */
    mtuCode: string | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOSearchId_Id` |
     * | Type | `Edm.Guid` |
     */
    WOOSearchId_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOSearchId` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EXDSOpLandingWOOSearch` |
     */
    WOOSearchId?: EXDSOpLandingWOOSearch | null;
}

export type EXDSOpLandingProducedMaterialsSearchId = string | {Id: string};

export interface EXDSOpLandingActConsMatWOOp {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Code` |
     * | Type | `Edm.String` |
     */
    Code: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialConsumptionStatus` |
     * | Type | `Edm.String` |
     */
    MaterialConsumptionStatus: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItemAssembledQty` |
     * | Type | `Edm.Decimal` |
     */
    MaterialItemAssembledQty: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedMaterialItemActualQty` |
     * | Type | `Edm.Decimal` |
     */
    ProducedMaterialItemActualQty: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualConsumedTotalQty` |
     * | Type | `Edm.Decimal` |
     */
    ActualConsumedTotalQty: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualConsumedCode` |
     * | Type | `Edm.String` |
     */
    ActualConsumedCode: string | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOpId` |
     * | Type | `Edm.Guid` |
     */
    WOOpId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeConsumedId` |
     * | Type | `Edm.Guid` |
     */
    ToBeConsumedId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualConsumedId` |
     * | Type | `Edm.Guid` |
     */
    ActualConsumedId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedMaterialItemId_Id` |
     * | Type | `Edm.Guid` |
     */
    ProducedMaterialItemId_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedMaterialItemId` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EXDSOpLandingActProducedWOOp` |
     */
    ProducedMaterialItemId?: EXDSOpLandingActProducedWOOp | null;
}

export type EXDSOpLandingActConsMatWOOpId = string | {Id: string};

export interface EXDSOpLandingActConsMatWOStep {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Code` |
     * | Type | `Edm.String` |
     */
    Code: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialConsumptionStatus` |
     * | Type | `Edm.String` |
     */
    MaterialConsumptionStatus: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItemAssembledQty` |
     * | Type | `Edm.Decimal` |
     */
    MaterialItemAssembledQty: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedMaterialItemActualQty` |
     * | Type | `Edm.Decimal` |
     */
    ProducedMaterialItemActualQty: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualConsumedTotalQty` |
     * | Type | `Edm.Decimal` |
     */
    ActualConsumedTotalQty: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualConsumedCode` |
     * | Type | `Edm.String` |
     */
    ActualConsumedCode: string | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOStepId` |
     * | Type | `Edm.Guid` |
     */
    WOStepId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeConsumedId` |
     * | Type | `Edm.Guid` |
     */
    ToBeConsumedId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualConsumedId` |
     * | Type | `Edm.Guid` |
     */
    ActualConsumedId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedMaterialItemId_Id` |
     * | Type | `Edm.Guid` |
     */
    ProducedMaterialItemId_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedMaterialItemId` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EXDSOpLandingActProducedWOStep` |
     */
    ProducedMaterialItemId?: EXDSOpLandingActProducedWOStep | null;
}

export type EXDSOpLandingActConsMatWOStepId = string | {Id: string};

export interface EXDSOpLandingActProducedWOOp {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Code` |
     * | Type | `Edm.String` |
     */
    Code: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialDefinitionNId` |
     * | Type | `Edm.String` |
     */
    MaterialDefinitionNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserId` |
     * | Type | `Edm.String` |
     */
    UserId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProdMatStatus` |
     * | Type | `Edm.String` |
     */
    ProdMatStatus: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ConsumptionStatus` |
     * | Type | `Edm.String` |
     */
    ConsumptionStatus: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PartialWorkedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    PartialWorkedQuantity: number | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOpId` |
     * | Type | `Edm.Guid` |
     */
    WOOpId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MTUId` |
     * | Type | `Edm.Guid` |
     */
    MTUId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DMMTUId` |
     * | Type | `Edm.Guid` |
     */
    DMMTUId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualConsumedMaterials` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EXDSOpLandingActConsMatWOOp)` |
     */
    ActualConsumedMaterials?: Array<EXDSOpLandingActConsMatWOOp>;
}

export type EXDSOpLandingActProducedWOOpId = string | {Id: string};

export interface EXDSOpLandingActProducedWOStep {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Code` |
     * | Type | `Edm.String` |
     */
    Code: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialDefinitionNId` |
     * | Type | `Edm.String` |
     */
    MaterialDefinitionNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserId` |
     * | Type | `Edm.String` |
     */
    UserId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProdMatStatus` |
     * | Type | `Edm.String` |
     */
    ProdMatStatus: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ConsumptionStatus` |
     * | Type | `Edm.String` |
     */
    ConsumptionStatus: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PartialWorkedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    PartialWorkedQuantity: number | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOStepId` |
     * | Type | `Edm.Guid` |
     */
    WOStepId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MTUId` |
     * | Type | `Edm.Guid` |
     */
    MTUId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DMMTUId` |
     * | Type | `Edm.Guid` |
     */
    DMMTUId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualConsumedMaterials` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EXDSOpLandingActConsMatWOStep)` |
     */
    ActualConsumedMaterials?: Array<EXDSOpLandingActConsMatWOStep>;
}

export type EXDSOpLandingActProducedWOStepId = string | {Id: string};

export interface EXDSOpLandingToBeConsMatWOOp {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOProductionType` |
     * | Type | `Edm.String` |
     */
    WOProductionType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedMaterialQty` |
     * | Type | `Edm.Decimal` |
     */
    ProducedMaterialQty: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialNId` |
     * | Type | `Edm.String` |
     */
    MaterialNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialSpecificationType` |
     * | Type | `Edm.String` |
     */
    MaterialSpecificationType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeConsumedTotalQty` |
     * | Type | `Edm.Decimal` |
     */
    ToBeConsumedTotalQty: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `GroupId` |
     * | Type | `Edm.String` |
     */
    GroupId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogicalPosition` |
     * | Type | `Edm.String` |
     */
    LogicalPosition: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     */
    Sequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AlternativeSelected` |
     * | Type | `Edm.Boolean` |
     */
    AlternativeSelected: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoMNId` |
     * | Type | `Edm.String` |
     */
    UoMNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SerialNumberProfile` |
     * | Type | `Edm.Boolean` |
     */
    SerialNumberProfile: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialDefinitionId` |
     * | Type | `Edm.Guid` |
     */
    DM_MaterialDefinitionId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialRevision` |
     * | Type | `Edm.String` |
     */
    MaterialRevision: string | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOpId` |
     * | Type | `Edm.Guid` |
     */
    WOOpId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialDefinitionId` |
     * | Type | `Edm.Guid` |
     */
    MaterialDefinitionId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrekittedToBeConsumedMaterials` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EXDSOpLandingPrekittedConsumptionWOOp)` |
     */
    PrekittedToBeConsumedMaterials?: Array<EXDSOpLandingPrekittedConsumptionWOOp>;
}

export type EXDSOpLandingToBeConsMatWOOpId = string | {Id: string};

export interface EXDSOpLandingToBeConsMatWOStep {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOProductionType` |
     * | Type | `Edm.String` |
     */
    WOProductionType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedMaterialQty` |
     * | Type | `Edm.Decimal` |
     */
    ProducedMaterialQty: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialNId` |
     * | Type | `Edm.String` |
     */
    MaterialNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialSpecificationType` |
     * | Type | `Edm.String` |
     */
    MaterialSpecificationType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeConsumedTotalQty` |
     * | Type | `Edm.Decimal` |
     */
    ToBeConsumedTotalQty: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `GroupId` |
     * | Type | `Edm.String` |
     */
    GroupId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogicalPosition` |
     * | Type | `Edm.String` |
     */
    LogicalPosition: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     */
    Sequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AlternativeSelected` |
     * | Type | `Edm.Boolean` |
     */
    AlternativeSelected: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoMNId` |
     * | Type | `Edm.String` |
     */
    UoMNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SerialNumberProfile` |
     * | Type | `Edm.Boolean` |
     */
    SerialNumberProfile: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialDefinitionId` |
     * | Type | `Edm.Guid` |
     */
    DM_MaterialDefinitionId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialRevision` |
     * | Type | `Edm.String` |
     */
    MaterialRevision: string | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOStepId` |
     * | Type | `Edm.Guid` |
     */
    WOStepId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialDefinitionId` |
     * | Type | `Edm.Guid` |
     */
    MaterialDefinitionId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrekittedToBeConsumedMaterials` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EXDSOpLandingPrekittedConsumptionWOStep)` |
     */
    PrekittedToBeConsumedMaterials?: Array<EXDSOpLandingPrekittedConsumptionWOStep>;
}

export type EXDSOpLandingToBeConsMatWOStepId = string | {Id: string};

export interface ToBeAndActualProducedMaterial_MTUAndContainer {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOperationId` |
     * | Type | `Edm.Guid` |
     */
    WOOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TOBeDMMtuID` |
     * | Type | `Edm.Guid` |
     */
    TOBeDMMtuID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeProducedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    ToBeProducedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DMMtuId` |
     * | Type | `Edm.Guid` |
     */
    DMMtuId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsReserved` |
     * | Type | `Edm.Boolean` |
     */
    IsReserved: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActiveNCNumber` |
     * | Type | `Edm.Int32` |
     */
    ActiveNCNumber: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CompletedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    CompletedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Equipment` |
     * | Type | `Edm.String` |
     */
    Equipment: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NotWorkedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    NotWorkedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PartialWorkedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    PartialWorkedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PausedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    PausedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReopenedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    ReopenedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ScrappedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    ScrappedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SentencedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    SentencedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SplitQuantity` |
     * | Type | `Edm.Decimal` |
     */
    SplitQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserId` |
     * | Type | `Edm.String` |
     */
    UserId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupPhaseId` |
     * | Type | `Edm.Guid` |
     */
    ExecutionGroupPhaseId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActulDMMtuID` |
     * | Type | `Edm.Guid` |
     */
    ActulDMMtuID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DMMaterialId` |
     * | Type | `Edm.Guid` |
     */
    DMMaterialId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialTrackingUnit` |
     * | Type | `Edm.Guid` |
     */
    MaterialTrackingUnit: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialNId` |
     * | Type | `Edm.String` |
     */
    MaterialNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialName` |
     * | Type | `Edm.String` |
     */
    MaterialName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialDescription` |
     * | Type | `Edm.String` |
     */
    MaterialDescription: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Code` |
     * | Type | `Edm.String` |
     */
    Code: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CodeType` |
     * | Type | `Edm.Int32` |
     */
    CodeType: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StatusNId` |
     * | Type | `Edm.String` |
     */
    StatusNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StateMachineNId` |
     * | Type | `Edm.String` |
     */
    StateMachineNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialDefNId` |
     * | Type | `Edm.String` |
     */
    MaterialDefNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `materialRevision` |
     * | Type | `Edm.String` |
     */
    materialRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `materialQuantityValue` |
     * | Type | `Edm.Decimal` |
     */
    materialQuantityValue: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoMNid` |
     * | Type | `Edm.String` |
     */
    UoMNid: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContainerType` |
     * | Type | `Edm.String` |
     */
    ContainerType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsReusable` |
     * | Type | `Edm.Boolean` |
     */
    IsReusable: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsContainerActiveOnCurrentOperation` |
     * | Type | `Edm.Int32` |
     */
    IsContainerActiveOnCurrentOperation: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsContainerPauseOnCurrentOperation` |
     * | Type | `Edm.Int32` |
     */
    IsContainerPauseOnCurrentOperation: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsContainerCompleteOnCurrentOperation` |
     * | Type | `Edm.Int32` |
     */
    IsContainerCompleteOnCurrentOperation: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResultStrategy` |
     * | Type | `Edm.String` |
     */
    ResultStrategy: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResultValue` |
     * | Type | `Edm.String` |
     */
    ResultValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SuggestedResultIsKo` |
     * | Type | `Edm.Boolean` |
     */
    SuggestedResultIsKo: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SuggestedResultValue` |
     * | Type | `Edm.String` |
     */
    SuggestedResultValue: string | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsContainer` |
     * | Type | `Edm.Int32` |
     */
    IsContainer: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialId` |
     * | Type | `Edm.Guid` |
     */
    MaterialId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsResultKo` |
     * | Type | `Edm.Boolean` |
     */
    IsResultKo: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsRepeatOfKo` |
     * | Type | `Edm.Boolean` |
     */
    IsRepeatOfKo: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
}

export type ToBeAndActualProducedMaterial_MTUAndContainerId = string | {Id: string};

export interface EXDSContainerOrMTU {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Code` |
     * | Type | `Edm.String` |
     */
    Code: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CodeType` |
     * | Type | `Edm.Int32` |
     */
    CodeType: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialNId` |
     * | Type | `Edm.String` |
     */
    MaterialNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialRevision` |
     * | Type | `Edm.String` |
     */
    MaterialRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     */
    Status: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StateMachine` |
     * | Type | `Edm.String` |
     */
    StateMachine: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContainerType` |
     * | Type | `Edm.String` |
     */
    ContainerType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsReusable` |
     * | Type | `Edm.Boolean` |
     */
    IsReusable: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsContainer` |
     * | Type | `Edm.Boolean` |
     */
    IsContainer: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MTUId` |
     * | Type | `Edm.Guid` |
     */
    DM_MTUId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsResultKo` |
     * | Type | `Edm.Boolean` |
     */
    IsResultKo: boolean | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export type EXDSContainerOrMTUId = string | {Id: string};

export interface EXDSOpLandingProducedMaterialsContainerSearch {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContainerNId` |
     * | Type | `Edm.String` |
     */
    ContainerNId: string | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOSearchId_Id` |
     * | Type | `Edm.Guid` |
     */
    WOOSearchId_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOSearchId` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EXDSOpLandingWOOSearch` |
     */
    WOOSearchId?: EXDSOpLandingWOOSearch | null;
}

export type EXDSOpLandingProducedMaterialsContainerSearchId = string | {Id: string};

export interface EXDSContainerOrMTUbyWorkOrderOperation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Code` |
     * | Type | `Edm.String` |
     */
    Code: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CodeType` |
     * | Type | `Edm.Int32` |
     */
    CodeType: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MTUId` |
     * | Type | `Edm.Guid` |
     */
    DM_MTUId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialNId` |
     * | Type | `Edm.String` |
     */
    MaterialNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialRevision` |
     * | Type | `Edm.String` |
     */
    MaterialRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StateMachine` |
     * | Type | `Edm.String` |
     */
    StateMachine: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     */
    Status: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsContainer` |
     * | Type | `Edm.Boolean` |
     */
    IsContainer: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContainerType` |
     * | Type | `Edm.String` |
     */
    ContainerType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsReusable` |
     * | Type | `Edm.Boolean` |
     */
    IsReusable: boolean | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsResultKo` |
     * | Type | `Edm.Boolean` |
     */
    IsResultKo: boolean | null;
}

export type EXDSContainerOrMTUbyWorkOrderOperationId = string | {Id: string};

export interface EXDSActiveMTUOrContainerOnWOOpAndUser {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialTrackingUnitAggregate` |
     * | Type | `Edm.Guid` |
     */
    MaterialTrackingUnitAggregate: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnit` |
     * | Type | `Edm.Guid` |
     */
    DM_MaterialTrackingUnit: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialNId` |
     * | Type | `Edm.String` |
     */
    MaterialNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialRevision` |
     * | Type | `Edm.String` |
     */
    MaterialRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsReserved` |
     * | Type | `Edm.Boolean` |
     */
    IsReserved: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContainerTypeNId` |
     * | Type | `Edm.String` |
     */
    ContainerTypeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Code` |
     * | Type | `Edm.String` |
     */
    Code: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoMNId` |
     * | Type | `Edm.String` |
     */
    UoMNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StatusNId` |
     * | Type | `Edm.String` |
     */
    StatusNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `User` |
     * | Type | `Edm.String` |
     */
    User: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TeamNId` |
     * | Type | `Edm.String` |
     */
    TeamNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Equipment` |
     * | Type | `Edm.String` |
     */
    Equipment: string | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsContainer` |
     * | Type | `Edm.Boolean` |
     */
    IsContainer: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperation: string | null;
}

export type EXDSActiveMTUOrContainerOnWOOpAndUserId = string | {Id: string};

export interface EXDSActiveMTUOrContainerOnWOStepAndUser {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderStepNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialTrackingUnitAggregate` |
     * | Type | `Edm.Guid` |
     */
    MaterialTrackingUnitAggregate: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnit` |
     * | Type | `Edm.Guid` |
     */
    DM_MaterialTrackingUnit: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialNId` |
     * | Type | `Edm.String` |
     */
    MaterialNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialRevision` |
     * | Type | `Edm.String` |
     */
    MaterialRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsReserved` |
     * | Type | `Edm.Boolean` |
     */
    IsReserved: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContainerTypeNId` |
     * | Type | `Edm.String` |
     */
    ContainerTypeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Code` |
     * | Type | `Edm.String` |
     */
    Code: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoMNId` |
     * | Type | `Edm.String` |
     */
    UoMNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StatusNId` |
     * | Type | `Edm.String` |
     */
    StatusNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `User` |
     * | Type | `Edm.String` |
     */
    User: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TeamNId` |
     * | Type | `Edm.String` |
     */
    TeamNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Equipment` |
     * | Type | `Edm.String` |
     */
    Equipment: string | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsContainer` |
     * | Type | `Edm.Boolean` |
     */
    IsContainer: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStep` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStep: string | null;
}

export type EXDSActiveMTUOrContainerOnWOStepAndUserId = string | {Id: string};

export interface EXDSOpLandingMaterialATNInstance {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialId` |
     * | Type | `Edm.Guid` |
     */
    MaterialId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ATNInstanceNId` |
     * | Type | `Edm.String` |
     */
    ATNInstanceNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialParamaterNId` |
     * | Type | `Edm.String` |
     */
    MaterialParamaterNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ATNInstanceParameter` |
     * | Type | `Edm.String` |
     */
    ATNInstanceParameter: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStepId: string | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export type EXDSOpLandingMaterialATNInstanceId = string | {Id: string};

export interface EXDSOpLandingContainerWithConsumptionStatusByWOOpAndUser {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Code` |
     * | Type | `Edm.String` |
     */
    Code: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoMNId` |
     * | Type | `Edm.String` |
     */
    UoMNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserId` |
     * | Type | `Edm.String` |
     */
    UserId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TeamNId` |
     * | Type | `Edm.String` |
     */
    TeamNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PartialWorkedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    PartialWorkedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProdMatStatus` |
     * | Type | `Edm.String` |
     */
    ProdMatStatus: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ConsumptionStatus` |
     * | Type | `Edm.String` |
     */
    ConsumptionStatus: string | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOpId` |
     * | Type | `Edm.Guid` |
     */
    WOOpId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualConsumedMaterials` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EXDSOpLandingActConsMatOnContainerWOOp)` |
     */
    ActualConsumedMaterials?: Array<EXDSOpLandingActConsMatOnContainerWOOp>;
}

export type EXDSOpLandingContainerWithConsumptionStatusByWOOpAndUserId = string | {Id: string};

export interface EXDSOpLandingContainerWithConsumptionStatusByWOStepAndUser {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Code` |
     * | Type | `Edm.String` |
     */
    Code: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoMNId` |
     * | Type | `Edm.String` |
     */
    UoMNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserId` |
     * | Type | `Edm.String` |
     */
    UserId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TeamNId` |
     * | Type | `Edm.String` |
     */
    TeamNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PartialWorkedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    PartialWorkedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProdMatStatus` |
     * | Type | `Edm.String` |
     */
    ProdMatStatus: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ConsumptionStatus` |
     * | Type | `Edm.String` |
     */
    ConsumptionStatus: string | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOStepId` |
     * | Type | `Edm.Guid` |
     */
    WOStepId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualConsumedMaterials` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EXDSOpLandingActConsMatOnContainerWOStep)` |
     */
    ActualConsumedMaterials?: Array<EXDSOpLandingActConsMatOnContainerWOStep>;
}

export type EXDSOpLandingContainerWithConsumptionStatusByWOStepAndUserId = string | {Id: string};

export interface EXDSOpLandingMTUNotInContainerWithConsumptionStatusByWOOpAndUser {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Code` |
     * | Type | `Edm.String` |
     */
    Code: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserId` |
     * | Type | `Edm.String` |
     */
    UserId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TeamNId` |
     * | Type | `Edm.String` |
     */
    TeamNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PartialWorkedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    PartialWorkedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProdMatStatus` |
     * | Type | `Edm.String` |
     */
    ProdMatStatus: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ConsumptionStatus` |
     * | Type | `Edm.String` |
     */
    ConsumptionStatus: string | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOpId` |
     * | Type | `Edm.Guid` |
     */
    WOOpId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MTUId` |
     * | Type | `Edm.Guid` |
     */
    MTUId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DMMTUId` |
     * | Type | `Edm.Guid` |
     */
    DMMTUId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedMaterialItemId` |
     * | Type | `Edm.Guid` |
     */
    ProducedMaterialItemId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualConsumedMaterials` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EXDSOpLandingActConsMatOnMTUWOOp)` |
     */
    ActualConsumedMaterials?: Array<EXDSOpLandingActConsMatOnMTUWOOp>;
}

export type EXDSOpLandingMTUNotInContainerWithConsumptionStatusByWOOpAndUserId = string | {Id: string};

export interface EXDSOpLandingMTUNotInContainerWithConsumptionStatusByWOStepAndUser {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Code` |
     * | Type | `Edm.String` |
     */
    Code: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserId` |
     * | Type | `Edm.String` |
     */
    UserId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TeamNId` |
     * | Type | `Edm.String` |
     */
    TeamNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PartialWorkedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    PartialWorkedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProdMatStatus` |
     * | Type | `Edm.String` |
     */
    ProdMatStatus: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ConsumptionStatus` |
     * | Type | `Edm.String` |
     */
    ConsumptionStatus: string | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOStepId` |
     * | Type | `Edm.Guid` |
     */
    WOStepId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MTUId` |
     * | Type | `Edm.Guid` |
     */
    MTUId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DMMTUId` |
     * | Type | `Edm.Guid` |
     */
    DMMTUId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedMaterialItemId` |
     * | Type | `Edm.Guid` |
     */
    ProducedMaterialItemId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualConsumedMaterials` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EXDSOpLandingActConsMatOnMTUWOStep)` |
     */
    ActualConsumedMaterials?: Array<EXDSOpLandingActConsMatOnMTUWOStep>;
}

export type EXDSOpLandingMTUNotInContainerWithConsumptionStatusByWOStepAndUserId = string | {Id: string};

export interface EXDSOpLandingActConsMatOnContainerWOOp {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialConsumptionStatus` |
     * | Type | `Edm.String` |
     */
    MaterialConsumptionStatus: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualConsumedCode` |
     * | Type | `Edm.String` |
     */
    ActualConsumedCode: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItemAssembledQty` |
     * | Type | `Edm.Decimal` |
     */
    MaterialItemAssembledQty: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedMaterialItemActualQty` |
     * | Type | `Edm.Decimal` |
     */
    ProducedMaterialItemActualQty: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualConsumedTotalQty` |
     * | Type | `Edm.Decimal` |
     */
    ActualConsumedTotalQty: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedMaterialItemActualQtyOnEquipment` |
     * | Type | `Edm.Decimal` |
     */
    ProducedMaterialItemActualQtyOnEquipment: number | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOpId` |
     * | Type | `Edm.Guid` |
     */
    WOOpId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeConsumedId` |
     * | Type | `Edm.Guid` |
     */
    ToBeConsumedId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialTrackingUnitAggregateId_Id` |
     * | Type | `Edm.Guid` |
     */
    MaterialTrackingUnitAggregateId_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialTrackingUnitAggregateId` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EXDSOpLandingContainerWithConsumptionStatusByWOOpAndUser` |
     */
    MaterialTrackingUnitAggregateId?: EXDSOpLandingContainerWithConsumptionStatusByWOOpAndUser | null;
}

export type EXDSOpLandingActConsMatOnContainerWOOpId = string | {Id: string};

export interface EXDSOpLandingActConsMatOnContainerWOStep {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialConsumptionStatus` |
     * | Type | `Edm.String` |
     */
    MaterialConsumptionStatus: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualConsumedCode` |
     * | Type | `Edm.String` |
     */
    ActualConsumedCode: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItemAssembledQty` |
     * | Type | `Edm.Decimal` |
     */
    MaterialItemAssembledQty: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedMaterialItemActualQty` |
     * | Type | `Edm.Decimal` |
     */
    ProducedMaterialItemActualQty: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualConsumedTotalQty` |
     * | Type | `Edm.Decimal` |
     */
    ActualConsumedTotalQty: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedMaterialItemActualQtyOnEquipment` |
     * | Type | `Edm.Decimal` |
     */
    ProducedMaterialItemActualQtyOnEquipment: number | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOStepId` |
     * | Type | `Edm.Guid` |
     */
    WOStepId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeConsumedId` |
     * | Type | `Edm.Guid` |
     */
    ToBeConsumedId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialTrackingUnitAggregateId_Id` |
     * | Type | `Edm.Guid` |
     */
    MaterialTrackingUnitAggregateId_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialTrackingUnitAggregateId` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EXDSOpLandingContainerWithConsumptionStatusByWOStepAndUser` |
     */
    MaterialTrackingUnitAggregateId?: EXDSOpLandingContainerWithConsumptionStatusByWOStepAndUser | null;
}

export type EXDSOpLandingActConsMatOnContainerWOStepId = string | {Id: string};

export interface EXDSAsBuiltSN {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsKO` |
     * | Type | `Edm.Boolean` |
     */
    IsKO: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MtuNId` |
     * | Type | `Edm.String` |
     */
    MtuNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Code` |
     * | Type | `Edm.String` |
     */
    Code: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MtuDescription` |
     * | Type | `Edm.String` |
     */
    MtuDescription: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MtuName` |
     * | Type | `Edm.String` |
     */
    MtuName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CodeType` |
     * | Type | `Edm.Int32` |
     */
    CodeType: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MtuStatus` |
     * | Type | `Edm.String` |
     */
    MtuStatus: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UomNId` |
     * | Type | `Edm.String` |
     */
    UomNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WeightUoMNId` |
     * | Type | `Edm.String` |
     */
    WeightUoMNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WeightQty` |
     * | Type | `Edm.Decimal` |
     */
    WeightQty: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `VolumeUoMNId` |
     * | Type | `Edm.String` |
     */
    VolumeUoMNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `VolumeQty` |
     * | Type | `Edm.Decimal` |
     */
    VolumeQty: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DMMatNId` |
     * | Type | `Edm.String` |
     */
    DMMatNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialRevision` |
     * | Type | `Edm.String` |
     */
    MaterialRevision: string | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOId` |
     * | Type | `Edm.Guid` |
     */
    WOId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperations` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EXDSAsBuiltActualProdMatOnWoop)` |
     */
    WorkOrderOperations?: Array<EXDSAsBuiltActualProdMatOnWoop>;
}

export type EXDSAsBuiltSNId = string | {Id: string};

export interface EXDSAsBuiltSNWithWOOp {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsKO` |
     * | Type | `Edm.Boolean` |
     */
    IsKO: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MtuNId` |
     * | Type | `Edm.String` |
     */
    MtuNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Code` |
     * | Type | `Edm.String` |
     */
    Code: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MtuDescription` |
     * | Type | `Edm.String` |
     */
    MtuDescription: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MtuName` |
     * | Type | `Edm.String` |
     */
    MtuName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CodeType` |
     * | Type | `Edm.Int32` |
     */
    CodeType: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MtuStatus` |
     * | Type | `Edm.String` |
     */
    MtuStatus: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UomNId` |
     * | Type | `Edm.String` |
     */
    UomNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WeightUoMNId` |
     * | Type | `Edm.String` |
     */
    WeightUoMNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WeightQty` |
     * | Type | `Edm.Decimal` |
     */
    WeightQty: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `VolumeUoMNId` |
     * | Type | `Edm.String` |
     */
    VolumeUoMNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `VolumeQty` |
     * | Type | `Edm.Decimal` |
     */
    VolumeQty: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DMMatNId` |
     * | Type | `Edm.String` |
     */
    DMMatNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialRevision` |
     * | Type | `Edm.String` |
     */
    MaterialRevision: string | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOId` |
     * | Type | `Edm.Guid` |
     */
    WOId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOpId` |
     * | Type | `Edm.Guid` |
     */
    WOOpId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
}

export type EXDSAsBuiltSNWithWOOpId = string | {Id: string};

export interface ToBeAndActualProducedMaterial_MTUAndContainerForSteps {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOperationId` |
     * | Type | `Edm.Guid` |
     */
    WOOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOStepId` |
     * | Type | `Edm.Guid` |
     */
    WOStepId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TOBeDMMtuID` |
     * | Type | `Edm.Guid` |
     */
    TOBeDMMtuID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeProducedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    ToBeProducedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DMMtuId` |
     * | Type | `Edm.Guid` |
     */
    DMMtuId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsReserved` |
     * | Type | `Edm.Boolean` |
     */
    IsReserved: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActiveNCNumber` |
     * | Type | `Edm.Int32` |
     */
    ActiveNCNumber: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CompletedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    CompletedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Equipment` |
     * | Type | `Edm.String` |
     */
    Equipment: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NotWorkedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    NotWorkedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PartialWorkedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    PartialWorkedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PausedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    PausedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReopenedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    ReopenedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ScrappedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    ScrappedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SentencedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    SentencedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SplitQuantity` |
     * | Type | `Edm.Decimal` |
     */
    SplitQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserId` |
     * | Type | `Edm.String` |
     */
    UserId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupPhaseId` |
     * | Type | `Edm.Guid` |
     */
    ExecutionGroupPhaseId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActulDMMtuID` |
     * | Type | `Edm.Guid` |
     */
    ActulDMMtuID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DMMaterialId` |
     * | Type | `Edm.Guid` |
     */
    DMMaterialId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialTrackingUnit` |
     * | Type | `Edm.Guid` |
     */
    MaterialTrackingUnit: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialNId` |
     * | Type | `Edm.String` |
     */
    MaterialNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialName` |
     * | Type | `Edm.String` |
     */
    MaterialName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialDescription` |
     * | Type | `Edm.String` |
     */
    MaterialDescription: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Code` |
     * | Type | `Edm.String` |
     */
    Code: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CodeType` |
     * | Type | `Edm.Int32` |
     */
    CodeType: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StatusNId` |
     * | Type | `Edm.String` |
     */
    StatusNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StateMachineNId` |
     * | Type | `Edm.String` |
     */
    StateMachineNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialDefNId` |
     * | Type | `Edm.String` |
     */
    MaterialDefNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `materialRevision` |
     * | Type | `Edm.String` |
     */
    materialRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `materialQuantityValue` |
     * | Type | `Edm.Decimal` |
     */
    materialQuantityValue: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoMNid` |
     * | Type | `Edm.String` |
     */
    UoMNid: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContainerType` |
     * | Type | `Edm.String` |
     */
    ContainerType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsReusable` |
     * | Type | `Edm.Boolean` |
     */
    IsReusable: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsContainerActiveOnCurrentStep` |
     * | Type | `Edm.Int32` |
     */
    IsContainerActiveOnCurrentStep: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsContainerPauseOnCurrentStep` |
     * | Type | `Edm.Int32` |
     */
    IsContainerPauseOnCurrentStep: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsContainerCompleteOnCurrentStep` |
     * | Type | `Edm.Int32` |
     */
    IsContainerCompleteOnCurrentStep: number | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsContainer` |
     * | Type | `Edm.Int32` |
     */
    IsContainer: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialId` |
     * | Type | `Edm.Guid` |
     */
    MaterialId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsResultKo` |
     * | Type | `Edm.Boolean` |
     */
    IsResultKo: boolean | null;
}

export type ToBeAndActualProducedMaterial_MTUAndContainerForStepsId = string | {Id: string};

export interface EXDSOpLandingActConsMatOnMTUWOOp {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Code` |
     * | Type | `Edm.String` |
     */
    Code: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialConsumptionStatus` |
     * | Type | `Edm.String` |
     */
    MaterialConsumptionStatus: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualConsumedCode` |
     * | Type | `Edm.String` |
     */
    ActualConsumedCode: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItemAssembledQty` |
     * | Type | `Edm.Decimal` |
     */
    MaterialItemAssembledQty: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedMaterialItemActualQty` |
     * | Type | `Edm.Decimal` |
     */
    ProducedMaterialItemActualQty: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualConsumedTotalQty` |
     * | Type | `Edm.Decimal` |
     */
    ActualConsumedTotalQty: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedMaterialItemActualQtyOnEquipment` |
     * | Type | `Edm.Decimal` |
     */
    ProducedMaterialItemActualQtyOnEquipment: number | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOpId` |
     * | Type | `Edm.Guid` |
     */
    WOOpId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeConsumedId` |
     * | Type | `Edm.Guid` |
     */
    ToBeConsumedId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualConsumedId` |
     * | Type | `Edm.Guid` |
     */
    ActualConsumedId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedMaterialItemId_Id` |
     * | Type | `Edm.Guid` |
     */
    ProducedMaterialItemId_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedMaterialItemId` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EXDSOpLandingMTUNotInContainerWithConsumptionStatusByWOOpAndUser` |
     */
    ProducedMaterialItemId?: EXDSOpLandingMTUNotInContainerWithConsumptionStatusByWOOpAndUser | null;
}

export type EXDSOpLandingActConsMatOnMTUWOOpId = string | {Id: string};

export interface EXDSOpLandingActConsMatOnMTUWOStep {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Code` |
     * | Type | `Edm.String` |
     */
    Code: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialConsumptionStatus` |
     * | Type | `Edm.String` |
     */
    MaterialConsumptionStatus: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualConsumedCode` |
     * | Type | `Edm.String` |
     */
    ActualConsumedCode: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItemAssembledQty` |
     * | Type | `Edm.Decimal` |
     */
    MaterialItemAssembledQty: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedMaterialItemActualQty` |
     * | Type | `Edm.Decimal` |
     */
    ProducedMaterialItemActualQty: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualConsumedTotalQty` |
     * | Type | `Edm.Decimal` |
     */
    ActualConsumedTotalQty: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedMaterialItemActualQtyOnEquipment` |
     * | Type | `Edm.Decimal` |
     */
    ProducedMaterialItemActualQtyOnEquipment: number | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOStepId` |
     * | Type | `Edm.Guid` |
     */
    WOStepId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeConsumedId` |
     * | Type | `Edm.Guid` |
     */
    ToBeConsumedId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualConsumedId` |
     * | Type | `Edm.Guid` |
     */
    ActualConsumedId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedMaterialItemId_Id` |
     * | Type | `Edm.Guid` |
     */
    ProducedMaterialItemId_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedMaterialItemId` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EXDSOpLandingMTUNotInContainerWithConsumptionStatusByWOStepAndUser` |
     */
    ProducedMaterialItemId?: EXDSOpLandingMTUNotInContainerWithConsumptionStatusByWOStepAndUser | null;
}

export type EXDSOpLandingActConsMatOnMTUWOStepId = string | {Id: string};

export interface EXDSGetResultHistory {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderName` |
     * | Type | `Edm.String` |
     */
    WorkOrderName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationSequence` |
     * | Type | `Edm.Int32` |
     */
    WorkOrderOperationSequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationName` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Int32` |
     */
    WorkOrderStepId: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderStepNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepSequence` |
     * | Type | `Edm.Int32` |
     */
    WorkOrderStepSequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepName` |
     * | Type | `Edm.String` |
     */
    WorkOrderStepName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CategoryNId` |
     * | Type | `Edm.String` |
     */
    CategoryNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CategoryName` |
     * | Type | `Edm.String` |
     */
    CategoryName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOperationTypeNId` |
     * | Type | `Edm.String` |
     */
    WorkOperationTypeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialTrackingUnitNId` |
     * | Type | `Edm.String` |
     */
    MaterialTrackingUnitNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActionNId` |
     * | Type | `Edm.String` |
     */
    ActionNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActionName` |
     * | Type | `Edm.String` |
     */
    ActionName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserId` |
     * | Type | `Edm.String` |
     */
    UserId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResultIsKO` |
     * | Type | `Edm.Boolean` |
     */
    ResultIsKO: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResultValue` |
     * | Type | `Edm.String` |
     */
    ResultValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResultStrategy` |
     * | Type | `Edm.String` |
     */
    ResultStrategy: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceNId` |
     * | Type | `Edm.String` |
     */
    NonConformanceNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Date` |
     * | Type | `Edm.DateTimeOffset` |
     */
    Date: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResultId` |
     * | Type | `Edm.Guid` |
     */
    ResultId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProductionTypeNId` |
     * | Type | `Edm.String` |
     */
    ProductionTypeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActivityNId` |
     * | Type | `Edm.String` |
     */
    ActivityNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActivityType` |
     * | Type | `Edm.String` |
     */
    ActivityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsPartial` |
     * | Type | `Edm.Boolean` |
     */
    IsPartial: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedWithActivity` |
     * | Type | `Edm.Boolean` |
     */
    CreatedWithActivity: boolean | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export type EXDSGetResultHistoryId = string | {Id: string};

export interface EXDSOpLandingAssignedUsersSearch {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserName` |
     * | Type | `Edm.String` |
     */
    UserName: string | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOSearchId_Id` |
     * | Type | `Edm.Guid` |
     */
    WOOSearchId_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOSearchId` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EXDSOpLandingWOOSearch` |
     */
    WOOSearchId?: EXDSOpLandingWOOSearch | null;
}

export type EXDSOpLandingAssignedUsersSearchId = string | {Id: string};

export interface ToBeAndActualProducedMTUWithContainerForPartialQuantity {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOperationId` |
     * | Type | `Edm.Guid` |
     */
    WOOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TBQuantity` |
     * | Type | `Edm.Decimal` |
     */
    TBQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOpId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOpId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContainerId` |
     * | Type | `Edm.Guid` |
     */
    ContainerId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FakeMTUId` |
     * | Type | `Edm.Guid` |
     */
    FakeMTUId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsReserved` |
     * | Type | `Edm.Boolean` |
     */
    IsReserved: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActiveNCNumber` |
     * | Type | `Edm.Int32` |
     */
    ActiveNCNumber: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DMMaterialId` |
     * | Type | `Edm.Guid` |
     */
    DMMaterialId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialNId` |
     * | Type | `Edm.String` |
     */
    MaterialNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialName` |
     * | Type | `Edm.String` |
     */
    MaterialName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialDescription` |
     * | Type | `Edm.String` |
     */
    MaterialDescription: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Code` |
     * | Type | `Edm.String` |
     */
    Code: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CodeType` |
     * | Type | `Edm.Int32` |
     */
    CodeType: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialDefNId` |
     * | Type | `Edm.String` |
     */
    MaterialDefNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `materialRevision` |
     * | Type | `Edm.String` |
     */
    materialRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StateMachineNId` |
     * | Type | `Edm.String` |
     */
    StateMachineNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StatusNId` |
     * | Type | `Edm.String` |
     */
    StatusNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `materialQuantityValue` |
     * | Type | `Edm.Decimal` |
     */
    materialQuantityValue: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoMNid` |
     * | Type | `Edm.String` |
     */
    UoMNid: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContainerType` |
     * | Type | `Edm.String` |
     */
    ContainerType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsReusable` |
     * | Type | `Edm.Boolean` |
     */
    IsReusable: boolean | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsContainerActiveOnCurrentOperation` |
     * | Type | `Edm.Int32` |
     */
    IsContainerActiveOnCurrentOperation: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsContainerPauseOnCurrentOperation` |
     * | Type | `Edm.Int32` |
     */
    IsContainerPauseOnCurrentOperation: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsContainerCompleteOnCurrentOperation` |
     * | Type | `Edm.Int32` |
     */
    IsContainerCompleteOnCurrentOperation: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialId` |
     * | Type | `Edm.Guid` |
     */
    MaterialId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsResultKo` |
     * | Type | `Edm.Boolean` |
     */
    IsResultKo: boolean | null;
}

export type ToBeAndActualProducedMTUWithContainerForPartialQuantityId = string | {Id: string};

export interface EXDSAsBuiltActualProdMatOnWoop {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WoopId` |
     * | Type | `Edm.Guid` |
     */
    WoopId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProdMatId_Id` |
     * | Type | `Edm.Guid` |
     */
    ProdMatId_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProdMatId` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EXDSAsBuiltSN` |
     */
    ProdMatId?: EXDSAsBuiltSN | null;
}

export type EXDSAsBuiltActualProdMatOnWoopId = string | {Id: string};

export interface ToBeAndActualProducedMaterial_MTUAndContainerWithPartialQuantity {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOperationId` |
     * | Type | `Edm.Guid` |
     */
    WOOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TOBeDMMtuID` |
     * | Type | `Edm.Guid` |
     */
    TOBeDMMtuID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeProducedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    ToBeProducedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContainerId` |
     * | Type | `Edm.Guid` |
     */
    ContainerId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DMMtuId` |
     * | Type | `Edm.Guid` |
     */
    DMMtuId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsReserved` |
     * | Type | `Edm.Boolean` |
     */
    IsReserved: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActiveNCNumber` |
     * | Type | `Edm.Int32` |
     */
    ActiveNCNumber: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CompletedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    CompletedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Equipment` |
     * | Type | `Edm.String` |
     */
    Equipment: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NotWorkedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    NotWorkedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PartialWorkedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    PartialWorkedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PausedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    PausedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReopenedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    ReopenedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ScrappedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    ScrappedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SentencedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    SentencedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SplitQuantity` |
     * | Type | `Edm.Decimal` |
     */
    SplitQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserId` |
     * | Type | `Edm.String` |
     */
    UserId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupPhaseId` |
     * | Type | `Edm.Guid` |
     */
    ExecutionGroupPhaseId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActulDMMtuID` |
     * | Type | `Edm.Guid` |
     */
    ActulDMMtuID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DMMaterialId` |
     * | Type | `Edm.Guid` |
     */
    DMMaterialId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialTrackingUnit` |
     * | Type | `Edm.Guid` |
     */
    MaterialTrackingUnit: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialNId` |
     * | Type | `Edm.String` |
     */
    MaterialNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialName` |
     * | Type | `Edm.String` |
     */
    MaterialName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialDescription` |
     * | Type | `Edm.String` |
     */
    MaterialDescription: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Code` |
     * | Type | `Edm.String` |
     */
    Code: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CodeType` |
     * | Type | `Edm.Int32` |
     */
    CodeType: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StatusNId` |
     * | Type | `Edm.String` |
     */
    StatusNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StateMachineNId` |
     * | Type | `Edm.String` |
     */
    StateMachineNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialDefNId` |
     * | Type | `Edm.String` |
     */
    MaterialDefNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `materialRevision` |
     * | Type | `Edm.String` |
     */
    materialRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `materialQuantityValue` |
     * | Type | `Edm.Decimal` |
     */
    materialQuantityValue: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoMNid` |
     * | Type | `Edm.String` |
     */
    UoMNid: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContainerType` |
     * | Type | `Edm.String` |
     */
    ContainerType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsReusable` |
     * | Type | `Edm.Boolean` |
     */
    IsReusable: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsContainerActiveOnCurrentOperation` |
     * | Type | `Edm.Int32` |
     */
    IsContainerActiveOnCurrentOperation: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsContainerPauseOnCurrentOperation` |
     * | Type | `Edm.Int32` |
     */
    IsContainerPauseOnCurrentOperation: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsContainerCompleteOnCurrentOperation` |
     * | Type | `Edm.Int32` |
     */
    IsContainerCompleteOnCurrentOperation: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SuggestedResultIsKo` |
     * | Type | `Edm.Boolean` |
     */
    SuggestedResultIsKo: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SuggestedResultValue` |
     * | Type | `Edm.String` |
     */
    SuggestedResultValue: string | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsContainer` |
     * | Type | `Edm.Int32` |
     */
    IsContainer: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialId` |
     * | Type | `Edm.Guid` |
     */
    MaterialId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsResultKo` |
     * | Type | `Edm.Boolean` |
     */
    IsResultKo: boolean | null;
}

export type ToBeAndActualProducedMaterial_MTUAndContainerWithPartialQuantityId = string | {Id: string};

export interface EXDSOpLandingPrekittedConsumptionWOOp {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOpId` |
     * | Type | `Edm.Guid` |
     */
    WOOpId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrekittedTargetMaterialCode` |
     * | Type | `Edm.String` |
     */
    PrekittedTargetMaterialCode: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceMTUId` |
     * | Type | `Edm.Guid` |
     */
    SourceMTUId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrekittedSourceMaterialCode` |
     * | Type | `Edm.String` |
     */
    PrekittedSourceMaterialCode: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrekittedQty` |
     * | Type | `Edm.Decimal` |
     */
    PrekittedQty: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeValidated` |
     * | Type | `Edm.Boolean` |
     */
    ToBeValidated: boolean | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedMaterialItemId` |
     * | Type | `Edm.Guid` |
     */
    ProducedMaterialItemId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetDMMTUId` |
     * | Type | `Edm.Guid` |
     */
    TargetDMMTUId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetMTUId` |
     * | Type | `Edm.Guid` |
     */
    TargetMTUId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceDMMTUId` |
     * | Type | `Edm.Guid` |
     */
    SourceDMMTUId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeConsumedMaterialId_Id` |
     * | Type | `Edm.Guid` |
     */
    ToBeConsumedMaterialId_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeConsumedMaterialId` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EXDSOpLandingToBeConsMatWOOp` |
     */
    ToBeConsumedMaterialId?: EXDSOpLandingToBeConsMatWOOp | null;
}

export type EXDSOpLandingPrekittedConsumptionWOOpId = string | {Id: string};

export interface EXDSOpLandingPrekittedConsumptionWOStep {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOStepId` |
     * | Type | `Edm.Guid` |
     */
    WOStepId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrekittedTargetMaterialCode` |
     * | Type | `Edm.String` |
     */
    PrekittedTargetMaterialCode: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceMTUId` |
     * | Type | `Edm.Guid` |
     */
    SourceMTUId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrekittedSourceMaterialCode` |
     * | Type | `Edm.String` |
     */
    PrekittedSourceMaterialCode: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrekittedQty` |
     * | Type | `Edm.Decimal` |
     */
    PrekittedQty: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeValidated` |
     * | Type | `Edm.Boolean` |
     */
    ToBeValidated: boolean | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedMaterialItemId` |
     * | Type | `Edm.Guid` |
     */
    ProducedMaterialItemId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetDMMTUId` |
     * | Type | `Edm.Guid` |
     */
    TargetDMMTUId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetMTUId` |
     * | Type | `Edm.Guid` |
     */
    TargetMTUId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceDMMTUId` |
     * | Type | `Edm.Guid` |
     */
    SourceDMMTUId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeConsumedMaterialId_Id` |
     * | Type | `Edm.Guid` |
     */
    ToBeConsumedMaterialId_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeConsumedMaterialId` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EXDSOpLandingToBeConsMatWOStep` |
     */
    ToBeConsumedMaterialId?: EXDSOpLandingToBeConsMatWOStep | null;
}

export type EXDSOpLandingPrekittedConsumptionWOStepId = string | {Id: string};

export interface ToBeProducedMTUWithResult {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     */
    Status: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Code` |
     * | Type | `Edm.String` |
     */
    Code: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WooStepId` |
     * | Type | `Edm.Guid` |
     */
    WooStepId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WoopId` |
     * | Type | `Edm.Guid` |
     */
    WoopId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AggregateId` |
     * | Type | `Edm.Guid` |
     */
    AggregateId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoM` |
     * | Type | `Edm.String` |
     */
    UoM: string | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DmMtuId` |
     * | Type | `Edm.Guid` |
     */
    DmMtuId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsResultKo` |
     * | Type | `Edm.Boolean` |
     */
    IsResultKo: boolean | null;
}

export type ToBeProducedMTUWithResultId = string | {Id: string};

export interface DMMtuWithResult {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     */
    Status: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoM` |
     * | Type | `Edm.String` |
     */
    UoM: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Volume` |
     * | Type | `Edm.Decimal` |
     */
    Volume: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `VolumeUoM` |
     * | Type | `Edm.String` |
     */
    VolumeUoM: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Weight` |
     * | Type | `Edm.Decimal` |
     */
    Weight: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WeightUoM` |
     * | Type | `Edm.String` |
     */
    WeightUoM: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CodeType` |
     * | Type | `Edm.String` |
     */
    CodeType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Code` |
     * | Type | `Edm.String` |
     */
    Code: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsReserved` |
     * | Type | `Edm.Boolean` |
     */
    IsReserved: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialId` |
     * | Type | `Edm.Guid` |
     */
    DM_MaterialId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialNId` |
     * | Type | `Edm.String` |
     */
    MaterialNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialRevision` |
     * | Type | `Edm.String` |
     */
    MaterialRevision: string | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsResultKo` |
     * | Type | `Edm.Boolean` |
     */
    IsResultKo: boolean | null;
}

export type DMMtuWithResultId = string | {Id: string};

export interface ProducedMTUWithResult {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOId` |
     * | Type | `Edm.Guid` |
     */
    WOId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MTUNId` |
     * | Type | `Edm.String` |
     */
    MTUNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsReserved` |
     * | Type | `Edm.Boolean` |
     */
    IsReserved: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialDefinitionId` |
     * | Type | `Edm.Guid` |
     */
    MaterialDefinitionId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SerialNumberCode` |
     * | Type | `Edm.String` |
     */
    SerialNumberCode: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoMNId` |
     * | Type | `Edm.String` |
     */
    UoMNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     */
    Status: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialDefinitionNId` |
     * | Type | `Edm.String` |
     */
    MaterialDefinitionNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStatus` |
     * | Type | `Edm.String` |
     */
    WorkOrderStatus: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RecycleCount` |
     * | Type | `Edm.Int32` |
     */
    RecycleCount: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaxRecycleCount` |
     * | Type | `Edm.Int32` |
     */
    MaxRecycleCount: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MinQuantity` |
     * | Type | `Edm.Decimal` |
     */
    MinQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CodeType` |
     * | Type | `Edm.String` |
     */
    CodeType: string | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsResultKo` |
     * | Type | `Edm.Boolean` |
     */
    IsResultKo: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MTUId` |
     * | Type | `Edm.Guid` |
     */
    MTUId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DMMTUId` |
     * | Type | `Edm.Guid` |
     */
    DMMTUId: string | null;
}

export type ProducedMTUWithResultId = string | {Id: string};

export interface EXDSOpenWoo {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsReady` |
     * | Type | `Edm.Boolean` |
     */
    IsReady: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Enterprise` |
     * | Type | `Edm.String` |
     */
    Enterprise: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Plant` |
     * | Type | `Edm.String` |
     */
    Plant: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedStartTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedStartTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedEndTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedEndTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedDuration` |
     * | Type | `Edm.Int64` |
     */
    EstimatedDuration: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     */
    Status: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     */
    Sequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WoNId` |
     * | Type | `Edm.String` |
     */
    WoNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WoStatus` |
     * | Type | `Edm.String` |
     */
    WoStatus: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FinalMaterialNId` |
     * | Type | `Edm.String` |
     */
    FinalMaterialNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Preferred` |
     * | Type | `Edm.Boolean` |
     */
    Preferred: boolean | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WoId` |
     * | Type | `Edm.Guid` |
     */
    WoId: string | null;
}

export type EXDSOpenWooId = string | {Id: string};

export interface EXDSOpenWooByEquipment {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Enterprise` |
     * | Type | `Edm.String` |
     */
    Enterprise: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Plant` |
     * | Type | `Edm.String` |
     */
    Plant: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationId` |
     * | Type | `Edm.Guid` |
     */
    OperationId: string | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export type EXDSOpenWooByEquipmentId = string | {Id: string};

export interface EXDSOpenWooByEquipmentType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentType` |
     * | Type | `Edm.String` |
     */
    EquipmentType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Enterprise` |
     * | Type | `Edm.String` |
     */
    Enterprise: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Plant` |
     * | Type | `Edm.String` |
     */
    Plant: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationId` |
     * | Type | `Edm.Guid` |
     */
    OperationId: string | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export type EXDSOpenWooByEquipmentTypeId = string | {Id: string};

export interface EXDSEquipmentRelation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChildEquipmentNId` |
     * | Type | `Edm.String` |
     */
    ChildEquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `HierarchyNId` |
     * | Type | `Edm.String` |
     */
    HierarchyNId: string | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export type EXDSEquipmentRelationId = string | {Id: string};

export interface EXDSActiveWoo {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Enterprise` |
     * | Type | `Edm.String` |
     */
    Enterprise: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Plant` |
     * | Type | `Edm.String` |
     */
    Plant: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualStartTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    ActualStartTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedStartTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedStartTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedEndTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedEndTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedDuration` |
     * | Type | `Edm.Int64` |
     */
    EstimatedDuration: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     */
    Status: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     */
    Sequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WoNId` |
     * | Type | `Edm.String` |
     */
    WoNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WoStatus` |
     * | Type | `Edm.String` |
     */
    WoStatus: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FinalMaterialNId` |
     * | Type | `Edm.String` |
     */
    FinalMaterialNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AvailableQuantity` |
     * | Type | `Edm.Decimal` |
     */
    AvailableQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Preferred` |
     * | Type | `Edm.Boolean` |
     */
    Preferred: boolean | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WoId` |
     * | Type | `Edm.Guid` |
     */
    WoId: string | null;
}

export type EXDSActiveWooId = string | {Id: string};

export interface EXDSActiveWooByEquipment {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationId` |
     * | Type | `Edm.Guid` |
     */
    OperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Enterprise` |
     * | Type | `Edm.String` |
     */
    Enterprise: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Plant` |
     * | Type | `Edm.String` |
     */
    Plant: string | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export type EXDSActiveWooByEquipmentId = string | {Id: string};

export interface EXDSQueueWooByEquipment {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Enterprise` |
     * | Type | `Edm.String` |
     */
    Enterprise: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Plant` |
     * | Type | `Edm.String` |
     */
    Plant: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationId` |
     * | Type | `Edm.Guid` |
     */
    OperationId: string | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export type EXDSQueueWooByEquipmentId = string | {Id: string};

export interface EXDSQueueWooByEquipmentType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentType` |
     * | Type | `Edm.String` |
     */
    EquipmentType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Enterprise` |
     * | Type | `Edm.String` |
     */
    Enterprise: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Plant` |
     * | Type | `Edm.String` |
     */
    Plant: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationId` |
     * | Type | `Edm.Guid` |
     */
    OperationId: string | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export type EXDSQueueWooByEquipmentTypeId = string | {Id: string};

export interface EXDSEquipmentsOnOperations {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OpenOccurence` |
     * | Type | `Edm.Int32` |
     */
    OpenOccurence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `QueueOccurence` |
     * | Type | `Edm.Int32` |
     */
    QueueOccurence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActiveOccurence` |
     * | Type | `Edm.Int32` |
     */
    ActiveOccurence: number | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export type EXDSEquipmentsOnOperationsId = string | {Id: string};

export interface EXDSCompleteWoo {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Enterprise` |
     * | Type | `Edm.String` |
     */
    Enterprise: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Plant` |
     * | Type | `Edm.String` |
     */
    Plant: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualStartTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    ActualStartTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedStartTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedStartTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualEndTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    ActualEndTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedEndTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedEndTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedDuration` |
     * | Type | `Edm.Int64` |
     */
    EstimatedDuration: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     */
    Status: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     */
    Sequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WoNId` |
     * | Type | `Edm.String` |
     */
    WoNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WoStatus` |
     * | Type | `Edm.String` |
     */
    WoStatus: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FinalMaterialNId` |
     * | Type | `Edm.String` |
     */
    FinalMaterialNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Preferred` |
     * | Type | `Edm.Boolean` |
     */
    Preferred: boolean | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WoId` |
     * | Type | `Edm.Guid` |
     */
    WoId: string | null;
}

export type EXDSCompleteWooId = string | {Id: string};

export interface EXDSCompleteWooByEquipment {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationId` |
     * | Type | `Edm.Guid` |
     */
    OperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Enterprise` |
     * | Type | `Edm.String` |
     */
    Enterprise: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Plant` |
     * | Type | `Edm.String` |
     */
    Plant: string | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export type EXDSCompleteWooByEquipmentId = string | {Id: string};

export interface EXDSEquipmentDetails {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentLevel` |
     * | Type | `Edm.String` |
     */
    EquipmentLevel: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentType` |
     * | Type | `Edm.String` |
     */
    EquipmentType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentName` |
     * | Type | `Edm.String` |
     */
    EquipmentName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CompleteByDifferentUser` |
     * | Type | `Edm.String` |
     */
    CompleteByDifferentUser: string | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export type EXDSEquipmentDetailsId = string | {Id: string};

export interface EXDSStartableActiveWooByEquipment {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationId` |
     * | Type | `Edm.Guid` |
     */
    OperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Enterprise` |
     * | Type | `Edm.String` |
     */
    Enterprise: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Plant` |
     * | Type | `Edm.String` |
     */
    Plant: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     */
    Status: string | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export type EXDSStartableActiveWooByEquipmentId = string | {Id: string};

export interface EXDSStartableActiveWooByEquipmentType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentType` |
     * | Type | `Edm.String` |
     */
    EquipmentType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationId` |
     * | Type | `Edm.Guid` |
     */
    OperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Enterprise` |
     * | Type | `Edm.String` |
     */
    Enterprise: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Plant` |
     * | Type | `Edm.String` |
     */
    Plant: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     */
    Status: string | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export type EXDSStartableActiveWooByEquipmentTypeId = string | {Id: string};

export interface EXDSActiveOperationFromActiveUsersOnMachines {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Enterprise` |
     * | Type | `Edm.String` |
     */
    Enterprise: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedDuration` |
     * | Type | `Edm.Int64` |
     */
    EstimatedDuration: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedEndTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedEndTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedStartTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedStartTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FinalMaterialNId` |
     * | Type | `Edm.String` |
     */
    FinalMaterialNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Plant` |
     * | Type | `Edm.String` |
     */
    Plant: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     */
    Sequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     */
    Status: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WoNId` |
     * | Type | `Edm.String` |
     */
    WoNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WoStatus` |
     * | Type | `Edm.String` |
     */
    WoStatus: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualStartTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    ActualStartTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AvailableQuantity` |
     * | Type | `Edm.Decimal` |
     */
    AvailableQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Preferred` |
     * | Type | `Edm.Boolean` |
     */
    Preferred: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WooId` |
     * | Type | `Edm.Guid` |
     */
    WooId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WoId` |
     * | Type | `Edm.Guid` |
     */
    WoId: string | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export type EXDSActiveOperationFromActiveUsersOnMachinesId = string | {Id: string};

export interface EXDSCompleteOperationFromActualUsedMachines {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Enterprise` |
     * | Type | `Edm.String` |
     */
    Enterprise: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedDuration` |
     * | Type | `Edm.Int64` |
     */
    EstimatedDuration: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedEndTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedEndTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedStartTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedStartTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FinalMaterialNId` |
     * | Type | `Edm.String` |
     */
    FinalMaterialNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Plant` |
     * | Type | `Edm.String` |
     */
    Plant: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     */
    Sequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     */
    Status: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WoNId` |
     * | Type | `Edm.String` |
     */
    WoNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WoStatus` |
     * | Type | `Edm.String` |
     */
    WoStatus: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualStartTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    ActualStartTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualEndTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    ActualEndTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Preferred` |
     * | Type | `Edm.Boolean` |
     */
    Preferred: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WooId` |
     * | Type | `Edm.Guid` |
     */
    WooId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WoId` |
     * | Type | `Edm.Guid` |
     */
    WoId: string | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export type EXDSCompleteOperationFromActualUsedMachinesId = string | {Id: string};

export interface EXDSOpenOperationFromToBeUsedMachines {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Enterprise` |
     * | Type | `Edm.String` |
     */
    Enterprise: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedDuration` |
     * | Type | `Edm.Int64` |
     */
    EstimatedDuration: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedEndTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedEndTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedStartTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedStartTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FinalMaterialNId` |
     * | Type | `Edm.String` |
     */
    FinalMaterialNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsReady` |
     * | Type | `Edm.Boolean` |
     */
    IsReady: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Plant` |
     * | Type | `Edm.String` |
     */
    Plant: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     */
    Sequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     */
    Status: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WoNId` |
     * | Type | `Edm.String` |
     */
    WoNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WoStatus` |
     * | Type | `Edm.String` |
     */
    WoStatus: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Preferred` |
     * | Type | `Edm.Boolean` |
     */
    Preferred: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WooId` |
     * | Type | `Edm.Guid` |
     */
    WooId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WoId` |
     * | Type | `Edm.Guid` |
     */
    WoId: string | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export type EXDSOpenOperationFromToBeUsedMachinesId = string | {Id: string};

export interface EXDSStartableOperationFromToBeUsedMachines {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Enterprise` |
     * | Type | `Edm.String` |
     */
    Enterprise: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedDuration` |
     * | Type | `Edm.Int64` |
     */
    EstimatedDuration: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedEndTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedEndTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedStartTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedStartTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FinalMaterialNId` |
     * | Type | `Edm.String` |
     */
    FinalMaterialNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Plant` |
     * | Type | `Edm.String` |
     */
    Plant: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     */
    Sequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     */
    Status: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WoNId` |
     * | Type | `Edm.String` |
     */
    WoNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WoStatus` |
     * | Type | `Edm.String` |
     */
    WoStatus: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualStartTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    ActualStartTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AvailableQuantity` |
     * | Type | `Edm.Decimal` |
     */
    AvailableQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WooId` |
     * | Type | `Edm.Guid` |
     */
    WooId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WoId` |
     * | Type | `Edm.Guid` |
     */
    WoId: string | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export type EXDSStartableOperationFromToBeUsedMachinesId = string | {Id: string};

export interface EXDSOpLandingMachineEGSearch {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Machine` |
     * | Type | `Edm.String` |
     */
    Machine: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Preferred` |
     * | Type | `Edm.Int32` |
     */
    Preferred: number | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EGSearchId_Id` |
     * | Type | `Edm.Guid` |
     */
    EGSearchId_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EGSearchId` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EXDSOpLandingEGSearch` |
     */
    EGSearchId?: EXDSOpLandingEGSearch | null;
}

export type EXDSOpLandingMachineEGSearchId = string | {Id: string};

export interface EXDSOpLandingProducedMaterialsEGSearch {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `mtuCode` |
     * | Type | `Edm.String` |
     */
    mtuCode: string | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EGSearchId_Id` |
     * | Type | `Edm.Guid` |
     */
    EGSearchId_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EGSearchId` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EXDSOpLandingEGSearch` |
     */
    EGSearchId?: EXDSOpLandingEGSearch | null;
}

export type EXDSOpLandingProducedMaterialsEGSearchId = string | {Id: string};

export interface EXDSAsBuiltAutoconsumeReferenceMaterials {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WONId` |
     * | Type | `Edm.String` |
     */
    WONId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOpName` |
     * | Type | `Edm.String` |
     */
    WOOpName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOpSequence` |
     * | Type | `Edm.Int32` |
     */
    WOOpSequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOpStatusNId` |
     * | Type | `Edm.String` |
     */
    WOOpStatusNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOStepId` |
     * | Type | `Edm.Guid` |
     */
    WOStepId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOStepName` |
     * | Type | `Edm.String` |
     */
    WOStepName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOStepSequence` |
     * | Type | `Edm.Int32` |
     */
    WOStepSequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOStepStatusNId` |
     * | Type | `Edm.String` |
     */
    WOStepStatusNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoMNId` |
     * | Type | `Edm.String` |
     */
    UoMNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialSpecificationType` |
     * | Type | `Edm.String` |
     */
    MaterialSpecificationType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialNId` |
     * | Type | `Edm.String` |
     */
    MaterialNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialClassNId` |
     * | Type | `Edm.String` |
     */
    MaterialClassNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `HistoryAction` |
     * | Type | `Edm.String` |
     */
    HistoryAction: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `QuantityAssembled` |
     * | Type | `Edm.Decimal` |
     */
    QuantityAssembled: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogicalPosition` |
     * | Type | `Edm.String` |
     */
    LogicalPosition: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OccurenceId` |
     * | Type | `Edm.String` |
     */
    OccurenceId: string | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOId` |
     * | Type | `Edm.Guid` |
     */
    WOId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOpId` |
     * | Type | `Edm.Guid` |
     */
    WOOpId: string | null;
}

export type EXDSAsBuiltAutoconsumeReferenceMaterialsId = string | {Id: string};

export interface EXDSOpLandingTimeBasedInspection {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Frequency` |
     * | Type | `Edm.Decimal` |
     */
    Frequency: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TimeBasedScheduleMode` |
     * | Type | `Edm.String` |
     */
    TimeBasedScheduleMode: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CurrentTimerExpiration` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CurrentTimerExpiration: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MandatoryInspectionWarning` |
     * | Type | `Edm.Int32` |
     */
    MandatoryInspectionWarning: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MandatoryInspectionWarningUoM` |
     * | Type | `Edm.String` |
     */
    MandatoryInspectionWarningUoM: string | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EngineId` |
     * | Type | `Edm.Guid` |
     */
    EngineId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOSearch_Id` |
     * | Type | `Edm.Guid` |
     */
    WOOSearch_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOSearch` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EXDSOpLandingWOOSearch` |
     */
    WOOSearch?: EXDSOpLandingWOOSearch | null;
}

export type EXDSOpLandingTimeBasedInspectionId = string | {Id: string};

export interface EXDSOpLandingDocumentList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Category` |
     * | Type | `Edm.String` |
     */
    Category: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperation: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SerialNumber` |
     * | Type | `Edm.String` |
     */
    SerialNumber: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FileName` |
     * | Type | `Edm.String` |
     */
    FileName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MIMEType` |
     * | Type | `Edm.String` |
     */
    MIMEType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Type` |
     * | Type | `Edm.String` |
     */
    Type: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UId` |
     * | Type | `Edm.String` |
     */
    UId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FileId` |
     * | Type | `Edm.Guid` |
     */
    FileId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStep` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStep: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupPhase` |
     * | Type | `Edm.Guid` |
     */
    ExecutionGroupPhase: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IconId` |
     * | Type | `Edm.Guid` |
     */
    IconId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContainerTypeId` |
     * | Type | `Edm.Guid` |
     */
    ContainerTypeId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PLMXPackageId` |
     * | Type | `Edm.String` |
     */
    PLMXPackageId: string | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Document` |
     * | Type | `Edm.Guid` |
     */
    Document: string | null;
}

export type EXDSOpLandingDocumentListId = string | {Id: string};

export interface EXDSGetMTUDocumentAssociation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MIMEType` |
     * | Type | `Edm.String` |
     */
    MIMEType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IconId` |
     * | Type | `Edm.Guid` |
     */
    IconId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RepositoryType` |
     * | Type | `Edm.Int32` |
     */
    RepositoryType: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LocalFileId` |
     * | Type | `Edm.Guid` |
     */
    LocalFileId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FileName` |
     * | Type | `Edm.String` |
     */
    FileName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IconName` |
     * | Type | `Edm.String` |
     */
    IconName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     */
    Revision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Category` |
     * | Type | `Edm.String` |
     */
    Category: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentCategoryLink` |
     * | Type | `Edm.String` |
     */
    DocumentCategoryLink: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialTrackingUnitId` |
     * | Type | `Edm.Guid` |
     */
    MaterialTrackingUnitId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnitDocumentAssociationId` |
     * | Type | `Edm.Guid` |
     */
    DM_MaterialTrackingUnitDocumentAssociationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityLinkId` |
     * | Type | `Edm.Guid` |
     */
    EntityLinkId: string | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocId` |
     * | Type | `Edm.Guid` |
     */
    DocId: string | null;
}

export type EXDSGetMTUDocumentAssociationId = string | {Id: string};

export interface EXDSOpLandingGetAllMaterialDefinitionDocuments {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FileName` |
     * | Type | `Edm.String` |
     */
    FileName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MIMEType` |
     * | Type | `Edm.String` |
     */
    MIMEType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Nid` |
     * | Type | `Edm.String` |
     */
    Nid: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LocalFileId` |
     * | Type | `Edm.Guid` |
     */
    LocalFileId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Category` |
     * | Type | `Edm.String` |
     */
    Category: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStepId: string | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocId` |
     * | Type | `Edm.Guid` |
     */
    DocId: string | null;
}

export type EXDSOpLandingGetAllMaterialDefinitionDocumentsId = string | {Id: string};

export interface EXDSGetNCDocumentAssociation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MIMEType` |
     * | Type | `Edm.String` |
     */
    MIMEType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IconId` |
     * | Type | `Edm.Guid` |
     */
    IconId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RepositoryType` |
     * | Type | `Edm.Int32` |
     */
    RepositoryType: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LocalFileId` |
     * | Type | `Edm.Guid` |
     */
    LocalFileId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FileName` |
     * | Type | `Edm.String` |
     */
    FileName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IconName` |
     * | Type | `Edm.String` |
     */
    IconName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     */
    Revision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonconformanceId` |
     * | Type | `Edm.Guid` |
     */
    NonconformanceId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LinkedEntityId` |
     * | Type | `Edm.Guid` |
     */
    LinkedEntityId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Category` |
     * | Type | `Edm.String` |
     */
    Category: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonconformanceHistoryId` |
     * | Type | `Edm.Guid` |
     */
    NonconformanceHistoryId: string | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityLinkId` |
     * | Type | `Edm.Guid` |
     */
    EntityLinkId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocId` |
     * | Type | `Edm.Guid` |
     */
    DocId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
}

export type EXDSGetNCDocumentAssociationId = string | {Id: string};

export interface vEXDSBoM {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FinalMaterial` |
     * | Type | `Edm.String` |
     */
    FinalMaterial: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BOM` |
     * | Type | `Edm.String` |
     */
    BOM: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BOMItem` |
     * | Type | `Edm.String` |
     */
    BOMItem: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoM` |
     * | Type | `Edm.String` |
     */
    UoM: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Traceable` |
     * | Type | `Edm.Boolean` |
     */
    Traceable: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialId` |
     * | Type | `Edm.Guid` |
     */
    MaterialId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Material` |
     * | Type | `Edm.String` |
     */
    Material: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentBOM` |
     * | Type | `Edm.Guid` |
     */
    ParentBOM: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentId` |
     * | Type | `Edm.Guid` |
     */
    DocumentId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FinalMaterialId` |
     * | Type | `Edm.Guid` |
     */
    FinalMaterialId: string | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export type vEXDSBoMId = string | {Id: string};

export interface vEXDSSnagAndNote {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperation: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Message` |
     * | Type | `Edm.String` |
     */
    Message: string | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export type vEXDSSnagAndNoteId = string | {Id: string};

export interface EXDSDocActualCollectDocument {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnitId` |
     * | Type | `Edm.Guid` |
     */
    DM_MaterialTrackingUnitId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStepId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupPhaseId` |
     * | Type | `Edm.Guid` |
     */
    ExecutionGroupPhaseId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Document` |
     * | Type | `Edm.Guid` |
     */
    Document: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MIMEType` |
     * | Type | `Edm.String` |
     */
    MIMEType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FileName` |
     * | Type | `Edm.String` |
     */
    FileName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IconName` |
     * | Type | `Edm.String` |
     */
    IconName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RepositoryType` |
     * | Type | `Edm.Int32` |
     */
    RepositoryType: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IconId` |
     * | Type | `Edm.Guid` |
     */
    IconId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LocalFileId` |
     * | Type | `Edm.Guid` |
     */
    LocalFileId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     */
    Revision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceRevision` |
     * | Type | `Edm.String` |
     */
    SourceRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsCurrent` |
     * | Type | `Edm.Boolean` |
     */
    IsCurrent: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `egPhaseNId` |
     * | Type | `Edm.String` |
     */
    egPhaseNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `egPhaseName` |
     * | Type | `Edm.String` |
     */
    egPhaseName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `egNId` |
     * | Type | `Edm.String` |
     */
    egNId: string | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
}

export type EXDSDocActualCollectDocumentId = string | {Id: string};

export interface EXDSWorkOrderHistoryRuntimeDocument {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Document` |
     * | Type | `Edm.String` |
     */
    Document: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MIMEType` |
     * | Type | `Edm.String` |
     */
    MIMEType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FileName` |
     * | Type | `Edm.String` |
     */
    FileName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IconName` |
     * | Type | `Edm.String` |
     */
    IconName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RepositoryType` |
     * | Type | `Edm.Int32` |
     */
    RepositoryType: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IconId` |
     * | Type | `Edm.Guid` |
     */
    IconId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LocalFileId` |
     * | Type | `Edm.Guid` |
     */
    LocalFileId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     */
    Revision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceRevision` |
     * | Type | `Edm.String` |
     */
    SourceRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsCurrent` |
     * | Type | `Edm.Boolean` |
     */
    IsCurrent: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Equipment` |
     * | Type | `Edm.String` |
     */
    Equipment: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Message` |
     * | Type | `Edm.String` |
     */
    Message: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessUId` |
     * | Type | `Edm.String` |
     */
    ProcessUId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserId` |
     * | Type | `Edm.String` |
     */
    UserId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SerialNumber` |
     * | Type | `Edm.String` |
     */
    SerialNumber: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupPhaseId` |
     * | Type | `Edm.Guid` |
     */
    ExecutionGroupPhaseId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStepId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Date` |
     * | Type | `Edm.DateTimeOffset` |
     */
    Date: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationName` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderStepNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepName` |
     * | Type | `Edm.String` |
     */
    WorkOrderStepName: string | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export type EXDSWorkOrderHistoryRuntimeDocumentId = string | {Id: string};

export interface EXDSGetExecutionGroupList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedDuration` |
     * | Type | `Edm.String` |
     */
    EstimatedDuration: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedEndTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedEndTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedStartTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedStartTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DueDate` |
     * | Type | `Edm.DateTimeOffset` |
     */
    DueDate: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     */
    Status: string | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export type EXDSGetExecutionGroupListId = string | {Id: string};

export interface EXDSOpenAndStartableOperationFromToBeUsedMachines {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Enterprise` |
     * | Type | `Edm.String` |
     */
    Enterprise: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Plant` |
     * | Type | `Edm.String` |
     */
    Plant: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualStartTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    ActualStartTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedStartTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedStartTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedEndTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedEndTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedDuration` |
     * | Type | `Edm.Int64` |
     */
    EstimatedDuration: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     */
    Status: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     */
    Sequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WoNId` |
     * | Type | `Edm.String` |
     */
    WoNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WoStatus` |
     * | Type | `Edm.String` |
     */
    WoStatus: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FinalMaterialNId` |
     * | Type | `Edm.String` |
     */
    FinalMaterialNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AvailableQuantity` |
     * | Type | `Edm.Decimal` |
     */
    AvailableQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsReady` |
     * | Type | `Edm.Boolean` |
     */
    IsReady: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Preferred` |
     * | Type | `Edm.Boolean` |
     */
    Preferred: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WooId` |
     * | Type | `Edm.Guid` |
     */
    WooId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WoId` |
     * | Type | `Edm.Guid` |
     */
    WoId: string | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export type EXDSOpenAndStartableOperationFromToBeUsedMachinesId = string | {Id: string};

export interface EXDSGetReworkCode {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefectTypeId` |
     * | Type | `Edm.Guid` |
     */
    DefectTypeId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefectGroupId` |
     * | Type | `Edm.Guid` |
     */
    DefectGroupId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialNId` |
     * | Type | `Edm.String` |
     */
    DM_MaterialNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FailureNId` |
     * | Type | `Edm.String` |
     */
    FailureNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FailureName` |
     * | Type | `Edm.String` |
     */
    FailureName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessId` |
     * | Type | `Edm.Guid` |
     */
    ProcessId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessNId` |
     * | Type | `Edm.String` |
     */
    ProcessNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessRevision` |
     * | Type | `Edm.String` |
     */
    ProcessRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UId` |
     * | Type | `Edm.String` |
     */
    UId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TypeDescription` |
     * | Type | `Edm.String` |
     */
    TypeDescription: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `GroupDescription` |
     * | Type | `Edm.String` |
     */
    GroupDescription: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefectGroupNId` |
     * | Type | `Edm.String` |
     */
    DefectGroupNId: string | null;
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
}

export type EXDSGetReworkCodeId = string | {Id: string};

export interface EquipmentConfigurationToAutomationNodeInstance {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutomationNodeInstanceNId` |
     * | Type | `Edm.String` |
     */
    AutomationNodeInstanceNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfiguration_Id` |
     * | Type | `Edm.Guid` |
     */
    EquipmentConfiguration_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfiguration` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentConfiguration` |
     */
    EquipmentConfiguration?: EquipmentConfiguration | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentConfigurationToAutomationNodeInstanceFacet)` |
     */
    Facets?: Array<EquipmentConfigurationToAutomationNodeInstanceFacet>;
}

export type EquipmentConfigurationToAutomationNodeInstanceId = string | {Id: string};

export interface DocumentNew {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     */
    Revision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceRevision` |
     * | Type | `Edm.String` |
     */
    SourceRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsCurrent` |
     * | Type | `Edm.Boolean` |
     */
    IsCurrent: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MIMEType` |
     * | Type | `Edm.String` |
     */
    MIMEType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FileName` |
     * | Type | `Edm.String` |
     */
    FileName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IconName` |
     * | Type | `Edm.String` |
     */
    IconName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Url` |
     * | Type | `Edm.String` |
     */
    Url: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UrlSource` |
     * | Type | `Siemens.OpcenterEX.FN.MasterData.DOC_MS.MSModel.Types.ReadingModel.UrlSourceEnum` |
     */
    UrlSource: UrlSourceEnum | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Icon_Id_Id` |
     * | Type | `Edm.Guid` |
     */
    Icon_Id_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LocalFile_Id_Id` |
     * | Type | `Edm.Guid` |
     */
    LocalFile_Id_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RepositoryType` |
     * | Type | `Siemens.OpcenterEX.FN.MasterData.DOC_MS.MSModel.Types.ReadingModel.DocumentType` |
     */
    RepositoryType: DocumentType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Icon_Id` |
     * | Type | `Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.File` |
     */
    Icon_Id?: File | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LocalFile_Id` |
     * | Type | `Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.File` |
     */
    LocalFile_Id?: File | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DocumentNewFacet)` |
     */
    Facets?: Array<DocumentNewFacet>;
}

export type DocumentNewId = string | {Id: string};

export interface InspectionOperation {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     */
    Revision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceRevision` |
     * | Type | `Edm.String` |
     */
    SourceRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsCurrent` |
     * | Type | `Edm.Boolean` |
     */
    IsCurrent: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CharacteristicRepresentations` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.CharacteristicRepresentation)` |
     */
    CharacteristicRepresentations?: Array<CharacteristicRepresentation>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.InspectionOperationFacet)` |
     */
    Facets?: Array<InspectionOperationFacet>;
}

export type InspectionOperationId = string | {Id: string};

export interface WorkOrderOperationToolInfo {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutomationNodeInstanceNId` |
     * | Type | `Edm.String` |
     */
    AutomationNodeInstanceNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkplaceNId` |
     * | Type | `Edm.String` |
     */
    WorkplaceNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActivityNId` |
     * | Type | `Edm.String` |
     */
    ActivityNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolId` |
     * | Type | `Edm.Guid` |
     */
    ToolId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AlertCommunication` |
     * | Type | `Edm.Boolean` |
     */
    AlertCommunication: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderOperation` |
     */
    WorkOrderOperation?: WorkOrderOperation | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderOperationToolInfoFacet)` |
     */
    Facets?: Array<WorkOrderOperationToolInfoFacet>;
}

export type WorkOrderOperationToolInfoId = string | {Id: string};

export interface ScrewingToolHistory {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolNId` |
     * | Type | `Edm.String` |
     */
    ToolNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `User` |
     * | Type | `Edm.String` |
     */
    User: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UsageDate` |
     * | Type | `Edm.DateTimeOffset` |
     */
    UsageDate: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MTUId` |
     * | Type | `Edm.Guid` |
     */
    DM_MTUId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MTUNId` |
     * | Type | `Edm.String` |
     */
    MTUNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MTUCode` |
     * | Type | `Edm.String` |
     */
    MTUCode: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Reason` |
     * | Type | `Edm.String` |
     */
    Reason: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Torque` |
     * | Type | `Edm.Decimal` |
     */
    Torque: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Angle` |
     * | Type | `Edm.Decimal` |
     */
    Angle: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsOk` |
     * | Type | `Edm.Boolean` |
     */
    IsOk: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItemId` |
     * | Type | `Edm.Int32` |
     */
    ItemId: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedTool_Id` |
     * | Type | `Edm.Guid` |
     */
    ToBeUsedTool_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedTool` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToBeUsedTool` |
     */
    ToBeUsedTool?: ToBeUsedTool | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ScrewingToolHistoryFacet)` |
     */
    Facets?: Array<ScrewingToolHistoryFacet>;
}

export type ScrewingToolHistoryId = string | {Id: string};

export interface TaskContextUserField {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserFieldValue` |
     * | Type | `Edm.String` |
     */
    UserFieldValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserFieldType` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.SupportedTypes` |
     */
    UserFieldType: SupportedTypes | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskContext_Id` |
     * | Type | `Edm.Guid` |
     */
    TaskContext_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskContext` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.TaskContext` |
     */
    TaskContext?: TaskContext | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.TaskContextUserFieldFacet)` |
     */
    Facets?: Array<TaskContextUserFieldFacet>;
}

export type TaskContextUserFieldId = string | {Id: string};

export interface TaskContext {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContextEntityType` |
     * | Type | `Edm.String` |
     */
    ContextEntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContextDefinitionNId` |
     * | Type | `Edm.String` |
     */
    ContextDefinitionNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Task_Id` |
     * | Type | `Edm.Guid` |
     */
    Task_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserFields` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.TaskContextUserField)` |
     */
    UserFields?: Array<TaskContextUserField>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Task` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Task` |
     */
    Task?: Task | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.TaskContextFacet)` |
     */
    Facets?: Array<TaskContextFacet>;
}

export type TaskContextId = string | {Id: string};

export interface Task {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskTypeNId` |
     * | Type | `Edm.String` |
     */
    TaskTypeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskUI` |
     * | Type | `Edm.String` |
     */
    TaskUI: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskMessageUI` |
     * | Type | `Edm.String` |
     */
    TaskMessageUI: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskDefinitionNId` |
     * | Type | `Edm.String` |
     */
    TaskDefinitionNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskDefinitionRevision` |
     * | Type | `Edm.String` |
     */
    TaskDefinitionRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskInstanceUI` |
     * | Type | `Edm.String` |
     */
    TaskInstanceUI: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskTypeIcon` |
     * | Type | `Edm.String` |
     */
    TaskTypeIcon: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ErrorCount` |
     * | Type | `Edm.Int32` |
     */
    ErrorCount: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsSkippable` |
     * | Type | `Edm.Boolean` |
     */
    IsSkippable: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.StatusType` |
     * | Nullable | `false` |
     */
    Status: StatusType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskFlow` |
     * | Type | `Siemens.SimaticIT.OperationalData.TSK_OP.OPModel.Types.ReadingModel.TaskFlowType_Siemens_SimaticIT_OperationalData_TSK_OP_OPModel_Types` |
     * | Nullable | `false` |
     */
    TaskFlow: TaskFlowType_Siemens_SimaticIT_OperationalData_TSK_OP_OPModel_Types;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Contexts` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.TaskContext)` |
     */
    Contexts?: Array<TaskContext>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.TaskFacet)` |
     */
    Facets?: Array<TaskFacet>;
}

export type TaskId = string | {Id: string};

export interface TaskContextDefinitionUserField {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserFieldValue` |
     * | Type | `Edm.String` |
     */
    UserFieldValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserFieldType` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.SupportedTypes` |
     */
    UserFieldType: SupportedTypes | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskContextDefinition_Id` |
     * | Type | `Edm.Guid` |
     */
    TaskContextDefinition_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskContextDefinition` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.TaskContextDefinition` |
     */
    TaskContextDefinition?: TaskContextDefinition | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.TaskContextDefinitionUserFieldFacet)` |
     */
    Facets?: Array<TaskContextDefinitionUserFieldFacet>;
}

export type TaskContextDefinitionUserFieldId = string | {Id: string};

export interface TaskDefinition {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     */
    Revision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceRevision` |
     * | Type | `Edm.String` |
     */
    SourceRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsCurrent` |
     * | Type | `Edm.Boolean` |
     */
    IsCurrent: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskDefinitionUI` |
     * | Type | `Edm.String` |
     */
    TaskDefinitionUI: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskMessageUI` |
     * | Type | `Edm.String` |
     */
    TaskMessageUI: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskTypeNId` |
     * | Type | `Edm.String` |
     */
    TaskTypeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskUI` |
     * | Type | `Edm.String` |
     */
    TaskUI: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskEntityType` |
     * | Type | `Edm.String` |
     */
    TaskEntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskInstanceUI` |
     * | Type | `Edm.String` |
     */
    TaskInstanceUI: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskTypeIcon` |
     * | Type | `Edm.String` |
     */
    TaskTypeIcon: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskContextDefinitions` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.TaskContextDefinition)` |
     */
    TaskContextDefinitions?: Array<TaskContextDefinition>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.TaskDefinitionFacet)` |
     */
    Facets?: Array<TaskDefinitionFacet>;
}

export type TaskDefinitionId = string | {Id: string};

export interface TaskContextDefinition {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContextEntityType` |
     * | Type | `Edm.String` |
     */
    ContextEntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserFields` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.TaskContextDefinitionUserField)` |
     */
    UserFields?: Array<TaskContextDefinitionUserField>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskDefinitions` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.TaskDefinition)` |
     */
    TaskDefinitions?: Array<TaskDefinition>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.TaskContextDefinitionFacet)` |
     */
    Facets?: Array<TaskContextDefinitionFacet>;
}

export type TaskContextDefinitionId = string | {Id: string};

export interface FeatureValue {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Feature_Id` |
     * | Type | `Edm.Guid` |
     */
    Feature_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Feature` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Feature` |
     */
    Feature?: Feature | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.FeatureValueFacet)` |
     */
    Facets?: Array<FeatureValueFacet>;
}

export type FeatureValueId = string | {Id: string};

export interface Feature {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsOption` |
     * | Type | `Edm.Boolean` |
     */
    IsOption: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FeatureValueList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.FeatureValue)` |
     */
    FeatureValueList?: Array<FeatureValue>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.FeatureFacet)` |
     */
    Facets?: Array<FeatureFacet>;
}

export type FeatureId = string | {Id: string};

export interface BillOfFeatureItem {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FeatureNId` |
     * | Type | `Edm.String` |
     */
    FeatureNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FeatureValueNId` |
     * | Type | `Edm.String` |
     */
    FeatureValueNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsOption` |
     * | Type | `Edm.Boolean` |
     */
    IsOption: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BillOfFeature_Id` |
     * | Type | `Edm.Guid` |
     */
    BillOfFeature_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BillOfFeature` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.BillOfFeature` |
     */
    BillOfFeature?: BillOfFeature | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.BillOfFeatureItemFacet)` |
     */
    Facets?: Array<BillOfFeatureItemFacet>;
}

export type BillOfFeatureItemId = string | {Id: string};

export interface ToBeUsedBillOfFeature {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BillOfFeatureNId` |
     * | Type | `Edm.String` |
     */
    BillOfFeatureNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BillOfFeatureRevision` |
     * | Type | `Edm.String` |
     */
    BillOfFeatureRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToBeUsedBillOfFeatureFacet)` |
     */
    Facets?: Array<ToBeUsedBillOfFeatureFacet>;
}

export type ToBeUsedBillOfFeatureId = string | {Id: string};

export interface BillOfFeature {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     */
    Revision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceRevision` |
     * | Type | `Edm.String` |
     */
    SourceRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsCurrent` |
     * | Type | `Edm.Boolean` |
     */
    IsCurrent: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BillOfFeatureItemList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.BillOfFeatureItem)` |
     */
    BillOfFeatureItemList?: Array<BillOfFeatureItem>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.BillOfFeatureFacet)` |
     */
    Facets?: Array<BillOfFeatureFacet>;
}

export type BillOfFeatureId = string | {Id: string};

export interface NumberingPatternEntityInfo {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AppName` |
     * | Type | `Edm.String` |
     */
    AppName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityName` |
     * | Type | `Edm.String` |
     */
    EntityName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityProperty` |
     * | Type | `Edm.String` |
     */
    EntityProperty: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NumberingPatternEntityNId_Id` |
     * | Type | `Edm.Guid` |
     */
    NumberingPatternEntityNId_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NumberingPatternEntityNId` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NumberingPatternEntity` |
     */
    NumberingPatternEntityNId?: NumberingPatternEntity | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NumberingPatternEntityInfoFacet)` |
     */
    Facets?: Array<NumberingPatternEntityInfoFacet>;
}

export type NumberingPatternEntityInfoId = string | {Id: string};

export interface NumberingPatternMaterialAssociation {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NumberingPatternNId` |
     * | Type | `Edm.String` |
     */
    NumberingPatternNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityTypeNId` |
     * | Type | `Edm.String` |
     */
    EntityTypeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DMMaterialId` |
     * | Type | `Edm.Guid` |
     */
    DMMaterialId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NumberingPatternMaterialAssociationFacet)` |
     */
    Facets?: Array<NumberingPatternMaterialAssociationFacet>;
}

export type NumberingPatternMaterialAssociationId = string | {Id: string};

export interface ExtEventLogFailureNotification {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EventId` |
     * | Type | `Edm.Guid` |
     */
    EventId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExtEventLog_Id` |
     * | Type | `Edm.Guid` |
     */
    ExtEventLog_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExtEventLog` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ExtEventLog` |
     */
    ExtEventLog?: ExtEventLog | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ExtEventLogFailureNotificationFacet)` |
     */
    Facets?: Array<ExtEventLogFailureNotificationFacet>;
}

export type ExtEventLogFailureNotificationId = string | {Id: string};

export interface ToBeUsedSetPointItemATNInstanceAssociation {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutomationInstanceNId` |
     * | Type | `Edm.String` |
     */
    AutomationInstanceNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutomationInstanceParameterNId` |
     * | Type | `Edm.String` |
     */
    AutomationInstanceParameterNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Equipment` |
     * | Type | `Edm.String` |
     */
    Equipment: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointItemValue` |
     * | Type | `Edm.String` |
     */
    SetPointItemValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsDefaultValue` |
     * | Type | `Edm.Boolean` |
     */
    IsDefaultValue: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointItem_Id` |
     * | Type | `Edm.Guid` |
     */
    SetPointItem_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointItem` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.SetPointItem` |
     */
    SetPointItem?: SetPointItem | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderOperation` |
     */
    WorkOrderOperation?: WorkOrderOperation | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToBeUsedSetPointItemATNInstanceAssociationFacet)` |
     */
    Facets?: Array<ToBeUsedSetPointItemATNInstanceAssociationFacet>;
}

export type ToBeUsedSetPointItemATNInstanceAssociationId = string | {Id: string};

export interface RuntimeCharReprRefOperationAssociation {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RuntimeCharacteristicRepresentationNId` |
     * | Type | `Edm.String` |
     */
    RuntimeCharacteristicRepresentationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessToOperationLinkUId` |
     * | Type | `Edm.String` |
     */
    ProcessToOperationLinkUId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChrReprFrequencyNId` |
     * | Type | `Edm.String` |
     */
    ChrReprFrequencyNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedInspection_Id` |
     * | Type | `Edm.Guid` |
     */
    ToBeUsedInspection_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedInspection` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToBeUsedInspection` |
     */
    ToBeUsedInspection?: ToBeUsedInspection | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.RuntimeCharReprRefOperationAssociationFacet)` |
     */
    Facets?: Array<RuntimeCharReprRefOperationAssociationFacet>;
}

export type RuntimeCharReprRefOperationAssociationId = string | {Id: string};

export interface CharacteristicRepresentationFrequency {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CharacteristicRepresentation` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.CharacteristicRepresentation)` |
     */
    CharacteristicRepresentation?: Array<CharacteristicRepresentation>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.CharacteristicRepresentationFrequencyFacet)` |
     */
    Facets?: Array<CharacteristicRepresentationFrequencyFacet>;
}

export type CharacteristicRepresentationFrequencyId = string | {Id: string};

export interface ScenarioInstance {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActionLabel` |
     * | Type | `Edm.String` |
     */
    ActionLabel: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SignedEntityType` |
     * | Type | `Edm.String` |
     */
    SignedEntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Siemens.SimaticIT.SystemData.ES_SD.SDModel.Types.ReadingModel.StatusScenarioEnum` |
     */
    Status: StatusScenarioEnum | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ValidationMode` |
     * | Type | `Siemens.SimaticIT.SystemData.ES_SD.SDModel.Types.ReadingModel.ValidationModeEnum` |
     */
    ValidationMode: ValidationModeEnum | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ScenarioConfigurationId` |
     * | Type | `Edm.Guid` |
     */
    ScenarioConfigurationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ScenarioConfigurationNId` |
     * | Type | `Edm.String` |
     */
    ScenarioConfigurationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Context` |
     * | Type | `Edm.String` |
     */
    Context: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ScenarioConfigurationVersion` |
     * | Type | `Edm.String` |
     */
    ScenarioConfigurationVersion: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ApplicationName` |
     * | Type | `Edm.String` |
     */
    ApplicationName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SignedEntityId` |
     * | Type | `Edm.Guid` |
     */
    SignedEntityId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ValidationPolicy` |
     * | Type | `Siemens.SimaticIT.MasterData.ES_MS.MSModel.Types.ReadingModel.ValidationPolicyEnum` |
     */
    ValidationPolicy: ValidationPolicyEnum | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SignatureInstances` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.SignatureInstance)` |
     */
    SignatureInstances?: Array<SignatureInstance>;
}

export type ScenarioInstanceId = string | {Id: string};

export interface SignatureInstance {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     */
    Sequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Reason` |
     * | Type | `Edm.String` |
     */
    Reason: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TimeStamp` |
     * | Type | `Edm.DateTimeOffset` |
     */
    TimeStamp: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Siemens.SimaticIT.SystemData.ES_SD.SDModel.Types.ReadingModel.StatusScenarioEnum` |
     */
    Status: StatusScenarioEnum | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Comment` |
     * | Type | `Edm.String` |
     */
    Comment: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsCommentMandatory` |
     * | Type | `Edm.Boolean` |
     */
    IsCommentMandatory: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Index` |
     * | Type | `Edm.Int32` |
     */
    Index: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ScenarioInstance_Id` |
     * | Type | `Edm.Guid` |
     */
    ScenarioInstance_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Signer` |
     * | Type | `Siemens.SimaticIT.MasterData.ES_MS.MSModel.Types.ReadingModel.SignerValueType_Siemens_SimaticIT_MasterData_ES_MS_MSModel_Types` |
     * | Nullable | `false` |
     */
    Signer: SignerValueType_Siemens_SimaticIT_MasterData_ES_MS_MSModel_Types;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserIdentity` |
     * | Type | `Siemens.SimaticIT.SystemData.ES_SD.SDModel.Types.ReadingModel.SignerIdentityType_Siemens_SimaticIT_SystemData_ES_SD_SDModel_Types` |
     * | Nullable | `false` |
     */
    UserIdentity: SignerIdentityType_Siemens_SimaticIT_SystemData_ES_SD_SDModel_Types;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ScenarioInstance` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ScenarioInstance` |
     */
    ScenarioInstance?: ScenarioInstance | null;
}

export type SignatureInstanceId = string | {Id: string};

export interface SignatureConfiguration {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     */
    Sequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Reason` |
     * | Type | `Edm.String` |
     */
    Reason: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsCommentMandatory` |
     * | Type | `Edm.Boolean` |
     */
    IsCommentMandatory: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Index` |
     * | Type | `Edm.Int32` |
     */
    Index: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ScenarioConfiguration_Id` |
     * | Type | `Edm.Guid` |
     */
    ScenarioConfiguration_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Signer` |
     * | Type | `Siemens.SimaticIT.MasterData.ES_MS.MSModel.Types.ReadingModel.SignerValueType_Siemens_SimaticIT_MasterData_ES_MS_MSModel_Types` |
     * | Nullable | `false` |
     */
    Signer: SignerValueType_Siemens_SimaticIT_MasterData_ES_MS_MSModel_Types;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ScenarioConfiguration` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ScenarioConfiguration` |
     */
    ScenarioConfiguration?: ScenarioConfiguration | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.SignatureConfigurationFacet)` |
     */
    Facets?: Array<SignatureConfigurationFacet>;
}

export type SignatureConfigurationId = string | {Id: string};

export interface ScenarioConfiguration {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     */
    Revision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceRevision` |
     * | Type | `Edm.String` |
     */
    SourceRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsCurrent` |
     * | Type | `Edm.Boolean` |
     */
    IsCurrent: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MultipleSignaturesFromSameUser` |
     * | Type | `Edm.Boolean` |
     */
    MultipleSignaturesFromSameUser: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ValidationPolicy` |
     * | Type | `Siemens.SimaticIT.MasterData.ES_MS.MSModel.Types.ReadingModel.ValidationPolicyEnum` |
     */
    ValidationPolicy: ValidationPolicyEnum | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SignatureConfigurations` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.SignatureConfiguration)` |
     */
    SignatureConfigurations?: Array<SignatureConfiguration>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ScenarioConfigurationFacet)` |
     */
    Facets?: Array<ScenarioConfigurationFacet>;
}

export type ScenarioConfigurationId = string | {Id: string};

export interface OutMsg {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MsgId` |
     * | Type | `Edm.String` |
     */
    MsgId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OutMsgDefinitionNId` |
     * | Type | `Edm.String` |
     */
    OutMsgDefinitionNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MsgHeaderData` |
     * | Type | `Edm.Binary` |
     */
    MsgHeaderData: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SendTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    SendTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MsgSchemaNId` |
     * | Type | `Edm.String` |
     */
    MsgSchemaNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsRegenerated` |
     * | Type | `Edm.Boolean` |
     */
    IsRegenerated: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PlantNId` |
     * | Type | `Edm.String` |
     */
    PlantNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PlantERPNId` |
     * | Type | `Edm.String` |
     */
    PlantERPNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkPlaceNId` |
     * | Type | `Edm.String` |
     */
    WorkPlaceNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DestinationNId` |
     * | Type | `Edm.String` |
     */
    DestinationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PFCMilestoneNId` |
     * | Type | `Edm.String` |
     */
    PFCMilestoneNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PFCDiagramNId` |
     * | Type | `Edm.String` |
     */
    PFCDiagramNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialInstanceNId` |
     * | Type | `Edm.String` |
     */
    MaterialInstanceNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PFCMilestoneSequence` |
     * | Type | `Edm.Int32` |
     */
    PFCMilestoneSequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FileId` |
     * | Type | `Edm.Guid` |
     */
    FileId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OutMsgDefinitionRevision` |
     * | Type | `Edm.String` |
     */
    OutMsgDefinitionRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.OutMsgFacet)` |
     */
    Facets?: Array<OutMsgFacet>;
}

export type OutMsgId = string | {Id: string};

export interface DM_FunctionalCode {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DM_FunctionalCodeFacet)` |
     */
    Facets?: Array<DM_FunctionalCodeFacet>;
}

export type DM_FunctionalCodeId = string | {Id: string};

export interface MaterialSupplierAssociation {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SupplierNId` |
     * | Type | `Edm.String` |
     */
    SupplierNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Supplier_Id` |
     * | Type | `Edm.Guid` |
     */
    Supplier_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_Material_Id` |
     * | Type | `Edm.Guid` |
     */
    DM_Material_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Material` |
     * | Type | `Siemens.SimaticIT.UADM.MasterData.FB_MS_MAT.MSModel.Types.ReadingModel.MaterialValueType_Siemens_SimaticIT_UADM_MasterData_FB_MS_MAT_MSModel_Types` |
     * | Nullable | `false` |
     */
    Material: MaterialValueType_Siemens_SimaticIT_UADM_MasterData_FB_MS_MAT_MSModel_Types;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Supplier` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Supplier` |
     */
    Supplier?: Supplier | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_Material` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DM_Material` |
     */
    DM_Material?: DM_Material | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.MaterialSupplierAssociationFacet)` |
     */
    Facets?: Array<MaterialSupplierAssociationFacet>;
}

export type MaterialSupplierAssociationId = string | {Id: string};

export interface WorkInstructionToExecutionGroupPhaseAssociation {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupPhase_Id` |
     * | Type | `Edm.Guid` |
     */
    ExecutionGroupPhase_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstruction_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkInstruction_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnit_Id` |
     * | Type | `Edm.Guid` |
     */
    DM_MaterialTrackingUnit_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupPhase` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ExecutionGroupPhase` |
     */
    ExecutionGroupPhase?: ExecutionGroupPhase | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstruction` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkInstruction` |
     */
    WorkInstruction?: WorkInstruction | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnit` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DM_MaterialTrackingUnit` |
     */
    DM_MaterialTrackingUnit?: DM_MaterialTrackingUnit | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkInstructionToExecutionGroupPhaseAssociationFacet)` |
     */
    Facets?: Array<WorkInstructionToExecutionGroupPhaseAssociationFacet>;
}

export type WorkInstructionToExecutionGroupPhaseAssociationId = string | {Id: string};

export interface WIDefinitionToEGPhaseAssociation {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionAssociationType_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkInstructionAssociationType_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionDefinition_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkInstructionDefinition_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EGPhase_Id` |
     * | Type | `Edm.Guid` |
     */
    EGPhase_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionAssociationType` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkInstructionAssociationType` |
     */
    WorkInstructionAssociationType?: WorkInstructionAssociationType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionDefinition` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkInstructionDefinition` |
     */
    WorkInstructionDefinition?: WorkInstructionDefinition | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EGPhase` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ExecutionGroupPhase` |
     */
    EGPhase?: ExecutionGroupPhase | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WIDefinitionToEGPhaseAssociationFacet)` |
     */
    Facets?: Array<WIDefinitionToEGPhaseAssociationFacet>;
}

export type WIDefinitionToEGPhaseAssociationId = string | {Id: string};

export interface ResultType {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResultValue` |
     * | Type | `Edm.String` |
     */
    ResultValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsKO` |
     * | Type | `Edm.Boolean` |
     */
    IsKO: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsDefault` |
     * | Type | `Edm.Boolean` |
     */
    IsDefault: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ResultTypeFacet)` |
     */
    Facets?: Array<ResultTypeFacet>;
}

export type ResultTypeId = string | {Id: string};

export interface ResultStrategy {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ResultStrategyFacet)` |
     */
    Facets?: Array<ResultStrategyFacet>;
}

export type ResultStrategyId = string | {Id: string};

export interface ResultHistoryAction {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ResultHistoryActionFacet)` |
     */
    Facets?: Array<ResultHistoryActionFacet>;
}

export type ResultHistoryActionId = string | {Id: string};

export interface ResultHistory {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderStepNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialTrackingUnitNId` |
     * | Type | `Edm.String` |
     */
    MaterialTrackingUnitNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserId` |
     * | Type | `Edm.String` |
     */
    UserId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Date` |
     * | Type | `Edm.DateTimeOffset` |
     */
    Date: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResultValue` |
     * | Type | `Edm.String` |
     */
    ResultValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceNId` |
     * | Type | `Edm.String` |
     */
    NonConformanceNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResultStrategy` |
     * | Type | `Edm.String` |
     */
    ResultStrategy: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActivityNId` |
     * | Type | `Edm.String` |
     */
    ActivityNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActivityType` |
     * | Type | `Edm.String` |
     */
    ActivityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsPartial` |
     * | Type | `Edm.Boolean` |
     */
    IsPartial: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResultIsKO` |
     * | Type | `Edm.Boolean` |
     */
    ResultIsKO: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResultHistoryAction_Id` |
     * | Type | `Edm.Guid` |
     */
    ResultHistoryAction_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Results_Id` |
     * | Type | `Edm.Guid` |
     */
    Results_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResultHistoryAction` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ResultHistoryAction` |
     */
    ResultHistoryAction?: ResultHistoryAction | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Results` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Result` |
     */
    Results?: Result | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ResultHistoryFacet)` |
     */
    Facets?: Array<ResultHistoryFacet>;
}

export type ResultHistoryId = string | {Id: string};

export interface Result {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderStepNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialTrackingUnitNId` |
     * | Type | `Edm.String` |
     */
    MaterialTrackingUnitNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActivityNId` |
     * | Type | `Edm.String` |
     */
    ActivityNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActivityType` |
     * | Type | `Edm.String` |
     */
    ActivityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsPartial` |
     * | Type | `Edm.Boolean` |
     */
    IsPartial: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResultStrategy_Id` |
     * | Type | `Edm.Guid` |
     */
    ResultStrategy_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResultType_Id` |
     * | Type | `Edm.Guid` |
     */
    ResultType_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResultHistoryList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ResultHistory)` |
     */
    ResultHistoryList?: Array<ResultHistory>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResultStrategy` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ResultStrategy` |
     */
    ResultStrategy?: ResultStrategy | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResultType` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ResultType` |
     */
    ResultType?: ResultType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ResultFacet)` |
     */
    Facets?: Array<ResultFacet>;
}

export type ResultId = string | {Id: string};

export interface ContainerCompatibleMaterial {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaxQuantity` |
     * | Type | `Edm.Decimal` |
     */
    MaxQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Container_Id` |
     * | Type | `Edm.Guid` |
     */
    Container_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Material` |
     * | Type | `Siemens.SimaticIT.U4DM.MasterData.FB_MS_Container.MSModel.Types.ReadingModel.MaterialType_Siemens_SimaticIT_U4DM_MasterData_FB_MS_Container_MSModel_Types` |
     * | Nullable | `false` |
     */
    Material: MaterialType_Siemens_SimaticIT_U4DM_MasterData_FB_MS_Container_MSModel_Types;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Container` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.MaterialTrackingUnitAggregate` |
     */
    Container?: MaterialTrackingUnitAggregate | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ContainerCompatibleMaterialFacet)` |
     */
    Facets?: Array<ContainerCompatibleMaterialFacet>;
}

export type ContainerCompatibleMaterialId = string | {Id: string};

export interface Attachment {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FileAttachment_Id_Id` |
     * | Type | `Edm.Guid` |
     */
    FileAttachment_Id_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IconAttachment_Id_Id` |
     * | Type | `Edm.Guid` |
     */
    IconAttachment_Id_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Failures` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Failure)` |
     */
    Failures?: Array<Failure>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FileAttachment_Id` |
     * | Type | `Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.File` |
     */
    FileAttachment_Id?: File | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IconAttachment_Id` |
     * | Type | `Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.File` |
     */
    IconAttachment_Id?: File | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.AttachmentFacet)` |
     */
    Facets?: Array<AttachmentFacet>;
}

export type AttachmentId = string | {Id: string};

export interface QualityAction {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DueDate` |
     * | Type | `Edm.DateTimeOffset` |
     */
    DueDate: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Type` |
     * | Type | `Siemens.OpcenterEX.FN.MasterData.DEF_MS.MSModel.Types.ReadingModel.QualityActionType` |
     */
    Type: QualityActionType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Failures` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Failure)` |
     */
    Failures?: Array<Failure>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.QualityActionFacet)` |
     */
    Facets?: Array<QualityActionFacet>;
}

export type QualityActionId = string | {Id: string};

export interface FailureReference {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CharacteristicSpecification_Id` |
     * | Type | `Edm.Guid` |
     */
    CharacteristicSpecification_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Failure_Id` |
     * | Type | `Edm.Guid` |
     */
    Failure_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CharacteristicSpecification` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.CharacteristicSpecification` |
     */
    CharacteristicSpecification?: CharacteristicSpecification | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Failure` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Failure` |
     */
    Failure?: Failure | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.FailureReferenceFacet)` |
     */
    Facets?: Array<FailureReferenceFacet>;
}

export type FailureReferenceId = string | {Id: string};

export interface FailureParent {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FailureParentNId` |
     * | Type | `Edm.String` |
     */
    FailureParentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FailureParentRevision` |
     * | Type | `Edm.String` |
     */
    FailureParentRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FailureChild_Id` |
     * | Type | `Edm.Guid` |
     */
    FailureChild_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FailureChild` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Failure` |
     */
    FailureChild?: Failure | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.FailureParentFacet)` |
     */
    Facets?: Array<FailureParentFacet>;
}

export type FailureParentId = string | {Id: string};

export interface FailureChild {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FailureChildNId` |
     * | Type | `Edm.String` |
     */
    FailureChildNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FailureChildRevision` |
     * | Type | `Edm.String` |
     */
    FailureChildRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FailureParent_Id` |
     * | Type | `Edm.Guid` |
     */
    FailureParent_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FailureParent` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Failure` |
     */
    FailureParent?: Failure | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.FailureChildFacet)` |
     */
    Facets?: Array<FailureChildFacet>;
}

export type FailureChildId = string | {Id: string};

export interface Failure {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     */
    Revision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceRevision` |
     * | Type | `Edm.String` |
     */
    SourceRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsCurrent` |
     * | Type | `Edm.Boolean` |
     */
    IsCurrent: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Attachments` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Attachment)` |
     */
    Attachments?: Array<Attachment>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FailureParents` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.FailureParent)` |
     */
    FailureParents?: Array<FailureParent>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FailureChildren` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.FailureChild)` |
     */
    FailureChildren?: Array<FailureChild>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `QualityActions` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.QualityAction)` |
     */
    QualityActions?: Array<QualityAction>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.FailureFacet)` |
     */
    Facets?: Array<FailureFacet>;
}

export type FailureId = string | {Id: string};

export interface ContainerHistory {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActionNId` |
     * | Type | `Edm.String` |
     */
    ActionNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Date` |
     * | Type | `Edm.DateTimeOffset` |
     */
    Date: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OldSourceEquipmentNId` |
     * | Type | `Edm.String` |
     */
    OldSourceEquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OldStatusNId` |
     * | Type | `Edm.String` |
     */
    OldStatusNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OldTargetEquipmentNId` |
     * | Type | `Edm.String` |
     */
    OldTargetEquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceEquipmentNId` |
     * | Type | `Edm.String` |
     */
    SourceEquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StatusNId` |
     * | Type | `Edm.String` |
     */
    StatusNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetEquipmentNId` |
     * | Type | `Edm.String` |
     */
    TargetEquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `User` |
     * | Type | `Edm.String` |
     */
    User: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialTrackinUnitAggregateId` |
     * | Type | `Edm.Guid` |
     */
    MaterialTrackinUnitAggregateId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OldEquipmentNId` |
     * | Type | `Edm.String` |
     */
    OldEquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderStepNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecGroupPhaseNId` |
     * | Type | `Edm.String` |
     */
    ExecGroupPhaseNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContainerNId` |
     * | Type | `Edm.String` |
     */
    ContainerNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialTrackingUnits` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.FB_OP_Container.OPModel.Types.ReadingModel.MTUAggregateContent_Siemens_SimaticIT_U4DM_OperationalData_FB_OP_Container_OPModel_Types` |
     * | Nullable | `false` |
     */
    MaterialTrackingUnits: MTUAggregateContent_Siemens_SimaticIT_U4DM_OperationalData_FB_OP_Container_OPModel_Types;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ContainerHistoryFacet)` |
     */
    Facets?: Array<ContainerHistoryFacet>;
}

export type ContainerHistoryId = string | {Id: string};

export interface ExtObjectType {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExtEventContexts` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ExtEventContext)` |
     */
    ExtEventContexts?: Array<ExtEventContext>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ExtObjectTypeFacet)` |
     */
    Facets?: Array<ExtObjectTypeFacet>;
}

export type ExtObjectTypeId = string | {Id: string};

export interface ExtEventContext {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContextNId` |
     * | Type | `Edm.String` |
     */
    ContextNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `State` |
     * | Type | `Edm.String` |
     */
    State: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EventId` |
     * | Type | `Edm.Guid` |
     */
    EventId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ObjectId` |
     * | Type | `Edm.Guid` |
     */
    ObjectId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExtEventLog_Id` |
     * | Type | `Edm.Guid` |
     */
    ExtEventLog_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExtObjectType_Id` |
     * | Type | `Edm.Guid` |
     */
    ExtObjectType_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExtEventLog` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ExtEventLog` |
     */
    ExtEventLog?: ExtEventLog | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExtObjectType` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ExtObjectType` |
     */
    ExtObjectType?: ExtObjectType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ExtEventContextFacet)` |
     */
    Facets?: Array<ExtEventContextFacet>;
}

export type ExtEventContextId = string | {Id: string};

export interface ExtEventType {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExtEventLogs` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ExtEventLog)` |
     */
    ExtEventLogs?: Array<ExtEventLog>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ExtEventTypeFacet)` |
     */
    Facets?: Array<ExtEventTypeFacet>;
}

export type ExtEventTypeId = string | {Id: string};

export interface ExtEventLog {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SystemNId` |
     * | Type | `Edm.String` |
     */
    SystemNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EventTypeNId` |
     * | Type | `Edm.String` |
     */
    EventTypeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ObjectId` |
     * | Type | `Edm.Guid` |
     */
    ObjectId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ErrorMessage` |
     * | Type | `Edm.String` |
     */
    ErrorMessage: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CompletedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    CompletedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExtEventType_Id` |
     * | Type | `Edm.Guid` |
     */
    ExtEventType_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.StatusType` |
     * | Nullable | `false` |
     */
    Status: StatusType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExtEventLogFailureNotification` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ExtEventLogFailureNotification)` |
     */
    ExtEventLogFailureNotification?: Array<ExtEventLogFailureNotification>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExtEventContexts` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ExtEventContext)` |
     */
    ExtEventContexts?: Array<ExtEventContext>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExtEventType` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ExtEventType` |
     */
    ExtEventType?: ExtEventType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ExtEventLogFacet)` |
     */
    Facets?: Array<ExtEventLogFacet>;
}

export type ExtEventLogId = string | {Id: string};

export interface ContainerTypeDocument {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentId` |
     * | Type | `Edm.Guid` |
     */
    DocumentId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContainerType_Id` |
     * | Type | `Edm.Guid` |
     */
    ContainerType_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Document_Id` |
     * | Type | `Edm.Guid` |
     */
    Document_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContainerType` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ContainerType` |
     */
    ContainerType?: ContainerType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Document` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Document` |
     */
    Document?: Document | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ContainerTypeDocumentFacet)` |
     */
    Facets?: Array<ContainerTypeDocumentFacet>;
}

export type ContainerTypeDocumentId = string | {Id: string};

export interface ContainerTypeCompatibleMaterial {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaxQuantity` |
     * | Type | `Edm.Decimal` |
     */
    MaxQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContainerType_Id` |
     * | Type | `Edm.Guid` |
     */
    ContainerType_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Material` |
     * | Type | `Siemens.SimaticIT.U4DM.MasterData.FB_MS_Container.MSModel.Types.ReadingModel.MaterialType_Siemens_SimaticIT_U4DM_MasterData_FB_MS_Container_MSModel_Types` |
     * | Nullable | `false` |
     */
    Material: MaterialType_Siemens_SimaticIT_U4DM_MasterData_FB_MS_Container_MSModel_Types;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContainerType` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ContainerType` |
     */
    ContainerType?: ContainerType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ContainerTypeCompatibleMaterialFacet)` |
     */
    Facets?: Array<ContainerTypeCompatibleMaterialFacet>;
}

export type ContainerTypeCompatibleMaterialId = string | {Id: string};

export interface ContainerType {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsReusable` |
     * | Type | `Edm.Boolean` |
     */
    IsReusable: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Documents` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ContainerTypeDocument)` |
     */
    Documents?: Array<ContainerTypeDocument>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CompatibleMaterials` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ContainerTypeCompatibleMaterial)` |
     */
    CompatibleMaterials?: Array<ContainerTypeCompatibleMaterial>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ContainerTypeFacet)` |
     */
    Facets?: Array<ContainerTypeFacet>;
}

export type ContainerTypeId = string | {Id: string};

export interface OfflineActionAmend {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserId` |
     * | Type | `Edm.String` |
     */
    UserId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CommandPayload` |
     * | Type | `Edm.Binary` |
     */
    CommandPayload: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Date` |
     * | Type | `Edm.DateTimeOffset` |
     */
    Date: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OfflineAction_Id` |
     * | Type | `Edm.Guid` |
     */
    OfflineAction_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OfflineAction` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.OfflineAction` |
     */
    OfflineAction?: OfflineAction | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.OfflineActionAmendFacet)` |
     */
    Facets?: Array<OfflineActionAmendFacet>;
}

export type OfflineActionAmendId = string | {Id: string};

export interface OfflineAction {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CommandName` |
     * | Type | `Edm.String` |
     */
    CommandName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CommandApp` |
     * | Type | `Edm.String` |
     */
    CommandApp: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CommandPayload` |
     * | Type | `Edm.Binary` |
     */
    CommandPayload: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserId` |
     * | Type | `Edm.String` |
     */
    UserId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CheckInDate` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CheckInDate: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CheckInResponse` |
     * | Type | `Edm.String` |
     */
    CheckInResponse: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Date` |
     * | Type | `Edm.DateTimeOffset` |
     */
    Date: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `InternalId` |
     * | Type | `Edm.Guid` |
     */
    InternalId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OfflineSession_Id` |
     * | Type | `Edm.Guid` |
     */
    OfflineSession_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CheckInStatus` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.StatusType` |
     * | Nullable | `false` |
     */
    CheckInStatus: StatusType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OfflineActionAmendList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.OfflineActionAmend)` |
     */
    OfflineActionAmendList?: Array<OfflineActionAmend>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OfflineSession` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.OfflineSession` |
     */
    OfflineSession?: OfflineSession | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.OfflineActionFacet)` |
     */
    Facets?: Array<OfflineActionFacet>;
}

export type OfflineActionId = string | {Id: string};

export interface OfflineSessionWOOperationAssociation {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OfflineSession_Id` |
     * | Type | `Edm.Guid` |
     */
    OfflineSession_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OfflineSession` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.OfflineSession` |
     */
    OfflineSession?: OfflineSession | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.OfflineSessionWOOperationAssociationFacet)` |
     */
    Facets?: Array<OfflineSessionWOOperationAssociationFacet>;
}

export type OfflineSessionWOOperationAssociationId = string | {Id: string};

export interface OfflineSession {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserId` |
     * | Type | `Edm.String` |
     */
    UserId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DownloadDate` |
     * | Type | `Edm.DateTimeOffset` |
     */
    DownloadDate: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UploadDate` |
     * | Type | `Edm.DateTimeOffset` |
     */
    UploadDate: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CheckInDate` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CheckInDate: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DeviceId` |
     * | Type | `Edm.String` |
     */
    DeviceId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.StatusType` |
     * | Nullable | `false` |
     */
    Status: StatusType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OfflineAction` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.OfflineAction)` |
     */
    OfflineAction?: Array<OfflineAction>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OfflineSessionWOOperationAssociationList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.OfflineSessionWOOperationAssociation)` |
     */
    OfflineSessionWOOperationAssociationList?: Array<OfflineSessionWOOperationAssociation>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.OfflineSessionFacet)` |
     */
    Facets?: Array<OfflineSessionFacet>;
}

export type OfflineSessionId = string | {Id: string};

export interface DM_MaterialTrackingUnitDocumentAssociation {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentCategory` |
     * | Type | `Edm.String` |
     */
    DocumentCategory: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Document_Id` |
     * | Type | `Edm.Guid` |
     */
    Document_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnit_Id` |
     * | Type | `Edm.Guid` |
     */
    DM_MaterialTrackingUnit_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Document` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Document` |
     */
    Document?: Document | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnit` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DM_MaterialTrackingUnit` |
     */
    DM_MaterialTrackingUnit?: DM_MaterialTrackingUnit | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DM_MaterialTrackingUnitDocumentAssociationFacet)` |
     */
    Facets?: Array<DM_MaterialTrackingUnitDocumentAssociationFacet>;
}

export type DM_MaterialTrackingUnitDocumentAssociationId = string | {Id: string};

export interface WorkOrderHumanResource {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CertificationNId` |
     * | Type | `Edm.String` |
     */
    CertificationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NumberOfUsers` |
     * | Type | `Edm.Int32` |
     */
    NumberOfUsers: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStep_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStep_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderOperation` |
     */
    WorkOrderOperation?: WorkOrderOperation | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStep` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderStep` |
     */
    WorkOrderStep?: WorkOrderStep | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderHumanResourceFacet)` |
     */
    Facets?: Array<WorkOrderHumanResourceFacet>;
}

export type WorkOrderHumanResourceId = string | {Id: string};

export interface ActualCoProducedMaterial {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MTUNId` |
     * | Type | `Edm.String` |
     */
    MTUNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MTUCode` |
     * | Type | `Edm.String` |
     */
    MTUCode: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MTUId` |
     * | Type | `Edm.Guid` |
     */
    DM_MTUId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DisassembleWorkOrderOperationNId` |
     * | Type | `Edm.String` |
     */
    DisassembleWorkOrderOperationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DisassembleWorkOrderStepNId` |
     * | Type | `Edm.String` |
     */
    DisassembleWorkOrderStepNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DisassembleMTUCode` |
     * | Type | `Edm.String` |
     */
    DisassembleMTUCode: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DisassembleWorkOrderNId` |
     * | Type | `Edm.String` |
     */
    DisassembleWorkOrderNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DisassembleWorkOrderOperationName` |
     * | Type | `Edm.String` |
     */
    DisassembleWorkOrderOperationName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DisassembleMTUName` |
     * | Type | `Edm.String` |
     */
    DisassembleMTUName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DisassembleWorkOrderStepName` |
     * | Type | `Edm.String` |
     */
    DisassembleWorkOrderStepName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MTUId` |
     * | Type | `Edm.Guid` |
     */
    MTUId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItemCoProducedQty` |
     * | Type | `Edm.Decimal` |
     */
    MaterialItemCoProducedQty: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedMaterialItemActualQty` |
     * | Type | `Edm.Decimal` |
     */
    ProducedMaterialItemActualQty: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStep_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStep_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCoProducedMaterial_Id` |
     * | Type | `Edm.Guid` |
     */
    ToBeCoProducedMaterial_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderOperation` |
     */
    WorkOrderOperation?: WorkOrderOperation | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStep` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderStep` |
     */
    WorkOrderStep?: WorkOrderStep | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCoProducedMaterial` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToBeCoProducedMaterial` |
     */
    ToBeCoProducedMaterial?: ToBeCoProducedMaterial | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ActualCoProducedMaterialFacet)` |
     */
    Facets?: Array<ActualCoProducedMaterialFacet>;
}

export type ActualCoProducedMaterialId = string | {Id: string};

export interface ToBeCoProducedMaterial {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialSpecificationTypeNId` |
     * | Type | `Edm.String` |
     */
    MaterialSpecificationTypeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogicalPosition` |
     * | Type | `Edm.String` |
     */
    LogicalPosition: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OccurrenceId` |
     * | Type | `Edm.String` |
     */
    OccurrenceId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_Material_Id` |
     * | Type | `Edm.Guid` |
     */
    DM_Material_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStep_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStep_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualCoProducedMaterial` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ActualCoProducedMaterial)` |
     */
    ActualCoProducedMaterial?: Array<ActualCoProducedMaterial>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_Material` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DM_Material` |
     */
    DM_Material?: DM_Material | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderOperation` |
     */
    WorkOrderOperation?: WorkOrderOperation | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStep` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderStep` |
     */
    WorkOrderStep?: WorkOrderStep | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToBeCoProducedMaterialFacet)` |
     */
    Facets?: Array<ToBeCoProducedMaterialFacet>;
}

export type ToBeCoProducedMaterialId = string | {Id: string};

export interface CertificationSpecification {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CertificationNId` |
     * | Type | `Edm.String` |
     */
    CertificationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UId` |
     * | Type | `Edm.String` |
     */
    UId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     */
    CorrelationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EffectivityExpression` |
     * | Type | `Edm.String` |
     */
    EffectivityExpression: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NumberOfUsers` |
     * | Type | `Edm.Int32` |
     */
    NumberOfUsers: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Operation_Id` |
     * | Type | `Edm.Guid` |
     */
    Operation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Step_Id` |
     * | Type | `Edm.Guid` |
     */
    Step_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBoP_Id` |
     * | Type | `Edm.Guid` |
     */
    AsPlannedBoP_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlan_Id` |
     * | Type | `Edm.Guid` |
     */
    MasterPlan_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Operation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Operation` |
     */
    Operation?: Operation | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Step` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Step` |
     */
    Step?: Step | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBoP` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.AsPlannedBOP` |
     */
    AsPlannedBoP?: AsPlannedBOP | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlan` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.MasterPlan` |
     */
    MasterPlan?: MasterPlan | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.CertificationSpecificationFacet)` |
     */
    Facets?: Array<CertificationSpecificationFacet>;
}

export type CertificationSpecificationId = string | {Id: string};

export interface UserWorkOrderOperationAssociation {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserId` |
     * | Type | `Edm.String` |
     */
    UserId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderOperation` |
     */
    WorkOrderOperation?: WorkOrderOperation | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.UserWorkOrderOperationAssociationFacet)` |
     */
    Facets?: Array<UserWorkOrderOperationAssociationFacet>;
}

export type UserWorkOrderOperationAssociationId = string | {Id: string};

export interface RuntimePJFSerialNumberAssociation {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFileId_Id` |
     * | Type | `Edm.Guid` |
     */
    PrintJobFileId_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SerialNumber_Id` |
     * | Type | `Edm.Guid` |
     */
    SerialNumber_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFileId` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.PrintJobFile` |
     */
    PrintJobFileId?: PrintJobFile | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SerialNumber` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.MaterialTrackingUnit` |
     */
    SerialNumber?: MaterialTrackingUnit | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.RuntimePJFSerialNumberAssociationFacet)` |
     */
    Facets?: Array<RuntimePJFSerialNumberAssociationFacet>;
}

export type RuntimePJFSerialNumberAssociationId = string | {Id: string};

export interface SetPointItemToolDefinitionATNTypeParameterAssociation {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessOperationUId` |
     * | Type | `Edm.String` |
     */
    ProcessOperationUId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutomationNodeTypeNId` |
     * | Type | `Edm.String` |
     */
    AutomationNodeTypeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutomationNodeTypeParameterNId` |
     * | Type | `Edm.String` |
     */
    AutomationNodeTypeParameterNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Editable` |
     * | Type | `Edm.Boolean` |
     */
    Editable: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetpointItem_Id` |
     * | Type | `Edm.Guid` |
     */
    SetpointItem_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolDefinitionParameter` |
     * | Type | `Siemens.SimaticIT.U4DM.MasterData.FB_MS_AGWInt.MSModel.Types.ReadingModel.ToolDefinitionValueType_Siemens_SimaticIT_U4DM_MasterData_FB_MS_AGWInt_MSModel_Types` |
     * | Nullable | `false` |
     */
    ToolDefinitionParameter: ToolDefinitionValueType_Siemens_SimaticIT_U4DM_MasterData_FB_MS_AGWInt_MSModel_Types;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetpointItem` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.SetPointItem` |
     */
    SetpointItem?: SetPointItem | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.SetPointItemToolDefinitionATNTypeParameterAssociationFacet)` |
     */
    Facets?: Array<SetPointItemToolDefinitionATNTypeParameterAssociationFacet>;
}

export type SetPointItemToolDefinitionATNTypeParameterAssociationId = string | {Id: string};

export interface MachineToDNC {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DNCMachine` |
     * | Type | `Edm.String` |
     */
    DNCMachine: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.MachineToDNCFacet)` |
     */
    Facets?: Array<MachineToDNCFacet>;
}

export type MachineToDNCId = string | {Id: string};

export interface DNCItemMachineMaterialAssociation {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialId_Id` |
     * | Type | `Edm.Guid` |
     */
    DM_MaterialId_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MachineToDNC_Id` |
     * | Type | `Edm.Guid` |
     */
    MachineToDNC_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DNCItem_Id` |
     * | Type | `Edm.Guid` |
     */
    DNCItem_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialId` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DM_Material` |
     */
    DM_MaterialId?: DM_Material | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MachineToDNC` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.MachineToDNC` |
     */
    MachineToDNC?: MachineToDNC | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DNCItem` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DNCItem` |
     */
    DNCItem?: DNCItem | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DNCItemMachineMaterialAssociationFacet)` |
     */
    Facets?: Array<DNCItemMachineMaterialAssociationFacet>;
}

export type DNCItemMachineMaterialAssociationId = string | {Id: string};

export interface DNCItem {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DNCId` |
     * | Type | `Edm.String` |
     */
    DNCId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DNCExternalId` |
     * | Type | `Edm.String` |
     */
    DNCExternalId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Trialcut` |
     * | Type | `Edm.Boolean` |
     */
    Trialcut: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     */
    Status: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CanBePreviewed` |
     * | Type | `Edm.Boolean` |
     */
    CanBePreviewed: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CanBeTransferred` |
     * | Type | `Edm.Boolean` |
     */
    CanBeTransferred: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Version` |
     * | Type | `Edm.String` |
     */
    Version: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Type` |
     * | Type | `Edm.String` |
     */
    Type: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Released` |
     * | Type | `Edm.Boolean` |
     */
    Released: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Parent_Id` |
     * | Type | `Edm.Guid` |
     */
    Parent_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DNCItemMachineMaterialAssociationList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DNCItemMachineMaterialAssociation)` |
     */
    DNCItemMachineMaterialAssociationList?: Array<DNCItemMachineMaterialAssociation>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Parent` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DNCItem` |
     */
    Parent?: DNCItem | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Children` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DNCItem)` |
     */
    Children?: Array<DNCItem>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DNCItemFacet)` |
     */
    Facets?: Array<DNCItemFacet>;
}

export type DNCItemId = string | {Id: string};

export interface AutomationNodeTypeParameter {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterValue` |
     * | Type | `Edm.String` |
     */
    ParameterValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MinValue` |
     * | Type | `Edm.String` |
     */
    MinValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaxValue` |
     * | Type | `Edm.String` |
     */
    MaxValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaxLength` |
     * | Type | `Edm.Int32` |
     */
    MaxLength: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterType` |
     * | Type | `Siemens.SimaticIT.MasterData.ATN_MS.MSModel.Types.ReadingModel.ParameterType` |
     */
    ParameterType: ParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterValues` |
     * | Type | `Edm.String` |
     */
    ParameterValues: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DataType` |
     * | Type | `Siemens.SimaticIT.MasterData.ATN_MS.MSModel.Types.ReadingModel.DataType` |
     */
    DataType: DataType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsStatic` |
     * | Type | `Edm.Boolean` |
     */
    IsStatic: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsPersistent` |
     * | Type | `Edm.Boolean` |
     */
    IsPersistent: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsInternal` |
     * | Type | `Edm.Boolean` |
     */
    IsInternal: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutomationNodeType_Id` |
     * | Type | `Edm.Guid` |
     */
    AutomationNodeType_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutomationNodeType` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.AutomationNodeType` |
     */
    AutomationNodeType?: AutomationNodeType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutomationNodeInstanceParameters` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.AutomationNodeInstanceParameter)` |
     */
    AutomationNodeInstanceParameters?: Array<AutomationNodeInstanceParameter>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.AutomationNodeTypeParameterFacet)` |
     */
    Facets?: Array<AutomationNodeTypeParameterFacet>;
}

export type AutomationNodeTypeParameterId = string | {Id: string};

export interface AutomationNodeType {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     */
    Revision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceRevision` |
     * | Type | `Edm.String` |
     */
    SourceRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsCurrent` |
     * | Type | `Edm.Boolean` |
     */
    IsCurrent: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActivationStatus` |
     * | Type | `Siemens.SimaticIT.MasterData.ATN_MS.MSModel.Types.ReadingModel.ActivationStatus_Siemens_SimaticIT_MasterData_ATN_MS_MSModel_Types` |
     * | Nullable | `false` |
     */
    ActivationStatus: ActivationStatus_Siemens_SimaticIT_MasterData_ATN_MS_MSModel_Types;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Parameters` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.AutomationNodeTypeParameter)` |
     */
    Parameters?: Array<AutomationNodeTypeParameter>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutomationNodeInstances` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.AutomationNodeInstance)` |
     */
    AutomationNodeInstances?: Array<AutomationNodeInstance>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.AutomationNodeTypeFacet)` |
     */
    Facets?: Array<AutomationNodeTypeFacet>;
}

export type AutomationNodeTypeId = string | {Id: string};

export interface AutomationNodeInstanceParameter {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterValue` |
     * | Type | `Edm.String` |
     */
    ParameterValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterValues` |
     * | Type | `Edm.String` |
     */
    ParameterValues: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutomationNodeInstance_Id` |
     * | Type | `Edm.Guid` |
     */
    AutomationNodeInstance_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutomationNodeTypeParameter_Id` |
     * | Type | `Edm.Guid` |
     */
    AutomationNodeTypeParameter_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TagAspect` |
     * | Type | `Siemens.SimaticIT.MasterData.ATN_MS.MSModel.Types.ReadingModel.TagAspectType_Siemens_SimaticIT_MasterData_ATN_MS_MSModel_Types` |
     * | Nullable | `false` |
     */
    TagAspect: TagAspectType_Siemens_SimaticIT_MasterData_ATN_MS_MSModel_Types;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutomationNodeInstance` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.AutomationNodeInstance` |
     */
    AutomationNodeInstance?: AutomationNodeInstance | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutomationNodeTypeParameter` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.AutomationNodeTypeParameter` |
     */
    AutomationNodeTypeParameter?: AutomationNodeTypeParameter | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.AutomationNodeInstanceParameterFacet)` |
     */
    Facets?: Array<AutomationNodeInstanceParameterFacet>;
}

export type AutomationNodeInstanceParameterId = string | {Id: string};

export interface AutomationNodeInstance {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     */
    Revision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceRevision` |
     * | Type | `Edm.String` |
     */
    SourceRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsCurrent` |
     * | Type | `Edm.Boolean` |
     */
    IsCurrent: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChannelNId` |
     * | Type | `Edm.String` |
     */
    ChannelNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutomationNodeType_Id` |
     * | Type | `Edm.Guid` |
     */
    AutomationNodeType_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActivationStatus` |
     * | Type | `Siemens.SimaticIT.MasterData.ATN_MS.MSModel.Types.ReadingModel.ActivationStatus_Siemens_SimaticIT_MasterData_ATN_MS_MSModel_Types` |
     * | Nullable | `false` |
     */
    ActivationStatus: ActivationStatus_Siemens_SimaticIT_MasterData_ATN_MS_MSModel_Types;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Parameters` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.AutomationNodeInstanceParameter)` |
     */
    Parameters?: Array<AutomationNodeInstanceParameter>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutomationNodeType` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.AutomationNodeType` |
     */
    AutomationNodeType?: AutomationNodeType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.AutomationNodeInstanceFacet)` |
     */
    Facets?: Array<AutomationNodeInstanceFacet>;
}

export type AutomationNodeInstanceId = string | {Id: string};

export interface SetPointEquipmentTypeAssociation {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeNId` |
     * | Type | `Edm.String` |
     */
    EquipmentTypeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsDefault` |
     * | Type | `Edm.Boolean` |
     */
    IsDefault: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPoint_Id` |
     * | Type | `Edm.Guid` |
     */
    SetPoint_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPoint` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.SetPoint` |
     */
    SetPoint?: SetPoint | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.SetPointEquipmentTypeAssociationFacet)` |
     */
    Facets?: Array<SetPointEquipmentTypeAssociationFacet>;
}

export type SetPointEquipmentTypeAssociationId = string | {Id: string};

export interface SetPointToolAssociation {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolNId` |
     * | Type | `Edm.String` |
     */
    ToolNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsDefault` |
     * | Type | `Edm.Boolean` |
     */
    IsDefault: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPoint_Id` |
     * | Type | `Edm.Guid` |
     */
    SetPoint_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPoint` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.SetPoint` |
     */
    SetPoint?: SetPoint | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.SetPointToolAssociationFacet)` |
     */
    Facets?: Array<SetPointToolAssociationFacet>;
}

export type SetPointToolAssociationId = string | {Id: string};

export interface SetPointToolDefinitionAssociation {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsDefault` |
     * | Type | `Edm.Boolean` |
     */
    IsDefault: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPoint_Id` |
     * | Type | `Edm.Guid` |
     */
    SetPoint_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolDefinitionParameter` |
     * | Type | `Siemens.SimaticIT.U4DM.MasterData.FB_MS_AGWInt.MSModel.Types.ReadingModel.ToolDefinitionValueType_Siemens_SimaticIT_U4DM_MasterData_FB_MS_AGWInt_MSModel_Types` |
     * | Nullable | `false` |
     */
    ToolDefinitionParameter: ToolDefinitionValueType_Siemens_SimaticIT_U4DM_MasterData_FB_MS_AGWInt_MSModel_Types;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPoint` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.SetPoint` |
     */
    SetPoint?: SetPoint | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.SetPointToolDefinitionAssociationFacet)` |
     */
    Facets?: Array<SetPointToolDefinitionAssociationFacet>;
}

export type SetPointToolDefinitionAssociationId = string | {Id: string};

export interface ToolAutomationNodeInstanceAssociation {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolNId` |
     * | Type | `Edm.String` |
     */
    ToolNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutomationNodeInstanceNId` |
     * | Type | `Edm.String` |
     */
    AutomationNodeInstanceNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToolAutomationNodeInstanceAssociationFacet)` |
     */
    Facets?: Array<ToolAutomationNodeInstanceAssociationFacet>;
}

export type ToolAutomationNodeInstanceAssociationId = string | {Id: string};

export interface ToolDefinitionAutomationNodeTypeAssociation {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutomationNodeTypeNId` |
     * | Type | `Edm.String` |
     */
    AutomationNodeTypeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolDefinitionParameter` |
     * | Type | `Siemens.SimaticIT.U4DM.MasterData.FB_MS_AGWInt.MSModel.Types.ReadingModel.ToolDefinitionValueType_Siemens_SimaticIT_U4DM_MasterData_FB_MS_AGWInt_MSModel_Types` |
     * | Nullable | `false` |
     */
    ToolDefinitionParameter: ToolDefinitionValueType_Siemens_SimaticIT_U4DM_MasterData_FB_MS_AGWInt_MSModel_Types;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToolDefinitionAutomationNodeTypeAssociationFacet)` |
     */
    Facets?: Array<ToolDefinitionAutomationNodeTypeAssociationFacet>;
}

export type ToolDefinitionAutomationNodeTypeAssociationId = string | {Id: string};

export interface SetPointItemDefaultValue {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointItem_Id` |
     * | Type | `Edm.Guid` |
     */
    SetPointItem_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointItem` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.SetPointItem` |
     */
    SetPointItem?: SetPointItem | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.SetPointItemDefaultValueFacet)` |
     */
    Facets?: Array<SetPointItemDefaultValueFacet>;
}

export type SetPointItemDefaultValueId = string | {Id: string};

export interface SetPointItemATNInstanceAssociation {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Equipment` |
     * | Type | `Edm.String` |
     */
    Equipment: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutomationInstanceNId` |
     * | Type | `Edm.String` |
     */
    AutomationInstanceNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutomationInstanceParameterNId` |
     * | Type | `Edm.String` |
     */
    AutomationInstanceParameterNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointItemValue` |
     * | Type | `Edm.String` |
     */
    SetPointItemValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointItemATNInstanceAssociationDefaultValue` |
     * | Type | `Edm.String` |
     */
    SetPointItemATNInstanceAssociationDefaultValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessOperation` |
     * | Type | `Edm.Guid` |
     */
    ProcessOperation: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointItem_Id` |
     * | Type | `Edm.Guid` |
     */
    SetPointItem_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointItem` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.SetPointItem` |
     */
    SetPointItem?: SetPointItem | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.SetPointItemATNInstanceAssociationFacet)` |
     */
    Facets?: Array<SetPointItemATNInstanceAssociationFacet>;
}

export type SetPointItemATNInstanceAssociationId = string | {Id: string};

export interface SetPointItem {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DataType` |
     * | Type | `Edm.String` |
     */
    DataType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Editable` |
     * | Type | `Edm.Boolean` |
     */
    Editable: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPoint_Id` |
     * | Type | `Edm.Guid` |
     */
    SetPoint_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointItemDefaultValues` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.SetPointItemDefaultValue)` |
     */
    SetPointItemDefaultValues?: Array<SetPointItemDefaultValue>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPoint` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.SetPoint` |
     */
    SetPoint?: SetPoint | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.SetPointItemFacet)` |
     */
    Facets?: Array<SetPointItemFacet>;
}

export type SetPointItemId = string | {Id: string};

export interface SetPointEquipmentAssociation {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsDefault` |
     * | Type | `Edm.Boolean` |
     */
    IsDefault: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPoint_Id` |
     * | Type | `Edm.Guid` |
     */
    SetPoint_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPoint` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.SetPoint` |
     */
    SetPoint?: SetPoint | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.SetPointEquipmentAssociationFacet)` |
     */
    Facets?: Array<SetPointEquipmentAssociationFacet>;
}

export type SetPointEquipmentAssociationId = string | {Id: string};

export interface SetPoint {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.StatusType` |
     * | Nullable | `false` |
     */
    Status: StatusType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointEquipmentTypeAssociations` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.SetPointEquipmentTypeAssociation)` |
     */
    SetPointEquipmentTypeAssociations?: Array<SetPointEquipmentTypeAssociation>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointToTool` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.SetPointToolAssociation)` |
     */
    SetPointToTool?: Array<SetPointToolAssociation>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointToolDefinitionAssociations` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.SetPointToolDefinitionAssociation)` |
     */
    SetPointToolDefinitionAssociations?: Array<SetPointToolDefinitionAssociation>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointItems` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.SetPointItem)` |
     */
    SetPointItems?: Array<SetPointItem>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointEquipmentAssociations` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.SetPointEquipmentAssociation)` |
     */
    SetPointEquipmentAssociations?: Array<SetPointEquipmentAssociation>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.SetPointFacet)` |
     */
    Facets?: Array<SetPointFacet>;
}

export type SetPointId = string | {Id: string};

export interface ToBeUsedMachinePJF {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFileExternalId` |
     * | Type | `Edm.String` |
     */
    PrintJobFileExternalId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EG_PhaseId` |
     * | Type | `Edm.Guid` |
     */
    EG_PhaseId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFileName` |
     * | Type | `Edm.String` |
     */
    PrintJobFileName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFileSource` |
     * | Type | `Edm.String` |
     */
    PrintJobFileSource: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsSourcePJF` |
     * | Type | `Edm.Boolean` |
     */
    IsSourcePJF: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFile_Id` |
     * | Type | `Edm.Guid` |
     */
    PrintJobFile_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedMachine_Id` |
     * | Type | `Edm.Guid` |
     */
    ToBeUsedMachine_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFile` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.PrintJobFile` |
     */
    PrintJobFile?: PrintJobFile | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedMachine` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToBeUsedMachine` |
     */
    ToBeUsedMachine?: ToBeUsedMachine | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToBeUsedMachinePJFFacet)` |
     */
    Facets?: Array<ToBeUsedMachinePJFFacet>;
}

export type ToBeUsedMachinePJFId = string | {Id: string};

export interface ActualUsedMachinePJF {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFileExternalId` |
     * | Type | `Edm.String` |
     */
    PrintJobFileExternalId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EG_PhaseId` |
     * | Type | `Edm.Guid` |
     */
    EG_PhaseId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFileName` |
     * | Type | `Edm.String` |
     */
    PrintJobFileName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFileSource` |
     * | Type | `Edm.String` |
     */
    PrintJobFileSource: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsSourcePJF` |
     * | Type | `Edm.Boolean` |
     */
    IsSourcePJF: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFile_Id` |
     * | Type | `Edm.Guid` |
     */
    PrintJobFile_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualUsedMachines_Id` |
     * | Type | `Edm.Guid` |
     */
    ActualUsedMachines_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFile` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.PrintJobFile` |
     */
    PrintJobFile?: PrintJobFile | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualUsedMachines` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ActualUsedMachine` |
     */
    ActualUsedMachines?: ActualUsedMachine | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ActualUsedMachinePJFFacet)` |
     */
    Facets?: Array<ActualUsedMachinePJFFacet>;
}

export type ActualUsedMachinePJFId = string | {Id: string};

export interface DSParameter {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DataType` |
     * | Type | `Edm.String` |
     */
    DataType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContextEntity` |
     * | Type | `Edm.String` |
     */
    ContextEntity: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DSParameterFacet)` |
     */
    Facets?: Array<DSParameterFacet>;
}

export type DSParameterId = string | {Id: string};

export interface DiscreteAutomationNodeDataTypeMapping {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutomationType` |
     * | Type | `Edm.String` |
     */
    AutomationType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DataType` |
     * | Type | `Edm.String` |
     */
    DataType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DiscreteAutomationNodeDataTypeMappingFacet)` |
     */
    Facets?: Array<DiscreteAutomationNodeDataTypeMappingFacet>;
}

export type DiscreteAutomationNodeDataTypeMappingId = string | {Id: string};

export interface ProcessToOpLinkDependencyNavigation {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AlternativeGroup` |
     * | Type | `Edm.String` |
     */
    AlternativeGroup: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RelativePath` |
     * | Type | `Edm.String` |
     */
    RelativePath: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FullPath` |
     * | Type | `Edm.String` |
     */
    FullPath: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentNavigation` |
     * | Type | `Edm.Guid` |
     */
    ParentNavigation: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsPreferred` |
     * | Type | `Edm.Boolean` |
     */
    IsPreferred: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationDependency_Id` |
     * | Type | `Edm.Guid` |
     */
    OperationDependency_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationDependency` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.OperationDependency` |
     */
    OperationDependency?: OperationDependency | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ProcessToOpLinkDependencyNavigationFacet)` |
     */
    Facets?: Array<ProcessToOpLinkDependencyNavigationFacet>;
}

export type ProcessToOpLinkDependencyNavigationId = string | {Id: string};

export interface PrintJobFileEquipmentTypeAssociation {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeNId` |
     * | Type | `Edm.String` |
     */
    EquipmentTypeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFile_Id` |
     * | Type | `Edm.Guid` |
     */
    PrintJobFile_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFile` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.PrintJobFile` |
     */
    PrintJobFile?: PrintJobFile | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.PrintJobFileEquipmentTypeAssociationFacet)` |
     */
    Facets?: Array<PrintJobFileEquipmentTypeAssociationFacet>;
}

export type PrintJobFileEquipmentTypeAssociationId = string | {Id: string};

export interface PrintJobFileEquipmentAssociation {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFile_Id` |
     * | Type | `Edm.Guid` |
     */
    PrintJobFile_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFile` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.PrintJobFile` |
     */
    PrintJobFile?: PrintJobFile | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.PrintJobFileEquipmentAssociationFacet)` |
     */
    Facets?: Array<PrintJobFileEquipmentAssociationFacet>;
}

export type PrintJobFileEquipmentAssociationId = string | {Id: string};

export interface PrintJobFileDM_MaterialAssociation {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialNId` |
     * | Type | `Edm.String` |
     */
    MaterialNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialRevision` |
     * | Type | `Edm.String` |
     */
    MaterialRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialId` |
     * | Type | `Edm.Guid` |
     */
    DM_MaterialId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFile_Id` |
     * | Type | `Edm.Guid` |
     */
    PrintJobFile_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.QuantityType` |
     * | Nullable | `false` |
     */
    Quantity: QuantityType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFile` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.PrintJobFile` |
     */
    PrintJobFile?: PrintJobFile | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.PrintJobFileDM_MaterialAssociationFacet)` |
     */
    Facets?: Array<PrintJobFileDM_MaterialAssociationFacet>;
}

export type PrintJobFileDM_MaterialAssociationId = string | {Id: string};

export interface AMPowderBatchGenealogy {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Date` |
     * | Type | `Edm.DateTimeOffset` |
     */
    Date: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnit` |
     * | Type | `Edm.Guid` |
     */
    DM_MaterialTrackingUnit: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MixedQuantity` |
     * | Type | `Edm.String` |
     */
    MixedQuantity: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RecycleCount` |
     * | Type | `Edm.String` |
     */
    RecycleCount: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     */
    Status: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserId` |
     * | Type | `Edm.String` |
     */
    UserId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStep` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStep: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Code` |
     * | Type | `Edm.String` |
     */
    Code: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CodeType` |
     * | Type | `Siemens.SimaticIT.OperationalData.MAT_OP.OPModel.Types.ReadingModel.MTUCodeType` |
     */
    CodeType: MTUCodeType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceCode` |
     * | Type | `Edm.String` |
     */
    SourceCode: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetCode` |
     * | Type | `Edm.String` |
     */
    TargetCode: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OldQuantity` |
     * | Type | `Edm.Decimal` |
     */
    OldQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrder` |
     * | Type | `Edm.Guid` |
     */
    WorkOrder: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperation: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Action_Id` |
     * | Type | `Edm.Guid` |
     */
    Action_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetDM_MaterialTrackingUnit_Id` |
     * | Type | `Edm.Guid` |
     */
    TargetDM_MaterialTrackingUnit_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceDM_MaterialTrackingUnit_Id` |
     * | Type | `Edm.Guid` |
     */
    SourceDM_MaterialTrackingUnit_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Action` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DM_MaterialTrackingUnitHistoryAction` |
     */
    Action?: DM_MaterialTrackingUnitHistoryAction | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetDM_MaterialTrackingUnit` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DM_MaterialTrackingUnit` |
     */
    TargetDM_MaterialTrackingUnit?: DM_MaterialTrackingUnit | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceDM_MaterialTrackingUnit` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DM_MaterialTrackingUnit` |
     */
    SourceDM_MaterialTrackingUnit?: DM_MaterialTrackingUnit | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.AMPowderBatchGenealogyFacet)` |
     */
    Facets?: Array<AMPowderBatchGenealogyFacet>;
}

export type AMPowderBatchGenealogyId = string | {Id: string};

export interface VisualDetectedFailure {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Count` |
     * | Type | `Edm.Int32` |
     */
    Count: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FailureNId` |
     * | Type | `Edm.String` |
     */
    FailureNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Timestamp` |
     * | Type | `Edm.DateTimeOffset` |
     */
    Timestamp: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `User` |
     * | Type | `Edm.String` |
     */
    User: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MTUNId` |
     * | Type | `Edm.String` |
     */
    MTUNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Coords` |
     * | Type | `Edm.String` |
     */
    Coords: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsNoFailure` |
     * | Type | `Edm.Boolean` |
     */
    IsNoFailure: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CharacteristicType` |
     * | Type | `Siemens.SimaticIT.MasterData.CHR_MS.MSModel.Types.ReadingModel.CharacteristicType` |
     */
    CharacteristicType: CharacteristicType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `InspectionSample_Id` |
     * | Type | `Edm.Guid` |
     */
    InspectionSample_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `InspectionSample` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.InspectionSample` |
     */
    InspectionSample?: InspectionSample | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.VisualDetectedFailureFacet)` |
     */
    Facets?: Array<VisualDetectedFailureFacet>;
}

export type VisualDetectedFailureId = string | {Id: string};

export interface InspectionValue {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MeasuredAttributeValue` |
     * | Type | `Edm.Boolean` |
     */
    MeasuredAttributeValue: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MeasuredVariableValue` |
     * | Type | `Edm.Decimal` |
     */
    MeasuredVariableValue: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MTUNId` |
     * | Type | `Edm.String` |
     */
    MTUNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Timestamp` |
     * | Type | `Edm.DateTimeOffset` |
     */
    Timestamp: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `User` |
     * | Type | `Edm.String` |
     */
    User: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FailureNId` |
     * | Type | `Edm.String` |
     */
    FailureNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FailureRevision` |
     * | Type | `Edm.String` |
     */
    FailureRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CharacteristicType` |
     * | Type | `Siemens.SimaticIT.MasterData.CHR_MS.MSModel.Types.ReadingModel.CharacteristicType` |
     */
    CharacteristicType: CharacteristicType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `InspectionSample_Id` |
     * | Type | `Edm.Guid` |
     */
    InspectionSample_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `InspectionSample` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.InspectionSample` |
     */
    InspectionSample?: InspectionSample | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.InspectionValueFacet)` |
     */
    Facets?: Array<InspectionValueFacet>;
}

export type InspectionValueId = string | {Id: string};

export interface InspectionSample {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AnyViolation` |
     * | Type | `Edm.Boolean` |
     */
    AnyViolation: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Timestamp` |
     * | Type | `Edm.DateTimeOffset` |
     */
    Timestamp: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `User` |
     * | Type | `Edm.String` |
     */
    User: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ScenarioInstanceId` |
     * | Type | `Edm.Guid` |
     */
    ScenarioInstanceId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsSignaturePending` |
     * | Type | `Edm.Boolean` |
     */
    IsSignaturePending: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SketchRows` |
     * | Type | `Edm.Int32` |
     */
    SketchRows: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SketchColumns` |
     * | Type | `Edm.Int32` |
     */
    SketchColumns: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SketchMimeType` |
     * | Type | `Edm.String` |
     */
    SketchMimeType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsConfirmed` |
     * | Type | `Edm.Boolean` |
     */
    IsConfirmed: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sketch_Id_Id` |
     * | Type | `Edm.Guid` |
     */
    Sketch_Id_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterSketch_Id_Id` |
     * | Type | `Edm.Guid` |
     */
    MasterSketch_Id_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `InspectionAcquisitionContext_Id` |
     * | Type | `Edm.Guid` |
     */
    InspectionAcquisitionContext_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `VisualDetectedFailures` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.VisualDetectedFailure)` |
     */
    VisualDetectedFailures?: Array<VisualDetectedFailure>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `InspectionValues` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.InspectionValue)` |
     */
    InspectionValues?: Array<InspectionValue>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `InspectionAcquisitionContext` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.InspectionAcquisitionContext` |
     */
    InspectionAcquisitionContext?: InspectionAcquisitionContext | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sketch_Id` |
     * | Type | `Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.File` |
     */
    Sketch_Id?: File | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterSketch_Id` |
     * | Type | `Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.File` |
     */
    MasterSketch_Id?: File | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.InspectionSampleFacet)` |
     */
    Facets?: Array<InspectionSampleFacet>;
}

export type InspectionSampleId = string | {Id: string};

export interface InspectionAcquisitionContext {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialNId` |
     * | Type | `Edm.String` |
     */
    MaterialNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialRevision` |
     * | Type | `Edm.String` |
     */
    MaterialRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CharacteristicRepresentationNId` |
     * | Type | `Edm.String` |
     */
    CharacteristicRepresentationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RuntimeCharacteristicRepresentationNId` |
     * | Type | `Edm.String` |
     */
    RuntimeCharacteristicRepresentationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `InspectionSamples` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.InspectionSample)` |
     */
    InspectionSamples?: Array<InspectionSample>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.InspectionAcquisitionContextFacet)` |
     */
    Facets?: Array<InspectionAcquisitionContextFacet>;
}

export type InspectionAcquisitionContextId = string | {Id: string};

export interface WorkOrderStepSkill {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Level` |
     * | Type | `Edm.Int32` |
     */
    Level: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SkillId_Id` |
     * | Type | `Edm.Guid` |
     */
    SkillId_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStep_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStep_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SkillId` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Skill_BOP` |
     */
    SkillId?: Skill_BOP | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStep` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderStep` |
     */
    WorkOrderStep?: WorkOrderStep | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderStepSkillFacet)` |
     */
    Facets?: Array<WorkOrderStepSkillFacet>;
}

export type WorkOrderStepSkillId = string | {Id: string};

export interface WOOpDependencyNavigationMTUAssociation {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialTrackingUnit` |
     * | Type | `Edm.Guid` |
     */
    MaterialTrackingUnit: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MTUStatus` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ReadingModel.AlternativeOperationMTUStatus` |
     */
    MTUStatus: AlternativeOperationMTUStatus | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOpDependencyNavigation_Id` |
     * | Type | `Edm.Guid` |
     */
    WOOpDependencyNavigation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOpDependencyNavigation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WOOpDependencyNavigation` |
     */
    WOOpDependencyNavigation?: WOOpDependencyNavigation | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WOOpDependencyNavigationMTUAssociationFacet)` |
     */
    Facets?: Array<WOOpDependencyNavigationMTUAssociationFacet>;
}

export type WOOpDependencyNavigationMTUAssociationId = string | {Id: string};

export interface WOOpDependencyNavigation {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AlternativeGroup` |
     * | Type | `Edm.String` |
     */
    AlternativeGroup: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RelativePath` |
     * | Type | `Edm.String` |
     */
    RelativePath: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FullPath` |
     * | Type | `Edm.String` |
     */
    FullPath: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentNavigation` |
     * | Type | `Edm.Guid` |
     */
    ParentNavigation: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsPreferred` |
     * | Type | `Edm.Boolean` |
     */
    IsPreferred: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOOperationDependency_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOOperationDependency_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOpDependencyNavigationMTUAssociation` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WOOpDependencyNavigationMTUAssociation)` |
     */
    WOOpDependencyNavigationMTUAssociation?: Array<WOOpDependencyNavigationMTUAssociation>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOOperationDependency` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOOperationDependency` |
     */
    WorkOOperationDependency?: WorkOOperationDependency | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WOOpDependencyNavigationFacet)` |
     */
    Facets?: Array<WOOpDependencyNavigationFacet>;
}

export type WOOpDependencyNavigationId = string | {Id: string};

export interface StepSkill {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Level` |
     * | Type | `Edm.Int32` |
     */
    Level: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Step_Id` |
     * | Type | `Edm.Guid` |
     */
    Step_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Skill_Id` |
     * | Type | `Edm.Guid` |
     */
    Skill_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Step` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Step` |
     */
    Step?: Step | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Skill` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Skill_BOP` |
     */
    Skill?: Skill_BOP | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.StepSkillFacet)` |
     */
    Facets?: Array<StepSkillFacet>;
}

export type StepSkillId = string | {Id: string};

export interface ItlkCheckOperationToStepLinkAssociationParameterValue {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterValue` |
     * | Type | `Edm.String` |
     */
    ParameterValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckParameter_Id` |
     * | Type | `Edm.Guid` |
     */
    ItlkCheckParameter_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckOperationToStepLinkAssociation_Id` |
     * | Type | `Edm.Guid` |
     */
    ItlkCheckOperationToStepLinkAssociation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckParameter` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ItlkCheckParameter` |
     */
    ItlkCheckParameter?: ItlkCheckParameter | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckOperationToStepLinkAssociation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ItlkCheckOperationToStepLinkAssociation` |
     */
    ItlkCheckOperationToStepLinkAssociation?: ItlkCheckOperationToStepLinkAssociation | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ItlkCheckOperationToStepLinkAssociationParameterValueFacet)` |
     */
    Facets?: Array<ItlkCheckOperationToStepLinkAssociationParameterValueFacet>;
}

export type ItlkCheckOperationToStepLinkAssociationParameterValueId = string | {Id: string};

export interface ItlkCheckOperationToStepLinkAssociation {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsInbound` |
     * | Type | `Edm.Boolean` |
     */
    IsInbound: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsOutbound` |
     * | Type | `Edm.Boolean` |
     */
    IsOutbound: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationToStepLink_Id` |
     * | Type | `Edm.Guid` |
     */
    OperationToStepLink_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheck_Id` |
     * | Type | `Edm.Guid` |
     */
    ItlkCheck_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckOperationToStepLinkAssociationParameterValues` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ItlkCheckOperationToStepLinkAssociationParameterValue)` |
     */
    ItlkCheckOperationToStepLinkAssociationParameterValues?: Array<ItlkCheckOperationToStepLinkAssociationParameterValue>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationToStepLink` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.OperationToStepLink` |
     */
    OperationToStepLink?: OperationToStepLink | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheck` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ItlkCheck` |
     */
    ItlkCheck?: ItlkCheck | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ItlkCheckOperationToStepLinkAssociationFacet)` |
     */
    Facets?: Array<ItlkCheckOperationToStepLinkAssociationFacet>;
}

export type ItlkCheckOperationToStepLinkAssociationId = string | {Id: string};

export interface WorkInstructionDefinitionToStepAssociation {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionAssociationType_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkInstructionAssociationType_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionDefinition_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkInstructionDefinition_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Step_Id` |
     * | Type | `Edm.Guid` |
     */
    Step_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionAssociationType` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkInstructionAssociationType` |
     */
    WorkInstructionAssociationType?: WorkInstructionAssociationType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionDefinition` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkInstructionDefinition` |
     */
    WorkInstructionDefinition?: WorkInstructionDefinition | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Step` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Step` |
     */
    Step?: Step | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkInstructionDefinitionToStepAssociationFacet)` |
     */
    Facets?: Array<WorkInstructionDefinitionToStepAssociationFacet>;
}

export type WorkInstructionDefinitionToStepAssociationId = string | {Id: string};

export interface WIDefinitionToWOStepAssociation {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionDefinition_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkInstructionDefinition_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionAssociationType_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkInstructionAssociationType_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStep_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStep_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionDefinition` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkInstructionDefinition` |
     */
    WorkInstructionDefinition?: WorkInstructionDefinition | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionAssociationType` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkInstructionAssociationType` |
     */
    WorkInstructionAssociationType?: WorkInstructionAssociationType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStep` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderStep` |
     */
    WorkOrderStep?: WorkOrderStep | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WIDefinitionToWOStepAssociationFacet)` |
     */
    Facets?: Array<WIDefinitionToWOStepAssociationFacet>;
}

export type WIDefinitionToWOStepAssociationId = string | {Id: string};

export interface WorkInstructionToWorkOrderStepAssociation {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStep_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStep_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstruction_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkInstruction_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnit_Id` |
     * | Type | `Edm.Guid` |
     */
    DM_MaterialTrackingUnit_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStep` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderStep` |
     */
    WorkOrderStep?: WorkOrderStep | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstruction` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkInstruction` |
     */
    WorkInstruction?: WorkInstruction | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnit` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DM_MaterialTrackingUnit` |
     */
    DM_MaterialTrackingUnit?: DM_MaterialTrackingUnit | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkInstructionToWorkOrderStepAssociationFacet)` |
     */
    Facets?: Array<WorkInstructionToWorkOrderStepAssociationFacet>;
}

export type WorkInstructionToWorkOrderStepAssociationId = string | {Id: string};

export interface RuntimeCharacteristicRepresentationContainer {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RuntimeChrRepresentations` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.RuntimeCharacteristicRepresentation)` |
     */
    RuntimeChrRepresentations?: Array<RuntimeCharacteristicRepresentation>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.RuntimeCharacteristicRepresentationContainerFacet)` |
     */
    Facets?: Array<RuntimeCharacteristicRepresentationContainerFacet>;
}

export type RuntimeCharacteristicRepresentationContainerId = string | {Id: string};

export interface RuntimeCharacteristicRepresentation {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChrReprNId` |
     * | Type | `Edm.String` |
     */
    ChrReprNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChrSpecNId` |
     * | Type | `Edm.String` |
     */
    ChrSpecNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChrSpecRevision` |
     * | Type | `Edm.String` |
     */
    ChrSpecRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CanBeSkipped` |
     * | Type | `Edm.Boolean` |
     */
    CanBeSkipped: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChrSpecUId` |
     * | Type | `Edm.String` |
     */
    ChrSpecUId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Label` |
     * | Type | `Edm.String` |
     */
    Label: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChrReprRevision` |
     * | Type | `Edm.String` |
     */
    ChrReprRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChrReprFrequencyNId` |
     * | Type | `Edm.String` |
     */
    ChrReprFrequencyNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReferencedOperation` |
     * | Type | `Edm.String` |
     */
    ReferencedOperation: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AcquisitionBehaviour` |
     * | Type | `Siemens.SimaticIT.OperationalData.CHR_OP.OPModel.Types.ReadingModel.AcquisitionBehaviour` |
     */
    AcquisitionBehaviour: AcquisitionBehaviour | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChrReprSampleSize` |
     * | Type | `Edm.Int32` |
     */
    ChrReprSampleSize: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MandatoryExecutionsCompleted` |
     * | Type | `Edm.Boolean` |
     */
    MandatoryExecutionsCompleted: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RuntimeChrReprContainer_Id` |
     * | Type | `Edm.Guid` |
     */
    RuntimeChrReprContainer_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ScenarioConfiguration` |
     * | Type | `Siemens.SimaticIT.MasterData.ES_MS.MSModel.Types.ReadingModel.ScenarioConfigurationValueType_Siemens_SimaticIT_MasterData_ES_MS_MSModel_Types` |
     * | Nullable | `false` |
     */
    ScenarioConfiguration: ScenarioConfigurationValueType_Siemens_SimaticIT_MasterData_ES_MS_MSModel_Types;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RuntimeChrReprContainer` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.RuntimeCharacteristicRepresentationContainer` |
     */
    RuntimeChrReprContainer?: RuntimeCharacteristicRepresentationContainer | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.RuntimeCharacteristicRepresentationFacet)` |
     */
    Facets?: Array<RuntimeCharacteristicRepresentationFacet>;
}

export type RuntimeCharacteristicRepresentationId = string | {Id: string};

export interface ToBeUsedInspection {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RuntimeCharacteristicRepresentationContainerNId` |
     * | Type | `Edm.String` |
     */
    RuntimeCharacteristicRepresentationContainerNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStep_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStep_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RuntimeCharReprRefOperationAssociations` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.RuntimeCharReprRefOperationAssociation)` |
     */
    RuntimeCharReprRefOperationAssociations?: Array<RuntimeCharReprRefOperationAssociation>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderOperation` |
     */
    WorkOrderOperation?: WorkOrderOperation | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStep` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderStep` |
     */
    WorkOrderStep?: WorkOrderStep | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualUsedInspection` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ActualUsedInspection)` |
     */
    ActualUsedInspection?: Array<ActualUsedInspection>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToBeUsedInspectionFacet)` |
     */
    Facets?: Array<ToBeUsedInspectionFacet>;
}

export type ToBeUsedInspectionId = string | {Id: string};

export interface ActualUsedInspection {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedInspection_Id` |
     * | Type | `Edm.Guid` |
     */
    ToBeUsedInspection_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStep_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStep_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedInspection` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToBeUsedInspection` |
     */
    ToBeUsedInspection?: ToBeUsedInspection | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderOperation` |
     */
    WorkOrderOperation?: WorkOrderOperation | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStep` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderStep` |
     */
    WorkOrderStep?: WorkOrderStep | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ActualUsedInspectionFacet)` |
     */
    Facets?: Array<ActualUsedInspectionFacet>;
}

export type ActualUsedInspectionId = string | {Id: string};

export interface ItlkCheckWOStepAssociationParameterValue {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterValue` |
     * | Type | `Edm.String` |
     */
    ParameterValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckParameter_Id` |
     * | Type | `Edm.Guid` |
     */
    ItlkCheckParameter_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckWOStepAssociation_Id` |
     * | Type | `Edm.Guid` |
     */
    ItlkCheckWOStepAssociation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckParameter` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ItlkCheckParameter` |
     */
    ItlkCheckParameter?: ItlkCheckParameter | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckWOStepAssociation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ItlkCheckWOStepAssociation` |
     */
    ItlkCheckWOStepAssociation?: ItlkCheckWOStepAssociation | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ItlkCheckWOStepAssociationParameterValueFacet)` |
     */
    Facets?: Array<ItlkCheckWOStepAssociationParameterValueFacet>;
}

export type ItlkCheckWOStepAssociationParameterValueId = string | {Id: string};

export interface ItlkCheckWOStepAssociation {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsInbound` |
     * | Type | `Edm.Boolean` |
     */
    IsInbound: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsOutbound` |
     * | Type | `Edm.Boolean` |
     */
    IsOutbound: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheck_Id` |
     * | Type | `Edm.Guid` |
     */
    ItlkCheck_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStep_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStep_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckWOStepAssociationParameterValues` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ItlkCheckWOStepAssociationParameterValue)` |
     */
    ItlkCheckWOStepAssociationParameterValues?: Array<ItlkCheckWOStepAssociationParameterValue>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheck` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ItlkCheck` |
     */
    ItlkCheck?: ItlkCheck | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStep` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderStep` |
     */
    WorkOrderStep?: WorkOrderStep | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckHistoryList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ItlkCheckHistory)` |
     */
    ItlkCheckHistoryList?: Array<ItlkCheckHistory>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ItlkCheckWOStepAssociationFacet)` |
     */
    Facets?: Array<ItlkCheckWOStepAssociationFacet>;
}

export type ItlkCheckWOStepAssociationId = string | {Id: string};

export interface Criticality {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsSystemDefined` |
     * | Type | `Edm.Boolean` |
     */
    IsSystemDefined: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.CriticalityFacet)` |
     */
    Facets?: Array<CriticalityFacet>;
}

export type CriticalityId = string | {Id: string};

export interface APSAlert {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TraceDate` |
     * | Type | `Edm.DateTimeOffset` |
     */
    TraceDate: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UId` |
     * | Type | `Edm.String` |
     */
    UId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OrderNId` |
     * | Type | `Edm.String` |
     */
    OrderNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChangeInformation` |
     * | Type | `Edm.String` |
     */
    ChangeInformation: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationNId` |
     * | Type | `Edm.String` |
     */
    OperationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Type` |
     * | Type | `Edm.String` |
     */
    Type: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.APSAlertFacet)` |
     */
    Facets?: Array<APSAlertFacet>;
}

export type APSAlertId = string | {Id: string};

export interface CharacteristicSpecification {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     */
    Revision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceRevision` |
     * | Type | `Edm.String` |
     */
    SourceRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsCurrent` |
     * | Type | `Edm.Boolean` |
     */
    IsCurrent: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UId` |
     * | Type | `Edm.String` |
     */
    UId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CriticalityNId` |
     * | Type | `Edm.String` |
     */
    CriticalityNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Type` |
     * | Type | `Siemens.SimaticIT.MasterData.CHR_MS.MSModel.Types.ReadingModel.CharacteristicType` |
     */
    Type: CharacteristicType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Context` |
     * | Type | `Siemens.SimaticIT.MasterData.CHR_MS.MSModel.Types.ReadingModel.CharacteristicContext` |
     */
    Context: CharacteristicContext | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FailureReferences` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.FailureReference)` |
     */
    FailureReferences?: Array<FailureReference>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CharacteristicRepresentations` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.CharacteristicRepresentation)` |
     */
    CharacteristicRepresentations?: Array<CharacteristicRepresentation>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CharacterisicFailureAssociations` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.CharacteristicFailureAssociation)` |
     */
    CharacterisicFailureAssociations?: Array<CharacteristicFailureAssociation>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.CharacteristicSpecificationFacet)` |
     */
    Facets?: Array<CharacteristicSpecificationFacet>;
}

export type CharacteristicSpecificationId = string | {Id: string};

export interface VisualCharacteristicSpecification extends CharacteristicSpecification {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SketchRows` |
     * | Type | `Edm.Int32` |
     */
    SketchRows: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SketchColumns` |
     * | Type | `Edm.Int32` |
     */
    SketchColumns: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SketchMimeType` |
     * | Type | `Edm.String` |
     */
    SketchMimeType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sketch_Id_Id` |
     * | Type | `Edm.Guid` |
     */
    Sketch_Id_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sketch_Id` |
     * | Type | `Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.File` |
     */
    Sketch_Id?: File | null;
}

export interface VariableCharacteristicSpecification extends CharacteristicSpecification {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LowerTolerance` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.QuantityType` |
     * | Nullable | `false` |
     */
    LowerTolerance: QuantityType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UpperTolerance` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.QuantityType` |
     * | Nullable | `false` |
     */
    UpperTolerance: QuantityType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NominalValue` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.QuantityType` |
     * | Nullable | `false` |
     */
    NominalValue: QuantityType;
}

export interface AttributiveCharacteristicSpecification extends CharacteristicSpecification {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NOKDescription` |
     * | Type | `Edm.String` |
     */
    NOKDescription: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OKDescription` |
     * | Type | `Edm.String` |
     */
    OKDescription: string | null;
}

export interface CharacteristicRepresentation {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     */
    Revision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceRevision` |
     * | Type | `Edm.String` |
     */
    SourceRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsCurrent` |
     * | Type | `Edm.Boolean` |
     */
    IsCurrent: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CanBeSkipped` |
     * | Type | `Edm.Boolean` |
     */
    CanBeSkipped: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CharacteristicRepresentationFrequencyValue` |
     * | Type | `Edm.Decimal` |
     */
    CharacteristicRepresentationFrequencyValue: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TimeBasedScheduleMode` |
     * | Type | `Edm.String` |
     */
    TimeBasedScheduleMode: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TimeBasedMandatoryInspectionWarningValue` |
     * | Type | `Edm.Int32` |
     */
    TimeBasedMandatoryInspectionWarningValue: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TimeBasedMandatoryInspectionWarningUoM` |
     * | Type | `Siemens.SimaticIT.MasterData.CHR_MS.MSModel.Types.ReadingModel.TimeBasedUoM` |
     */
    TimeBasedMandatoryInspectionWarningUoM: TimeBasedUoM | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SampleSize` |
     * | Type | `Edm.Int32` |
     */
    SampleSize: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CharacteristicSpecification_Id` |
     * | Type | `Edm.Guid` |
     */
    CharacteristicSpecification_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CharacteristicRepresentationFrequency_Id` |
     * | Type | `Edm.Guid` |
     */
    CharacteristicRepresentationFrequency_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `InspectionOperations` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.InspectionOperation)` |
     */
    InspectionOperations?: Array<InspectionOperation>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CharacteristicSpecification` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.CharacteristicSpecification` |
     */
    CharacteristicSpecification?: CharacteristicSpecification | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CharacteristicRepresentationFrequency` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.CharacteristicRepresentationFrequency` |
     */
    CharacteristicRepresentationFrequency?: CharacteristicRepresentationFrequency | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.CharacteristicRepresentationFacet)` |
     */
    Facets?: Array<CharacteristicRepresentationFacet>;
}

export type CharacteristicRepresentationId = string | {Id: string};

export interface CharacteristicFailureAssociation2 {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CharacteristicSpecification_Id` |
     * | Type | `Edm.Guid` |
     */
    CharacteristicSpecification_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CharacteristicSpecification` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.CharacteristicSpecification` |
     */
    CharacteristicSpecification?: CharacteristicSpecification | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.CharacteristicFailureAssociationFacet)` |
     */
    Facets?: Array<CharacteristicFailureAssociationFacet>;
}

export type CharacteristicFailureAssociation2Id = string | {Id: string};

export interface BoMItemGroupType {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.BoMItemGroupTypeFacet)` |
     */
    Facets?: Array<BoMItemGroupTypeFacet>;
}

export type BoMItemGroupTypeId = string | {Id: string};

export interface BoMItem {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsAlternativeSelected` |
     * | Type | `Edm.Boolean` |
     */
    IsAlternativeSelected: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `GroupName` |
     * | Type | `Edm.String` |
     */
    GroupName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogicalPosition` |
     * | Type | `Edm.String` |
     */
    LogicalPosition: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BoM_Id` |
     * | Type | `Edm.Guid` |
     */
    BoM_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BoMItemBoM_Id` |
     * | Type | `Edm.Guid` |
     */
    BoMItemBoM_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `GroupType_Id` |
     * | Type | `Edm.Guid` |
     */
    GroupType_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialDefinition_Id` |
     * | Type | `Edm.Guid` |
     */
    MaterialDefinition_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.QuantityType` |
     * | Nullable | `false` |
     */
    Quantity: QuantityType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialProperties` |
     * | Type | `Siemens.SimaticIT.UADM.MasterData.FB_MS_MAT.MSModel.Types.ReadingModel.MaterialValueType_Siemens_SimaticIT_UADM_MasterData_FB_MS_MAT_MSModel_Types` |
     * | Nullable | `false` |
     */
    MaterialProperties: MaterialValueType_Siemens_SimaticIT_UADM_MasterData_FB_MS_MAT_MSModel_Types;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BoM` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.BoM` |
     */
    BoM?: BoM | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BoMItemBoM` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.BoM` |
     */
    BoMItemBoM?: BoM | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `GroupType` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.BoMItemGroupType` |
     */
    GroupType?: BoMItemGroupType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialDefinition` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DM_Material` |
     */
    MaterialDefinition?: DM_Material | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.BoMItemFacet)` |
     */
    Facets?: Array<BoMItemFacet>;
}

export type BoMItemId = string | {Id: string};

export interface ItlkCheckOperationStepCategoryAssociationParameterValue {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterValue` |
     * | Type | `Edm.String` |
     */
    ParameterValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckParameter_Id` |
     * | Type | `Edm.Guid` |
     */
    ItlkCheckParameter_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckOperationStepCategoryAssociation_Id` |
     * | Type | `Edm.Guid` |
     */
    ItlkCheckOperationStepCategoryAssociation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckParameter` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ItlkCheckParameter` |
     */
    ItlkCheckParameter?: ItlkCheckParameter | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckOperationStepCategoryAssociation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ItlkCheckOperationStepCategoryAssociation` |
     */
    ItlkCheckOperationStepCategoryAssociation?: ItlkCheckOperationStepCategoryAssociation | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ItlkCheckOperationStepCategoryAssociationParameterValueFacet)` |
     */
    Facets?: Array<ItlkCheckOperationStepCategoryAssociationParameterValueFacet>;
}

export type ItlkCheckOperationStepCategoryAssociationParameterValueId = string | {Id: string};

export interface ItlkCheckOperationStepCategoryAssociation {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsInbound` |
     * | Type | `Edm.Boolean` |
     */
    IsInbound: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsOutbound` |
     * | Type | `Edm.Boolean` |
     */
    IsOutbound: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StepRelevant` |
     * | Type | `Edm.Boolean` |
     */
    StepRelevant: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationRelevant` |
     * | Type | `Edm.Boolean` |
     */
    OperationRelevant: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheck_Id` |
     * | Type | `Edm.Guid` |
     */
    ItlkCheck_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationStepCategory_Id` |
     * | Type | `Edm.Guid` |
     */
    OperationStepCategory_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckOperationStepCategoryAssociationParameterValues` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ItlkCheckOperationStepCategoryAssociationParameterValue)` |
     */
    ItlkCheckOperationStepCategoryAssociationParameterValues?: Array<ItlkCheckOperationStepCategoryAssociationParameterValue>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheck` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ItlkCheck` |
     */
    ItlkCheck?: ItlkCheck | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationStepCategory` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.OperationStepCategory` |
     */
    OperationStepCategory?: OperationStepCategory | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckOperationStepCategoryAssociations` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ItlkCheckHistory)` |
     */
    ItlkCheckOperationStepCategoryAssociations?: Array<ItlkCheckHistory>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ItlkCheckOperationStepCategoryAssociationFacet)` |
     */
    Facets?: Array<ItlkCheckOperationStepCategoryAssociationFacet>;
}

export type ItlkCheckOperationStepCategoryAssociationId = string | {Id: string};

export interface InspectionSpecification {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CharacteristicRepresentationNId` |
     * | Type | `Edm.String` |
     */
    CharacteristicRepresentationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UId` |
     * | Type | `Edm.String` |
     */
    UId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CharacteristicRepresentationRevision` |
     * | Type | `Edm.String` |
     */
    CharacteristicRepresentationRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReferencedOperation` |
     * | Type | `Edm.String` |
     */
    ReferencedOperation: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsWOSpecific` |
     * | Type | `Edm.Boolean` |
     */
    IsWOSpecific: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Operation_Id` |
     * | Type | `Edm.Guid` |
     */
    Operation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Step_Id` |
     * | Type | `Edm.Guid` |
     */
    Step_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBop_Id` |
     * | Type | `Edm.Guid` |
     */
    AsPlannedBop_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlan_Id` |
     * | Type | `Edm.Guid` |
     */
    MasterPlan_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Operation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Operation` |
     */
    Operation?: Operation | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Step` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Step` |
     */
    Step?: Step | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBop` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.AsPlannedBOP` |
     */
    AsPlannedBop?: AsPlannedBOP | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlan` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.MasterPlan` |
     */
    MasterPlan?: MasterPlan | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.InspectionSpecificationFacet)` |
     */
    Facets?: Array<InspectionSpecificationFacet>;
}

export type InspectionSpecificationId = string | {Id: string};

export interface EquipmentStateMachine {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Equipment_Id` |
     * | Type | `Edm.Guid` |
     */
    Equipment_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.StatusType` |
     * | Nullable | `false` |
     */
    Status: StatusType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Equipment` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Equipment` |
     */
    Equipment?: Equipment | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentStateMachineFacet)` |
     */
    Facets?: Array<EquipmentStateMachineFacet>;
}

export type EquipmentStateMachineId = string | {Id: string};

export interface EquipmentPropertyAttribute {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AttributeValue` |
     * | Type | `Edm.String` |
     */
    AttributeValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Operational` |
     * | Type | `Edm.Boolean` |
     */
    Operational: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AttributeType` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.SupportedTypes` |
     */
    AttributeType: SupportedTypes | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentProperty_Id` |
     * | Type | `Edm.Guid` |
     */
    EquipmentProperty_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentProperty` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentProperty` |
     */
    EquipmentProperty?: EquipmentProperty | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentPropertyAttributeFacet)` |
     */
    Facets?: Array<EquipmentPropertyAttributeFacet>;
}

export type EquipmentPropertyAttributeId = string | {Id: string};

export interface EquipmentProperty {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PropertyValue` |
     * | Type | `Edm.String` |
     */
    PropertyValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Operational` |
     * | Type | `Edm.Boolean` |
     */
    Operational: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PropertyType` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.SupportedTypes` |
     */
    PropertyType: SupportedTypes | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Equipment_Id` |
     * | Type | `Edm.Guid` |
     */
    Equipment_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentPropertyAttributes` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentPropertyAttribute)` |
     */
    EquipmentPropertyAttributes?: Array<EquipmentPropertyAttribute>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Equipment` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Equipment` |
     */
    Equipment?: Equipment | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentPropertyFacet)` |
     */
    Facets?: Array<EquipmentPropertyFacet>;
}

export type EquipmentPropertyId = string | {Id: string};

export interface EquipmentGroup {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Category` |
     * | Type | `Edm.String` |
     */
    Category: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGroupConfigurationId` |
     * | Type | `Edm.Guid` |
     */
    EquipmentGroupConfigurationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Equipment` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Equipment)` |
     */
    Equipment?: Array<Equipment>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentGroupFacet)` |
     */
    Facets?: Array<EquipmentGroupFacet>;
}

export type EquipmentGroupId = string | {Id: string};

export interface EquipmentGraphNode {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGraphConfigurationNId` |
     * | Type | `Edm.String` |
     */
    EquipmentGraphConfigurationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGraphType` |
     * | Type | `Edm.String` |
     */
    EquipmentGraphType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGroupNId` |
     * | Type | `Edm.String` |
     */
    EquipmentGroupNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGraphNodeConfigurationId` |
     * | Type | `Edm.Guid` |
     */
    EquipmentGraphNodeConfigurationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OffsetX` |
     * | Type | `Edm.Int32` |
     */
    OffsetX: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OffsetY` |
     * | Type | `Edm.Int32` |
     */
    OffsetY: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentGraphNodeFacet)` |
     */
    Facets?: Array<EquipmentGraphNodeFacet>;
}

export type EquipmentGraphNodeId = string | {Id: string};

export interface EquipmentGraphLink {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Label` |
     * | Type | `Edm.String` |
     */
    Label: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourcePosition` |
     * | Type | `Edm.String` |
     */
    SourcePosition: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DestinationPosition` |
     * | Type | `Edm.String` |
     */
    DestinationPosition: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGraphLinkConfigurationId` |
     * | Type | `Edm.Guid` |
     */
    EquipmentGraphLinkConfigurationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Source_Id` |
     * | Type | `Edm.Guid` |
     */
    Source_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Destination_Id` |
     * | Type | `Edm.Guid` |
     */
    Destination_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Source` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentGraphNode` |
     */
    Source?: EquipmentGraphNode | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Destination` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentGraphNode` |
     */
    Destination?: EquipmentGraphNode | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentGraphLinkFacet)` |
     */
    Facets?: Array<EquipmentGraphLinkFacet>;
}

export type EquipmentGraphLinkId = string | {Id: string};

export interface Equipment {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkCalendarNId` |
     * | Type | `Edm.String` |
     */
    WorkCalendarNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationId` |
     * | Type | `Edm.Guid` |
     */
    EquipmentConfigurationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LevelNId` |
     * | Type | `Edm.String` |
     */
    LevelNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.StatusType` |
     * | Nullable | `false` |
     */
    Status: StatusType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StateMachines` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentStateMachine)` |
     */
    StateMachines?: Array<EquipmentStateMachine>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentProperties` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentProperty)` |
     */
    EquipmentProperties?: Array<EquipmentProperty>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGroups` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentGroup)` |
     */
    EquipmentGroups?: Array<EquipmentGroup>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentFacet)` |
     */
    Facets?: Array<EquipmentFacet>;
}

export type EquipmentId = string | {Id: string};

export interface EquipmentTypeStateMachine {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StateMachineNId` |
     * | Type | `Edm.String` |
     */
    StateMachineNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentType_Id` |
     * | Type | `Edm.Guid` |
     */
    EquipmentType_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentType` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentType` |
     */
    EquipmentType?: EquipmentType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentTypeStateMachineFacet)` |
     */
    Facets?: Array<EquipmentTypeStateMachineFacet>;
}

export type EquipmentTypeStateMachineId = string | {Id: string};

export interface EquipmentTypePropertyAttribute {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AttributeValue` |
     * | Type | `Edm.String` |
     */
    AttributeValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Operational` |
     * | Type | `Edm.Boolean` |
     */
    Operational: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AttributeType` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.SupportedTypes` |
     */
    AttributeType: SupportedTypes | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeProperty_Id` |
     * | Type | `Edm.Guid` |
     */
    EquipmentTypeProperty_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeProperty` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentTypeProperty` |
     */
    EquipmentTypeProperty?: EquipmentTypeProperty | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentTypePropertyAttributeFacet)` |
     */
    Facets?: Array<EquipmentTypePropertyAttributeFacet>;
}

export type EquipmentTypePropertyAttributeId = string | {Id: string};

export interface EquipmentTypeProperty {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PropertyValue` |
     * | Type | `Edm.String` |
     */
    PropertyValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Operational` |
     * | Type | `Edm.Boolean` |
     */
    Operational: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PropertyType` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.SupportedTypes` |
     */
    PropertyType: SupportedTypes | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentType_Id` |
     * | Type | `Edm.Guid` |
     */
    EquipmentType_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypePropertyAttributes` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentTypePropertyAttribute)` |
     */
    EquipmentTypePropertyAttributes?: Array<EquipmentTypePropertyAttribute>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentType` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentType` |
     */
    EquipmentType?: EquipmentType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentTypePropertyFacet)` |
     */
    Facets?: Array<EquipmentTypePropertyFacet>;
}

export type EquipmentTypePropertyId = string | {Id: string};

export interface EquipmentType {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsDefault` |
     * | Type | `Edm.Boolean` |
     */
    IsDefault: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LevelNId` |
     * | Type | `Edm.String` |
     */
    LevelNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StateMachines` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentTypeStateMachine)` |
     */
    StateMachines?: Array<EquipmentTypeStateMachine>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeProperties` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentTypeProperty)` |
     */
    EquipmentTypeProperties?: Array<EquipmentTypeProperty>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentTypeFacet)` |
     */
    Facets?: Array<EquipmentTypeFacet>;
}

export type EquipmentTypeId = string | {Id: string};

export interface EquipmentLevel {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Level` |
     * | Type | `Edm.Int32` |
     */
    Level: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsSystemDefined` |
     * | Type | `Edm.Boolean` |
     */
    IsSystemDefined: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentLevelFacet)` |
     */
    Facets?: Array<EquipmentLevelFacet>;
}

export type EquipmentLevelId = string | {Id: string};

export interface EquipmentGroupConfiguration {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Category` |
     * | Type | `Edm.String` |
     */
    Category: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurations` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentConfiguration)` |
     */
    EquipmentConfigurations?: Array<EquipmentConfiguration>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGroupConfigurationParents` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentGroupConfiguration)` |
     */
    EquipmentGroupConfigurationParents?: Array<EquipmentGroupConfiguration>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGroupConfigurationChildren` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentGroupConfiguration)` |
     */
    EquipmentGroupConfigurationChildren?: Array<EquipmentGroupConfiguration>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentGroupConfigurationFacet)` |
     */
    Facets?: Array<EquipmentGroupConfigurationFacet>;
}

export type EquipmentGroupConfigurationId = string | {Id: string};

export interface EquipmentGraphType {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentGraphTypeFacet)` |
     */
    Facets?: Array<EquipmentGraphTypeFacet>;
}

export type EquipmentGraphTypeId = string | {Id: string};

export interface EquipmentGraphNodeConfiguration {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationNId` |
     * | Type | `Edm.String` |
     */
    EquipmentConfigurationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGroupConfigurationNId` |
     * | Type | `Edm.String` |
     */
    EquipmentGroupConfigurationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OffsetX` |
     * | Type | `Edm.Int32` |
     */
    OffsetX: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OffsetY` |
     * | Type | `Edm.Int32` |
     */
    OffsetY: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGraphConfiguration_Id` |
     * | Type | `Edm.Guid` |
     */
    EquipmentGraphConfiguration_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGraphConfiguration` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentGraphConfiguration` |
     */
    EquipmentGraphConfiguration?: EquipmentGraphConfiguration | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentGraphNodeConfigurationFacet)` |
     */
    Facets?: Array<EquipmentGraphNodeConfigurationFacet>;
}

export type EquipmentGraphNodeConfigurationId = string | {Id: string};

export interface EquipmentGraphLinkConfiguration {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Label` |
     * | Type | `Edm.String` |
     */
    Label: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourcePosition` |
     * | Type | `Edm.String` |
     */
    SourcePosition: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DestinationPosition` |
     * | Type | `Edm.String` |
     */
    DestinationPosition: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Source_Id` |
     * | Type | `Edm.Guid` |
     */
    Source_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Destination_Id` |
     * | Type | `Edm.Guid` |
     */
    Destination_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Source` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentGraphNodeConfiguration` |
     */
    Source?: EquipmentGraphNodeConfiguration | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Destination` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentGraphNodeConfiguration` |
     */
    Destination?: EquipmentGraphNodeConfiguration | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentGraphLinkConfigurationFacet)` |
     */
    Facets?: Array<EquipmentGraphLinkConfigurationFacet>;
}

export type EquipmentGraphLinkConfigurationId = string | {Id: string};

export interface EquipmentGraphConfiguration {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsDefault` |
     * | Type | `Edm.Boolean` |
     */
    IsDefault: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Type_Id` |
     * | Type | `Edm.Guid` |
     */
    Type_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Type` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentGraphType` |
     */
    Type?: EquipmentGraphType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentGraphConfigurationFacet)` |
     */
    Facets?: Array<EquipmentGraphConfigurationFacet>;
}

export type EquipmentGraphConfigurationId = string | {Id: string};

export interface EquipmentConfigurationStateMachine {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StateMachineNId` |
     * | Type | `Edm.String` |
     */
    StateMachineNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfiguration_Id` |
     * | Type | `Edm.Guid` |
     */
    EquipmentConfiguration_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfiguration` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentConfiguration` |
     */
    EquipmentConfiguration?: EquipmentConfiguration | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentConfigurationStateMachineFacet)` |
     */
    Facets?: Array<EquipmentConfigurationStateMachineFacet>;
}

export type EquipmentConfigurationStateMachineId = string | {Id: string};

export interface EquipmentConfigurationPropertyAttribute {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AttributeValue` |
     * | Type | `Edm.String` |
     */
    AttributeValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Operational` |
     * | Type | `Edm.Boolean` |
     */
    Operational: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AttributeType` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.SupportedTypes` |
     */
    AttributeType: SupportedTypes | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationProperty_Id` |
     * | Type | `Edm.Guid` |
     */
    EquipmentConfigurationProperty_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationProperty` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentConfigurationProperty` |
     */
    EquipmentConfigurationProperty?: EquipmentConfigurationProperty | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentConfigurationPropertyAttributeFacet)` |
     */
    Facets?: Array<EquipmentConfigurationPropertyAttributeFacet>;
}

export type EquipmentConfigurationPropertyAttributeId = string | {Id: string};

export interface EquipmentConfigurationProperty {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PropertyValue` |
     * | Type | `Edm.String` |
     */
    PropertyValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Operational` |
     * | Type | `Edm.Boolean` |
     */
    Operational: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PropertyType` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.SupportedTypes` |
     */
    PropertyType: SupportedTypes | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfiguration_Id` |
     * | Type | `Edm.Guid` |
     */
    EquipmentConfiguration_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationPropertyAttributes` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentConfigurationPropertyAttribute)` |
     */
    EquipmentConfigurationPropertyAttributes?: Array<EquipmentConfigurationPropertyAttribute>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfiguration` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentConfiguration` |
     */
    EquipmentConfiguration?: EquipmentConfiguration | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentConfigurationPropertyFacet)` |
     */
    Facets?: Array<EquipmentConfigurationPropertyFacet>;
}

export type EquipmentConfigurationPropertyId = string | {Id: string};

export interface EquipmentConfiguration {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeNId` |
     * | Type | `Edm.String` |
     */
    EquipmentTypeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LevelNId` |
     * | Type | `Edm.String` |
     */
    LevelNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGroupConfigurations` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentGroupConfiguration)` |
     */
    EquipmentGroupConfigurations?: Array<EquipmentGroupConfiguration>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StateMachines` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentConfigurationStateMachine)` |
     */
    StateMachines?: Array<EquipmentConfigurationStateMachine>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationProperties` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentConfigurationProperty)` |
     */
    EquipmentConfigurationProperties?: Array<EquipmentConfigurationProperty>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentConfigurationFacet)` |
     */
    Facets?: Array<EquipmentConfigurationFacet>;
}

export type EquipmentConfigurationId = string | {Id: string};

export interface BoM {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Priority` |
     * | Type | `Edm.Int32` |
     */
    Priority: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ValidityFrom` |
     * | Type | `Edm.DateTimeOffset` |
     */
    ValidityFrom: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ValidityTo` |
     * | Type | `Edm.DateTimeOffset` |
     */
    ValidityTo: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Version` |
     * | Type | `Edm.String` |
     */
    Version: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialDefinition_Id` |
     * | Type | `Edm.Guid` |
     */
    MaterialDefinition_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.StatusType` |
     * | Nullable | `false` |
     */
    Status: StatusType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.QuantityType` |
     * | Nullable | `false` |
     */
    Quantity: QuantityType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialProperties` |
     * | Type | `Siemens.SimaticIT.UADM.MasterData.FB_MS_MAT.MSModel.Types.ReadingModel.MaterialValueType_Siemens_SimaticIT_UADM_MasterData_FB_MS_MAT_MSModel_Types` |
     * | Nullable | `false` |
     */
    MaterialProperties: MaterialValueType_Siemens_SimaticIT_UADM_MasterData_FB_MS_MAT_MSModel_Types;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BoMItems` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.BoMItem)` |
     */
    BoMItems?: Array<BoMItem>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialDefinition` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DM_Material` |
     */
    MaterialDefinition?: DM_Material | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.BoMFacet)` |
     */
    Facets?: Array<BoMFacet>;
}

export type BoMId = string | {Id: string};

export interface WorkProcessDMMaterialTrackingUnitAssociation {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkProcessNId` |
     * | Type | `Edm.String` |
     */
    WorkProcessNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnitNId` |
     * | Type | `Edm.String` |
     */
    DM_MaterialTrackingUnitNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderStepNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkProcessDMMaterialTrackingUnitAssociationFacet)` |
     */
    Facets?: Array<WorkProcessDMMaterialTrackingUnitAssociationFacet>;
}

export type WorkProcessDMMaterialTrackingUnitAssociationId = string | {Id: string};

export interface UserHAEquipmentPreferences {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `User` |
     * | Type | `Edm.String` |
     */
    User: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.UserHAEquipmentPreferencesFacet)` |
     */
    Facets?: Array<UserHAEquipmentPreferencesFacet>;
}

export type UserHAEquipmentPreferencesId = string | {Id: string};

export interface MaterialTrackingUnitAggregate {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialNId` |
     * | Type | `Edm.String` |
     */
    MaterialNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialRevision` |
     * | Type | `Edm.String` |
     */
    MaterialRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialUId` |
     * | Type | `Edm.String` |
     */
    MaterialUId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TemplateNId` |
     * | Type | `Edm.String` |
     */
    TemplateNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Code` |
     * | Type | `Edm.String` |
     */
    Code: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CodeType` |
     * | Type | `Siemens.SimaticIT.OperationalData.MAT_OP.OPModel.Types.ReadingModel.MTUCodeType` |
     */
    CodeType: MTUCodeType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CurrentLocation` |
     * | Type | `Edm.String` |
     */
    CurrentLocation: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialTrackingUnitAggregatePosition_Id` |
     * | Type | `Edm.Guid` |
     */
    MaterialTrackingUnitAggregatePosition_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.StatusType` |
     * | Nullable | `false` |
     */
    Status: StatusType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.QuantityType` |
     * | Nullable | `false` |
     */
    Quantity: QuantityType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialTrackingUnitAggregatePosition` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.MaterialTrackingUnitAggregate` |
     */
    MaterialTrackingUnitAggregatePosition?: MaterialTrackingUnitAggregate | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialTrackingUnitAggregates` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.MaterialTrackingUnitAggregate)` |
     */
    MaterialTrackingUnitAggregates?: Array<MaterialTrackingUnitAggregate>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialTrackingUnits` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.MaterialTrackingUnit)` |
     */
    MaterialTrackingUnits?: Array<MaterialTrackingUnit>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.MaterialTrackingUnitAggregateFacet)` |
     */
    Facets?: Array<MaterialTrackingUnitAggregateFacet>;
}

export type MaterialTrackingUnitAggregateId = string | {Id: string};

export interface MaterialTrackingUnit {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialNId` |
     * | Type | `Edm.String` |
     */
    MaterialNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialRevision` |
     * | Type | `Edm.String` |
     */
    MaterialRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialUId` |
     * | Type | `Edm.String` |
     */
    MaterialUId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TemplateNId` |
     * | Type | `Edm.String` |
     */
    TemplateNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Code` |
     * | Type | `Edm.String` |
     */
    Code: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CodeType` |
     * | Type | `Siemens.SimaticIT.OperationalData.MAT_OP.OPModel.Types.ReadingModel.MTUCodeType` |
     */
    CodeType: MTUCodeType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CurrentLocation` |
     * | Type | `Edm.String` |
     */
    CurrentLocation: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialLot_Id` |
     * | Type | `Edm.Guid` |
     */
    MaterialLot_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialTrackingUnitAggregate_Id` |
     * | Type | `Edm.Guid` |
     */
    MaterialTrackingUnitAggregate_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.StatusType` |
     * | Nullable | `false` |
     */
    Status: StatusType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.QuantityType` |
     * | Nullable | `false` |
     */
    Quantity: QuantityType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MTU` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.RuntimePJFSerialNumberAssociation)` |
     */
    MTU?: Array<RuntimePJFSerialNumberAssociation>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialLot` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.MaterialLot` |
     */
    MaterialLot?: MaterialLot | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialTrackingUnitAggregate` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.MaterialTrackingUnitAggregate` |
     */
    MaterialTrackingUnitAggregate?: MaterialTrackingUnitAggregate | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.MaterialTrackingUnitFacet)` |
     */
    Facets?: Array<MaterialTrackingUnitFacet>;
}

export type MaterialTrackingUnitId = string | {Id: string};

export interface MaterialLot {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialNId` |
     * | Type | `Edm.String` |
     */
    MaterialNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialRevision` |
     * | Type | `Edm.String` |
     */
    MaterialRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialUId` |
     * | Type | `Edm.String` |
     */
    MaterialUId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TemplateNId` |
     * | Type | `Edm.String` |
     */
    TemplateNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.StatusType` |
     * | Nullable | `false` |
     */
    Status: StatusType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.QuantityType` |
     * | Nullable | `false` |
     */
    Quantity: QuantityType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialTrackingUnits` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.MaterialTrackingUnit)` |
     */
    MaterialTrackingUnits?: Array<MaterialTrackingUnit>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.MaterialLotFacet)` |
     */
    Facets?: Array<MaterialLotFacet>;
}

export type MaterialLotId = string | {Id: string};

export interface DM_MaterialTrackingUnitHistoryAction {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Histories` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DM_MaterialTrackingUnitHistory)` |
     */
    Histories?: Array<DM_MaterialTrackingUnitHistory>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DM_MaterialTrackingUnitHistoryActionFacet)` |
     */
    Facets?: Array<DM_MaterialTrackingUnitHistoryActionFacet>;
}

export type DM_MaterialTrackingUnitHistoryActionId = string | {Id: string};

export interface DM_MaterialTrackingUnitHistory {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Date` |
     * | Type | `Edm.DateTimeOffset` |
     */
    Date: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MixedQuantity` |
     * | Type | `Edm.String` |
     */
    MixedQuantity: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OldQuantity` |
     * | Type | `Edm.Decimal` |
     */
    OldQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RecycleCount` |
     * | Type | `Edm.String` |
     */
    RecycleCount: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     */
    Status: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserId` |
     * | Type | `Edm.String` |
     */
    UserId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrder` |
     * | Type | `Edm.Guid` |
     */
    WorkOrder: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperation: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStep` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStep: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceDM_MaterialTrackingUnitId` |
     * | Type | `Edm.Guid` |
     */
    SourceDM_MaterialTrackingUnitId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetDM_MaterialTrackingUnitId` |
     * | Type | `Edm.Guid` |
     */
    TargetDM_MaterialTrackingUnitId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Code` |
     * | Type | `Edm.String` |
     */
    Code: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CodeType` |
     * | Type | `Siemens.SimaticIT.OperationalData.MAT_OP.OPModel.Types.ReadingModel.MTUCodeType` |
     */
    CodeType: MTUCodeType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceCode` |
     * | Type | `Edm.String` |
     */
    SourceCode: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetCode` |
     * | Type | `Edm.String` |
     */
    TargetCode: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OldCode` |
     * | Type | `Edm.String` |
     */
    OldCode: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NewCode` |
     * | Type | `Edm.String` |
     */
    NewCode: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupPhase` |
     * | Type | `Edm.Guid` |
     */
    ExecutionGroupPhase: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BufferNId` |
     * | Type | `Edm.String` |
     */
    BufferNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DisassembledFromHistory` |
     * | Type | `Edm.Guid` |
     */
    DisassembledFromHistory: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentNId` |
     * | Type | `Edm.String` |
     */
    DocumentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupPhaseNId` |
     * | Type | `Edm.String` |
     */
    ExecutionGroupPhaseNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnitId` |
     * | Type | `Edm.Guid` |
     */
    DM_MaterialTrackingUnitId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformance_Id` |
     * | Type | `Edm.Guid` |
     */
    NonConformance_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Action_Id` |
     * | Type | `Edm.Guid` |
     */
    Action_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformance` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NonConformance` |
     */
    NonConformance?: NonConformance | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Action` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DM_MaterialTrackingUnitHistoryAction` |
     */
    Action?: DM_MaterialTrackingUnitHistoryAction | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DM_MaterialTrackingUnitHistoryFacet)` |
     */
    Facets?: Array<DM_MaterialTrackingUnitHistoryFacet>;
}

export type DM_MaterialTrackingUnitHistoryId = string | {Id: string};

export interface DM_MaterialTrackingUnit {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsReserved` |
     * | Type | `Edm.Boolean` |
     */
    IsReserved: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActiveNonConformanceNumber` |
     * | Type | `Edm.Int32` |
     */
    ActiveNonConformanceNumber: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BufferNId` |
     * | Type | `Edm.String` |
     */
    BufferNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     */
    CorrelationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialId_Id` |
     * | Type | `Edm.Guid` |
     */
    DM_MaterialId_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentDM_MTU_Id` |
     * | Type | `Edm.Guid` |
     */
    ParentDM_MTU_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialTrackingUnit_Id` |
     * | Type | `Edm.Guid` |
     */
    MaterialTrackingUnit_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Weight` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.QuantityType` |
     * | Nullable | `false` |
     */
    Weight: QuantityType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Volume` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.QuantityType` |
     * | Nullable | `false` |
     */
    Volume: QuantityType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialId` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DM_Material` |
     */
    DM_MaterialId?: DM_Material | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentDM_MTU` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DM_MaterialTrackingUnit` |
     */
    ParentDM_MTU?: DM_MaterialTrackingUnit | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialTrackingUnit` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.MaterialTrackingUnit` |
     */
    MaterialTrackingUnit?: MaterialTrackingUnit | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedMaterialItem` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ProducedMaterialItem)` |
     */
    ProducedMaterialItem?: Array<ProducedMaterialItem>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItem` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NonConformanceHistory)` |
     */
    MaterialItem?: Array<NonConformanceHistory>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DM_MaterialTrackingUnitFacet)` |
     */
    Facets?: Array<DM_MaterialTrackingUnitFacet>;
}

export type DM_MaterialTrackingUnitId = string | {Id: string};

export interface Supplier {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Materials` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.MaterialSupplierAssociation)` |
     */
    Materials?: Array<MaterialSupplierAssociation>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.SupplierFacet)` |
     */
    Facets?: Array<SupplierFacet>;
}

export type SupplierId = string | {Id: string};

export interface Material {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     */
    Revision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceRevision` |
     * | Type | `Edm.String` |
     */
    SourceRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsCurrent` |
     * | Type | `Edm.Boolean` |
     */
    IsCurrent: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UId` |
     * | Type | `Edm.String` |
     */
    UId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoMNId` |
     * | Type | `Edm.String` |
     */
    UoMNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TemplateNId` |
     * | Type | `Edm.String` |
     */
    TemplateNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialGroups` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.MaterialGroup)` |
     */
    MaterialGroups?: Array<MaterialGroup>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.MaterialFacet)` |
     */
    Facets?: Array<MaterialFacet>;
}

export type MaterialId = string | {Id: string};

export interface MaterialGroup {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Materials` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Material)` |
     */
    Materials?: Array<Material>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialGroupParents` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.MaterialGroup)` |
     */
    MaterialGroupParents?: Array<MaterialGroup>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialGroupChildren` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.MaterialGroup)` |
     */
    MaterialGroupChildren?: Array<MaterialGroup>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.MaterialGroupFacet)` |
     */
    Facets?: Array<MaterialGroupFacet>;
}

export type MaterialGroupId = string | {Id: string};

export interface FunctionalCode extends MaterialGroup {
}

export interface MaterialClass extends MaterialGroup {
}

export interface DM_Material {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SerialNumberProfile` |
     * | Type | `Edm.Boolean` |
     */
    SerialNumberProfile: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FirstArticleInspection` |
     * | Type | `Edm.Boolean` |
     */
    FirstArticleInspection: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsPhantom` |
     * | Type | `Edm.Boolean` |
     */
    IsPhantom: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogisticClassNId` |
     * | Type | `Edm.String` |
     */
    LogisticClassNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.String` |
     */
    CorrelationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EffectivityExpression` |
     * | Type | `Edm.String` |
     */
    EffectivityExpression: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Traceable` |
     * | Type | `Edm.Boolean` |
     */
    Traceable: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Lot` |
     * | Type | `Edm.Boolean` |
     */
    Lot: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EnableAutomaticConsumptionQty` |
     * | Type | `Edm.Boolean` |
     */
    EnableAutomaticConsumptionQty: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaxQuantityConsumption` |
     * | Type | `Edm.Decimal` |
     */
    MaxQuantityConsumption: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FunctionalCodeNId` |
     * | Type | `Edm.String` |
     */
    FunctionalCodeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Material_Id` |
     * | Type | `Edm.Guid` |
     */
    Material_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialClass_Id` |
     * | Type | `Edm.Guid` |
     */
    MaterialClass_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Supplier_Id` |
     * | Type | `Edm.Guid` |
     */
    Supplier_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FunctionalCode_Id` |
     * | Type | `Edm.Guid` |
     */
    FunctionalCode_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Weight` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.QuantityType` |
     * | Nullable | `false` |
     */
    Weight: QuantityType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Volume` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.QuantityType` |
     * | Nullable | `false` |
     */
    Volume: QuantityType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Suppliers` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.MaterialSupplierAssociation)` |
     */
    Suppliers?: Array<MaterialSupplierAssociation>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCoProducedMaterial` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToBeCoProducedMaterial)` |
     */
    ToBeCoProducedMaterial?: Array<ToBeCoProducedMaterial>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Material` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Material` |
     */
    Material?: Material | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialClass` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.MaterialClass` |
     */
    MaterialClass?: MaterialClass | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Supplier` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Supplier` |
     */
    Supplier?: Supplier | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FunctionalCode` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.FunctionalCode` |
     */
    FunctionalCode?: FunctionalCode | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DM_MaterialFacet)` |
     */
    Facets?: Array<DM_MaterialFacet>;
}

export type DM_MaterialId = string | {Id: string};

export interface ProcessContextDefinitionUserField {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserFieldValue` |
     * | Type | `Edm.String` |
     */
    UserFieldValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserFieldType` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.SupportedTypes` |
     */
    UserFieldType: SupportedTypes | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessContextDefinition_Id` |
     * | Type | `Edm.Guid` |
     */
    ProcessContextDefinition_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessContextDefinition` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ProcessContextDefinition` |
     */
    ProcessContextDefinition?: ProcessContextDefinition | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ProcessContextDefinitionUserFieldFacet)` |
     */
    Facets?: Array<ProcessContextDefinitionUserFieldFacet>;
}

export type ProcessContextDefinitionUserFieldId = string | {Id: string};

export interface ProcessContextDefinition {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContextEntityType` |
     * | Type | `Edm.String` |
     */
    ContextEntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserFields` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ProcessContextDefinitionUserField)` |
     */
    UserFields?: Array<ProcessContextDefinitionUserField>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessDefinitions` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ProcessDefinition)` |
     */
    ProcessDefinitions?: Array<ProcessDefinition>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ProcessContextDefinitionFacet)` |
     */
    Facets?: Array<ProcessContextDefinitionFacet>;
}

export type ProcessContextDefinitionId = string | {Id: string};

export interface ProcessDefinitionParameter {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterValue` |
     * | Type | `Edm.String` |
     */
    ParameterValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterUoMNId` |
     * | Type | `Edm.String` |
     */
    ParameterUoMNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterType` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.SupportedTypes` |
     */
    ParameterType: SupportedTypes | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Direction` |
     * | Type | `Siemens.SimaticIT.MasterData.TSK_MS.MSModel.Types.ReadingModel.TaskDefinitionParameterDirections` |
     */
    Direction: TaskDefinitionParameterDirections | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsReadOnly` |
     * | Type | `Edm.Boolean` |
     */
    IsReadOnly: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessDefinition_Id` |
     * | Type | `Edm.Guid` |
     */
    ProcessDefinition_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessDefinition` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ProcessDefinition` |
     */
    ProcessDefinition?: ProcessDefinition | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ProcessDefinitionParameterFacet)` |
     */
    Facets?: Array<ProcessDefinitionParameterFacet>;
}

export type ProcessDefinitionParameterId = string | {Id: string};

export interface ProcessDefinition {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     */
    Revision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceRevision` |
     * | Type | `Edm.String` |
     */
    SourceRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsCurrent` |
     * | Type | `Edm.Boolean` |
     */
    IsCurrent: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TemplateNId` |
     * | Type | `Edm.String` |
     */
    TemplateNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsExecutable` |
     * | Type | `Edm.Boolean` |
     */
    IsExecutable: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Design` |
     * | Type | `Siemens.SimaticIT.MasterData.BPF_MS.MSModel.Types.ReadingModel.DesignValueType_Siemens_SimaticIT_MasterData_BPF_MS_MSModel_Types` |
     * | Nullable | `false` |
     */
    Design: DesignValueType_Siemens_SimaticIT_MasterData_BPF_MS_MSModel_Types;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Parameters` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ProcessDefinitionParameter)` |
     */
    Parameters?: Array<ProcessDefinitionParameter>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessContextDefinitions` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ProcessContextDefinition)` |
     */
    ProcessContextDefinitions?: Array<ProcessContextDefinition>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ProcessDefinitionFacet)` |
     */
    Facets?: Array<ProcessDefinitionFacet>;
}

export type ProcessDefinitionId = string | {Id: string};

export interface ItlkCheckProcessToOpLinkAssociationParameterValue {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterValue` |
     * | Type | `Edm.String` |
     */
    ParameterValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckProcessToOpLinkAssociation_Id` |
     * | Type | `Edm.Guid` |
     */
    ItlkCheckProcessToOpLinkAssociation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckParameter_Id` |
     * | Type | `Edm.Guid` |
     */
    ItlkCheckParameter_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckProcessToOpLinkAssociation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ItlkCheckProcessToOpLinkAssociation` |
     */
    ItlkCheckProcessToOpLinkAssociation?: ItlkCheckProcessToOpLinkAssociation | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckParameter` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ItlkCheckParameter` |
     */
    ItlkCheckParameter?: ItlkCheckParameter | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ItlkCheckProcessToOpLinkAssociationParameterValueFacet)` |
     */
    Facets?: Array<ItlkCheckProcessToOpLinkAssociationParameterValueFacet>;
}

export type ItlkCheckProcessToOpLinkAssociationParameterValueId = string | {Id: string};

export interface ItlkCheckProcessToOpLinkAssociation {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsInbound` |
     * | Type | `Edm.Boolean` |
     */
    IsInbound: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsOutbound` |
     * | Type | `Edm.Boolean` |
     */
    IsOutbound: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheck_Id` |
     * | Type | `Edm.Guid` |
     */
    ItlkCheck_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessToOperationLink_Id` |
     * | Type | `Edm.Guid` |
     */
    ProcessToOperationLink_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckProcessToOpLinkAssociationParameterValues` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ItlkCheckProcessToOpLinkAssociationParameterValue)` |
     */
    ItlkCheckProcessToOpLinkAssociationParameterValues?: Array<ItlkCheckProcessToOpLinkAssociationParameterValue>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheck` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ItlkCheck` |
     */
    ItlkCheck?: ItlkCheck | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessToOperationLink` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ProcessToOperationLink` |
     */
    ProcessToOperationLink?: ProcessToOperationLink | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ItlkCheckProcessToOpLinkAssociationFacet)` |
     */
    Facets?: Array<ItlkCheckProcessToOpLinkAssociationFacet>;
}

export type ItlkCheckProcessToOpLinkAssociationId = string | {Id: string};

export interface OperationStepCategoryProcessDefinitionAssociation {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessDefinitionNId` |
     * | Type | `Edm.String` |
     */
    ProcessDefinitionNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessDefinitionRevision` |
     * | Type | `Edm.String` |
     */
    ProcessDefinitionRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Active` |
     * | Type | `Edm.Boolean` |
     */
    Active: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ByMTU` |
     * | Type | `Edm.Boolean` |
     */
    ByMTU: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_Material_Id` |
     * | Type | `Edm.Guid` |
     */
    DM_Material_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationStepCategory_Id` |
     * | Type | `Edm.Guid` |
     */
    OperationStepCategory_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessDefinition_Id` |
     * | Type | `Edm.Guid` |
     */
    ProcessDefinition_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_Material` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DM_Material` |
     */
    DM_Material?: DM_Material | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationStepCategory` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.OperationStepCategory` |
     */
    OperationStepCategory?: OperationStepCategory | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessDefinition` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ProcessDefinition` |
     */
    ProcessDefinition?: ProcessDefinition | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.OperationStepCategoryProcessDefinitionAssociationFacet)` |
     */
    Facets?: Array<OperationStepCategoryProcessDefinitionAssociationFacet>;
}

export type OperationStepCategoryProcessDefinitionAssociationId = string | {Id: string};

export interface ItlkCheckWOOpAssociationParameterValue {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterValue` |
     * | Type | `Edm.String` |
     */
    ParameterValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckParameter_Id` |
     * | Type | `Edm.Guid` |
     */
    ItlkCheckParameter_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckWOOpAssociation_Id` |
     * | Type | `Edm.Guid` |
     */
    ItlkCheckWOOpAssociation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckParameter` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ItlkCheckParameter` |
     */
    ItlkCheckParameter?: ItlkCheckParameter | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckWOOpAssociation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ItlkCheckWOOpAssociation` |
     */
    ItlkCheckWOOpAssociation?: ItlkCheckWOOpAssociation | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ItlkCheckWOOpAssociationParameterValueFacet)` |
     */
    Facets?: Array<ItlkCheckWOOpAssociationParameterValueFacet>;
}

export type ItlkCheckWOOpAssociationParameterValueId = string | {Id: string};

export interface ItlkCheckWOOpAssociation {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsInbound` |
     * | Type | `Edm.Boolean` |
     */
    IsInbound: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsOutbound` |
     * | Type | `Edm.Boolean` |
     */
    IsOutbound: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheck_Id` |
     * | Type | `Edm.Guid` |
     */
    ItlkCheck_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckWOOpAssociationParameterValues` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ItlkCheckWOOpAssociationParameterValue)` |
     */
    ItlkCheckWOOpAssociationParameterValues?: Array<ItlkCheckWOOpAssociationParameterValue>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheck` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ItlkCheck` |
     */
    ItlkCheck?: ItlkCheck | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderOperation` |
     */
    WorkOrderOperation?: WorkOrderOperation | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckHistoryList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ItlkCheckHistory)` |
     */
    ItlkCheckHistoryList?: Array<ItlkCheckHistory>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ItlkCheckWOOpAssociationFacet)` |
     */
    Facets?: Array<ItlkCheckWOOpAssociationFacet>;
}

export type ItlkCheckWOOpAssociationId = string | {Id: string};

export interface ItlkCheckHistoryParameterValue {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterValue` |
     * | Type | `Edm.String` |
     */
    ParameterValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckParameter` |
     * | Type | `Edm.Guid` |
     */
    ItlkCheckParameter: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckHistory_Id` |
     * | Type | `Edm.Guid` |
     */
    ItlkCheckHistory_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckHistory` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ItlkCheckHistory` |
     */
    ItlkCheckHistory?: ItlkCheckHistory | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ItlkCheckHistoryParameterValueFacet)` |
     */
    Facets?: Array<ItlkCheckHistoryParameterValueFacet>;
}

export type ItlkCheckHistoryParameterValueId = string | {Id: string};

export interface ItlkCheckHistory {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStepId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderStepNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MTUCode` |
     * | Type | `Edm.String` |
     */
    MTUCode: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `User` |
     * | Type | `Edm.String` |
     */
    User: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationStepCategoryId` |
     * | Type | `Edm.Guid` |
     */
    OperationStepCategoryId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationStepCategoryNId` |
     * | Type | `Edm.String` |
     */
    OperationStepCategoryNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckSessionId` |
     * | Type | `Edm.Guid` |
     */
    ItlkCheckSessionId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MTUId` |
     * | Type | `Edm.Guid` |
     */
    DM_MTUId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MTUCodeType` |
     * | Type | `Siemens.SimaticIT.OperationalData.MAT_OP.OPModel.Types.ReadingModel.MTUCodeType` |
     */
    MTUCodeType: MTUCodeType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckResult` |
     * | Type | `Edm.Boolean` |
     */
    ItlkCheckResult: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Date` |
     * | Type | `Edm.DateTimeOffset` |
     */
    Date: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckOperationStepCategoryAssociation_Id` |
     * | Type | `Edm.Guid` |
     */
    ItlkCheckOperationStepCategoryAssociation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckWOOpAssociation_Id` |
     * | Type | `Edm.Guid` |
     */
    ItlkCheckWOOpAssociation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckWOStepAssociation_Id` |
     * | Type | `Edm.Guid` |
     */
    ItlkCheckWOStepAssociation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckHistoryParameterValues` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ItlkCheckHistoryParameterValue)` |
     */
    ItlkCheckHistoryParameterValues?: Array<ItlkCheckHistoryParameterValue>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckOperationStepCategoryAssociation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ItlkCheckOperationStepCategoryAssociation` |
     */
    ItlkCheckOperationStepCategoryAssociation?: ItlkCheckOperationStepCategoryAssociation | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckWOOpAssociation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ItlkCheckWOOpAssociation` |
     */
    ItlkCheckWOOpAssociation?: ItlkCheckWOOpAssociation | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckWOStepAssociation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ItlkCheckWOStepAssociation` |
     */
    ItlkCheckWOStepAssociation?: ItlkCheckWOStepAssociation | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ItlkCheckHistoryFacet)` |
     */
    Facets?: Array<ItlkCheckHistoryFacet>;
}

export type ItlkCheckHistoryId = string | {Id: string};

export interface TeamUserAssociation {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `User` |
     * | Type | `Edm.String` |
     */
    User: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Team_Id` |
     * | Type | `Edm.Guid` |
     */
    Team_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Team` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Team` |
     */
    Team?: Team | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.TeamUserAssociationFacet)` |
     */
    Facets?: Array<TeamUserAssociationFacet>;
}

export type TeamUserAssociationId = string | {Id: string};

export interface TeamHistory {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `User` |
     * | Type | `Edm.String` |
     */
    User: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AssociatedUser` |
     * | Type | `Edm.String` |
     */
    AssociatedUser: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Date` |
     * | Type | `Edm.DateTimeOffset` |
     */
    Date: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Action_Id` |
     * | Type | `Edm.Guid` |
     */
    Action_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Teams_Id` |
     * | Type | `Edm.Guid` |
     */
    Teams_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Action` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.TeamHistoryAction` |
     */
    Action?: TeamHistoryAction | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Teams` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Team` |
     */
    Teams?: Team | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.TeamHistoryFacet)` |
     */
    Facets?: Array<TeamHistoryFacet>;
}

export type TeamHistoryId = string | {Id: string};

export interface TeamHistoryAction {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.TeamHistoryActionFacet)` |
     */
    Facets?: Array<TeamHistoryActionFacet>;
}

export type TeamHistoryActionId = string | {Id: string};

export interface TeamSkillAssociation {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Level` |
     * | Type | `Edm.Int32` |
     */
    Level: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Skill_Id` |
     * | Type | `Edm.Guid` |
     */
    Skill_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Teams_Id` |
     * | Type | `Edm.Guid` |
     */
    Teams_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Skill` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Skill_BOP` |
     */
    Skill?: Skill_BOP | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Teams` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Team` |
     */
    Teams?: Team | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.TeamSkillAssociationFacet)` |
     */
    Facets?: Array<TeamSkillAssociationFacet>;
}

export type TeamSkillAssociationId = string | {Id: string};

export interface Team {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaximumUsers` |
     * | Type | `Edm.Int32` |
     */
    MaximumUsers: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TeamUserAssociation` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.TeamUserAssociation)` |
     */
    TeamUserAssociation?: Array<TeamUserAssociation>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TeamSkill` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.TeamSkillAssociation)` |
     */
    TeamSkill?: Array<TeamSkillAssociation>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Teams` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderHistory)` |
     */
    Teams?: Array<WorkOrderHistory>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.TeamFacet)` |
     */
    Facets?: Array<TeamFacet>;
}

export type TeamId = string | {Id: string};

export interface NonProductiveActivityHistory {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NPAContextId` |
     * | Type | `Edm.Guid` |
     */
    NPAContextId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NPAContextValue` |
     * | Type | `Edm.Guid` |
     */
    NPAContextValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `User` |
     * | Type | `Edm.String` |
     */
    User: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NPAEquipmentNIdValue` |
     * | Type | `Edm.String` |
     */
    NPAEquipmentNIdValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NPAId` |
     * | Type | `Edm.Guid` |
     */
    NPAId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Date` |
     * | Type | `Edm.DateTimeOffset` |
     */
    Date: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Action_Id` |
     * | Type | `Edm.Guid` |
     */
    Action_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Action` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NonProductiveActivityHistoryAction` |
     */
    Action?: NonProductiveActivityHistoryAction | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NonProductiveActivityHistoryFacet)` |
     */
    Facets?: Array<NonProductiveActivityHistoryFacet>;
}

export type NonProductiveActivityHistoryId = string | {Id: string};

export interface NonProductiveActivityHistoryAction {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NonProductiveActivityHistoryActionFacet)` |
     */
    Facets?: Array<NonProductiveActivityHistoryActionFacet>;
}

export type NonProductiveActivityHistoryActionId = string | {Id: string};

export interface NonProductiveActivityContext {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NonProductiveActivityContextFacet)` |
     */
    Facets?: Array<NonProductiveActivityContextFacet>;
}

export type NonProductiveActivityContextId = string | {Id: string};

export interface NonProductiveActivityNotification {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `User` |
     * | Type | `Edm.String` |
     */
    User: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StartDate` |
     * | Type | `Edm.DateTimeOffset` |
     */
    StartDate: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EndDate` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EndDate: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserNPAId` |
     * | Type | `Edm.Guid` |
     */
    UserNPAId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NonProductiveActivityNotificationFacet)` |
     */
    Facets?: Array<NonProductiveActivityNotificationFacet>;
}

export type NonProductiveActivityNotificationId = string | {Id: string};

export interface UserNonProductiveActivity {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EndDate` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EndDate: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NPAContextValue` |
     * | Type | `Edm.Guid` |
     */
    NPAContextValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `User` |
     * | Type | `Edm.String` |
     */
    User: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NPAEquipmentNIdValue` |
     * | Type | `Edm.String` |
     */
    NPAEquipmentNIdValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StartDate` |
     * | Type | `Edm.DateTimeOffset` |
     */
    StartDate: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NPAId_Id` |
     * | Type | `Edm.Guid` |
     */
    NPAId_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NPAContext_Id` |
     * | Type | `Edm.Guid` |
     */
    NPAContext_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NPAId` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NonProductiveActivity` |
     */
    NPAId?: NonProductiveActivity | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NPAContext` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NonProductiveActivityContext` |
     */
    NPAContext?: NonProductiveActivityContext | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.UserNonProductiveActivityFacet)` |
     */
    Facets?: Array<UserNonProductiveActivityFacet>;
}

export type UserNonProductiveActivityId = string | {Id: string};

export interface ItlkCheckParameter {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DataType` |
     * | Type | `Siemens.SimaticIT.U4DM.MasterData.FB_MS_ITLK.MSModel.Types.ReadingModel.ItlkCheckParameterDataTypeEnum` |
     */
    DataType: ItlkCheckParameterDataTypeEnum | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsMandatory` |
     * | Type | `Edm.Boolean` |
     */
    IsMandatory: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsList` |
     * | Type | `Edm.Boolean` |
     */
    IsList: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheck_Id` |
     * | Type | `Edm.Guid` |
     */
    ItlkCheck_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckWOStepAssociationParameterValues` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ItlkCheckWOStepAssociationParameterValue)` |
     */
    ItlkCheckWOStepAssociationParameterValues?: Array<ItlkCheckWOStepAssociationParameterValue>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckOperationStepCategoryAssociationParameterValues` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ItlkCheckOperationStepCategoryAssociationParameterValue)` |
     */
    ItlkCheckOperationStepCategoryAssociationParameterValues?: Array<ItlkCheckOperationStepCategoryAssociationParameterValue>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckProcessToOpLinkAssociationParameterValues` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ItlkCheckProcessToOpLinkAssociationParameterValue)` |
     */
    ItlkCheckProcessToOpLinkAssociationParameterValues?: Array<ItlkCheckProcessToOpLinkAssociationParameterValue>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckWOOpAssociationParameterValues` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ItlkCheckWOOpAssociationParameterValue)` |
     */
    ItlkCheckWOOpAssociationParameterValues?: Array<ItlkCheckWOOpAssociationParameterValue>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheck` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ItlkCheck` |
     */
    ItlkCheck?: ItlkCheck | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ItlkCheckParameterFacet)` |
     */
    Facets?: Array<ItlkCheckParameterFacet>;
}

export type ItlkCheckParameterId = string | {Id: string};

export interface ItlkCheck {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StepRelevant` |
     * | Type | `Edm.Boolean` |
     */
    StepRelevant: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationRelevant` |
     * | Type | `Edm.Boolean` |
     */
    OperationRelevant: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsStandard` |
     * | Type | `Edm.Boolean` |
     */
    IsStandard: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsInbound` |
     * | Type | `Edm.Boolean` |
     */
    IsInbound: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsOutbound` |
     * | Type | `Edm.Boolean` |
     */
    IsOutbound: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckWOStepAssociations` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ItlkCheckWOStepAssociation)` |
     */
    ItlkCheckWOStepAssociations?: Array<ItlkCheckWOStepAssociation>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckOperationStepCategoryAssociation` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ItlkCheckOperationStepCategoryAssociation)` |
     */
    ItlkCheckOperationStepCategoryAssociation?: Array<ItlkCheckOperationStepCategoryAssociation>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckProcessToOpLinkAssociations` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ItlkCheckProcessToOpLinkAssociation)` |
     */
    ItlkCheckProcessToOpLinkAssociations?: Array<ItlkCheckProcessToOpLinkAssociation>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckWOOpAssociations` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ItlkCheckWOOpAssociation)` |
     */
    ItlkCheckWOOpAssociations?: Array<ItlkCheckWOOpAssociation>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckParameters` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ItlkCheckParameter)` |
     */
    ItlkCheckParameters?: Array<ItlkCheckParameter>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ItlkCheckFacet)` |
     */
    Facets?: Array<ItlkCheckFacet>;
}

export type ItlkCheckId = string | {Id: string};

export interface OperationStepCategory {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationStepCategoryProcessDefinitionAssociations` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.OperationStepCategoryProcessDefinitionAssociation)` |
     */
    OperationStepCategoryProcessDefinitionAssociations?: Array<OperationStepCategoryProcessDefinitionAssociation>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderSteps` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderStep)` |
     */
    WorkOrderSteps?: Array<WorkOrderStep>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperations` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderOperation)` |
     */
    WorkOrderOperations?: Array<WorkOrderOperation>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Steps` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Step)` |
     */
    Steps?: Array<Step>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Operations` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Operation)` |
     */
    Operations?: Array<Operation>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.OperationStepCategoryFacet)` |
     */
    Facets?: Array<OperationStepCategoryFacet>;
}

export type OperationStepCategoryId = string | {Id: string};

export interface NonProductiveActivity {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserNonProductiveActivity` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.UserNonProductiveActivity)` |
     */
    UserNonProductiveActivity?: Array<UserNonProductiveActivity>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NonProductiveActivityFacet)` |
     */
    Facets?: Array<NonProductiveActivityFacet>;
}

export type NonProductiveActivityId = string | {Id: string};

export interface WorkOrderOperationSkill {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Level` |
     * | Type | `Edm.Int32` |
     */
    Level: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SkillId_Id` |
     * | Type | `Edm.Guid` |
     */
    SkillId_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SkillId` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Skill_BOP` |
     */
    SkillId?: Skill_BOP | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderOperation` |
     */
    WorkOrderOperation?: WorkOrderOperation | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderOperationSkillFacet)` |
     */
    Facets?: Array<WorkOrderOperationSkillFacet>;
}

export type WorkOrderOperationSkillId = string | {Id: string};

export interface ExecutionGroupPhaseDependency {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FromEGPhase_Id` |
     * | Type | `Edm.Guid` |
     */
    FromEGPhase_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToEGPhase_Id` |
     * | Type | `Edm.Guid` |
     */
    ToEGPhase_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FromEGPhase` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ExecutionGroupPhase` |
     */
    FromEGPhase?: ExecutionGroupPhase | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToEGPhase` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ExecutionGroupPhase` |
     */
    ToEGPhase?: ExecutionGroupPhase | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ExecutionGroupPhaseDependencyFacet)` |
     */
    Facets?: Array<ExecutionGroupPhaseDependencyFacet>;
}

export type ExecutionGroupPhaseDependencyId = string | {Id: string};

export interface ActualCollectedDocument {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Document_Id` |
     * | Type | `Edm.Guid` |
     */
    Document_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnit_Id` |
     * | Type | `Edm.Guid` |
     */
    DM_MaterialTrackingUnit_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStep_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStep_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupPhase_Id` |
     * | Type | `Edm.Guid` |
     */
    ExecutionGroupPhase_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Document` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Document` |
     */
    Document?: Document | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderOperation` |
     */
    WorkOrderOperation?: WorkOrderOperation | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnit` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DM_MaterialTrackingUnit` |
     */
    DM_MaterialTrackingUnit?: DM_MaterialTrackingUnit | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStep` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderStep` |
     */
    WorkOrderStep?: WorkOrderStep | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupPhase` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ExecutionGroupPhase` |
     */
    ExecutionGroupPhase?: ExecutionGroupPhase | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ActualCollectedDocumentFacet)` |
     */
    Facets?: Array<ActualCollectedDocumentFacet>;
}

export type ActualCollectedDocumentId = string | {Id: string};

export interface WorkInstructionAssociationType {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionAssociation` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkInstructionDefinitionToStepAssociation)` |
     */
    WorkInstructionAssociation?: Array<WorkInstructionDefinitionToStepAssociation>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkInstructionAssociationTypeFacet)` |
     */
    Facets?: Array<WorkInstructionAssociationTypeFacet>;
}

export type WorkInstructionAssociationTypeId = string | {Id: string};

export interface WIDefinitionToWOOperationAssociation {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `HideOnExecGroup` |
     * | Type | `Edm.Boolean` |
     */
    HideOnExecGroup: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionAssociationType_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkInstructionAssociationType_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionDefinition_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkInstructionDefinition_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionAssociationType` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkInstructionAssociationType` |
     */
    WorkInstructionAssociationType?: WorkInstructionAssociationType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionDefinition` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkInstructionDefinition` |
     */
    WorkInstructionDefinition?: WorkInstructionDefinition | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderOperation` |
     */
    WorkOrderOperation?: WorkOrderOperation | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WIDefinitionToWOOperationAssociationFacet)` |
     */
    Facets?: Array<WIDefinitionToWOOperationAssociationFacet>;
}

export type WIDefinitionToWOOperationAssociationId = string | {Id: string};

export interface TransportOperationSource {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsSelected` |
     * | Type | `Edm.Boolean` |
     */
    IsSelected: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Priority` |
     * | Type | `Edm.Int32` |
     */
    Priority: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TransportOperation_Id` |
     * | Type | `Edm.Guid` |
     */
    TransportOperation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Buffer_Id` |
     * | Type | `Edm.Guid` |
     */
    Buffer_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogisticRequestItem_Id` |
     * | Type | `Edm.Guid` |
     */
    LogisticRequestItem_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TransportOperation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.TransportOperation` |
     */
    TransportOperation?: TransportOperation | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Buffer` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Buffer` |
     */
    Buffer?: Buffer | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogisticRequestItem` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.LogisticRequestItem` |
     */
    LogisticRequestItem?: LogisticRequestItem | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.TransportOperationSourceFacet)` |
     */
    Facets?: Array<TransportOperationSourceFacet>;
}

export type TransportOperationSourceId = string | {Id: string};

export interface TransportOperationHistoryAssignedHU {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `HandlingUnitNId` |
     * | Type | `Edm.String` |
     */
    HandlingUnitNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TransportOperationHistory_Id` |
     * | Type | `Edm.Guid` |
     */
    TransportOperationHistory_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TransportOperationHistory` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.TransportOperationHistory` |
     */
    TransportOperationHistory?: TransportOperationHistory | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.TransportOperationHistoryAssignedHUFacet)` |
     */
    Facets?: Array<TransportOperationHistoryAssignedHUFacet>;
}

export type TransportOperationHistoryAssignedHUId = string | {Id: string};

export interface TransportOperationHistoryAction {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.TransportOperationHistoryActionFacet)` |
     */
    Facets?: Array<TransportOperationHistoryActionFacet>;
}

export type TransportOperationHistoryActionId = string | {Id: string};

export interface TransportOperationHistory {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserId` |
     * | Type | `Edm.String` |
     */
    UserId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Date` |
     * | Type | `Edm.DateTimeOffset` |
     */
    Date: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DestinationBufferNId` |
     * | Type | `Edm.String` |
     */
    DestinationBufferNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceBufferNId` |
     * | Type | `Edm.String` |
     */
    SourceBufferNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AssignedUserId` |
     * | Type | `Edm.String` |
     */
    AssignedUserId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TransportOperation_Id` |
     * | Type | `Edm.Guid` |
     */
    TransportOperation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Action_Id` |
     * | Type | `Edm.Guid` |
     */
    Action_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AssignedHandlingUnit` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.TransportOperationHistoryAssignedHU)` |
     */
    AssignedHandlingUnit?: Array<TransportOperationHistoryAssignedHU>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TransportOperation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.TransportOperation` |
     */
    TransportOperation?: TransportOperation | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Action` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.TransportOperationHistoryAction` |
     */
    Action?: TransportOperationHistoryAction | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.TransportOperationHistoryFacet)` |
     */
    Facets?: Array<TransportOperationHistoryFacet>;
}

export type TransportOperationHistoryId = string | {Id: string};

export interface TransportOperationDestination {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsSelected` |
     * | Type | `Edm.Boolean` |
     */
    IsSelected: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Priority` |
     * | Type | `Edm.Int32` |
     */
    Priority: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TransportOperation_Id` |
     * | Type | `Edm.Guid` |
     */
    TransportOperation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Buffer_Id` |
     * | Type | `Edm.Guid` |
     */
    Buffer_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogisticRequestItem_Id` |
     * | Type | `Edm.Guid` |
     */
    LogisticRequestItem_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TransportOperation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.TransportOperation` |
     */
    TransportOperation?: TransportOperation | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Buffer` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Buffer` |
     */
    Buffer?: Buffer | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogisticRequestItem` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.LogisticRequestItem` |
     */
    LogisticRequestItem?: LogisticRequestItem | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.TransportOperationDestinationFacet)` |
     */
    Facets?: Array<TransportOperationDestinationFacet>;
}

export type TransportOperationDestinationId = string | {Id: string};

export interface TransportOperation {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RoleId` |
     * | Type | `Edm.String` |
     */
    RoleId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedDuration_Ticks` |
     * | Type | `Edm.Int64` |
     */
    EstimatedDuration_Ticks: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedDuration` |
     * | Type | `Edm.Duration` |
     */
    EstimatedDuration: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.StatusType` |
     * | Nullable | `false` |
     */
    Status: StatusType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TransportOperationSources` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.TransportOperationSource)` |
     */
    TransportOperationSources?: Array<TransportOperationSource>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TransportOperationHistoryList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.TransportOperationHistory)` |
     */
    TransportOperationHistoryList?: Array<TransportOperationHistory>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TransportOperationDestinations` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.TransportOperationDestination)` |
     */
    TransportOperationDestinations?: Array<TransportOperationDestination>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogisticRequestItems` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.LogisticRequestItem)` |
     */
    LogisticRequestItems?: Array<LogisticRequestItem>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `HandlingUnits` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.HandlingUnit)` |
     */
    HandlingUnits?: Array<HandlingUnit>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.TransportOperationFacet)` |
     */
    Facets?: Array<TransportOperationFacet>;
}

export type TransportOperationId = string | {Id: string};

export interface RuntimeLogisticWhitelist {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CapacityType` |
     * | Type | `Edm.Guid` |
     */
    CapacityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContainedEntityType` |
     * | Type | `Edm.String` |
     */
    ContainedEntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContainerEntityType` |
     * | Type | `Edm.String` |
     */
    ContainerEntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolDefinition` |
     * | Type | `Edm.Guid` |
     */
    ToolDefinition: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogisticClass_Id` |
     * | Type | `Edm.Guid` |
     */
    LogisticClass_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_Material_Id` |
     * | Type | `Edm.Guid` |
     */
    DM_Material_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Buffer_Id` |
     * | Type | `Edm.Guid` |
     */
    Buffer_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaxQty` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.QuantityType` |
     * | Nullable | `false` |
     */
    MaxQty: QuantityType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaxVolume` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.QuantityType` |
     * | Nullable | `false` |
     */
    MaxVolume: QuantityType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaxWeight` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.QuantityType` |
     * | Nullable | `false` |
     */
    MaxWeight: QuantityType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Min` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.QuantityType` |
     * | Nullable | `false` |
     */
    Min: QuantityType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Target` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.QuantityType` |
     * | Nullable | `false` |
     */
    Target: QuantityType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Threshold` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.QuantityType` |
     * | Nullable | `false` |
     */
    Threshold: QuantityType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogisticClass` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.LogisticClass` |
     */
    LogisticClass?: LogisticClass | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_Material` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DM_Material` |
     */
    DM_Material?: DM_Material | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Buffer` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Buffer` |
     */
    Buffer?: Buffer | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.RuntimeLogisticWhitelistFacet)` |
     */
    Facets?: Array<RuntimeLogisticWhitelistFacet>;
}

export type RuntimeLogisticWhitelistId = string | {Id: string};

export interface LogisticRequestItem {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolDefinition` |
     * | Type | `Edm.Guid` |
     */
    ToolDefinition: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Type` |
     * | Type | `Edm.String` |
     */
    Type: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_Material_Id` |
     * | Type | `Edm.Guid` |
     */
    DM_Material_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogisticRequest_Id` |
     * | Type | `Edm.Guid` |
     */
    LogisticRequest_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Source_Id` |
     * | Type | `Edm.Guid` |
     */
    Source_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TransportOperation_Id` |
     * | Type | `Edm.Guid` |
     */
    TransportOperation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.QuantityType` |
     * | Nullable | `false` |
     */
    Quantity: QuantityType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_Material` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DM_Material` |
     */
    DM_Material?: DM_Material | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogisticRequest` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.LogisticRequest` |
     */
    LogisticRequest?: LogisticRequest | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Source` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Buffer` |
     */
    Source?: Buffer | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TransportOperation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.TransportOperation` |
     */
    TransportOperation?: TransportOperation | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.LogisticRequestItemFacet)` |
     */
    Facets?: Array<LogisticRequestItemFacet>;
}

export type LogisticRequestItemId = string | {Id: string};

export interface LogisticRequestHistoryAction {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.LogisticRequestHistoryActionFacet)` |
     */
    Facets?: Array<LogisticRequestHistoryActionFacet>;
}

export type LogisticRequestHistoryActionId = string | {Id: string};

export interface LogisticRequestHistory {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Date` |
     * | Type | `Edm.DateTimeOffset` |
     */
    Date: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DestinationBufferId` |
     * | Type | `Edm.Guid` |
     */
    DestinationBufferId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Message` |
     * | Type | `Edm.String` |
     */
    Message: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TransportOperationId` |
     * | Type | `Edm.Guid` |
     */
    TransportOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserId` |
     * | Type | `Edm.String` |
     */
    UserId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Action_Id` |
     * | Type | `Edm.Guid` |
     */
    Action_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogisticRequest_Id` |
     * | Type | `Edm.Guid` |
     */
    LogisticRequest_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Action` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.LogisticRequestHistoryAction` |
     */
    Action?: LogisticRequestHistoryAction | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogisticRequest` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.LogisticRequest` |
     */
    LogisticRequest?: LogisticRequest | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.LogisticRequestHistoryFacet)` |
     */
    Facets?: Array<LogisticRequestHistoryFacet>;
}

export type LogisticRequestHistoryId = string | {Id: string};

export interface LogisticRequest {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DueDate` |
     * | Type | `Edm.DateTimeOffset` |
     */
    DueDate: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserId` |
     * | Type | `Edm.String` |
     */
    UserId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Priority` |
     * | Type | `Edm.Int32` |
     */
    Priority: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Destination_Id` |
     * | Type | `Edm.Guid` |
     */
    Destination_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Buffer_Id` |
     * | Type | `Edm.Guid` |
     */
    Buffer_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.StatusType` |
     * | Nullable | `false` |
     */
    Status: StatusType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogisticRequestItems` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.LogisticRequestItem)` |
     */
    LogisticRequestItems?: Array<LogisticRequestItem>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogisticRequestHistoryList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.LogisticRequestHistory)` |
     */
    LogisticRequestHistoryList?: Array<LogisticRequestHistory>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Destination` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Buffer` |
     */
    Destination?: Buffer | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Buffer` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Buffer` |
     */
    Buffer?: Buffer | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.LogisticRequestFacet)` |
     */
    Facets?: Array<LogisticRequestFacet>;
}

export type LogisticRequestId = string | {Id: string};

export interface HistoryItems {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Type` |
     * | Type | `Edm.String` |
     */
    Type: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BufferHistoryList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.BufferHistory)` |
     */
    BufferHistoryList?: Array<BufferHistory>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.HistoryItemsFacet)` |
     */
    Facets?: Array<HistoryItemsFacet>;
}

export type HistoryItemsId = string | {Id: string};

export interface HandlingUnitMaterialItemAssociation {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnit_Id` |
     * | Type | `Edm.Guid` |
     */
    DM_MaterialTrackingUnit_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `HandlingUnit_Id` |
     * | Type | `Edm.Guid` |
     */
    HandlingUnit_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnit` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DM_MaterialTrackingUnit` |
     */
    DM_MaterialTrackingUnit?: DM_MaterialTrackingUnit | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `HandlingUnit` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.HandlingUnit` |
     */
    HandlingUnit?: HandlingUnit | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.HandlingUnitMaterialItemAssociationFacet)` |
     */
    Facets?: Array<HandlingUnitMaterialItemAssociationFacet>;
}

export type HandlingUnitMaterialItemAssociationId = string | {Id: string};

export interface HandlingUnitHistoryAction {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.HandlingUnitHistoryActionFacet)` |
     */
    Facets?: Array<HandlingUnitHistoryActionFacet>;
}

export type HandlingUnitHistoryActionId = string | {Id: string};

export interface HandlingUnitHistory {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BatchId` |
     * | Type | `Edm.String` |
     */
    BatchId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Date` |
     * | Type | `Edm.DateTimeOffset` |
     */
    Date: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DestinationBufferNId` |
     * | Type | `Edm.String` |
     */
    DestinationBufferNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LocationNId` |
     * | Type | `Edm.String` |
     */
    LocationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `HandlingUnitNId` |
     * | Type | `Edm.String` |
     */
    HandlingUnitNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SerialNumber` |
     * | Type | `Edm.String` |
     */
    SerialNumber: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceBufferNId` |
     * | Type | `Edm.String` |
     */
    SourceBufferNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StatusNId` |
     * | Type | `Edm.String` |
     */
    StatusNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TransportOperationNId` |
     * | Type | `Edm.String` |
     */
    TransportOperationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserId` |
     * | Type | `Edm.String` |
     */
    UserId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `HandlingUnit_Id` |
     * | Type | `Edm.Guid` |
     */
    HandlingUnit_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Action_Id` |
     * | Type | `Edm.Guid` |
     */
    Action_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItemQuantity` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.QuantityType` |
     * | Nullable | `false` |
     */
    MaterialItemQuantity: QuantityType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `HandlingUnit` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.HandlingUnit` |
     */
    HandlingUnit?: HandlingUnit | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Action` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.HandlingUnitHistoryAction` |
     */
    Action?: HandlingUnitHistoryAction | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.HandlingUnitHistoryFacet)` |
     */
    Facets?: Array<HandlingUnitHistoryFacet>;
}

export type HandlingUnitHistoryId = string | {Id: string};

export interface HandlingUnit {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LocationNId` |
     * | Type | `Edm.String` |
     */
    LocationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TransportOperation_Id` |
     * | Type | `Edm.Guid` |
     */
    TransportOperation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.StatusType` |
     * | Nullable | `false` |
     */
    Status: StatusType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Weight` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.QuantityType` |
     * | Nullable | `false` |
     */
    Weight: QuantityType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `HandlingUnitMaterialItemAssociations` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.HandlingUnitMaterialItemAssociation)` |
     */
    HandlingUnitMaterialItemAssociations?: Array<HandlingUnitMaterialItemAssociation>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TransportOperation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.TransportOperation` |
     */
    TransportOperation?: TransportOperation | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.HandlingUnitFacet)` |
     */
    Facets?: Array<HandlingUnitFacet>;
}

export type HandlingUnitId = string | {Id: string};

export interface BufferToolAssociation {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Tool` |
     * | Type | `Edm.Guid` |
     */
    Tool: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Buffer_Id` |
     * | Type | `Edm.Guid` |
     */
    Buffer_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Buffer` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Buffer` |
     */
    Buffer?: Buffer | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.BufferToolAssociationFacet)` |
     */
    Facets?: Array<BufferToolAssociationFacet>;
}

export type BufferToolAssociationId = string | {Id: string};

export interface BufferMaterialItemAssociation {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnit_Id` |
     * | Type | `Edm.Guid` |
     */
    DM_MaterialTrackingUnit_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Buffer_Id` |
     * | Type | `Edm.Guid` |
     */
    Buffer_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnit` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DM_MaterialTrackingUnit` |
     */
    DM_MaterialTrackingUnit?: DM_MaterialTrackingUnit | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Buffer` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Buffer` |
     */
    Buffer?: Buffer | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.BufferMaterialItemAssociationFacet)` |
     */
    Facets?: Array<BufferMaterialItemAssociationFacet>;
}

export type BufferMaterialItemAssociationId = string | {Id: string};

export interface BufferHistoryAction {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Action` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.BufferHistory)` |
     */
    Action?: Array<BufferHistory>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.BufferHistoryActionFacet)` |
     */
    Facets?: Array<BufferHistoryActionFacet>;
}

export type BufferHistoryActionId = string | {Id: string};

export interface BufferHistory {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserId` |
     * | Type | `Edm.String` |
     */
    UserId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItemId` |
     * | Type | `Edm.Guid` |
     */
    ItemId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItemNId` |
     * | Type | `Edm.String` |
     */
    ItemNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Date` |
     * | Type | `Edm.DateTimeOffset` |
     */
    Date: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Action_Id` |
     * | Type | `Edm.Guid` |
     */
    Action_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Buffer_Id` |
     * | Type | `Edm.Guid` |
     */
    Buffer_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Type_Id` |
     * | Type | `Edm.Guid` |
     */
    Type_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.QuantityType` |
     * | Nullable | `false` |
     */
    Quantity: QuantityType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Action` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.BufferHistoryAction` |
     */
    Action?: BufferHistoryAction | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Buffer` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Buffer` |
     */
    Buffer?: Buffer | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Type` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.HistoryItems` |
     */
    Type?: HistoryItems | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.BufferHistoryFacet)` |
     */
    Facets?: Array<BufferHistoryFacet>;
}

export type BufferHistoryId = string | {Id: string};

export interface BufferEquipmentAssoication {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Priority` |
     * | Type | `Edm.Int32` |
     */
    Priority: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Buffer_Id` |
     * | Type | `Edm.Guid` |
     */
    Buffer_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Buffer` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Buffer` |
     */
    Buffer?: Buffer | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.BufferEquipmentAssoicationFacet)` |
     */
    Facets?: Array<BufferEquipmentAssoicationFacet>;
}

export type BufferEquipmentAssoicationId = string | {Id: string};

export interface Buffer {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentName` |
     * | Type | `Edm.String` |
     */
    EquipmentName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ValidityFrom` |
     * | Type | `Edm.DateTimeOffset` |
     */
    ValidityFrom: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ValidityTo` |
     * | Type | `Edm.DateTimeOffset` |
     */
    ValidityTo: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BufferDefinition_Id` |
     * | Type | `Edm.Guid` |
     */
    BufferDefinition_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CapacityType_Id` |
     * | Type | `Edm.Guid` |
     */
    CapacityType_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaxQty` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.QuantityType` |
     * | Nullable | `false` |
     */
    MaxQty: QuantityType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaxVolume` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.QuantityType` |
     * | Nullable | `false` |
     */
    MaxVolume: QuantityType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaxWeight` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.QuantityType` |
     * | Nullable | `false` |
     */
    MaxWeight: QuantityType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.StatusType` |
     * | Nullable | `false` |
     */
    Status: StatusType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RuntimeLogisticWhitelists` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.RuntimeLogisticWhitelist)` |
     */
    RuntimeLogisticWhitelists?: Array<RuntimeLogisticWhitelist>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Source` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.LogisticRequestItem)` |
     */
    Source?: Array<LogisticRequestItem>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogisticRequests` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.LogisticRequest)` |
     */
    LogisticRequests?: Array<LogisticRequest>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TriggeredLogisticRequests` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.LogisticRequest)` |
     */
    TriggeredLogisticRequests?: Array<LogisticRequest>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BufferToolAssociations` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.BufferToolAssociation)` |
     */
    BufferToolAssociations?: Array<BufferToolAssociation>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BufferMaterialItemAssociations` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.BufferMaterialItemAssociation)` |
     */
    BufferMaterialItemAssociations?: Array<BufferMaterialItemAssociation>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BufferHistoryList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.BufferHistory)` |
     */
    BufferHistoryList?: Array<BufferHistory>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BufferEquipmentAssoication` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.BufferEquipmentAssoication)` |
     */
    BufferEquipmentAssoication?: Array<BufferEquipmentAssoication>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BufferDefinition` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.BufferDefinition` |
     */
    BufferDefinition?: BufferDefinition | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CapacityType` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.CapacityType` |
     */
    CapacityType?: CapacityType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.BufferFacet)` |
     */
    Facets?: Array<BufferFacet>;
}

export type BufferId = string | {Id: string};

export interface ExecutionGroupPhaseWOOAssociation {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupPhase_Id` |
     * | Type | `Edm.Guid` |
     */
    ExecutionGroupPhase_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupPhase` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ExecutionGroupPhase` |
     */
    ExecutionGroupPhase?: ExecutionGroupPhase | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderOperation` |
     */
    WorkOrderOperation?: WorkOrderOperation | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ExecutionGroupPhaseWOOAssociationFacet)` |
     */
    Facets?: Array<ExecutionGroupPhaseWOOAssociationFacet>;
}

export type ExecutionGroupPhaseWOOAssociationId = string | {Id: string};

export interface WorkInstructionToWorkOrderOperationAssociation {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `HideOnExecGroup` |
     * | Type | `Edm.Boolean` |
     */
    HideOnExecGroup: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WIDefToWOOpAssociationId` |
     * | Type | `Edm.Guid` |
     */
    WIDefToWOOpAssociationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstruction_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkInstruction_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnit_Id` |
     * | Type | `Edm.Guid` |
     */
    DM_MaterialTrackingUnit_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderOperation` |
     */
    WorkOrderOperation?: WorkOrderOperation | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstruction` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkInstruction` |
     */
    WorkInstruction?: WorkInstruction | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnit` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DM_MaterialTrackingUnit` |
     */
    DM_MaterialTrackingUnit?: DM_MaterialTrackingUnit | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkInstructionToWorkOrderOperationAssociationFacet)` |
     */
    Facets?: Array<WorkInstructionToWorkOrderOperationAssociationFacet>;
}

export type WorkInstructionToWorkOrderOperationAssociationId = string | {Id: string};

export interface ExecutionGroupPhase {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     */
    Sequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedStartTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedStartTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedEndTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedEndTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PreferredMachineNId` |
     * | Type | `Edm.String` |
     */
    PreferredMachineNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCollectedDocument` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCollectedDocument: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedDuration_Ticks` |
     * | Type | `Edm.Int64` |
     */
    EstimatedDuration_Ticks: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedDuration` |
     * | Type | `Edm.Duration` |
     */
    EstimatedDuration: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroup_Id` |
     * | Type | `Edm.Guid` |
     */
    ExecutionGroup_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.StatusType` |
     * | Nullable | `false` |
     */
    Status: StatusType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionToEGPhaseAssociation` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkInstructionToExecutionGroupPhaseAssociation)` |
     */
    WorkInstructionToEGPhaseAssociation?: Array<WorkInstructionToExecutionGroupPhaseAssociation>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WIDefinitionToEGPhaseAssociation` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WIDefinitionToEGPhaseAssociation)` |
     */
    WIDefinitionToEGPhaseAssociation?: Array<WIDefinitionToEGPhaseAssociation>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Successors` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ExecutionGroupPhaseDependency)` |
     */
    Successors?: Array<ExecutionGroupPhaseDependency>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Predecessor` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ExecutionGroupPhaseDependency)` |
     */
    Predecessor?: Array<ExecutionGroupPhaseDependency>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualCollectedDocument` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ActualCollectedDocument)` |
     */
    ActualCollectedDocument?: Array<ActualCollectedDocument>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupPhaseWOOAssociation` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ExecutionGroupPhaseWOOAssociation)` |
     */
    ExecutionGroupPhaseWOOAssociation?: Array<ExecutionGroupPhaseWOOAssociation>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroup` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ExecutionGroup` |
     */
    ExecutionGroup?: ExecutionGroup | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualConsumedMaterials` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ActualConsumedMaterial)` |
     */
    ActualConsumedMaterials?: Array<ActualConsumedMaterial>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActiveUserOnMachines` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ActiveUserOnMachine)` |
     */
    ActiveUserOnMachines?: Array<ActiveUserOnMachine>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ExecutionGroupPhaseFacet)` |
     */
    Facets?: Array<ExecutionGroupPhaseFacet>;
}

export type ExecutionGroupPhaseId = string | {Id: string};

export interface ExecutionGroupHistoryAction {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ExecutionGroupHistoryActionFacet)` |
     */
    Facets?: Array<ExecutionGroupHistoryActionFacet>;
}

export type ExecutionGroupHistoryActionId = string | {Id: string};

export interface ExecutionGroupHistory {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupId` |
     * | Type | `Edm.Guid` |
     */
    ExecutionGroupId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserId` |
     * | Type | `Edm.String` |
     */
    UserId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOId` |
     * | Type | `Edm.Guid` |
     */
    WOOId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Date` |
     * | Type | `Edm.DateTimeOffset` |
     */
    Date: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OldQuantity` |
     * | Type | `Edm.Decimal` |
     */
    OldQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NewQuantity` |
     * | Type | `Edm.Decimal` |
     */
    NewQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupPhaseId` |
     * | Type | `Edm.Guid` |
     */
    ExecutionGroupPhaseId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionDefinitionId` |
     * | Type | `Edm.Guid` |
     */
    WorkInstructionDefinitionId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Action_Id` |
     * | Type | `Edm.Guid` |
     */
    Action_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Action` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ExecutionGroupHistoryAction` |
     */
    Action?: ExecutionGroupHistoryAction | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ExecutionGroupHistoryFacet)` |
     */
    Facets?: Array<ExecutionGroupHistoryFacet>;
}

export type ExecutionGroupHistoryId = string | {Id: string};

export interface ExecutionGroup {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedStartTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedStartTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedEndTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedEndTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsUnderScheduling` |
     * | Type | `Edm.Boolean` |
     */
    IsUnderScheduling: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SchedulingDate` |
     * | Type | `Edm.DateTimeOffset` |
     */
    SchedulingDate: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DueDate` |
     * | Type | `Edm.DateTimeOffset` |
     */
    DueDate: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedDuration_Ticks` |
     * | Type | `Edm.Int64` |
     */
    EstimatedDuration_Ticks: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedDuration` |
     * | Type | `Edm.Duration` |
     */
    EstimatedDuration: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.StatusType` |
     * | Nullable | `false` |
     */
    Status: StatusType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupPhases` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ExecutionGroupPhase)` |
     */
    ExecutionGroupPhases?: Array<ExecutionGroupPhase>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ExecutionGroupFacet)` |
     */
    Facets?: Array<ExecutionGroupFacet>;
}

export type ExecutionGroupId = string | {Id: string};

export interface WorkInstructionStepItemLimit {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItemNId` |
     * | Type | `Edm.String` |
     */
    ItemNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Target` |
     * | Type | `Edm.String` |
     */
    Target: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetBinding` |
     * | Type | `Edm.String` |
     */
    TargetBinding: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LowLimit` |
     * | Type | `Edm.String` |
     */
    LowLimit: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LowLimitBinding` |
     * | Type | `Edm.String` |
     */
    LowLimitBinding: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `HighLimit` |
     * | Type | `Edm.String` |
     */
    HighLimit: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `HighLimitBinding` |
     * | Type | `Edm.String` |
     */
    HighLimitBinding: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AlertMin` |
     * | Type | `Edm.String` |
     */
    AlertMin: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AlertMinBinding` |
     * | Type | `Edm.String` |
     */
    AlertMinBinding: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CautionMin` |
     * | Type | `Edm.String` |
     */
    CautionMin: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CautionMinBinding` |
     * | Type | `Edm.String` |
     */
    CautionMinBinding: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CautionMax` |
     * | Type | `Edm.String` |
     */
    CautionMax: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CautionMaxBinding` |
     * | Type | `Edm.String` |
     */
    CautionMaxBinding: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AlertMax` |
     * | Type | `Edm.String` |
     */
    AlertMax: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AlertMaxBinding` |
     * | Type | `Edm.String` |
     */
    AlertMaxBinding: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionStepItem_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkInstructionStepItem_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionStepItem` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkInstructionStepItem` |
     */
    WorkInstructionStepItem?: WorkInstructionStepItem | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkInstructionStepItemLimitFacet)` |
     */
    Facets?: Array<WorkInstructionStepItemLimitFacet>;
}

export type WorkInstructionStepItemLimitId = string | {Id: string};

export interface WorkInstructionStepItem {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItemNId` |
     * | Type | `Edm.String` |
     */
    ItemNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StepNId` |
     * | Type | `Edm.String` |
     */
    StepNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItemValue` |
     * | Type | `Edm.String` |
     */
    ItemValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DataType` |
     * | Type | `Edm.String` |
     */
    DataType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Binding` |
     * | Type | `Edm.String` |
     */
    Binding: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Label` |
     * | Type | `Edm.String` |
     */
    Label: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Caption` |
     * | Type | `Edm.String` |
     */
    Caption: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UIControl` |
     * | Type | `Edm.String` |
     */
    UIControl: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsRequired` |
     * | Type | `Edm.Boolean` |
     */
    IsRequired: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsReadOnly` |
     * | Type | `Edm.Boolean` |
     */
    IsReadOnly: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoM` |
     * | Type | `Edm.String` |
     */
    UoM: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Format` |
     * | Type | `Edm.String` |
     */
    Format: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefaultValue` |
     * | Type | `Edm.String` |
     */
    DefaultValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionDate` |
     * | Type | `Edm.DateTimeOffset` |
     */
    ExecutionDate: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CompletedBy` |
     * | Type | `Edm.String` |
     */
    CompletedBy: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsModifiable` |
     * | Type | `Edm.Boolean` |
     */
    IsModifiable: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsForceBlank` |
     * | Type | `Edm.Boolean` |
     */
    IsForceBlank: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsOutOfSpec` |
     * | Type | `Edm.Boolean` |
     */
    IsOutOfSpec: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Length` |
     * | Type | `Edm.Int32` |
     */
    Length: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastValueUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastValueUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsCompleted` |
     * | Type | `Edm.Boolean` |
     */
    IsCompleted: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `InstanceNumber` |
     * | Type | `Edm.Int32` |
     */
    InstanceNumber: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AcquisitionBehavior` |
     * | Type | `Siemens.SimaticIT.OperationalData.WI_OP.OPModel.Types.ReadingModel.AcquisitionType` |
     */
    AcquisitionBehavior: AcquisitionType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionStep_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkInstructionStep_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Limit` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkInstructionStepItemLimit)` |
     */
    Limit?: Array<WorkInstructionStepItemLimit>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionStep` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkInstructionStep` |
     */
    WorkInstructionStep?: WorkInstructionStep | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkInstructionStepItemFacet)` |
     */
    Facets?: Array<WorkInstructionStepItemFacet>;
}

export type WorkInstructionStepItemId = string | {Id: string};

export interface WorkInstructionStep {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Title` |
     * | Type | `Edm.String` |
     */
    Title: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `InstanceNumber` |
     * | Type | `Edm.Int32` |
     */
    InstanceNumber: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Instructions` |
     * | Type | `Edm.String` |
     */
    Instructions: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AcknowledgeOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    AcknowledgeOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CompletedBy` |
     * | Type | `Edm.String` |
     */
    CompletedBy: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     */
    Sequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsSignaturePending` |
     * | Type | `Edm.Boolean` |
     */
    IsSignaturePending: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ScenarioInstanceId` |
     * | Type | `Edm.Guid` |
     */
    ScenarioInstanceId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Type` |
     * | Type | `Siemens.SimaticIT.OperationalData.WI_OP.OPModel.Types.ReadingModel.WorkInstructionStepType` |
     */
    Type: WorkInstructionStepType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsCompleted` |
     * | Type | `Edm.Boolean` |
     */
    IsCompleted: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionSection_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkInstructionSection_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ScenarioConfiguration` |
     * | Type | `Siemens.SimaticIT.MasterData.ES_MS.MSModel.Types.ReadingModel.ScenarioConfigurationValueType_Siemens_SimaticIT_MasterData_ES_MS_MSModel_Types` |
     * | Nullable | `false` |
     */
    ScenarioConfiguration: ScenarioConfigurationValueType_Siemens_SimaticIT_MasterData_ES_MS_MSModel_Types;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Items` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkInstructionStepItem)` |
     */
    Items?: Array<WorkInstructionStepItem>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionSection` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkInstructionSection` |
     */
    WorkInstructionSection?: WorkInstructionSection | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkInstructionStepFacet)` |
     */
    Facets?: Array<WorkInstructionStepFacet>;
}

export type WorkInstructionStepId = string | {Id: string};

export interface WorkInstructionSection {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Title` |
     * | Type | `Edm.String` |
     */
    Title: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CompletedBy` |
     * | Type | `Edm.String` |
     */
    CompletedBy: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     */
    Sequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsCompleted` |
     * | Type | `Edm.Boolean` |
     */
    IsCompleted: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstruction_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkInstruction_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Steps` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkInstructionStep)` |
     */
    Steps?: Array<WorkInstructionStep>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstruction` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkInstruction` |
     */
    WorkInstruction?: WorkInstruction | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkInstructionSectionFacet)` |
     */
    Facets?: Array<WorkInstructionSectionFacet>;
}

export type WorkInstructionSectionId = string | {Id: string};

export interface WorkInstructionParameter {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterValue` |
     * | Type | `Edm.String` |
     */
    ParameterValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterUoMNId` |
     * | Type | `Edm.String` |
     */
    ParameterUoMNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsReadOnly` |
     * | Type | `Edm.Boolean` |
     */
    IsReadOnly: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Direction` |
     * | Type | `Siemens.SimaticIT.MasterData.WI_MS.MSModel.Types.ReadingModel.WorkInstructionDefinitionParameterDirection` |
     */
    Direction: WorkInstructionDefinitionParameterDirection | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterType` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.SupportedTypes` |
     */
    ParameterType: SupportedTypes | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstruction_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkInstruction_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstruction` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkInstruction` |
     */
    WorkInstruction?: WorkInstruction | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkInstructionParameterFacet)` |
     */
    Facets?: Array<WorkInstructionParameterFacet>;
}

export type WorkInstructionParameterId = string | {Id: string};

export interface WorkInstruction {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionDefinitionNId` |
     * | Type | `Edm.String` |
     */
    WorkInstructionDefinitionNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionDefinitionRevision` |
     * | Type | `Edm.String` |
     */
    WorkInstructionDefinitionRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsReEditEnabled` |
     * | Type | `Edm.Boolean` |
     */
    IsReEditEnabled: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Design` |
     * | Type | `Siemens.SimaticIT.MasterData.WI_MS.MSModel.Types.ReadingModel.WorkInstructionDesignValueType_Siemens_SimaticIT_MasterData_WI_MS_MSModel_Types` |
     * | Nullable | `false` |
     */
    Design: WorkInstructionDesignValueType_Siemens_SimaticIT_MasterData_WI_MS_MSModel_Types;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.StatusType` |
     * | Nullable | `false` |
     */
    Status: StatusType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sections` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkInstructionSection)` |
     */
    Sections?: Array<WorkInstructionSection>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Parameters` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkInstructionParameter)` |
     */
    Parameters?: Array<WorkInstructionParameter>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkInstructionFacet)` |
     */
    Facets?: Array<WorkInstructionFacet>;
}

export type WorkInstructionId = string | {Id: string};

export interface WorkInstructionDefinitionToOperationAssociation {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `HideOnExecGroup` |
     * | Type | `Edm.Boolean` |
     */
    HideOnExecGroup: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionAssociationType_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkInstructionAssociationType_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionDefinition_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkInstructionDefinition_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Operation_Id` |
     * | Type | `Edm.Guid` |
     */
    Operation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionAssociationType` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkInstructionAssociationType` |
     */
    WorkInstructionAssociationType?: WorkInstructionAssociationType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionDefinition` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkInstructionDefinition` |
     */
    WorkInstructionDefinition?: WorkInstructionDefinition | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Operation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Operation` |
     */
    Operation?: Operation | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkInstructionDefinitionToOperationAssociationFacet)` |
     */
    Facets?: Array<WorkInstructionDefinitionToOperationAssociationFacet>;
}

export type WorkInstructionDefinitionToOperationAssociationId = string | {Id: string};

export interface WorkInstructionTemplateParameter {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterValue` |
     * | Type | `Edm.String` |
     */
    ParameterValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterUoMNId` |
     * | Type | `Edm.String` |
     */
    ParameterUoMNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Direction` |
     * | Type | `Siemens.SimaticIT.MasterData.WI_MS.MSModel.Types.ReadingModel.WorkInstructionDefinitionParameterDirection` |
     */
    Direction: WorkInstructionDefinitionParameterDirection | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsReadOnly` |
     * | Type | `Edm.Boolean` |
     */
    IsReadOnly: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterType` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.SupportedTypes` |
     */
    ParameterType: SupportedTypes | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionTemplate_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkInstructionTemplate_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionTemplate` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkInstructionTemplate` |
     */
    WorkInstructionTemplate?: WorkInstructionTemplate | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkInstructionTemplateParameterFacet)` |
     */
    Facets?: Array<WorkInstructionTemplateParameterFacet>;
}

export type WorkInstructionTemplateParameterId = string | {Id: string};

export interface WorkInstructionTemplate {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsSystemDefined` |
     * | Type | `Edm.Boolean` |
     */
    IsSystemDefined: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsDefault` |
     * | Type | `Edm.Boolean` |
     */
    IsDefault: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionTemplateParameters` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkInstructionTemplateParameter)` |
     */
    WorkInstructionTemplateParameters?: Array<WorkInstructionTemplateParameter>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkInstructionTemplateFacet)` |
     */
    Facets?: Array<WorkInstructionTemplateFacet>;
}

export type WorkInstructionTemplateId = string | {Id: string};

export interface WorkInstructionDefinitionParameter {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterUoMNId` |
     * | Type | `Edm.String` |
     */
    ParameterUoMNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterValue` |
     * | Type | `Edm.String` |
     */
    ParameterValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Direction` |
     * | Type | `Siemens.SimaticIT.MasterData.WI_MS.MSModel.Types.ReadingModel.WorkInstructionDefinitionParameterDirection` |
     */
    Direction: WorkInstructionDefinitionParameterDirection | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsReadOnly` |
     * | Type | `Edm.Boolean` |
     */
    IsReadOnly: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterType` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.SupportedTypes` |
     */
    ParameterType: SupportedTypes | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionDefinition_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkInstructionDefinition_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionDefinition` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkInstructionDefinition` |
     */
    WorkInstructionDefinition?: WorkInstructionDefinition | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkInstructionDefinitionParameterFacet)` |
     */
    Facets?: Array<WorkInstructionDefinitionParameterFacet>;
}

export type WorkInstructionDefinitionParameterId = string | {Id: string};

export interface WorkInstructionDefinition {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     */
    Revision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceRevision` |
     * | Type | `Edm.String` |
     */
    SourceRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsCurrent` |
     * | Type | `Edm.Boolean` |
     */
    IsCurrent: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsExecutable` |
     * | Type | `Edm.Boolean` |
     */
    IsExecutable: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionTemplateNId` |
     * | Type | `Edm.String` |
     */
    WorkInstructionTemplateNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Design` |
     * | Type | `Siemens.SimaticIT.MasterData.WI_MS.MSModel.Types.ReadingModel.WorkInstructionDesignValueType_Siemens_SimaticIT_MasterData_WI_MS_MSModel_Types` |
     * | Nullable | `false` |
     */
    Design: WorkInstructionDesignValueType_Siemens_SimaticIT_MasterData_WI_MS_MSModel_Types;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Parameters` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkInstructionDefinitionParameter)` |
     */
    Parameters?: Array<WorkInstructionDefinitionParameter>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkInstructionDefinitionFacet)` |
     */
    Facets?: Array<WorkInstructionDefinitionFacet>;
}

export type WorkInstructionDefinitionId = string | {Id: string};

export interface NumberingPattern {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityTypeNId` |
     * | Type | `Edm.String` |
     */
    EntityTypeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DestinationProperty` |
     * | Type | `Edm.String` |
     */
    DestinationProperty: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NumberingPatternParts` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NumberingPatternPart)` |
     */
    NumberingPatternParts?: Array<NumberingPatternPart>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NumberingPatternFacet)` |
     */
    Facets?: Array<NumberingPatternFacet>;
}

export type NumberingPatternId = string | {Id: string};

export interface NumberingPatternParameter {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NumberingPatternEntity_Id` |
     * | Type | `Edm.Guid` |
     */
    NumberingPatternEntity_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NumberingPatternEntity` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NumberingPatternEntity` |
     */
    NumberingPatternEntity?: NumberingPatternEntity | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NumberingPatternParameterFacet)` |
     */
    Facets?: Array<NumberingPatternParameterFacet>;
}

export type NumberingPatternParameterId = string | {Id: string};

export interface NumberingPatternPart {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Constant` |
     * | Type | `Edm.String` |
     */
    Constant: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Timestamp` |
     * | Type | `Edm.String` |
     */
    Timestamp: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterNId` |
     * | Type | `Edm.String` |
     */
    ParameterNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RegularExpression` |
     * | Type | `Edm.String` |
     */
    RegularExpression: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CustomPart` |
     * | Type | `Edm.String` |
     */
    CustomPart: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     */
    Sequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NumberingPattern_Id` |
     * | Type | `Edm.Guid` |
     */
    NumberingPattern_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Counter_Id` |
     * | Type | `Edm.Guid` |
     */
    Counter_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NumberingPattern` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NumberingPattern` |
     */
    NumberingPattern?: NumberingPattern | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Counter` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Counter` |
     */
    Counter?: Counter | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NumberingPatternPartFacet)` |
     */
    Facets?: Array<NumberingPatternPartFacet>;
}

export type NumberingPatternPartId = string | {Id: string};

export interface NumberingPatternEntity {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NumberingPatternEntityDescriptor` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NumberingPatternEntityInfo)` |
     */
    NumberingPatternEntityDescriptor?: Array<NumberingPatternEntityInfo>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NumberingPatternParamenters` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NumberingPatternParameter)` |
     */
    NumberingPatternParamenters?: Array<NumberingPatternParameter>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NumberingPatternEntityFacet)` |
     */
    Facets?: Array<NumberingPatternEntityFacet>;
}

export type NumberingPatternEntityId = string | {Id: string};

export interface Counter {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Seed` |
     * | Type | `Edm.Int64` |
     */
    Seed: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Increment` |
     * | Type | `Edm.Int64` |
     */
    Increment: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaxValue` |
     * | Type | `Edm.Int64` |
     */
    MaxValue: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LeadingZeros` |
     * | Type | `Edm.Boolean` |
     */
    LeadingZeros: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TimeBasedReset` |
     * | Type | `Edm.String` |
     */
    TimeBasedReset: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsTransactional` |
     * | Type | `Edm.Boolean` |
     */
    IsTransactional: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsHidden` |
     * | Type | `Edm.Boolean` |
     */
    IsHidden: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NumberingPatternParts` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NumberingPatternPart)` |
     */
    NumberingPatternParts?: Array<NumberingPatternPart>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.CounterFacet)` |
     */
    Facets?: Array<CounterFacet>;
}

export type CounterId = string | {Id: string};

export interface LogisticWhitelist {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContainedEntityType` |
     * | Type | `Edm.String` |
     */
    ContainedEntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContainerEntityType` |
     * | Type | `Edm.String` |
     */
    ContainerEntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolDefinition_Id` |
     * | Type | `Edm.Guid` |
     */
    ToolDefinition_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DMMaterial_Id` |
     * | Type | `Edm.Guid` |
     */
    DMMaterial_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CapacityType_Id` |
     * | Type | `Edm.Guid` |
     */
    CapacityType_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogisticClass_Id` |
     * | Type | `Edm.Guid` |
     */
    LogisticClass_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BufferDefinition_Id` |
     * | Type | `Edm.Guid` |
     */
    BufferDefinition_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaxQty` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.QuantityType` |
     * | Nullable | `false` |
     */
    MaxQty: QuantityType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaxWeight` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.QuantityType` |
     * | Nullable | `false` |
     */
    MaxWeight: QuantityType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaxVolume` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.QuantityType` |
     * | Nullable | `false` |
     */
    MaxVolume: QuantityType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Min` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.QuantityType` |
     * | Nullable | `false` |
     */
    Min: QuantityType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Target` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.QuantityType` |
     * | Nullable | `false` |
     */
    Target: QuantityType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Treshold` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.QuantityType` |
     * | Nullable | `false` |
     */
    Treshold: QuantityType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolDefinition` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToolDefinition` |
     */
    ToolDefinition?: ToolDefinition | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DMMaterial` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DM_Material` |
     */
    DMMaterial?: DM_Material | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CapacityType` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.CapacityType` |
     */
    CapacityType?: CapacityType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogisticClass` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.LogisticClass` |
     */
    LogisticClass?: LogisticClass | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BufferDefinition` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.BufferDefinition` |
     */
    BufferDefinition?: BufferDefinition | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.LogisticWhitelistFacet)` |
     */
    Facets?: Array<LogisticWhitelistFacet>;
}

export type LogisticWhitelistId = string | {Id: string};

export interface LogisticClass {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.LogisticClassFacet)` |
     */
    Facets?: Array<LogisticClassFacet>;
}

export type LogisticClassId = string | {Id: string};

export interface CapacityType {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CapacityTypes` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Buffer)` |
     */
    CapacityTypes?: Array<Buffer>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.CapacityTypeFacet)` |
     */
    Facets?: Array<CapacityTypeFacet>;
}

export type CapacityTypeId = string | {Id: string};

export interface BufferDefinition {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Version` |
     * | Type | `Edm.String` |
     */
    Version: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsValid` |
     * | Type | `Edm.Boolean` |
     */
    IsValid: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CapacityType_Id` |
     * | Type | `Edm.Guid` |
     */
    CapacityType_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaxQty` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.QuantityType` |
     * | Nullable | `false` |
     */
    MaxQty: QuantityType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaxWeight` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.QuantityType` |
     * | Nullable | `false` |
     */
    MaxWeight: QuantityType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaxVolume` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.QuantityType` |
     * | Nullable | `false` |
     */
    MaxVolume: QuantityType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BufferDefinitions` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Buffer)` |
     */
    BufferDefinitions?: Array<Buffer>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CapacityType` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.CapacityType` |
     */
    CapacityType?: CapacityType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.BufferDefinitionFacet)` |
     */
    Facets?: Array<BufferDefinitionFacet>;
}

export type BufferDefinitionId = string | {Id: string};

export interface UoMFactor {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `K0Multiplier` |
     * | Type | `Edm.Decimal` |
     */
    K0Multiplier: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Addend` |
     * | Type | `Edm.Decimal` |
     */
    Addend: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `K1Multiplier` |
     * | Type | `Edm.Decimal` |
     */
    K1Multiplier: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Exponent` |
     * | Type | `Edm.Int16` |
     */
    Exponent: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsHidden` |
     * | Type | `Edm.Boolean` |
     */
    IsHidden: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsSystemDefined` |
     * | Type | `Edm.Boolean` |
     */
    IsSystemDefined: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetUoM_Id` |
     * | Type | `Edm.Guid` |
     */
    TargetUoM_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceUoM_Id` |
     * | Type | `Edm.Guid` |
     */
    SourceUoM_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetUoM` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.UoM` |
     */
    TargetUoM?: UoM | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceUoM` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.UoM` |
     */
    SourceUoM?: UoM | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.UoMFactorFacet)` |
     */
    Facets?: Array<UoMFactorFacet>;
}

export type UoMFactorId = string | {Id: string};

export interface UoMDimension {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsHidden` |
     * | Type | `Edm.Boolean` |
     */
    IsHidden: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsSystemDefined` |
     * | Type | `Edm.Boolean` |
     */
    IsSystemDefined: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoMs` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.UoM)` |
     */
    UoMs?: Array<UoM>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.UoMDimensionFacet)` |
     */
    Facets?: Array<UoMDimensionFacet>;
}

export type UoMDimensionId = string | {Id: string};

export interface UoM {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsHidden` |
     * | Type | `Edm.Boolean` |
     */
    IsHidden: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsSystemDefined` |
     * | Type | `Edm.Boolean` |
     */
    IsSystemDefined: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoMDimension_Id` |
     * | Type | `Edm.Guid` |
     */
    UoMDimension_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoMBase_Id` |
     * | Type | `Edm.Guid` |
     */
    UoMBase_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TUoMFactors` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.UoMFactor)` |
     */
    TUoMFactors?: Array<UoMFactor>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SUoMFactors` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.UoMFactor)` |
     */
    SUoMFactors?: Array<UoMFactor>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoMDimension` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.UoMDimension` |
     */
    UoMDimension?: UoMDimension | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoMBase` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.UoM` |
     */
    UoMBase?: UoM | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoMsMultipleOrSubmultiple` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.UoM)` |
     */
    UoMsMultipleOrSubmultiple?: Array<UoM>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.UoMFacet)` |
     */
    Facets?: Array<UoMFacet>;
}

export type UoMId = string | {Id: string};

export interface StatusTransitionDefinition {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Verb` |
     * | Type | `Edm.String` |
     */
    Verb: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsHidden` |
     * | Type | `Edm.Boolean` |
     */
    IsHidden: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsSystemDefined` |
     * | Type | `Edm.Boolean` |
     */
    IsSystemDefined: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.StatusTransitionDefinitionFacet)` |
     */
    Facets?: Array<StatusTransitionDefinitionFacet>;
}

export type StatusTransitionDefinitionId = string | {Id: string};

export interface StatusTransition {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Verb` |
     * | Type | `Edm.String` |
     */
    Verb: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DoRaiseEvent` |
     * | Type | `Edm.Boolean` |
     */
    DoRaiseEvent: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsHidden` |
     * | Type | `Edm.Boolean` |
     */
    IsHidden: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsSystemDefined` |
     * | Type | `Edm.Boolean` |
     */
    IsSystemDefined: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetStatus_Id` |
     * | Type | `Edm.Guid` |
     */
    TargetStatus_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceStatus_Id` |
     * | Type | `Edm.Guid` |
     */
    SourceStatus_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetStatus` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Status` |
     */
    TargetStatus?: Status | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceStatus` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Status` |
     */
    SourceStatus?: Status | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.StatusTransitionFacet)` |
     */
    Facets?: Array<StatusTransitionFacet>;
}

export type StatusTransitionId = string | {Id: string};

export interface StatusDefinition {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Color` |
     * | Type | `Edm.String` |
     */
    Color: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsHidden` |
     * | Type | `Edm.Boolean` |
     */
    IsHidden: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsSystemDefined` |
     * | Type | `Edm.Boolean` |
     */
    IsSystemDefined: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Outcome` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.StatusesOutcome` |
     */
    Outcome: StatusesOutcome | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.StatusDefinitionFacet)` |
     */
    Facets?: Array<StatusDefinitionFacet>;
}

export type StatusDefinitionId = string | {Id: string};

export interface StatusBehaviorDefinition {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Statuses` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Status)` |
     */
    Statuses?: Array<Status>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.StatusBehaviorDefinitionFacet)` |
     */
    Facets?: Array<StatusBehaviorDefinitionFacet>;
}

export type StatusBehaviorDefinitionId = string | {Id: string};

export interface Status {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Color` |
     * | Type | `Edm.String` |
     */
    Color: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsHidden` |
     * | Type | `Edm.Boolean` |
     */
    IsHidden: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsSystemDefined` |
     * | Type | `Edm.Boolean` |
     */
    IsSystemDefined: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsInitial` |
     * | Type | `Edm.Boolean` |
     */
    IsInitial: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Outcome` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.StatusesOutcome` |
     */
    Outcome: StatusesOutcome | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StateMachine_Id` |
     * | Type | `Edm.Guid` |
     */
    StateMachine_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceStatusTransitions` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.StatusTransition)` |
     */
    SourceStatusTransitions?: Array<StatusTransition>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetStatusTransitions` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.StatusTransition)` |
     */
    TargetStatusTransitions?: Array<StatusTransition>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StatusBehaviorDefinitions` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.StatusBehaviorDefinition)` |
     */
    StatusBehaviorDefinitions?: Array<StatusBehaviorDefinition>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StateMachine` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.StateMachine` |
     */
    StateMachine?: StateMachine | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.StatusFacet)` |
     */
    Facets?: Array<StatusFacet>;
}

export type StatusId = string | {Id: string};

export interface StateMachine {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsHidden` |
     * | Type | `Edm.Boolean` |
     */
    IsHidden: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsSystemDefined` |
     * | Type | `Edm.Boolean` |
     */
    IsSystemDefined: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Statuses` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Status)` |
     */
    Statuses?: Array<Status>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.StateMachineFacet)` |
     */
    Facets?: Array<StateMachineFacet>;
}

export type StateMachineId = string | {Id: string};

export interface UserPlantAssociation {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserId` |
     * | Type | `Edm.String` |
     */
    UserId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Plant` |
     * | Type | `Edm.String` |
     */
    Plant: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Date` |
     * | Type | `Edm.DateTimeOffset` |
     */
    Date: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.UserPlantAssociationFacet)` |
     */
    Facets?: Array<UserPlantAssociationFacet>;
}

export type UserPlantAssociationId = string | {Id: string};

export interface MasterPlan {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.String` |
     */
    CorrelationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UId` |
     * | Type | `Edm.String` |
     */
    UId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Completed` |
     * | Type | `Edm.Boolean` |
     */
    Completed: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SpecializedSpecificationSet` |
     * | Type | `Edm.Boolean` |
     */
    SpecializedSpecificationSet: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CertificationSpecification` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.CertificationSpecification)` |
     */
    CertificationSpecification?: Array<CertificationSpecification>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `InspectionSpecification` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.InspectionSpecification)` |
     */
    InspectionSpecification?: Array<InspectionSpecification>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationToStepLinks` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.OperationToStepLink)` |
     */
    OperationToStepLinks?: Array<OperationToStepLink>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessToProcessLinks` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ProcessToProcessLink)` |
     */
    ProcessToProcessLinks?: Array<ProcessToProcessLink>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessToOperationLinks` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ProcessToOperationLink)` |
     */
    ProcessToOperationLinks?: Array<ProcessToOperationLink>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StepDependencies` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.StepDependency)` |
     */
    StepDependencies?: Array<StepDependency>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Processes` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Process)` |
     */
    Processes?: Array<Process>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationDependencies` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.OperationDependency)` |
     */
    OperationDependencies?: Array<OperationDependency>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialSpecification` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.MaterialSpecification)` |
     */
    MaterialSpecification?: Array<MaterialSpecification>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentSpecification` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentSpecification)` |
     */
    EquipmentSpecification?: Array<EquipmentSpecification>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolSpecification` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToolSpecification)` |
     */
    ToolSpecification?: Array<ToolSpecification>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.MasterPlanFacet)` |
     */
    Facets?: Array<MasterPlanFacet>;
}

export type MasterPlanId = string | {Id: string};

export interface Skill_BOP {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Color` |
     * | Type | `Edm.String` |
     */
    Color: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Skill_Step` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderStepSkill)` |
     */
    Skill_Step?: Array<WorkOrderStepSkill>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StepSkills` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.StepSkill)` |
     */
    StepSkills?: Array<StepSkill>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TeamSkill` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.TeamSkillAssociation)` |
     */
    TeamSkill?: Array<TeamSkillAssociation>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Skill` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderOperationSkill)` |
     */
    Skill?: Array<WorkOrderOperationSkill>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationSkill` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.OperationSkill)` |
     */
    OperationSkill?: Array<OperationSkill>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SkillId` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.SkillCertificationAssociation)` |
     */
    SkillId?: Array<SkillCertificationAssociation>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Skill_BOPFacet)` |
     */
    Facets?: Array<Skill_BOPFacet>;
}

export type Skill_BOPId = string | {Id: string};

export interface OperationToStepLink {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.String` |
     */
    CorrelationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     */
    Sequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UId` |
     * | Type | `Edm.String` |
     */
    UId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EffectivityExpression` |
     * | Type | `Edm.String` |
     */
    EffectivityExpression: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCollectedDocument` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCollectedDocument: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentOperation_Id` |
     * | Type | `Edm.Guid` |
     */
    ParentOperation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChildStep_Id` |
     * | Type | `Edm.Guid` |
     */
    ChildStep_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBOP_Id` |
     * | Type | `Edm.Guid` |
     */
    AsPlannedBOP_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlan_Id` |
     * | Type | `Edm.Guid` |
     */
    MasterPlan_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentOperation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Operation` |
     */
    ParentOperation?: Operation | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChildStep` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Step` |
     */
    ChildStep?: Step | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBOP` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.AsPlannedBOP` |
     */
    AsPlannedBOP?: AsPlannedBOP | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlan` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.MasterPlan` |
     */
    MasterPlan?: MasterPlan | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToStepDependency` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.StepDependency)` |
     */
    ToStepDependency?: Array<StepDependency>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FromStepDependency` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.StepDependency)` |
     */
    FromStepDependency?: Array<StepDependency>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.OperationToStepLinkFacet)` |
     */
    Facets?: Array<OperationToStepLinkFacet>;
}

export type OperationToStepLinkId = string | {Id: string};

export interface ProcessToProcessLink {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.String` |
     */
    CorrelationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UId` |
     * | Type | `Edm.String` |
     */
    UId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     */
    Sequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EffectivityExpression` |
     * | Type | `Edm.String` |
     */
    EffectivityExpression: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBOP_Id` |
     * | Type | `Edm.Guid` |
     */
    AsPlannedBOP_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlan_Id` |
     * | Type | `Edm.Guid` |
     */
    MasterPlan_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentProcess_Id` |
     * | Type | `Edm.Guid` |
     */
    ParentProcess_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChildProcess_Id` |
     * | Type | `Edm.Guid` |
     */
    ChildProcess_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBOP` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.AsPlannedBOP` |
     */
    AsPlannedBOP?: AsPlannedBOP | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlan` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.MasterPlan` |
     */
    MasterPlan?: MasterPlan | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentProcess` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Process` |
     */
    ParentProcess?: Process | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChildProcess` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Process` |
     */
    ChildProcess?: Process | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ProcessToProcessLinkFacet)` |
     */
    Facets?: Array<ProcessToProcessLinkFacet>;
}

export type ProcessToProcessLinkId = string | {Id: string};

export interface ProcessToOperationLink {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.String` |
     */
    CorrelationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     */
    Sequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UId` |
     * | Type | `Edm.String` |
     */
    UId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EffectivityExpression` |
     * | Type | `Edm.String` |
     */
    EffectivityExpression: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentProcess_Id` |
     * | Type | `Edm.Guid` |
     */
    ParentProcess_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChildOperation_Id` |
     * | Type | `Edm.Guid` |
     */
    ChildOperation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBOP_Id` |
     * | Type | `Edm.Guid` |
     */
    AsPlannedBOP_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlan_Id` |
     * | Type | `Edm.Guid` |
     */
    MasterPlan_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentProcess` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Process` |
     */
    ParentProcess?: Process | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChildOperation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Operation` |
     */
    ChildOperation?: Operation | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBOP` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.AsPlannedBOP` |
     */
    AsPlannedBOP?: AsPlannedBOP | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlan` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.MasterPlan` |
     */
    MasterPlan?: MasterPlan | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DependencyLinkFrom` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.OperationDependency)` |
     */
    DependencyLinkFrom?: Array<OperationDependency>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DependencyLinkTo` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.OperationDependency)` |
     */
    DependencyLinkTo?: Array<OperationDependency>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ProcessToOperationLinkFacet)` |
     */
    Facets?: Array<ProcessToOperationLinkFacet>;
}

export type ProcessToOperationLinkId = string | {Id: string};

export interface OperationSkill {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Level` |
     * | Type | `Edm.Int32` |
     */
    Level: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Operation_Id` |
     * | Type | `Edm.Guid` |
     */
    Operation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Skill_Id` |
     * | Type | `Edm.Guid` |
     */
    Skill_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Operation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Operation` |
     */
    Operation?: Operation | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Skill` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Skill_BOP` |
     */
    Skill?: Skill_BOP | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.OperationSkillFacet)` |
     */
    Facets?: Array<OperationSkillFacet>;
}

export type OperationSkillId = string | {Id: string};

export interface ProducedMaterialUnderRework {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItemStatusOnWOOp` |
     * | Type | `Edm.String` |
     */
    MaterialItemStatusOnWOOp: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PartialQuantity` |
     * | Type | `Edm.Decimal` |
     */
    PartialQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CompletedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    CompletedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReworkOrder_Id` |
     * | Type | `Edm.Guid` |
     */
    ReworkOrder_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnit_Id` |
     * | Type | `Edm.Guid` |
     */
    DM_MaterialTrackingUnit_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.QuantityType` |
     * | Nullable | `false` |
     */
    Quantity: QuantityType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReworkOrder` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrder` |
     */
    ReworkOrder?: WorkOrder | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderOperation` |
     */
    WorkOrderOperation?: WorkOrderOperation | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnit` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DM_MaterialTrackingUnit` |
     */
    DM_MaterialTrackingUnit?: DM_MaterialTrackingUnit | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ProducedMaterialUnderReworkFacet)` |
     */
    Facets?: Array<ProducedMaterialUnderReworkFacet>;
}

export type ProducedMaterialUnderReworkId = string | {Id: string};

export interface SnagAndNoteNotification {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SnagAndNoteId` |
     * | Type | `Edm.Guid` |
     */
    SnagAndNoteId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.SnagAndNoteNotificationFacet)` |
     */
    Facets?: Array<SnagAndNoteNotificationFacet>;
}

export type SnagAndNoteNotificationId = string | {Id: string};

export interface NonConformanceStatusBehavior {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsScrap` |
     * | Type | `Edm.Boolean` |
     */
    IsScrap: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLock` |
     * | Type | `Edm.Boolean` |
     */
    IsLock: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsClosedOk` |
     * | Type | `Edm.Boolean` |
     */
    IsClosedOk: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsRuntimeFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsRuntimeFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsSetWckHold` |
     * | Type | `Edm.Boolean` |
     */
    IsSetWckHold: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceStatus_Id` |
     * | Type | `Edm.Guid` |
     */
    NonConformanceStatus_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceLifecycle_Id` |
     * | Type | `Edm.Guid` |
     */
    NonConformanceLifecycle_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceStatus` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NonConformanceStatus` |
     */
    NonConformanceStatus?: NonConformanceStatus | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceLifecycle` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NonConformanceLifecycle` |
     */
    NonConformanceLifecycle?: NonConformanceLifecycle | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NonConformanceStatusBehaviorFacet)` |
     */
    Facets?: Array<NonConformanceStatusBehaviorFacet>;
}

export type NonConformanceStatusBehaviorId = string | {Id: string};

export interface NonConformanceItem {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceSupervisor` |
     * | Type | `Edm.Guid` |
     */
    NonConformanceSupervisor: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Equipment` |
     * | Type | `Edm.String` |
     */
    Equipment: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Tool_Id` |
     * | Type | `Edm.Guid` |
     */
    Tool_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformance_Id` |
     * | Type | `Edm.Guid` |
     */
    NonConformance_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnit_Id` |
     * | Type | `Edm.Guid` |
     */
    DM_MaterialTrackingUnit_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Tool` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Tool` |
     */
    Tool?: Tool | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformance` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NonConformance` |
     */
    NonConformance?: NonConformance | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnit` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DM_MaterialTrackingUnit` |
     */
    DM_MaterialTrackingUnit?: DM_MaterialTrackingUnit | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NonConformanceItemFacet)` |
     */
    Facets?: Array<NonConformanceItemFacet>;
}

export type NonConformanceItemId = string | {Id: string};

export interface ToBeConsumedMaterialPrekitHistory {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActionNId` |
     * | Type | `Edm.String` |
     */
    ActionNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DateHistory` |
     * | Type | `Edm.DateTimeOffset` |
     */
    DateHistory: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserId` |
     * | Type | `Edm.String` |
     */
    UserId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrder_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrder_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStep_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStep_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrekitDM_MaterialTrackingUnit_Id` |
     * | Type | `Edm.Guid` |
     */
    PrekitDM_MaterialTrackingUnit_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetMaterialItem_Id` |
     * | Type | `Edm.Guid` |
     */
    TargetMaterialItem_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrder` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrder` |
     */
    WorkOrder?: WorkOrder | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStep` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderStep` |
     */
    WorkOrderStep?: WorkOrderStep | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrekitDM_MaterialTrackingUnit` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DM_MaterialTrackingUnit` |
     */
    PrekitDM_MaterialTrackingUnit?: DM_MaterialTrackingUnit | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetMaterialItem` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DM_MaterialTrackingUnit` |
     */
    TargetMaterialItem?: DM_MaterialTrackingUnit | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderOperation` |
     */
    WorkOrderOperation?: WorkOrderOperation | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToBeConsumedMaterialPrekitHistoryFacet)` |
     */
    Facets?: Array<ToBeConsumedMaterialPrekitHistoryFacet>;
}

export type ToBeConsumedMaterialPrekitHistoryId = string | {Id: string};

export interface ToBeConsumedMaterialPrekit {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrekitSerialNumber` |
     * | Type | `Edm.String` |
     */
    PrekitSerialNumber: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PreKitBatchCode` |
     * | Type | `Edm.String` |
     */
    PreKitBatchCode: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeValidated` |
     * | Type | `Edm.Boolean` |
     */
    ToBeValidated: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeConsumedMaterial_Id` |
     * | Type | `Edm.Guid` |
     */
    ToBeConsumedMaterial_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnit_Id` |
     * | Type | `Edm.Guid` |
     */
    DM_MaterialTrackingUnit_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrekitMaterialItem_Id` |
     * | Type | `Edm.Guid` |
     */
    PrekitMaterialItem_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeConsumedMaterial` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToBeConsumedMaterial` |
     */
    ToBeConsumedMaterial?: ToBeConsumedMaterial | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnit` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DM_MaterialTrackingUnit` |
     */
    DM_MaterialTrackingUnit?: DM_MaterialTrackingUnit | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrekitMaterialItem` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DM_MaterialTrackingUnit` |
     */
    PrekitMaterialItem?: DM_MaterialTrackingUnit | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToBeConsumedMaterialPrekitFacet)` |
     */
    Facets?: Array<ToBeConsumedMaterialPrekitFacet>;
}

export type ToBeConsumedMaterialPrekitId = string | {Id: string};

export interface WorkOperationType {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Milestone` |
     * | Type | `Edm.Boolean` |
     */
    Milestone: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Optional` |
     * | Type | `Edm.Boolean` |
     */
    Optional: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Skippable` |
     * | Type | `Edm.Boolean` |
     */
    Skippable: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActiveOnlyOne` |
     * | Type | `Edm.Boolean` |
     */
    ActiveOnlyOne: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutoStart` |
     * | Type | `Edm.Boolean` |
     */
    AutoStart: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutoComplete` |
     * | Type | `Edm.Boolean` |
     */
    AutoComplete: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MachineAutoStart` |
     * | Type | `Edm.Boolean` |
     */
    MachineAutoStart: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MachineAutoComplete` |
     * | Type | `Edm.Boolean` |
     */
    MachineAutoComplete: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MachineAutoPause` |
     * | Type | `Edm.Boolean` |
     */
    MachineAutoPause: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CNC` |
     * | Type | `Edm.Boolean` |
     */
    CNC: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AM` |
     * | Type | `Edm.Boolean` |
     */
    AM: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FastOperationConfirmation` |
     * | Type | `Edm.Boolean` |
     */
    FastOperationConfirmation: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOperationTypeFacet)` |
     */
    Facets?: Array<WorkOperationTypeFacet>;
}

export type WorkOperationTypeId = string | {Id: string};

export interface ToolDefinitionCompatibleMachine {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeNId` |
     * | Type | `Edm.String` |
     */
    EquipmentTypeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationNId` |
     * | Type | `Edm.String` |
     */
    EquipmentConfigurationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolDefinition_Id` |
     * | Type | `Edm.Guid` |
     */
    ToolDefinition_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolDefinition` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToolDefinition` |
     */
    ToolDefinition?: ToolDefinition | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToolDefinitionCompatibleMachineFacet)` |
     */
    Facets?: Array<ToolDefinitionCompatibleMachineFacet>;
}

export type ToolDefinitionCompatibleMachineId = string | {Id: string};

export interface ToolDefinition {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.String` |
     */
    CorrelationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExpirationDate` |
     * | Type | `Edm.DateTimeOffset` |
     */
    ExpirationDate: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolClass` |
     * | Type | `Edm.Int32` |
     */
    ToolClass: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolClassNId` |
     * | Type | `Edm.String` |
     */
    ToolClassNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UId` |
     * | Type | `Edm.String` |
     */
    UId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UsageCounterMax` |
     * | Type | `Edm.Int32` |
     */
    UsageCounterMax: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UsageDurationMax` |
     * | Type | `Edm.Int64` |
     */
    UsageDurationMax: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Version` |
     * | Type | `Edm.String` |
     */
    Version: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Consumable` |
     * | Type | `Edm.Boolean` |
     */
    Consumable: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RevisionExpression` |
     * | Type | `Edm.String` |
     */
    RevisionExpression: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Volume` |
     * | Type | `Edm.Decimal` |
     */
    Volume: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `VolumeUoM` |
     * | Type | `Edm.String` |
     */
    VolumeUoM: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WeightUoM` |
     * | Type | `Edm.String` |
     */
    WeightUoM: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Weight` |
     * | Type | `Edm.Decimal` |
     */
    Weight: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Lockable` |
     * | Type | `Edm.Boolean` |
     */
    Lockable: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogisticClass_Id` |
     * | Type | `Edm.Guid` |
     */
    LogisticClass_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolDefinitionCompatibleMachine` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToolDefinitionCompatibleMachine)` |
     */
    ToolDefinitionCompatibleMachine?: Array<ToolDefinitionCompatibleMachine>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogisticClass` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.LogisticClass` |
     */
    LogisticClass?: LogisticClass | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToolDefinitionFacet)` |
     */
    Facets?: Array<ToolDefinitionFacet>;
}

export type ToolDefinitionId = string | {Id: string};

export interface Skill {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.SkillFacet)` |
     */
    Facets?: Array<SkillFacet>;
}

export type SkillId = string | {Id: string};

export interface ReworkCode {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialNId` |
     * | Type | `Edm.String` |
     */
    DM_MaterialNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessNId` |
     * | Type | `Edm.String` |
     */
    ProcessNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessRevision` |
     * | Type | `Edm.String` |
     */
    ProcessRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UId` |
     * | Type | `Edm.String` |
     */
    UId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FailureNId` |
     * | Type | `Edm.String` |
     */
    FailureNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessId_Id` |
     * | Type | `Edm.Guid` |
     */
    ProcessId_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefectGroup_Id` |
     * | Type | `Edm.Guid` |
     */
    DefectGroup_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefectType_Id` |
     * | Type | `Edm.Guid` |
     */
    DefectType_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessId` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Process` |
     */
    ProcessId?: Process | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefectGroup` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DefectGroup` |
     */
    DefectGroup?: DefectGroup | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefectType` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DefectType` |
     */
    DefectType?: DefectType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ReworkCodeFacet)` |
     */
    Facets?: Array<ReworkCodeFacet>;
}

export type ReworkCodeId = string | {Id: string};

export interface NonConformanceTransition {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Lifecycle` |
     * | Type | `Edm.String` |
     */
    Lifecycle: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MailAddressList` |
     * | Type | `Edm.String` |
     */
    MailAddressList: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AuthorizedRoleList` |
     * | Type | `Edm.String` |
     */
    AuthorizedRoleList: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SendMail` |
     * | Type | `Edm.Int16` |
     */
    SendMail: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FromStatus_Id` |
     * | Type | `Edm.Guid` |
     */
    FromStatus_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToStatus_Id` |
     * | Type | `Edm.Guid` |
     */
    ToStatus_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FromStatus` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NonConformanceStatus` |
     */
    FromStatus?: NonConformanceStatus | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToStatus` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NonConformanceStatus` |
     */
    ToStatus?: NonConformanceStatus | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NonConformanceTransitionFacet)` |
     */
    Facets?: Array<NonConformanceTransitionFacet>;
}

export type NonConformanceTransitionId = string | {Id: string};

export interface NonConformanceStatus {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NonConformanceStatusFacet)` |
     */
    Facets?: Array<NonConformanceStatusFacet>;
}

export type NonConformanceStatusId = string | {Id: string};

export interface NonConformanceSeverity {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Val` |
     * | Type | `Edm.Int32` |
     */
    Val: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NonConformanceSeverityFacet)` |
     */
    Facets?: Array<NonConformanceSeverityFacet>;
}

export type NonConformanceSeverityId = string | {Id: string};

export interface NonConformanceLifecycle {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Type` |
     * | Type | `Edm.String` |
     */
    Type: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `InitialStatus_Id` |
     * | Type | `Edm.Guid` |
     */
    InitialStatus_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `InitialStatus` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NonConformanceStatus` |
     */
    InitialStatus?: NonConformanceStatus | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NonConformanceLifecycleFacet)` |
     */
    Facets?: Array<NonConformanceLifecycleFacet>;
}

export type NonConformanceLifecycleId = string | {Id: string};

export interface DefectType {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Groups` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DefectGroup)` |
     */
    Groups?: Array<DefectGroup>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefectSpecifications` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DefectSpecification)` |
     */
    DefectSpecifications?: Array<DefectSpecification>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Defects` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NonConformanceHistory)` |
     */
    Defects?: Array<NonConformanceHistory>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DefectTypeFacet)` |
     */
    Facets?: Array<DefectTypeFacet>;
}

export type DefectTypeId = string | {Id: string};

export interface DefectSpecification {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContextNId` |
     * | Type | `Edm.String` |
     */
    ContextNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SpecificationType` |
     * | Type | `Edm.String` |
     */
    SpecificationType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SpecificationNId` |
     * | Type | `Edm.String` |
     */
    SpecificationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SpecificationTypeCode` |
     * | Type | `Edm.Int32` |
     */
    SpecificationTypeCode: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefectType_Id` |
     * | Type | `Edm.Guid` |
     */
    DefectType_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefectType` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DefectType` |
     */
    DefectType?: DefectType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DefectSpecificationFacet)` |
     */
    Facets?: Array<DefectSpecificationFacet>;
}

export type DefectSpecificationId = string | {Id: string};

export interface DefectGroupSpecification {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContextNId` |
     * | Type | `Edm.String` |
     */
    ContextNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SpecificationType` |
     * | Type | `Edm.String` |
     */
    SpecificationType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SpecificationNId` |
     * | Type | `Edm.String` |
     */
    SpecificationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SpecificationTypeCode` |
     * | Type | `Edm.Int32` |
     */
    SpecificationTypeCode: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefectGroup_Id` |
     * | Type | `Edm.Guid` |
     */
    DefectGroup_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefectGroup` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DefectGroup` |
     */
    DefectGroup?: DefectGroup | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DefectGroupSpecificationFacet)` |
     */
    Facets?: Array<DefectGroupSpecificationFacet>;
}

export type DefectGroupSpecificationId = string | {Id: string};

export interface DefectGroup {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Types` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DefectType)` |
     */
    Types?: Array<DefectType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefectGroupSpecifications` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DefectGroupSpecification)` |
     */
    DefectGroupSpecifications?: Array<DefectGroupSpecification>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentGroups` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DefectGroup)` |
     */
    ParentGroups?: Array<DefectGroup>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChildGroups` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DefectGroup)` |
     */
    ChildGroups?: Array<DefectGroup>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DefectGroupFacet)` |
     */
    Facets?: Array<DefectGroupFacet>;
}

export type DefectGroupId = string | {Id: string};

export interface WorkOStepDependency {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DependencyType` |
     * | Type | `Edm.String` |
     */
    DependencyType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `To_Id` |
     * | Type | `Edm.Guid` |
     */
    To_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WosFrom_Id` |
     * | Type | `Edm.Guid` |
     */
    WosFrom_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `To` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderStep` |
     */
    To?: WorkOrderStep | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WosFrom` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderStep` |
     */
    WosFrom?: WorkOrderStep | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOStepDependencyFacet)` |
     */
    Facets?: Array<WorkOStepDependencyFacet>;
}

export type WorkOStepDependencyId = string | {Id: string};

export interface WorkOrderStep {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualEndTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    ActualEndTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualStartTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    ActualStartTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignatureComplete` |
     * | Type | `Edm.Boolean` |
     */
    ElectronicSignatureComplete: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignaturePause` |
     * | Type | `Edm.Boolean` |
     */
    ElectronicSignaturePause: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignatureStart` |
     * | Type | `Edm.Boolean` |
     */
    ElectronicSignatureStart: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedEndTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedEndTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedStartTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedStartTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastPauseTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastPauseTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Optional` |
     * | Type | `Edm.Boolean` |
     */
    Optional: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PauseDuration` |
     * | Type | `Edm.Int64` |
     */
    PauseDuration: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Priority` |
     * | Type | `Edm.Int32` |
     */
    Priority: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RequiredCertificateNId` |
     * | Type | `Edm.String` |
     */
    RequiredCertificateNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RequiredInspectionRole` |
     * | Type | `Edm.String` |
     */
    RequiredInspectionRole: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     */
    Sequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Step` |
     * | Type | `Edm.Guid` |
     */
    Step: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StepNId` |
     * | Type | `Edm.String` |
     */
    StepNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StepRevision` |
     * | Type | `Edm.String` |
     */
    StepRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StepUId` |
     * | Type | `Edm.String` |
     */
    StepUId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WaitingForInspection` |
     * | Type | `Edm.Boolean` |
     */
    WaitingForInspection: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetQuantity` |
     * | Type | `Edm.Decimal` |
     */
    TargetQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AvailableQuantity` |
     * | Type | `Edm.Decimal` |
     */
    AvailableQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PartialWorkedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    PartialWorkedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    ProducedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCollectedDocument` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCollectedDocument: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NotWorkedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    NotWorkedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ScrappedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    ScrappedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReworkedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    ReworkedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedDuration_Ticks` |
     * | Type | `Edm.Int64` |
     */
    EstimatedDuration_Ticks: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedDuration` |
     * | Type | `Edm.Duration` |
     */
    EstimatedDuration: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionDuration_Ticks` |
     * | Type | `Edm.Int64` |
     */
    ExecutionDuration_Ticks: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionDuration` |
     * | Type | `Edm.Duration` |
     */
    ExecutionDuration: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsReady` |
     * | Type | `Edm.Boolean` |
     */
    IsReady: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationStepCategoryId_Id` |
     * | Type | `Edm.Guid` |
     */
    OperationStepCategoryId_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.StatusType` |
     * | Nullable | `false` |
     */
    Status: StatusType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderHumanResource` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderHumanResource)` |
     */
    WorkOrderHumanResource?: Array<WorkOrderHumanResource>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualCoProducedMaterials` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ActualCoProducedMaterial)` |
     */
    ActualCoProducedMaterials?: Array<ActualCoProducedMaterial>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCoProducedMaterials` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToBeCoProducedMaterial)` |
     */
    ToBeCoProducedMaterials?: Array<ToBeCoProducedMaterial>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepSkills` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderStepSkill)` |
     */
    WorkOrderStepSkills?: Array<WorkOrderStepSkill>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WIDefinitionToWOStepAssociation` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WIDefinitionToWOStepAssociation)` |
     */
    WIDefinitionToWOStepAssociation?: Array<WIDefinitionToWOStepAssociation>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionToWOStepAssociation` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkInstructionToWorkOrderStepAssociation)` |
     */
    WorkInstructionToWOStepAssociation?: Array<WorkInstructionToWorkOrderStepAssociation>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedInspection` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToBeUsedInspection)` |
     */
    ToBeUsedInspection?: Array<ToBeUsedInspection>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualUsedInspection` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ActualUsedInspection)` |
     */
    ActualUsedInspection?: Array<ActualUsedInspection>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckWOStepAssociations` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ItlkCheckWOStepAssociation)` |
     */
    ItlkCheckWOStepAssociations?: Array<ItlkCheckWOStepAssociation>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualCollectedDocuments` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ActualCollectedDocument)` |
     */
    ActualCollectedDocuments?: Array<ActualCollectedDocument>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Predecessors` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOStepDependency)` |
     */
    Predecessors?: Array<WorkOStepDependency>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Successors` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOStepDependency)` |
     */
    Successors?: Array<WorkOStepDependency>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationStepCategoryId` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.OperationStepCategory` |
     */
    OperationStepCategoryId?: OperationStepCategory | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderOperation` |
     */
    WorkOrderOperation?: WorkOrderOperation | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedTools` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToBeUsedTool)` |
     */
    ToBeUsedTools?: Array<ToBeUsedTool>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedDocuments` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToBeUsedDocument)` |
     */
    ToBeUsedDocuments?: Array<ToBeUsedDocument>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeProducedMaterials` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToBeProducedMaterial)` |
     */
    ToBeProducedMaterials?: Array<ToBeProducedMaterial>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeConsumedMaterials` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToBeConsumedMaterial)` |
     */
    ToBeConsumedMaterials?: Array<ToBeConsumedMaterial>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualUsedTools` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ActualUsedTool)` |
     */
    ActualUsedTools?: Array<ActualUsedTool>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualUsedMachines` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ActualUsedMachine)` |
     */
    ActualUsedMachines?: Array<ActualUsedMachine>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualProducedMaterials` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ActualProducedMaterial)` |
     */
    ActualProducedMaterials?: Array<ActualProducedMaterial>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualConsumedMaterials` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ActualConsumedMaterial)` |
     */
    ActualConsumedMaterials?: Array<ActualConsumedMaterial>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActiveUserOnMachines` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ActiveUserOnMachine)` |
     */
    ActiveUserOnMachines?: Array<ActiveUserOnMachine>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderStepFacet)` |
     */
    Facets?: Array<WorkOrderStepFacet>;
}

export type WorkOrderStepId = string | {Id: string};

export interface WorkOrderOperation {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActiveNonConformanceNr` |
     * | Type | `Edm.Int32` |
     */
    ActiveNonConformanceNr: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualEndTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    ActualEndTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualStartTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    ActualStartTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AvailableQuantity` |
     * | Type | `Edm.Decimal` |
     */
    AvailableQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignatureComplete` |
     * | Type | `Edm.Boolean` |
     */
    ElectronicSignatureComplete: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignaturePause` |
     * | Type | `Edm.Boolean` |
     */
    ElectronicSignaturePause: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignatureStart` |
     * | Type | `Edm.Boolean` |
     */
    ElectronicSignatureStart: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedEndTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedEndTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedStartTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedStartTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastPauseTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastPauseTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationNId` |
     * | Type | `Edm.String` |
     */
    OperationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationRevision` |
     * | Type | `Edm.String` |
     */
    OperationRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationUId` |
     * | Type | `Edm.String` |
     */
    OperationUId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PartialWorkedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    PartialWorkedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    ProducedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RequiredCertificateNId` |
     * | Type | `Edm.String` |
     */
    RequiredCertificateNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReworkedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    ReworkedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RequiredInspectionRole` |
     * | Type | `Edm.String` |
     */
    RequiredInspectionRole: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ScrappedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    ScrappedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetQuantity` |
     * | Type | `Edm.Decimal` |
     */
    TargetQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCollectedDocument` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCollectedDocument: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationOccurrenceUId` |
     * | Type | `Edm.String` |
     */
    OperationOccurrenceUId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ERPConfirmationId` |
     * | Type | `Edm.String` |
     */
    ERPConfirmationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedDuration_Ticks` |
     * | Type | `Edm.Int64` |
     */
    EstimatedDuration_Ticks: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedDuration` |
     * | Type | `Edm.Duration` |
     */
    EstimatedDuration: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionDuration_Ticks` |
     * | Type | `Edm.Int64` |
     */
    ExecutionDuration_Ticks: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionDuration` |
     * | Type | `Edm.Duration` |
     */
    ExecutionDuration: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PauseDuration_Ticks` |
     * | Type | `Edm.Int64` |
     */
    PauseDuration_Ticks: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PauseDuration` |
     * | Type | `Edm.Duration` |
     */
    PauseDuration: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsReady` |
     * | Type | `Edm.Boolean` |
     */
    IsReady: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Optional` |
     * | Type | `Edm.Boolean` |
     */
    Optional: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Priority` |
     * | Type | `Edm.Int32` |
     */
    Priority: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     */
    Sequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Skippable` |
     * | Type | `Edm.Boolean` |
     */
    Skippable: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WaitingForInspection` |
     * | Type | `Edm.Boolean` |
     */
    WaitingForInspection: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Operation_Id` |
     * | Type | `Edm.Guid` |
     */
    Operation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOperationType_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOperationType_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationStepCategoryId_Id` |
     * | Type | `Edm.Guid` |
     */
    OperationStepCategoryId_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrder_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrder_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.StatusType` |
     * | Nullable | `false` |
     */
    Status: StatusType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PreviousStatus` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.StatusType` |
     * | Nullable | `false` |
     */
    PreviousStatus: StatusType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedSetPointItemATNInstanceAssociations` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToBeUsedSetPointItemATNInstanceAssociation)` |
     */
    ToBeUsedSetPointItemATNInstanceAssociations?: Array<ToBeUsedSetPointItemATNInstanceAssociation>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderHumanResource` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderHumanResource)` |
     */
    WorkOrderHumanResource?: Array<WorkOrderHumanResource>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualCoProducedMaterials` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ActualCoProducedMaterial)` |
     */
    ActualCoProducedMaterials?: Array<ActualCoProducedMaterial>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCoProducedMaterials` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToBeCoProducedMaterial)` |
     */
    ToBeCoProducedMaterials?: Array<ToBeCoProducedMaterial>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AssociatedUsers` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.UserWorkOrderOperationAssociation)` |
     */
    AssociatedUsers?: Array<UserWorkOrderOperationAssociation>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedInspection` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToBeUsedInspection)` |
     */
    ToBeUsedInspection?: Array<ToBeUsedInspection>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualUsedInspection` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ActualUsedInspection)` |
     */
    ActualUsedInspection?: Array<ActualUsedInspection>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckWOOpAssociations` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ItlkCheckWOOpAssociation)` |
     */
    ItlkCheckWOOpAssociations?: Array<ItlkCheckWOOpAssociation>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationSkill` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderOperationSkill)` |
     */
    WorkOrderOperationSkill?: Array<WorkOrderOperationSkill>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualCollectedDocuments` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ActualCollectedDocument)` |
     */
    ActualCollectedDocuments?: Array<ActualCollectedDocument>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WIDefinitionToWOOperationAssociation` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WIDefinitionToWOOperationAssociation)` |
     */
    WIDefinitionToWOOperationAssociation?: Array<WIDefinitionToWOOperationAssociation>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupPhaseWOOAssociation` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ExecutionGroupPhaseWOOAssociation)` |
     */
    ExecutionGroupPhaseWOOAssociation?: Array<ExecutionGroupPhaseWOOAssociation>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionToWorkOOAssociation` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkInstructionToWorkOrderOperationAssociation)` |
     */
    WorkInstructionToWorkOOAssociation?: Array<WorkInstructionToWorkOrderOperationAssociation>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedMaterialUnderRework` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ProducedMaterialUnderRework)` |
     */
    ProducedMaterialUnderRework?: Array<ProducedMaterialUnderRework>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderSteps` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderStep)` |
     */
    WorkOrderSteps?: Array<WorkOrderStep>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Operation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Operation` |
     */
    Operation?: Operation | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOperationType` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOperationType` |
     */
    WorkOperationType?: WorkOperationType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationStepCategoryId` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.OperationStepCategory` |
     */
    OperationStepCategoryId?: OperationStepCategory | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrder` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrder` |
     */
    WorkOrder?: WorkOrder | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Successors` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOOperationDependency)` |
     */
    Successors?: Array<WorkOOperationDependency>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Predecessors` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOOperationDependency)` |
     */
    Predecessors?: Array<WorkOOperationDependency>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedTools` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToBeUsedTool)` |
     */
    ToBeUsedTools?: Array<ToBeUsedTool>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedMachines` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToBeUsedMachine)` |
     */
    ToBeUsedMachines?: Array<ToBeUsedMachine>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedDocuments` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToBeUsedDocument)` |
     */
    ToBeUsedDocuments?: Array<ToBeUsedDocument>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeProducedMaterials` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToBeProducedMaterial)` |
     */
    ToBeProducedMaterials?: Array<ToBeProducedMaterial>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeConsumedMaterials` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToBeConsumedMaterial)` |
     */
    ToBeConsumedMaterials?: Array<ToBeConsumedMaterial>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformances` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NonConformance)` |
     */
    NonConformances?: Array<NonConformance>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualUsedTools` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ActualUsedTool)` |
     */
    ActualUsedTools?: Array<ActualUsedTool>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualUsedMachines` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ActualUsedMachine)` |
     */
    ActualUsedMachines?: Array<ActualUsedMachine>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualProducedMaterials` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ActualProducedMaterial)` |
     */
    ActualProducedMaterials?: Array<ActualProducedMaterial>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualConsumedMaterials` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ActualConsumedMaterial)` |
     */
    ActualConsumedMaterials?: Array<ActualConsumedMaterial>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActiveUserOnMachines` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ActiveUserOnMachine)` |
     */
    ActiveUserOnMachines?: Array<ActiveUserOnMachine>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderOperationFacet)` |
     */
    Facets?: Array<WorkOrderOperationFacet>;
}

export type WorkOrderOperationId = string | {Id: string};

export interface WorkOrderHistoryMaterialItem {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderHistory_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderHistory_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnit_Id` |
     * | Type | `Edm.Guid` |
     */
    DM_MaterialTrackingUnit_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderHistory` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderHistory` |
     */
    WorkOrderHistory?: WorkOrderHistory | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnit` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DM_MaterialTrackingUnit` |
     */
    DM_MaterialTrackingUnit?: DM_MaterialTrackingUnit | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderHistoryMaterialItemFacet)` |
     */
    Facets?: Array<WorkOrderHistoryMaterialItemFacet>;
}

export type WorkOrderHistoryMaterialItemId = string | {Id: string};

export interface WorkOrderHistoryAction {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderHistoryActionFacet)` |
     */
    Facets?: Array<WorkOrderHistoryActionFacet>;
}

export type WorkOrderHistoryActionId = string | {Id: string};

export interface WorkOrderHistory {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Context` |
     * | Type | `Edm.String` |
     */
    Context: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DNCItem` |
     * | Type | `Edm.String` |
     */
    DNCItem: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Document` |
     * | Type | `Edm.String` |
     */
    Document: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Equipment` |
     * | Type | `Edm.String` |
     */
    Equipment: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Message` |
     * | Type | `Edm.String` |
     */
    Message: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFile` |
     * | Type | `Edm.String` |
     */
    PrintJobFile: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessUId` |
     * | Type | `Edm.String` |
     */
    ProcessUId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserId` |
     * | Type | `Edm.String` |
     */
    UserId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SerialNumber` |
     * | Type | `Edm.String` |
     */
    SerialNumber: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupPhaseId` |
     * | Type | `Edm.Guid` |
     */
    ExecutionGroupPhaseId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BaseLine` |
     * | Type | `Edm.String` |
     */
    BaseLine: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OldBaseLine` |
     * | Type | `Edm.String` |
     */
    OldBaseLine: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceWorkOrderNId` |
     * | Type | `Edm.String` |
     */
    SourceWorkOrderNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetWorkOrderNId` |
     * | Type | `Edm.String` |
     */
    TargetWorkOrderNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     */
    Status: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PartProgramName` |
     * | Type | `Edm.String` |
     */
    PartProgramName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Date` |
     * | Type | `Edm.DateTimeOffset` |
     */
    Date: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Team_Id` |
     * | Type | `Edm.Guid` |
     */
    Team_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Action_Id` |
     * | Type | `Edm.Guid` |
     */
    Action_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStep_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStep_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrder_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrder_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReferencedWorkOrderHistory_Id` |
     * | Type | `Edm.Guid` |
     */
    ReferencedWorkOrderHistory_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Team` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Team` |
     */
    Team?: Team | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Action` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderHistoryAction` |
     */
    Action?: WorkOrderHistoryAction | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderOperation` |
     */
    WorkOrderOperation?: WorkOrderOperation | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStep` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderStep` |
     */
    WorkOrderStep?: WorkOrderStep | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrder` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrder` |
     */
    WorkOrder?: WorkOrder | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReferencedWorkOrderHistory` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderHistory` |
     */
    ReferencedWorkOrderHistory?: WorkOrderHistory | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderHistoryFacet)` |
     */
    Facets?: Array<WorkOrderHistoryFacet>;
}

export type WorkOrderHistoryId = string | {Id: string};

export interface WorkOrder {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualEndTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    ActualEndTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualStartTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    ActualStartTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentBatch` |
     * | Type | `Edm.String` |
     */
    ParentBatch: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PBOPIdentID` |
     * | Type | `Edm.String` |
     */
    PBOPIdentID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Plant` |
     * | Type | `Edm.String` |
     */
    Plant: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlanned` |
     * | Type | `Edm.Guid` |
     */
    AsPlanned: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreationDate` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreationDate: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DueDate` |
     * | Type | `Edm.DateTimeOffset` |
     */
    DueDate: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Enterprise` |
     * | Type | `Edm.String` |
     */
    Enterprise: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ERPOrder` |
     * | Type | `Edm.String` |
     */
    ERPOrder: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedEndTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedEndTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedStartTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedStartTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `InitialQuantity` |
     * | Type | `Edm.Decimal` |
     */
    InitialQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessNId` |
     * | Type | `Edm.String` |
     */
    ProcessNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessRevision` |
     * | Type | `Edm.String` |
     */
    ProcessRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessUId` |
     * | Type | `Edm.String` |
     */
    ProcessUId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SchedulingDate` |
     * | Type | `Edm.DateTimeOffset` |
     */
    SchedulingDate: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     */
    Sequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ConfigurationParameter` |
     * | Type | `Edm.String` |
     */
    ConfigurationParameter: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RoutingID` |
     * | Type | `Edm.String` |
     */
    RoutingID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetProductID` |
     * | Type | `Edm.String` |
     */
    TargetProductID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PlannedTargetQuantity` |
     * | Type | `Edm.Decimal` |
     */
    PlannedTargetQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualTargetQuantity` |
     * | Type | `Edm.Decimal` |
     */
    ActualTargetQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetQuantity` |
     * | Type | `Edm.Decimal` |
     */
    TargetQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ConfirmationType` |
     * | Type | `Edm.String` |
     */
    ConfirmationType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RealInitialQty` |
     * | Type | `Edm.Decimal` |
     */
    RealInitialQty: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PoC` |
     * | Type | `Edm.Decimal` |
     */
    PoC: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Priority` |
     * | Type | `Edm.Int32` |
     */
    Priority: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsUnderScheduling` |
     * | Type | `Edm.Boolean` |
     */
    IsUnderScheduling: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    ProducedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReworkedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    ReworkedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ScrappedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    ScrappedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Process_Id` |
     * | Type | `Edm.Guid` |
     */
    Process_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FinalMaterial_Id` |
     * | Type | `Edm.Guid` |
     */
    FinalMaterial_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedBillOfFeature_Id` |
     * | Type | `Edm.Guid` |
     */
    ToBeUsedBillOfFeature_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReworkOfOrder_Id` |
     * | Type | `Edm.Guid` |
     */
    ReworkOfOrder_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentOrder_Id` |
     * | Type | `Edm.Guid` |
     */
    ParentOrder_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProductionType_Id` |
     * | Type | `Edm.Guid` |
     */
    ProductionType_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.StatusType` |
     * | Nullable | `false` |
     */
    Status: StatusType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PreviousStatus` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.StatusType` |
     * | Nullable | `false` |
     */
    PreviousStatus: StatusType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedBoM` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ReadingModel.BoMType_Siemens_SimaticIT_U4DM_OperationalData_Runtime_OPModel_Types` |
     * | Nullable | `false` |
     */
    ToBeUsedBoM: BoMType_Siemens_SimaticIT_U4DM_OperationalData_Runtime_OPModel_Types;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedMaterialUnderRework` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ProducedMaterialUnderRework)` |
     */
    ProducedMaterialUnderRework?: Array<ProducedMaterialUnderRework>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperations` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderOperation)` |
     */
    WorkOrderOperations?: Array<WorkOrderOperation>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Process` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Process` |
     */
    Process?: Process | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FinalMaterial` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DM_Material` |
     */
    FinalMaterial?: DM_Material | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedBillOfFeature` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToBeUsedBillOfFeature` |
     */
    ToBeUsedBillOfFeature?: ToBeUsedBillOfFeature | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReworkOfOrder` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrder` |
     */
    ReworkOfOrder?: WorkOrder | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentOrder` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrder` |
     */
    ParentOrder?: WorkOrder | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChildOrders` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrder)` |
     */
    ChildOrders?: Array<WorkOrder>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProductionType` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ProductionType` |
     */
    ProductionType?: ProductionType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedMaterialItems` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ProducedMaterialItem)` |
     */
    ProducedMaterialItems?: Array<ProducedMaterialItem>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceSupervisors` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NonConformanceSupervisor)` |
     */
    NonConformanceSupervisors?: Array<NonConformanceSupervisor>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderFacet)` |
     */
    Facets?: Array<WorkOrderFacet>;
}

export type WorkOrderId = string | {Id: string};

export interface WorkOOperationDependency {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DependencyType` |
     * | Type | `Edm.String` |
     */
    DependencyType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PartialCompleted` |
     * | Type | `Edm.Boolean` |
     */
    PartialCompleted: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FromWOO_Id` |
     * | Type | `Edm.Guid` |
     */
    FromWOO_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToWOO_Id` |
     * | Type | `Edm.Guid` |
     */
    ToWOO_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOpDependencyNavigations` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WOOpDependencyNavigation)` |
     */
    WOOpDependencyNavigations?: Array<WOOpDependencyNavigation>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FromWOO` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderOperation` |
     */
    FromWOO?: WorkOrderOperation | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToWOO` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderOperation` |
     */
    ToWOO?: WorkOrderOperation | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOOperationDependencyFacet)` |
     */
    Facets?: Array<WorkOOperationDependencyFacet>;
}

export type WorkOOperationDependencyId = string | {Id: string};

export interface ToolHistoryAction {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToolHistoryActionFacet)` |
     */
    Facets?: Array<ToolHistoryActionFacet>;
}

export type ToolHistoryActionId = string | {Id: string};

export interface ToolHistory {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Date` |
     * | Type | `Edm.DateTimeOffset` |
     */
    Date: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Equipment` |
     * | Type | `Edm.String` |
     */
    Equipment: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OldThickness` |
     * | Type | `Edm.Decimal` |
     */
    OldThickness: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OldTreatmentCount` |
     * | Type | `Edm.Int32` |
     */
    OldTreatmentCount: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Thickness` |
     * | Type | `Edm.Decimal` |
     */
    Thickness: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TreatmentCount` |
     * | Type | `Edm.Int32` |
     */
    TreatmentCount: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserId` |
     * | Type | `Edm.String` |
     */
    UserId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UsageDuration_Ticks` |
     * | Type | `Edm.Int64` |
     */
    UsageDuration_Ticks: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UsageDuration` |
     * | Type | `Edm.Duration` |
     */
    UsageDuration: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UsedToolCount` |
     * | Type | `Edm.Decimal` |
     */
    UsedToolCount: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Action_Id` |
     * | Type | `Edm.Guid` |
     */
    Action_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformance_Id` |
     * | Type | `Edm.Guid` |
     */
    NonConformance_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Tool_Id` |
     * | Type | `Edm.Guid` |
     */
    Tool_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnit_Id` |
     * | Type | `Edm.Guid` |
     */
    DM_MaterialTrackingUnit_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStep_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStep_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Action` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToolHistoryAction` |
     */
    Action?: ToolHistoryAction | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderOperation` |
     */
    WorkOrderOperation?: WorkOrderOperation | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformance` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NonConformance` |
     */
    NonConformance?: NonConformance | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Tool` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Tool` |
     */
    Tool?: Tool | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnit` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DM_MaterialTrackingUnit` |
     */
    DM_MaterialTrackingUnit?: DM_MaterialTrackingUnit | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStep` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderStep` |
     */
    WorkOrderStep?: WorkOrderStep | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToolHistoryFacet)` |
     */
    Facets?: Array<ToolHistoryFacet>;
}

export type ToolHistoryId = string | {Id: string};

export interface ToolCompatibleMachine {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Machine` |
     * | Type | `Edm.String` |
     */
    Machine: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentType` |
     * | Type | `Edm.String` |
     */
    EquipmentType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Tool_Id` |
     * | Type | `Edm.Guid` |
     */
    Tool_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Tool` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Tool` |
     */
    Tool?: Tool | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToolCompatibleMachineFacet)` |
     */
    Facets?: Array<ToolCompatibleMachineFacet>;
}

export type ToolCompatibleMachineId = string | {Id: string};

export interface Tool {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExpirationDate` |
     * | Type | `Edm.DateTimeOffset` |
     */
    ExpirationDate: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     */
    Status: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UsageCounter` |
     * | Type | `Edm.Decimal` |
     */
    UsageCounter: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UsageCounterMax` |
     * | Type | `Edm.Int32` |
     */
    UsageCounterMax: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActiveNonConformanceNr` |
     * | Type | `Edm.Int32` |
     */
    ActiveNonConformanceNr: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsScrap` |
     * | Type | `Edm.Boolean` |
     */
    IsScrap: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLock` |
     * | Type | `Edm.Boolean` |
     */
    IsLock: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Lockable` |
     * | Type | `Edm.Boolean` |
     */
    Lockable: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsRuntimeFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsRuntimeFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UsageDuration_Ticks` |
     * | Type | `Edm.Int64` |
     */
    UsageDuration_Ticks: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UsageDuration` |
     * | Type | `Edm.Duration` |
     */
    UsageDuration: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UsageDurationMax_Ticks` |
     * | Type | `Edm.Int64` |
     */
    UsageDurationMax_Ticks: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UsageDurationMax` |
     * | Type | `Edm.Duration` |
     */
    UsageDurationMax: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolDefinition_Id` |
     * | Type | `Edm.Guid` |
     */
    ToolDefinition_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolHistoryList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToolHistory)` |
     */
    ToolHistoryList?: Array<ToolHistory>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolCompatibleMachine` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToolCompatibleMachine)` |
     */
    ToolCompatibleMachine?: Array<ToolCompatibleMachine>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolDefinition` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToolDefinition` |
     */
    ToolDefinition?: ToolDefinition | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Tools` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NonConformanceHistory)` |
     */
    Tools?: Array<NonConformanceHistory>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualUsedTools` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ActualUsedTool)` |
     */
    ActualUsedTools?: Array<ActualUsedTool>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToolFacet)` |
     */
    Facets?: Array<ToolFacet>;
}

export type ToolId = string | {Id: string};

export interface ToBeUsedTool {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TimesToBeUsed` |
     * | Type | `Edm.Int32` |
     */
    TimesToBeUsed: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolDefinition_Id` |
     * | Type | `Edm.Guid` |
     */
    ToolDefinition_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStep_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStep_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolDefinition` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToolDefinition` |
     */
    ToolDefinition?: ToolDefinition | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderOperation` |
     */
    WorkOrderOperation?: WorkOrderOperation | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStep` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderStep` |
     */
    WorkOrderStep?: WorkOrderStep | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualUsedTools` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ActualUsedTool)` |
     */
    ActualUsedTools?: Array<ActualUsedTool>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToBeUsedToolFacet)` |
     */
    Facets?: Array<ToBeUsedToolFacet>;
}

export type ToBeUsedToolId = string | {Id: string};

export interface ToBeUsedMachine {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Machine` |
     * | Type | `Edm.String` |
     */
    Machine: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentType` |
     * | Type | `Edm.String` |
     */
    EquipmentType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PartProgram` |
     * | Type | `Edm.String` |
     */
    PartProgram: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFile` |
     * | Type | `Edm.Guid` |
     */
    PrintJobFile: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Preferred` |
     * | Type | `Edm.Boolean` |
     */
    Preferred: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderOperation` |
     */
    WorkOrderOperation?: WorkOrderOperation | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualUsedMachine` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ActualUsedMachine)` |
     */
    ActualUsedMachine?: Array<ActualUsedMachine>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToBeUsedMachineFacet)` |
     */
    Facets?: Array<ToBeUsedMachineFacet>;
}

export type ToBeUsedMachineId = string | {Id: string};

export interface ToBeUsedDocument {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentType` |
     * | Type | `Edm.String` |
     */
    DocumentType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Document_Id` |
     * | Type | `Edm.Guid` |
     */
    Document_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStep_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStep_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Document` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Document` |
     */
    Document?: Document | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderOperation` |
     */
    WorkOrderOperation?: WorkOrderOperation | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStep` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderStep` |
     */
    WorkOrderStep?: WorkOrderStep | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToBeUsedDocumentFacet)` |
     */
    Facets?: Array<ToBeUsedDocumentFacet>;
}

export type ToBeUsedDocumentId = string | {Id: string};

export interface ToBeProducedMaterial {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnit_Id` |
     * | Type | `Edm.Guid` |
     */
    DM_MaterialTrackingUnit_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStep_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStep_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderOperation` |
     */
    WorkOrderOperation?: WorkOrderOperation | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnit` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DM_MaterialTrackingUnit` |
     */
    DM_MaterialTrackingUnit?: DM_MaterialTrackingUnit | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStep` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderStep` |
     */
    WorkOrderStep?: WorkOrderStep | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualProducedMaterial` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ActualProducedMaterial)` |
     */
    ActualProducedMaterial?: Array<ActualProducedMaterial>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToBeProducedMaterialFacet)` |
     */
    Facets?: Array<ToBeProducedMaterialFacet>;
}

export type ToBeProducedMaterialId = string | {Id: string};

export interface ToBeConsumedMaterial {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DCDRuntimeTask` |
     * | Type | `Edm.String` |
     */
    DCDRuntimeTask: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DCDTask` |
     * | Type | `Edm.String` |
     */
    DCDTask: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FAIRuntimeTask` |
     * | Type | `Edm.String` |
     */
    FAIRuntimeTask: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `GroupId` |
     * | Type | `Edm.String` |
     */
    GroupId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogicalPosition` |
     * | Type | `Edm.String` |
     */
    LogicalPosition: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialSpecificationType` |
     * | Type | `Edm.String` |
     */
    MaterialSpecificationType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrekitSerialNumber` |
     * | Type | `Edm.String` |
     */
    PrekitSerialNumber: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OccurenceId` |
     * | Type | `Edm.String` |
     */
    OccurenceId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AlternativeSelected` |
     * | Type | `Edm.Boolean` |
     */
    AlternativeSelected: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     */
    Sequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialDefinition_Id` |
     * | Type | `Edm.Guid` |
     */
    MaterialDefinition_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStep_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStep_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrekitSerialNumberList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToBeConsumedMaterialPrekit)` |
     */
    PrekitSerialNumberList?: Array<ToBeConsumedMaterialPrekit>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialDefinition` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DM_Material` |
     */
    MaterialDefinition?: DM_Material | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderOperation` |
     */
    WorkOrderOperation?: WorkOrderOperation | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStep` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderStep` |
     */
    WorkOrderStep?: WorkOrderStep | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualConsumedMaterials` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ActualConsumedMaterial)` |
     */
    ActualConsumedMaterials?: Array<ActualConsumedMaterial>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToBeConsumedMaterialFacet)` |
     */
    Facets?: Array<ToBeConsumedMaterialFacet>;
}

export type ToBeConsumedMaterialId = string | {Id: string};

export interface SkipReason {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.SkipReasonFacet)` |
     */
    Facets?: Array<SkipReasonFacet>;
}

export type SkipReasonId = string | {Id: string};

export interface ProductionType {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ProductionTypeFacet)` |
     */
    Facets?: Array<ProductionTypeFacet>;
}

export type ProductionTypeId = string | {Id: string};

export interface ProducedMaterialItem {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnit_Id` |
     * | Type | `Edm.Guid` |
     */
    DM_MaterialTrackingUnit_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrder_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrder_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnit` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DM_MaterialTrackingUnit` |
     */
    DM_MaterialTrackingUnit?: DM_MaterialTrackingUnit | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrder` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrder` |
     */
    WorkOrder?: WorkOrder | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualConsumedMaterials` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ActualConsumedMaterial)` |
     */
    ActualConsumedMaterials?: Array<ActualConsumedMaterial>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ProducedMaterialItemFacet)` |
     */
    Facets?: Array<ProducedMaterialItemFacet>;
}

export type ProducedMaterialItemId = string | {Id: string};

export interface PauseReason {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Location` |
     * | Type | `Edm.String` |
     */
    Location: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.PauseReasonFacet)` |
     */
    Facets?: Array<PauseReasonFacet>;
}

export type PauseReasonId = string | {Id: string};

export interface NonConformanceSupervisor {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Defect` |
     * | Type | `Edm.String` |
     */
    Defect: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     */
    Status: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `User` |
     * | Type | `Edm.String` |
     */
    User: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     */
    Sequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrder_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrder_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrder` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrder` |
     */
    WorkOrder?: WorkOrder | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NonConformanceSupervisorFacet)` |
     */
    Facets?: Array<NonConformanceSupervisorFacet>;
}

export type NonConformanceSupervisorId = string | {Id: string};

export interface NonConformanceResource {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Operation` |
     * | Type | `Edm.String` |
     */
    Operation: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResourceId` |
     * | Type | `Edm.String` |
     */
    ResourceId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Type` |
     * | Type | `Edm.String` |
     */
    Type: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceHistory_Id` |
     * | Type | `Edm.Guid` |
     */
    NonConformanceHistory_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceHistory` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NonConformanceHistory` |
     */
    NonConformanceHistory?: NonConformanceHistory | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NonConformanceResourceFacet)` |
     */
    Facets?: Array<NonConformanceResourceFacet>;
}

export type NonConformanceResourceId = string | {Id: string};

export interface NonConformanceHistory {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     */
    Status: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Transition` |
     * | Type | `Edm.String` |
     */
    Transition: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserId` |
     * | Type | `Edm.String` |
     */
    UserId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Action` |
     * | Type | `Edm.String` |
     */
    Action: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Severity` |
     * | Type | `Edm.String` |
     */
    Severity: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PreviousSeverity` |
     * | Type | `Edm.String` |
     */
    PreviousSeverity: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Equipment` |
     * | Type | `Edm.String` |
     */
    Equipment: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FailureNId` |
     * | Type | `Edm.String` |
     */
    FailureNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReasonNId` |
     * | Type | `Edm.String` |
     */
    ReasonNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Date` |
     * | Type | `Edm.DateTimeOffset` |
     */
    Date: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Defect_Id` |
     * | Type | `Edm.Guid` |
     */
    Defect_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Tool_Id` |
     * | Type | `Edm.Guid` |
     */
    Tool_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItem_Id` |
     * | Type | `Edm.Guid` |
     */
    MaterialItem_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformance_Id` |
     * | Type | `Edm.Guid` |
     */
    NonConformance_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Resources` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NonConformanceResource)` |
     */
    Resources?: Array<NonConformanceResource>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Defect` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DefectType` |
     */
    Defect?: DefectType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Tool` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Tool` |
     */
    Tool?: Tool | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItem` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DM_MaterialTrackingUnit` |
     */
    MaterialItem?: DM_MaterialTrackingUnit | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformance` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NonConformance` |
     */
    NonConformance?: NonConformance | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Attachments` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NonConformanceAttachment)` |
     */
    Attachments?: Array<NonConformanceAttachment>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NonConformanceHistoryFacet)` |
     */
    Facets?: Array<NonConformanceHistoryFacet>;
}

export type NonConformanceHistoryId = string | {Id: string};

export interface NonConformanceAttachment {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Type` |
     * | Type | `Edm.String` |
     */
    Type: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Document_Id` |
     * | Type | `Edm.Guid` |
     */
    Document_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceHistory_Id` |
     * | Type | `Edm.Guid` |
     */
    NonConformanceHistory_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Nonconformance_Id` |
     * | Type | `Edm.Guid` |
     */
    Nonconformance_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Document` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Document` |
     */
    Document?: Document | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceHistory` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NonConformanceHistory` |
     */
    NonConformanceHistory?: NonConformanceHistory | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Nonconformance` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NonConformance` |
     */
    Nonconformance?: NonConformance | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NonConformanceAttachmentFacet)` |
     */
    Facets?: Array<NonConformanceAttachmentFacet>;
}

export type NonConformanceAttachmentId = string | {Id: string};

export interface SnagAndNote {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperation: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OpenDate` |
     * | Type | `Edm.String` |
     */
    OpenDate: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OpenDateTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    OpenDateTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OpenUser` |
     * | Type | `Edm.String` |
     */
    OpenUser: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     */
    Status: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CloseDate` |
     * | Type | `Edm.String` |
     */
    CloseDate: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CloseDateTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CloseDateTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CloseUser` |
     * | Type | `Edm.String` |
     */
    CloseUser: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Message` |
     * | Type | `Edm.String` |
     */
    Message: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrder` |
     * | Type | `Edm.Guid` |
     */
    WorkOrder: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsWorkOrderLevel` |
     * | Type | `Edm.Boolean` |
     */
    IsWorkOrderLevel: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.SnagAndNoteFacet)` |
     */
    Facets?: Array<SnagAndNoteFacet>;
}

export type SnagAndNoteId = string | {Id: string};

export interface NonConformance {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EndDate` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EndDate: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Equipment` |
     * | Type | `Edm.String` |
     */
    Equipment: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialNId` |
     * | Type | `Edm.String` |
     */
    MaterialNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceLifecycle` |
     * | Type | `Edm.String` |
     */
    NonConformanceLifecycle: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Severity` |
     * | Type | `Edm.String` |
     */
    Severity: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StartDate` |
     * | Type | `Edm.DateTimeOffset` |
     */
    StartDate: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     */
    Status: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Type` |
     * | Type | `Edm.String` |
     */
    Type: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Context` |
     * | Type | `Edm.String` |
     */
    Context: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `User` |
     * | Type | `Edm.String` |
     */
    User: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `InspectedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    InspectedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialDefinition` |
     * | Type | `Edm.String` |
     */
    MaterialDefinition: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceQuantity` |
     * | Type | `Edm.Decimal` |
     */
    NonConformanceQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SerialNumber` |
     * | Type | `Edm.String` |
     */
    SerialNumber: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolDefinition` |
     * | Type | `Edm.String` |
     */
    ToolDefinition: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentNonConformanceNId` |
     * | Type | `Edm.String` |
     */
    ParentNonConformanceNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrder_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrder_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChangeType_Id` |
     * | Type | `Edm.Guid` |
     */
    ChangeType_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceItems` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NonConformanceItem)` |
     */
    NonConformanceItems?: Array<NonConformanceItem>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderOperation` |
     */
    WorkOrderOperation?: WorkOrderOperation | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrder` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrder` |
     */
    WorkOrder?: WorkOrder | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChangeType` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ChangeType` |
     */
    ChangeType?: ChangeType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Defects` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Defect)` |
     */
    Defects?: Array<Defect>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NonConformanceFacet)` |
     */
    Facets?: Array<NonConformanceFacet>;
}

export type NonConformanceId = string | {Id: string};

export interface HoldReason {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Type` |
     * | Type | `Edm.String` |
     */
    Type: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.HoldReasonFacet)` |
     */
    Facets?: Array<HoldReasonFacet>;
}

export type HoldReasonId = string | {Id: string};

export interface Hold {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CloseComment` |
     * | Type | `Edm.String` |
     */
    CloseComment: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CloseTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CloseTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CloseUserId` |
     * | Type | `Edm.String` |
     */
    CloseUserId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Comment` |
     * | Type | `Edm.String` |
     */
    Comment: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FutureHoldId` |
     * | Type | `Edm.String` |
     */
    FutureHoldId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsPresent` |
     * | Type | `Edm.Boolean` |
     */
    IsPresent: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OpenTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    OpenTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OpenUserId` |
     * | Type | `Edm.String` |
     */
    OpenUserId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PreviousState` |
     * | Type | `Edm.String` |
     */
    PreviousState: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReasonId` |
     * | Type | `Edm.Guid` |
     */
    ReasonId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Type` |
     * | Type | `Edm.String` |
     */
    Type: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TypeNId` |
     * | Type | `Edm.String` |
     */
    TypeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `HoldReason_Id` |
     * | Type | `Edm.Guid` |
     */
    HoldReason_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `HoldReason` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.HoldReason` |
     */
    HoldReason?: HoldReason | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.HoldFacet)` |
     */
    Facets?: Array<HoldFacet>;
}

export type HoldId = string | {Id: string};

export interface FutureHold {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CloseTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CloseTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CloseUserId` |
     * | Type | `Edm.String` |
     */
    CloseUserId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Comment` |
     * | Type | `Edm.String` |
     */
    Comment: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsPresent` |
     * | Type | `Edm.Boolean` |
     */
    IsPresent: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Lifecycle` |
     * | Type | `Edm.String` |
     */
    Lifecycle: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OpenTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    OpenTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OpenUserId` |
     * | Type | `Edm.String` |
     */
    OpenUserId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PreviousStatus` |
     * | Type | `Edm.String` |
     */
    PreviousStatus: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReasonId` |
     * | Type | `Edm.String` |
     */
    ReasonId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.FutureHoldFacet)` |
     */
    Facets?: Array<FutureHoldFacet>;
}

export type FutureHoldId = string | {Id: string};

export interface Defect {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `GroupPath` |
     * | Type | `Edm.String` |
     */
    GroupPath: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FailureNId` |
     * | Type | `Edm.String` |
     */
    FailureNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefectType_Id` |
     * | Type | `Edm.Guid` |
     */
    DefectType_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformance_Id` |
     * | Type | `Edm.Guid` |
     */
    NonConformance_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefectType` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DefectType` |
     */
    DefectType?: DefectType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformance` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NonConformance` |
     */
    NonConformance?: NonConformance | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DefectFacet)` |
     */
    Facets?: Array<DefectFacet>;
}

export type DefectId = string | {Id: string};

export interface ChangeType {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Groupp` |
     * | Type | `Edm.String` |
     */
    Groupp: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ChangeTypeFacet)` |
     */
    Facets?: Array<ChangeTypeFacet>;
}

export type ChangeTypeId = string | {Id: string};

export interface AMSubstrateLifecycle {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.AMSubstrateLifecycleFacet)` |
     */
    Facets?: Array<AMSubstrateLifecycleFacet>;
}

export type AMSubstrateLifecycleId = string | {Id: string};

export interface AMPowderLifecycle {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.AMPowderLifecycleFacet)` |
     */
    Facets?: Array<AMPowderLifecycleFacet>;
}

export type AMPowderLifecycleId = string | {Id: string};

export interface ActualUsedTool {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualUsageCounter` |
     * | Type | `Edm.Decimal` |
     */
    ActualUsageCounter: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `User` |
     * | Type | `Edm.String` |
     */
    User: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MachineNId` |
     * | Type | `Edm.String` |
     */
    MachineNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UsedTimes` |
     * | Type | `Edm.Decimal` |
     */
    UsedTimes: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolDefinition_Id` |
     * | Type | `Edm.Guid` |
     */
    ToolDefinition_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedTool_Id` |
     * | Type | `Edm.Guid` |
     */
    ToBeUsedTool_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStep_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStep_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Tool_Id` |
     * | Type | `Edm.Guid` |
     */
    Tool_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedDM_MaterialTrackingUnit_Id` |
     * | Type | `Edm.Guid` |
     */
    ProducedDM_MaterialTrackingUnit_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolDefinition` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToolDefinition` |
     */
    ToolDefinition?: ToolDefinition | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedTool` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToBeUsedTool` |
     */
    ToBeUsedTool?: ToBeUsedTool | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderOperation` |
     */
    WorkOrderOperation?: WorkOrderOperation | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStep` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderStep` |
     */
    WorkOrderStep?: WorkOrderStep | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Tool` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Tool` |
     */
    Tool?: Tool | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedDM_MaterialTrackingUnit` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DM_MaterialTrackingUnit` |
     */
    ProducedDM_MaterialTrackingUnit?: DM_MaterialTrackingUnit | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ActualUsedToolFacet)` |
     */
    Facets?: Array<ActualUsedToolFacet>;
}

export type ActualUsedToolId = string | {Id: string};

export interface ActualUsedMachine {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Machine` |
     * | Type | `Edm.String` |
     */
    Machine: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PartProgram` |
     * | Type | `Edm.String` |
     */
    PartProgram: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperations_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperations_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedMachine_Id` |
     * | Type | `Edm.Guid` |
     */
    ToBeUsedMachine_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStep_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStep_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperations` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderOperation` |
     */
    WorkOrderOperations?: WorkOrderOperation | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedMachine` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToBeUsedMachine` |
     */
    ToBeUsedMachine?: ToBeUsedMachine | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStep` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderStep` |
     */
    WorkOrderStep?: WorkOrderStep | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ActualUsedMachineFacet)` |
     */
    Facets?: Array<ActualUsedMachineFacet>;
}

export type ActualUsedMachineId = string | {Id: string};

export interface ActualProducedMaterial {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CompletedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    CompletedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Equipment` |
     * | Type | `Edm.String` |
     */
    Equipment: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NotWorkedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    NotWorkedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PartialWorkedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    PartialWorkedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PausedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    PausedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReopenedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    ReopenedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ScrappedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    ScrappedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SentencedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    SentencedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SplitQuantity` |
     * | Type | `Edm.Decimal` |
     */
    SplitQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserId` |
     * | Type | `Edm.String` |
     */
    UserId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupPhaseId` |
     * | Type | `Edm.Guid` |
     */
    ExecutionGroupPhaseId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WaitingForQualityQuantity` |
     * | Type | `Edm.Decimal` |
     */
    WaitingForQualityQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UnderQualityInspectionQuantity` |
     * | Type | `Edm.Decimal` |
     */
    UnderQualityInspectionQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperations_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperations_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeProducedMaterial_Id` |
     * | Type | `Edm.Guid` |
     */
    ToBeProducedMaterial_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnit_Id` |
     * | Type | `Edm.Guid` |
     */
    DM_MaterialTrackingUnit_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStep_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStep_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperations` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderOperation` |
     */
    WorkOrderOperations?: WorkOrderOperation | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeProducedMaterial` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToBeProducedMaterial` |
     */
    ToBeProducedMaterial?: ToBeProducedMaterial | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnit` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DM_MaterialTrackingUnit` |
     */
    DM_MaterialTrackingUnit?: DM_MaterialTrackingUnit | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStep` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderStep` |
     */
    WorkOrderStep?: WorkOrderStep | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ActualProducedMaterialFacet)` |
     */
    Facets?: Array<ActualProducedMaterialFacet>;
}

export type ActualProducedMaterialId = string | {Id: string};

export interface ActualConsumedMaterial {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ConsumptionDateTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    ConsumptionDateTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItemAssembledQty` |
     * | Type | `Edm.Decimal` |
     */
    MaterialItemAssembledQty: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedMaterialItemActualQty` |
     * | Type | `Edm.Decimal` |
     */
    ProducedMaterialItemActualQty: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedMaterialItem_Id` |
     * | Type | `Edm.Guid` |
     */
    ProducedMaterialItem_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStep_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStep_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeConsumedMaterial_Id` |
     * | Type | `Edm.Guid` |
     */
    ToBeConsumedMaterial_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnit_Id` |
     * | Type | `Edm.Guid` |
     */
    DM_MaterialTrackingUnit_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupPhase_Id` |
     * | Type | `Edm.Guid` |
     */
    ExecutionGroupPhase_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedMaterialItem` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ProducedMaterialItem` |
     */
    ProducedMaterialItem?: ProducedMaterialItem | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderOperation` |
     */
    WorkOrderOperation?: WorkOrderOperation | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStep` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderStep` |
     */
    WorkOrderStep?: WorkOrderStep | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeConsumedMaterial` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToBeConsumedMaterial` |
     */
    ToBeConsumedMaterial?: ToBeConsumedMaterial | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnit` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DM_MaterialTrackingUnit` |
     */
    DM_MaterialTrackingUnit?: DM_MaterialTrackingUnit | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupPhase` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ExecutionGroupPhase` |
     */
    ExecutionGroupPhase?: ExecutionGroupPhase | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ActualConsumedMaterialFacet)` |
     */
    Facets?: Array<ActualConsumedMaterialFacet>;
}

export type ActualConsumedMaterialId = string | {Id: string};

export interface ActiveUserOnMachine {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Equipment` |
     * | Type | `Edm.String` |
     */
    Equipment: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `User` |
     * | Type | `Edm.String` |
     */
    User: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupPhase_Id` |
     * | Type | `Edm.Guid` |
     */
    ExecutionGroupPhase_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStep_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStep_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderOperation` |
     */
    WorkOrderOperation?: WorkOrderOperation | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupPhase` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ExecutionGroupPhase` |
     */
    ExecutionGroupPhase?: ExecutionGroupPhase | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStep` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderStep` |
     */
    WorkOrderStep?: WorkOrderStep | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ActiveUserOnMachineFacet)` |
     */
    Facets?: Array<ActiveUserOnMachineFacet>;
}

export type ActiveUserOnMachineId = string | {Id: string};

export interface WorkOrderNotification {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStatus` |
     * | Type | `Edm.String` |
     */
    WorkOrderStatus: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderFinalMaterial` |
     * | Type | `Edm.String` |
     */
    WorkOrderFinalMaterial: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderEstimatedStartTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    WorkOrderEstimatedStartTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderNotificationFacet)` |
     */
    Facets?: Array<WorkOrderNotificationFacet>;
}

export type WorkOrderNotificationId = string | {Id: string};

export interface ProcessNotification {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessNId` |
     * | Type | `Edm.String` |
     */
    ProcessNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessRevision` |
     * | Type | `Edm.String` |
     */
    ProcessRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessUId` |
     * | Type | `Edm.String` |
     */
    ProcessUId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessName` |
     * | Type | `Edm.String` |
     */
    ProcessName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessId` |
     * | Type | `Edm.Guid` |
     */
    ProcessId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBOPId` |
     * | Type | `Edm.Guid` |
     */
    AsPlannedBOPId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ProcessNotificationFacet)` |
     */
    Facets?: Array<ProcessNotificationFacet>;
}

export type ProcessNotificationId = string | {Id: string};

export interface ConfigurationKeyMultiValue {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Type` |
     * | Type | `Edm.String` |
     */
    Type: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Val` |
     * | Type | `Edm.String` |
     */
    Val: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ConfigurationKey_Id` |
     * | Type | `Edm.Guid` |
     */
    ConfigurationKey_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ConfigurationKey` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ConfigurationKey` |
     */
    ConfigurationKey?: ConfigurationKey | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ConfigurationKeyMultiValueFacet)` |
     */
    Facets?: Array<ConfigurationKeyMultiValueFacet>;
}

export type ConfigurationKeyMultiValueId = string | {Id: string};

export interface PrintJobFile {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BuildtrayLayout` |
     * | Type | `Edm.String` |
     */
    BuildtrayLayout: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExternalId` |
     * | Type | `Edm.String` |
     */
    ExternalId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FileName` |
     * | Type | `Edm.String` |
     */
    FileName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProductSerializable` |
     * | Type | `Edm.Boolean` |
     */
    ProductSerializable: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProductSerialNumberManagement` |
     * | Type | `Siemens.SimaticIT.U4DM.MasterData.FB_MS_AMMS.MSModel.Types.ReadingModel.AMSerialNumberManagement` |
     */
    ProductSerialNumberManagement: AMSerialNumberManagement | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RunTimeOnly` |
     * | Type | `Edm.Boolean` |
     */
    RunTimeOnly: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Source` |
     * | Type | `Edm.String` |
     */
    Source: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TestBars` |
     * | Type | `Edm.Boolean` |
     */
    TestBars: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TestBarsNumber` |
     * | Type | `Edm.Int32` |
     */
    TestBarsNumber: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TestBarsSerializable` |
     * | Type | `Edm.Boolean` |
     */
    TestBarsSerializable: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TestBarsSerialNumberManagement` |
     * | Type | `Siemens.SimaticIT.U4DM.MasterData.FB_MS_AMMS.MSModel.Types.ReadingModel.AMSerialNumberManagement` |
     */
    TestBarsSerialNumberManagement: AMSerialNumberManagement | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProductionPrinter` |
     * | Type | `Edm.String` |
     */
    ProductionPrinter: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedBuildProcessDuration_Ticks` |
     * | Type | `Edm.Int64` |
     */
    EstimatedBuildProcessDuration_Ticks: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedBuildProcessDuration` |
     * | Type | `Edm.Duration` |
     */
    EstimatedBuildProcessDuration: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedPrintDuration_Ticks` |
     * | Type | `Edm.Int64` |
     */
    EstimatedPrintDuration_Ticks: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedPrintDuration` |
     * | Type | `Edm.Duration` |
     */
    EstimatedPrintDuration: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentPJF_Id` |
     * | Type | `Edm.Guid` |
     */
    ParentPJF_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedMaterialConsumption` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.QuantityType` |
     * | Nullable | `false` |
     */
    EstimatedMaterialConsumption: QuantityType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaxProducedHeight` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.QuantityType` |
     * | Nullable | `false` |
     */
    MaxProducedHeight: QuantityType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PJF` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.RuntimePJFSerialNumberAssociation)` |
     */
    PJF?: Array<RuntimePJFSerialNumberAssociation>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.PrintJobFileEquipmentTypeAssociation)` |
     */
    EquipmentTypeList?: Array<PrintJobFileEquipmentTypeAssociation>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrinterList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.PrintJobFileEquipmentAssociation)` |
     */
    PrinterList?: Array<PrintJobFileEquipmentAssociation>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.PrintJobFileDM_MaterialAssociation)` |
     */
    DM_MaterialList?: Array<PrintJobFileDM_MaterialAssociation>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentPJF` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.PrintJobFile` |
     */
    ParentPJF?: PrintJobFile | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.PrintJobFileFacet)` |
     */
    Facets?: Array<PrintJobFileFacet>;
}

export type PrintJobFileId = string | {Id: string};

export interface MachineToAM {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeNId` |
     * | Type | `Edm.String` |
     */
    EquipmentTypeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AMMachine` |
     * | Type | `Edm.String` |
     */
    AMMachine: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TransferPlugin` |
     * | Type | `Edm.String` |
     */
    TransferPlugin: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.MachineToAMFacet)` |
     */
    Facets?: Array<MachineToAMFacet>;
}

export type MachineToAMId = string | {Id: string};

export interface ConfigurationKey {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Type` |
     * | Type | `Edm.String` |
     */
    Type: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Val` |
     * | Type | `Edm.String` |
     */
    Val: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsProtected` |
     * | Type | `Edm.Boolean` |
     */
    IsProtected: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Category` |
     * | Type | `Edm.String` |
     */
    Category: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsMultiValue` |
     * | Type | `Edm.Boolean` |
     */
    IsMultiValue: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ConfigurationKeyFacet)` |
     */
    Facets?: Array<ConfigurationKeyFacet>;
}

export type ConfigurationKeyId = string | {Id: string};

export interface NonConformanceNotification {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrder` |
     * | Type | `Edm.String` |
     */
    WorkOrder: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperation: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserRole` |
     * | Type | `Edm.String` |
     */
    UserRole: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceType` |
     * | Type | `Edm.String` |
     */
    NonConformanceType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceNId` |
     * | Type | `Edm.String` |
     */
    NonConformanceNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Date` |
     * | Type | `Edm.DateTimeOffset` |
     */
    Date: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NonConformanceNotificationFacet)` |
     */
    Facets?: Array<NonConformanceNotificationFacet>;
}

export type NonConformanceNotificationId = string | {Id: string};

export interface UserCertificationAssociation {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExpiryDate` |
     * | Type | `Edm.DateTimeOffset` |
     */
    ExpiryDate: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `User` |
     * | Type | `Edm.String` |
     */
    User: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Certification_Id` |
     * | Type | `Edm.Guid` |
     */
    Certification_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Certification` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Certification` |
     */
    Certification?: Certification | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.UserCertificationAssociationFacet)` |
     */
    Facets?: Array<UserCertificationAssociationFacet>;
}

export type UserCertificationAssociationId = string | {Id: string};

export interface SkillCertificationAssociation {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Level` |
     * | Type | `Edm.Int32` |
     */
    Level: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SkillId_Id` |
     * | Type | `Edm.Guid` |
     */
    SkillId_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Certification_Id` |
     * | Type | `Edm.Guid` |
     */
    Certification_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SkillId` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Skill_BOP` |
     */
    SkillId?: Skill_BOP | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Certification` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Certification` |
     */
    Certification?: Certification | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.SkillCertificationAssociationFacet)` |
     */
    Facets?: Array<SkillCertificationAssociationFacet>;
}

export type SkillCertificationAssociationId = string | {Id: string};

export interface RoleCertificationAssociation {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExpiryDate` |
     * | Type | `Edm.DateTimeOffset` |
     */
    ExpiryDate: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Role` |
     * | Type | `Edm.String` |
     */
    Role: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Certification_Id` |
     * | Type | `Edm.Guid` |
     */
    Certification_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Certification` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Certification` |
     */
    Certification?: Certification | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.RoleCertificationAssociationFacet)` |
     */
    Facets?: Array<RoleCertificationAssociationFacet>;
}

export type RoleCertificationAssociationId = string | {Id: string};

export interface MaterialCertificationAssociation {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialId_Id` |
     * | Type | `Edm.Guid` |
     */
    MaterialId_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Certification_Id` |
     * | Type | `Edm.Guid` |
     */
    Certification_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialId` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DM_Material` |
     */
    MaterialId?: DM_Material | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Certification` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Certification` |
     */
    Certification?: Certification | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.MaterialCertificationAssociationFacet)` |
     */
    Facets?: Array<MaterialCertificationAssociationFacet>;
}

export type MaterialCertificationAssociationId = string | {Id: string};

export interface EquipmentCertificationAssociation {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentType` |
     * | Type | `Edm.String` |
     */
    EquipmentType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeNId` |
     * | Type | `Edm.String` |
     */
    EquipmentTypeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Certification_Id` |
     * | Type | `Edm.Guid` |
     */
    Certification_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Certification` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Certification` |
     */
    Certification?: Certification | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentCertificationAssociationFacet)` |
     */
    Facets?: Array<EquipmentCertificationAssociationFacet>;
}

export type EquipmentCertificationAssociationId = string | {Id: string};

export interface CertificationHistoryAction {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Certifications` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.CertificationHistory)` |
     */
    Certifications?: Array<CertificationHistory>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.CertificationHistoryActionFacet)` |
     */
    Facets?: Array<CertificationHistoryActionFacet>;
}

export type CertificationHistoryActionId = string | {Id: string};

export interface CertificationHistory {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Date` |
     * | Type | `Edm.DateTimeOffset` |
     */
    Date: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReferenceRoleId` |
     * | Type | `Edm.String` |
     */
    ReferenceRoleId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReferenceUserId` |
     * | Type | `Edm.String` |
     */
    ReferenceUserId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserId` |
     * | Type | `Edm.String` |
     */
    UserId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialId` |
     * | Type | `Edm.Guid` |
     */
    MaterialId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialNId` |
     * | Type | `Edm.String` |
     */
    MaterialNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeNId` |
     * | Type | `Edm.String` |
     */
    EquipmentTypeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SkillNId` |
     * | Type | `Edm.String` |
     */
    SkillNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CertificationNId` |
     * | Type | `Edm.String` |
     */
    CertificationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SkillId` |
     * | Type | `Edm.Guid` |
     */
    SkillId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Action_Id` |
     * | Type | `Edm.Guid` |
     */
    Action_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Action` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.CertificationHistoryAction` |
     */
    Action?: CertificationHistoryAction | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.CertificationHistoryFacet)` |
     */
    Facets?: Array<CertificationHistoryFacet>;
}

export type CertificationHistoryId = string | {Id: string};

export interface Certification {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     */
    CorrelationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.UserCertificationAssociation)` |
     */
    UserList?: Array<UserCertificationAssociation>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SkillList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.SkillCertificationAssociation)` |
     */
    SkillList?: Array<SkillCertificationAssociation>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RoleList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.RoleCertificationAssociation)` |
     */
    RoleList?: Array<RoleCertificationAssociation>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.MaterialCertificationAssociation)` |
     */
    MaterialList?: Array<MaterialCertificationAssociation>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentCertificationAssociation)` |
     */
    EquipmentList?: Array<EquipmentCertificationAssociation>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.CertificationFacet)` |
     */
    Facets?: Array<CertificationFacet>;
}

export type CertificationId = string | {Id: string};

export interface TemplateToMaterialPlant {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_Material` |
     * | Type | `Edm.Guid` |
     */
    DM_Material: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Template_Id` |
     * | Type | `Edm.Guid` |
     */
    Template_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Template` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Template` |
     */
    Template?: Template | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.TemplateToMaterialPlantFacet)` |
     */
    Facets?: Array<TemplateToMaterialPlantFacet>;
}

export type TemplateToMaterialPlantId = string | {Id: string};

export interface TemplateType {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Templates` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Template)` |
     */
    Templates?: Array<Template>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.TemplateTypeFacet)` |
     */
    Facets?: Array<TemplateTypeFacet>;
}

export type TemplateTypeId = string | {Id: string};

export interface TemplateBlock {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExtendedYear` |
     * | Type | `Edm.Boolean` |
     */
    ExtendedYear: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NextValue` |
     * | Type | `Edm.Int32` |
     */
    NextValue: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NumDigits` |
     * | Type | `Edm.Int32` |
     */
    NumDigits: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Separator` |
     * | Type | `Edm.String` |
     */
    Separator: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BlockType` |
     * | Type | `Edm.String` |
     */
    BlockType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ZeroPadding` |
     * | Type | `Edm.Boolean` |
     */
    ZeroPadding: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     */
    Sequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Template_Id` |
     * | Type | `Edm.Guid` |
     */
    Template_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Template` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Template` |
     */
    Template?: Template | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.TemplateBlockFacet)` |
     */
    Facets?: Array<TemplateBlockFacet>;
}

export type TemplateBlockId = string | {Id: string};

export interface Template {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EditingUser` |
     * | Type | `Edm.String` |
     */
    EditingUser: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Editing` |
     * | Type | `Edm.Boolean` |
     */
    Editing: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TemplateType_Id` |
     * | Type | `Edm.Guid` |
     */
    TemplateType_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialPlant` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.TemplateToMaterialPlant)` |
     */
    MaterialPlant?: Array<TemplateToMaterialPlant>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TemplateBlocks` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.TemplateBlock)` |
     */
    TemplateBlocks?: Array<TemplateBlock>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TemplateType` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.TemplateType` |
     */
    TemplateType?: TemplateType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.TemplateFacet)` |
     */
    Facets?: Array<TemplateFacet>;
}

export type TemplateId = string | {Id: string};

export interface MaterialSpecificationType {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `HasOutputBehavior` |
     * | Type | `Edm.Boolean` |
     */
    HasOutputBehavior: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialSpecification` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.MaterialSpecification)` |
     */
    MaterialSpecification?: Array<MaterialSpecification>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.MaterialSpecificationTypeFacet)` |
     */
    Facets?: Array<MaterialSpecificationTypeFacet>;
}

export type MaterialSpecificationTypeId = string | {Id: string};

export interface ToolDefinitionDocument {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolDefinitionId` |
     * | Type | `Edm.Guid` |
     */
    ToolDefinitionId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Document_Id` |
     * | Type | `Edm.Guid` |
     */
    Document_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Document` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Document` |
     */
    Document?: Document | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToolDefinitionDocumentFacet)` |
     */
    Facets?: Array<ToolDefinitionDocumentFacet>;
}

export type ToolDefinitionDocumentId = string | {Id: string};

export interface StepDependency {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Type` |
     * | Type | `Edm.String` |
     */
    Type: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LinkTo_Id` |
     * | Type | `Edm.Guid` |
     */
    LinkTo_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LinkFrom_Id` |
     * | Type | `Edm.Guid` |
     */
    LinkFrom_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToStep_Id` |
     * | Type | `Edm.Guid` |
     */
    ToStep_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FromStep_Id` |
     * | Type | `Edm.Guid` |
     */
    FromStep_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DependencyType_Id` |
     * | Type | `Edm.Guid` |
     */
    DependencyType_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationContext_Id` |
     * | Type | `Edm.Guid` |
     */
    OperationContext_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBoP_Id` |
     * | Type | `Edm.Guid` |
     */
    AsPlannedBoP_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlan_Id` |
     * | Type | `Edm.Guid` |
     */
    MasterPlan_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LinkTo` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.OperationToStepLink` |
     */
    LinkTo?: OperationToStepLink | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LinkFrom` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.OperationToStepLink` |
     */
    LinkFrom?: OperationToStepLink | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToStep` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Step` |
     */
    ToStep?: Step | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FromStep` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Step` |
     */
    FromStep?: Step | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DependencyType` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DependencyType` |
     */
    DependencyType?: DependencyType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationContext` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Operation` |
     */
    OperationContext?: Operation | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBoP` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.AsPlannedBOP` |
     */
    AsPlannedBoP?: AsPlannedBOP | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlan` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.MasterPlan` |
     */
    MasterPlan?: MasterPlan | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.StepDependencyFacet)` |
     */
    Facets?: Array<StepDependencyFacet>;
}

export type StepDependencyId = string | {Id: string};

export interface Step {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     */
    Sequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Optional` |
     * | Type | `Edm.Boolean` |
     */
    Optional: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.String` |
     */
    CorrelationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     */
    Revision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UId` |
     * | Type | `Edm.String` |
     */
    UId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RequiredInspectionRole` |
     * | Type | `Edm.String` |
     */
    RequiredInspectionRole: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignatureComplete` |
     * | Type | `Edm.Boolean` |
     */
    ElectronicSignatureComplete: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignaturePause` |
     * | Type | `Edm.Boolean` |
     */
    ElectronicSignaturePause: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignatureStart` |
     * | Type | `Edm.Boolean` |
     */
    ElectronicSignatureStart: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RequiredCertificateNId` |
     * | Type | `Edm.String` |
     */
    RequiredCertificateNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EffectivityExpression` |
     * | Type | `Edm.String` |
     */
    EffectivityExpression: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCollectedDocument` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCollectedDocument: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedDuration_Ticks` |
     * | Type | `Edm.Int64` |
     */
    EstimatedDuration_Ticks: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedDuration` |
     * | Type | `Edm.Duration` |
     */
    EstimatedDuration: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationStepCategoryId_Id` |
     * | Type | `Edm.Guid` |
     */
    OperationStepCategoryId_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CertificationSpecification` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.CertificationSpecification)` |
     */
    CertificationSpecification?: Array<CertificationSpecification>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StepSkills` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.StepSkill)` |
     */
    StepSkills?: Array<StepSkill>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionDefinitions` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkInstructionDefinitionToStepAssociation)` |
     */
    WorkInstructionDefinitions?: Array<WorkInstructionDefinitionToStepAssociation>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `InspectionSpecification` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.InspectionSpecification)` |
     */
    InspectionSpecification?: Array<InspectionSpecification>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationToStepLinks` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.OperationToStepLink)` |
     */
    OperationToStepLinks?: Array<OperationToStepLink>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToStepDependency` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.StepDependency)` |
     */
    ToStepDependency?: Array<StepDependency>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FromStepDependency` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.StepDependency)` |
     */
    FromStepDependency?: Array<StepDependency>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationStepCategoryId` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.OperationStepCategory` |
     */
    OperationStepCategoryId?: OperationStepCategory | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Operations` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Operation)` |
     */
    Operations?: Array<Operation>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialSpecifications` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.MaterialSpecification)` |
     */
    MaterialSpecifications?: Array<MaterialSpecification>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Documents` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Document)` |
     */
    Documents?: Array<Document>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolSpecifications` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToolSpecification)` |
     */
    ToolSpecifications?: Array<ToolSpecification>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.StepFacet)` |
     */
    Facets?: Array<StepFacet>;
}

export type StepId = string | {Id: string};

export interface Process {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     */
    Sequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     */
    Revision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UId` |
     * | Type | `Edm.String` |
     */
    UId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Plant` |
     * | Type | `Edm.String` |
     */
    Plant: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.String` |
     */
    CorrelationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EffectivityExpression` |
     * | Type | `Edm.String` |
     */
    EffectivityExpression: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Version` |
     * | Type | `Edm.String` |
     */
    Version: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FinalMaterialId_Id` |
     * | Type | `Edm.Guid` |
     */
    FinalMaterialId_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaxQuantity` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.QuantityType` |
     * | Nullable | `false` |
     */
    MaxQuantity: QuantityType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.QuantityType` |
     * | Nullable | `false` |
     */
    Quantity: QuantityType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MinQuantity` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.QuantityType` |
     * | Nullable | `false` |
     */
    MinQuantity: QuantityType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DiscreteStatus` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.StatusType` |
     * | Nullable | `false` |
     */
    DiscreteStatus: StatusType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessLinksWithRoleParent` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ProcessToProcessLink)` |
     */
    ProcessLinksWithRoleParent?: Array<ProcessToProcessLink>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessLinksWithRoleChild` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ProcessToProcessLink)` |
     */
    ProcessLinksWithRoleChild?: Array<ProcessToProcessLink>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessToOperationLinks` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ProcessToOperationLink)` |
     */
    ProcessToOperationLinks?: Array<ProcessToOperationLink>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrders` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrder)` |
     */
    WorkOrders?: Array<WorkOrder>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FinalMaterialId` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DM_Material` |
     */
    FinalMaterialId?: DM_Material | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentProcesses` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Process)` |
     */
    ParentProcesses?: Array<Process>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChildrenProcesses` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Process)` |
     */
    ChildrenProcesses?: Array<Process>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlan` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.MasterPlan)` |
     */
    MasterPlan?: Array<MasterPlan>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBOP` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.AsPlannedBOP)` |
     */
    AsPlannedBOP?: Array<AsPlannedBOP>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationDependencies` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.OperationDependency)` |
     */
    OperationDependencies?: Array<OperationDependency>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Operations` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Operation)` |
     */
    Operations?: Array<Operation>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ProcessFacet)` |
     */
    Facets?: Array<ProcessFacet>;
}

export type ProcessId = string | {Id: string};

export interface OperationDependency {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Type` |
     * | Type | `Edm.String` |
     */
    Type: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FromOperation_Id` |
     * | Type | `Edm.Guid` |
     */
    FromOperation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToOperation_Id` |
     * | Type | `Edm.Guid` |
     */
    ToOperation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DependencyType_Id` |
     * | Type | `Edm.Guid` |
     */
    DependencyType_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContextProcess_Id` |
     * | Type | `Edm.Guid` |
     */
    ContextProcess_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LinkFrom_Id` |
     * | Type | `Edm.Guid` |
     */
    LinkFrom_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LinkTo_Id` |
     * | Type | `Edm.Guid` |
     */
    LinkTo_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBoP_Id` |
     * | Type | `Edm.Guid` |
     */
    AsPlannedBoP_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlan_Id` |
     * | Type | `Edm.Guid` |
     */
    MasterPlan_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessToOpLinkDependencyNavigations` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ProcessToOpLinkDependencyNavigation)` |
     */
    ProcessToOpLinkDependencyNavigations?: Array<ProcessToOpLinkDependencyNavigation>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FromOperation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Operation` |
     */
    FromOperation?: Operation | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToOperation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Operation` |
     */
    ToOperation?: Operation | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DependencyType` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DependencyType` |
     */
    DependencyType?: DependencyType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContextProcess` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Process` |
     */
    ContextProcess?: Process | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LinkFrom` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ProcessToOperationLink` |
     */
    LinkFrom?: ProcessToOperationLink | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LinkTo` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ProcessToOperationLink` |
     */
    LinkTo?: ProcessToOperationLink | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBoP` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.AsPlannedBOP` |
     */
    AsPlannedBoP?: AsPlannedBOP | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlan` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.MasterPlan` |
     */
    MasterPlan?: MasterPlan | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.OperationDependencyFacet)` |
     */
    Facets?: Array<OperationDependencyFacet>;
}

export type OperationDependencyId = string | {Id: string};

export interface Operation {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Optional` |
     * | Type | `Edm.Boolean` |
     */
    Optional: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     */
    Sequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.String` |
     */
    CorrelationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     */
    Revision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UId` |
     * | Type | `Edm.String` |
     */
    UId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignatureStart` |
     * | Type | `Edm.Boolean` |
     */
    ElectronicSignatureStart: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignaturePause` |
     * | Type | `Edm.Boolean` |
     */
    ElectronicSignaturePause: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignatureComplete` |
     * | Type | `Edm.Boolean` |
     */
    ElectronicSignatureComplete: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RequiredInspectionRole` |
     * | Type | `Edm.String` |
     */
    RequiredInspectionRole: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RequiredCertificateNId` |
     * | Type | `Edm.String` |
     */
    RequiredCertificateNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCollectedDocument` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCollectedDocument: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EffectivityExpression` |
     * | Type | `Edm.String` |
     */
    EffectivityExpression: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedDuration_Ticks` |
     * | Type | `Edm.Int64` |
     */
    EstimatedDuration_Ticks: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedDuration` |
     * | Type | `Edm.Duration` |
     */
    EstimatedDuration: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOperationId_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOperationId_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationStepCategoryId_Id` |
     * | Type | `Edm.Guid` |
     */
    OperationStepCategoryId_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CertificationSpecification` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.CertificationSpecification)` |
     */
    CertificationSpecification?: Array<CertificationSpecification>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `InspectionSpecification` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.InspectionSpecification)` |
     */
    InspectionSpecification?: Array<InspectionSpecification>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionDefinitions` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkInstructionDefinitionToOperationAssociation)` |
     */
    WorkInstructionDefinitions?: Array<WorkInstructionDefinitionToOperationAssociation>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationToStepLinks` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.OperationToStepLink)` |
     */
    OperationToStepLinks?: Array<OperationToStepLink>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessToOperationLinks` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ProcessToOperationLink)` |
     */
    ProcessToOperationLinks?: Array<ProcessToOperationLink>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationSkill` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.OperationSkill)` |
     */
    OperationSkill?: Array<OperationSkill>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperations` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderOperation)` |
     */
    WorkOrderOperations?: Array<WorkOrderOperation>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StepDependencies` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.StepDependency)` |
     */
    StepDependencies?: Array<StepDependency>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Steps` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Step)` |
     */
    Steps?: Array<Step>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FromOperationDependency` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.OperationDependency)` |
     */
    FromOperationDependency?: Array<OperationDependency>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToOperationDependency` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.OperationDependency)` |
     */
    ToOperationDependency?: Array<OperationDependency>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOperationId` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOperationType` |
     */
    WorkOperationId?: WorkOperationType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationStepCategoryId` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.OperationStepCategory` |
     */
    OperationStepCategoryId?: OperationStepCategory | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Processes` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Process)` |
     */
    Processes?: Array<Process>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialSpecifications` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.MaterialSpecification)` |
     */
    MaterialSpecifications?: Array<MaterialSpecification>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentSpecifications` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentSpecification)` |
     */
    EquipmentSpecifications?: Array<EquipmentSpecification>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Documents` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Document)` |
     */
    Documents?: Array<Document>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolSpecifications` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToolSpecification)` |
     */
    ToolSpecifications?: Array<ToolSpecification>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.OperationFacet)` |
     */
    Facets?: Array<OperationFacet>;
}

export type OperationId = string | {Id: string};

export interface MaterialSpecification {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UId` |
     * | Type | `Edm.String` |
     */
    UId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogicalPosition` |
     * | Type | `Edm.String` |
     */
    LogicalPosition: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `GroupId` |
     * | Type | `Edm.String` |
     */
    GroupId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AlternativeSelected` |
     * | Type | `Edm.Boolean` |
     */
    AlternativeSelected: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EffectivityExpression` |
     * | Type | `Edm.String` |
     */
    EffectivityExpression: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     */
    CorrelationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FunctionalCodeNId` |
     * | Type | `Edm.String` |
     */
    FunctionalCodeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OccurrenceId` |
     * | Type | `Edm.String` |
     */
    OccurrenceId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialId_Id` |
     * | Type | `Edm.Guid` |
     */
    DM_MaterialId_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Operation_Id` |
     * | Type | `Edm.Guid` |
     */
    Operation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Step_Id` |
     * | Type | `Edm.Guid` |
     */
    Step_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialTypeNId_Id` |
     * | Type | `Edm.Guid` |
     */
    MaterialTypeNId_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBOP_Id` |
     * | Type | `Edm.Guid` |
     */
    AsPlannedBOP_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlan_Id` |
     * | Type | `Edm.Guid` |
     */
    MasterPlan_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.QuantityType` |
     * | Nullable | `false` |
     */
    Quantity: QuantityType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialId` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DM_Material` |
     */
    DM_MaterialId?: DM_Material | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Operation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Operation` |
     */
    Operation?: Operation | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Step` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Step` |
     */
    Step?: Step | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialTypeNId` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.MaterialSpecificationType` |
     */
    MaterialTypeNId?: MaterialSpecificationType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBOP` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.AsPlannedBOP` |
     */
    AsPlannedBOP?: AsPlannedBOP | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlan` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.MasterPlan` |
     */
    MasterPlan?: MasterPlan | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.MaterialSpecificationFacet)` |
     */
    Facets?: Array<MaterialSpecificationFacet>;
}

export type MaterialSpecificationId = string | {Id: string};

export interface MaterialDefinitionDocument {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialDefinitionId` |
     * | Type | `Edm.Guid` |
     */
    MaterialDefinitionId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Document_Id` |
     * | Type | `Edm.Guid` |
     */
    Document_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Document` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Document` |
     */
    Document?: Document | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.MaterialDefinitionDocumentFacet)` |
     */
    Facets?: Array<MaterialDefinitionDocumentFacet>;
}

export type MaterialDefinitionDocumentId = string | {Id: string};

export interface EquipmentSpecification {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PartProgram` |
     * | Type | `Edm.String` |
     */
    PartProgram: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeNId` |
     * | Type | `Edm.String` |
     */
    EquipmentTypeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Type` |
     * | Type | `Edm.String` |
     */
    Type: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFile` |
     * | Type | `Edm.String` |
     */
    PrintJobFile: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFileId` |
     * | Type | `Edm.Guid` |
     */
    PrintJobFileId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     */
    CorrelationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EffectivityExpression` |
     * | Type | `Edm.String` |
     */
    EffectivityExpression: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UId` |
     * | Type | `Edm.String` |
     */
    UId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentOperation_Id` |
     * | Type | `Edm.Guid` |
     */
    ParentOperation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlan_Id` |
     * | Type | `Edm.Guid` |
     */
    MasterPlan_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBOP_Id` |
     * | Type | `Edm.Guid` |
     */
    AsPlannedBOP_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentOperation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Operation` |
     */
    ParentOperation?: Operation | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlan` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.MasterPlan` |
     */
    MasterPlan?: MasterPlan | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBOP` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.AsPlannedBOP` |
     */
    AsPlannedBOP?: AsPlannedBOP | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentSpecificationFacet)` |
     */
    Facets?: Array<EquipmentSpecificationFacet>;
}

export type EquipmentSpecificationId = string | {Id: string};

export interface Document {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FileName` |
     * | Type | `Edm.String` |
     */
    FileName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MIMEType` |
     * | Type | `Edm.String` |
     */
    MIMEType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.String` |
     */
    CorrelationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DatasetNId` |
     * | Type | `Edm.String` |
     */
    DatasetNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Type` |
     * | Type | `Edm.String` |
     */
    Type: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UId` |
     * | Type | `Edm.String` |
     */
    UId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `File_Id_Id` |
     * | Type | `Edm.Guid` |
     */
    File_Id_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Steps` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Step)` |
     */
    Steps?: Array<Step>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Operations` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Operation)` |
     */
    Operations?: Array<Operation>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `File_Id` |
     * | Type | `Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.File` |
     */
    File_Id?: File | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DocumentFacet)` |
     */
    Facets?: Array<DocumentFacet>;
}

export type DocumentId = string | {Id: string};

export interface DependencyType {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DependencyTypeFacet)` |
     */
    Facets?: Array<DependencyTypeFacet>;
}

export type DependencyTypeId = string | {Id: string};

export interface AsPlannedBOP {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BaselineName` |
     * | Type | `Edm.String` |
     */
    BaselineName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.String` |
     */
    CorrelationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BaselineUId` |
     * | Type | `Edm.String` |
     */
    BaselineUId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PBOPIdentID` |
     * | Type | `Edm.String` |
     */
    PBOPIdentID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlanUID` |
     * | Type | `Edm.String` |
     */
    MasterPlanUID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OrderId` |
     * | Type | `Edm.String` |
     */
    OrderId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsOutOfDate` |
     * | Type | `Edm.Boolean` |
     */
    IsOutOfDate: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EffectivityExpression` |
     * | Type | `Edm.String` |
     */
    EffectivityExpression: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Completed` |
     * | Type | `Edm.Boolean` |
     */
    Completed: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CertificationSpecification` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.CertificationSpecification)` |
     */
    CertificationSpecification?: Array<CertificationSpecification>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `InspectionSpecification` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.InspectionSpecification)` |
     */
    InspectionSpecification?: Array<InspectionSpecification>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationToStepLinks` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.OperationToStepLink)` |
     */
    OperationToStepLinks?: Array<OperationToStepLink>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessToProcessLinks` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ProcessToProcessLink)` |
     */
    ProcessToProcessLinks?: Array<ProcessToProcessLink>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessToOperationLinks` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ProcessToOperationLink)` |
     */
    ProcessToOperationLinks?: Array<ProcessToOperationLink>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StepDependencies` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.StepDependency)` |
     */
    StepDependencies?: Array<StepDependency>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Processes` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Process)` |
     */
    Processes?: Array<Process>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationDependencies` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.OperationDependency)` |
     */
    OperationDependencies?: Array<OperationDependency>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialSpecification` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.MaterialSpecification)` |
     */
    MaterialSpecification?: Array<MaterialSpecification>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentSpecification` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentSpecification)` |
     */
    EquipmentSpecification?: Array<EquipmentSpecification>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolSpecification` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToolSpecification)` |
     */
    ToolSpecification?: Array<ToolSpecification>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.AsPlannedBOPFacet)` |
     */
    Facets?: Array<AsPlannedBOPFacet>;
}

export type AsPlannedBOPId = string | {Id: string};

export interface ToolSpecification {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UId` |
     * | Type | `Edm.String` |
     */
    UId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UsageNumber` |
     * | Type | `Edm.Int32` |
     */
    UsageNumber: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EffectivityExpression` |
     * | Type | `Edm.String` |
     */
    EffectivityExpression: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     */
    CorrelationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UsageDuration_Ticks` |
     * | Type | `Edm.Int64` |
     */
    UsageDuration_Ticks: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UsageDuration` |
     * | Type | `Edm.Duration` |
     */
    UsageDuration: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolDefinitionId_Id` |
     * | Type | `Edm.Guid` |
     */
    ToolDefinitionId_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Operation_Id` |
     * | Type | `Edm.Guid` |
     */
    Operation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Step_Id` |
     * | Type | `Edm.Guid` |
     */
    Step_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBOP_Id` |
     * | Type | `Edm.Guid` |
     */
    AsPlannedBOP_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlan_Id` |
     * | Type | `Edm.Guid` |
     */
    MasterPlan_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolDefinitionId` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToolDefinition` |
     */
    ToolDefinitionId?: ToolDefinition | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Operation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Operation` |
     */
    Operation?: Operation | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Step` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Step` |
     */
    Step?: Step | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBOP` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.AsPlannedBOP` |
     */
    AsPlannedBOP?: AsPlannedBOP | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlan` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.MasterPlan` |
     */
    MasterPlan?: MasterPlan | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToolSpecificationFacet)` |
     */
    Facets?: Array<ToolSpecificationFacet>;
}

export type ToolSpecificationId = string | {Id: string};

export interface DocumentNewFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentNew_Id` |
     * | Type | `Edm.Guid` |
     */
    DocumentNew_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentNew` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DocumentNew` |
     */
    DocumentNew?: DocumentNew | null;
}

export type DocumentNewFacetId = string | {Id: string};

export interface PLMXDocument extends DocumentNewFacet {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PackageId` |
     * | Type | `Edm.String` |
     */
    PackageId: string | null;
}

export interface ContainerHistoryFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContainerHistory_Id` |
     * | Type | `Edm.Guid` |
     */
    ContainerHistory_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContainerHistory` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ContainerHistory` |
     */
    ContainerHistory?: ContainerHistory | null;
}

export type ContainerHistoryFacetId = string | {Id: string};

export interface ContainerNonConformance extends ContainerHistoryFacet {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceNId` |
     * | Type | `Edm.String` |
     */
    NonConformanceNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReworkOrderNId` |
     * | Type | `Edm.String` |
     */
    ReworkOrderNId: string | null;
}

export interface ContainerExecutionHistory extends ContainerHistoryFacet {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderStepNId: string | null;
}

export interface InspectionValueFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `InspectionValue_Id` |
     * | Type | `Edm.Guid` |
     */
    InspectionValue_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `InspectionValue` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.InspectionValue` |
     */
    InspectionValue?: InspectionValue | null;
}

export type InspectionValueFacetId = string | {Id: string};

export interface QualityGateOnInspectionValue extends InspectionValueFacet {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `QualityGateNId` |
     * | Type | `Edm.String` |
     */
    QualityGateNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActivityNId` |
     * | Type | `Edm.String` |
     */
    ActivityNId: string | null;
}

export interface RuntimeCharacteristicRepresentationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RuntimeCharacteristicRepresentation_Id` |
     * | Type | `Edm.Guid` |
     */
    RuntimeCharacteristicRepresentation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RuntimeCharacteristicRepresentation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.RuntimeCharacteristicRepresentation` |
     */
    RuntimeCharacteristicRepresentation?: RuntimeCharacteristicRepresentation | null;
}

export type RuntimeCharacteristicRepresentationFacetId = string | {Id: string};

export interface ActivityToBeUsedInspection extends RuntimeCharacteristicRepresentationFacet {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActivityNId` |
     * | Type | `Edm.String` |
     */
    ActivityNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefaultResultValue` |
     * | Type | `Edm.String` |
     */
    DefaultResultValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefaultResultStrategy` |
     * | Type | `Edm.String` |
     */
    DefaultResultStrategy: string | null;
}

export interface CharacteristicSpecificationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CharacteristicSpecification_Id` |
     * | Type | `Edm.Guid` |
     */
    CharacteristicSpecification_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CharacteristicSpecification` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.CharacteristicSpecification` |
     */
    CharacteristicSpecification?: CharacteristicSpecification | null;
}

export type CharacteristicSpecificationFacetId = string | {Id: string};

export interface BuyOffCharacteristic extends CharacteristicSpecificationFacet {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsBuyOff` |
     * | Type | `Edm.Boolean` |
     */
    IsBuyOff: boolean | null;
}

export interface MaterialTrackingUnitAggregateFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialTrackingUnitAggregate_Id` |
     * | Type | `Edm.Guid` |
     */
    MaterialTrackingUnitAggregate_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialTrackingUnitAggregate` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.MaterialTrackingUnitAggregate` |
     */
    MaterialTrackingUnitAggregate?: MaterialTrackingUnitAggregate | null;
}

export type MaterialTrackingUnitAggregateFacetId = string | {Id: string};

export interface Container extends MaterialTrackingUnitAggregateFacet {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContainerTypeNId` |
     * | Type | `Edm.String` |
     */
    ContainerTypeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsReusable` |
     * | Type | `Edm.Boolean` |
     */
    IsReusable: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceEquipmentNId` |
     * | Type | `Edm.String` |
     */
    SourceEquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetEquipmentNId` |
     * | Type | `Edm.String` |
     */
    TargetEquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsContainer` |
     * | Type | `Edm.Boolean` |
     */
    IsContainer: boolean | null;
}

export interface ContainerExecution extends MaterialTrackingUnitAggregateFacet {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderNId: string | null;
}

export interface DM_MaterialTrackingUnitHistoryFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnitHistory_Id` |
     * | Type | `Edm.Guid` |
     */
    DM_MaterialTrackingUnitHistory_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnitHistory` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DM_MaterialTrackingUnitHistory` |
     */
    DM_MaterialTrackingUnitHistory?: DM_MaterialTrackingUnitHistory | null;
}

export type DM_MaterialTrackingUnitHistoryFacetId = string | {Id: string};

export interface QualityGateOnDM_MaterialTrackingUnitHistory extends DM_MaterialTrackingUnitHistoryFacet {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `QualityGateNId` |
     * | Type | `Edm.String` |
     */
    QualityGateNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActivityNId` |
     * | Type | `Edm.String` |
     */
    ActivityNId: string | null;
}

export interface ContainerDM_MaterialTrackingUnitHistory extends DM_MaterialTrackingUnitHistoryFacet {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContainerNId` |
     * | Type | `Edm.String` |
     */
    ContainerNId: string | null;
}

export interface ATNAcquisitionMTUHistory extends DM_MaterialTrackingUnitHistoryFacet {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ATNAcquisitionHistoryAssociation` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.FB_OP_AGWInt.OPModel.Types.ReadingModel.ATNAcquisitionHistoryAssociationValueType_Siemens_SimaticIT_U4DM_OperationalData_FB_OP_AGWInt_OPModel_Types` |
     * | Nullable | `false` |
     */
    ATNAcquisitionHistoryAssociation: ATNAcquisitionHistoryAssociationValueType_Siemens_SimaticIT_U4DM_OperationalData_FB_OP_AGWInt_OPModel_Types;
}

export interface DM_MaterialTrackingUnitFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnit_Id` |
     * | Type | `Edm.Guid` |
     */
    DM_MaterialTrackingUnit_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnit` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DM_MaterialTrackingUnit` |
     */
    DM_MaterialTrackingUnit?: DM_MaterialTrackingUnit | null;
}

export type DM_MaterialTrackingUnitFacetId = string | {Id: string};

export interface AMPowderMaterialTrackingUnit extends DM_MaterialTrackingUnitFacet {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaxRecycleCount` |
     * | Type | `Edm.Int32` |
     */
    MaxRecycleCount: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RecycleCount` |
     * | Type | `Edm.Int32` |
     */
    RecycleCount: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MinQuantity` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.QuantityType` |
     * | Nullable | `false` |
     */
    MinQuantity: QuantityType;
}

export interface MaterialFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Material_Id` |
     * | Type | `Edm.Guid` |
     */
    Material_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Material` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Material` |
     */
    Material?: Material | null;
}

export type MaterialFacetId = string | {Id: string};

export interface MaterialATNInstanceParameterAssociation extends MaterialFacet {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialParameterNId` |
     * | Type | `Edm.String` |
     */
    MaterialParameterNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ATNInstanceParameter` |
     * | Type | `Siemens.SimaticIT.U4DM.MasterData.FB_MS_AGWInt.MSModel.Types.ReadingModel.ATNInstanceValueType_Siemens_SimaticIT_U4DM_MasterData_FB_MS_AGWInt_MSModel_Types` |
     * | Nullable | `false` |
     */
    ATNInstanceParameter: ATNInstanceValueType_Siemens_SimaticIT_U4DM_MasterData_FB_MS_AGWInt_MSModel_Types;
}

export interface DM_MaterialFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_Material_Id` |
     * | Type | `Edm.Guid` |
     */
    DM_Material_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_Material` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DM_Material` |
     */
    DM_Material?: DM_Material | null;
}

export type DM_MaterialFacetId = string | {Id: string};

export interface AMPowder extends DM_MaterialFacet {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaxRecycleCount` |
     * | Type | `Edm.Int32` |
     */
    MaxRecycleCount: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MinQuantity` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.QuantityType` |
     * | Nullable | `false` |
     */
    MinQuantity: QuantityType;
}

export interface WIDefinitionToWOOperationAssociationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WIDefinitionToWOOperationAssociation_Id` |
     * | Type | `Edm.Guid` |
     */
    WIDefinitionToWOOperationAssociation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WIDefinitionToWOOperationAssociation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WIDefinitionToWOOperationAssociation` |
     */
    WIDefinitionToWOOperationAssociation?: WIDefinitionToWOOperationAssociation | null;
}

export type WIDefinitionToWOOperationAssociationFacetId = string | {Id: string};

export interface ActivityWorkInstruction extends WIDefinitionToWOOperationAssociationFacet {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActivityNId` |
     * | Type | `Edm.String` |
     */
    ActivityNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefaultResultValue` |
     * | Type | `Edm.String` |
     */
    DefaultResultValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefaultResultStrategy` |
     * | Type | `Edm.String` |
     */
    DefaultResultStrategy: string | null;
}

export interface WorkInstructionStepItemFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionStepItem_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkInstructionStepItem_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionStepItem` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkInstructionStepItem` |
     */
    WorkInstructionStepItem?: WorkInstructionStepItem | null;
}

export type WorkInstructionStepItemFacetId = string | {Id: string};

export interface QualityGateOnWorkInstructionStepItem extends WorkInstructionStepItemFacet {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `QualityGateNId` |
     * | Type | `Edm.String` |
     */
    QualityGateNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActivityNId` |
     * | Type | `Edm.String` |
     */
    ActivityNId: string | null;
}

export interface ATNAcquisitionHistoryAssociation extends WorkInstructionStepItemFacet {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ATNParameterValue` |
     * | Type | `Edm.String` |
     */
    ATNParameterValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ATNAcquisitionHistoryParameter` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.FB_OP_AGWInt.OPModel.Types.ReadingModel.ATNAcquisitionHistoryAssociationValueType_Siemens_SimaticIT_U4DM_OperationalData_FB_OP_AGWInt_OPModel_Types` |
     * | Nullable | `false` |
     */
    ATNAcquisitionHistoryParameter: ATNAcquisitionHistoryAssociationValueType_Siemens_SimaticIT_U4DM_OperationalData_FB_OP_AGWInt_OPModel_Types;
}

export interface WorkInstructionStepFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionStep_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkInstructionStep_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionStep` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkInstructionStep` |
     */
    WorkInstructionStep?: WorkInstructionStep | null;
}

export type WorkInstructionStepFacetId = string | {Id: string};

export interface QualityGateOnWorkInstructionStep extends WorkInstructionStepFacet {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActivityNId` |
     * | Type | `Edm.String` |
     */
    ActivityNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `QualityGateNId` |
     * | Type | `Edm.String` |
     */
    QualityGateNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationNId: string | null;
}

export interface WorkInstructionFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstruction_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkInstruction_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstruction` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkInstruction` |
     */
    WorkInstruction?: WorkInstruction | null;
}

export type WorkInstructionFacetId = string | {Id: string};

export interface WIResult2 extends WorkInstructionFacet {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsKo` |
     * | Type | `Edm.Boolean` |
     */
    IsKo: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsRepeated` |
     * | Type | `Edm.Boolean` |
     */
    IsRepeated: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CanBeRepeated` |
     * | Type | `Edm.Boolean` |
     */
    CanBeRepeated: boolean | null;
}

export interface WorkInstructionDefinitionParameterFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionDefinitionParameter_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkInstructionDefinitionParameter_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionDefinitionParameter` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkInstructionDefinitionParameter` |
     */
    WorkInstructionDefinitionParameter?: WorkInstructionDefinitionParameter | null;
}

export type WorkInstructionDefinitionParameterFacetId = string | {Id: string};

export interface WIDefinitionATNInstanceParameterAssociation extends WorkInstructionDefinitionParameterFacet {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ATNInstanceParameter` |
     * | Type | `Siemens.SimaticIT.U4DM.MasterData.FB_MS_AGWInt.MSModel.Types.ReadingModel.ATNInstanceValueType_Siemens_SimaticIT_U4DM_MasterData_FB_MS_AGWInt_MSModel_Types` |
     * | Nullable | `false` |
     */
    ATNInstanceParameter: ATNInstanceValueType_Siemens_SimaticIT_U4DM_MasterData_FB_MS_AGWInt_MSModel_Types;
}

export interface ToolDefinitionFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolDefinition_Id` |
     * | Type | `Edm.Guid` |
     */
    ToolDefinition_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolDefinition` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToolDefinition` |
     */
    ToolDefinition?: ToolDefinition | null;
}

export type ToolDefinitionFacetId = string | {Id: string};

export interface ToolDefinitionATNInstanceParameterAssociation extends ToolDefinitionFacet {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolDefinitionParameterNId` |
     * | Type | `Edm.String` |
     */
    ToolDefinitionParameterNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ATNInstanceParameter` |
     * | Type | `Siemens.SimaticIT.U4DM.MasterData.FB_MS_AGWInt.MSModel.Types.ReadingModel.ATNInstanceValueType_Siemens_SimaticIT_U4DM_MasterData_FB_MS_AGWInt_MSModel_Types` |
     * | Nullable | `false` |
     */
    ATNInstanceParameter: ATNInstanceValueType_Siemens_SimaticIT_U4DM_MasterData_FB_MS_AGWInt_MSModel_Types;
}

export interface SubstrateDefinition extends ToolDefinitionFacet {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutomaticThicknessDecrease` |
     * | Type | `Edm.Boolean` |
     */
    AutomaticThicknessDecrease: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaxTreatmentCountHold` |
     * | Type | `Edm.Int32` |
     */
    MaxTreatmentCountHold: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaxTreatmentCountWarning` |
     * | Type | `Edm.Int32` |
     */
    MaxTreatmentCountWarning: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MinThicknessHold` |
     * | Type | `Edm.Decimal` |
     */
    MinThicknessHold: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MinThicknessWarning` |
     * | Type | `Edm.Decimal` |
     */
    MinThicknessWarning: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ThicknessDecreaseAmount` |
     * | Type | `Edm.Decimal` |
     */
    ThicknessDecreaseAmount: number | null;
}

export interface WorkOrderOperationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderOperation` |
     */
    WorkOrderOperation?: WorkOrderOperation | null;
}

export type WorkOrderOperationFacetId = string | {Id: string};

export interface ResultQuantity extends WorkOrderOperationFacet {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `KoQuantity` |
     * | Type | `Edm.Decimal` |
     */
    KoQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OkQuantity` |
     * | Type | `Edm.Decimal` |
     */
    OkQuantity: number | null;
}

export interface Offline extends WorkOrderOperationFacet {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CheckedOut` |
     * | Type | `Edm.Boolean` |
     */
    CheckedOut: boolean | null;
}

export interface WorkOrderHistoryMaterialItemFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderHistoryMaterialItem_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderHistoryMaterialItem_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderHistoryMaterialItem` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderHistoryMaterialItem` |
     */
    WorkOrderHistoryMaterialItem?: WorkOrderHistoryMaterialItem | null;
}

export type WorkOrderHistoryMaterialItemFacetId = string | {Id: string};

export interface ActionResult extends WorkOrderHistoryMaterialItemFacet {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResultValue` |
     * | Type | `Edm.String` |
     */
    ResultValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsKo` |
     * | Type | `Edm.Boolean` |
     */
    IsKo: boolean | null;
}

export interface ContainerWorkOrderHistory extends WorkOrderHistoryMaterialItemFacet {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContainerNId` |
     * | Type | `Edm.String` |
     */
    ContainerNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
}

export interface WorkOrderHistoryFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderHistory_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderHistory_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderHistory` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderHistory` |
     */
    WorkOrderHistory?: WorkOrderHistory | null;
}

export type WorkOrderHistoryFacetId = string | {Id: string};

export interface ATNTransmissionWorkOrderHistory extends WorkOrderHistoryFacet {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ATNTransmissionWorkOrderHistoryAssociation` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.FB_OP_AGWInt.OPModel.Types.ReadingModel.ATNTransmissionHistoryAssociationValueType_Siemens_SimaticIT_U4DM_OperationalData_FB_OP_AGWInt_OPModel_Types` |
     * | Nullable | `false` |
     */
    ATNTransmissionWorkOrderHistoryAssociation: ATNTransmissionHistoryAssociationValueType_Siemens_SimaticIT_U4DM_OperationalData_FB_OP_AGWInt_OPModel_Types;
}

export interface ActivityManagement extends WorkOrderFacet {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreateWithActivity` |
     * | Type | `Edm.Boolean` |
     */
    CreateWithActivity: boolean | null;
}

export interface ToolHistoryFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolHistory_Id` |
     * | Type | `Edm.Guid` |
     */
    ToolHistory_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolHistory` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToolHistory` |
     */
    ToolHistory?: ToolHistory | null;
}

export type ToolHistoryFacetId = string | {Id: string};

export interface ToolUsageQualityGate extends ToolHistoryFacet {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `QualityGateNId` |
     * | Type | `Edm.String` |
     */
    QualityGateNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActivityNId` |
     * | Type | `Edm.String` |
     */
    ActivityNId: string | null;
}

export interface ContainerToolHistory extends ToolHistoryFacet {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContainerNId` |
     * | Type | `Edm.String` |
     */
    ContainerNId: string | null;
}

export interface ATNDataTransmissionToolHistory extends ToolHistoryFacet {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ATNTransmissionToolHistoryAssociation` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.FB_OP_AGWInt.OPModel.Types.ReadingModel.ATNTransmissionHistoryAssociationValueType_Siemens_SimaticIT_U4DM_OperationalData_FB_OP_AGWInt_OPModel_Types` |
     * | Nullable | `false` |
     */
    ATNTransmissionToolHistoryAssociation: ATNTransmissionHistoryAssociationValueType_Siemens_SimaticIT_U4DM_OperationalData_FB_OP_AGWInt_OPModel_Types;
}

export interface ATNAcquisitionToolHistory extends ToolHistoryFacet {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ATNAcquisitionHistoryAssociation` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.FB_OP_AGWInt.OPModel.Types.ReadingModel.ATNAcquisitionHistoryAssociationValueType_Siemens_SimaticIT_U4DM_OperationalData_FB_OP_AGWInt_OPModel_Types` |
     * | Nullable | `false` |
     */
    ATNAcquisitionHistoryAssociation: ATNAcquisitionHistoryAssociationValueType_Siemens_SimaticIT_U4DM_OperationalData_FB_OP_AGWInt_OPModel_Types;
}

export interface ToolFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Tool_Id` |
     * | Type | `Edm.Guid` |
     */
    Tool_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Tool` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Tool` |
     */
    Tool?: Tool | null;
}

export type ToolFacetId = string | {Id: string};

export interface Substrate extends ToolFacet {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutomaticThicknessDecrease` |
     * | Type | `Edm.Boolean` |
     */
    AutomaticThicknessDecrease: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CurrentThickness` |
     * | Type | `Edm.Decimal` |
     */
    CurrentThickness: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaxTreatmentCountHold` |
     * | Type | `Edm.Int32` |
     */
    MaxTreatmentCountHold: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaxTreatmentCountWarning` |
     * | Type | `Edm.Int32` |
     */
    MaxTreatmentCountWarning: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MinThicknessHold` |
     * | Type | `Edm.Decimal` |
     */
    MinThicknessHold: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MinThicknessWarning` |
     * | Type | `Edm.Decimal` |
     */
    MinThicknessWarning: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TreatmentCount` |
     * | Type | `Edm.Int32` |
     */
    TreatmentCount: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ThicknessDescreaseAmount` |
     * | Type | `Edm.Decimal` |
     */
    ThicknessDescreaseAmount: number | null;
}

export interface ToBeUsedToolFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedTool_Id` |
     * | Type | `Edm.Guid` |
     */
    ToBeUsedTool_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedTool` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToBeUsedTool` |
     */
    ToBeUsedTool?: ToBeUsedTool | null;
}

export type ToBeUsedToolFacetId = string | {Id: string};

export interface ActivityToBeUsedTool extends ToBeUsedToolFacet {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActivityNId` |
     * | Type | `Edm.String` |
     */
    ActivityNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefaultResultValue` |
     * | Type | `Edm.String` |
     */
    DefaultResultValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefaultResultStrategy` |
     * | Type | `Edm.String` |
     */
    DefaultResultStrategy: string | null;
}

export interface ActiveMaterialTrackingUnit extends ToBeUsedToolFacet {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnitId` |
     * | Type | `Edm.Guid` |
     */
    DM_MaterialTrackingUnitId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialTrackingUnitNId` |
     * | Type | `Edm.String` |
     */
    MaterialTrackingUnitNId: string | null;
}

export interface ScrewingOperationCharacteristics extends ToBeUsedToolFacet {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AngleValueMin` |
     * | Type | `Edm.Decimal` |
     */
    AngleValueMin: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TorqueValueMin` |
     * | Type | `Edm.Decimal` |
     */
    TorqueValueMin: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AngleValueMax` |
     * | Type | `Edm.Decimal` |
     */
    AngleValueMax: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TorqueValueMax` |
     * | Type | `Edm.Decimal` |
     */
    TorqueValueMax: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NumberOfBolts` |
     * | Type | `Edm.Int32` |
     */
    NumberOfBolts: number | null;
}

export interface ToBeProducedMaterialFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeProducedMaterial_Id` |
     * | Type | `Edm.Guid` |
     */
    ToBeProducedMaterial_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeProducedMaterial` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToBeProducedMaterial` |
     */
    ToBeProducedMaterial?: ToBeProducedMaterial | null;
}

export type ToBeProducedMaterialFacetId = string | {Id: string};

export interface Repeat extends ToBeProducedMaterialFacet {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsKo` |
     * | Type | `Edm.Boolean` |
     */
    IsKo: boolean | null;
}

export interface ToBeConsumedMaterialFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeConsumedMaterial_Id` |
     * | Type | `Edm.Guid` |
     */
    ToBeConsumedMaterial_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeConsumedMaterial` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToBeConsumedMaterial` |
     */
    ToBeConsumedMaterial?: ToBeConsumedMaterial | null;
}

export type ToBeConsumedMaterialFacetId = string | {Id: string};

export interface ActivityToBeConsumedMaterial extends ToBeConsumedMaterialFacet {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActivityNId` |
     * | Type | `Edm.String` |
     */
    ActivityNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefaultResultValue` |
     * | Type | `Edm.String` |
     */
    DefaultResultValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefaultResultStrategy` |
     * | Type | `Edm.String` |
     */
    DefaultResultStrategy: string | null;
}

export interface NonConformanceHistoryFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceHistory_Id` |
     * | Type | `Edm.Guid` |
     */
    NonConformanceHistory_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceHistory` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NonConformanceHistory` |
     */
    NonConformanceHistory?: NonConformanceHistory | null;
}

export type NonConformanceHistoryFacetId = string | {Id: string};

export interface BuyOffHistory extends NonConformanceHistoryFacet {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualValue` |
     * | Type | `Edm.String` |
     */
    ActualValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ScenarioInstanceId` |
     * | Type | `Edm.Guid` |
     */
    ScenarioInstanceId: string | null;
}

export interface ContainerNonConformanceHistory extends NonConformanceHistoryFacet {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContainerNId` |
     * | Type | `Edm.String` |
     */
    ContainerNId: string | null;
}

export interface NonConformanceFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformance_Id` |
     * | Type | `Edm.Guid` |
     */
    NonConformance_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformance` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NonConformance` |
     */
    NonConformance?: NonConformance | null;
}

export type NonConformanceFacetId = string | {Id: string};

export interface ChangeRouting extends NonConformanceFacet {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CloseNotes` |
     * | Type | `Edm.String` |
     */
    CloseNotes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RefNumber` |
     * | Type | `Edm.String` |
     */
    RefNumber: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NewOperationFrom` |
     * | Type | `Edm.String` |
     */
    NewOperationFrom: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NewOperationTo` |
     * | Type | `Edm.String` |
     */
    NewOperationTo: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NewDependency` |
     * | Type | `Edm.String` |
     */
    NewDependency: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OldOperationFrom` |
     * | Type | `Edm.String` |
     */
    OldOperationFrom: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OldOperationTo` |
     * | Type | `Edm.String` |
     */
    OldOperationTo: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OldDependency` |
     * | Type | `Edm.String` |
     */
    OldDependency: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChangeType` |
     * | Type | `Edm.Guid` |
     */
    ChangeType: string | null;
}

export interface ChangeTool extends NonConformanceFacet {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NewToolDefinitionName` |
     * | Type | `Edm.String` |
     */
    NewToolDefinitionName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RefNumber` |
     * | Type | `Edm.String` |
     */
    RefNumber: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CloseNotes` |
     * | Type | `Edm.String` |
     */
    CloseNotes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolUsageNumber` |
     * | Type | `Edm.Decimal` |
     */
    ToolUsageNumber: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChangeType` |
     * | Type | `Edm.Guid` |
     */
    ChangeType: string | null;
}

export interface BuyOff extends NonConformanceFacet {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RuntimeCharRepresentationNId` |
     * | Type | `Edm.String` |
     */
    RuntimeCharRepresentationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStepId: string | null;
}

export interface ChangePart extends NonConformanceFacet {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CloseNotes` |
     * | Type | `Edm.String` |
     */
    CloseNotes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogicalPosition` |
     * | Type | `Edm.String` |
     */
    LogicalPosition: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NewPart` |
     * | Type | `Edm.String` |
     */
    NewPart: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NewPartQuantity` |
     * | Type | `Edm.Decimal` |
     */
    NewPartQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OldPart` |
     * | Type | `Edm.String` |
     */
    OldPart: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OldPartQuantity` |
     * | Type | `Edm.Decimal` |
     */
    OldPartQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RefNumber` |
     * | Type | `Edm.String` |
     */
    RefNumber: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChangeType` |
     * | Type | `Edm.Guid` |
     */
    ChangeType: string | null;
}

export interface ChangeOperation extends NonConformanceFacet {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CloseNotes` |
     * | Type | `Edm.String` |
     */
    CloseNotes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NewOperationName` |
     * | Type | `Edm.String` |
     */
    NewOperationName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentName` |
     * | Type | `Edm.String` |
     */
    EquipmentName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationNameList` |
     * | Type | `Edm.String` |
     */
    OperationNameList: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RefNumber` |
     * | Type | `Edm.String` |
     */
    RefNumber: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RoutingOperationAfter` |
     * | Type | `Edm.String` |
     */
    RoutingOperationAfter: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SequenceAfter` |
     * | Type | `Edm.Guid` |
     */
    SequenceAfter: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OldOperationName` |
     * | Type | `Edm.String` |
     */
    OldOperationName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChangeType` |
     * | Type | `Edm.Guid` |
     */
    ChangeType: string | null;
}

export interface ChangeDataCollection extends NonConformanceFacet {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CloseNotes` |
     * | Type | `Edm.String` |
     */
    CloseNotes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReferenceWorkorderOperations` |
     * | Type | `Edm.String` |
     */
    ReferenceWorkorderOperations: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RefNumber` |
     * | Type | `Edm.String` |
     */
    RefNumber: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WIDefinition` |
     * | Type | `Edm.String` |
     */
    WIDefinition: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChangeType` |
     * | Type | `Edm.Guid` |
     */
    ChangeType: string | null;
}

export interface ActualUsedToolFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualUsedTool_Id` |
     * | Type | `Edm.Guid` |
     */
    ActualUsedTool_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualUsedTool` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ActualUsedTool` |
     */
    ActualUsedTool?: ActualUsedTool | null;
}

export type ActualUsedToolFacetId = string | {Id: string};

export interface QualityGateOnActualUsedTool extends ActualUsedToolFacet {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `QualityGateNId` |
     * | Type | `Edm.String` |
     */
    QualityGateNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActivityNId` |
     * | Type | `Edm.String` |
     */
    ActivityNId: string | null;
}

export interface ActualConsumedMaterialFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualConsumedMaterial_Id` |
     * | Type | `Edm.Guid` |
     */
    ActualConsumedMaterial_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualConsumedMaterial` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ActualConsumedMaterial` |
     */
    ActualConsumedMaterial?: ActualConsumedMaterial | null;
}

export type ActualConsumedMaterialFacetId = string | {Id: string};

export interface QualityGateOnActualConsumedMaterial extends ActualConsumedMaterialFacet {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `QualityGateNId` |
     * | Type | `Edm.String` |
     */
    QualityGateNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActivityNId` |
     * | Type | `Edm.String` |
     */
    ActivityNId: string | null;
}

export interface EquipmentConfigurationToAutomationNodeInstanceFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationToAutomationNodeInstance_Id` |
     * | Type | `Edm.Guid` |
     */
    EquipmentConfigurationToAutomationNodeInstance_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationToAutomationNodeInstance` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentConfigurationToAutomationNodeInstance` |
     */
    EquipmentConfigurationToAutomationNodeInstance?: EquipmentConfigurationToAutomationNodeInstance | null;
}

export type EquipmentConfigurationToAutomationNodeInstanceFacetId = string | {Id: string};

export interface InspectionOperationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `InspectionOperation_Id` |
     * | Type | `Edm.Guid` |
     */
    InspectionOperation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `InspectionOperation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.InspectionOperation` |
     */
    InspectionOperation?: InspectionOperation | null;
}

export type InspectionOperationFacetId = string | {Id: string};

export interface WorkOrderOperationToolInfoFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationToolInfo_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationToolInfo_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationToolInfo` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderOperationToolInfo` |
     */
    WorkOrderOperationToolInfo?: WorkOrderOperationToolInfo | null;
}

export type WorkOrderOperationToolInfoFacetId = string | {Id: string};

export interface ScrewingToolHistoryFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ScrewingToolHistory_Id` |
     * | Type | `Edm.Guid` |
     */
    ScrewingToolHistory_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ScrewingToolHistory` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ScrewingToolHistory` |
     */
    ScrewingToolHistory?: ScrewingToolHistory | null;
}

export type ScrewingToolHistoryFacetId = string | {Id: string};

export interface TaskContextUserFieldFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskContextUserField_Id` |
     * | Type | `Edm.Guid` |
     */
    TaskContextUserField_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskContextUserField` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.TaskContextUserField` |
     */
    TaskContextUserField?: TaskContextUserField | null;
}

export type TaskContextUserFieldFacetId = string | {Id: string};

export interface TaskContextFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskContext_Id` |
     * | Type | `Edm.Guid` |
     */
    TaskContext_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskContext` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.TaskContext` |
     */
    TaskContext?: TaskContext | null;
}

export type TaskContextFacetId = string | {Id: string};

export interface TaskFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Task_Id` |
     * | Type | `Edm.Guid` |
     */
    Task_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Task` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Task` |
     */
    Task?: Task | null;
}

export type TaskFacetId = string | {Id: string};

export interface TaskContextDefinitionUserFieldFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskContextDefinitionUserField_Id` |
     * | Type | `Edm.Guid` |
     */
    TaskContextDefinitionUserField_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskContextDefinitionUserField` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.TaskContextDefinitionUserField` |
     */
    TaskContextDefinitionUserField?: TaskContextDefinitionUserField | null;
}

export type TaskContextDefinitionUserFieldFacetId = string | {Id: string};

export interface TaskDefinitionFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskDefinition_Id` |
     * | Type | `Edm.Guid` |
     */
    TaskDefinition_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskDefinition` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.TaskDefinition` |
     */
    TaskDefinition?: TaskDefinition | null;
}

export type TaskDefinitionFacetId = string | {Id: string};

export interface TaskContextDefinitionFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskContextDefinition_Id` |
     * | Type | `Edm.Guid` |
     */
    TaskContextDefinition_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskContextDefinition` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.TaskContextDefinition` |
     */
    TaskContextDefinition?: TaskContextDefinition | null;
}

export type TaskContextDefinitionFacetId = string | {Id: string};

export interface FeatureValueFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FeatureValue_Id` |
     * | Type | `Edm.Guid` |
     */
    FeatureValue_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FeatureValue` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.FeatureValue` |
     */
    FeatureValue?: FeatureValue | null;
}

export type FeatureValueFacetId = string | {Id: string};

export interface FeatureFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Feature_Id` |
     * | Type | `Edm.Guid` |
     */
    Feature_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Feature` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Feature` |
     */
    Feature?: Feature | null;
}

export type FeatureFacetId = string | {Id: string};

export interface BillOfFeatureItemFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BillOfFeatureItem_Id` |
     * | Type | `Edm.Guid` |
     */
    BillOfFeatureItem_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BillOfFeatureItem` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.BillOfFeatureItem` |
     */
    BillOfFeatureItem?: BillOfFeatureItem | null;
}

export type BillOfFeatureItemFacetId = string | {Id: string};

export interface ToBeUsedBillOfFeatureFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedBillOfFeature_Id` |
     * | Type | `Edm.Guid` |
     */
    ToBeUsedBillOfFeature_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedBillOfFeature` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToBeUsedBillOfFeature` |
     */
    ToBeUsedBillOfFeature?: ToBeUsedBillOfFeature | null;
}

export type ToBeUsedBillOfFeatureFacetId = string | {Id: string};

export interface BillOfFeatureFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BillOfFeature_Id` |
     * | Type | `Edm.Guid` |
     */
    BillOfFeature_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BillOfFeature` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.BillOfFeature` |
     */
    BillOfFeature?: BillOfFeature | null;
}

export type BillOfFeatureFacetId = string | {Id: string};

export interface NumberingPatternEntityInfoFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NumberingPatternEntityInfo_Id` |
     * | Type | `Edm.Guid` |
     */
    NumberingPatternEntityInfo_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NumberingPatternEntityInfo` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NumberingPatternEntityInfo` |
     */
    NumberingPatternEntityInfo?: NumberingPatternEntityInfo | null;
}

export type NumberingPatternEntityInfoFacetId = string | {Id: string};

export interface NumberingPatternMaterialAssociationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NumberingPatternMaterialAssociation_Id` |
     * | Type | `Edm.Guid` |
     */
    NumberingPatternMaterialAssociation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NumberingPatternMaterialAssociation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NumberingPatternMaterialAssociation` |
     */
    NumberingPatternMaterialAssociation?: NumberingPatternMaterialAssociation | null;
}

export type NumberingPatternMaterialAssociationFacetId = string | {Id: string};

export interface ExtEventLogFailureNotificationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExtEventLogFailureNotification_Id` |
     * | Type | `Edm.Guid` |
     */
    ExtEventLogFailureNotification_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExtEventLogFailureNotification` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ExtEventLogFailureNotification` |
     */
    ExtEventLogFailureNotification?: ExtEventLogFailureNotification | null;
}

export type ExtEventLogFailureNotificationFacetId = string | {Id: string};

export interface ToBeUsedSetPointItemATNInstanceAssociationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedSetPointItemATNInstanceAssociation_Id` |
     * | Type | `Edm.Guid` |
     */
    ToBeUsedSetPointItemATNInstanceAssociation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedSetPointItemATNInstanceAssociation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToBeUsedSetPointItemATNInstanceAssociation` |
     */
    ToBeUsedSetPointItemATNInstanceAssociation?: ToBeUsedSetPointItemATNInstanceAssociation | null;
}

export type ToBeUsedSetPointItemATNInstanceAssociationFacetId = string | {Id: string};

export interface RuntimeCharReprRefOperationAssociationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RuntimeCharReprRefOperationAssociation_Id` |
     * | Type | `Edm.Guid` |
     */
    RuntimeCharReprRefOperationAssociation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RuntimeCharReprRefOperationAssociation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.RuntimeCharReprRefOperationAssociation` |
     */
    RuntimeCharReprRefOperationAssociation?: RuntimeCharReprRefOperationAssociation | null;
}

export type RuntimeCharReprRefOperationAssociationFacetId = string | {Id: string};

export interface CharacteristicRepresentationFrequencyFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CharacteristicRepresentationFrequency_Id` |
     * | Type | `Edm.Guid` |
     */
    CharacteristicRepresentationFrequency_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CharacteristicRepresentationFrequency` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.CharacteristicRepresentationFrequency` |
     */
    CharacteristicRepresentationFrequency?: CharacteristicRepresentationFrequency | null;
}

export type CharacteristicRepresentationFrequencyFacetId = string | {Id: string};

export interface SignatureConfigurationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SignatureConfiguration_Id` |
     * | Type | `Edm.Guid` |
     */
    SignatureConfiguration_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SignatureConfiguration` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.SignatureConfiguration` |
     */
    SignatureConfiguration?: SignatureConfiguration | null;
}

export type SignatureConfigurationFacetId = string | {Id: string};

export interface ScenarioConfigurationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ScenarioConfiguration_Id` |
     * | Type | `Edm.Guid` |
     */
    ScenarioConfiguration_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ScenarioConfiguration` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ScenarioConfiguration` |
     */
    ScenarioConfiguration?: ScenarioConfiguration | null;
}

export type ScenarioConfigurationFacetId = string | {Id: string};

export interface OutMsgFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OutMsg_Id` |
     * | Type | `Edm.Guid` |
     */
    OutMsg_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OutMsg` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.OutMsg` |
     */
    OutMsg?: OutMsg | null;
}

export type OutMsgFacetId = string | {Id: string};

export interface DM_FunctionalCodeFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_FunctionalCode_Id` |
     * | Type | `Edm.Guid` |
     */
    DM_FunctionalCode_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_FunctionalCode` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DM_FunctionalCode` |
     */
    DM_FunctionalCode?: DM_FunctionalCode | null;
}

export type DM_FunctionalCodeFacetId = string | {Id: string};

export interface MaterialSupplierAssociationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialSupplierAssociation_Id` |
     * | Type | `Edm.Guid` |
     */
    MaterialSupplierAssociation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialSupplierAssociation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.MaterialSupplierAssociation` |
     */
    MaterialSupplierAssociation?: MaterialSupplierAssociation | null;
}

export type MaterialSupplierAssociationFacetId = string | {Id: string};

export interface WorkInstructionToExecutionGroupPhaseAssociationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionToExecutionGroupPhaseAssociation_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkInstructionToExecutionGroupPhaseAssociation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionToExecutionGroupPhaseAssociation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkInstructionToExecutionGroupPhaseAssociation` |
     */
    WorkInstructionToExecutionGroupPhaseAssociation?: WorkInstructionToExecutionGroupPhaseAssociation | null;
}

export type WorkInstructionToExecutionGroupPhaseAssociationFacetId = string | {Id: string};

export interface WIDefinitionToEGPhaseAssociationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WIDefinitionToEGPhaseAssociation_Id` |
     * | Type | `Edm.Guid` |
     */
    WIDefinitionToEGPhaseAssociation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WIDefinitionToEGPhaseAssociation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WIDefinitionToEGPhaseAssociation` |
     */
    WIDefinitionToEGPhaseAssociation?: WIDefinitionToEGPhaseAssociation | null;
}

export type WIDefinitionToEGPhaseAssociationFacetId = string | {Id: string};

export interface ResultTypeFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResultType_Id` |
     * | Type | `Edm.Guid` |
     */
    ResultType_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResultType` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ResultType` |
     */
    ResultType?: ResultType | null;
}

export type ResultTypeFacetId = string | {Id: string};

export interface ResultStrategyFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResultStrategy_Id` |
     * | Type | `Edm.Guid` |
     */
    ResultStrategy_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResultStrategy` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ResultStrategy` |
     */
    ResultStrategy?: ResultStrategy | null;
}

export type ResultStrategyFacetId = string | {Id: string};

export interface ResultHistoryActionFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResultHistoryAction_Id` |
     * | Type | `Edm.Guid` |
     */
    ResultHistoryAction_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResultHistoryAction` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ResultHistoryAction` |
     */
    ResultHistoryAction?: ResultHistoryAction | null;
}

export type ResultHistoryActionFacetId = string | {Id: string};

export interface ResultHistoryFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResultHistory_Id` |
     * | Type | `Edm.Guid` |
     */
    ResultHistory_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResultHistory` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ResultHistory` |
     */
    ResultHistory?: ResultHistory | null;
}

export type ResultHistoryFacetId = string | {Id: string};

export interface ResultFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Result_Id` |
     * | Type | `Edm.Guid` |
     */
    Result_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Result` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Result` |
     */
    Result?: Result | null;
}

export type ResultFacetId = string | {Id: string};

export interface ContainerCompatibleMaterialFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContainerCompatibleMaterial_Id` |
     * | Type | `Edm.Guid` |
     */
    ContainerCompatibleMaterial_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContainerCompatibleMaterial` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ContainerCompatibleMaterial` |
     */
    ContainerCompatibleMaterial?: ContainerCompatibleMaterial | null;
}

export type ContainerCompatibleMaterialFacetId = string | {Id: string};

export interface AttachmentFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Attachment_Id` |
     * | Type | `Edm.Guid` |
     */
    Attachment_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Attachment` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Attachment` |
     */
    Attachment?: Attachment | null;
}

export type AttachmentFacetId = string | {Id: string};

export interface QualityActionFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `QualityAction_Id` |
     * | Type | `Edm.Guid` |
     */
    QualityAction_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `QualityAction` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.QualityAction` |
     */
    QualityAction?: QualityAction | null;
}

export type QualityActionFacetId = string | {Id: string};

export interface FailureReferenceFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FailureReference_Id` |
     * | Type | `Edm.Guid` |
     */
    FailureReference_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FailureReference` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.FailureReference` |
     */
    FailureReference?: FailureReference | null;
}

export type FailureReferenceFacetId = string | {Id: string};

export interface FailureParentFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FailureParent_Id` |
     * | Type | `Edm.Guid` |
     */
    FailureParent_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FailureParent` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.FailureParent` |
     */
    FailureParent?: FailureParent | null;
}

export type FailureParentFacetId = string | {Id: string};

export interface FailureChildFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FailureChild_Id` |
     * | Type | `Edm.Guid` |
     */
    FailureChild_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FailureChild` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.FailureChild` |
     */
    FailureChild?: FailureChild | null;
}

export type FailureChildFacetId = string | {Id: string};

export interface FailureFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Failure_Id` |
     * | Type | `Edm.Guid` |
     */
    Failure_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Failure` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Failure` |
     */
    Failure?: Failure | null;
}

export type FailureFacetId = string | {Id: string};

export interface ExtObjectTypeFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExtObjectType_Id` |
     * | Type | `Edm.Guid` |
     */
    ExtObjectType_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExtObjectType` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ExtObjectType` |
     */
    ExtObjectType?: ExtObjectType | null;
}

export type ExtObjectTypeFacetId = string | {Id: string};

export interface ExtEventContextFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExtEventContext_Id` |
     * | Type | `Edm.Guid` |
     */
    ExtEventContext_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExtEventContext` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ExtEventContext` |
     */
    ExtEventContext?: ExtEventContext | null;
}

export type ExtEventContextFacetId = string | {Id: string};

export interface ExtEventTypeFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExtEventType_Id` |
     * | Type | `Edm.Guid` |
     */
    ExtEventType_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExtEventType` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ExtEventType` |
     */
    ExtEventType?: ExtEventType | null;
}

export type ExtEventTypeFacetId = string | {Id: string};

export interface ExtEventLogFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExtEventLog_Id` |
     * | Type | `Edm.Guid` |
     */
    ExtEventLog_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExtEventLog` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ExtEventLog` |
     */
    ExtEventLog?: ExtEventLog | null;
}

export type ExtEventLogFacetId = string | {Id: string};

export interface ContainerTypeDocumentFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContainerTypeDocument_Id` |
     * | Type | `Edm.Guid` |
     */
    ContainerTypeDocument_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContainerTypeDocument` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ContainerTypeDocument` |
     */
    ContainerTypeDocument?: ContainerTypeDocument | null;
}

export type ContainerTypeDocumentFacetId = string | {Id: string};

export interface ContainerTypeCompatibleMaterialFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContainerTypeCompatibleMaterial_Id` |
     * | Type | `Edm.Guid` |
     */
    ContainerTypeCompatibleMaterial_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContainerTypeCompatibleMaterial` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ContainerTypeCompatibleMaterial` |
     */
    ContainerTypeCompatibleMaterial?: ContainerTypeCompatibleMaterial | null;
}

export type ContainerTypeCompatibleMaterialFacetId = string | {Id: string};

export interface ContainerTypeFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContainerType_Id` |
     * | Type | `Edm.Guid` |
     */
    ContainerType_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContainerType` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ContainerType` |
     */
    ContainerType?: ContainerType | null;
}

export type ContainerTypeFacetId = string | {Id: string};

export interface OfflineActionAmendFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OfflineActionAmend_Id` |
     * | Type | `Edm.Guid` |
     */
    OfflineActionAmend_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OfflineActionAmend` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.OfflineActionAmend` |
     */
    OfflineActionAmend?: OfflineActionAmend | null;
}

export type OfflineActionAmendFacetId = string | {Id: string};

export interface OfflineActionFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OfflineAction_Id` |
     * | Type | `Edm.Guid` |
     */
    OfflineAction_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OfflineAction` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.OfflineAction` |
     */
    OfflineAction?: OfflineAction | null;
}

export type OfflineActionFacetId = string | {Id: string};

export interface OfflineSessionWOOperationAssociationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OfflineSessionWOOperationAssociation_Id` |
     * | Type | `Edm.Guid` |
     */
    OfflineSessionWOOperationAssociation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OfflineSessionWOOperationAssociation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.OfflineSessionWOOperationAssociation` |
     */
    OfflineSessionWOOperationAssociation?: OfflineSessionWOOperationAssociation | null;
}

export type OfflineSessionWOOperationAssociationFacetId = string | {Id: string};

export interface OfflineSessionFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OfflineSession_Id` |
     * | Type | `Edm.Guid` |
     */
    OfflineSession_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OfflineSession` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.OfflineSession` |
     */
    OfflineSession?: OfflineSession | null;
}

export type OfflineSessionFacetId = string | {Id: string};

export interface DM_MaterialTrackingUnitDocumentAssociationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnitDocumentAssociation_Id` |
     * | Type | `Edm.Guid` |
     */
    DM_MaterialTrackingUnitDocumentAssociation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnitDocumentAssociation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DM_MaterialTrackingUnitDocumentAssociation` |
     */
    DM_MaterialTrackingUnitDocumentAssociation?: DM_MaterialTrackingUnitDocumentAssociation | null;
}

export type DM_MaterialTrackingUnitDocumentAssociationFacetId = string | {Id: string};

export interface WorkOrderHumanResourceFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderHumanResource_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderHumanResource_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderHumanResource` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderHumanResource` |
     */
    WorkOrderHumanResource?: WorkOrderHumanResource | null;
}

export type WorkOrderHumanResourceFacetId = string | {Id: string};

export interface ActualCoProducedMaterialFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualCoProducedMaterial_Id` |
     * | Type | `Edm.Guid` |
     */
    ActualCoProducedMaterial_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualCoProducedMaterial` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ActualCoProducedMaterial` |
     */
    ActualCoProducedMaterial?: ActualCoProducedMaterial | null;
}

export type ActualCoProducedMaterialFacetId = string | {Id: string};

export interface ToBeCoProducedMaterialFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCoProducedMaterial_Id` |
     * | Type | `Edm.Guid` |
     */
    ToBeCoProducedMaterial_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCoProducedMaterial` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToBeCoProducedMaterial` |
     */
    ToBeCoProducedMaterial?: ToBeCoProducedMaterial | null;
}

export type ToBeCoProducedMaterialFacetId = string | {Id: string};

export interface CertificationSpecificationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CertificationSpecification_Id` |
     * | Type | `Edm.Guid` |
     */
    CertificationSpecification_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CertificationSpecification` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.CertificationSpecification` |
     */
    CertificationSpecification?: CertificationSpecification | null;
}

export type CertificationSpecificationFacetId = string | {Id: string};

export interface UserWorkOrderOperationAssociationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserWorkOrderOperationAssociation_Id` |
     * | Type | `Edm.Guid` |
     */
    UserWorkOrderOperationAssociation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserWorkOrderOperationAssociation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.UserWorkOrderOperationAssociation` |
     */
    UserWorkOrderOperationAssociation?: UserWorkOrderOperationAssociation | null;
}

export type UserWorkOrderOperationAssociationFacetId = string | {Id: string};

export interface RuntimePJFSerialNumberAssociationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RuntimePJFSerialNumberAssociation_Id` |
     * | Type | `Edm.Guid` |
     */
    RuntimePJFSerialNumberAssociation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RuntimePJFSerialNumberAssociation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.RuntimePJFSerialNumberAssociation` |
     */
    RuntimePJFSerialNumberAssociation?: RuntimePJFSerialNumberAssociation | null;
}

export type RuntimePJFSerialNumberAssociationFacetId = string | {Id: string};

export interface SetPointItemToolDefinitionATNTypeParameterAssociationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointItemToolDefinitionATNTypeParameterAssociation_Id` |
     * | Type | `Edm.Guid` |
     */
    SetPointItemToolDefinitionATNTypeParameterAssociation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointItemToolDefinitionATNTypeParameterAssociation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.SetPointItemToolDefinitionATNTypeParameterAssociation` |
     */
    SetPointItemToolDefinitionATNTypeParameterAssociation?: SetPointItemToolDefinitionATNTypeParameterAssociation | null;
}

export type SetPointItemToolDefinitionATNTypeParameterAssociationFacetId = string | {Id: string};

export interface MachineToDNCFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MachineToDNC_Id` |
     * | Type | `Edm.Guid` |
     */
    MachineToDNC_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MachineToDNC` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.MachineToDNC` |
     */
    MachineToDNC?: MachineToDNC | null;
}

export type MachineToDNCFacetId = string | {Id: string};

export interface DNCItemMachineMaterialAssociationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DNCItemMachineMaterialAssociation_Id` |
     * | Type | `Edm.Guid` |
     */
    DNCItemMachineMaterialAssociation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DNCItemMachineMaterialAssociation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DNCItemMachineMaterialAssociation` |
     */
    DNCItemMachineMaterialAssociation?: DNCItemMachineMaterialAssociation | null;
}

export type DNCItemMachineMaterialAssociationFacetId = string | {Id: string};

export interface DNCItemFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DNCItem_Id` |
     * | Type | `Edm.Guid` |
     */
    DNCItem_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DNCItem` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DNCItem` |
     */
    DNCItem?: DNCItem | null;
}

export type DNCItemFacetId = string | {Id: string};

export interface AutomationNodeTypeParameterFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutomationNodeTypeParameter_Id` |
     * | Type | `Edm.Guid` |
     */
    AutomationNodeTypeParameter_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutomationNodeTypeParameter` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.AutomationNodeTypeParameter` |
     */
    AutomationNodeTypeParameter?: AutomationNodeTypeParameter | null;
}

export type AutomationNodeTypeParameterFacetId = string | {Id: string};

export interface AutomationNodeTypeFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutomationNodeType_Id` |
     * | Type | `Edm.Guid` |
     */
    AutomationNodeType_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutomationNodeType` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.AutomationNodeType` |
     */
    AutomationNodeType?: AutomationNodeType | null;
}

export type AutomationNodeTypeFacetId = string | {Id: string};

export interface AutomationNodeInstanceParameterFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutomationNodeInstanceParameter_Id` |
     * | Type | `Edm.Guid` |
     */
    AutomationNodeInstanceParameter_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutomationNodeInstanceParameter` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.AutomationNodeInstanceParameter` |
     */
    AutomationNodeInstanceParameter?: AutomationNodeInstanceParameter | null;
}

export type AutomationNodeInstanceParameterFacetId = string | {Id: string};

export interface AutomationNodeInstanceFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutomationNodeInstance_Id` |
     * | Type | `Edm.Guid` |
     */
    AutomationNodeInstance_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutomationNodeInstance` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.AutomationNodeInstance` |
     */
    AutomationNodeInstance?: AutomationNodeInstance | null;
}

export type AutomationNodeInstanceFacetId = string | {Id: string};

export interface SetPointEquipmentTypeAssociationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointEquipmentTypeAssociation_Id` |
     * | Type | `Edm.Guid` |
     */
    SetPointEquipmentTypeAssociation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointEquipmentTypeAssociation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.SetPointEquipmentTypeAssociation` |
     */
    SetPointEquipmentTypeAssociation?: SetPointEquipmentTypeAssociation | null;
}

export type SetPointEquipmentTypeAssociationFacetId = string | {Id: string};

export interface SetPointToolAssociationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointToolAssociation_Id` |
     * | Type | `Edm.Guid` |
     */
    SetPointToolAssociation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointToolAssociation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.SetPointToolAssociation` |
     */
    SetPointToolAssociation?: SetPointToolAssociation | null;
}

export type SetPointToolAssociationFacetId = string | {Id: string};

export interface SetPointToolDefinitionAssociationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointToolDefinitionAssociation_Id` |
     * | Type | `Edm.Guid` |
     */
    SetPointToolDefinitionAssociation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointToolDefinitionAssociation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.SetPointToolDefinitionAssociation` |
     */
    SetPointToolDefinitionAssociation?: SetPointToolDefinitionAssociation | null;
}

export type SetPointToolDefinitionAssociationFacetId = string | {Id: string};

export interface ToolAutomationNodeInstanceAssociationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolAutomationNodeInstanceAssociation_Id` |
     * | Type | `Edm.Guid` |
     */
    ToolAutomationNodeInstanceAssociation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolAutomationNodeInstanceAssociation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToolAutomationNodeInstanceAssociation` |
     */
    ToolAutomationNodeInstanceAssociation?: ToolAutomationNodeInstanceAssociation | null;
}

export type ToolAutomationNodeInstanceAssociationFacetId = string | {Id: string};

export interface ToolDefinitionAutomationNodeTypeAssociationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolDefinitionAutomationNodeTypeAssociation_Id` |
     * | Type | `Edm.Guid` |
     */
    ToolDefinitionAutomationNodeTypeAssociation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolDefinitionAutomationNodeTypeAssociation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToolDefinitionAutomationNodeTypeAssociation` |
     */
    ToolDefinitionAutomationNodeTypeAssociation?: ToolDefinitionAutomationNodeTypeAssociation | null;
}

export type ToolDefinitionAutomationNodeTypeAssociationFacetId = string | {Id: string};

export interface SetPointItemDefaultValueFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointItemDefaultValue_Id` |
     * | Type | `Edm.Guid` |
     */
    SetPointItemDefaultValue_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointItemDefaultValue` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.SetPointItemDefaultValue` |
     */
    SetPointItemDefaultValue?: SetPointItemDefaultValue | null;
}

export type SetPointItemDefaultValueFacetId = string | {Id: string};

export interface SetPointItemATNInstanceAssociationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointItemATNInstanceAssociation_Id` |
     * | Type | `Edm.Guid` |
     */
    SetPointItemATNInstanceAssociation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointItemATNInstanceAssociation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.SetPointItemATNInstanceAssociation` |
     */
    SetPointItemATNInstanceAssociation?: SetPointItemATNInstanceAssociation | null;
}

export type SetPointItemATNInstanceAssociationFacetId = string | {Id: string};

export interface SetPointItemFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointItem_Id` |
     * | Type | `Edm.Guid` |
     */
    SetPointItem_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointItem` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.SetPointItem` |
     */
    SetPointItem?: SetPointItem | null;
}

export type SetPointItemFacetId = string | {Id: string};

export interface SetPointEquipmentAssociationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointEquipmentAssociation_Id` |
     * | Type | `Edm.Guid` |
     */
    SetPointEquipmentAssociation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointEquipmentAssociation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.SetPointEquipmentAssociation` |
     */
    SetPointEquipmentAssociation?: SetPointEquipmentAssociation | null;
}

export type SetPointEquipmentAssociationFacetId = string | {Id: string};

export interface SetPointFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPoint_Id` |
     * | Type | `Edm.Guid` |
     */
    SetPoint_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPoint` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.SetPoint` |
     */
    SetPoint?: SetPoint | null;
}

export type SetPointFacetId = string | {Id: string};

export interface ToBeUsedMachinePJFFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedMachinePJF_Id` |
     * | Type | `Edm.Guid` |
     */
    ToBeUsedMachinePJF_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedMachinePJF` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToBeUsedMachinePJF` |
     */
    ToBeUsedMachinePJF?: ToBeUsedMachinePJF | null;
}

export type ToBeUsedMachinePJFFacetId = string | {Id: string};

export interface ActualUsedMachinePJFFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualUsedMachinePJF_Id` |
     * | Type | `Edm.Guid` |
     */
    ActualUsedMachinePJF_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualUsedMachinePJF` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ActualUsedMachinePJF` |
     */
    ActualUsedMachinePJF?: ActualUsedMachinePJF | null;
}

export type ActualUsedMachinePJFFacetId = string | {Id: string};

export interface DSParameterFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DSParameter_Id` |
     * | Type | `Edm.Guid` |
     */
    DSParameter_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DSParameter` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DSParameter` |
     */
    DSParameter?: DSParameter | null;
}

export type DSParameterFacetId = string | {Id: string};

export interface DiscreteAutomationNodeDataTypeMappingFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DiscreteAutomationNodeDataTypeMapping_Id` |
     * | Type | `Edm.Guid` |
     */
    DiscreteAutomationNodeDataTypeMapping_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DiscreteAutomationNodeDataTypeMapping` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DiscreteAutomationNodeDataTypeMapping` |
     */
    DiscreteAutomationNodeDataTypeMapping?: DiscreteAutomationNodeDataTypeMapping | null;
}

export type DiscreteAutomationNodeDataTypeMappingFacetId = string | {Id: string};

export interface ProcessToOpLinkDependencyNavigationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessToOpLinkDependencyNavigation_Id` |
     * | Type | `Edm.Guid` |
     */
    ProcessToOpLinkDependencyNavigation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessToOpLinkDependencyNavigation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ProcessToOpLinkDependencyNavigation` |
     */
    ProcessToOpLinkDependencyNavigation?: ProcessToOpLinkDependencyNavigation | null;
}

export type ProcessToOpLinkDependencyNavigationFacetId = string | {Id: string};

export interface PrintJobFileEquipmentTypeAssociationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFileEquipmentTypeAssociation_Id` |
     * | Type | `Edm.Guid` |
     */
    PrintJobFileEquipmentTypeAssociation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFileEquipmentTypeAssociation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.PrintJobFileEquipmentTypeAssociation` |
     */
    PrintJobFileEquipmentTypeAssociation?: PrintJobFileEquipmentTypeAssociation | null;
}

export type PrintJobFileEquipmentTypeAssociationFacetId = string | {Id: string};

export interface PrintJobFileEquipmentAssociationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFileEquipmentAssociation_Id` |
     * | Type | `Edm.Guid` |
     */
    PrintJobFileEquipmentAssociation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFileEquipmentAssociation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.PrintJobFileEquipmentAssociation` |
     */
    PrintJobFileEquipmentAssociation?: PrintJobFileEquipmentAssociation | null;
}

export type PrintJobFileEquipmentAssociationFacetId = string | {Id: string};

export interface PrintJobFileDM_MaterialAssociationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFileDM_MaterialAssociation_Id` |
     * | Type | `Edm.Guid` |
     */
    PrintJobFileDM_MaterialAssociation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFileDM_MaterialAssociation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.PrintJobFileDM_MaterialAssociation` |
     */
    PrintJobFileDM_MaterialAssociation?: PrintJobFileDM_MaterialAssociation | null;
}

export type PrintJobFileDM_MaterialAssociationFacetId = string | {Id: string};

export interface AMPowderBatchGenealogyFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AMPowderBatchGenealogy_Id` |
     * | Type | `Edm.Guid` |
     */
    AMPowderBatchGenealogy_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AMPowderBatchGenealogy` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.AMPowderBatchGenealogy` |
     */
    AMPowderBatchGenealogy?: AMPowderBatchGenealogy | null;
}

export type AMPowderBatchGenealogyFacetId = string | {Id: string};

export interface VisualDetectedFailureFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `VisualDetectedFailure_Id` |
     * | Type | `Edm.Guid` |
     */
    VisualDetectedFailure_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `VisualDetectedFailure` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.VisualDetectedFailure` |
     */
    VisualDetectedFailure?: VisualDetectedFailure | null;
}

export type VisualDetectedFailureFacetId = string | {Id: string};

export interface InspectionSampleFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `InspectionSample_Id` |
     * | Type | `Edm.Guid` |
     */
    InspectionSample_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `InspectionSample` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.InspectionSample` |
     */
    InspectionSample?: InspectionSample | null;
}

export type InspectionSampleFacetId = string | {Id: string};

export interface InspectionAcquisitionContextFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `InspectionAcquisitionContext_Id` |
     * | Type | `Edm.Guid` |
     */
    InspectionAcquisitionContext_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `InspectionAcquisitionContext` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.InspectionAcquisitionContext` |
     */
    InspectionAcquisitionContext?: InspectionAcquisitionContext | null;
}

export type InspectionAcquisitionContextFacetId = string | {Id: string};

export interface WorkOrderStepSkillFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepSkill_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStepSkill_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepSkill` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderStepSkill` |
     */
    WorkOrderStepSkill?: WorkOrderStepSkill | null;
}

export type WorkOrderStepSkillFacetId = string | {Id: string};

export interface WOOpDependencyNavigationMTUAssociationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOpDependencyNavigationMTUAssociation_Id` |
     * | Type | `Edm.Guid` |
     */
    WOOpDependencyNavigationMTUAssociation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOpDependencyNavigationMTUAssociation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WOOpDependencyNavigationMTUAssociation` |
     */
    WOOpDependencyNavigationMTUAssociation?: WOOpDependencyNavigationMTUAssociation | null;
}

export type WOOpDependencyNavigationMTUAssociationFacetId = string | {Id: string};

export interface WOOpDependencyNavigationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOpDependencyNavigation_Id` |
     * | Type | `Edm.Guid` |
     */
    WOOpDependencyNavigation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOpDependencyNavigation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WOOpDependencyNavigation` |
     */
    WOOpDependencyNavigation?: WOOpDependencyNavigation | null;
}

export type WOOpDependencyNavigationFacetId = string | {Id: string};

export interface StepSkillFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StepSkill_Id` |
     * | Type | `Edm.Guid` |
     */
    StepSkill_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StepSkill` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.StepSkill` |
     */
    StepSkill?: StepSkill | null;
}

export type StepSkillFacetId = string | {Id: string};

export interface ItlkCheckOperationToStepLinkAssociationParameterValueFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckOperationToStepLinkAssociationParameterValue_Id` |
     * | Type | `Edm.Guid` |
     */
    ItlkCheckOperationToStepLinkAssociationParameterValue_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckOperationToStepLinkAssociationParameterValue` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ItlkCheckOperationToStepLinkAssociationParameterValue` |
     */
    ItlkCheckOperationToStepLinkAssociationParameterValue?: ItlkCheckOperationToStepLinkAssociationParameterValue | null;
}

export type ItlkCheckOperationToStepLinkAssociationParameterValueFacetId = string | {Id: string};

export interface ItlkCheckOperationToStepLinkAssociationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckOperationToStepLinkAssociation_Id` |
     * | Type | `Edm.Guid` |
     */
    ItlkCheckOperationToStepLinkAssociation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckOperationToStepLinkAssociation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ItlkCheckOperationToStepLinkAssociation` |
     */
    ItlkCheckOperationToStepLinkAssociation?: ItlkCheckOperationToStepLinkAssociation | null;
}

export type ItlkCheckOperationToStepLinkAssociationFacetId = string | {Id: string};

export interface WorkInstructionDefinitionToStepAssociationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionDefinitionToStepAssociation_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkInstructionDefinitionToStepAssociation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionDefinitionToStepAssociation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkInstructionDefinitionToStepAssociation` |
     */
    WorkInstructionDefinitionToStepAssociation?: WorkInstructionDefinitionToStepAssociation | null;
}

export type WorkInstructionDefinitionToStepAssociationFacetId = string | {Id: string};

export interface WIDefinitionToWOStepAssociationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WIDefinitionToWOStepAssociation_Id` |
     * | Type | `Edm.Guid` |
     */
    WIDefinitionToWOStepAssociation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WIDefinitionToWOStepAssociation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WIDefinitionToWOStepAssociation` |
     */
    WIDefinitionToWOStepAssociation?: WIDefinitionToWOStepAssociation | null;
}

export type WIDefinitionToWOStepAssociationFacetId = string | {Id: string};

export interface WorkInstructionToWorkOrderStepAssociationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionToWorkOrderStepAssociation_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkInstructionToWorkOrderStepAssociation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionToWorkOrderStepAssociation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkInstructionToWorkOrderStepAssociation` |
     */
    WorkInstructionToWorkOrderStepAssociation?: WorkInstructionToWorkOrderStepAssociation | null;
}

export type WorkInstructionToWorkOrderStepAssociationFacetId = string | {Id: string};

export interface RuntimeCharacteristicRepresentationContainerFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RuntimeCharacteristicRepresentationContainer_Id` |
     * | Type | `Edm.Guid` |
     */
    RuntimeCharacteristicRepresentationContainer_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RuntimeCharacteristicRepresentationContainer` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.RuntimeCharacteristicRepresentationContainer` |
     */
    RuntimeCharacteristicRepresentationContainer?: RuntimeCharacteristicRepresentationContainer | null;
}

export type RuntimeCharacteristicRepresentationContainerFacetId = string | {Id: string};

export interface ToBeUsedInspectionFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedInspection_Id` |
     * | Type | `Edm.Guid` |
     */
    ToBeUsedInspection_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedInspection` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToBeUsedInspection` |
     */
    ToBeUsedInspection?: ToBeUsedInspection | null;
}

export type ToBeUsedInspectionFacetId = string | {Id: string};

export interface ActualUsedInspectionFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualUsedInspection_Id` |
     * | Type | `Edm.Guid` |
     */
    ActualUsedInspection_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualUsedInspection` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ActualUsedInspection` |
     */
    ActualUsedInspection?: ActualUsedInspection | null;
}

export type ActualUsedInspectionFacetId = string | {Id: string};

export interface ItlkCheckWOStepAssociationParameterValueFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckWOStepAssociationParameterValue_Id` |
     * | Type | `Edm.Guid` |
     */
    ItlkCheckWOStepAssociationParameterValue_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckWOStepAssociationParameterValue` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ItlkCheckWOStepAssociationParameterValue` |
     */
    ItlkCheckWOStepAssociationParameterValue?: ItlkCheckWOStepAssociationParameterValue | null;
}

export type ItlkCheckWOStepAssociationParameterValueFacetId = string | {Id: string};

export interface ItlkCheckWOStepAssociationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckWOStepAssociation_Id` |
     * | Type | `Edm.Guid` |
     */
    ItlkCheckWOStepAssociation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckWOStepAssociation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ItlkCheckWOStepAssociation` |
     */
    ItlkCheckWOStepAssociation?: ItlkCheckWOStepAssociation | null;
}

export type ItlkCheckWOStepAssociationFacetId = string | {Id: string};

export interface CriticalityFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Criticality_Id` |
     * | Type | `Edm.Guid` |
     */
    Criticality_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Criticality` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Criticality` |
     */
    Criticality?: Criticality | null;
}

export type CriticalityFacetId = string | {Id: string};

export interface APSAlertFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `APSAlert_Id` |
     * | Type | `Edm.Guid` |
     */
    APSAlert_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `APSAlert` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.APSAlert` |
     */
    APSAlert?: APSAlert | null;
}

export type APSAlertFacetId = string | {Id: string};

export interface CharacteristicRepresentationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CharacteristicRepresentation_Id` |
     * | Type | `Edm.Guid` |
     */
    CharacteristicRepresentation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CharacteristicRepresentation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.CharacteristicRepresentation` |
     */
    CharacteristicRepresentation?: CharacteristicRepresentation | null;
}

export type CharacteristicRepresentationFacetId = string | {Id: string};

export interface CharacteristicFailureAssociationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CharacteristicFailureAssociation_Id` |
     * | Type | `Edm.Guid` |
     */
    CharacteristicFailureAssociation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CharacteristicFailureAssociation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.CharacteristicFailureAssociation` |
     */
    CharacteristicFailureAssociation?: CharacteristicFailureAssociation | null;
}

export type CharacteristicFailureAssociationFacetId = string | {Id: string};

export interface BoMItemGroupTypeFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BoMItemGroupType_Id` |
     * | Type | `Edm.Guid` |
     */
    BoMItemGroupType_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BoMItemGroupType` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.BoMItemGroupType` |
     */
    BoMItemGroupType?: BoMItemGroupType | null;
}

export type BoMItemGroupTypeFacetId = string | {Id: string};

export interface BoMItemFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BoMItem_Id` |
     * | Type | `Edm.Guid` |
     */
    BoMItem_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BoMItem` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.BoMItem` |
     */
    BoMItem?: BoMItem | null;
}

export type BoMItemFacetId = string | {Id: string};

export interface ItlkCheckOperationStepCategoryAssociationParameterValueFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckOperationStepCategoryAssociationParameterValue_Id` |
     * | Type | `Edm.Guid` |
     */
    ItlkCheckOperationStepCategoryAssociationParameterValue_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckOperationStepCategoryAssociationParameterValue` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ItlkCheckOperationStepCategoryAssociationParameterValue` |
     */
    ItlkCheckOperationStepCategoryAssociationParameterValue?: ItlkCheckOperationStepCategoryAssociationParameterValue | null;
}

export type ItlkCheckOperationStepCategoryAssociationParameterValueFacetId = string | {Id: string};

export interface ItlkCheckOperationStepCategoryAssociationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckOperationStepCategoryAssociation_Id` |
     * | Type | `Edm.Guid` |
     */
    ItlkCheckOperationStepCategoryAssociation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckOperationStepCategoryAssociation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ItlkCheckOperationStepCategoryAssociation` |
     */
    ItlkCheckOperationStepCategoryAssociation?: ItlkCheckOperationStepCategoryAssociation | null;
}

export type ItlkCheckOperationStepCategoryAssociationFacetId = string | {Id: string};

export interface InspectionSpecificationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `InspectionSpecification_Id` |
     * | Type | `Edm.Guid` |
     */
    InspectionSpecification_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `InspectionSpecification` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.InspectionSpecification` |
     */
    InspectionSpecification?: InspectionSpecification | null;
}

export type InspectionSpecificationFacetId = string | {Id: string};

export interface EquipmentStateMachineFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentStateMachine_Id` |
     * | Type | `Edm.Guid` |
     */
    EquipmentStateMachine_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentStateMachine` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentStateMachine` |
     */
    EquipmentStateMachine?: EquipmentStateMachine | null;
}

export type EquipmentStateMachineFacetId = string | {Id: string};

export interface EquipmentPropertyAttributeFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentPropertyAttribute_Id` |
     * | Type | `Edm.Guid` |
     */
    EquipmentPropertyAttribute_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentPropertyAttribute` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentPropertyAttribute` |
     */
    EquipmentPropertyAttribute?: EquipmentPropertyAttribute | null;
}

export type EquipmentPropertyAttributeFacetId = string | {Id: string};

export interface EquipmentPropertyFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentProperty_Id` |
     * | Type | `Edm.Guid` |
     */
    EquipmentProperty_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentProperty` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentProperty` |
     */
    EquipmentProperty?: EquipmentProperty | null;
}

export type EquipmentPropertyFacetId = string | {Id: string};

export interface EquipmentGroupFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGroup_Id` |
     * | Type | `Edm.Guid` |
     */
    EquipmentGroup_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGroup` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentGroup` |
     */
    EquipmentGroup?: EquipmentGroup | null;
}

export type EquipmentGroupFacetId = string | {Id: string};

export interface EquipmentGraphNodeFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGraphNode_Id` |
     * | Type | `Edm.Guid` |
     */
    EquipmentGraphNode_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGraphNode` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentGraphNode` |
     */
    EquipmentGraphNode?: EquipmentGraphNode | null;
}

export type EquipmentGraphNodeFacetId = string | {Id: string};

export interface EquipmentGraphLinkFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGraphLink_Id` |
     * | Type | `Edm.Guid` |
     */
    EquipmentGraphLink_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGraphLink` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentGraphLink` |
     */
    EquipmentGraphLink?: EquipmentGraphLink | null;
}

export type EquipmentGraphLinkFacetId = string | {Id: string};

export interface EquipmentFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Equipment_Id` |
     * | Type | `Edm.Guid` |
     */
    Equipment_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Equipment` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Equipment` |
     */
    Equipment?: Equipment | null;
}

export type EquipmentFacetId = string | {Id: string};

export interface EquipmentTypeStateMachineFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeStateMachine_Id` |
     * | Type | `Edm.Guid` |
     */
    EquipmentTypeStateMachine_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeStateMachine` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentTypeStateMachine` |
     */
    EquipmentTypeStateMachine?: EquipmentTypeStateMachine | null;
}

export type EquipmentTypeStateMachineFacetId = string | {Id: string};

export interface EquipmentTypePropertyAttributeFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypePropertyAttribute_Id` |
     * | Type | `Edm.Guid` |
     */
    EquipmentTypePropertyAttribute_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypePropertyAttribute` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentTypePropertyAttribute` |
     */
    EquipmentTypePropertyAttribute?: EquipmentTypePropertyAttribute | null;
}

export type EquipmentTypePropertyAttributeFacetId = string | {Id: string};

export interface EquipmentTypePropertyFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeProperty_Id` |
     * | Type | `Edm.Guid` |
     */
    EquipmentTypeProperty_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeProperty` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentTypeProperty` |
     */
    EquipmentTypeProperty?: EquipmentTypeProperty | null;
}

export type EquipmentTypePropertyFacetId = string | {Id: string};

export interface EquipmentTypeFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentType_Id` |
     * | Type | `Edm.Guid` |
     */
    EquipmentType_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentType` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentType` |
     */
    EquipmentType?: EquipmentType | null;
}

export type EquipmentTypeFacetId = string | {Id: string};

export interface EquipmentLevelFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentLevel_Id` |
     * | Type | `Edm.Guid` |
     */
    EquipmentLevel_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentLevel` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentLevel` |
     */
    EquipmentLevel?: EquipmentLevel | null;
}

export type EquipmentLevelFacetId = string | {Id: string};

export interface EquipmentGroupConfigurationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGroupConfiguration_Id` |
     * | Type | `Edm.Guid` |
     */
    EquipmentGroupConfiguration_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGroupConfiguration` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentGroupConfiguration` |
     */
    EquipmentGroupConfiguration?: EquipmentGroupConfiguration | null;
}

export type EquipmentGroupConfigurationFacetId = string | {Id: string};

export interface EquipmentGraphTypeFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGraphType_Id` |
     * | Type | `Edm.Guid` |
     */
    EquipmentGraphType_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGraphType` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentGraphType` |
     */
    EquipmentGraphType?: EquipmentGraphType | null;
}

export type EquipmentGraphTypeFacetId = string | {Id: string};

export interface EquipmentGraphNodeConfigurationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGraphNodeConfiguration_Id` |
     * | Type | `Edm.Guid` |
     */
    EquipmentGraphNodeConfiguration_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGraphNodeConfiguration` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentGraphNodeConfiguration` |
     */
    EquipmentGraphNodeConfiguration?: EquipmentGraphNodeConfiguration | null;
}

export type EquipmentGraphNodeConfigurationFacetId = string | {Id: string};

export interface EquipmentGraphLinkConfigurationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGraphLinkConfiguration_Id` |
     * | Type | `Edm.Guid` |
     */
    EquipmentGraphLinkConfiguration_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGraphLinkConfiguration` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentGraphLinkConfiguration` |
     */
    EquipmentGraphLinkConfiguration?: EquipmentGraphLinkConfiguration | null;
}

export type EquipmentGraphLinkConfigurationFacetId = string | {Id: string};

export interface EquipmentGraphConfigurationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGraphConfiguration_Id` |
     * | Type | `Edm.Guid` |
     */
    EquipmentGraphConfiguration_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGraphConfiguration` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentGraphConfiguration` |
     */
    EquipmentGraphConfiguration?: EquipmentGraphConfiguration | null;
}

export type EquipmentGraphConfigurationFacetId = string | {Id: string};

export interface EquipmentConfigurationStateMachineFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationStateMachine_Id` |
     * | Type | `Edm.Guid` |
     */
    EquipmentConfigurationStateMachine_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationStateMachine` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentConfigurationStateMachine` |
     */
    EquipmentConfigurationStateMachine?: EquipmentConfigurationStateMachine | null;
}

export type EquipmentConfigurationStateMachineFacetId = string | {Id: string};

export interface EquipmentConfigurationPropertyAttributeFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationPropertyAttribute_Id` |
     * | Type | `Edm.Guid` |
     */
    EquipmentConfigurationPropertyAttribute_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationPropertyAttribute` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentConfigurationPropertyAttribute` |
     */
    EquipmentConfigurationPropertyAttribute?: EquipmentConfigurationPropertyAttribute | null;
}

export type EquipmentConfigurationPropertyAttributeFacetId = string | {Id: string};

export interface EquipmentConfigurationPropertyFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationProperty_Id` |
     * | Type | `Edm.Guid` |
     */
    EquipmentConfigurationProperty_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationProperty` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentConfigurationProperty` |
     */
    EquipmentConfigurationProperty?: EquipmentConfigurationProperty | null;
}

export type EquipmentConfigurationPropertyFacetId = string | {Id: string};

export interface EquipmentConfigurationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfiguration_Id` |
     * | Type | `Edm.Guid` |
     */
    EquipmentConfiguration_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfiguration` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentConfiguration` |
     */
    EquipmentConfiguration?: EquipmentConfiguration | null;
}

export type EquipmentConfigurationFacetId = string | {Id: string};

export interface BoMFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BoM_Id` |
     * | Type | `Edm.Guid` |
     */
    BoM_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BoM` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.BoM` |
     */
    BoM?: BoM | null;
}

export type BoMFacetId = string | {Id: string};

export interface WorkProcessDMMaterialTrackingUnitAssociationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkProcessDMMaterialTrackingUnitAssociation_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkProcessDMMaterialTrackingUnitAssociation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkProcessDMMaterialTrackingUnitAssociation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkProcessDMMaterialTrackingUnitAssociation` |
     */
    WorkProcessDMMaterialTrackingUnitAssociation?: WorkProcessDMMaterialTrackingUnitAssociation | null;
}

export type WorkProcessDMMaterialTrackingUnitAssociationFacetId = string | {Id: string};

export interface UserHAEquipmentPreferencesFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserHAEquipmentPreferences_Id` |
     * | Type | `Edm.Guid` |
     */
    UserHAEquipmentPreferences_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserHAEquipmentPreferences` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.UserHAEquipmentPreferences` |
     */
    UserHAEquipmentPreferences?: UserHAEquipmentPreferences | null;
}

export type UserHAEquipmentPreferencesFacetId = string | {Id: string};

export interface MaterialTrackingUnitFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialTrackingUnit_Id` |
     * | Type | `Edm.Guid` |
     */
    MaterialTrackingUnit_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialTrackingUnit` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.MaterialTrackingUnit` |
     */
    MaterialTrackingUnit?: MaterialTrackingUnit | null;
}

export type MaterialTrackingUnitFacetId = string | {Id: string};

export interface MaterialLotFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialLot_Id` |
     * | Type | `Edm.Guid` |
     */
    MaterialLot_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialLot` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.MaterialLot` |
     */
    MaterialLot?: MaterialLot | null;
}

export type MaterialLotFacetId = string | {Id: string};

export interface DM_MaterialTrackingUnitHistoryActionFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnitHistoryAction_Id` |
     * | Type | `Edm.Guid` |
     */
    DM_MaterialTrackingUnitHistoryAction_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnitHistoryAction` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DM_MaterialTrackingUnitHistoryAction` |
     */
    DM_MaterialTrackingUnitHistoryAction?: DM_MaterialTrackingUnitHistoryAction | null;
}

export type DM_MaterialTrackingUnitHistoryActionFacetId = string | {Id: string};

export interface SupplierFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Supplier_Id` |
     * | Type | `Edm.Guid` |
     */
    Supplier_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Supplier` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Supplier` |
     */
    Supplier?: Supplier | null;
}

export type SupplierFacetId = string | {Id: string};

export interface MaterialGroupFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialGroup_Id` |
     * | Type | `Edm.Guid` |
     */
    MaterialGroup_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialGroup` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.MaterialGroup` |
     */
    MaterialGroup?: MaterialGroup | null;
}

export type MaterialGroupFacetId = string | {Id: string};

export interface ProcessContextDefinitionUserFieldFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessContextDefinitionUserField_Id` |
     * | Type | `Edm.Guid` |
     */
    ProcessContextDefinitionUserField_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessContextDefinitionUserField` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ProcessContextDefinitionUserField` |
     */
    ProcessContextDefinitionUserField?: ProcessContextDefinitionUserField | null;
}

export type ProcessContextDefinitionUserFieldFacetId = string | {Id: string};

export interface ProcessContextDefinitionFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessContextDefinition_Id` |
     * | Type | `Edm.Guid` |
     */
    ProcessContextDefinition_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessContextDefinition` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ProcessContextDefinition` |
     */
    ProcessContextDefinition?: ProcessContextDefinition | null;
}

export type ProcessContextDefinitionFacetId = string | {Id: string};

export interface ProcessDefinitionParameterFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessDefinitionParameter_Id` |
     * | Type | `Edm.Guid` |
     */
    ProcessDefinitionParameter_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessDefinitionParameter` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ProcessDefinitionParameter` |
     */
    ProcessDefinitionParameter?: ProcessDefinitionParameter | null;
}

export type ProcessDefinitionParameterFacetId = string | {Id: string};

export interface ProcessDefinitionFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessDefinition_Id` |
     * | Type | `Edm.Guid` |
     */
    ProcessDefinition_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessDefinition` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ProcessDefinition` |
     */
    ProcessDefinition?: ProcessDefinition | null;
}

export type ProcessDefinitionFacetId = string | {Id: string};

export interface ItlkCheckProcessToOpLinkAssociationParameterValueFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckProcessToOpLinkAssociationParameterValue_Id` |
     * | Type | `Edm.Guid` |
     */
    ItlkCheckProcessToOpLinkAssociationParameterValue_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckProcessToOpLinkAssociationParameterValue` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ItlkCheckProcessToOpLinkAssociationParameterValue` |
     */
    ItlkCheckProcessToOpLinkAssociationParameterValue?: ItlkCheckProcessToOpLinkAssociationParameterValue | null;
}

export type ItlkCheckProcessToOpLinkAssociationParameterValueFacetId = string | {Id: string};

export interface ItlkCheckProcessToOpLinkAssociationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckProcessToOpLinkAssociation_Id` |
     * | Type | `Edm.Guid` |
     */
    ItlkCheckProcessToOpLinkAssociation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckProcessToOpLinkAssociation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ItlkCheckProcessToOpLinkAssociation` |
     */
    ItlkCheckProcessToOpLinkAssociation?: ItlkCheckProcessToOpLinkAssociation | null;
}

export type ItlkCheckProcessToOpLinkAssociationFacetId = string | {Id: string};

export interface OperationStepCategoryProcessDefinitionAssociationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationStepCategoryProcessDefinitionAssociation_Id` |
     * | Type | `Edm.Guid` |
     */
    OperationStepCategoryProcessDefinitionAssociation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationStepCategoryProcessDefinitionAssociation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.OperationStepCategoryProcessDefinitionAssociation` |
     */
    OperationStepCategoryProcessDefinitionAssociation?: OperationStepCategoryProcessDefinitionAssociation | null;
}

export type OperationStepCategoryProcessDefinitionAssociationFacetId = string | {Id: string};

export interface ItlkCheckWOOpAssociationParameterValueFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckWOOpAssociationParameterValue_Id` |
     * | Type | `Edm.Guid` |
     */
    ItlkCheckWOOpAssociationParameterValue_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckWOOpAssociationParameterValue` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ItlkCheckWOOpAssociationParameterValue` |
     */
    ItlkCheckWOOpAssociationParameterValue?: ItlkCheckWOOpAssociationParameterValue | null;
}

export type ItlkCheckWOOpAssociationParameterValueFacetId = string | {Id: string};

export interface ItlkCheckWOOpAssociationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckWOOpAssociation_Id` |
     * | Type | `Edm.Guid` |
     */
    ItlkCheckWOOpAssociation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckWOOpAssociation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ItlkCheckWOOpAssociation` |
     */
    ItlkCheckWOOpAssociation?: ItlkCheckWOOpAssociation | null;
}

export type ItlkCheckWOOpAssociationFacetId = string | {Id: string};

export interface ItlkCheckHistoryParameterValueFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckHistoryParameterValue_Id` |
     * | Type | `Edm.Guid` |
     */
    ItlkCheckHistoryParameterValue_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckHistoryParameterValue` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ItlkCheckHistoryParameterValue` |
     */
    ItlkCheckHistoryParameterValue?: ItlkCheckHistoryParameterValue | null;
}

export type ItlkCheckHistoryParameterValueFacetId = string | {Id: string};

export interface ItlkCheckHistoryFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckHistory_Id` |
     * | Type | `Edm.Guid` |
     */
    ItlkCheckHistory_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckHistory` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ItlkCheckHistory` |
     */
    ItlkCheckHistory?: ItlkCheckHistory | null;
}

export type ItlkCheckHistoryFacetId = string | {Id: string};

export interface TeamUserAssociationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TeamUserAssociation_Id` |
     * | Type | `Edm.Guid` |
     */
    TeamUserAssociation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TeamUserAssociation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.TeamUserAssociation` |
     */
    TeamUserAssociation?: TeamUserAssociation | null;
}

export type TeamUserAssociationFacetId = string | {Id: string};

export interface TeamHistoryFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TeamHistory_Id` |
     * | Type | `Edm.Guid` |
     */
    TeamHistory_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TeamHistory` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.TeamHistory` |
     */
    TeamHistory?: TeamHistory | null;
}

export type TeamHistoryFacetId = string | {Id: string};

export interface TeamHistoryActionFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TeamHistoryAction_Id` |
     * | Type | `Edm.Guid` |
     */
    TeamHistoryAction_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TeamHistoryAction` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.TeamHistoryAction` |
     */
    TeamHistoryAction?: TeamHistoryAction | null;
}

export type TeamHistoryActionFacetId = string | {Id: string};

export interface TeamSkillAssociationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TeamSkillAssociation_Id` |
     * | Type | `Edm.Guid` |
     */
    TeamSkillAssociation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TeamSkillAssociation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.TeamSkillAssociation` |
     */
    TeamSkillAssociation?: TeamSkillAssociation | null;
}

export type TeamSkillAssociationFacetId = string | {Id: string};

export interface TeamFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Team_Id` |
     * | Type | `Edm.Guid` |
     */
    Team_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Team` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Team` |
     */
    Team?: Team | null;
}

export type TeamFacetId = string | {Id: string};

export interface NonProductiveActivityHistoryFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonProductiveActivityHistory_Id` |
     * | Type | `Edm.Guid` |
     */
    NonProductiveActivityHistory_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonProductiveActivityHistory` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NonProductiveActivityHistory` |
     */
    NonProductiveActivityHistory?: NonProductiveActivityHistory | null;
}

export type NonProductiveActivityHistoryFacetId = string | {Id: string};

export interface NonProductiveActivityHistoryActionFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonProductiveActivityHistoryAction_Id` |
     * | Type | `Edm.Guid` |
     */
    NonProductiveActivityHistoryAction_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonProductiveActivityHistoryAction` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NonProductiveActivityHistoryAction` |
     */
    NonProductiveActivityHistoryAction?: NonProductiveActivityHistoryAction | null;
}

export type NonProductiveActivityHistoryActionFacetId = string | {Id: string};

export interface NonProductiveActivityContextFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonProductiveActivityContext_Id` |
     * | Type | `Edm.Guid` |
     */
    NonProductiveActivityContext_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonProductiveActivityContext` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NonProductiveActivityContext` |
     */
    NonProductiveActivityContext?: NonProductiveActivityContext | null;
}

export type NonProductiveActivityContextFacetId = string | {Id: string};

export interface NonProductiveActivityNotificationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonProductiveActivityNotification_Id` |
     * | Type | `Edm.Guid` |
     */
    NonProductiveActivityNotification_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonProductiveActivityNotification` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NonProductiveActivityNotification` |
     */
    NonProductiveActivityNotification?: NonProductiveActivityNotification | null;
}

export type NonProductiveActivityNotificationFacetId = string | {Id: string};

export interface UserNonProductiveActivityFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserNonProductiveActivity_Id` |
     * | Type | `Edm.Guid` |
     */
    UserNonProductiveActivity_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserNonProductiveActivity` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.UserNonProductiveActivity` |
     */
    UserNonProductiveActivity?: UserNonProductiveActivity | null;
}

export type UserNonProductiveActivityFacetId = string | {Id: string};

export interface ItlkCheckParameterFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckParameter_Id` |
     * | Type | `Edm.Guid` |
     */
    ItlkCheckParameter_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckParameter` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ItlkCheckParameter` |
     */
    ItlkCheckParameter?: ItlkCheckParameter | null;
}

export type ItlkCheckParameterFacetId = string | {Id: string};

export interface ItlkCheckFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheck_Id` |
     * | Type | `Edm.Guid` |
     */
    ItlkCheck_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheck` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ItlkCheck` |
     */
    ItlkCheck?: ItlkCheck | null;
}

export type ItlkCheckFacetId = string | {Id: string};

export interface OperationStepCategoryFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationStepCategory_Id` |
     * | Type | `Edm.Guid` |
     */
    OperationStepCategory_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationStepCategory` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.OperationStepCategory` |
     */
    OperationStepCategory?: OperationStepCategory | null;
}

export type OperationStepCategoryFacetId = string | {Id: string};

export interface NonProductiveActivityFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonProductiveActivity_Id` |
     * | Type | `Edm.Guid` |
     */
    NonProductiveActivity_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonProductiveActivity` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NonProductiveActivity` |
     */
    NonProductiveActivity?: NonProductiveActivity | null;
}

export type NonProductiveActivityFacetId = string | {Id: string};

export interface WorkOrderOperationSkillFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationSkill_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationSkill_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationSkill` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderOperationSkill` |
     */
    WorkOrderOperationSkill?: WorkOrderOperationSkill | null;
}

export type WorkOrderOperationSkillFacetId = string | {Id: string};

export interface ExecutionGroupPhaseDependencyFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupPhaseDependency_Id` |
     * | Type | `Edm.Guid` |
     */
    ExecutionGroupPhaseDependency_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupPhaseDependency` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ExecutionGroupPhaseDependency` |
     */
    ExecutionGroupPhaseDependency?: ExecutionGroupPhaseDependency | null;
}

export type ExecutionGroupPhaseDependencyFacetId = string | {Id: string};

export interface ActualCollectedDocumentFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualCollectedDocument_Id` |
     * | Type | `Edm.Guid` |
     */
    ActualCollectedDocument_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualCollectedDocument` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ActualCollectedDocument` |
     */
    ActualCollectedDocument?: ActualCollectedDocument | null;
}

export type ActualCollectedDocumentFacetId = string | {Id: string};

export interface WorkInstructionAssociationTypeFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionAssociationType_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkInstructionAssociationType_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionAssociationType` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkInstructionAssociationType` |
     */
    WorkInstructionAssociationType?: WorkInstructionAssociationType | null;
}

export type WorkInstructionAssociationTypeFacetId = string | {Id: string};

export interface TransportOperationSourceFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TransportOperationSource_Id` |
     * | Type | `Edm.Guid` |
     */
    TransportOperationSource_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TransportOperationSource` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.TransportOperationSource` |
     */
    TransportOperationSource?: TransportOperationSource | null;
}

export type TransportOperationSourceFacetId = string | {Id: string};

export interface TransportOperationHistoryAssignedHUFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TransportOperationHistoryAssignedHU_Id` |
     * | Type | `Edm.Guid` |
     */
    TransportOperationHistoryAssignedHU_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TransportOperationHistoryAssignedHU` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.TransportOperationHistoryAssignedHU` |
     */
    TransportOperationHistoryAssignedHU?: TransportOperationHistoryAssignedHU | null;
}

export type TransportOperationHistoryAssignedHUFacetId = string | {Id: string};

export interface TransportOperationHistoryActionFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TransportOperationHistoryAction_Id` |
     * | Type | `Edm.Guid` |
     */
    TransportOperationHistoryAction_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TransportOperationHistoryAction` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.TransportOperationHistoryAction` |
     */
    TransportOperationHistoryAction?: TransportOperationHistoryAction | null;
}

export type TransportOperationHistoryActionFacetId = string | {Id: string};

export interface TransportOperationHistoryFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TransportOperationHistory_Id` |
     * | Type | `Edm.Guid` |
     */
    TransportOperationHistory_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TransportOperationHistory` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.TransportOperationHistory` |
     */
    TransportOperationHistory?: TransportOperationHistory | null;
}

export type TransportOperationHistoryFacetId = string | {Id: string};

export interface TransportOperationDestinationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TransportOperationDestination_Id` |
     * | Type | `Edm.Guid` |
     */
    TransportOperationDestination_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TransportOperationDestination` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.TransportOperationDestination` |
     */
    TransportOperationDestination?: TransportOperationDestination | null;
}

export type TransportOperationDestinationFacetId = string | {Id: string};

export interface TransportOperationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TransportOperation_Id` |
     * | Type | `Edm.Guid` |
     */
    TransportOperation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TransportOperation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.TransportOperation` |
     */
    TransportOperation?: TransportOperation | null;
}

export type TransportOperationFacetId = string | {Id: string};

export interface RuntimeLogisticWhitelistFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RuntimeLogisticWhitelist_Id` |
     * | Type | `Edm.Guid` |
     */
    RuntimeLogisticWhitelist_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RuntimeLogisticWhitelist` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.RuntimeLogisticWhitelist` |
     */
    RuntimeLogisticWhitelist?: RuntimeLogisticWhitelist | null;
}

export type RuntimeLogisticWhitelistFacetId = string | {Id: string};

export interface LogisticRequestItemFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogisticRequestItem_Id` |
     * | Type | `Edm.Guid` |
     */
    LogisticRequestItem_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogisticRequestItem` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.LogisticRequestItem` |
     */
    LogisticRequestItem?: LogisticRequestItem | null;
}

export type LogisticRequestItemFacetId = string | {Id: string};

export interface LogisticRequestHistoryActionFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogisticRequestHistoryAction_Id` |
     * | Type | `Edm.Guid` |
     */
    LogisticRequestHistoryAction_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogisticRequestHistoryAction` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.LogisticRequestHistoryAction` |
     */
    LogisticRequestHistoryAction?: LogisticRequestHistoryAction | null;
}

export type LogisticRequestHistoryActionFacetId = string | {Id: string};

export interface LogisticRequestHistoryFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogisticRequestHistory_Id` |
     * | Type | `Edm.Guid` |
     */
    LogisticRequestHistory_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogisticRequestHistory` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.LogisticRequestHistory` |
     */
    LogisticRequestHistory?: LogisticRequestHistory | null;
}

export type LogisticRequestHistoryFacetId = string | {Id: string};

export interface LogisticRequestFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogisticRequest_Id` |
     * | Type | `Edm.Guid` |
     */
    LogisticRequest_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogisticRequest` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.LogisticRequest` |
     */
    LogisticRequest?: LogisticRequest | null;
}

export type LogisticRequestFacetId = string | {Id: string};

export interface HistoryItemsFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `HistoryItems_Id` |
     * | Type | `Edm.Guid` |
     */
    HistoryItems_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `HistoryItems` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.HistoryItems` |
     */
    HistoryItems?: HistoryItems | null;
}

export type HistoryItemsFacetId = string | {Id: string};

export interface HandlingUnitMaterialItemAssociationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `HandlingUnitMaterialItemAssociation_Id` |
     * | Type | `Edm.Guid` |
     */
    HandlingUnitMaterialItemAssociation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `HandlingUnitMaterialItemAssociation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.HandlingUnitMaterialItemAssociation` |
     */
    HandlingUnitMaterialItemAssociation?: HandlingUnitMaterialItemAssociation | null;
}

export type HandlingUnitMaterialItemAssociationFacetId = string | {Id: string};

export interface HandlingUnitHistoryActionFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `HandlingUnitHistoryAction_Id` |
     * | Type | `Edm.Guid` |
     */
    HandlingUnitHistoryAction_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `HandlingUnitHistoryAction` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.HandlingUnitHistoryAction` |
     */
    HandlingUnitHistoryAction?: HandlingUnitHistoryAction | null;
}

export type HandlingUnitHistoryActionFacetId = string | {Id: string};

export interface HandlingUnitHistoryFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `HandlingUnitHistory_Id` |
     * | Type | `Edm.Guid` |
     */
    HandlingUnitHistory_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `HandlingUnitHistory` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.HandlingUnitHistory` |
     */
    HandlingUnitHistory?: HandlingUnitHistory | null;
}

export type HandlingUnitHistoryFacetId = string | {Id: string};

export interface HandlingUnitFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `HandlingUnit_Id` |
     * | Type | `Edm.Guid` |
     */
    HandlingUnit_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `HandlingUnit` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.HandlingUnit` |
     */
    HandlingUnit?: HandlingUnit | null;
}

export type HandlingUnitFacetId = string | {Id: string};

export interface BufferToolAssociationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BufferToolAssociation_Id` |
     * | Type | `Edm.Guid` |
     */
    BufferToolAssociation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BufferToolAssociation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.BufferToolAssociation` |
     */
    BufferToolAssociation?: BufferToolAssociation | null;
}

export type BufferToolAssociationFacetId = string | {Id: string};

export interface BufferMaterialItemAssociationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BufferMaterialItemAssociation_Id` |
     * | Type | `Edm.Guid` |
     */
    BufferMaterialItemAssociation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BufferMaterialItemAssociation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.BufferMaterialItemAssociation` |
     */
    BufferMaterialItemAssociation?: BufferMaterialItemAssociation | null;
}

export type BufferMaterialItemAssociationFacetId = string | {Id: string};

export interface BufferHistoryActionFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BufferHistoryAction_Id` |
     * | Type | `Edm.Guid` |
     */
    BufferHistoryAction_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BufferHistoryAction` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.BufferHistoryAction` |
     */
    BufferHistoryAction?: BufferHistoryAction | null;
}

export type BufferHistoryActionFacetId = string | {Id: string};

export interface BufferHistoryFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BufferHistory_Id` |
     * | Type | `Edm.Guid` |
     */
    BufferHistory_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BufferHistory` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.BufferHistory` |
     */
    BufferHistory?: BufferHistory | null;
}

export type BufferHistoryFacetId = string | {Id: string};

export interface BufferEquipmentAssoicationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BufferEquipmentAssoication_Id` |
     * | Type | `Edm.Guid` |
     */
    BufferEquipmentAssoication_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BufferEquipmentAssoication` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.BufferEquipmentAssoication` |
     */
    BufferEquipmentAssoication?: BufferEquipmentAssoication | null;
}

export type BufferEquipmentAssoicationFacetId = string | {Id: string};

export interface BufferFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Buffer_Id` |
     * | Type | `Edm.Guid` |
     */
    Buffer_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Buffer` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Buffer` |
     */
    Buffer?: Buffer | null;
}

export type BufferFacetId = string | {Id: string};

export interface ExecutionGroupPhaseWOOAssociationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupPhaseWOOAssociation_Id` |
     * | Type | `Edm.Guid` |
     */
    ExecutionGroupPhaseWOOAssociation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupPhaseWOOAssociation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ExecutionGroupPhaseWOOAssociation` |
     */
    ExecutionGroupPhaseWOOAssociation?: ExecutionGroupPhaseWOOAssociation | null;
}

export type ExecutionGroupPhaseWOOAssociationFacetId = string | {Id: string};

export interface WorkInstructionToWorkOrderOperationAssociationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionToWorkOrderOperationAssociation_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkInstructionToWorkOrderOperationAssociation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionToWorkOrderOperationAssociation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkInstructionToWorkOrderOperationAssociation` |
     */
    WorkInstructionToWorkOrderOperationAssociation?: WorkInstructionToWorkOrderOperationAssociation | null;
}

export type WorkInstructionToWorkOrderOperationAssociationFacetId = string | {Id: string};

export interface ExecutionGroupPhaseFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupPhase_Id` |
     * | Type | `Edm.Guid` |
     */
    ExecutionGroupPhase_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupPhase` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ExecutionGroupPhase` |
     */
    ExecutionGroupPhase?: ExecutionGroupPhase | null;
}

export type ExecutionGroupPhaseFacetId = string | {Id: string};

export interface ExecutionGroupHistoryActionFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupHistoryAction_Id` |
     * | Type | `Edm.Guid` |
     */
    ExecutionGroupHistoryAction_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupHistoryAction` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ExecutionGroupHistoryAction` |
     */
    ExecutionGroupHistoryAction?: ExecutionGroupHistoryAction | null;
}

export type ExecutionGroupHistoryActionFacetId = string | {Id: string};

export interface ExecutionGroupHistoryFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupHistory_Id` |
     * | Type | `Edm.Guid` |
     */
    ExecutionGroupHistory_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupHistory` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ExecutionGroupHistory` |
     */
    ExecutionGroupHistory?: ExecutionGroupHistory | null;
}

export type ExecutionGroupHistoryFacetId = string | {Id: string};

export interface ExecutionGroupFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroup_Id` |
     * | Type | `Edm.Guid` |
     */
    ExecutionGroup_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroup` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ExecutionGroup` |
     */
    ExecutionGroup?: ExecutionGroup | null;
}

export type ExecutionGroupFacetId = string | {Id: string};

export interface WorkInstructionStepItemLimitFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionStepItemLimit_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkInstructionStepItemLimit_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionStepItemLimit` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkInstructionStepItemLimit` |
     */
    WorkInstructionStepItemLimit?: WorkInstructionStepItemLimit | null;
}

export type WorkInstructionStepItemLimitFacetId = string | {Id: string};

export interface WorkInstructionSectionFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionSection_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkInstructionSection_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionSection` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkInstructionSection` |
     */
    WorkInstructionSection?: WorkInstructionSection | null;
}

export type WorkInstructionSectionFacetId = string | {Id: string};

export interface WorkInstructionParameterFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionParameter_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkInstructionParameter_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionParameter` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkInstructionParameter` |
     */
    WorkInstructionParameter?: WorkInstructionParameter | null;
}

export type WorkInstructionParameterFacetId = string | {Id: string};

export interface WorkInstructionDefinitionToOperationAssociationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionDefinitionToOperationAssociation_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkInstructionDefinitionToOperationAssociation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionDefinitionToOperationAssociation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkInstructionDefinitionToOperationAssociation` |
     */
    WorkInstructionDefinitionToOperationAssociation?: WorkInstructionDefinitionToOperationAssociation | null;
}

export type WorkInstructionDefinitionToOperationAssociationFacetId = string | {Id: string};

export interface WorkInstructionTemplateParameterFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionTemplateParameter_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkInstructionTemplateParameter_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionTemplateParameter` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkInstructionTemplateParameter` |
     */
    WorkInstructionTemplateParameter?: WorkInstructionTemplateParameter | null;
}

export type WorkInstructionTemplateParameterFacetId = string | {Id: string};

export interface WorkInstructionTemplateFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionTemplate_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkInstructionTemplate_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionTemplate` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkInstructionTemplate` |
     */
    WorkInstructionTemplate?: WorkInstructionTemplate | null;
}

export type WorkInstructionTemplateFacetId = string | {Id: string};

export interface WorkInstructionDefinitionFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionDefinition_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkInstructionDefinition_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionDefinition` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkInstructionDefinition` |
     */
    WorkInstructionDefinition?: WorkInstructionDefinition | null;
}

export type WorkInstructionDefinitionFacetId = string | {Id: string};

export interface NumberingPatternFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NumberingPattern_Id` |
     * | Type | `Edm.Guid` |
     */
    NumberingPattern_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NumberingPattern` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NumberingPattern` |
     */
    NumberingPattern?: NumberingPattern | null;
}

export type NumberingPatternFacetId = string | {Id: string};

export interface NumberingPatternParameterFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NumberingPatternParameter_Id` |
     * | Type | `Edm.Guid` |
     */
    NumberingPatternParameter_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NumberingPatternParameter` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NumberingPatternParameter` |
     */
    NumberingPatternParameter?: NumberingPatternParameter | null;
}

export type NumberingPatternParameterFacetId = string | {Id: string};

export interface NumberingPatternPartFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NumberingPatternPart_Id` |
     * | Type | `Edm.Guid` |
     */
    NumberingPatternPart_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NumberingPatternPart` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NumberingPatternPart` |
     */
    NumberingPatternPart?: NumberingPatternPart | null;
}

export type NumberingPatternPartFacetId = string | {Id: string};

export interface NumberingPatternEntityFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NumberingPatternEntity_Id` |
     * | Type | `Edm.Guid` |
     */
    NumberingPatternEntity_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NumberingPatternEntity` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NumberingPatternEntity` |
     */
    NumberingPatternEntity?: NumberingPatternEntity | null;
}

export type NumberingPatternEntityFacetId = string | {Id: string};

export interface CounterFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Counter_Id` |
     * | Type | `Edm.Guid` |
     */
    Counter_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Counter` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Counter` |
     */
    Counter?: Counter | null;
}

export type CounterFacetId = string | {Id: string};

export interface LogisticWhitelistFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogisticWhitelist_Id` |
     * | Type | `Edm.Guid` |
     */
    LogisticWhitelist_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogisticWhitelist` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.LogisticWhitelist` |
     */
    LogisticWhitelist?: LogisticWhitelist | null;
}

export type LogisticWhitelistFacetId = string | {Id: string};

export interface LogisticClassFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogisticClass_Id` |
     * | Type | `Edm.Guid` |
     */
    LogisticClass_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogisticClass` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.LogisticClass` |
     */
    LogisticClass?: LogisticClass | null;
}

export type LogisticClassFacetId = string | {Id: string};

export interface CapacityTypeFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CapacityType_Id` |
     * | Type | `Edm.Guid` |
     */
    CapacityType_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CapacityType` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.CapacityType` |
     */
    CapacityType?: CapacityType | null;
}

export type CapacityTypeFacetId = string | {Id: string};

export interface BufferDefinitionFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BufferDefinition_Id` |
     * | Type | `Edm.Guid` |
     */
    BufferDefinition_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BufferDefinition` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.BufferDefinition` |
     */
    BufferDefinition?: BufferDefinition | null;
}

export type BufferDefinitionFacetId = string | {Id: string};

export interface UoMFactorFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoMFactor_Id` |
     * | Type | `Edm.Guid` |
     */
    UoMFactor_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoMFactor` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.UoMFactor` |
     */
    UoMFactor?: UoMFactor | null;
}

export type UoMFactorFacetId = string | {Id: string};

export interface UoMDimensionFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoMDimension_Id` |
     * | Type | `Edm.Guid` |
     */
    UoMDimension_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoMDimension` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.UoMDimension` |
     */
    UoMDimension?: UoMDimension | null;
}

export type UoMDimensionFacetId = string | {Id: string};

export interface UoMFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoM_Id` |
     * | Type | `Edm.Guid` |
     */
    UoM_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoM` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.UoM` |
     */
    UoM?: UoM | null;
}

export type UoMFacetId = string | {Id: string};

export interface StatusTransitionDefinitionFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StatusTransitionDefinition_Id` |
     * | Type | `Edm.Guid` |
     */
    StatusTransitionDefinition_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StatusTransitionDefinition` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.StatusTransitionDefinition` |
     */
    StatusTransitionDefinition?: StatusTransitionDefinition | null;
}

export type StatusTransitionDefinitionFacetId = string | {Id: string};

export interface StatusTransitionFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StatusTransition_Id` |
     * | Type | `Edm.Guid` |
     */
    StatusTransition_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StatusTransition` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.StatusTransition` |
     */
    StatusTransition?: StatusTransition | null;
}

export type StatusTransitionFacetId = string | {Id: string};

export interface StatusDefinitionFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StatusDefinition_Id` |
     * | Type | `Edm.Guid` |
     */
    StatusDefinition_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StatusDefinition` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.StatusDefinition` |
     */
    StatusDefinition?: StatusDefinition | null;
}

export type StatusDefinitionFacetId = string | {Id: string};

export interface StatusBehaviorDefinitionFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StatusBehaviorDefinition_Id` |
     * | Type | `Edm.Guid` |
     */
    StatusBehaviorDefinition_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StatusBehaviorDefinition` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.StatusBehaviorDefinition` |
     */
    StatusBehaviorDefinition?: StatusBehaviorDefinition | null;
}

export type StatusBehaviorDefinitionFacetId = string | {Id: string};

export interface StatusFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status_Id` |
     * | Type | `Edm.Guid` |
     */
    Status_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Status` |
     */
    Status?: Status | null;
}

export type StatusFacetId = string | {Id: string};

export interface StateMachineFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StateMachine_Id` |
     * | Type | `Edm.Guid` |
     */
    StateMachine_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StateMachine` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.StateMachine` |
     */
    StateMachine?: StateMachine | null;
}

export type StateMachineFacetId = string | {Id: string};

export interface UserPlantAssociationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserPlantAssociation_Id` |
     * | Type | `Edm.Guid` |
     */
    UserPlantAssociation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserPlantAssociation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.UserPlantAssociation` |
     */
    UserPlantAssociation?: UserPlantAssociation | null;
}

export type UserPlantAssociationFacetId = string | {Id: string};

export interface MasterPlanFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlan_Id` |
     * | Type | `Edm.Guid` |
     */
    MasterPlan_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlan` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.MasterPlan` |
     */
    MasterPlan?: MasterPlan | null;
}

export type MasterPlanFacetId = string | {Id: string};

export interface Skill_BOPFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Skill_BOP_Id` |
     * | Type | `Edm.Guid` |
     */
    Skill_BOP_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Skill_BOP` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Skill_BOP` |
     */
    Skill_BOP?: Skill_BOP | null;
}

export type Skill_BOPFacetId = string | {Id: string};

export interface OperationToStepLinkFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationToStepLink_Id` |
     * | Type | `Edm.Guid` |
     */
    OperationToStepLink_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationToStepLink` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.OperationToStepLink` |
     */
    OperationToStepLink?: OperationToStepLink | null;
}

export type OperationToStepLinkFacetId = string | {Id: string};

export interface ProcessToProcessLinkFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessToProcessLink_Id` |
     * | Type | `Edm.Guid` |
     */
    ProcessToProcessLink_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessToProcessLink` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ProcessToProcessLink` |
     */
    ProcessToProcessLink?: ProcessToProcessLink | null;
}

export type ProcessToProcessLinkFacetId = string | {Id: string};

export interface ProcessToOperationLinkFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessToOperationLink_Id` |
     * | Type | `Edm.Guid` |
     */
    ProcessToOperationLink_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessToOperationLink` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ProcessToOperationLink` |
     */
    ProcessToOperationLink?: ProcessToOperationLink | null;
}

export type ProcessToOperationLinkFacetId = string | {Id: string};

export interface OperationSkillFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationSkill_Id` |
     * | Type | `Edm.Guid` |
     */
    OperationSkill_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationSkill` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.OperationSkill` |
     */
    OperationSkill?: OperationSkill | null;
}

export type OperationSkillFacetId = string | {Id: string};

export interface ProducedMaterialUnderReworkFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedMaterialUnderRework_Id` |
     * | Type | `Edm.Guid` |
     */
    ProducedMaterialUnderRework_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedMaterialUnderRework` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ProducedMaterialUnderRework` |
     */
    ProducedMaterialUnderRework?: ProducedMaterialUnderRework | null;
}

export type ProducedMaterialUnderReworkFacetId = string | {Id: string};

export interface SnagAndNoteNotificationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SnagAndNoteNotification_Id` |
     * | Type | `Edm.Guid` |
     */
    SnagAndNoteNotification_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SnagAndNoteNotification` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.SnagAndNoteNotification` |
     */
    SnagAndNoteNotification?: SnagAndNoteNotification | null;
}

export type SnagAndNoteNotificationFacetId = string | {Id: string};

export interface NonConformanceStatusBehaviorFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceStatusBehavior_Id` |
     * | Type | `Edm.Guid` |
     */
    NonConformanceStatusBehavior_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceStatusBehavior` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NonConformanceStatusBehavior` |
     */
    NonConformanceStatusBehavior?: NonConformanceStatusBehavior | null;
}

export type NonConformanceStatusBehaviorFacetId = string | {Id: string};

export interface NonConformanceItemFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceItem_Id` |
     * | Type | `Edm.Guid` |
     */
    NonConformanceItem_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceItem` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NonConformanceItem` |
     */
    NonConformanceItem?: NonConformanceItem | null;
}

export type NonConformanceItemFacetId = string | {Id: string};

export interface ToBeConsumedMaterialPrekitHistoryFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeConsumedMaterialPrekitHistory_Id` |
     * | Type | `Edm.Guid` |
     */
    ToBeConsumedMaterialPrekitHistory_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeConsumedMaterialPrekitHistory` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToBeConsumedMaterialPrekitHistory` |
     */
    ToBeConsumedMaterialPrekitHistory?: ToBeConsumedMaterialPrekitHistory | null;
}

export type ToBeConsumedMaterialPrekitHistoryFacetId = string | {Id: string};

export interface ToBeConsumedMaterialPrekitFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeConsumedMaterialPrekit_Id` |
     * | Type | `Edm.Guid` |
     */
    ToBeConsumedMaterialPrekit_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeConsumedMaterialPrekit` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToBeConsumedMaterialPrekit` |
     */
    ToBeConsumedMaterialPrekit?: ToBeConsumedMaterialPrekit | null;
}

export type ToBeConsumedMaterialPrekitFacetId = string | {Id: string};

export interface WorkOperationTypeFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOperationType_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOperationType_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOperationType` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOperationType` |
     */
    WorkOperationType?: WorkOperationType | null;
}

export type WorkOperationTypeFacetId = string | {Id: string};

export interface ToolDefinitionCompatibleMachineFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolDefinitionCompatibleMachine_Id` |
     * | Type | `Edm.Guid` |
     */
    ToolDefinitionCompatibleMachine_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolDefinitionCompatibleMachine` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToolDefinitionCompatibleMachine` |
     */
    ToolDefinitionCompatibleMachine?: ToolDefinitionCompatibleMachine | null;
}

export type ToolDefinitionCompatibleMachineFacetId = string | {Id: string};

export interface SkillFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Skill_Id` |
     * | Type | `Edm.Guid` |
     */
    Skill_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Skill` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Skill` |
     */
    Skill?: Skill | null;
}

export type SkillFacetId = string | {Id: string};

export interface ReworkCodeFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReworkCode_Id` |
     * | Type | `Edm.Guid` |
     */
    ReworkCode_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReworkCode` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ReworkCode` |
     */
    ReworkCode?: ReworkCode | null;
}

export type ReworkCodeFacetId = string | {Id: string};

export interface NonConformanceTransitionFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceTransition_Id` |
     * | Type | `Edm.Guid` |
     */
    NonConformanceTransition_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceTransition` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NonConformanceTransition` |
     */
    NonConformanceTransition?: NonConformanceTransition | null;
}

export type NonConformanceTransitionFacetId = string | {Id: string};

export interface NonConformanceStatusFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceStatus_Id` |
     * | Type | `Edm.Guid` |
     */
    NonConformanceStatus_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceStatus` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NonConformanceStatus` |
     */
    NonConformanceStatus?: NonConformanceStatus | null;
}

export type NonConformanceStatusFacetId = string | {Id: string};

export interface NonConformanceSeverityFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceSeverity_Id` |
     * | Type | `Edm.Guid` |
     */
    NonConformanceSeverity_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceSeverity` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NonConformanceSeverity` |
     */
    NonConformanceSeverity?: NonConformanceSeverity | null;
}

export type NonConformanceSeverityFacetId = string | {Id: string};

export interface NonConformanceLifecycleFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceLifecycle_Id` |
     * | Type | `Edm.Guid` |
     */
    NonConformanceLifecycle_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceLifecycle` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NonConformanceLifecycle` |
     */
    NonConformanceLifecycle?: NonConformanceLifecycle | null;
}

export type NonConformanceLifecycleFacetId = string | {Id: string};

export interface DefectTypeFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefectType_Id` |
     * | Type | `Edm.Guid` |
     */
    DefectType_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefectType` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DefectType` |
     */
    DefectType?: DefectType | null;
}

export type DefectTypeFacetId = string | {Id: string};

export interface DefectSpecificationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefectSpecification_Id` |
     * | Type | `Edm.Guid` |
     */
    DefectSpecification_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefectSpecification` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DefectSpecification` |
     */
    DefectSpecification?: DefectSpecification | null;
}

export type DefectSpecificationFacetId = string | {Id: string};

export interface DefectGroupSpecificationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefectGroupSpecification_Id` |
     * | Type | `Edm.Guid` |
     */
    DefectGroupSpecification_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefectGroupSpecification` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DefectGroupSpecification` |
     */
    DefectGroupSpecification?: DefectGroupSpecification | null;
}

export type DefectGroupSpecificationFacetId = string | {Id: string};

export interface DefectGroupFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefectGroup_Id` |
     * | Type | `Edm.Guid` |
     */
    DefectGroup_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefectGroup` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DefectGroup` |
     */
    DefectGroup?: DefectGroup | null;
}

export type DefectGroupFacetId = string | {Id: string};

export interface WorkOStepDependencyFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOStepDependency_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOStepDependency_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOStepDependency` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOStepDependency` |
     */
    WorkOStepDependency?: WorkOStepDependency | null;
}

export type WorkOStepDependencyFacetId = string | {Id: string};

export interface WorkOrderStepFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStep_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStep_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStep` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderStep` |
     */
    WorkOrderStep?: WorkOrderStep | null;
}

export type WorkOrderStepFacetId = string | {Id: string};

export interface WorkOrderHistoryActionFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderHistoryAction_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderHistoryAction_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderHistoryAction` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderHistoryAction` |
     */
    WorkOrderHistoryAction?: WorkOrderHistoryAction | null;
}

export type WorkOrderHistoryActionFacetId = string | {Id: string};

export interface WorkOOperationDependencyFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOOperationDependency_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOOperationDependency_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOOperationDependency` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOOperationDependency` |
     */
    WorkOOperationDependency?: WorkOOperationDependency | null;
}

export type WorkOOperationDependencyFacetId = string | {Id: string};

export interface ToolHistoryActionFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolHistoryAction_Id` |
     * | Type | `Edm.Guid` |
     */
    ToolHistoryAction_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolHistoryAction` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToolHistoryAction` |
     */
    ToolHistoryAction?: ToolHistoryAction | null;
}

export type ToolHistoryActionFacetId = string | {Id: string};

export interface ToolCompatibleMachineFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolCompatibleMachine_Id` |
     * | Type | `Edm.Guid` |
     */
    ToolCompatibleMachine_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolCompatibleMachine` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToolCompatibleMachine` |
     */
    ToolCompatibleMachine?: ToolCompatibleMachine | null;
}

export type ToolCompatibleMachineFacetId = string | {Id: string};

export interface ToBeUsedMachineFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedMachine_Id` |
     * | Type | `Edm.Guid` |
     */
    ToBeUsedMachine_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedMachine` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToBeUsedMachine` |
     */
    ToBeUsedMachine?: ToBeUsedMachine | null;
}

export type ToBeUsedMachineFacetId = string | {Id: string};

export interface ToBeUsedDocumentFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedDocument_Id` |
     * | Type | `Edm.Guid` |
     */
    ToBeUsedDocument_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedDocument` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToBeUsedDocument` |
     */
    ToBeUsedDocument?: ToBeUsedDocument | null;
}

export type ToBeUsedDocumentFacetId = string | {Id: string};

export interface SkipReasonFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SkipReason_Id` |
     * | Type | `Edm.Guid` |
     */
    SkipReason_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SkipReason` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.SkipReason` |
     */
    SkipReason?: SkipReason | null;
}

export type SkipReasonFacetId = string | {Id: string};

export interface ProductionTypeFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProductionType_Id` |
     * | Type | `Edm.Guid` |
     */
    ProductionType_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProductionType` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ProductionType` |
     */
    ProductionType?: ProductionType | null;
}

export type ProductionTypeFacetId = string | {Id: string};

export interface ProducedMaterialItemFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedMaterialItem_Id` |
     * | Type | `Edm.Guid` |
     */
    ProducedMaterialItem_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedMaterialItem` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ProducedMaterialItem` |
     */
    ProducedMaterialItem?: ProducedMaterialItem | null;
}

export type ProducedMaterialItemFacetId = string | {Id: string};

export interface PauseReasonFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PauseReason_Id` |
     * | Type | `Edm.Guid` |
     */
    PauseReason_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PauseReason` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.PauseReason` |
     */
    PauseReason?: PauseReason | null;
}

export type PauseReasonFacetId = string | {Id: string};

export interface NonConformanceSupervisorFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceSupervisor_Id` |
     * | Type | `Edm.Guid` |
     */
    NonConformanceSupervisor_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceSupervisor` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NonConformanceSupervisor` |
     */
    NonConformanceSupervisor?: NonConformanceSupervisor | null;
}

export type NonConformanceSupervisorFacetId = string | {Id: string};

export interface NonConformanceResourceFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceResource_Id` |
     * | Type | `Edm.Guid` |
     */
    NonConformanceResource_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceResource` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NonConformanceResource` |
     */
    NonConformanceResource?: NonConformanceResource | null;
}

export type NonConformanceResourceFacetId = string | {Id: string};

export interface NonConformanceAttachmentFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceAttachment_Id` |
     * | Type | `Edm.Guid` |
     */
    NonConformanceAttachment_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceAttachment` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NonConformanceAttachment` |
     */
    NonConformanceAttachment?: NonConformanceAttachment | null;
}

export type NonConformanceAttachmentFacetId = string | {Id: string};

export interface SnagAndNoteFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SnagAndNote_Id` |
     * | Type | `Edm.Guid` |
     */
    SnagAndNote_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SnagAndNote` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.SnagAndNote` |
     */
    SnagAndNote?: SnagAndNote | null;
}

export type SnagAndNoteFacetId = string | {Id: string};

export interface HoldReasonFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `HoldReason_Id` |
     * | Type | `Edm.Guid` |
     */
    HoldReason_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `HoldReason` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.HoldReason` |
     */
    HoldReason?: HoldReason | null;
}

export type HoldReasonFacetId = string | {Id: string};

export interface HoldFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Hold_Id` |
     * | Type | `Edm.Guid` |
     */
    Hold_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Hold` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Hold` |
     */
    Hold?: Hold | null;
}

export type HoldFacetId = string | {Id: string};

export interface FutureHoldFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FutureHold_Id` |
     * | Type | `Edm.Guid` |
     */
    FutureHold_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FutureHold` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.FutureHold` |
     */
    FutureHold?: FutureHold | null;
}

export type FutureHoldFacetId = string | {Id: string};

export interface DefectFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Defect_Id` |
     * | Type | `Edm.Guid` |
     */
    Defect_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Defect` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Defect` |
     */
    Defect?: Defect | null;
}

export type DefectFacetId = string | {Id: string};

export interface ChangeTypeFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChangeType_Id` |
     * | Type | `Edm.Guid` |
     */
    ChangeType_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChangeType` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ChangeType` |
     */
    ChangeType?: ChangeType | null;
}

export type ChangeTypeFacetId = string | {Id: string};

export interface AMSubstrateLifecycleFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AMSubstrateLifecycle_Id` |
     * | Type | `Edm.Guid` |
     */
    AMSubstrateLifecycle_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AMSubstrateLifecycle` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.AMSubstrateLifecycle` |
     */
    AMSubstrateLifecycle?: AMSubstrateLifecycle | null;
}

export type AMSubstrateLifecycleFacetId = string | {Id: string};

export interface AMPowderLifecycleFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AMPowderLifecycle_Id` |
     * | Type | `Edm.Guid` |
     */
    AMPowderLifecycle_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AMPowderLifecycle` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.AMPowderLifecycle` |
     */
    AMPowderLifecycle?: AMPowderLifecycle | null;
}

export type AMPowderLifecycleFacetId = string | {Id: string};

export interface ActualUsedMachineFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualUsedMachine_Id` |
     * | Type | `Edm.Guid` |
     */
    ActualUsedMachine_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualUsedMachine` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ActualUsedMachine` |
     */
    ActualUsedMachine?: ActualUsedMachine | null;
}

export type ActualUsedMachineFacetId = string | {Id: string};

export interface ActualProducedMaterialFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualProducedMaterial_Id` |
     * | Type | `Edm.Guid` |
     */
    ActualProducedMaterial_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualProducedMaterial` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ActualProducedMaterial` |
     */
    ActualProducedMaterial?: ActualProducedMaterial | null;
}

export type ActualProducedMaterialFacetId = string | {Id: string};

export interface ActiveUserOnMachineFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActiveUserOnMachine_Id` |
     * | Type | `Edm.Guid` |
     */
    ActiveUserOnMachine_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActiveUserOnMachine` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ActiveUserOnMachine` |
     */
    ActiveUserOnMachine?: ActiveUserOnMachine | null;
}

export type ActiveUserOnMachineFacetId = string | {Id: string};

export interface WorkOrderNotificationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderNotification_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderNotification_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderNotification` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.WorkOrderNotification` |
     */
    WorkOrderNotification?: WorkOrderNotification | null;
}

export type WorkOrderNotificationFacetId = string | {Id: string};

export interface ProcessNotificationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessNotification_Id` |
     * | Type | `Edm.Guid` |
     */
    ProcessNotification_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessNotification` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ProcessNotification` |
     */
    ProcessNotification?: ProcessNotification | null;
}

export type ProcessNotificationFacetId = string | {Id: string};

export interface ConfigurationKeyMultiValueFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ConfigurationKeyMultiValue_Id` |
     * | Type | `Edm.Guid` |
     */
    ConfigurationKeyMultiValue_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ConfigurationKeyMultiValue` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ConfigurationKeyMultiValue` |
     */
    ConfigurationKeyMultiValue?: ConfigurationKeyMultiValue | null;
}

export type ConfigurationKeyMultiValueFacetId = string | {Id: string};

export interface PrintJobFileFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFile_Id` |
     * | Type | `Edm.Guid` |
     */
    PrintJobFile_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFile` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.PrintJobFile` |
     */
    PrintJobFile?: PrintJobFile | null;
}

export type PrintJobFileFacetId = string | {Id: string};

export interface MachineToAMFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MachineToAM_Id` |
     * | Type | `Edm.Guid` |
     */
    MachineToAM_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MachineToAM` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.MachineToAM` |
     */
    MachineToAM?: MachineToAM | null;
}

export type MachineToAMFacetId = string | {Id: string};

export interface ConfigurationKeyFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ConfigurationKey_Id` |
     * | Type | `Edm.Guid` |
     */
    ConfigurationKey_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ConfigurationKey` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ConfigurationKey` |
     */
    ConfigurationKey?: ConfigurationKey | null;
}

export type ConfigurationKeyFacetId = string | {Id: string};

export interface NonConformanceNotificationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceNotification_Id` |
     * | Type | `Edm.Guid` |
     */
    NonConformanceNotification_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceNotification` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.NonConformanceNotification` |
     */
    NonConformanceNotification?: NonConformanceNotification | null;
}

export type NonConformanceNotificationFacetId = string | {Id: string};

export interface UserCertificationAssociationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserCertificationAssociation_Id` |
     * | Type | `Edm.Guid` |
     */
    UserCertificationAssociation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserCertificationAssociation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.UserCertificationAssociation` |
     */
    UserCertificationAssociation?: UserCertificationAssociation | null;
}

export type UserCertificationAssociationFacetId = string | {Id: string};

export interface SkillCertificationAssociationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SkillCertificationAssociation_Id` |
     * | Type | `Edm.Guid` |
     */
    SkillCertificationAssociation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SkillCertificationAssociation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.SkillCertificationAssociation` |
     */
    SkillCertificationAssociation?: SkillCertificationAssociation | null;
}

export type SkillCertificationAssociationFacetId = string | {Id: string};

export interface RoleCertificationAssociationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RoleCertificationAssociation_Id` |
     * | Type | `Edm.Guid` |
     */
    RoleCertificationAssociation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RoleCertificationAssociation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.RoleCertificationAssociation` |
     */
    RoleCertificationAssociation?: RoleCertificationAssociation | null;
}

export type RoleCertificationAssociationFacetId = string | {Id: string};

export interface MaterialCertificationAssociationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialCertificationAssociation_Id` |
     * | Type | `Edm.Guid` |
     */
    MaterialCertificationAssociation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialCertificationAssociation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.MaterialCertificationAssociation` |
     */
    MaterialCertificationAssociation?: MaterialCertificationAssociation | null;
}

export type MaterialCertificationAssociationFacetId = string | {Id: string};

export interface EquipmentCertificationAssociationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentCertificationAssociation_Id` |
     * | Type | `Edm.Guid` |
     */
    EquipmentCertificationAssociation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentCertificationAssociation` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentCertificationAssociation` |
     */
    EquipmentCertificationAssociation?: EquipmentCertificationAssociation | null;
}

export type EquipmentCertificationAssociationFacetId = string | {Id: string};

export interface CertificationHistoryActionFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CertificationHistoryAction_Id` |
     * | Type | `Edm.Guid` |
     */
    CertificationHistoryAction_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CertificationHistoryAction` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.CertificationHistoryAction` |
     */
    CertificationHistoryAction?: CertificationHistoryAction | null;
}

export type CertificationHistoryActionFacetId = string | {Id: string};

export interface CertificationHistoryFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CertificationHistory_Id` |
     * | Type | `Edm.Guid` |
     */
    CertificationHistory_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CertificationHistory` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.CertificationHistory` |
     */
    CertificationHistory?: CertificationHistory | null;
}

export type CertificationHistoryFacetId = string | {Id: string};

export interface CertificationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Certification_Id` |
     * | Type | `Edm.Guid` |
     */
    Certification_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Certification` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Certification` |
     */
    Certification?: Certification | null;
}

export type CertificationFacetId = string | {Id: string};

export interface TemplateToMaterialPlantFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TemplateToMaterialPlant_Id` |
     * | Type | `Edm.Guid` |
     */
    TemplateToMaterialPlant_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TemplateToMaterialPlant` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.TemplateToMaterialPlant` |
     */
    TemplateToMaterialPlant?: TemplateToMaterialPlant | null;
}

export type TemplateToMaterialPlantFacetId = string | {Id: string};

export interface TemplateTypeFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TemplateType_Id` |
     * | Type | `Edm.Guid` |
     */
    TemplateType_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TemplateType` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.TemplateType` |
     */
    TemplateType?: TemplateType | null;
}

export type TemplateTypeFacetId = string | {Id: string};

export interface TemplateBlockFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TemplateBlock_Id` |
     * | Type | `Edm.Guid` |
     */
    TemplateBlock_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TemplateBlock` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.TemplateBlock` |
     */
    TemplateBlock?: TemplateBlock | null;
}

export type TemplateBlockFacetId = string | {Id: string};

export interface TemplateFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Template_Id` |
     * | Type | `Edm.Guid` |
     */
    Template_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Template` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Template` |
     */
    Template?: Template | null;
}

export type TemplateFacetId = string | {Id: string};

export interface MaterialSpecificationTypeFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialSpecificationType_Id` |
     * | Type | `Edm.Guid` |
     */
    MaterialSpecificationType_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialSpecificationType` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.MaterialSpecificationType` |
     */
    MaterialSpecificationType?: MaterialSpecificationType | null;
}

export type MaterialSpecificationTypeFacetId = string | {Id: string};

export interface ToolDefinitionDocumentFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolDefinitionDocument_Id` |
     * | Type | `Edm.Guid` |
     */
    ToolDefinitionDocument_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolDefinitionDocument` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToolDefinitionDocument` |
     */
    ToolDefinitionDocument?: ToolDefinitionDocument | null;
}

export type ToolDefinitionDocumentFacetId = string | {Id: string};

export interface StepDependencyFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StepDependency_Id` |
     * | Type | `Edm.Guid` |
     */
    StepDependency_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StepDependency` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.StepDependency` |
     */
    StepDependency?: StepDependency | null;
}

export type StepDependencyFacetId = string | {Id: string};

export interface StepFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Step_Id` |
     * | Type | `Edm.Guid` |
     */
    Step_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Step` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Step` |
     */
    Step?: Step | null;
}

export type StepFacetId = string | {Id: string};

export interface ProcessFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Process_Id` |
     * | Type | `Edm.Guid` |
     */
    Process_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Process` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Process` |
     */
    Process?: Process | null;
}

export type ProcessFacetId = string | {Id: string};

export interface OperationDependencyFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationDependency_Id` |
     * | Type | `Edm.Guid` |
     */
    OperationDependency_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationDependency` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.OperationDependency` |
     */
    OperationDependency?: OperationDependency | null;
}

export type OperationDependencyFacetId = string | {Id: string};

export interface MaterialSpecificationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialSpecification_Id` |
     * | Type | `Edm.Guid` |
     */
    MaterialSpecification_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialSpecification` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.MaterialSpecification` |
     */
    MaterialSpecification?: MaterialSpecification | null;
}

export type MaterialSpecificationFacetId = string | {Id: string};

export interface MaterialDefinitionDocumentFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialDefinitionDocument_Id` |
     * | Type | `Edm.Guid` |
     */
    MaterialDefinitionDocument_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialDefinitionDocument` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.MaterialDefinitionDocument` |
     */
    MaterialDefinitionDocument?: MaterialDefinitionDocument | null;
}

export type MaterialDefinitionDocumentFacetId = string | {Id: string};

export interface EquipmentSpecificationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentSpecification_Id` |
     * | Type | `Edm.Guid` |
     */
    EquipmentSpecification_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentSpecification` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentSpecification` |
     */
    EquipmentSpecification?: EquipmentSpecification | null;
}

export type EquipmentSpecificationFacetId = string | {Id: string};

export interface DocumentFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Document_Id` |
     * | Type | `Edm.Guid` |
     */
    Document_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Document` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Document` |
     */
    Document?: Document | null;
}

export type DocumentFacetId = string | {Id: string};

export interface DependencyTypeFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DependencyType_Id` |
     * | Type | `Edm.Guid` |
     */
    DependencyType_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DependencyType` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.DependencyType` |
     */
    DependencyType?: DependencyType | null;
}

export type DependencyTypeFacetId = string | {Id: string};

export interface AsPlannedBOPFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBOP_Id` |
     * | Type | `Edm.Guid` |
     */
    AsPlannedBOP_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBOP` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.AsPlannedBOP` |
     */
    AsPlannedBOP?: AsPlannedBOP | null;
}

export type AsPlannedBOPFacetId = string | {Id: string};

export interface ToolSpecificationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolSpecification_Id` |
     * | Type | `Edm.Guid` |
     */
    ToolSpecification_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolSpecification` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.ToolSpecification` |
     */
    ToolSpecification?: ToolSpecification | null;
}

export type ToolSpecificationFacetId = string | {Id: string};

export interface APPMain_GF_WorkOrderExtension extends WorkOrderFacet {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ShortText` |
     * | Type | `Edm.String` |
     */
    ShortText: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LongText` |
     * | Type | `Edm.String` |
     */
    LongText: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BasicDataText` |
     * | Type | `Edm.String` |
     */
    BasicDataText: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialMemo` |
     * | Type | `Edm.String` |
     */
    MaterialMemo: string | null;
}

export interface APPMain_GF_Operation extends OperationFacet {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `InclusionRule` |
     * | Type | `Edm.String` |
     */
    InclusionRule: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `InclusionRuleParsed` |
     * | Type | `Edm.String` |
     */
    InclusionRuleParsed: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Mandatory` |
     * | Type | `Edm.Boolean` |
     */
    Mandatory: boolean | null;
}

export interface APPMain_DocumentCategory {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Grundfos.Opcenter.AppU4DM.APPMain.AMPOMModel.DataModel.ReadingModel.APPMain_DocumentCategoryFacet)` |
     */
    Facets?: Array<APPMain_DocumentCategoryFacet>;
}

export type APPMain_DocumentCategoryId = string | {Id: string};

export interface APPMain_GF_UoMMappings {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoMNId` |
     * | Type | `Edm.String` |
     */
    UoMNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SAPUoM` |
     * | Type | `Edm.String` |
     */
    SAPUoM: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Grundfos.Opcenter.AppU4DM.APPMain.AMPOMModel.DataModel.ReadingModel.APPMain_GF_UoMMappingsFacet)` |
     */
    Facets?: Array<APPMain_GF_UoMMappingsFacet>;
}

export type APPMain_GF_UoMMappingsId = string | {Id: string};

export interface APPMain_GF_File {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `File` |
     * | Type | `Edm.Binary` |
     */
    File: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FileName` |
     * | Type | `Edm.String` |
     */
    FileName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FileType` |
     * | Type | `Edm.String` |
     */
    FileType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Metadata` |
     * | Type | `Edm.String` |
     */
    Metadata: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Grundfos.Opcenter.AppU4DM.APPMain.AMPOMModel.DataModel.ReadingModel.APPMain_GF_FileFacet)` |
     */
    Facets?: Array<APPMain_GF_FileFacet>;
}

export type APPMain_GF_FileId = string | {Id: string};

export interface APPMain_GF_ReworkProcessAssignment {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FailureNId` |
     * | Type | `Edm.String` |
     */
    FailureNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UId` |
     * | Type | `Edm.Guid` |
     */
    UId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Failure_Id` |
     * | Type | `Edm.Guid` |
     */
    Failure_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Process_Id` |
     * | Type | `Edm.Guid` |
     */
    Process_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfig_Id` |
     * | Type | `Edm.Guid` |
     */
    EquipmentConfig_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Failure` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Failure` |
     */
    Failure?: Failure | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Process` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Process` |
     */
    Process?: Process | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfig` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentConfiguration` |
     */
    EquipmentConfig?: EquipmentConfiguration | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Grundfos.Opcenter.AppU4DM.APPMain.AMPOMModel.DataModel.ReadingModel.APPMain_GF_ReworkProcessAssignmentFacet)` |
     */
    Facets?: Array<APPMain_GF_ReworkProcessAssignmentFacet>;
}

export type APPMain_GF_ReworkProcessAssignmentId = string | {Id: string};

export interface APPMain_MaterialProperty {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PropertyValue` |
     * | Type | `Edm.String` |
     */
    PropertyValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PropertyUoMNId` |
     * | Type | `Edm.String` |
     */
    PropertyUoMNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PropertyType` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.SupportedTypes` |
     */
    PropertyType: SupportedTypes | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Material_Id` |
     * | Type | `Edm.Guid` |
     */
    Material_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Material` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Material` |
     */
    Material?: Material | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Grundfos.Opcenter.AppU4DM.APPMain.AMPOMModel.DataModel.ReadingModel.APPMain_MaterialPropertyFacet)` |
     */
    Facets?: Array<APPMain_MaterialPropertyFacet>;
}

export type APPMain_MaterialPropertyId = string | {Id: string};

export interface APPMain_DocumentEntityLink {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentNId` |
     * | Type | `Edm.String` |
     */
    DocumentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentRevision` |
     * | Type | `Edm.String` |
     */
    DocumentRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LinkedEntityType` |
     * | Type | `Edm.String` |
     */
    LinkedEntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LinkedEntityId` |
     * | Type | `Edm.Guid` |
     */
    LinkedEntityId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Grundfos.Opcenter.AppU4DM.APPMain.AMPOMModel.DataModel.ReadingModel.APPMain_DocumentEntityLinkFacet)` |
     */
    Facets?: Array<APPMain_DocumentEntityLinkFacet>;
}

export type APPMain_DocumentEntityLinkId = string | {Id: string};

export interface APPMain_TaskParameter {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterValue` |
     * | Type | `Edm.String` |
     */
    ParameterValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterUoMNId` |
     * | Type | `Edm.String` |
     */
    ParameterUoMNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsReadOnly` |
     * | Type | `Edm.Boolean` |
     */
    IsReadOnly: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Direction` |
     * | Type | `Siemens.SimaticIT.MasterData.TSK_MS.MSModel.Types.ReadingModel.TaskDefinitionParameterDirections` |
     */
    Direction: TaskDefinitionParameterDirections | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterType` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ReadingModel.SupportedTypes` |
     */
    ParameterType: SupportedTypes | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Task_Id` |
     * | Type | `Edm.Guid` |
     */
    Task_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Task` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Task` |
     */
    Task?: Task | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Grundfos.Opcenter.AppU4DM.APPMain.AMPOMModel.DataModel.ReadingModel.APPMain_TaskParameterFacet)` |
     */
    Facets?: Array<APPMain_TaskParameterFacet>;
}

export type APPMain_TaskParameterId = string | {Id: string};

export interface APPMain_GF_ScanDiagnostic {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SerialNumber` |
     * | Type | `Edm.String` |
     */
    SerialNumber: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Type` |
     * | Type | `Edm.String` |
     */
    Type: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkCenter` |
     * | Type | `Edm.String` |
     */
    WorkCenter: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Timestamp` |
     * | Type | `Edm.DateTimeOffset` |
     */
    Timestamp: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Grundfos.Opcenter.AppU4DM.APPMain.AMPOMModel.DataModel.ReadingModel.APPMain_GF_ScanDiagnosticFacet)` |
     */
    Facets?: Array<APPMain_GF_ScanDiagnosticFacet>;
}

export type APPMain_GF_ScanDiagnosticId = string | {Id: string};

export interface APPMain_GF_RunningScans {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RawXml` |
     * | Type | `Edm.String` |
     */
    RawXml: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Grundfos.Opcenter.AppU4DM.APPMain.AMPOMModel.DataModel.ReadingModel.APPMain_GF_RunningScansFacet)` |
     */
    Facets?: Array<APPMain_GF_RunningScansFacet>;
}

export type APPMain_GF_RunningScansId = string | {Id: string};

export interface APPMain_GF_ProductsWaitingForValidation {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProductId` |
     * | Type | `Edm.String` |
     */
    ProductId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkcenterNId` |
     * | Type | `Edm.String` |
     */
    WorkcenterNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ValidatedProductId` |
     * | Type | `Edm.String` |
     */
    ValidatedProductId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskId` |
     * | Type | `Edm.Guid` |
     */
    TaskId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ValidationOK` |
     * | Type | `Edm.Boolean` |
     */
    ValidationOK: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Handshaken` |
     * | Type | `Edm.Boolean` |
     */
    Handshaken: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Grundfos.Opcenter.AppU4DM.APPMain.AMPOMModel.DataModel.ReadingModel.APPMain_GF_ProductsWaitingForValidationFacet)` |
     */
    Facets?: Array<APPMain_GF_ProductsWaitingForValidationFacet>;
}

export type APPMain_GF_ProductsWaitingForValidationId = string | {Id: string};

export interface APPMain_GF_LineRouting {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FEVOR` |
     * | Type | `Edm.String` |
     */
    FEVOR: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DISPO` |
     * | Type | `Edm.String` |
     */
    DISPO: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WERKS` |
     * | Type | `Edm.String` |
     */
    WERKS: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UId` |
     * | Type | `Edm.Guid` |
     */
    UId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Equipment_Id` |
     * | Type | `Edm.Guid` |
     */
    Equipment_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Equipment` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.Equipment` |
     */
    Equipment?: Equipment | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Grundfos.Opcenter.AppU4DM.APPMain.AMPOMModel.DataModel.ReadingModel.APPMain_GF_LineRoutingFacet)` |
     */
    Facets?: Array<APPMain_GF_LineRoutingFacet>;
}

export type APPMain_GF_LineRoutingId = string | {Id: string};

export interface APPMain_DocumentCategoryFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `APPMain_DocumentCategory_Id` |
     * | Type | `Edm.Guid` |
     */
    APPMain_DocumentCategory_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `APPMain_DocumentCategory` |
     * | Type | `Grundfos.Opcenter.AppU4DM.APPMain.AMPOMModel.DataModel.ReadingModel.APPMain_DocumentCategory` |
     */
    APPMain_DocumentCategory?: APPMain_DocumentCategory | null;
}

export type APPMain_DocumentCategoryFacetId = string | {Id: string};

export interface APPMain_GF_UoMMappingsFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `APPMain_GF_UoMMappings_Id` |
     * | Type | `Edm.Guid` |
     */
    APPMain_GF_UoMMappings_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `APPMain_GF_UoMMappings` |
     * | Type | `Grundfos.Opcenter.AppU4DM.APPMain.AMPOMModel.DataModel.ReadingModel.APPMain_GF_UoMMappings` |
     */
    APPMain_GF_UoMMappings?: APPMain_GF_UoMMappings | null;
}

export type APPMain_GF_UoMMappingsFacetId = string | {Id: string};

export interface APPMain_GF_FileFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `APPMain_GF_File_Id` |
     * | Type | `Edm.Guid` |
     */
    APPMain_GF_File_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `APPMain_GF_File` |
     * | Type | `Grundfos.Opcenter.AppU4DM.APPMain.AMPOMModel.DataModel.ReadingModel.APPMain_GF_File` |
     */
    APPMain_GF_File?: APPMain_GF_File | null;
}

export type APPMain_GF_FileFacetId = string | {Id: string};

export interface APPMain_GF_ReworkProcessAssignmentFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `APPMain_GF_ReworkProcessAssignment_Id` |
     * | Type | `Edm.Guid` |
     */
    APPMain_GF_ReworkProcessAssignment_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `APPMain_GF_ReworkProcessAssignment` |
     * | Type | `Grundfos.Opcenter.AppU4DM.APPMain.AMPOMModel.DataModel.ReadingModel.APPMain_GF_ReworkProcessAssignment` |
     */
    APPMain_GF_ReworkProcessAssignment?: APPMain_GF_ReworkProcessAssignment | null;
}

export type APPMain_GF_ReworkProcessAssignmentFacetId = string | {Id: string};

export interface APPMain_MaterialPropertyFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `APPMain_MaterialProperty_Id` |
     * | Type | `Edm.Guid` |
     */
    APPMain_MaterialProperty_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `APPMain_MaterialProperty` |
     * | Type | `Grundfos.Opcenter.AppU4DM.APPMain.AMPOMModel.DataModel.ReadingModel.APPMain_MaterialProperty` |
     */
    APPMain_MaterialProperty?: APPMain_MaterialProperty | null;
}

export type APPMain_MaterialPropertyFacetId = string | {Id: string};

export interface APPMain_DocumentEntityLinkFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `APPMain_DocumentEntityLink_Id` |
     * | Type | `Edm.Guid` |
     */
    APPMain_DocumentEntityLink_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `APPMain_DocumentEntityLink` |
     * | Type | `Grundfos.Opcenter.AppU4DM.APPMain.AMPOMModel.DataModel.ReadingModel.APPMain_DocumentEntityLink` |
     */
    APPMain_DocumentEntityLink?: APPMain_DocumentEntityLink | null;
}

export type APPMain_DocumentEntityLinkFacetId = string | {Id: string};

export interface APPMain_TaskParameterFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `APPMain_TaskParameter_Id` |
     * | Type | `Edm.Guid` |
     */
    APPMain_TaskParameter_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `APPMain_TaskParameter` |
     * | Type | `Grundfos.Opcenter.AppU4DM.APPMain.AMPOMModel.DataModel.ReadingModel.APPMain_TaskParameter` |
     */
    APPMain_TaskParameter?: APPMain_TaskParameter | null;
}

export type APPMain_TaskParameterFacetId = string | {Id: string};

export interface APPMain_GF_ScanDiagnosticFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `APPMain_GF_ScanDiagnostic_Id` |
     * | Type | `Edm.Guid` |
     */
    APPMain_GF_ScanDiagnostic_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `APPMain_GF_ScanDiagnostic` |
     * | Type | `Grundfos.Opcenter.AppU4DM.APPMain.AMPOMModel.DataModel.ReadingModel.APPMain_GF_ScanDiagnostic` |
     */
    APPMain_GF_ScanDiagnostic?: APPMain_GF_ScanDiagnostic | null;
}

export type APPMain_GF_ScanDiagnosticFacetId = string | {Id: string};

export interface APPMain_GF_RunningScansFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `APPMain_GF_RunningScans_Id` |
     * | Type | `Edm.Guid` |
     */
    APPMain_GF_RunningScans_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `APPMain_GF_RunningScans` |
     * | Type | `Grundfos.Opcenter.AppU4DM.APPMain.AMPOMModel.DataModel.ReadingModel.APPMain_GF_RunningScans` |
     */
    APPMain_GF_RunningScans?: APPMain_GF_RunningScans | null;
}

export type APPMain_GF_RunningScansFacetId = string | {Id: string};

export interface APPMain_GF_ProductsWaitingForValidationFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `APPMain_GF_ProductsWaitingForValidation_Id` |
     * | Type | `Edm.Guid` |
     */
    APPMain_GF_ProductsWaitingForValidation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `APPMain_GF_ProductsWaitingForValidation` |
     * | Type | `Grundfos.Opcenter.AppU4DM.APPMain.AMPOMModel.DataModel.ReadingModel.APPMain_GF_ProductsWaitingForValidation` |
     */
    APPMain_GF_ProductsWaitingForValidation?: APPMain_GF_ProductsWaitingForValidation | null;
}

export type APPMain_GF_ProductsWaitingForValidationFacetId = string | {Id: string};

export interface APPMain_GF_LineRoutingFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `APPMain_GF_LineRouting_Id` |
     * | Type | `Edm.Guid` |
     */
    APPMain_GF_LineRouting_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `APPMain_GF_LineRouting` |
     * | Type | `Grundfos.Opcenter.AppU4DM.APPMain.AMPOMModel.DataModel.ReadingModel.APPMain_GF_LineRouting` |
     */
    APPMain_GF_LineRouting?: APPMain_GF_LineRouting | null;
}

export type APPMain_GF_LineRoutingFacetId = string | {Id: string};

export interface DSBoF_AcquisitionCycle {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     */
    Revision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceRevision` |
     * | Type | `Edm.String` |
     */
    SourceRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsCurrent` |
     * | Type | `Edm.Boolean` |
     */
    IsCurrent: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StartOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    StartOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Interval` |
     * | Type | `Edm.Int32` |
     */
    Interval: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StartingTimeKind` |
     * | Type | `Siemens.SimaticIT.MasterData.ATN_MS.MSModel.Types.ReadingModel.TagDateTimeKind` |
     */
    StartingTimeKind: TagDateTimeKind | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActivationStatus` |
     * | Type | `Siemens.SimaticIT.MasterData.ATN_MS.MSModel.Types.ReadingModel.ActivationStatus_Siemens_SimaticIT_MasterData_ATN_MS_MSModel_Types` |
     * | Nullable | `false` |
     */
    ActivationStatus: ActivationStatus_Siemens_SimaticIT_MasterData_ATN_MS_MSModel_Types;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.OpcenterEX.DS.AppU4DM.DSBoF.BFPOMModel.DataModel.ReadingModel.DSBoF_AcquisitionCycleFacet)` |
     */
    Facets?: Array<DSBoF_AcquisitionCycleFacet>;
}

export type DSBoF_AcquisitionCycleId = string | {Id: string};

export interface DSBoF_AcquisitionCycleFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DSBoF_AcquisitionCycle_Id` |
     * | Type | `Edm.Guid` |
     */
    DSBoF_AcquisitionCycle_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DSBoF_AcquisitionCycle` |
     * | Type | `Siemens.OpcenterEX.DS.AppU4DM.DSBoF.BFPOMModel.DataModel.ReadingModel.DSBoF_AcquisitionCycle` |
     */
    DSBoF_AcquisitionCycle?: DSBoF_AcquisitionCycle | null;
}

export type DSBoF_AcquisitionCycleFacetId = string | {Id: string};

export interface ToolAGW_EquipmentConfigurationToAutomationNodeInstance {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutomationNodeInstanceNId` |
     * | Type | `Edm.String` |
     */
    AutomationNodeInstanceNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfiguration_Id` |
     * | Type | `Edm.Guid` |
     */
    EquipmentConfiguration_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfiguration` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.DataModel.ReadingModel.EquipmentConfiguration` |
     */
    EquipmentConfiguration?: EquipmentConfiguration | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Facets` |
     * | Type | `Collection(Siemens.OpcenterEX.AT.AppU4DM.ToolAGW.TAPOMModel.DataModel.ReadingModel.ToolAGW_EquipmentConfigurationToAutomationNodeInstanceFacet)` |
     */
    Facets?: Array<ToolAGW_EquipmentConfigurationToAutomationNodeInstanceFacet>;
}

export type ToolAGW_EquipmentConfigurationToAutomationNodeInstanceId = string | {Id: string};

export interface ToolAGW_EquipmentConfigurationToAutomationNodeInstanceFacet {
    /**
     * **Key Property**: This is a key property used to identify the entity.<br/>**Managed**: This property is managed on the server side and cannot be edited.
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     */
    EntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCleaned` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCleaned: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolAGW_EquipmentConfigurationToAutomationNodeInstance_Id` |
     * | Type | `Edm.Guid` |
     */
    ToolAGW_EquipmentConfigurationToAutomationNodeInstance_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SegregationTags` |
     * | Type | `Collection(Siemens.SimaticIT.SystemData.Foundation.DataModel.ReadingModel.SegregationTag)` |
     */
    SegregationTags?: Array<SegregationTag>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolAGW_EquipmentConfigurationToAutomationNodeInstance` |
     * | Type | `Siemens.OpcenterEX.AT.AppU4DM.ToolAGW.TAPOMModel.DataModel.ReadingModel.ToolAGW_EquipmentConfigurationToAutomationNodeInstance` |
     */
    ToolAGW_EquipmentConfigurationToAutomationNodeInstance?: ToolAGW_EquipmentConfigurationToAutomationNodeInstance | null;
}

export type ToolAGW_EquipmentConfigurationToAutomationNodeInstanceFacetId = string | {Id: string};

export interface ExecutionError {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ErrorCode` |
     * | Type | `Edm.Int32` |
     * | Nullable | `false` |
     */
    ErrorCode: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ErrorMessage` |
     * | Type | `Edm.String` |
     */
    ErrorMessage: string | null;
}

export interface PrecheckExecution {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FullName` |
     * | Type | `Edm.String` |
     */
    FullName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Error` |
     * | Type | `Siemens.SimaticIT.Unified.Common.ExecutionError` |
     * | Nullable | `false` |
     */
    Error: ExecutionError;
}

export interface SitUafExecutionDetail {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrecheckDetails` |
     * | Type | `Collection(Siemens.SimaticIT.Unified.Common.PrecheckExecution)` |
     * | Nullable | `false` |
     */
    PrecheckDetails: Array<PrecheckExecution>;
}

export interface CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Succeeded` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    Succeeded: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Error` |
     * | Type | `Siemens.SimaticIT.Unified.Common.ExecutionError` |
     * | Nullable | `false` |
     */
    Error: ExecutionError;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SitUafExecutionDetail` |
     * | Type | `Siemens.SimaticIT.Unified.Common.SitUafExecutionDetail` |
     */
    SitUafExecutionDetail: SitUafExecutionDetail | null;
}

export interface FunctionResponse extends CommandResponse {
}

export interface PreCheckResponse extends CommandResponse {
}

export interface ServiceLayerUnityError {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `commandcallstack` |
     * | Type | `Collection(Edm.String)` |
     */
    commandcallstack: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `stacktrace` |
     * | Type | `Edm.String` |
     */
    stacktrace: string | null;
}

export interface ServiceLayerErrorObject {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `code` |
     * | Type | `Edm.String` |
     */
    code: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `message` |
     * | Type | `Edm.String` |
     */
    message: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `innererror` |
     * | Type | `Siemens.SimaticIT.ServiceLayer.Core.ServiceLayerUnityError` |
     */
    innererror: ServiceLayerUnityError | null;
}

export interface ServiceLayerError {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `error` |
     * | Type | `Siemens.SimaticIT.ServiceLayer.Core.ServiceLayerErrorObject` |
     */
    error: ServiceLayerErrorObject | null;
}

export interface UADMDeleteWorkOperationTypeListResponse extends CommandResponse {
}

export interface UADMDeleteWorkOperationTypeList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface UADMStartOperationResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Edm.String` |
     */
    WarningMessage: string | null;
}

export interface UADMStartOperation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UADMStartOperationParameters` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.StartWOOperationFullQtyParameterType)` |
     * | Nullable | `false` |
     */
    UADMStartOperationParameters: Array<StartWOOperationFullQtyParameterType>;
}

export interface UADMUpdateWOByBoPListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Id: Array<string>;
}

export interface UADMUpdateWOByBoPList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOsDetailsForUpdate` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.WorkOrderDetailsForBoPUpdateParameterType)` |
     * | Nullable | `false` |
     */
    WOsDetailsForUpdate: Array<WorkOrderDetailsForBoPUpdateParameterType>;
}

export interface UADMStartWOOperationTransferBatchListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Edm.String` |
     */
    WarningMessage: string | null;
}

export interface UADMStartWOOperationTransferBatchList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StartTransferBatchParameterTypeList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.StartWOOperationTransferBatchParameterType)` |
     * | Nullable | `false` |
     */
    StartTransferBatchParameterTypeList: Array<StartWOOperationTransferBatchParameterType>;
}

export interface UADMConsumeMaterialItemListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Collection(Edm.String)` |
     */
    WarningMessage: Array<string>;
}

export interface UADMConsumeMaterialItemList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItemToConsumeList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.MaterialItemToConsumeParameterType)` |
     * | Nullable | `false` |
     */
    MaterialItemToConsumeList: Array<MaterialItemToConsumeParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStepId: string | null;
}

export interface UADMSentenceNonConformanceResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReworkOrderId` |
     * | Type | `Edm.Guid` |
     */
    ReworkOrderId: string | null;
}

export interface UADMSentenceNonConformance {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NonConformanceNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceStatusNid` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NonConformanceStatusNid: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceHistoryId` |
     * | Type | `Edm.String` |
     */
    NonConformanceHistoryId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DocumentIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReworkOrderCreationDetails` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.CreateReworkOrderParameterType` |
     */
    ReworkOrderCreationDetails: CreateReworkOrderParameterType | null;
}

export interface UADMCreateNonConformanceResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceNId` |
     * | Type | `Edm.String` |
     */
    NonConformanceNId: string | null;
}

export interface UADMCreateNonConformance {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceDetails` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.NonConformanceParameterType` |
     * | Nullable | `false` |
     */
    NonConformanceDetails: NonConformanceParameterType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceHistoryDetails` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.NonConformanceHistoryParameterType` |
     * | Nullable | `false` |
     */
    NonConformanceHistoryDetails: NonConformanceHistoryParameterType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefectsDetails` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.DefectParameterType)` |
     */
    DefectsDetails: Array<DefectParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Context` |
     * | Type | `Edm.String` |
     */
    Context: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExtensionKey` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ExtensionKey: string;
}

export interface AcceptBuyOffResponse extends CommandResponse {
}

export interface AcceptBuyOff {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NonConformanceNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceHistoryId` |
     * | Type | `Edm.String` |
     */
    NonConformanceHistoryId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DocumentIds: Array<string>;
}

export interface RejectBuyOffResponse extends CommandResponse {
}

export interface RejectBuyOff {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NonConformanceNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceHistoryId` |
     * | Type | `Edm.String` |
     */
    NonConformanceHistoryId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Notes: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DocumentIds: Array<string>;
}

export interface UADMCreateWorkOrdersFromAsPlannedBOPResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface UADMCreateWorkOrdersFromAsPlannedBOP {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BaselineUId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    BaselineUId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProductionTypeNId` |
     * | Type | `Edm.String` |
     */
    ProductionTypeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ERPOrder` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ERPOrder: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Plant` |
     * | Type | `Edm.String` |
     */
    Plant: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BomToBeUsed` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.BoMParameterType` |
     */
    BomToBeUsed: BoMParameterType | null;
}

export interface UADMCreateTravellingWorkResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceNId` |
     * | Type | `Edm.String` |
     */
    NonConformanceNId: string | null;
}

export interface UADMCreateTravellingWork {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkOrderOperationNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
}

export interface UADMTakeOwnershipTravellingWorkResponse extends CommandResponse {
}

export interface UADMTakeOwnershipTravellingWork {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NonConformanceNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
}

export interface UADMAcceptTravellingWorkResponse extends CommandResponse {
}

export interface UADMAcceptTravellingWork {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NonConformanceNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DocumentIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
}

export interface UADMStartWOOperationSerializedListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Edm.String` |
     */
    WarningMessage: string | null;
}

export interface UADMStartWOOperationSerializedList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StartWOOperationSerializedParameterTypeList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.StartWOOperationSerializedParameterType)` |
     * | Nullable | `false` |
     */
    StartWOOperationSerializedParameterTypeList: Array<StartWOOperationSerializedParameterType>;
}

export interface UADMSetWorkOrderOperationFutureHoldListResponse extends CommandResponse {
}

export interface UADMSetWorkOrderOperationFutureHoldList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FutureHoldDetails` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.HoldParamterType)` |
     * | Nullable | `false` |
     */
    FutureHoldDetails: Array<HoldParamterType>;
}

export interface UADMCreateChangeNonConformanceResponse extends CommandResponse {
}

export interface UADMCreateChangeNonConformance {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkOrderNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkOrderOperationNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChangeTypeId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ChangeTypeId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
}

export interface UADMAbortWorkOrderResponse extends CommandResponse {
}

export interface UADMAbortWorkOrder {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderIdentifiersList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.WorkOrderIdentifiersParameterType)` |
     * | Nullable | `false` |
     */
    WorkOrderIdentifiersList: Array<WorkOrderIdentifiersParameterType>;
}

export interface UADMVerifyWorkOrderResponse extends CommandResponse {
}

export interface UADMVerifyWorkOrder {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItemIdentifiersList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.MaterialItemIdentifiersParameterType)` |
     * | Nullable | `false` |
     */
    MaterialItemIdentifiersList: Array<MaterialItemIdentifiersParameterType>;
}

export interface UADMSetWorkOrderHoldListResponse extends CommandResponse {
}

export interface UADMSetWorkOrderHoldList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `HoldDetails` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.HoldParamterType)` |
     * | Nullable | `false` |
     */
    HoldDetails: Array<HoldParamterType>;
}

export interface UADMRemoveWorkOrderOperationFutureHoldListResponse extends CommandResponse {
}

export interface UADMRemoveWorkOrderOperationFutureHoldList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FutureHoldIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    FutureHoldIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Comment` |
     * | Type | `Edm.String` |
     */
    Comment: string | null;
}

export interface UADMCompleteWOOperationSerializedListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Edm.String` |
     */
    WarningMessage: string | null;
}

export interface UADMCompleteWOOperationSerializedList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CompleteSerializedWoOpParameterList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.CompleteWOOperationSerializedParameterType)` |
     * | Nullable | `false` |
     */
    CompleteSerializedWoOpParameterList: Array<CompleteWOOperationSerializedParameterType>;
}

export interface UADMUnVerifyWorkOrderResponse extends CommandResponse {
}

export interface UADMUnVerifyWorkOrder {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItemIdentifiersList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.MaterialItemIdentifiersParameterType)` |
     * | Nullable | `false` |
     */
    MaterialItemIdentifiersList: Array<MaterialItemIdentifiersParameterType>;
}

export interface UADMCreateAndAssignProducedMaterialItemsResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderNId: string | null;
}

export interface UADMCreateAndAssignProducedMaterialItems {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkOrderNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FlexibleWorkOrderQuantity` |
     * | Type | `Edm.Decimal` |
     */
    FlexibleWorkOrderQuantity: number | null;
}

export interface UADMCompleteWOStepListResponse extends CommandResponse {
}

export interface UADMCompleteWOStepList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepListDetails` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.IdentifiersParameterType)` |
     * | Nullable | `false` |
     */
    WorkOrderStepListDetails: Array<IdentifiersParameterType>;
}

export interface UADMStartWOStepResponse extends CommandResponse {
}

export interface UADMStartWOStep {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepDetails` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.IdentifiersParameterType` |
     * | Nullable | `false` |
     */
    WorkOrderStepDetails: IdentifiersParameterType;
}

export interface UADMAcceptChangeRepeatOperationResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    WorkOrderOperationIds: Array<string>;
}

export interface UADMAcceptChangeRepeatOperation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AfterWorkorderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    AfterWorkorderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NonConformanceNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RefNumber` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    RefNumber: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CloseNotes` |
     * | Type | `Edm.String` |
     */
    CloseNotes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChangeDetails` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.RepeatOperationChangeParameter)` |
     * | Nullable | `false` |
     */
    ChangeDetails: Array<RepeatOperationChangeParameter>;
}

export interface UADMAcceptChangeAddToBeConsumedMaterialResponse extends CommandResponse {
}

export interface UADMAcceptChangeAddToBeConsumedMaterial {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChangePartId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ChangePartId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeConsumedMaterial` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ToBeConsumedMaterialParameter` |
     * | Nullable | `false` |
     */
    ToBeConsumedMaterial: ToBeConsumedMaterialParameter;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStepId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RefNumber` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    RefNumber: string;
}

export interface UADMAcceptChangeAddDCDRuntimeTaskResponse extends CommandResponse {
}

export interface UADMAcceptChangeAddDCDRuntimeTask {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Int32` |
     */
    WorkOrderOperationId: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Int32` |
     */
    WorkOrderStepId: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeConsumedMaterialId` |
     * | Type | `Edm.Int32` |
     */
    ToBeConsumedMaterialId: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DCDTaskId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    DCDTaskId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChangeDataCollectionId` |
     * | Type | `Edm.Int64` |
     * | Nullable | `false` |
     */
    ChangeDataCollectionId: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RefNumber` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    RefNumber: string;
}

export interface UADMAcceptChangeAddOperationResponse extends CommandResponse {
}

export interface UADMAcceptChangeAddOperation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChangeOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ChangeOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationName` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkOrderOperationName: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedMachine` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ToBeUsedMachineParameter` |
     * | Nullable | `false` |
     */
    ToBeUsedMachine: ToBeUsedMachineParameter;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AfterSequence` |
     * | Type | `Edm.Int32` |
     */
    AfterSequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RefNumber` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    RefNumber: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DependencyType` |
     * | Type | `Edm.String` |
     */
    DependencyType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationDescription` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationDescription: string | null;
}

export interface UADMAcceptChangeChangeDependencyResponse extends CommandResponse {
}

export interface UADMAcceptChangeChangeDependency {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChangeOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ChangeOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OldWorkOOperationDependencyId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    OldWorkOOperationDependencyId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NewWorkOOperationDependency` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.WorkOOperationDependencyParameter` |
     * | Nullable | `false` |
     */
    NewWorkOOperationDependency: WorkOOperationDependencyParameter;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RefNumber` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    RefNumber: string;
}

export interface UADMAcceptChangeChangeToBeConsumedMaterialQuantityResponse extends CommandResponse {
}

export interface UADMAcceptChangeChangeToBeConsumedMaterialQuantity {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChangePartId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ChangePartId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeConsumedMaterialId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToBeConsumedMaterialId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NewQuantity` |
     * | Type | `Edm.Decimal` |
     * | Nullable | `false` |
     */
    NewQuantity: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RefNumber` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    RefNumber: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsMaterialBehaviourOutputTypeFlag0` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsMaterialBehaviourOutputTypeFlag0: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsMaterialBehaviourOutputType` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsMaterialBehaviourOutputType: boolean;
}

export interface UADMAcceptChangeChangeToBeUsedMachineResponse extends CommandResponse {
}

export interface UADMAcceptChangeChangeToBeUsedMachine {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChangeOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ChangeOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OldToBeUsedMachineId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OldToBeUsedMachineId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NewToBeUsedMachine` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ToBeUsedMachineParameter` |
     * | Nullable | `false` |
     */
    NewToBeUsedMachine: ToBeUsedMachineParameter;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RefNumber` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    RefNumber: string;
}

export interface UADMAcceptChangeRemoveDependencyResponse extends CommandResponse {
}

export interface UADMAcceptChangeRemoveDependency {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChangeOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ChangeOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOOperationDependencyId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOOperationDependencyId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RefNumber` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    RefNumber: string;
}

export interface UADMAcceptChangeRemoveOperationResponse extends CommandResponse {
}

export interface UADMAcceptChangeRemoveOperation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChangeOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ChangeOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RefNumber` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    RefNumber: string;
}

export interface UADMAcceptChangeRemoveToBeConsumedMaterialResponse extends CommandResponse {
}

export interface UADMAcceptChangeRemoveToBeConsumedMaterial {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChangePartId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ChangePartId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeConsumedMaterialId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToBeConsumedMaterialId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RefNumber` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    RefNumber: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsMaterialBehaviourOutputTypeFlag0` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsMaterialBehaviourOutputTypeFlag0: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsMaterialBehaviourOutputType` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsMaterialBehaviourOutputType: boolean;
}

export interface UADMAcceptChangeReplaceToBeConsumedMaterialResponse extends CommandResponse {
}

export interface UADMAcceptChangeReplaceToBeConsumedMaterial {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChangePartId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ChangePartId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OldToBeConsumedMaterialId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OldToBeConsumedMaterialId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NewToBeConsumedMaterial` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ToBeConsumedMaterialParameter` |
     * | Nullable | `false` |
     */
    NewToBeConsumedMaterial: ToBeConsumedMaterialParameter;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RefNumber` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    RefNumber: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsMaterialBehaviourOutputTypeFlag0` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsMaterialBehaviourOutputTypeFlag0: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsMaterialBehaviourOutputType` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsMaterialBehaviourOutputType: boolean;
}

export interface UADMRejectChangeNonConformanceResponse extends CommandResponse {
}

export interface UADMRejectChangeNonConformance {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    NonConformanceId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
}

export interface UADMCreateReworkCodeListResponse extends CommandResponse {
}

export interface UADMCreateReworkCodeList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefectTypeId` |
     * | Type | `Edm.Guid` |
     */
    DefectTypeId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefectGroupId` |
     * | Type | `Edm.Guid` |
     */
    DefectGroupId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialDefinitionIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    MaterialDefinitionIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ProcessIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FailureNId` |
     * | Type | `Edm.String` |
     */
    FailureNId: string | null;
}

export interface UADMSentenceNonConformanceSetLocationHoldResponse extends CommandResponse {
}

export interface UADMSentenceNonConformanceSetLocationHold {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NonConformanceNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `HoldReasonNIdList` |
     * | Type | `Collection(Edm.String)` |
     */
    HoldReasonNIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Comment` |
     * | Type | `Edm.String` |
     */
    Comment: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNIdList` |
     * | Type | `Collection(Edm.String)` |
     */
    EquipmentNIdList: Array<string>;
}

export interface UADMManageToBeConsumedMaterialDisassembleResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceNId` |
     * | Type | `Edm.String` |
     */
    NonConformanceNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Edm.String` |
     */
    WarningMessage: string | null;
}

export interface UADMManageToBeConsumedMaterialDisassemble {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeConsumedMaterialId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToBeConsumedMaterialId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItemIdentifiersList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.MaterialItemIdentifiersParameterType)` |
     */
    MaterialItemIdentifiersList: Array<MaterialItemIdentifiersParameterType>;
}

export interface UADMSplitWorkOrderResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NewWorkOrderList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.WorkOrderIdentifiersParameterType)` |
     */
    NewWorkOrderList: Array<WorkOrderIdentifiersParameterType>;
}

export interface UADMSplitWorkOrder {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkOrderNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SplitType` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    SplitType: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NewWorkOrderList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.NewWorkOrderForSplit)` |
     * | Nullable | `false` |
     */
    NewWorkOrderList: Array<NewWorkOrderForSplit>;
}

export interface UADMSkipWOOperationFullQtyResponse extends CommandResponse {
}

export interface UADMSkipWOOperationFullQty {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationDetail` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.IdentifiersParameterType` |
     * | Nullable | `false` |
     */
    WorkOrderOperationDetail: IdentifiersParameterType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReasonNId` |
     * | Type | `Edm.String` |
     */
    ReasonNId: string | null;
}

export interface UADMSkipWOOperationTransferBatchResponse extends CommandResponse {
}

export interface UADMSkipWOOperationTransferBatch {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkOrderOperationNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Int32` |
     * | Nullable | `false` |
     */
    Quantity: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReasonNId` |
     * | Type | `Edm.String` |
     */
    ReasonNId: string | null;
}

export interface UADMSkipWOOperationSerializedResponse extends CommandResponse {
}

export interface UADMSkipWOOperationSerialized {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkOrderOperationNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItemIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    MaterialItemIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReasonNId` |
     * | Type | `Edm.String` |
     */
    ReasonNId: string | null;
}

export interface UADMSentenceNonConformancePartiallyResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReworkOrderId` |
     * | Type | `Edm.Guid` |
     */
    ReworkOrderId: string | null;
}

export interface UADMSentenceNonConformancePartially {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NonConformanceNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceStatusNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NonConformanceStatusNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DocumentIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Int32` |
     */
    Quantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeProducedQuantity` |
     * | Type | `Edm.Int32` |
     */
    ToBeProducedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PartialWorkedQuantity` |
     * | Type | `Edm.Int32` |
     */
    PartialWorkedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CompletedQuantity` |
     * | Type | `Edm.Int32` |
     */
    CompletedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItemList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    MaterialItemList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReworkProcessId` |
     * | Type | `Edm.Guid` |
     */
    ReworkProcessId: string | null;
}

export interface UADMGetActiveUserListOnWorkOrderOperationResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserIds` |
     * | Type | `Collection(Edm.String)` |
     */
    UserIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsUserActive` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsUserActive: boolean;
}

export interface UADMGetActiveUserListOnWorkOrderOperation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserId` |
     * | Type | `Edm.String` |
     */
    UserId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkOrderOperationNId: string;
}

export interface UADMCreateSnagAndNoteListResponse extends CommandResponse {
}

export interface UADMCreateSnagAndNoteList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Messages` |
     * | Type | `Collection(Edm.String)` |
     */
    Messages: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Status: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsWorkOrderLevel` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsWorkOrderLevel: boolean;
}

export interface UADMConfirmSnagAndNoteListResponse extends CommandResponse {
}

export interface UADMConfirmSnagAndNoteList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SnagAndNoteIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    SnagAndNoteIds: Array<string>;
}

export interface UADMUseToolResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Edm.String` |
     */
    WarningMessage: string | null;
}

export interface UADMUseTool {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToolId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedMaterialItemId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ProducedMaterialItemId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Comments` |
     * | Type | `Edm.String` |
     */
    Comments: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UsageDuration` |
     * | Type | `Edm.Int64` |
     */
    UsageDuration: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderStepNId: string | null;
}

export interface UADMSaveDCDRuntimeTaskValuesResponse extends CommandResponse {
}

export interface UADMSaveDCDRuntimeTaskValues {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    TaskId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParametersData` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.Types.WorkInstructionRuntimeValueParameterType)` |
     * | Nullable | `false` |
     */
    ParametersData: Array<WorkInstructionRuntimeValueParameterType>;
}

export interface UADMCheckDCDRuntimeValuesResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FailedTaskIds` |
     * | Type | `Collection(Edm.String)` |
     */
    FailedTaskIds: Array<string>;
}

export interface UADMCheckDCDRuntimeValues {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Int32` |
     */
    WorkOrderOperationId: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Int32` |
     */
    WorkOrderStepId: number | null;
}

export interface UADMSetLocationHoldResponse extends CommandResponse {
}

export interface UADMSetLocationHold {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentIdentifiers` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    EquipmentIdentifiers: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `HoldReasonNIdList` |
     * | Type | `Collection(Edm.String)` |
     */
    HoldReasonNIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Comment` |
     * | Type | `Edm.String` |
     */
    Comment: string | null;
}

export interface UADMDisassembleMaterialItemResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationNId: string | null;
}

export interface UADMDisassembleMaterialItem {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkOrderOperationNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItemToDisassembleList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.MaterialItemToDisassembleParameterType)` |
     * | Nullable | `false` |
     */
    MaterialItemToDisassembleList: Array<MaterialItemToDisassembleParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
}

export interface UADMExportGenealogyResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FileId` |
     * | Type | `Edm.Guid` |
     */
    FileId: string | null;
}

export interface UADMExportGenealogy {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentBatch` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ParentBatch: string;
}

export interface UADMCreateNewMaterialDefinitionRevisionResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface UADMCreateNewMaterialDefinitionRevision {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OriginalId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OriginalId: string;
}

export interface UADMDisAssignProducedMaterialitemsResponse extends CommandResponse {
}

export interface UADMDisAssignProducedMaterialitems {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkOrderNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItems` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.MaterialItemIdentifiersParameterType)` |
     * | Nullable | `false` |
     */
    MaterialItems: Array<MaterialItemIdentifiersParameterType>;
}

export interface UADMImportLifecycleResponse extends CommandResponse {
}

export interface UADMImportLifecycle {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LifecycleConfigurationXml` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    LifecycleConfigurationXml: string;
}

export interface UADMSaveDocumentForPreviewResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FileName` |
     * | Type | `Edm.String` |
     */
    FileName: string | null;
}

export interface UADMSaveDocumentForPreview {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    DocumentId: string;
}

export interface UADMAcceptChangeAddProcessOperationResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceNId` |
     * | Type | `Edm.String` |
     */
    NonConformanceNId: string | null;
}

export interface UADMAcceptChangeAddProcessOperation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChangeProcessOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ChangeProcessOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RefNumber` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    RefNumber: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AfterSequence` |
     * | Type | `Edm.Int32` |
     */
    AfterSequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ProcessOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationName` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationSequence` |
     * | Type | `Edm.Int32` |
     * | Nullable | `false` |
     */
    WorkOrderOperationSequence: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DependencyType` |
     * | Type | `Edm.String` |
     */
    DependencyType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationId` |
     * | Type | `Edm.Guid` |
     */
    OperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBopId` |
     * | Type | `Edm.Guid` |
     */
    AsPlannedBopId: string | null;
}

export interface UADMDeleteEquipmentResponse extends CommandResponse {
}

export interface UADMDeleteEquipment {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
}

export interface UADMRemoveWorkOrderScrapResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderId: string | null;
}

export interface UADMRemoveWorkOrderScrap {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
}

export interface UADMEnableLocationMachineForCompleteByDifferentUserResponse extends CommandResponse {
}

export interface UADMEnableLocationMachineForCompleteByDifferentUser {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Collection(Edm.String)` |
     */
    EquipmentNId: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Enabled` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    Enabled: boolean;
}

export interface UADMCreateWorkOrderOperationFromProcessOperationResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface UADMCreateWorkOrderOperationFromProcessOperation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.WorkOrderOperationFromOperationParameter` |
     * | Nullable | `false` |
     */
    WorkOrderOperation: WorkOrderOperationFromOperationParameter;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DependencyType` |
     * | Type | `Edm.String` |
     */
    DependencyType: string | null;
}

export interface UADMCreateNonConformanceDefectListResponse extends CommandResponse {
}

export interface UADMCreateNonConformanceDefectList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    NonConformanceId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefectList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.DefectParameterType)` |
     * | Nullable | `false` |
     */
    DefectList: Array<DefectParameterType>;
}

export interface UADMCreateDefectTypeContextualizationResponse extends CommandResponse {
}

export interface UADMCreateDefectTypeContextualization {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefectType` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    DefectType: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DM_MaterialList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationList` |
     * | Type | `Collection(Edm.String)` |
     */
    EquipmentConfigurationList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeList` |
     * | Type | `Collection(Edm.String)` |
     */
    EquipmentTypeList: Array<string>;
}

export interface UADMCreateDefectGroupContextualizationResponse extends CommandResponse {
}

export interface UADMCreateDefectGroupContextualization {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefectGroup` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    DefectGroup: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialDefinitionList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    MaterialDefinitionList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentList` |
     * | Type | `Collection(Edm.String)` |
     */
    EquipmentList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeList` |
     * | Type | `Collection(Edm.String)` |
     */
    EquipmentTypeList: Array<string>;
}

export interface UADMAssignNonConformanceTransitionRoleListResponse extends CommandResponse {
}

export interface UADMAssignNonConformanceTransitionRoleList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceTransitionId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NonConformanceTransitionId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RoleList` |
     * | Type | `Collection(Edm.String)` |
     */
    RoleList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LifeCycle` |
     * | Type | `Edm.String` |
     */
    LifeCycle: string | null;
}

export interface UADMRemoveNonConformanceTransitionRoleListResponse extends CommandResponse {
}

export interface UADMRemoveNonConformanceTransitionRoleList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceTransitionId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NonConformanceTransitionId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RoleList` |
     * | Type | `Collection(Edm.String)` |
     */
    RoleList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LifeCycle` |
     * | Type | `Edm.String` |
     */
    LifeCycle: string | null;
}

export interface UADMRemoveDefectGroupContextualizationResponse extends CommandResponse {
}

export interface UADMRemoveDefectGroupContextualization {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefectGroupId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    DefectGroupId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialDefinitionList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    MaterialDefinitionList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentList` |
     * | Type | `Collection(Edm.String)` |
     */
    EquipmentList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeList` |
     * | Type | `Collection(Edm.String)` |
     */
    EquipmentTypeList: Array<string>;
}

export interface UADMRemoveDefectTypeContextualizationResponse extends CommandResponse {
}

export interface UADMRemoveDefectTypeContextualization {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefectTypeId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    DefectTypeId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DM_MaterialList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationList` |
     * | Type | `Collection(Edm.String)` |
     */
    EquipmentConfigurationList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeList` |
     * | Type | `Collection(Edm.String)` |
     */
    EquipmentTypeList: Array<string>;
}

export interface UADMAssignNonConformanceTransitionMailAddressListResponse extends CommandResponse {
}

export interface UADMAssignNonConformanceTransitionMailAddressList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceTransitionId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NonConformanceTransitionId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MailAddressList` |
     * | Type | `Collection(Edm.String)` |
     */
    MailAddressList: Array<string>;
}

export interface UADMRemoveNonConformanceTransitionMailAddressListResponse extends CommandResponse {
}

export interface UADMRemoveNonConformanceTransitionMailAddressList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceTransitionId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NonConformanceTransitionId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MailAddressList` |
     * | Type | `Collection(Edm.String)` |
     */
    MailAddressList: Array<string>;
}

export interface UADMCreatePrintJobFileResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface UADMCreatePrintJobFile {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFile` |
     * | Type | `Siemens.SimaticIT.U4DM.MasterData.FB_MS_AMMS.MSModel.Types.PJFParameterType` |
     * | Nullable | `false` |
     */
    PrintJobFile: PJFParameterType;
}

export interface UADMImportAMPrintJobFileResponse extends CommandResponse {
}

export interface UADMImportAMPrintJobFile {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsDeltaImport` |
     * | Type | `Edm.Boolean` |
     */
    IsDeltaImport: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PlugInNameList` |
     * | Type | `Collection(Edm.String)` |
     */
    PlugInNameList: Array<string>;
}

export interface UADMCreateEquipmentSpecificationWithPrintJobFileResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentSpecificationId` |
     * | Type | `Edm.Guid` |
     */
    EquipmentSpecificationId: string | null;
}

export interface UADMCreateEquipmentSpecificationWithPrintJobFile {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentSpecification` |
     * | Type | `Siemens.SimaticIT.U4DM.MasterData.FB_MS_BOP.MSModel.Types.EquipmentSpecificationParameterType` |
     * | Nullable | `false` |
     */
    EquipmentSpecification: EquipmentSpecificationParameterType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFile` |
     * | Type | `Edm.Guid` |
     */
    PrintJobFile: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Process` |
     * | Type | `Edm.Guid` |
     */
    Process: string | null;
}

export interface UADMEditPrintJobFileResponse extends CommandResponse {
}

export interface UADMEditPrintJobFile {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFileDetails` |
     * | Type | `Siemens.SimaticIT.U4DM.MasterData.FB_MS_AMMS.MSModel.Types.PJFParameterType` |
     * | Nullable | `false` |
     */
    PrintJobFileDetails: PJFParameterType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsImport` |
     * | Type | `Edm.Boolean` |
     */
    IsImport: boolean | null;
}

export interface UADMTransferAMDataResponse extends CommandResponse {
}

export interface UADMTransferAMData {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFileId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    PrintJobFileId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFileExternalId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    PrintJobFileExternalId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MachineExternalId` |
     * | Type | `Edm.String` |
     */
    MachineExternalId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MachineNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    MachineNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MTUIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    MTUIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupId` |
     * | Type | `Edm.Guid` |
     */
    ExecutionGroupId: string | null;
}

export interface UADMAutoTransferAMDataResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFileExternalId` |
     * | Type | `Edm.String` |
     */
    PrintJobFileExternalId: string | null;
}

export interface UADMAutoTransferAMData {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProductId` |
     * | Type | `Edm.Guid` |
     */
    ProductId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MachineNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    MachineNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MTUIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    MTUIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupId` |
     * | Type | `Edm.Guid` |
     */
    ExecutionGroupId: string | null;
}

export interface UADMCompleteWOOperationTransferBatchMultiMachineListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Edm.String` |
     */
    WarningMessage: string | null;
}

export interface UADMCompleteWOOperationTransferBatchMultiMachineList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CompleteTransferBatchParameterTypeList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.CompleteWOOperationTransferBatchParameterType)` |
     * | Nullable | `false` |
     */
    CompleteTransferBatchParameterTypeList: Array<CompleteWOOperationTransferBatchParameterType>;
}

export interface UADMDeletePrintJobFileListResponse extends CommandResponse {
}

export interface UADMDeletePrintJobFileList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFileList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    PrintJobFileList: Array<string>;
}

export interface UADMCreatePrintJobFileListResponse extends CommandResponse {
}

export interface UADMCreatePrintJobFileList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `quantity` |
     * | Type | `Edm.Int32` |
     */
    quantity: number | null;
}

export interface ImportAMPrintJobFileResponse extends CommandResponse {
}

export interface ImportAMPrintJobFile {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsDeltaImport` |
     * | Type | `Edm.Boolean` |
     */
    IsDeltaImport: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PlugInName` |
     * | Type | `Edm.String` |
     */
    PlugInName: string | null;
}

export interface UADMPauseWorkOrderOperationMultiMachineListResponse extends CommandResponse {
}

export interface UADMPauseWorkOrderOperationMultiMachineList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PauseMultiMachineParameterTypeList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.PauseWOOperationParameterType)` |
     * | Nullable | `false` |
     */
    PauseMultiMachineParameterTypeList: Array<PauseWOOperationParameterType>;
}

export interface UADMCompleteWOOperationFullQtyMultiMachineListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Edm.String` |
     */
    WarningMessage: string | null;
}

export interface UADMCompleteWOOperationFullQtyMultiMachineList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UADMCompleteOperationParameters` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.CompleteWOOperationFullQtyParameterType)` |
     * | Nullable | `false` |
     */
    UADMCompleteOperationParameters: Array<CompleteWOOperationFullQtyParameterType>;
}

export interface UADMDeleteToolDefinitionListResponse extends CommandResponse {
}

export interface UADMDeleteToolDefinitionList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolDefinitionList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ToolDefinitionList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IgnoreToolDefinitionAssociation` |
     * | Type | `Edm.Boolean` |
     */
    IgnoreToolDefinitionAssociation: boolean | null;
}

export interface UADMCreateFormResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FormName` |
     * | Type | `Edm.String` |
     */
    FormName: string | null;
}

export interface UADMCreateForm {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PMIXml` |
     * | Type | `Edm.String` |
     */
    PMIXml: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItamName` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ItamName: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItemRevision` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ItemRevision: string;
}

export interface UADMGetPMIResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItemRevision` |
     * | Type | `Edm.String` |
     */
    ItemRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItemName` |
     * | Type | `Edm.String` |
     */
    ItemName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PMIXml` |
     * | Type | `Edm.String` |
     */
    PMIXml: string | null;
}

export interface UADMGetPMI {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TCItemID` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    TCItemID: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Context_id` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Context_id: string;
}

export interface UADMSaveAsWorkInstructionResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NewWorkInstructionId` |
     * | Type | `Edm.String` |
     */
    NewWorkInstructionId: string | null;
}

export interface UADMSaveAsWorkInstruction {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkInstructionId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NewWorkInstructionName` |
     * | Type | `Edm.String` |
     */
    NewWorkInstructionName: string | null;
}

export interface UADMAssociateFormsToTcMResponse extends CommandResponse {
}

export interface UADMAssociateFormsToTcM {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TCItemID` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    TCItemID: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FormIdList` |
     * | Type | `Collection(Edm.String)` |
     */
    FormIdList: Array<string>;
}

export interface UADMChangeWorkInstructionStatusResponse extends CommandResponse {
}

export interface UADMChangeWorkInstructionStatus {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionIdList` |
     * | Type | `Collection(Edm.String)` |
     */
    WorkInstructionIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Status: string;
}

export interface UADMCreateNewProcessRevisionResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface UADMCreateNewProcessRevision {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentProcessId` |
     * | Type | `Edm.Guid` |
     */
    ParentProcessId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ProcessId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBOPId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    AsPlannedBOPId: string;
}

export interface UADMUpdateNonConformanceResponse extends CommandResponse {
}

export interface UADMUpdateNonConformance {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NonConformanceNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Severity` |
     * | Type | `Edm.String` |
     */
    Severity: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
}

export interface UADMSetWorkOrderForSchedulingResponse extends CommandResponse {
}

export interface UADMSetWorkOrderForScheduling {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    UserId: string;
}

export interface UADMReleaseWorkOrderResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Id: Array<string>;
}

export interface UADMReleaseWorkOrder {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReleaseWorkOrderDetails` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ReleaseWorkOrderParameterType)` |
     * | Nullable | `false` |
     */
    ReleaseWorkOrderDetails: Array<ReleaseWorkOrderParameterType>;
}

export interface UADMAcceptChangeAddToBeUsedToolResponse extends CommandResponse {
}

export interface UADMAcceptChangeAddToBeUsedTool {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RefNumber` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    RefNumber: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogicalPosition` |
     * | Type | `Edm.String` |
     */
    LogicalPosition: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolDefinitionNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ToolDefinitionNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolUsage` |
     * | Type | `Edm.Decimal` |
     * | Nullable | `false` |
     */
    ToolUsage: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChangeToolId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ChangeToolId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolDefinitionId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToolDefinitionId: string;
}

export interface PLMCreateIssueReportResponse extends CommandResponse {
}

export interface PLMCreateIssueReport {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NonConformanceNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DocumentIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
}

export interface PLMCreateMasterPlanResponse extends CommandResponse {
}

export interface PLMCreateMasterPlan {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlan` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.Types.PLMMasterPlanParameterType` |
     * | Nullable | `false` |
     */
    MasterPlan: PLMMasterPlanParameterType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     */
    CorrelationId: string | null;
}

export interface PLMCreateOperationListResponse extends CommandResponse {
}

export interface PLMCreateOperationList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.Types.PLMOperationParameterType)` |
     * | Nullable | `false` |
     */
    OperationList: Array<PLMOperationParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     */
    CorrelationId: string | null;
}

export interface PLMCreateProcessListResponse extends CommandResponse {
}

export interface PLMCreateProcessList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.Types.PLMProcessParameterType)` |
     * | Nullable | `false` |
     */
    ProcessList: Array<PLMProcessParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     */
    CorrelationId: string | null;
}

export interface PLMCreateDocumentListResponse extends CommandResponse {
}

export interface PLMCreateDocumentList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.Types.PLMDocumentParameterType)` |
     * | Nullable | `false` |
     */
    DocumentList: Array<PLMDocumentParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     */
    CorrelationId: string | null;
}

export interface PLMCreateMaterialDefinitionListResponse extends CommandResponse {
}

export interface PLMCreateMaterialDefinitionList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.Types.PLMMaterialDefinitionParameterType)` |
     * | Nullable | `false` |
     */
    MaterialList: Array<PLMMaterialDefinitionParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     */
    CorrelationId: string | null;
}

export interface PLMCreateToolDefinitionListResponse extends CommandResponse {
}

export interface PLMCreateToolDefinitionList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.Types.PLMToolDefinitionParameterType)` |
     * | Nullable | `false` |
     */
    ToolList: Array<PLMToolDefinitionParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     */
    CorrelationId: string | null;
}

export interface PLMCreateStepListResponse extends CommandResponse {
}

export interface PLMCreateStepList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StepList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.Types.PLMStepParameterType)` |
     * | Nullable | `false` |
     */
    StepList: Array<PLMStepParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     */
    CorrelationId: string | null;
}

export interface PLMAssociateDocumentToMaterialDefinitionListResponse extends CommandResponse {
}

export interface PLMAssociateDocumentToMaterialDefinitionList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentAssociationList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.Types.PLMDocumentAssociationParameterType)` |
     * | Nullable | `false` |
     */
    DocumentAssociationList: Array<PLMDocumentAssociationParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     */
    CorrelationId: string | null;
}

export interface PLMAssociateDocumentToToolDefinitionListResponse extends CommandResponse {
}

export interface PLMAssociateDocumentToToolDefinitionList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentAssociationList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.Types.PLMDocumentAssociationParameterType)` |
     * | Nullable | `false` |
     */
    DocumentAssociationList: Array<PLMDocumentAssociationParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     */
    CorrelationId: string | null;
}

export interface PLMAssociateDocumentToOperationListResponse extends CommandResponse {
}

export interface PLMAssociateDocumentToOperationList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentAssociationList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.Types.PLMDocumentAssociationParameterType)` |
     * | Nullable | `false` |
     */
    DocumentAssociationList: Array<PLMDocumentAssociationParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     */
    CorrelationId: string | null;
}

export interface PLMAssociateDocumentToStepListResponse extends CommandResponse {
}

export interface PLMAssociateDocumentToStepList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentAssociationList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.Types.PLMDocumentAssociationParameterType)` |
     * | Nullable | `false` |
     */
    DocumentAssociationList: Array<PLMDocumentAssociationParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     */
    CorrelationId: string | null;
}

export interface PLMCreateAsPlannedBoPResponse extends CommandResponse {
}

export interface PLMCreateAsPlannedBoP {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBoP` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.Types.PLMAsPlannedBoPParameterType` |
     * | Nullable | `false` |
     */
    AsPlannedBoP: PLMAsPlannedBoPParameterType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     */
    CorrelationId: string | null;
}

export interface PLMLinkProcessToProcessFullListResponse extends CommandResponse {
}

export interface PLMLinkProcessToProcessFullList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LinkList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.Types.PLMLinkParameterType)` |
     * | Nullable | `false` |
     */
    LinkList: Array<PLMLinkParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     */
    CorrelationId: string | null;
}

export interface PLMLinkProcessToOperationFullListResponse extends CommandResponse {
}

export interface PLMLinkProcessToOperationFullList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LinkList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.Types.PLMLinkParameterType)` |
     * | Nullable | `false` |
     */
    LinkList: Array<PLMLinkParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     */
    CorrelationId: string | null;
}

export interface PLMLinkOperationToStepFullListResponse extends CommandResponse {
}

export interface PLMLinkOperationToStepFullList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LinkList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.Types.PLMLinkParameterType)` |
     * | Nullable | `false` |
     */
    LinkList: Array<PLMLinkParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     */
    CorrelationId: string | null;
}

export interface PLMCreateStepMaterialSpecificationFullListResponse extends CommandResponse {
}

export interface PLMCreateStepMaterialSpecificationFullList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialSpecificationList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.Types.PLMMaterialSpecificationParameterType)` |
     * | Nullable | `false` |
     */
    MaterialSpecificationList: Array<PLMMaterialSpecificationParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     */
    CorrelationId: string | null;
}

export interface PLMCreateStepToolSpecificationFullListResponse extends CommandResponse {
}

export interface PLMCreateStepToolSpecificationFullList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolSpecificationList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.Types.PLMToolSpecificationParameterType)` |
     * | Nullable | `false` |
     */
    ToolSpecificationList: Array<PLMToolSpecificationParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     */
    CorrelationId: string | null;
}

export interface PLMCreateStepDependencyListResponse extends CommandResponse {
}

export interface PLMCreateStepDependencyList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StepDependencyList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.Types.PLMStepDependencyParameterType)` |
     * | Nullable | `false` |
     */
    StepDependencyList: Array<PLMStepDependencyParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     */
    CorrelationId: string | null;
}

export interface PLMCreateOperationEquipmentSpecLocationFullListResponse extends CommandResponse {
}

export interface PLMCreateOperationEquipmentSpecLocationFullList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentSpecificationList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.Types.PLMEquipmentSpecLocationParameterType)` |
     * | Nullable | `false` |
     */
    EquipmentSpecificationList: Array<PLMEquipmentSpecLocationParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     */
    CorrelationId: string | null;
}

export interface PLMCreateOperationMaterialSpecificationFullListResponse extends CommandResponse {
}

export interface PLMCreateOperationMaterialSpecificationFullList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialSpecificationList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.Types.PLMMaterialSpecificationParameterType)` |
     * | Nullable | `false` |
     */
    MaterialSpecificationList: Array<PLMMaterialSpecificationParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     */
    CorrelationId: string | null;
}

export interface PLMCreateOperationToolSpecificationFullListResponse extends CommandResponse {
}

export interface PLMCreateOperationToolSpecificationFullList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolSpecificationList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.Types.PLMToolSpecificationParameterType)` |
     * | Nullable | `false` |
     */
    ToolSpecificationList: Array<PLMToolSpecificationParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     */
    CorrelationId: string | null;
}

export interface PLMCreateOpDependencyListResponse extends CommandResponse {
}

export interface PLMCreateOpDependencyList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationDependencyList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.Types.PLMOpDependencyParameterType)` |
     * | Nullable | `false` |
     */
    OperationDependencyList: Array<PLMOpDependencyParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     */
    CorrelationId: string | null;
}

export interface PLMSubmitResponse extends CommandResponse {
}

export interface PLMSubmit {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    CorrelationId: string;
}

export interface PLMSubmitMasterPlanResponse extends CommandResponse {
}

export interface PLMSubmitMasterPlan {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    CorrelationId: string;
}

export interface PLMRollbackResponse extends CommandResponse {
}

export interface PLMRollback {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    CorrelationId: string;
}

export interface PLMRollbackMasterPlanResponse extends CommandResponse {
}

export interface PLMRollbackMasterPlan {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    CorrelationId: string;
}

export interface PLMCreateIssueReportResultResponse extends CommandResponse {
}

export interface PLMCreateIssueReportResult {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `JobID` |
     * | Type | `Edm.String` |
     */
    JobID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceID` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NonConformanceID: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProblemReportUID` |
     * | Type | `Edm.String` |
     */
    ProblemReportUID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `completed` |
     * | Type | `Edm.Boolean` |
     */
    completed: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `status` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    status: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `message` |
     * | Type | `Edm.String` |
     */
    message: string | null;
}

export interface PLMCreateWorkOrderHeaderResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface PLMCreateWorkOrderHeader {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Name: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     * | Nullable | `false` |
     */
    Quantity: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Plant` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Plant: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BatchId` |
     * | Type | `Edm.String` |
     */
    BatchId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DueDate` |
     * | Type | `Edm.DateTimeOffset` |
     */
    DueDate: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ERPOrder` |
     * | Type | `Edm.String` |
     */
    ERPOrder: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedStartTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedStartTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedEndTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedEndTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FinalMaterialId` |
     * | Type | `Edm.Guid` |
     */
    FinalMaterialId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Priority` |
     * | Type | `Edm.Int32` |
     */
    Priority: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProductionTypeNId` |
     * | Type | `Edm.String` |
     */
    ProductionTypeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ConfigurationParameter` |
     * | Type | `Edm.String` |
     */
    ConfigurationParameter: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RoutingID` |
     * | Type | `Edm.String` |
     */
    RoutingID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetProductID` |
     * | Type | `Edm.String` |
     */
    TargetProductID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.String` |
     */
    CorrelationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ConfirmationType` |
     * | Type | `Edm.String` |
     */
    ConfirmationType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PBOPIdentID` |
     * | Type | `Edm.String` |
     */
    PBOPIdentID: string | null;
}

export interface PLMCreateWorkOrderFromMasterPlanBOMResolutionResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface PLMCreateWorkOrderFromMasterPlanBOMResolution {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Name: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     * | Nullable | `false` |
     */
    Quantity: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Plant` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Plant: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BatchId` |
     * | Type | `Edm.String` |
     */
    BatchId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DueDate` |
     * | Type | `Edm.DateTimeOffset` |
     */
    DueDate: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ERPOrder` |
     * | Type | `Edm.String` |
     */
    ERPOrder: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedStartTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedStartTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedEndTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedEndTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FinalMaterialId` |
     * | Type | `Edm.Guid` |
     */
    FinalMaterialId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Priority` |
     * | Type | `Edm.Int32` |
     */
    Priority: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProductionTypeNId` |
     * | Type | `Edm.String` |
     */
    ProductionTypeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.String` |
     */
    CorrelationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ConfirmationType` |
     * | Type | `Edm.String` |
     */
    ConfirmationType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlanId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    MasterPlanId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BOMMaterialList` |
     * | Type | `Collection(Edm.String)` |
     */
    BOMMaterialList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetProductID` |
     * | Type | `Edm.String` |
     */
    TargetProductID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BillOfFeatureNId` |
     * | Type | `Edm.String` |
     */
    BillOfFeatureNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BillOfFeatureRevision` |
     * | Type | `Edm.String` |
     */
    BillOfFeatureRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BomToBeUsed` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.BoMParameterType` |
     */
    BomToBeUsed: BoMParameterType | null;
}

export interface UADMCompleteAsPlannedBOPResponse extends CommandResponse {
}

export interface UADMCompleteAsPlannedBOP {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface UpdateMaterialDefinitionResponse extends CommandResponse {
}

export interface UpdateMaterialDefinition {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Revision: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Name: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FirstArticleInspection` |
     * | Type | `Edm.Boolean` |
     */
    FirstArticleInspection: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SerialNumberProfile` |
     * | Type | `Edm.Boolean` |
     */
    SerialNumberProfile: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaxRecycleCount` |
     * | Type | `Edm.Int32` |
     */
    MaxRecycleCount: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MinQuantity` |
     * | Type | `Edm.Decimal` |
     */
    MinQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogisticParameterType` |
     * | Type | `Siemens.SimaticIT.U4DM.ReferenceData.FB_RD_SERV.RFModel.Types.LogisticParameterType` |
     * | Nullable | `false` |
     */
    LogisticParameterType: LogisticParameterType;
}

export interface UADMDeleteBufferDefinitionListResponse extends CommandResponse {
}

export interface UADMDeleteBufferDefinitionList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface CopyToolDefinitionResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CopyToolDefinition {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NID` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NID: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Revision: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UID` |
     * | Type | `Edm.String` |
     */
    UID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SubstrateDefinitionProperties` |
     * | Type | `Siemens.SimaticIT.MasterData.MatTool.MSModel.Types.SubstrateDefinitionPropertiesParameterType` |
     */
    SubstrateDefinitionProperties: SubstrateDefinitionPropertiesParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolClassNId` |
     * | Type | `Edm.String` |
     */
    ToolClassNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UsageCounterMax` |
     * | Type | `Edm.Int32` |
     */
    UsageCounterMax: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UsageDurationMax` |
     * | Type | `Edm.Duration` |
     */
    UsageDurationMax: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExpirationDate` |
     * | Type | `Edm.DateTimeOffset` |
     */
    ExpirationDate: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Consumable` |
     * | Type | `Edm.Boolean` |
     */
    Consumable: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RevisionExpression` |
     * | Type | `Edm.String` |
     */
    RevisionExpression: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogisticParameter` |
     * | Type | `Siemens.SimaticIT.U4DM.ReferenceData.FB_RD_SERV.RFModel.Types.LogisticParameterType` |
     */
    LogisticParameter: LogisticParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OriginalToolDefinitionID` |
     * | Type | `Edm.Guid` |
     */
    OriginalToolDefinitionID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Lockable` |
     * | Type | `Edm.Boolean` |
     */
    Lockable: boolean | null;
}

export interface UADMUpdateToolDefinitionResponse extends CommandResponse {
}

export interface UADMUpdateToolDefinition {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SubstrateDefinitionProperties` |
     * | Type | `Siemens.SimaticIT.MasterData.MatTool.MSModel.Types.SubstrateDefinitionPropertiesParameterType` |
     */
    SubstrateDefinitionProperties: SubstrateDefinitionPropertiesParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UsageCounterMax` |
     * | Type | `Edm.Int32` |
     */
    UsageCounterMax: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UsageDurationMax` |
     * | Type | `Edm.Duration` |
     */
    UsageDurationMax: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExpirationDate` |
     * | Type | `Edm.DateTimeOffset` |
     */
    ExpirationDate: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Consumable` |
     * | Type | `Edm.Boolean` |
     */
    Consumable: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogisticParameter` |
     * | Type | `Siemens.SimaticIT.U4DM.ReferenceData.FB_RD_SERV.RFModel.Types.LogisticParameterType` |
     */
    LogisticParameter: LogisticParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Lockable` |
     * | Type | `Edm.Boolean` |
     */
    Lockable: boolean | null;
}

export interface UADMDeleteMaterialDefinitionsResponse extends CommandResponse {
}

export interface UADMDeleteMaterialDefinitions {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface UADMDeleteAsPlannedBOPListResponse extends CommandResponse {
}

export interface UADMDeleteAsPlannedBOPList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface UADMLinkMaterialItemsToHandlingUnitResponse extends CommandResponse {
}

export interface UADMLinkMaterialItemsToHandlingUnit {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItems` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    MaterialItems: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `HandlingUnitId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    HandlingUnitId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
}

export interface UADMLinkGenericItemsToNonConformanceResponse extends CommandResponse {
}

export interface UADMLinkGenericItemsToNonConformance {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Context` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Context: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    NonConformanceId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `GenericItems` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    GenericItems: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNIds` |
     * | Type | `Collection(Edm.String)` |
     */
    EquipmentNIds: Array<string>;
}

export interface UADMUnLinkGenericItemsFromNonConformanceResponse extends CommandResponse {
}

export interface UADMUnLinkGenericItemsFromNonConformance {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Context` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Context: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `GenericItems` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    GenericItems: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    NonConformanceId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNIds` |
     * | Type | `Collection(Edm.String)` |
     */
    EquipmentNIds: Array<string>;
}

export interface UADMCreateExecutionGroupResponse extends CommandResponse {
}

export interface UADMCreateExecutionGroup {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedDuration` |
     * | Type | `Edm.Duration` |
     */
    EstimatedDuration: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedStartTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedStartTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedEndTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedEndTime: string | null;
}

export interface UADMCreateWorkOrderFromProcessResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface UADMCreateWorkOrderFromProcess {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BatchId` |
     * | Type | `Edm.String` |
     */
    BatchId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ProcessId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProductionTypeNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ProductionTypeNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DueDate` |
     * | Type | `Edm.DateTimeOffset` |
     */
    DueDate: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedStartTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedStartTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Priority` |
     * | Type | `Edm.Int32` |
     */
    Priority: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ERPOrder` |
     * | Type | `Edm.String` |
     */
    ERPOrder: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedEndTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedEndTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedId` |
     * | Type | `Edm.Guid` |
     */
    AsPlannedId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Plant` |
     * | Type | `Edm.String` |
     */
    Plant: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FinalMaterialId` |
     * | Type | `Edm.Guid` |
     */
    FinalMaterialId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BillOfFeatureNId` |
     * | Type | `Edm.String` |
     */
    BillOfFeatureNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BillOfFeatureRevision` |
     * | Type | `Edm.String` |
     */
    BillOfFeatureRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BomToBeUsed` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.BoMParameterType` |
     */
    BomToBeUsed: BoMParameterType | null;
}

export interface UADMLinkMaterialItemsToBufferResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Edm.String` |
     */
    WarningMessage: string | null;
}

export interface UADMLinkMaterialItemsToBuffer {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BufferId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    BufferId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItemList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    MaterialItemList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     * | Nullable | `false` |
     */
    Quantity: QuantityParameterType;
}

export interface UADMAcceptChangeAddWorkInstructionResponse extends CommandResponse {
}

export interface UADMAcceptChangeAddWorkInstruction {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WIDefinitionId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WIDefinitionId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SerialNumberCodes` |
     * | Type | `Collection(Edm.String)` |
     */
    SerialNumberCodes: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RefNumber` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    RefNumber: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChangeDataCollectionId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ChangeDataCollectionId: string;
}

export interface UADMDeleteSkillListResponse extends CommandResponse {
}

export interface UADMDeleteSkillList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SkillIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    SkillIds: Array<string>;
}

export interface UADMStartNonProductiveActivityListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface UADMStartNonProductiveActivityList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NPAIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    NPAIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NPAContextId` |
     * | Type | `Edm.Guid` |
     */
    NPAContextId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NPAContextValue` |
     * | Type | `Edm.Guid` |
     */
    NPAContextValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NPAEquipmentNIdValue` |
     * | Type | `Edm.String` |
     */
    NPAEquipmentNIdValue: string | null;
}

export interface UADMCompleteNonProductiveActivityListResponse extends CommandResponse {
}

export interface UADMCompleteNonProductiveActivityList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserNPAIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    UserNPAIds: Array<string>;
}

export interface UADMDeleteNonProductiveActivityListResponse extends CommandResponse {
}

export interface UADMDeleteNonProductiveActivityList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonProductiveActivityList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    NonProductiveActivityList: Array<string>;
}

export interface UADMDeleteOperationStepCategoryListResponse extends CommandResponse {
}

export interface UADMDeleteOperationStepCategoryList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface UADMLinkSkillsToTeamResponse extends CommandResponse {
}

export interface UADMLinkSkillsToTeam {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Level` |
     * | Type | `Edm.Int32` |
     */
    Level: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SkillIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    SkillIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TeamId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    TeamId: string;
}

export interface UADMCopyDM_MaterialResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialId` |
     * | Type | `Edm.Guid` |
     */
    DM_MaterialId: string | null;
}

export interface UADMCopyDM_Material {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OriginalDM_MaterialId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OriginalDM_MaterialId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Name: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SerialNumberProfile` |
     * | Type | `Edm.Boolean` |
     */
    SerialNumberProfile: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FirstArticleInspection` |
     * | Type | `Edm.Boolean` |
     */
    FirstArticleInspection: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AMPowderProperties` |
     * | Type | `Siemens.SimaticIT.UADM.OperationalData.FB_OP_MAT.OPModel.Types.AMPowderPropertiesParameterType` |
     */
    AMPowderProperties: AMPowderPropertiesParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogisticClassNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    LogisticClassNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Weight` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    Weight: QuantityParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Volume` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    Volume: QuantityParameterType | null;
}

export interface UADMUnLinkUsersFromTeamResponse extends CommandResponse {
}

export interface UADMUnLinkUsersFromTeam {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TeamUserAssociationIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    TeamUserAssociationIds: Array<string>;
}

export interface UADMLinkUsersToTeamResponse extends CommandResponse {
}

export interface UADMLinkUsersToTeam {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TeamId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    TeamId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Users` |
     * | Type | `Collection(Edm.String)` |
     */
    Users: Array<string>;
}

export interface UADMDeleteDM_MaterialListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Edm.String` |
     */
    WarningMessage: string | null;
}

export interface UADMDeleteDM_MaterialList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DM_MaterialIds: Array<string>;
}

export interface UADMDeleteCustomItlkCheckListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Edm.String` |
     */
    WarningMessage: string | null;
}

export interface UADMDeleteCustomItlkCheckList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ListOfItlkCheckId` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ListOfItlkCheckId: Array<string>;
}

export interface UADMDeleteCustomItlkCheckParameterListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Edm.String` |
     */
    WarningMessage: string | null;
}

export interface UADMDeleteCustomItlkCheckParameterList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ListOfItlkCheckParameterId` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ListOfItlkCheckParameterId: Array<string>;
}

export interface UADMRemoveHoldListResponse extends CommandResponse {
}

export interface UADMRemoveHoldList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `HoldIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    HoldIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Comment` |
     * | Type | `Edm.String` |
     */
    Comment: string | null;
}

export interface PLMCreateOperationDCDListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionDefinitionList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    WorkInstructionDefinitionList: Array<string>;
}

export interface PLMCreateOperationDCDList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DCDList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.Types.PLMDCDParameterType)` |
     * | Nullable | `false` |
     */
    DCDList: Array<PLMDCDParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     */
    CorrelationId: string | null;
}

export interface PLMCreateStepDCDListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionDefinitionList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    WorkInstructionDefinitionList: Array<string>;
}

export interface PLMCreateStepDCDList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DCDList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.Types.PLMDCDParameterType)` |
     * | Nullable | `false` |
     */
    DCDList: Array<PLMDCDParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     */
    CorrelationId: string | null;
}

export interface UADMRegisterNonProductiveActivityForUserResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface UADMRegisterNonProductiveActivityForUser {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NPAId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    NPAId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NPAUserParameter` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.NPAUserParameterType` |
     * | Nullable | `false` |
     */
    NPAUserParameter: NPAUserParameterType;
}

export interface UADMDeleteNonProductiveActivityListForUserResponse extends CommandResponse {
}

export interface UADMDeleteNonProductiveActivityListForUser {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserNPAIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    UserNPAIds: Array<string>;
}

export interface UADMUpdateNonProductiveActivityForUserResponse extends CommandResponse {
}

export interface UADMUpdateNonProductiveActivityForUser {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserNPAId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    UserNPAId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NPAUserParameter` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.NPAUserParameterType` |
     * | Nullable | `false` |
     */
    NPAUserParameter: NPAUserParameterType;
}

export interface CancelSchedulingResponse extends CommandResponse {
}

export interface CancelScheduling {
}

export interface SetInSchedulingResponse extends CommandResponse {
}

export interface SetInScheduling {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NIds` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.FB_OP_APSInt.OPModel.Types.NIdsParameterType` |
     * | Nullable | `false` |
     */
    NIds: NIdsParameterType;
}

export interface SetInScheduledResponse extends CommandResponse {
}

export interface SetInScheduled {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `APSOrderOperations` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.FB_OP_APSInt.OPModel.Types.APSOrderOperationsParameterType` |
     * | Nullable | `false` |
     */
    APSOrderOperations: APSOrderOperationsParameterType;
}

export interface SetAlternativeSelectedResponse extends CommandResponse {
}

export interface SetAlternativeSelected {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeConsumedMaterialId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToBeConsumedMaterialId: string;
}

export interface UADMAutomaticCreateNonConformanceOnMTUListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceNId` |
     * | Type | `Edm.String` |
     */
    NonConformanceNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Edm.String` |
     */
    WarningMessage: string | null;
}

export interface UADMAutomaticCreateNonConformanceOnMTUList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentName` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    EquipmentName: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Category` |
     * | Type | `Edm.String` |
     */
    Category: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TimeStamp` |
     * | Type | `Edm.DateTimeOffset` |
     */
    TimeStamp: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Severity` |
     * | Type | `Edm.String` |
     */
    Severity: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefectTypeList` |
     * | Type | `Collection(Edm.String)` |
     */
    DefectTypeList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MTUCodeList` |
     * | Type | `Collection(Edm.String)` |
     */
    MTUCodeList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
}

export interface UADMAutomaticCreateNonConformanceOnWOOperationResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceNId` |
     * | Type | `Edm.String` |
     */
    NonConformanceNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Edm.String` |
     */
    WarningMessage: string | null;
}

export interface UADMAutomaticCreateNonConformanceOnWOOperation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentName` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    EquipmentName: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Category` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Category: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TimeStamp` |
     * | Type | `Edm.DateTimeOffset` |
     */
    TimeStamp: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefectTypeList` |
     * | Type | `Collection(Edm.String)` |
     */
    DefectTypeList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Severity` |
     * | Type | `Edm.String` |
     */
    Severity: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
}

export interface UADMAutomaticCreateNonConformanceOnEquipmentResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceNId` |
     * | Type | `Edm.String` |
     */
    NonConformanceNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Edm.String` |
     */
    WarningMessage: string | null;
}

export interface UADMAutomaticCreateNonConformanceOnEquipment {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentName` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    EquipmentName: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TimeStamp` |
     * | Type | `Edm.DateTimeOffset` |
     */
    TimeStamp: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefectTypeList` |
     * | Type | `Collection(Edm.String)` |
     */
    DefectTypeList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Severity` |
     * | Type | `Edm.String` |
     */
    Severity: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
}

export interface UADMAutomaticUseToolListResponse extends CommandResponse {
}

export interface UADMAutomaticUseToolList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentName` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    EquipmentName: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Category` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Category: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TimeStamp` |
     * | Type | `Edm.DateTimeOffset` |
     * | Nullable | `false` |
     */
    TimeStamp: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolToBeUsedOnMaterialItemList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.Types.MaterialItemToolToBeUsedInfo)` |
     * | Nullable | `false` |
     */
    ToolToBeUsedOnMaterialItemList: Array<MaterialItemToolToBeUsedInfo>;
}

export interface UADMAutomaticConsumeMaterialTrackingUnitResponse extends CommandResponse {
}

export interface UADMAutomaticConsumeMaterialTrackingUnit {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentName` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    EquipmentName: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOperationCategory` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkOperationCategory: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TimeStamp` |
     * | Type | `Edm.DateTimeOffset` |
     * | Nullable | `false` |
     */
    TimeStamp: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ConsumptionDetails` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.AutomaticConsumptionParameterType)` |
     * | Nullable | `false` |
     */
    ConsumptionDetails: Array<AutomaticConsumptionParameterType>;
}

export interface UADMCreateNonConformanceV3_1Response extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceNId` |
     * | Type | `Edm.String` |
     */
    NonConformanceNId: string | null;
}

export interface UADMCreateNonConformanceV3_1 {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceProperties` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.NonConformancePropertyType` |
     * | Nullable | `false` |
     */
    NonConformanceProperties: NonConformancePropertyType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefectList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.DefectParameterType)` |
     */
    DefectList: Array<DefectParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChangeOperationProperties` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ChangeOperationParameterType` |
     */
    ChangeOperationProperties: ChangeOperationParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChangePartProperties` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ChangePartParameterType` |
     */
    ChangePartProperties: ChangePartParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChangeDataCollectionProperties` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ChangeDataCollectionParameterType` |
     */
    ChangeDataCollectionProperties: ChangeDataCollectionParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `QualityNonConformanceProperties` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.QualityNonConformancePropertiesType` |
     * | Nullable | `false` |
     */
    QualityNonConformanceProperties: QualityNonConformancePropertiesType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AttachmentList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.NonConformanceAttachmentParameterType)` |
     */
    AttachmentList: Array<NonConformanceAttachmentParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContainerNidList` |
     * | Type | `Collection(Edm.String)` |
     */
    ContainerNidList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsAutomatic` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsAutomatic: boolean;
}

export interface UADMSentenceNonConformanceV3_1Response extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReworkOrderId` |
     * | Type | `Edm.Guid` |
     */
    ReworkOrderId: string | null;
}

export interface UADMSentenceNonConformanceV3_1 {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NonConformanceNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceStatusNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NonConformanceStatusNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DocumentIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformancePartialWOOpQuantities` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.NonConformanceQuantities4PartialSentenceParameterType` |
     */
    NonConformancePartialWOOpQuantities: NonConformanceQuantities4PartialSentenceParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReworkProcessId` |
     * | Type | `Edm.Guid` |
     */
    ReworkProcessId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsAutomaticallyInvoked` |
     * | Type | `Edm.Boolean` |
     */
    IsAutomaticallyInvoked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNIdList` |
     * | Type | `Collection(Edm.String)` |
     */
    EquipmentNIdList: Array<string>;
}

export interface UADMAutomaticSentenceNonConformanceResponse extends CommandResponse {
}

export interface UADMAutomaticSentenceNonConformance {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentName` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    EquipmentName: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NonConformanceNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TimeStamp` |
     * | Type | `Edm.DateTimeOffset` |
     */
    TimeStamp: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetStatus` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    TargetStatus: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Int32` |
     */
    Quantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SerialNumberCodeList` |
     * | Type | `Collection(Edm.String)` |
     */
    SerialNumberCodeList: Array<string>;
}

export interface UADMCreateToBeUsedMachinePJFResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedMachineId` |
     * | Type | `Edm.Guid` |
     */
    ToBeUsedMachineId: string | null;
}

export interface UADMCreateToBeUsedMachinePJF {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkOrderOperationNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeNId` |
     * | Type | `Edm.String` |
     */
    EquipmentTypeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PartProgram` |
     * | Type | `Edm.String` |
     */
    PartProgram: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsSourcePJF` |
     * | Type | `Edm.Boolean` |
     */
    IsSourcePJF: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFile` |
     * | Type | `Edm.Guid` |
     */
    PrintJobFile: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFileExternalId` |
     * | Type | `Edm.String` |
     */
    PrintJobFileExternalId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFileName` |
     * | Type | `Edm.String` |
     */
    PrintJobFileName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFileSource` |
     * | Type | `Edm.String` |
     */
    PrintJobFileSource: string | null;
}

export interface UADMDeleteStepListResponse extends CommandResponse {
}

export interface UADMDeleteStepList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StepIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    StepIds: Array<string>;
}

export interface UADMAbruptlyCloseFlexibleWorkOrderResponse extends CommandResponse {
}

export interface UADMAbruptlyCloseFlexibleWorkOrder {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NewWorkOrderNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NewWorkOrderNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OriginalWorkOrderId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OriginalWorkOrderId: string;
}

export interface UADMLinkHumanResourceToProcessResponse extends CommandResponse {
}

export interface UADMLinkHumanResourceToProcess {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ParentId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CertificationNIds` |
     * | Type | `Collection(Edm.String)` |
     */
    CertificationNIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RequiredNumberOfHumanResource` |
     * | Type | `Collection(Edm.Int32)` |
     * | Nullable | `false` |
     */
    RequiredNumberOfHumanResource: Array<number>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentIndicator` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ParentIndicator: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBoPId` |
     * | Type | `Edm.Guid` |
     */
    AsPlannedBoPId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlanId` |
     * | Type | `Edm.Guid` |
     */
    MasterPlanId: string | null;
}

export interface UADMUnlinkHumanResourceFromProcessResponse extends CommandResponse {
}

export interface UADMUnlinkHumanResourceFromProcess {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ParentId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CertificationNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    CertificationNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentIndicator` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ParentIndicator: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBoPId` |
     * | Type | `Edm.Guid` |
     */
    AsPlannedBoPId: string | null;
}

export interface PLMCreateCertificationWithSkillListResponse extends CommandResponse {
}

export interface PLMCreateCertificationWithSkillList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CertificationList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.Types.PLMCertificationWithSkillParameterType)` |
     * | Nullable | `false` |
     */
    CertificationList: Array<PLMCertificationWithSkillParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     */
    CorrelationId: string | null;
}

export interface PLMCreateOperationHRSpecificationFullListResponse extends CommandResponse {
}

export interface PLMCreateOperationHRSpecificationFullList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `HumanResourceSpecificationList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.Types.PLMHRSpecificationParameterType)` |
     * | Nullable | `false` |
     */
    HumanResourceSpecificationList: Array<PLMHRSpecificationParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    CorrelationId: string;
}

export interface PLMCreateStepHRSpecificationFullListResponse extends CommandResponse {
}

export interface PLMCreateStepHRSpecificationFullList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `HumanResourceSpecificationList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.Types.PLMHRSpecificationParameterType)` |
     * | Nullable | `false` |
     */
    HumanResourceSpecificationList: Array<PLMHRSpecificationParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    CorrelationId: string;
}

export interface UADMDeleteDefectGroupListResponse extends CommandResponse {
}

export interface UADMDeleteDefectGroupList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefectGroupIdentifierList` |
     * | Type | `Collection(Siemens.SimaticIT.MasterData.MatTool.MSModel.Types.IdentifiersParameterType)` |
     * | Nullable | `false` |
     */
    DefectGroupIdentifierList: Array<IdentifiersParameterType>;
}

export interface UADMDeleteDefectTypeListResponse extends CommandResponse {
}

export interface UADMDeleteDefectTypeList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefectTypeIdentifiersList` |
     * | Type | `Collection(Siemens.SimaticIT.MasterData.MatTool.MSModel.Types.IdentifiersParameterType)` |
     * | Nullable | `false` |
     */
    DefectTypeIdentifiersList: Array<IdentifiersParameterType>;
}

export interface PLMCreateDM_MaterialTrackingUnitandMaterialTrackingUnitListResponse extends CommandResponse {
}

export interface PLMCreateDM_MaterialTrackingUnitandMaterialTrackingUnitList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    CorrelationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialTrackingUnitList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.Types.PLMMaterialTrackingUnitParameterType)` |
     * | Nullable | `false` |
     */
    MaterialTrackingUnitList: Array<PLMMaterialTrackingUnitParameterType>;
}

export interface PLMChangeStatusEventLogResponse extends CommandResponse {
}

export interface PLMChangeStatusEventLog {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EventId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    EventId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TransitionVerb` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    TransitionVerb: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ErrorMessage` |
     * | Type | `Edm.String` |
     */
    ErrorMessage: string | null;
}

export interface PLMDeleteEventLogListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DeletedEventIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DeletedEventIdList: Array<string>;
}

export interface PLMDeleteEventLogList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EventIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    EventIdList: Array<string>;
}

export interface PLMChangeStatusEventLogListResponse extends CommandResponse {
}

export interface PLMChangeStatusEventLogList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PLMChangeStatusEventLogParameterTypeList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.Types.PLMChangeStatusEventLogParameterType)` |
     * | Nullable | `false` |
     */
    PLMChangeStatusEventLogParameterTypeList: Array<PLMChangeStatusEventLogParameterType>;
}

export interface SetInScheduledNoBulkResponse extends CommandResponse {
}

export interface SetInScheduledNoBulk {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `APSOrderOperations` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.FB_OP_APSInt.OPModel.Types.APSOrderOperationsParameterType` |
     * | Nullable | `false` |
     */
    APSOrderOperations: APSOrderOperationsParameterType;
}

export interface PLMCreateOperationDCDWIResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionDefinitionId` |
     * | Type | `Edm.Guid` |
     */
    WorkInstructionDefinitionId: string | null;
}

export interface PLMCreateOperationDCDWI {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReferencedEntityUID` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ReferencedEntityUID: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AssociationType` |
     * | Type | `Edm.String` |
     */
    AssociationType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExtendedProperties` |
     * | Type | `Edm.String` |
     */
    ExtendedProperties: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DCDWI` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.Types.PLMDCDWIParameterType` |
     * | Nullable | `false` |
     */
    DCDWI: PLMDCDWIParameterType;
}

export interface PLMCreateStepDCDWIResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionDefinitionId` |
     * | Type | `Edm.Guid` |
     */
    WorkInstructionDefinitionId: string | null;
}

export interface PLMCreateStepDCDWI {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReferencedEntityUID` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ReferencedEntityUID: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AssociationType` |
     * | Type | `Edm.String` |
     */
    AssociationType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExtendedProperties` |
     * | Type | `Edm.String` |
     */
    ExtendedProperties: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DCDWI` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.Types.PLMDCDWIParameterType` |
     * | Nullable | `false` |
     */
    DCDWI: PLMDCDWIParameterType;
}

export interface UADMAutomaticAcquireQualityInspectionDataResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Collection(Edm.String)` |
     */
    WarningMessage: Array<string>;
}

export interface UADMAutomaticAcquireQualityInspectionData {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentName` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    EquipmentName: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Category` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Category: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MTUCodeList` |
     * | Type | `Collection(Edm.String)` |
     */
    MTUCodeList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `QualityCharctersticsDetails` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.AutomaticAcquireQualityCharactersticsParameterType)` |
     * | Nullable | `false` |
     */
    QualityCharctersticsDetails: Array<AutomaticAcquireQualityCharactersticsParameterType>;
}

export interface UADMAutomaticCreateSnagAndNoteResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SnagAndNoteId` |
     * | Type | `Edm.String` |
     */
    SnagAndNoteId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Edm.String` |
     */
    WarningMessage: string | null;
}

export interface UADMAutomaticCreateSnagAndNote {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentName` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    EquipmentName: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Category` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Category: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TimeStamp` |
     * | Type | `Edm.DateTimeOffset` |
     */
    TimeStamp: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Notes: string;
}

export interface UADMConsumeMaterialItemOnContainerResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Collection(Edm.String)` |
     */
    WarningMessage: Array<string>;
}

export interface UADMConsumeMaterialItemOnContainer {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItemToConsumeOnContainerList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.FB_OP_ContainerExec.OPModel.Types.MaterialItemToConsumeOnContainerParameterType)` |
     * | Nullable | `false` |
     */
    MaterialItemToConsumeOnContainerList: Array<MaterialItemToConsumeOnContainerParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStepId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
}

export interface UADMReleaseWorkOrderListResponse extends CommandResponse {
}

export interface UADMReleaseWorkOrderList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReleaseWorkOrderDetails` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ReleaseWorkOrderParameterType)` |
     * | Nullable | `false` |
     */
    ReleaseWorkOrderDetails: Array<ReleaseWorkOrderParameterType>;
}

export interface SetPointParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    SetPointId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointItemId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    SetPointItemId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointItemValue` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    SetPointItemValue: string;
}

export interface StartWOOperationFullQtyParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignatureId` |
     * | Type | `Edm.Guid` |
     */
    ElectronicSignatureId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointItemParameterType` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.SetPointParameterType)` |
     */
    SetPointItemParameterType: Array<SetPointParameterType>;
}

export interface WorkOrderDetailsForBoPUpdateParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkOrderNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStatus` |
     * | Type | `Edm.String` |
     */
    WorkOrderStatus: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessUId` |
     * | Type | `Edm.String` |
     */
    ProcessUId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ProcessId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedId` |
     * | Type | `Edm.Guid` |
     */
    AsPlannedId: string | null;
}

export interface StartWOOperationTransferBatchParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignatureId` |
     * | Type | `Edm.Guid` |
     */
    ElectronicSignatureId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     * | Nullable | `false` |
     */
    Quantity: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointItemParameterType` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.SetPointParameterType)` |
     */
    SetPointItemParameterType: Array<SetPointParameterType>;
}

export interface MaterialItemParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialDefinitionNId` |
     * | Type | `Edm.String` |
     */
    MaterialDefinitionNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SerialNumber` |
     * | Type | `Edm.String` |
     */
    SerialNumber: string | null;
}

export interface ToBeConsumedMaterialParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualQuantity` |
     * | Type | `Edm.Decimal` |
     * | Nullable | `false` |
     */
    ActualQuantity: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialDefinitionNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    MaterialDefinitionNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     * | Nullable | `false` |
     */
    Quantity: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SerialNumber` |
     * | Type | `Edm.String` |
     */
    SerialNumber: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeConsumedMaterialName` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ToBeConsumedMaterialName: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeConsumedMaterialSequence` |
     * | Type | `Edm.Int32` |
     * | Nullable | `false` |
     */
    ToBeConsumedMaterialSequence: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TotalQuantity` |
     * | Type | `Edm.Decimal` |
     * | Nullable | `false` |
     */
    TotalQuantity: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialDefinitonRevision` |
     * | Type | `Edm.String` |
     */
    MaterialDefinitonRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SpecificationType` |
     * | Type | `Edm.String` |
     */
    SpecificationType: string | null;
}

export interface MaterialItemToConsumeParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetMaterialItem` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.MaterialItemParameterType` |
     */
    TargetMaterialItem: MaterialItemParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeConsumedMaterialItemList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ToBeConsumedMaterialParameterType)` |
     */
    ToBeConsumedMaterialItemList: Array<ToBeConsumedMaterialParameterType>;
}

export interface CreateReworkOrderParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItemList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.MaterialItemParameterType)` |
     */
    MaterialItemList: Array<MaterialItemParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ProcessId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PartialQuantity` |
     * | Type | `Edm.Decimal` |
     */
    PartialQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CompletedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    CompletedQuantity: number | null;
}

export interface NonConformanceParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `HistoryId` |
     * | Type | `Edm.String` |
     */
    HistoryId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MateriaDefinitionNId` |
     * | Type | `Edm.String` |
     */
    MateriaDefinitionNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItemNId` |
     * | Type | `Edm.String` |
     */
    MaterialItemNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceLifecycleNId` |
     * | Type | `Edm.String` |
     */
    NonConformanceLifecycleNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceType` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NonConformanceType: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SerialNumber` |
     * | Type | `Edm.String` |
     */
    SerialNumber: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Severity` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Severity: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolNId` |
     * | Type | `Edm.String` |
     */
    ToolNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Equipments` |
     * | Type | `Collection(Edm.String)` |
     */
    Equipments: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Tools` |
     * | Type | `Collection(Edm.String)` |
     */
    Tools: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItems` |
     * | Type | `Collection(Edm.String)` |
     */
    MaterialItems: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
}

export interface NonConformanceAttachmentParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    DocumentId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentFileName` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    DocumentFileName: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentMIMEType` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    DocumentMIMEType: string;
}

export interface NonConformanceDetectionParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `InspectedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    InspectedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
}

export interface NonConformanceResourceParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Operation` |
     * | Type | `Edm.String` |
     */
    Operation: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResourceId` |
     * | Type | `Edm.String` |
     */
    ResourceId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Type` |
     * | Type | `Edm.String` |
     */
    Type: string | null;
}

export interface NonConformanceHistoryParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Attachments` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.NonConformanceAttachmentParameterType)` |
     */
    Attachments: Array<NonConformanceAttachmentParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Detections` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.NonConformanceDetectionParameterType)` |
     */
    Detections: Array<NonConformanceDetectionParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Resources` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.NonConformanceResourceParameterType)` |
     */
    Resources: Array<NonConformanceResourceParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserId` |
     * | Type | `Edm.String` |
     */
    UserId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TimeStamp` |
     * | Type | `Edm.DateTimeOffset` |
     */
    TimeStamp: string | null;
}

export interface DefectParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefectNId` |
     * | Type | `Edm.String` |
     */
    DefectNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `GroupPath` |
     * | Type | `Edm.String` |
     */
    GroupPath: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     */
    Status: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FailureNId` |
     * | Type | `Edm.String` |
     */
    FailureNId: string | null;
}

export interface BoMParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Version` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Version: string;
}

export interface StartWOOperationSerializedParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignatureId` |
     * | Type | `Edm.Guid` |
     */
    ElectronicSignatureId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MTUIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DM_MTUIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointItemParameterType` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.SetPointParameterType)` |
     */
    SetPointItemParameterType: Array<SetPointParameterType>;
}

export interface HoldParamterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Comment` |
     * | Type | `Edm.String` |
     */
    Comment: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Reasons` |
     * | Type | `Collection(Edm.String)` |
     */
    Reasons: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReasonsId` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ReasonsId: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Type` |
     * | Type | `Edm.String` |
     */
    Type: string | null;
}

export interface WorkOrderIdentifiersParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkOrderNId: string;
}

export interface MaterialItemIdentifiersParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItemId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    MaterialItemId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItemNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    MaterialItemNId: string;
}

export interface ResultParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialTrackingUnitNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    MaterialTrackingUnitNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResultValue` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ResultValue: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Strategy` |
     * | Type | `Edm.String` |
     */
    Strategy: string | null;
}

export interface CompleteWOOperationSerializedParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MTUIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DM_MTUIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignatureId` |
     * | Type | `Edm.Guid` |
     */
    ElectronicSignatureId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Results` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ResultParameterType)` |
     */
    Results: Array<ResultParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AvoidPausingOtherSerialNos` |
     * | Type | `Edm.Boolean` |
     */
    AvoidPausingOtherSerialNos: boolean | null;
}

export interface IdentifiersParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
}

export interface RepeatOperationChangeParameter {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NewDescription` |
     * | Type | `Edm.String` |
     */
    NewDescription: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NewWorkOrderOperationNId` |
     * | Type | `Edm.String` |
     */
    NewWorkOrderOperationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationName` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkOrderOperationName: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkOrderOperationNId: string;
}

export interface ToBeConsumedMaterialParameter {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AlternativeSelected` |
     * | Type | `Edm.Boolean` |
     */
    AlternativeSelected: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `GroupId` |
     * | Type | `Edm.String` |
     */
    GroupId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogicalPosition` |
     * | Type | `Edm.String` |
     */
    LogicalPosition: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialDefinitionId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    MaterialDefinitionId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialSpecificationType` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    MaterialSpecificationType: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     * | Nullable | `false` |
     */
    Quantity: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     */
    Sequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OccurrenceId` |
     * | Type | `Edm.String` |
     */
    OccurrenceId: string | null;
}

export interface ToBeUsedMachineParameter {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Machine` |
     * | Type | `Edm.String` |
     */
    Machine: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentType` |
     * | Type | `Edm.String` |
     */
    EquipmentType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PartProgram` |
     * | Type | `Edm.String` |
     */
    PartProgram: string | null;
}

export interface WorkOOperationDependencyParameter {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FromId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    FromId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationDependencyType` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    OperationDependencyType: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PartialCompleted` |
     * | Type | `Edm.Boolean` |
     */
    PartialCompleted: boolean | null;
}

export interface NewWorkOrderForSplit {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BatchId` |
     * | Type | `Edm.String` |
     */
    BatchId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CompletedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    CompletedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItemList` |
     * | Type | `Collection(Edm.Guid)` |
     */
    MaterialItemList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PartialWorkedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    PartialWorkedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     * | Nullable | `false` |
     */
    Quantity: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeProducedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    ToBeProducedQuantity: number | null;
}

export interface ToBeDisassembledMaterialItemParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AssembledQuantity` |
     * | Type | `Edm.Decimal` |
     * | Nullable | `false` |
     */
    AssembledQuantity: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialDefinitionId` |
     * | Type | `Edm.Guid` |
     */
    MaterialDefinitionId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialDefinitionNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    MaterialDefinitionNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedMaterialItemActualQuantity` |
     * | Type | `Edm.Decimal` |
     * | Nullable | `false` |
     */
    ProducedMaterialItemActualQuantity: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     * | Nullable | `false` |
     */
    Quantity: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SerialNumber` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    SerialNumber: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TotalQuantity` |
     * | Type | `Edm.Decimal` |
     * | Nullable | `false` |
     */
    TotalQuantity: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnit_Id` |
     * | Type | `Edm.Guid` |
     */
    DM_MaterialTrackingUnit_Id: string | null;
}

export interface MaterialItemToDisassembleParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedMaterialItem` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.MaterialItemParameterType` |
     */
    ProducedMaterialItem: MaterialItemParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeDisassembledMaterialItemList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ToBeDisassembledMaterialItemParameterType)` |
     */
    ToBeDisassembledMaterialItemList: Array<ToBeDisassembledMaterialItemParameterType>;
}

export interface WorkOrderOperationFromOperationParameter {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignatureComplete` |
     * | Type | `Edm.Boolean` |
     */
    ElectronicSignatureComplete: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignaturePause` |
     * | Type | `Edm.Boolean` |
     */
    ElectronicSignaturePause: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignatureStart` |
     * | Type | `Edm.Boolean` |
     */
    ElectronicSignatureStart: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedDuration` |
     * | Type | `Edm.Duration` |
     */
    EstimatedDuration: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedEndTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedEndTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedStartTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedStartTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationId` |
     * | Type | `Edm.Guid` |
     */
    OperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Priority` |
     * | Type | `Edm.Int32` |
     */
    Priority: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RequiredCertificateNId` |
     * | Type | `Edm.String` |
     */
    RequiredCertificateNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RequiredInspectionRole` |
     * | Type | `Edm.String` |
     */
    RequiredInspectionRole: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     * | Nullable | `false` |
     */
    Sequence: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCollectedDocument` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCollectedDocument: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOperationTypeId` |
     * | Type | `Edm.Guid` |
     */
    WorkOperationTypeId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationStepCategoryId` |
     * | Type | `Edm.Guid` |
     */
    OperationStepCategoryId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ERPConfirmationId` |
     * | Type | `Edm.String` |
     */
    ERPConfirmationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBopId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    AsPlannedBopId: string;
}

export interface ActualProducedMaterialTBParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     * | Nullable | `false` |
     */
    Quantity: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
}

export interface CompleteWOOperationTransferBatchParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignatureId` |
     * | Type | `Edm.Guid` |
     */
    ElectronicSignatureId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualProducedMaterialList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ActualProducedMaterialTBParameterType)` |
     */
    ActualProducedMaterialList: Array<ActualProducedMaterialTBParameterType>;
}

export interface PauseWOOperationParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReasonNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ReasonNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNIdList` |
     * | Type | `Collection(Edm.String)` |
     */
    EquipmentNIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignatureId` |
     * | Type | `Edm.Guid` |
     */
    ElectronicSignatureId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserId` |
     * | Type | `Edm.String` |
     */
    UserId: string | null;
}

export interface CompleteWOOperationFullQtyParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNIdList` |
     * | Type | `Collection(Edm.String)` |
     */
    EquipmentNIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignatureId` |
     * | Type | `Edm.Guid` |
     */
    ElectronicSignatureId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResultList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ResultParameterType)` |
     */
    ResultList: Array<ResultParameterType>;
}

export interface ReleaseWorkOrderParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SerialNumberCodes` |
     * | Type | `Collection(Edm.String)` |
     */
    SerialNumberCodes: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkOrderNId: string;
}

export interface NPAUserParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StartDate` |
     * | Type | `Edm.DateTimeOffset` |
     * | Nullable | `false` |
     */
    StartDate: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EndDate` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EndDate: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NPAContextId` |
     * | Type | `Edm.Guid` |
     */
    NPAContextId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NPAContextValue` |
     * | Type | `Edm.Guid` |
     */
    NPAContextValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `User` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    User: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NPAEquipmentNIdValue` |
     * | Type | `Edm.String` |
     */
    NPAEquipmentNIdValue: string | null;
}

export interface AutomaticToBeConsumedMaterialTrackingUnitParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialNId` |
     * | Type | `Edm.String` |
     */
    DM_MaterialNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogicalPosition` |
     * | Type | `Edm.String` |
     */
    LogicalPosition: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     * | Nullable | `false` |
     */
    Quantity: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialTrackingUnitCode` |
     * | Type | `Edm.String` |
     */
    MaterialTrackingUnitCode: string | null;
}

export interface AutomaticConsumptionParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetMaterialTrackingUnitCode` |
     * | Type | `Edm.String` |
     */
    TargetMaterialTrackingUnitCode: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeConsumedMaterialTrackingUnitList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.AutomaticToBeConsumedMaterialTrackingUnitParameterType)` |
     */
    ToBeConsumedMaterialTrackingUnitList: Array<AutomaticToBeConsumedMaterialTrackingUnitParameterType>;
}

export interface NonConformancePropertyType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceLifecycleNId` |
     * | Type | `Edm.String` |
     */
    NonConformanceLifecycleNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceType` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NonConformanceType: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Severity` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Severity: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Context` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.NCContext` |
     */
    Context: NCContext | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TimeStamp` |
     * | Type | `Edm.DateTimeOffset` |
     */
    TimeStamp: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentNonConformanceNId` |
     * | Type | `Edm.String` |
     */
    ParentNonConformanceNId: string | null;
}

export interface ChangeOperationParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChangeType` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ChangeType: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CloseNotes` |
     * | Type | `Edm.String` |
     */
    CloseNotes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RefNumber` |
     * | Type | `Edm.String` |
     */
    RefNumber: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SequenceAfter` |
     * | Type | `Edm.Guid` |
     */
    SequenceAfter: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NewOperationName` |
     * | Type | `Edm.String` |
     */
    NewOperationName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentName` |
     * | Type | `Edm.String` |
     */
    EquipmentName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationNameList` |
     * | Type | `Edm.String` |
     */
    OperationNameList: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RoutingOperationAfter` |
     * | Type | `Edm.String` |
     */
    RoutingOperationAfter: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OldOperationName` |
     * | Type | `Edm.String` |
     */
    OldOperationName: string | null;
}

export interface ChangePartParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChangeType` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ChangeType: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CloseNotes` |
     * | Type | `Edm.String` |
     */
    CloseNotes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogicalPosition` |
     * | Type | `Edm.String` |
     */
    LogicalPosition: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NewPart` |
     * | Type | `Edm.String` |
     */
    NewPart: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NewPartQuantity` |
     * | Type | `Edm.Decimal` |
     */
    NewPartQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OldPart` |
     * | Type | `Edm.String` |
     */
    OldPart: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OldPartQuantity` |
     * | Type | `Edm.Decimal` |
     * | Nullable | `false` |
     */
    OldPartQuantity: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RefNumber` |
     * | Type | `Edm.String` |
     */
    RefNumber: string | null;
}

export interface ChangeDataCollectionParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChangeType` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ChangeType: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CloseNotes` |
     * | Type | `Edm.String` |
     */
    CloseNotes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReferenceWorkorderOperations` |
     * | Type | `Edm.String` |
     */
    ReferenceWorkorderOperations: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RefNumber` |
     * | Type | `Edm.String` |
     */
    RefNumber: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WIDefinition` |
     * | Type | `Edm.String` |
     */
    WIDefinition: string | null;
}

export interface QualityNonConformancePropertiesType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MTUNIdList` |
     * | Type | `Collection(Edm.String)` |
     */
    MTUNIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolNIdList` |
     * | Type | `Collection(Edm.String)` |
     */
    ToolNIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNIdList` |
     * | Type | `Collection(Edm.String)` |
     */
    EquipmentNIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialNId` |
     * | Type | `Edm.String` |
     */
    MaterialNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsTriggeredByQualityInspectionFailure` |
     * | Type | `Edm.Boolean` |
     */
    IsTriggeredByQualityInspectionFailure: boolean | null;
}

export interface NonConformanceQuantities4PartialSentenceParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MTUNIdList` |
     * | Type | `Collection(Edm.String)` |
     */
    MTUNIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeProducedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    ToBeProducedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PartialWorkedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    PartialWorkedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CompletedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    CompletedQuantity: number | null;
}

export interface AutomaticAcquireQualityCharactersticsParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChrReprNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ChrReprNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FailureNId` |
     * | Type | `Edm.String` |
     */
    FailureNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MeasuredValue` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    MeasuredValue: string;
}

export interface NonConformanceSpecificationParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SpecificationNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    SpecificationNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SpecificationType` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    SpecificationType: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SpecificationTypeCode` |
     * | Type | `Edm.Int32` |
     * | Nullable | `false` |
     */
    SpecificationTypeCode: number;
}

export interface NonConformanceSentencingParamaterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceAttachmentList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.NonConformanceAttachmentParameterType)` |
     */
    NonConformanceAttachmentList: Array<NonConformanceAttachmentParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceDetectionList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.NonConformanceDetectionParameterType)` |
     */
    NonConformanceDetectionList: Array<NonConformanceDetectionParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceHistoryId` |
     * | Type | `Edm.String` |
     */
    NonConformanceHistoryId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NonConformanceNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceSpecificationList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.NonConformanceSpecificationParameterType)` |
     */
    NonConformanceSpecificationList: Array<NonConformanceSpecificationParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceTransitionNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NonConformanceTransitionNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReworkOrderCreationDetails` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.CreateReworkOrderParameterType` |
     */
    ReworkOrderCreationDetails: CreateReworkOrderParameterType | null;
}

export interface MaterialItemForSplitType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BatchId` |
     * | Type | `Edm.String` |
     */
    BatchId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `QuantityType` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    QuantityType: QuantityParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItemSplitQuantity` |
     * | Type | `Edm.Decimal` |
     */
    MaterialItemSplitQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
}

export interface ItlkCheckDM_MTUParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MTUId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    DM_MTUId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MTUCodeType` |
     * | Type | `Siemens.SimaticIT.OperationalData.MAT_OP.OPModel.Types.MTUCodeType` |
     * | Nullable | `false` |
     */
    MTUCodeType: MTUCodeType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MTUCode` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    MTUCode: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MTUNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    MTUNId: string;
}

export interface DeleteFutureHoldParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NonConformanceNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceStatusNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NonConformanceStatusNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceTransitionNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NonConformanceTransitionNId: string;
}

export interface WOOpDependencyNavigationParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationDependencyId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationDependencyId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsPreferred` |
     * | Type | `Edm.Boolean` |
     */
    IsPreferred: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AlternativeGroup` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    AlternativeGroup: string;
}

export interface ProductMaterialItem {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     * | Nullable | `false` |
     */
    Quantity: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Result` |
     * | Type | `Edm.String` |
     */
    Result: string | null;
}

export interface MaterialItemHistoryParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MTU_Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    DM_MTU_Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Code` |
     * | Type | `Edm.String` |
     */
    Code: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReferenceWorkOrderHistoryId` |
     * | Type | `Edm.Guid` |
     */
    ReferenceWorkOrderHistoryId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
}

export interface SplitContext {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentBacthId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ParentBacthId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChildBatchIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ChildBatchIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnitHistoryIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DM_MaterialTrackingUnitHistoryIdList: Array<string>;
}

export interface ResultWithTypeParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Result` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ResultParameterType` |
     */
    Result: ResultParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsKo` |
     * | Type | `Edm.Boolean` |
     */
    IsKo: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkOrderOperationNId: string;
}

export interface CompletedMTUParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOpId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WOOpId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MTUId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    DM_MTUId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsRealComplete` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsRealComplete: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Result` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ResultWithTypeParameterType` |
     */
    Result: ResultWithTypeParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOHistoryMaterialItemId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WOHistoryMaterialItemId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProductionType` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ProductionTypeEnum` |
     * | Nullable | `false` |
     */
    ProductionType: ProductionTypeEnum;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOpTargetQuantity` |
     * | Type | `Edm.Decimal` |
     * | Nullable | `false` |
     */
    WOOpTargetQuantity: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActivityNId` |
     * | Type | `Edm.String` |
     */
    ActivityNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActivityType` |
     * | Type | `Edm.String` |
     */
    ActivityType: string | null;
}

export interface WOOpSerializedLiteOutputParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationStatusNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationStatusNId: string | null;
}

export interface WOOperationSerializedLiteParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MTUIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DM_MTUIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
}

export interface CompleteWOOpSerializedLiteParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOperationSerializedLiteParameter` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.WOOperationSerializedLiteParameterType` |
     */
    WOOperationSerializedLiteParameter: WOOperationSerializedLiteParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Results` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ResultParameterType)` |
     */
    Results: Array<ResultParameterType>;
}

export interface ExecutionGroupOperationParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
}

export interface MaterialItemForVerify {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BatchId` |
     * | Type | `Edm.String` |
     */
    BatchId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CanVerify` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    CanVerify: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsReserved` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsReserved: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LocationPath` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    LocationPath: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialDefination` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    MaterialDefination: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialDefinationNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    MaterialDefinationNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaxRecycleCount` |
     * | Type | `Edm.Int32` |
     */
    MaxRecycleCount: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MinQuantity` |
     * | Type | `Edm.Decimal` |
     */
    MinQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Name: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     * | Nullable | `false` |
     */
    Quantity: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RecycleCount` |
     * | Type | `Edm.Int32` |
     */
    RecycleCount: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SerialNumberCode` |
     * | Type | `Edm.String` |
     */
    SerialNumberCode: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Status: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoM` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    UoM: string;
}

export interface CopyToBeProducedFacetsOutputParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CopiedFacetId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    CopiedFacetId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NewFacetId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    NewFacetId: string;
}

export interface ChangeRoutingParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CloseNotes` |
     * | Type | `Edm.String` |
     */
    CloseNotes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChangeType` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ChangeType: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RefNumber` |
     * | Type | `Edm.String` |
     */
    RefNumber: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NewOperationFrom` |
     * | Type | `Edm.String` |
     */
    NewOperationFrom: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NewOperationTo` |
     * | Type | `Edm.String` |
     */
    NewOperationTo: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NewDependency` |
     * | Type | `Edm.String` |
     */
    NewDependency: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OldOperationFrom` |
     * | Type | `Edm.String` |
     */
    OldOperationFrom: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OldOperationTo` |
     * | Type | `Edm.String` |
     */
    OldOperationTo: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OldDependency` |
     * | Type | `Edm.String` |
     */
    OldDependency: string | null;
}

export interface WorkOrderOperationParameter {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignatureComplete` |
     * | Type | `Edm.Boolean` |
     */
    ElectronicSignatureComplete: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignaturePause` |
     * | Type | `Edm.Boolean` |
     */
    ElectronicSignaturePause: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignatureStart` |
     * | Type | `Edm.Boolean` |
     */
    ElectronicSignatureStart: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedDuration` |
     * | Type | `Edm.Duration` |
     */
    EstimatedDuration: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedEndTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedEndTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedStartTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedStartTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Name: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationId` |
     * | Type | `Edm.Guid` |
     */
    OperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Priority` |
     * | Type | `Edm.Int32` |
     */
    Priority: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RequiredCertificateNId` |
     * | Type | `Edm.String` |
     */
    RequiredCertificateNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RequiredInspectionRole` |
     * | Type | `Edm.String` |
     */
    RequiredInspectionRole: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     * | Nullable | `false` |
     */
    Sequence: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCollectedDocument` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCollectedDocument: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOperationTypeId` |
     * | Type | `Edm.Guid` |
     */
    WorkOperationTypeId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationStepCategoryId` |
     * | Type | `Edm.Guid` |
     */
    OperationStepCategoryId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ERPConfirmationId` |
     * | Type | `Edm.String` |
     */
    ERPConfirmationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialSpecificationIdList` |
     * | Type | `Collection(Edm.Guid)` |
     */
    MaterialSpecificationIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `InspectionSpecificationIdList` |
     * | Type | `Collection(Edm.Guid)` |
     */
    InspectionSpecificationIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointItemATNInstanceAssociationIdList` |
     * | Type | `Collection(Edm.Guid)` |
     */
    SetPointItemATNInstanceAssociationIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolSpecificationIdList` |
     * | Type | `Collection(Edm.Guid)` |
     */
    ToolSpecificationIdList: Array<string>;
}

export interface DisassembledMaterialItemParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialTrackingUnitNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    MaterialTrackingUnitNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedMaterialItemActualQuantity` |
     * | Type | `Edm.Decimal` |
     * | Nullable | `false` |
     */
    ProducedMaterialItemActualQuantity: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     * | Nullable | `false` |
     */
    Quantity: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnit_Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    DM_MaterialTrackingUnit_Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SpecificationType` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    SpecificationType: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeConsumedMaterial_Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToBeConsumedMaterial_Id: string;
}

export interface StartWOStepFullQtyParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderStepId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
}

export interface WorkOStepDependencyParameter {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FromId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    FromId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StepDependencyType` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    StepDependencyType: string;
}

export interface ToBeUsedToolParameter {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TimesToBeUsed` |
     * | Type | `Edm.Int32` |
     * | Nullable | `false` |
     */
    TimesToBeUsed: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolDefinitionId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToolDefinitionId: string;
}

export interface TimesOfToolUsageParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnitId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    DM_MaterialTrackingUnitId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedToolId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToBeUsedToolId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TimesToBeUsed` |
     * | Type | `Edm.Int32` |
     * | Nullable | `false` |
     */
    TimesToBeUsed: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UsedTimes` |
     * | Type | `Edm.Decimal` |
     * | Nullable | `false` |
     */
    UsedTimes: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
}

export interface ToolToBeUsedParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TimesToBeUsed` |
     * | Type | `Edm.Decimal` |
     */
    TimesToBeUsed: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolDefinitionId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToolDefinitionId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ToolNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UsageDuration` |
     * | Type | `Edm.Duration` |
     */
    UsageDuration: string | null;
}

export interface ToolToBeUsedOnSNParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItemId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    MaterialItemId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Tool` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ToolToBeUsedParameterType` |
     */
    Tool: ToolToBeUsedParameterType | null;
}

export interface AMPowderBatchMixParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AMPowderBatchList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    AMPowderBatchList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BatchId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    BatchId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaxRecycleCount` |
     * | Type | `Edm.Int32` |
     */
    MaxRecycleCount: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MinQuantity` |
     * | Type | `Edm.Decimal` |
     */
    MinQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RecycleCount` |
     * | Type | `Edm.Int32` |
     */
    RecycleCount: number | null;
}

export interface AMPowderBatchFakeParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BatchId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    BatchId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RecycleCount` |
     * | Type | `Edm.Int32` |
     */
    RecycleCount: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaxRecycleCount` |
     * | Type | `Edm.Int32` |
     */
    MaxRecycleCount: number | null;
}

export interface ChangeToolParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NewToolDefinitionName` |
     * | Type | `Edm.String` |
     */
    NewToolDefinitionName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChangeType` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ChangeType: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RefNumber` |
     * | Type | `Edm.String` |
     */
    RefNumber: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CloseNotes` |
     * | Type | `Edm.String` |
     */
    CloseNotes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolUsageNumber` |
     * | Type | `Edm.Decimal` |
     */
    ToolUsageNumber: number | null;
}

export interface ToBeProducedIdAndOpId {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeProducedMaterialIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ToBeProducedMaterialIdList: Array<string>;
}

export interface DM_MTUIdAndOpId {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnitIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DM_MaterialTrackingUnitIdList: Array<string>;
}

export interface ProducedMaterialItemParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
}

export interface StartWOStepSerializedParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderStepId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MTUIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DM_MTUIdList: Array<string>;
}

export interface CompleteWOStepTransferBatchParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualProducedMaterialList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ActualProducedMaterialTBParameterType)` |
     */
    ActualProducedMaterialList: Array<ActualProducedMaterialTBParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderStepId: string;
}

export interface UserDetailsParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserId` |
     * | Type | `Edm.String` |
     */
    UserId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsUserPunchedIn` |
     * | Type | `Edm.Boolean` |
     */
    IsUserPunchedIn: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsUserEnabled` |
     * | Type | `Edm.Boolean` |
     */
    IsUserEnabled: boolean | null;
}

export interface MaterialItemWithHistoryParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOHistoryMaterialItemId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WOHistoryMaterialItemId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MTUId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    DM_MTUId: string;
}

export interface WOOpExecutionParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    EquipmentNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MTUIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DM_MTUIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProductionTypeNId` |
     * | Type | `Edm.String` |
     */
    ProductionTypeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationTargetQuantity` |
     * | Type | `Edm.Decimal` |
     * | Nullable | `false` |
     */
    WorkOrderOperationTargetQuantity: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOHistoryMatItemIdWithDM_MTUIdList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.MaterialItemWithHistoryParameterType)` |
     */
    WOHistoryMatItemIdWithDM_MTUIdList: Array<MaterialItemWithHistoryParameterType>;
}

export interface NonConformanceGroupPathParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefectNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    DefectNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `GroupPath` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    GroupPath: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MeasureId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    MeasureId: string;
}

export interface SubstratePropertiesParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CurrentThickness` |
     * | Type | `Edm.Decimal` |
     * | Nullable | `false` |
     */
    CurrentThickness: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SubstrateThresholds` |
     * | Type | `Siemens.SimaticIT.MasterData.MatTool.MSModel.Types.SubstrateDefinitionPropertiesParameterType` |
     */
    SubstrateThresholds: SubstrateDefinitionPropertiesParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TreatmentCount` |
     * | Type | `Edm.Int32` |
     */
    TreatmentCount: number | null;
}

export interface MaterialToBeConsumed {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    MaterialId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Code` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Code: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
}

export interface WOHeaderParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BOPId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    BOPId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ProcessId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentBatch` |
     * | Type | `Edm.String` |
     */
    ParentBatch: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DueDate` |
     * | Type | `Edm.DateTimeOffset` |
     */
    DueDate: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ERPOrder` |
     * | Type | `Edm.String` |
     */
    ERPOrder: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedStartTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedStartTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Priority` |
     * | Type | `Edm.Int32` |
     */
    Priority: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProductionTypeNId` |
     * | Type | `Edm.String` |
     */
    ProductionTypeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BatchId` |
     * | Type | `Edm.String` |
     */
    BatchId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedEndTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedEndTime: string | null;
}

export interface ExecutionGroupParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
}

export interface CompleteWOStepFullQtyParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderStepId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNIdList` |
     * | Type | `Collection(Edm.String)` |
     */
    EquipmentNIdList: Array<string>;
}

export interface RuntimeCharReprRefOpAssParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RuntimeCharacteristicRepresentationNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    RuntimeCharacteristicRepresentationNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkOrderOperationNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedInspectionId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToBeUsedInspectionId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessToOperationLinkUId` |
     * | Type | `Edm.String` |
     */
    ProcessToOperationLinkUId: string | null;
}

export interface CheckCertificationMultiMachineParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNIdList` |
     * | Type | `Collection(Edm.String)` |
     */
    EquipmentNIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkOrderOperationNId: string;
}

export interface ActiveUserOnMachineParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOperationId` |
     * | Type | `Edm.Guid` |
     */
    WOOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupPhaseId` |
     * | Type | `Edm.Guid` |
     */
    ExecutionGroupPhaseId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WoStepId` |
     * | Type | `Edm.Guid` |
     */
    WoStepId: string | null;
}

export interface AsPlannedWorkOrder {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BatchId` |
     * | Type | `Edm.String` |
     */
    BatchId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkOrderNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ProcessId: string;
}

export interface MaterialItemToReserveParamerType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialDefinition` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    MaterialDefinition: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     * | Nullable | `false` |
     */
    Quantity: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SerialNumberCode` |
     * | Type | `Edm.String` |
     */
    SerialNumberCode: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeConsumedMaterialName` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ToBeConsumedMaterialName: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeConsumedMaterialSequence` |
     * | Type | `Edm.Int32` |
     * | Nullable | `false` |
     */
    ToBeConsumedMaterialSequence: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkOrderOperationNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItemId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    MaterialItemId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeConsumedMaterialId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToBeConsumedMaterialId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PreKitBatchCode` |
     * | Type | `Edm.String` |
     */
    PreKitBatchCode: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeConsumedMaterialPrekitId` |
     * | Type | `Edm.Guid` |
     */
    ToBeConsumedMaterialPrekitId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeValidated` |
     * | Type | `Edm.Boolean` |
     */
    ToBeValidated: boolean | null;
}

export interface OperationMaterialParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOperationMaterialList` |
     * | Type | `Collection(Edm.Guid)` |
     */
    WorkOperationMaterialList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOperationId: string;
}

export interface StartExecutionGroupParameteType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupPhaseId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ExecutionGroupPhaseId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationMaterialParameterType` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.OperationMaterialParameterType)` |
     */
    OperationMaterialParameterType: Array<OperationMaterialParameterType>;
}

export interface CharacteristicRepresentationType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CharacteristicRepresentationRevision` |
     * | Type | `Edm.String` |
     */
    CharacteristicRepresentationRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CharacteristicRepresentationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    CharacteristicRepresentationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationNId: string | null;
}

export interface ToBeDisassembledFromParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStepId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetDM_MTUId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    TargetDM_MTUId: string;
}

export interface ToBeCoProducedMaterialParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCoProducedMaterialNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ToBeCoProducedMaterialNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MTUCode` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    MTUCode: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     * | Nullable | `false` |
     */
    Quantity: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeDisassembledFromList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ToBeDisassembledFromParameterType)` |
     */
    ToBeDisassembledFromList: Array<ToBeDisassembledFromParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialSpecificationNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    MaterialSpecificationNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedMaterialItemId` |
     * | Type | `Edm.Guid` |
     */
    ProducedMaterialItemId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCoProducedMaterialId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToBeCoProducedMaterialId: string;
}

export interface StartWOStepTransferBatchParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderStepId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignatureId` |
     * | Type | `Edm.Guid` |
     */
    ElectronicSignatureId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     * | Nullable | `false` |
     */
    Quantity: number;
}

export interface UsedToolParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ToolNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolHistoryId` |
     * | Type | `Edm.Int32` |
     * | Nullable | `false` |
     */
    ToolHistoryId: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentId` |
     * | Type | `Edm.Int32` |
     */
    EquipmentId: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItemId` |
     * | Type | `Edm.Int32` |
     */
    MaterialItemId: number | null;
}

export interface ProducedMaterialItemQuantity {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedMaterialItemId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ProducedMaterialItemId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     * | Nullable | `false` |
     */
    Quantity: number;
}

export interface UpdateSerialNumberParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItemId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    MaterialItemId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NewSerialNumberCode` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NewSerialNumberCode: string;
}

export interface MaterialItemUnderReworkParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItemId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    MaterialItemId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItemStatusOnWOOp` |
     * | Type | `Edm.String` |
     */
    MaterialItemStatusOnWOOp: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoMNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    UoMNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PartialQuantity` |
     * | Type | `Edm.Decimal` |
     */
    PartialQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CompletedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    CompletedQuantity: number | null;
}

export interface ToBeConsumedMaterialInfo {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialSpecificationType` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    MaterialSpecificationType: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `GroupId` |
     * | Type | `Edm.String` |
     */
    GroupId: string | null;
}

export interface WorkOrderOperationAndMTUsToSkipType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation_Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperation_Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MTUIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DM_MTUIdList: Array<string>;
}

export interface CheckCertificationParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkOrderOperationNId: string;
}

export interface WorkOrderOperationPairParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NewWorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    NewWorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SplittedWorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    SplittedWorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ClonedToBeProducedDM_MtuIds` |
     * | Type | `Collection(Edm.Guid)` |
     */
    ClonedToBeProducedDM_MtuIds: Array<string>;
}

export interface ExecutionGroupPhaseParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupPhaseNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ExecutionGroupPhaseNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupPhaseSequence` |
     * | Type | `Edm.Int32` |
     * | Nullable | `false` |
     */
    ExecutionGroupPhaseSequence: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    WorkOrderOperationIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ExecutionGroupId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PreviousExecutionGroupPhaseNId` |
     * | Type | `Edm.String` |
     */
    PreviousExecutionGroupPhaseNId: string | null;
}

export interface GetValidMachineWOOpIdsParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WOOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOperationNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WOOperationNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
}

export interface DM_MaterialTrackingUnitIdentifierParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MTUId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    DM_MTUId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MTUNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    MTUNId: string;
}

export interface CompleteWOStepSerializedParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MTUIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DM_MTUIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderStepId: string;
}

export interface WorkOrderToBeGrouped {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     * | Nullable | `false` |
     */
    Quantity: number;
}

export interface WoTypeAndEgNId {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOperationTypeNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkOperationTypeNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ExecutionGroupNId: string;
}

export interface WorkInstructionRuntimeValueParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterName` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ParameterName: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Sequence: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterValue` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ParameterValue: string;
}

export interface PLMMasterPlanParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UID` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    UID: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RootProcessUID` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    RootProcessUID: string;
}

export interface PLMOperationParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EffectivityExpression` |
     * | Type | `Edm.String` |
     */
    EffectivityExpression: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExtendedProperties` |
     * | Type | `Edm.String` |
     */
    ExtendedProperties: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FinalMaterialUID` |
     * | Type | `Edm.String` |
     */
    FinalMaterialUID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Revision: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UID` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    UID: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignatureStart` |
     * | Type | `Edm.Boolean` |
     */
    ElectronicSignatureStart: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignaturePause` |
     * | Type | `Edm.Boolean` |
     */
    ElectronicSignaturePause: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignatureComplete` |
     * | Type | `Edm.Boolean` |
     */
    ElectronicSignatureComplete: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RequiredCertificateNId` |
     * | Type | `Edm.String` |
     */
    RequiredCertificateNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RequiredInspectionRole` |
     * | Type | `Edm.String` |
     */
    RequiredInspectionRole: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOperationTypeNId` |
     * | Type | `Edm.String` |
     */
    WorkOperationTypeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedDuration` |
     * | Type | `Edm.Int64` |
     */
    EstimatedDuration: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationCategory` |
     * | Type | `Edm.String` |
     */
    OperationCategory: string | null;
}

export interface PLMProcessParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UID` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    UID: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Revision: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MinQuantity` |
     * | Type | `Edm.Decimal` |
     */
    MinQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaxQuantity` |
     * | Type | `Edm.Decimal` |
     */
    MaxQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Plant` |
     * | Type | `Edm.String` |
     */
    Plant: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FinalMaterialUID` |
     * | Type | `Edm.String` |
     */
    FinalMaterialUID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExtendedProperties` |
     * | Type | `Edm.String` |
     */
    ExtendedProperties: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EffectivityExpression` |
     * | Type | `Edm.String` |
     */
    EffectivityExpression: string | null;
}

export interface PLMDocumentParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UID` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    UID: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FileName` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    FileName: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MIMEType` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    MIMEType: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Type` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Type: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DatasetNId` |
     * | Type | `Edm.String` |
     */
    DatasetNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExtendedProperties` |
     * | Type | `Edm.String` |
     */
    ExtendedProperties: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FileLink` |
     * | Type | `Edm.String` |
     */
    FileLink: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FileBlob` |
     * | Type | `Edm.Binary` |
     */
    FileBlob: string | null;
}

export interface PLMMaterialDefinitionParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UID` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    UID: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Revision: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UOM` |
     * | Type | `Edm.String` |
     */
    UOM: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Traceable` |
     * | Type | `Edm.Boolean` |
     */
    Traceable: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SerialNumberProfile` |
     * | Type | `Edm.Boolean` |
     */
    SerialNumberProfile: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Lot` |
     * | Type | `Edm.Boolean` |
     */
    Lot: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Rotable` |
     * | Type | `Edm.Boolean` |
     */
    Rotable: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Consumable` |
     * | Type | `Edm.Boolean` |
     */
    Consumable: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PreserveQuantity` |
     * | Type | `Edm.Boolean` |
     */
    PreserveQuantity: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LifeLimited` |
     * | Type | `Edm.Boolean` |
     */
    LifeLimited: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExtendedProperties` |
     * | Type | `Edm.String` |
     */
    ExtendedProperties: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialClassNId` |
     * | Type | `Edm.String` |
     */
    MaterialClassNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EffectivityExpression` |
     * | Type | `Edm.String` |
     */
    EffectivityExpression: string | null;
}

export interface PLMToolDefinitionParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UID` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    UID: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Revision: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExtendedProperties` |
     * | Type | `Edm.String` |
     */
    ExtendedProperties: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EffectivityExpression` |
     * | Type | `Edm.String` |
     */
    EffectivityExpression: string | null;
}

export interface PLMStepParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UID` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    UID: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Revision: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedDuration` |
     * | Type | `Edm.Int64` |
     */
    EstimatedDuration: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignatureStart` |
     * | Type | `Edm.Boolean` |
     */
    ElectronicSignatureStart: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignaturePause` |
     * | Type | `Edm.Boolean` |
     */
    ElectronicSignaturePause: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignatureComplete` |
     * | Type | `Edm.Boolean` |
     */
    ElectronicSignatureComplete: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RequiredInspectionRole` |
     * | Type | `Edm.String` |
     */
    RequiredInspectionRole: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RequiredCertificateNId` |
     * | Type | `Edm.String` |
     */
    RequiredCertificateNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExtendedProperties` |
     * | Type | `Edm.String` |
     */
    ExtendedProperties: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EffectivityExpression` |
     * | Type | `Edm.String` |
     */
    EffectivityExpression: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StepCategory` |
     * | Type | `Edm.String` |
     */
    StepCategory: string | null;
}

export interface PLMDocumentAssociationParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentUID` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    DocumentUID: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReferencedEntityUID` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ReferencedEntityUID: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExtendedProperties` |
     * | Type | `Edm.String` |
     */
    ExtendedProperties: string | null;
}

export interface PLMAsPlannedBoPParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UID` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    UID: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PBOPIdentID` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    PBOPIdentID: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RootProcessUID` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    RootProcessUID: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlanUID` |
     * | Type | `Edm.String` |
     */
    MasterPlanUID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OrderId` |
     * | Type | `Edm.String` |
     */
    OrderId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EffectivityExpression` |
     * | Type | `Edm.String` |
     */
    EffectivityExpression: string | null;
}

export interface PLMLinkParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UID` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    UID: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBOPUID` |
     * | Type | `Edm.String` |
     */
    AsPlannedBOPUID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentUID` |
     * | Type | `Edm.String` |
     */
    ParentUID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChildUID` |
     * | Type | `Edm.String` |
     */
    ChildUID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExtendedProperties` |
     * | Type | `Edm.String` |
     */
    ExtendedProperties: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     */
    Sequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EffectivityExpression` |
     * | Type | `Edm.String` |
     */
    EffectivityExpression: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlanUID` |
     * | Type | `Edm.String` |
     */
    MasterPlanUID: string | null;
}

export interface PLMMaterialSpecificationParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialDefinitionUID` |
     * | Type | `Edm.String` |
     */
    MaterialDefinitionUID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogicalPosition` |
     * | Type | `Edm.String` |
     */
    LogicalPosition: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReferencedEntityUID` |
     * | Type | `Edm.String` |
     */
    ReferencedEntityUID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EffectivityExpression` |
     * | Type | `Edm.String` |
     */
    EffectivityExpression: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBOPUID` |
     * | Type | `Edm.String` |
     */
    AsPlannedBOPUID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlanUID` |
     * | Type | `Edm.String` |
     */
    MasterPlanUID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExtendedProperties` |
     * | Type | `Edm.String` |
     */
    ExtendedProperties: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UID` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    UID: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialSpecificationTypeNId` |
     * | Type | `Edm.String` |
     */
    MaterialSpecificationTypeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OccurrenceId` |
     * | Type | `Edm.String` |
     */
    OccurrenceId: string | null;
}

export interface PLMToolSpecificationParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolDefinitionUID` |
     * | Type | `Edm.String` |
     */
    ToolDefinitionUID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UsageNumber` |
     * | Type | `Edm.Int32` |
     */
    UsageNumber: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UsageDuration` |
     * | Type | `Edm.Int32` |
     */
    UsageDuration: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReferencedEntityUID` |
     * | Type | `Edm.String` |
     */
    ReferencedEntityUID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EffectivityExpression` |
     * | Type | `Edm.String` |
     */
    EffectivityExpression: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBOPUID` |
     * | Type | `Edm.String` |
     */
    AsPlannedBOPUID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlanUID` |
     * | Type | `Edm.String` |
     */
    MasterPlanUID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExtendedProperties` |
     * | Type | `Edm.String` |
     */
    ExtendedProperties: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UID` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    UID: string;
}

export interface PLMStepDependencyParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationToStepLinkFromUID` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    OperationToStepLinkFromUID: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationToStepLinkToUID` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    OperationToStepLinkToUID: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DependencyType` |
     * | Type | `Edm.String` |
     */
    DependencyType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBOPUID` |
     * | Type | `Edm.String` |
     */
    AsPlannedBOPUID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExtendedProperties` |
     * | Type | `Edm.String` |
     */
    ExtendedProperties: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlanUID` |
     * | Type | `Edm.String` |
     */
    MasterPlanUID: string | null;
}

export interface PLMEquipmentSpecLocationParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LocationId` |
     * | Type | `Edm.String` |
     */
    LocationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReferencedEntityUID` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ReferencedEntityUID: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PartProgram` |
     * | Type | `Edm.String` |
     */
    PartProgram: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExtendedProperties` |
     * | Type | `Edm.String` |
     */
    ExtendedProperties: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EffectivityExpression` |
     * | Type | `Edm.String` |
     */
    EffectivityExpression: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBOPUID` |
     * | Type | `Edm.String` |
     */
    AsPlannedBOPUID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlanUID` |
     * | Type | `Edm.String` |
     */
    MasterPlanUID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UID` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    UID: string;
}

export interface PLMOpDependencyParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessToOperationLinkFromUID` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ProcessToOperationLinkFromUID: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DependencyType` |
     * | Type | `Edm.String` |
     */
    DependencyType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessToOperationLinkToUID` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ProcessToOperationLinkToUID: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBOPUID` |
     * | Type | `Edm.String` |
     */
    AsPlannedBOPUID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExtendedProperties` |
     * | Type | `Edm.String` |
     */
    ExtendedProperties: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlanUID` |
     * | Type | `Edm.String` |
     */
    MasterPlanUID: string | null;
}

export interface PLMDCDParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReferencedEntityUID` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ReferencedEntityUID: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DimensionType` |
     * | Type | `Edm.String` |
     */
    DimensionType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NominalValue` |
     * | Type | `Edm.Decimal` |
     */
    NominalValue: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UpperLimit` |
     * | Type | `Edm.Decimal` |
     */
    UpperLimit: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LowerLimit` |
     * | Type | `Edm.Decimal` |
     */
    LowerLimit: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `InspectionType` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    InspectionType: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoM` |
     * | Type | `Edm.String` |
     */
    UoM: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsOptional` |
     * | Type | `Edm.Boolean` |
     */
    IsOptional: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Placeholder` |
     * | Type | `Edm.String` |
     */
    Placeholder: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DateTimeFormat` |
     * | Type | `Edm.String` |
     */
    DateTimeFormat: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExtendedProperties` |
     * | Type | `Edm.String` |
     */
    ExtendedProperties: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NumberOfDecimalPlaces` |
     * | Type | `Edm.Int32` |
     */
    NumberOfDecimalPlaces: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StringFormat` |
     * | Type | `Edm.String` |
     */
    StringFormat: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaximumLength` |
     * | Type | `Edm.Int32` |
     */
    MaximumLength: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AssociationType` |
     * | Type | `Edm.String` |
     */
    AssociationType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AlertMinLimit` |
     * | Type | `Edm.Decimal` |
     */
    AlertMinLimit: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AlertMaxLimit` |
     * | Type | `Edm.Decimal` |
     */
    AlertMaxLimit: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CautionMinLimit` |
     * | Type | `Edm.Decimal` |
     */
    CautionMinLimit: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CautionMaxLimit` |
     * | Type | `Edm.Decimal` |
     */
    CautionMaxLimit: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OutOfRangeBehavior` |
     * | Type | `Edm.String` |
     */
    OutOfRangeBehavior: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DataAcquisitionMethod` |
     * | Type | `Edm.String` |
     */
    DataAcquisitionMethod: string | null;
}

export interface ToolToBeUsedInfoParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ToolNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TimesToBeUsed` |
     * | Type | `Edm.Decimal` |
     */
    TimesToBeUsed: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UsageDuration` |
     * | Type | `Edm.Int64` |
     */
    UsageDuration: number | null;
}

export interface MaterialItemToolToBeUsedInfo {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SN` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    SN: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Tools` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.Types.ToolToBeUsedInfoParameterType)` |
     */
    Tools: Array<ToolToBeUsedInfoParameterType>;
}

export interface PLMCertificationWithSkillParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SkillList` |
     * | Type | `Collection(Edm.String)` |
     */
    SkillList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExtendedProperties` |
     * | Type | `Edm.String` |
     */
    ExtendedProperties: string | null;
}

export interface PLMHRSpecificationParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UID` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    UID: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CertificationNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    CertificationNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Int32` |
     */
    Quantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReferencedEntityUID` |
     * | Type | `Edm.String` |
     */
    ReferencedEntityUID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EffectivityExpression` |
     * | Type | `Edm.String` |
     */
    EffectivityExpression: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBOPUID` |
     * | Type | `Edm.String` |
     */
    AsPlannedBOPUID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlanUID` |
     * | Type | `Edm.String` |
     */
    MasterPlanUID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExtendedProperties` |
     * | Type | `Edm.String` |
     */
    ExtendedProperties: string | null;
}

export interface PLMMaterialTrackingUnitParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    DM_MaterialId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Name: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    Quantity: QuantityParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Code` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Code: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsReserved` |
     * | Type | `Edm.Boolean` |
     */
    IsReserved: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Weigth` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    Weigth: QuantityParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Volume` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    Volume: QuantityParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActiveNonConformanceNumber` |
     * | Type | `Edm.Int32` |
     */
    ActiveNonConformanceNumber: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BufferNId` |
     * | Type | `Edm.String` |
     */
    BufferNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AMPowderProperties` |
     * | Type | `Siemens.SimaticIT.UADM.OperationalData.FB_OP_MAT.OPModel.Types.AMPowderPropertiesParameterType` |
     */
    AMPowderProperties: AMPowderPropertiesParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExtendedProperties` |
     * | Type | `Edm.String` |
     */
    ExtendedProperties: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CodeType` |
     * | Type | `Siemens.SimaticIT.OperationalData.MAT_OP.OPModel.Types.MTUCodeType` |
     * | Nullable | `false` |
     */
    CodeType: MTUCodeType;
}

export interface PLMChangeStatusEventLogParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EventId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    EventId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TransitionVerb` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    TransitionVerb: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ErrorMessage` |
     * | Type | `Edm.String` |
     */
    ErrorMessage: string | null;
}

export interface PLMDCDStepItemParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DimensionType` |
     * | Type | `Edm.String` |
     */
    DimensionType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NominalValue` |
     * | Type | `Edm.Decimal` |
     */
    NominalValue: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UpperLimit` |
     * | Type | `Edm.Decimal` |
     */
    UpperLimit: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LowerLimit` |
     * | Type | `Edm.Decimal` |
     */
    LowerLimit: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `InspectionType` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    InspectionType: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaximumLength` |
     * | Type | `Edm.Int32` |
     */
    MaximumLength: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NumberOfDecimalPlaces` |
     * | Type | `Edm.Int32` |
     */
    NumberOfDecimalPlaces: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StringFormat` |
     * | Type | `Edm.String` |
     */
    StringFormat: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoM` |
     * | Type | `Edm.String` |
     */
    UoM: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsOptional` |
     * | Type | `Edm.Boolean` |
     */
    IsOptional: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Placeholder` |
     * | Type | `Edm.String` |
     */
    Placeholder: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DateTimeFormat` |
     * | Type | `Edm.String` |
     */
    DateTimeFormat: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AlertMinLimit` |
     * | Type | `Edm.Decimal` |
     */
    AlertMinLimit: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AlertMaxLimit` |
     * | Type | `Edm.Decimal` |
     */
    AlertMaxLimit: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CautionMinLimit` |
     * | Type | `Edm.Decimal` |
     */
    CautionMinLimit: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CautionMaxLimit` |
     * | Type | `Edm.Decimal` |
     */
    CautionMaxLimit: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OutOfRangeBehavior` |
     * | Type | `Edm.String` |
     */
    OutOfRangeBehavior: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DataAcquisitionMethod` |
     * | Type | `Edm.String` |
     */
    DataAcquisitionMethod: string | null;
}

export interface PLMDCDWIParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Instructions` |
     * | Type | `Edm.String` |
     */
    Instructions: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DCDList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.Types.PLMDCDStepItemParameterType)` |
     */
    DCDList: Array<PLMDCDStepItemParameterType>;
}

export interface SvgIcon {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `path` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    path: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `size` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    size: string;
}

export interface SkillParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Color` |
     * | Type | `Edm.String` |
     */
    Color: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Level` |
     * | Type | `Edm.Int32` |
     */
    Level: number | null;
}

export interface SignerParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Name: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Comment` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Comment: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TimeStamp` |
     * | Type | `Edm.DateTimeOffset` |
     * | Nullable | `false` |
     */
    TimeStamp: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SignerRequired` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    SignerRequired: string;
}

export interface MaterialQuantityList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialNId` |
     * | Type | `Edm.String` |
     */
    MaterialNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     */
    Revision: string | null;
}

export interface StateMachineStatusNIdParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StateMachineNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    StateMachineNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StatusNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    StatusNId: string;
}

export interface MTUGenealogyType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Code` |
     * | Type | `Edm.String` |
     */
    Code: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CodeType` |
     * | Type | `Edm.String` |
     */
    CodeType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialLot_Id` |
     * | Type | `Edm.Guid` |
     */
    MaterialLot_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialNId` |
     * | Type | `Edm.String` |
     */
    MaterialNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialRevision` |
     * | Type | `Edm.String` |
     */
    MaterialRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    Quantity: QuantityParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.Types.StateMachineStatusNIdParameterType` |
     */
    Status: StateMachineStatusNIdParameterType | null;
}

export interface DM_MTUGenealogyType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialId_Id` |
     * | Type | `Edm.Guid` |
     */
    DM_MaterialId_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialTrackingUnit_Id` |
     * | Type | `Edm.Guid` |
     */
    MaterialTrackingUnit_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentDM_MTU_Id` |
     * | Type | `Edm.Guid` |
     */
    ParentDM_MTU_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialTrackingUnit` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.Types.MTUGenealogyType` |
     */
    MaterialTrackingUnit: MTUGenealogyType | null;
}

export interface ProducedMTUGenealogyType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnit_Id` |
     * | Type | `Edm.Guid` |
     */
    DM_MaterialTrackingUnit_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrder_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrder_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnit` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.Types.DM_MTUGenealogyType` |
     */
    DM_MaterialTrackingUnit: DM_MTUGenealogyType | null;
}

export interface ToBeConsumedMaterialGenealogyType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogicalPosition` |
     * | Type | `Edm.String` |
     */
    LogicalPosition: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialDefinition_Id` |
     * | Type | `Edm.Guid` |
     */
    MaterialDefinition_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialSpecificationType` |
     * | Type | `Edm.String` |
     */
    MaterialSpecificationType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrekitSerialNumber` |
     * | Type | `Edm.String` |
     */
    PrekitSerialNumber: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     */
    Sequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStep_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStep_Id: string | null;
}

export interface UserFieldNIdValueParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserFieldValue` |
     * | Type | `Edm.String` |
     */
    UserFieldValue: string | null;
}

export interface TaskContextParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserFields` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.Types.UserFieldNIdValueParameterType)` |
     */
    UserFields: Array<UserFieldNIdValueParameterType>;
}

export interface ScrewingDetailsParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialTrackingUnitNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    MaterialTrackingUnitNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ToolNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AngleValueMax` |
     * | Type | `Edm.Decimal` |
     * | Nullable | `false` |
     */
    AngleValueMax: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AngleValueMin` |
     * | Type | `Edm.Decimal` |
     * | Nullable | `false` |
     */
    AngleValueMin: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TorqueValueMax` |
     * | Type | `Edm.Decimal` |
     * | Nullable | `false` |
     */
    TorqueValueMax: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TorqueValueMin` |
     * | Type | `Edm.Decimal` |
     * | Nullable | `false` |
     */
    TorqueValueMin: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BoltsNumber` |
     * | Type | `Edm.Int32` |
     * | Nullable | `false` |
     */
    BoltsNumber: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OkBoltsNumber` |
     * | Type | `Edm.Int32` |
     * | Nullable | `false` |
     */
    OkBoltsNumber: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NokBoltsNumber` |
     * | Type | `Edm.Int32` |
     * | Nullable | `false` |
     */
    NokBoltsNumber: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MissingBoltsNumber` |
     * | Type | `Edm.Int32` |
     * | Nullable | `false` |
     */
    MissingBoltsNumber: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsActive` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsActive: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedToolId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToBeUsedToolId: string;
}

export interface ScrewingDataParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Angle` |
     * | Type | `Edm.Decimal` |
     * | Nullable | `false` |
     */
    Angle: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Torque` |
     * | Type | `Edm.Decimal` |
     * | Nullable | `false` |
     */
    Torque: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BoltItemNumber` |
     * | Type | `Edm.Int32` |
     * | Nullable | `false` |
     */
    BoltItemNumber: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsOk` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsOk: boolean;
}

export interface ProcessMachinesParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Type` |
     * | Type | `Edm.String` |
     */
    Type: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LevelNId` |
     * | Type | `Edm.String` |
     */
    LevelNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentSpecificationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    EquipmentSpecificationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AssociatedPrintJobFileId` |
     * | Type | `Edm.Guid` |
     */
    AssociatedPrintJobFileId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AssociatedPrintJobFileNId` |
     * | Type | `Edm.String` |
     */
    AssociatedPrintJobFileNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AssociatedPartProgramId` |
     * | Type | `Edm.Guid` |
     */
    AssociatedPartProgramId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AssociatedPartProgramNId` |
     * | Type | `Edm.String` |
     */
    AssociatedPartProgramNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsWorkOperationAM` |
     * | Type | `Edm.Boolean` |
     */
    IsWorkOperationAM: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsWorkOperationCNC` |
     * | Type | `Edm.Boolean` |
     */
    IsWorkOperationCNC: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface ToolCompatibleMachineParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeNId` |
     * | Type | `Edm.String` |
     */
    EquipmentTypeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Level` |
     * | Type | `Edm.String` |
     */
    Level: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CompleteByDifferentUser` |
     * | Type | `Edm.Boolean` |
     */
    CompleteByDifferentUser: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Lockable` |
     * | Type | `Edm.Boolean` |
     */
    Lockable: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsActive` |
     * | Type | `Edm.Boolean` |
     */
    IsActive: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     */
    Status: string | null;
}

export interface RF_ToolDefinitionCompatibleMachineParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolDefinitionId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToolDefinitionId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolDefinitionNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ToolDefinitionNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeId` |
     * | Type | `Edm.Guid` |
     */
    EquipmentTypeId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeNId` |
     * | Type | `Edm.String` |
     */
    EquipmentTypeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationId` |
     * | Type | `Edm.Guid` |
     */
    EquipmentConfigurationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationNId` |
     * | Type | `Edm.String` |
     */
    EquipmentConfigurationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LevelName` |
     * | Type | `Edm.String` |
     */
    LevelName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationName` |
     * | Type | `Edm.String` |
     */
    EquipmentConfigurationName: string | null;
}

export interface UADMMaterialParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Name: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialClassNId` |
     * | Type | `Edm.String` |
     */
    MaterialClassNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogisticClassNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    LogisticClassNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SerialNumberProfile` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    SerialNumberProfile: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Volume` |
     * | Type | `Edm.Decimal` |
     */
    Volume: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `VolumeUoMNId` |
     * | Type | `Edm.String` |
     */
    VolumeUoMNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Weight` |
     * | Type | `Edm.Decimal` |
     */
    Weight: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WeightUoMNId` |
     * | Type | `Edm.String` |
     */
    WeightUoMNId: string | null;
}

export interface UADMEquipmentSpecificationParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Name: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LevelNId` |
     * | Type | `Edm.String` |
     */
    LevelNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeNId` |
     * | Type | `Edm.String` |
     */
    EquipmentTypeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Lockable` |
     * | Type | `Edm.Boolean` |
     */
    Lockable: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsScrapped` |
     * | Type | `Edm.Boolean` |
     */
    IsScrapped: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EnabledForCompleteByDifferentUser` |
     * | Type | `Edm.Boolean` |
     */
    EnabledForCompleteByDifferentUser: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsActive` |
     * | Type | `Edm.Boolean` |
     */
    IsActive: boolean | null;
}

export interface QualityInspectionDataType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MTUNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    MTUNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MeasuredAttributiveValue` |
     * | Type | `Edm.Boolean` |
     */
    MeasuredAttributiveValue: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MeasuredVariableValue` |
     * | Type | `Edm.Decimal` |
     */
    MeasuredVariableValue: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `VisualFailureNId` |
     * | Type | `Edm.String` |
     */
    VisualFailureNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `VisualFailureCount` |
     * | Type | `Edm.Int32` |
     */
    VisualFailureCount: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `User` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    User: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Timestamp` |
     * | Type | `Edm.DateTimeOffset` |
     */
    Timestamp: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AnyViolation` |
     * | Type | `Edm.Boolean` |
     */
    AnyViolation: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CharacteristicRepresentationNId` |
     * | Type | `Edm.String` |
     */
    CharacteristicRepresentationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FailureNId` |
     * | Type | `Edm.String` |
     */
    FailureNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `InspectionValue_Id` |
     * | Type | `Edm.Guid` |
     */
    InspectionValue_Id: string | null;
}

export interface Equipment3DPrinterParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LevelNId` |
     * | Type | `Edm.String` |
     */
    LevelNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Type` |
     * | Type | `Edm.String` |
     */
    Type: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExternalEquipmentNId` |
     * | Type | `Edm.String` |
     */
    ExternalEquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TransferPlugIn` |
     * | Type | `Edm.String` |
     */
    TransferPlugIn: string | null;
}

export interface AutomationNodeTypeParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     */
    Revision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     */
    Status: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
}

export interface AutomationNodeInstanceParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     */
    Revision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     */
    Status: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutomationNodeTypeNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    AutomationNodeTypeNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
}

export interface PrintJobFileWorkOrderParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrder` |
     * | Type | `Edm.String` |
     */
    WorkOrder: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationName` |
     * | Type | `Edm.String` |
     */
    OperationName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     */
    Sequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MachineUsed` |
     * | Type | `Edm.String` |
     */
    MachineUsed: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActionId` |
     * | Type | `Edm.String` |
     */
    ActionId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PJFTransferDate` |
     * | Type | `Edm.DateTimeOffset` |
     */
    PJFTransferDate: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `User` |
     * | Type | `Edm.String` |
     */
    User: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStatus` |
     * | Type | `Edm.String` |
     */
    WorkOrderStatus: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationStatus` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationStatus: string | null;
}

export interface QuantityParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoMNId` |
     * | Type | `Edm.String` |
     */
    UoMNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `QuantityValue` |
     * | Type | `Edm.Decimal` |
     */
    QuantityValue: number | null;
}

export interface BaseUoMParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
}

export interface PropertyParameterTypeCreate {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PropertyNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    PropertyNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PropertyType` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.SupportedTypes` |
     * | Nullable | `false` |
     */
    PropertyType: SupportedTypes;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PropertyUoMNId` |
     * | Type | `Edm.String` |
     */
    PropertyUoMNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PropertyValue` |
     * | Type | `Edm.String` |
     */
    PropertyValue: string | null;
}

export interface ParameterValueParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ParameterNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterValue` |
     * | Type | `Edm.String` |
     */
    ParameterValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterUoMNId` |
     * | Type | `Edm.String` |
     */
    ParameterUoMNId: string | null;
}

export interface StatusParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StatusDefinitionId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    StatusDefinitionId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
}

export interface StatusTypeParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StateMachineNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    StateMachineNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StatusNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    StatusNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Outcome` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.StatusesOutcome` |
     * | Nullable | `false` |
     */
    Outcome: StatusesOutcome;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Color` |
     * | Type | `Edm.String` |
     */
    Color: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
}

export interface MultipleOrSubmultipleUoMParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `K0Multiplier` |
     * | Type | `Edm.Decimal` |
     */
    K0Multiplier: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `K1Multiplier` |
     * | Type | `Edm.Decimal` |
     */
    K1Multiplier: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Addend` |
     * | Type | `Edm.Decimal` |
     */
    Addend: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Exponent` |
     * | Type | `Edm.Int16` |
     */
    Exponent: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
}

export interface PJFParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BuildtrayLayout` |
     * | Type | `Edm.String` |
     */
    BuildtrayLayout: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedBuildProcessDuration` |
     * | Type | `Edm.Duration` |
     */
    EstimatedBuildProcessDuration: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedMaterialConsumption` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    EstimatedMaterialConsumption: QuantityParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedPrintDuration` |
     * | Type | `Edm.Duration` |
     */
    EstimatedPrintDuration: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExternalId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ExternalId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaxProducedHeight` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    MaxProducedHeight: QuantityParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProductSerializable` |
     * | Type | `Edm.Boolean` |
     */
    ProductSerializable: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RunTimeOnly` |
     * | Type | `Edm.Boolean` |
     */
    RunTimeOnly: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Source` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Source: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TestBars` |
     * | Type | `Edm.Boolean` |
     */
    TestBars: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TestBarsSerializable` |
     * | Type | `Edm.Boolean` |
     */
    TestBarsSerializable: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TestBarsNumber` |
     * | Type | `Edm.Int32` |
     */
    TestBarsNumber: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FileName` |
     * | Type | `Edm.String` |
     */
    FileName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProductSerialNumberManagement` |
     * | Type | `Siemens.SimaticIT.U4DM.MasterData.FB_MS_AMMS.MSModel.Types.AMSerialNumberManagement` |
     * | Nullable | `false` |
     */
    ProductSerialNumberManagement: AMSerialNumberManagement;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TestBarsSerialNumberManagement` |
     * | Type | `Siemens.SimaticIT.U4DM.MasterData.FB_MS_AMMS.MSModel.Types.AMSerialNumberManagement` |
     * | Nullable | `false` |
     */
    TestBarsSerialNumberManagement: AMSerialNumberManagement;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrinterTypeList` |
     * | Type | `Collection(Edm.String)` |
     */
    PrinterTypeList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProductionPrinter` |
     * | Type | `Edm.String` |
     */
    ProductionPrinter: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentPJF` |
     * | Type | `Edm.Guid` |
     */
    ParentPJF: string | null;
}

export interface Link3DPrinterparameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExternalEquipmentNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ExternalEquipmentNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TransferPlugIn` |
     * | Type | `Edm.String` |
     */
    TransferPlugIn: string | null;
}

export interface PrinterParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    EquipmentTypeNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TransferPlugin` |
     * | Type | `Edm.String` |
     */
    TransferPlugin: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFile` |
     * | Type | `Edm.Guid` |
     */
    PrintJobFile: string | null;
}

export interface EquipmentSpecificationParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Type` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Type: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationID` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OperationID: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PartProgram` |
     * | Type | `Edm.String` |
     */
    PartProgram: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeNId` |
     * | Type | `Edm.String` |
     */
    EquipmentTypeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EffectivityExpression` |
     * | Type | `Edm.String` |
     */
    EffectivityExpression: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBopId` |
     * | Type | `Edm.Guid` |
     */
    AsPlannedBopId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UId` |
     * | Type | `Edm.String` |
     */
    UId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlanId` |
     * | Type | `Edm.Guid` |
     */
    MasterPlanId: string | null;
}

export interface TCM2ResourceDefinitionParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExtendedProperties` |
     * | Type | `Edm.String` |
     */
    ExtendedProperties: string | null;
}

export interface TCM2LinkParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UID` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    UID: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBopUID` |
     * | Type | `Edm.String` |
     */
    AsPlannedBopUID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentUID` |
     * | Type | `Edm.String` |
     */
    ParentUID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChildUID` |
     * | Type | `Edm.String` |
     */
    ChildUID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExtendedProperties` |
     * | Type | `Edm.String` |
     */
    ExtendedProperties: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     */
    Sequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EffectivityExpression` |
     * | Type | `Edm.String` |
     */
    EffectivityExpression: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlanUID` |
     * | Type | `Edm.String` |
     */
    MasterPlanUID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EWIStepURL` |
     * | Type | `Edm.String` |
     */
    EWIStepURL: string | null;
}

export interface OperationParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Revision: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Optional` |
     * | Type | `Edm.Boolean` |
     */
    Optional: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     */
    Sequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UId` |
     * | Type | `Edm.String` |
     */
    UId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessId` |
     * | Type | `Edm.Guid` |
     */
    ProcessId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedDuration` |
     * | Type | `Edm.Duration` |
     */
    EstimatedDuration: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RequiredInspectionRole` |
     * | Type | `Edm.String` |
     */
    RequiredInspectionRole: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignatureStart` |
     * | Type | `Edm.Boolean` |
     */
    ElectronicSignatureStart: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignatureComplete` |
     * | Type | `Edm.Boolean` |
     */
    ElectronicSignatureComplete: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignaturePause` |
     * | Type | `Edm.Boolean` |
     */
    ElectronicSignaturePause: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RequiredCertificateNId` |
     * | Type | `Edm.String` |
     */
    RequiredCertificateNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RevisionEffectivityExpression` |
     * | Type | `Edm.String` |
     */
    RevisionEffectivityExpression: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EffectivityExpression` |
     * | Type | `Edm.String` |
     */
    EffectivityExpression: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationStepCategoryId` |
     * | Type | `Edm.Guid` |
     */
    OperationStepCategoryId: string | null;
}

export interface MaterialSpecificationParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DMMaterialId` |
     * | Type | `Edm.Guid` |
     */
    DMMaterialId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    Quantity: QuantityParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationId` |
     * | Type | `Edm.Guid` |
     */
    OperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogicalPosition` |
     * | Type | `Edm.String` |
     */
    LogicalPosition: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StepId` |
     * | Type | `Edm.Guid` |
     */
    StepId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialSpecificationTypeId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    MaterialSpecificationTypeId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `GroupId` |
     * | Type | `Edm.String` |
     */
    GroupId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AlternativeSelected` |
     * | Type | `Edm.Boolean` |
     */
    AlternativeSelected: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EffectivityExpression` |
     * | Type | `Edm.String` |
     */
    EffectivityExpression: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBopId` |
     * | Type | `Edm.Guid` |
     */
    AsPlannedBopId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UId` |
     * | Type | `Edm.String` |
     */
    UId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlanId` |
     * | Type | `Edm.Guid` |
     */
    MasterPlanId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FunctionalCodeNId` |
     * | Type | `Edm.String` |
     */
    FunctionalCodeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OccurrenceId` |
     * | Type | `Edm.String` |
     */
    OccurrenceId: string | null;
}

export interface TCM2MaterialSpecificationParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    Quantity: QuantityParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogicalPosition` |
     * | Type | `Edm.String` |
     */
    LogicalPosition: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EffectivityExpression` |
     * | Type | `Edm.String` |
     */
    EffectivityExpression: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBopUID` |
     * | Type | `Edm.String` |
     */
    AsPlannedBopUID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlanUID` |
     * | Type | `Edm.String` |
     */
    MasterPlanUID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExtendedProperties` |
     * | Type | `Edm.String` |
     */
    ExtendedProperties: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    UId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialSpecificationTypeId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    MaterialSpecificationTypeId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DMMaterialId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    DMMaterialId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationId` |
     * | Type | `Edm.Guid` |
     */
    OperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StepId` |
     * | Type | `Edm.Guid` |
     */
    StepId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `GroupId` |
     * | Type | `Edm.String` |
     */
    GroupId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AlternativeSelected` |
     * | Type | `Edm.Boolean` |
     */
    AlternativeSelected: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OccurrenceId` |
     * | Type | `Edm.String` |
     */
    OccurrenceId: string | null;
}

export interface DocumentFromFileParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FileName` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    FileName: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MIMEType` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    MIMEType: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Type` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Type: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DatasetNId` |
     * | Type | `Edm.String` |
     */
    DatasetNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UId` |
     * | Type | `Edm.String` |
     */
    UId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FileId` |
     * | Type | `Edm.Guid` |
     */
    FileId: string | null;
}

export interface TCM2ToolSpecificationParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UsageNumber` |
     * | Type | `Edm.Int32` |
     */
    UsageNumber: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UsageDuration` |
     * | Type | `Edm.Duration` |
     * | Nullable | `false` |
     */
    UsageDuration: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EffectivityExpression` |
     * | Type | `Edm.String` |
     */
    EffectivityExpression: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBopUID` |
     * | Type | `Edm.String` |
     */
    AsPlannedBopUID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlanUID` |
     * | Type | `Edm.String` |
     */
    MasterPlanUID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExtendedProperties` |
     * | Type | `Edm.String` |
     */
    ExtendedProperties: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolDefinitionId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToolDefinitionId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationId` |
     * | Type | `Edm.Guid` |
     */
    OperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StepId` |
     * | Type | `Edm.Guid` |
     */
    StepId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    UId: string;
}

export interface TCM2StepDependencyParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationToStepLinkFromUID` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    OperationToStepLinkFromUID: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationToStepLinkToUID` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    OperationToStepLinkToUID: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DependencyType` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    DependencyType: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBopUID` |
     * | Type | `Edm.String` |
     */
    AsPlannedBopUID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExtendedProperties` |
     * | Type | `Edm.String` |
     */
    ExtendedProperties: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlanUID` |
     * | Type | `Edm.String` |
     */
    MasterPlanUID: string | null;
}

export interface TCM2DocumentAssociationParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentUID` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    DocumentUID: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReferencedEntityUID` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ReferencedEntityUID: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExtendedProperties` |
     * | Type | `Edm.String` |
     */
    ExtendedProperties: string | null;
}

export interface DependencyNavigationParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationDependencyId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OperationDependencyId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsPreferred` |
     * | Type | `Edm.Boolean` |
     */
    IsPreferred: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AlternativeGroup` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    AlternativeGroup: string;
}

export interface DocumentParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FileName` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    FileName: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MIMEType` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    MIMEType: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Type` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Type: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DatasetNId` |
     * | Type | `Edm.String` |
     */
    DatasetNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UId` |
     * | Type | `Edm.String` |
     */
    UId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `File` |
     * | Type | `Edm.Binary` |
     * | Nullable | `false` |
     */
    File: string;
}

export interface ProcessDefinitionIdentifierParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessDefinitionRevision` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ProcessDefinitionRevision: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessDefinitionNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ProcessDefinitionNId: string;
}

export interface TCM2OpDependencyParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessToOperationLinkFromUID` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ProcessToOperationLinkFromUID: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DependencyType` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    DependencyType: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessToOperationLinkToUID` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ProcessToOperationLinkToUID: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBopUID` |
     * | Type | `Edm.String` |
     */
    AsPlannedBopUID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExtendedProperties` |
     * | Type | `Edm.String` |
     */
    ExtendedProperties: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlanUID` |
     * | Type | `Edm.String` |
     */
    MasterPlanUID: string | null;
}

export interface StepDependencyParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FromStepId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    FromStepId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToStepId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToStepId: string;
}

export interface TCM2OperationParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UID` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    UID: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     */
    Revision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedDuration` |
     * | Type | `Edm.Int64` |
     */
    EstimatedDuration: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExtendedProperties` |
     * | Type | `Edm.String` |
     */
    ExtendedProperties: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RequiredInspectionRole` |
     * | Type | `Edm.String` |
     */
    RequiredInspectionRole: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignatureStart` |
     * | Type | `Edm.Boolean` |
     */
    ElectronicSignatureStart: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignaturePause` |
     * | Type | `Edm.Boolean` |
     */
    ElectronicSignaturePause: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignatureComplete` |
     * | Type | `Edm.Boolean` |
     */
    ElectronicSignatureComplete: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RequiredCertificateNId` |
     * | Type | `Edm.String` |
     */
    RequiredCertificateNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EffectivityExpression` |
     * | Type | `Edm.String` |
     */
    EffectivityExpression: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOperationTypeNId` |
     * | Type | `Edm.String` |
     */
    WorkOperationTypeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCollectedDocument` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCollectedDocument: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationStepCategoryId` |
     * | Type | `Edm.Guid` |
     */
    OperationStepCategoryId: string | null;
}

export interface OperationStepCategoryType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
}

export interface StepCatalogueParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedDuration` |
     * | Type | `Edm.Duration` |
     */
    EstimatedDuration: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RequiredInspectionRole` |
     * | Type | `Edm.String` |
     */
    RequiredInspectionRole: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignatureStart` |
     * | Type | `Edm.Boolean` |
     */
    ElectronicSignatureStart: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignatureComplete` |
     * | Type | `Edm.Boolean` |
     */
    ElectronicSignatureComplete: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignaturePause` |
     * | Type | `Edm.Boolean` |
     */
    ElectronicSignaturePause: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RequiredCertificateNId` |
     * | Type | `Edm.String` |
     */
    RequiredCertificateNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationStepCategoryId` |
     * | Type | `Edm.Guid` |
     */
    OperationStepCategoryId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     */
    Sequence: number | null;
}

export interface ProcessParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Revision: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FinalMaterialId` |
     * | Type | `Edm.Guid` |
     */
    FinalMaterialId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentProcessId` |
     * | Type | `Edm.Guid` |
     */
    ParentProcessId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     */
    Sequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UId` |
     * | Type | `Edm.String` |
     */
    UId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBOPId` |
     * | Type | `Edm.Guid` |
     */
    AsPlannedBOPId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaxQuantity` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    MaxQuantity: QuantityParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MinQuantity` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    MinQuantity: QuantityParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    Quantity: QuantityParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Plant` |
     * | Type | `Edm.String` |
     */
    Plant: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EffectivityExpression` |
     * | Type | `Edm.String` |
     */
    EffectivityExpression: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RevisionEffectivityExpression` |
     * | Type | `Edm.String` |
     */
    RevisionEffectivityExpression: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlanId` |
     * | Type | `Edm.Guid` |
     */
    MasterPlanId: string | null;
}

export interface ToolDefinitionDocumentParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolDefinitionId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToolDefinitionId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    DocumentId: string;
}

export interface ProcessInfoParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Revision: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    UId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Name: string;
}

export interface TCM2EquipmentSpecificationParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Type` |
     * | Type | `Edm.String` |
     */
    Type: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EffectivityExpression` |
     * | Type | `Edm.String` |
     */
    EffectivityExpression: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBOPUId` |
     * | Type | `Edm.String` |
     */
    AsPlannedBOPUId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlanUId` |
     * | Type | `Edm.String` |
     */
    MasterPlanUId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UID` |
     * | Type | `Edm.String` |
     */
    UID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReferencedOperationUID` |
     * | Type | `Edm.String` |
     */
    ReferencedOperationUID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeNId` |
     * | Type | `Edm.String` |
     */
    EquipmentTypeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PartProgram` |
     * | Type | `Edm.String` |
     */
    PartProgram: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationUID` |
     * | Type | `Edm.String` |
     */
    OperationUID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MachineDefinitionNId` |
     * | Type | `Edm.String` |
     */
    MachineDefinitionNId: string | null;
}

export interface OperationDependencyParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FromOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    FromOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Context` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Context: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DependencyTypeId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    DependencyTypeId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBoPId` |
     * | Type | `Edm.Guid` |
     */
    AsPlannedBoPId: string | null;
}

export interface TCM2AsPlannedBOPParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BaselineUId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    BaselineUId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BaselineName` |
     * | Type | `Edm.String` |
     */
    BaselineName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PBOPIdentID` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    PBOPIdentID: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlanUID` |
     * | Type | `Edm.String` |
     */
    MasterPlanUID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RootProcessUID` |
     * | Type | `Edm.String` |
     */
    RootProcessUID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OrderId` |
     * | Type | `Edm.String` |
     */
    OrderId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EffectivityExpression` |
     * | Type | `Edm.String` |
     */
    EffectivityExpression: string | null;
}

export interface UpdateStepParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedDuration` |
     * | Type | `Edm.Duration` |
     */
    EstimatedDuration: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RequiredInspectionRole` |
     * | Type | `Edm.String` |
     */
    RequiredInspectionRole: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignatureStart` |
     * | Type | `Edm.Boolean` |
     */
    ElectronicSignatureStart: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignatureComplete` |
     * | Type | `Edm.Boolean` |
     */
    ElectronicSignatureComplete: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignaturePause` |
     * | Type | `Edm.Boolean` |
     */
    ElectronicSignaturePause: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RequiredCertificateNId` |
     * | Type | `Edm.String` |
     */
    RequiredCertificateNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationStepCategoryId` |
     * | Type | `Edm.Guid` |
     */
    OperationStepCategoryId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCollectedDocument` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCollectedDocument: boolean | null;
}

export interface ToolSpecificationParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolDefinitionId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToolDefinitionId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StepId` |
     * | Type | `Edm.Guid` |
     */
    StepId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationId` |
     * | Type | `Edm.Guid` |
     */
    OperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UsageNumber` |
     * | Type | `Edm.Int32` |
     */
    UsageNumber: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UsageDuration` |
     * | Type | `Edm.Duration` |
     */
    UsageDuration: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EffectivityExpression` |
     * | Type | `Edm.String` |
     */
    EffectivityExpression: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBopId` |
     * | Type | `Edm.Guid` |
     */
    AsPlannedBopId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UId` |
     * | Type | `Edm.String` |
     */
    UId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlanId` |
     * | Type | `Edm.Guid` |
     */
    MasterPlanId: string | null;
}

export interface AsPlannedBOPParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BaselineUId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    BaselineUId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BaselineName` |
     * | Type | `Edm.String` |
     */
    BaselineName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PBOPIdentID` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    PBOPIdentID: string;
}

export interface OperationStructureDependencyParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FromLinkId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    FromLinkId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToLinkId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToLinkId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DependencyTypeId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    DependencyTypeId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBOPId` |
     * | Type | `Edm.Guid` |
     */
    AsPlannedBOPId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlanId` |
     * | Type | `Edm.Guid` |
     */
    MasterPlanId: string | null;
}

export interface TCM2ProcessParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UID` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    UID: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     */
    Revision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MinQuantity` |
     * | Type | `Edm.Decimal` |
     */
    MinQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaxQuantity` |
     * | Type | `Edm.Decimal` |
     */
    MaxQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Plant` |
     * | Type | `Edm.String` |
     */
    Plant: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FinalMaterialUID` |
     * | Type | `Edm.String` |
     */
    FinalMaterialUID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     */
    Sequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExtendedProperties` |
     * | Type | `Edm.String` |
     */
    ExtendedProperties: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EffectivityExpression` |
     * | Type | `Edm.String` |
     */
    EffectivityExpression: string | null;
}

export interface OutputProcessParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ProcessId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessUId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ProcessUId: string;
}

export interface TCM2StepParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UID` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    UID: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     */
    Revision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedDuration` |
     * | Type | `Edm.Int64` |
     */
    EstimatedDuration: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignatureStart` |
     * | Type | `Edm.Boolean` |
     */
    ElectronicSignatureStart: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignaturePause` |
     * | Type | `Edm.Boolean` |
     */
    ElectronicSignaturePause: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignatureComplete` |
     * | Type | `Edm.Boolean` |
     */
    ElectronicSignatureComplete: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RequiredInspectionRole` |
     * | Type | `Edm.String` |
     */
    RequiredInspectionRole: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RequiredCertificateNId` |
     * | Type | `Edm.String` |
     */
    RequiredCertificateNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Optional` |
     * | Type | `Edm.Boolean` |
     */
    Optional: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExtendedProperties` |
     * | Type | `Edm.String` |
     */
    ExtendedProperties: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EffectivityExpression` |
     * | Type | `Edm.String` |
     */
    EffectivityExpression: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationStepCategoryId` |
     * | Type | `Edm.Guid` |
     */
    OperationStepCategoryId: string | null;
}

export interface MaterialDefinitionDocumentParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialDefinitionId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    MaterialDefinitionId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    DocumentId: string;
}

export interface LinkParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChildEntityId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ChildEntityId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentEntityId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ParentEntityId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     */
    Sequence: number | null;
}

export interface StepInOperationParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedDuration` |
     * | Type | `Edm.Duration` |
     */
    EstimatedDuration: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RequiredInspectionRole` |
     * | Type | `Edm.String` |
     */
    RequiredInspectionRole: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignatureStart` |
     * | Type | `Edm.Boolean` |
     */
    ElectronicSignatureStart: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignatureComplete` |
     * | Type | `Edm.Boolean` |
     */
    ElectronicSignatureComplete: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignaturePause` |
     * | Type | `Edm.Boolean` |
     */
    ElectronicSignaturePause: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RequiredCertificateNId` |
     * | Type | `Edm.String` |
     */
    RequiredCertificateNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBOPId` |
     * | Type | `Edm.Guid` |
     */
    AsPlannedBOPId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PredecessorId` |
     * | Type | `Edm.Guid` |
     */
    PredecessorId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationStepCategoryId` |
     * | Type | `Edm.Guid` |
     */
    OperationStepCategoryId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     */
    Sequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCollectedDocument` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCollectedDocument: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlanId` |
     * | Type | `Edm.Guid` |
     */
    MasterPlanId: string | null;
}

export interface TCM2DocumentParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UID` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    UID: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FileName` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    FileName: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MIMEType` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    MIMEType: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Type` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Type: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DatasetNId` |
     * | Type | `Edm.String` |
     */
    DatasetNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExtendedProperties` |
     * | Type | `Edm.String` |
     */
    ExtendedProperties: string | null;
}

export interface TCM2MasterPlanParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UID` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    UID: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RootProcessUID` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    RootProcessUID: string;
}

export interface LogisticParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Volume` |
     * | Type | `Edm.Decimal` |
     */
    Volume: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Weight` |
     * | Type | `Edm.Decimal` |
     */
    Weight: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `VolumeUoM` |
     * | Type | `Edm.String` |
     */
    VolumeUoM: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WeightUoM` |
     * | Type | `Edm.String` |
     */
    WeightUoM: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogisticClass` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    LogisticClass: string;
}

export interface TCMOutputParameter {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Label` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Label: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsCreated` |
     * | Type | `Edm.Boolean` |
     */
    IsCreated: boolean | null;
}

export interface SubstrateDefinitionPropertiesParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutomaticThicknessDecrease` |
     * | Type | `Edm.Boolean` |
     */
    AutomaticThicknessDecrease: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaximumTreatmentCountHold` |
     * | Type | `Edm.Int32` |
     */
    MaximumTreatmentCountHold: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaximumTreatmentCountWarning` |
     * | Type | `Edm.Int32` |
     */
    MaximumTreatmentCountWarning: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MinimumThicknessWarning` |
     * | Type | `Edm.Decimal` |
     */
    MinimumThicknessWarning: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MinimumThicknessHold` |
     * | Type | `Edm.Decimal` |
     */
    MinimumThicknessHold: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ThicknessDecreaseAmount` |
     * | Type | `Edm.Decimal` |
     */
    ThicknessDecreaseAmount: number | null;
}

export interface IdentifiersParameterType2 {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface ProcessIdentifiersParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Revision: string;
}

export interface TCM2ToolDefinitionParameterTypeCreate {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Revision: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UId` |
     * | Type | `Edm.String` |
     */
    UId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolClassNId` |
     * | Type | `Edm.String` |
     */
    ToolClassNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UsageCounterMax` |
     * | Type | `Edm.Int32` |
     */
    UsageCounterMax: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UsageDurationMax` |
     * | Type | `Edm.Duration` |
     */
    UsageDurationMax: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExpirationDate` |
     * | Type | `Edm.DateTimeOffset` |
     */
    ExpirationDate: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EffectivityExpression` |
     * | Type | `Edm.String` |
     */
    EffectivityExpression: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SubstrateDefinitionProperties` |
     * | Type | `Siemens.SimaticIT.MasterData.MatTool.MSModel.Types.SubstrateDefinitionPropertiesParameterType` |
     */
    SubstrateDefinitionProperties: SubstrateDefinitionPropertiesParameterType | null;
}

export interface AMPowderPropertiesParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaxRecycleCount` |
     * | Type | `Edm.Int32` |
     */
    MaxRecycleCount: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RecycleCount` |
     * | Type | `Edm.Int32` |
     */
    RecycleCount: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MinQuantity` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    MinQuantity: QuantityParameterType | null;
}

export interface DM_MaterialTrackingUnitHistoryParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BufferNId` |
     * | Type | `Edm.String` |
     */
    BufferNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DisassembleFromHistoryId` |
     * | Type | `Edm.Guid` |
     */
    DisassembleFromHistoryId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupPhase` |
     * | Type | `Edm.Guid` |
     */
    ExecutionGroupPhase: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NewCode` |
     * | Type | `Edm.String` |
     */
    NewCode: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OldCode` |
     * | Type | `Edm.String` |
     */
    OldCode: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceId` |
     * | Type | `Edm.Guid` |
     */
    NonConformanceId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     */
    Status: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetCode` |
     * | Type | `Edm.String` |
     */
    TargetCode: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceCode` |
     * | Type | `Edm.String` |
     */
    SourceCode: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CodeType` |
     * | Type | `Siemens.SimaticIT.OperationalData.MAT_OP.OPModel.Types.MTUCodeType` |
     */
    CodeType: MTUCodeType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Code` |
     * | Type | `Edm.String` |
     */
    Code: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetDM_MaterialTrackingUnit` |
     * | Type | `Edm.Guid` |
     */
    TargetDM_MaterialTrackingUnit: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceDM_MaterialTrackingUnit` |
     * | Type | `Edm.Guid` |
     */
    SourceDM_MaterialTrackingUnit: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStep` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStep: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperation: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrder` |
     * | Type | `Edm.Guid` |
     */
    WorkOrder: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnit` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    DM_MaterialTrackingUnit: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RecycleCount` |
     * | Type | `Edm.Int32` |
     */
    RecycleCount: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OldQuantity` |
     * | Type | `Edm.Decimal` |
     */
    OldQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MixedQuantity` |
     * | Type | `Edm.Int32` |
     */
    MixedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Action` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Action: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Date` |
     * | Type | `Edm.DateTimeOffset` |
     */
    Date: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserId` |
     * | Type | `Edm.String` |
     */
    UserId: string | null;
}

export interface NIdsParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Values` |
     * | Type | `Collection(Edm.String)` |
     */
    Values: Array<string>;
}

export interface APSOrderOperationParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedEndTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedEndTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedStartTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedStartTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AssignedResourceNId` |
     * | Type | `Edm.String` |
     */
    AssignedResourceNId: string | null;
}

export interface APSOrderOperationsParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Values` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.FB_OP_APSInt.OPModel.Types.APSOrderOperationParameterType)` |
     */
    Values: Array<APSOrderOperationParameterType>;
}

export interface MaterialItemToConsumeOnContainerParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialDefinitionNId` |
     * | Type | `Edm.String` |
     */
    MaterialDefinitionNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContainerNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ContainerNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeConsumedMaterialItemList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ToBeConsumedMaterialParameterType)` |
     */
    ToBeConsumedMaterialItemList: Array<ToBeConsumedMaterialParameterType>;
}

export interface UnloadContainerParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContainerNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ContainerNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MTUNIdList` |
     * | Type | `Collection(Edm.String)` |
     */
    MTUNIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
}

export interface ToolToBeUsedOnContainerParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContainerNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ContainerNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Tool` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ToolToBeUsedParameterType` |
     */
    Tool: ToolToBeUsedParameterType | null;
}

export interface CreateBoMItemResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateBoMItem {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogicalPosition` |
     * | Type | `Edm.String` |
     */
    LogicalPosition: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsAlternativeSelected` |
     * | Type | `Edm.Boolean` |
     */
    IsAlternativeSelected: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BoMItemBoM` |
     * | Type | `Edm.Guid` |
     */
    BoMItemBoM: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `GroupType` |
     * | Type | `Edm.Guid` |
     */
    GroupType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `GroupName` |
     * | Type | `Edm.String` |
     */
    GroupName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    Quantity: QuantityParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BoM` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    BoM: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialDefinition` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    MaterialDefinition: string;
}

export interface SentenceNonConformanceResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CurrentStatus` |
     * | Type | `Edm.String` |
     */
    CurrentStatus: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReworkOrderId` |
     * | Type | `Edm.Guid` |
     */
    ReworkOrderId: string | null;
}

export interface SentenceNonConformance {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceSentencingDetails` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.NonConformanceSentencingParamaterType` |
     * | Nullable | `false` |
     */
    NonConformanceSentencingDetails: NonConformanceSentencingParamaterType;
}

export interface UpdateSkillResponse extends CommandResponse {
}

export interface UpdateSkill {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Color` |
     * | Type | `Edm.String` |
     */
    Color: string | null;
}

export interface SetWorkOrderHoldResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
}

export interface SetWorkOrderHold {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `HoldParametersType` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.HoldParamterType` |
     * | Nullable | `false` |
     */
    HoldParametersType: HoldParamterType;
}

export interface TriggerPrintingOnWorkOrderOperationResponse extends CommandResponse {
}

export interface TriggerPrintingOnWorkOrderOperation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
}

export interface SetNonConformanceStatusIsFrozenResponse extends CommandResponse {
}

export interface SetNonConformanceStatusIsFrozen {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceLifecycleId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    NonConformanceLifecycleId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceStatusId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    NonConformanceStatusId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsRuntimeFrozen` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsRuntimeFrozen: boolean;
}

export interface DeleteMaterialsTrackingUnitResponse extends CommandResponse {
}

export interface DeleteMaterialsTrackingUnit {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnitIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DM_MaterialTrackingUnitIds: Array<string>;
}

export interface DeleteToolSpecificationListResponse extends CommandResponse {
}

export interface DeleteToolSpecificationList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface UnlinkAMMachineToMESResponse extends CommandResponse {
}

export interface UnlinkAMMachineToMES {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MachineToAMMachine` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    MachineToAMMachine: string;
}

export interface CreateToBeUsedMachinePJFResponse extends CommandResponse {
}

export interface CreateToBeUsedMachinePJF {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsSourcePJF` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsSourcePJF: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFile` |
     * | Type | `Edm.Guid` |
     */
    PrintJobFile: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFileExternalId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    PrintJobFileExternalId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedMachineId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToBeUsedMachineId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFileName` |
     * | Type | `Edm.String` |
     */
    PrintJobFileName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFileSource` |
     * | Type | `Edm.String` |
     */
    PrintJobFileSource: string | null;
}

export interface LinkItlkCheckToOperationToStepLinkListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckOperationToStepLinkAssociationIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ItlkCheckOperationToStepLinkAssociationIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Edm.String` |
     */
    WarningMessage: string | null;
}

export interface LinkItlkCheckToOperationToStepLinkList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckOperationToStepLinkAssociationList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_ITLK.MSModel.Types.ItlkCheckOperationToStepLinkAssociationParameterType)` |
     * | Nullable | `false` |
     */
    ItlkCheckOperationToStepLinkAssociationList: Array<ItlkCheckOperationToStepLinkAssociationParameterType>;
}

export interface DeleteUoMResponse extends CommandResponse {
}

export interface DeleteUoM {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface SetToBeCollectedDocumentResponse extends CommandResponse {
}

export interface SetToBeCollectedDocument {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OperationId: string;
}

export interface InitializeCreatedTaskResponse extends CommandResponse {
}

export interface InitializeCreatedTask {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `InitializeCreatedTaskParameter` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.FB_OP_DMTask.OPModel.Types.InitializeCreatedTaskParameterType` |
     * | Nullable | `false` |
     */
    InitializeCreatedTaskParameter: InitializeCreatedTaskParameterType;
}

export interface StartWOOperationSerializedResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderHistoryId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderHistoryId: string | null;
}

export interface StartWOOperationSerialized {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupPhaseId` |
     * | Type | `Edm.Guid` |
     */
    ExecutionGroupPhaseId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StartWOOperationSerializedParameterType` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.StartWOOperationSerializedParameterType` |
     * | Nullable | `false` |
     */
    StartWOOperationSerializedParameterType: StartWOOperationSerializedParameterType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointItemParameterType` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.SetPointParameterType)` |
     */
    SetPointItemParameterType: Array<SetPointParameterType>;
}

export interface UnlinkDocumentListToDM_MaterialTrackingUnitResponse extends CommandResponse {
}

export interface UnlinkDocumentListToDM_MaterialTrackingUnit {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnitDocumentAssociationIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DM_MaterialTrackingUnitDocumentAssociationIds: Array<string>;
}

export interface TCM2CreateResourceDefinitionListResponse extends CommandResponse {
}

export interface TCM2CreateResourceDefinitionList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResourceDefinitionList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_BOP.MSModel.Types.TCM2ResourceDefinitionParameterType)` |
     * | Nullable | `false` |
     */
    ResourceDefinitionList: Array<TCM2ResourceDefinitionParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     */
    CorrelationId: string | null;
}

export interface GetBufferWithActualQuantityResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualQuantities` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.FB_OP_IPL.OPModel.Types.OutputBufferActualQuantityType)` |
     */
    ActualQuantities: Array<OutputBufferActualQuantityType>;
}

export interface GetBufferWithActualQuantity {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface DeleteToolDefinitionDocumentListResponse extends CommandResponse {
}

export interface DeleteToolDefinitionDocumentList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface SaveWorkInstructionDesignResponse extends CommandResponse {
}

export interface SaveWorkInstructionDesign {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Model` |
     * | Type | `Edm.String` |
     */
    Model: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WI_ESScenarios` |
     * | Type | `Collection(Siemens.SimaticIT.MasterData.WI_MS.MSModel.Types.WI_ESScenerioParameterType)` |
     */
    WI_ESScenarios: Array<WI_ESScenerioParameterType>;
}

export interface UnlinkSubstrateDefinitionToMachineResponse extends CommandResponse {
}

export interface UnlinkSubstrateDefinitionToMachine {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SubstrateDefinitionCompatibleMachineList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    SubstrateDefinitionCompatibleMachineList: Array<string>;
}

export interface LinkWIDefinitionsToWOStepResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface LinkWIDefinitionsToWOStep {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionDefinitionIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    WorkInstructionDefinitionIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderStepId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionAssociationType` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkInstructionAssociationType: string;
}

export interface LockWorkInstructionDefinitionResponse extends CommandResponse {
}

export interface LockWorkInstructionDefinition {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface CreateEquipmentGraphConfigurationResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateEquipmentGraphConfiguration {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Type` |
     * | Type | `Edm.String` |
     */
    Type: string | null;
}

export interface AssociateDNCItemMachineMaterialAssociationResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DNCItemMachineMaterialAssociationId` |
     * | Type | `Edm.Guid` |
     */
    DNCItemMachineMaterialAssociationId: string | null;
}

export interface AssociateDNCItemMachineMaterialAssociation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DNCItemId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    DNCItemId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MachineToDNCId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    MachineToDNCId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialId` |
     * | Type | `Edm.Guid` |
     */
    DM_MaterialId: string | null;
}

export interface TCM2LinkOperationToStepListResponse extends CommandResponse {
}

export interface TCM2LinkOperationToStepList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LinkList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_BOP.MSModel.Types.TCM2LinkParameterType)` |
     * | Nullable | `false` |
     */
    LinkList: Array<TCM2LinkParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     */
    CorrelationId: string | null;
}

export interface DeleteCustomItlkCheckParameterListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Edm.String` |
     */
    WarningMessage: string | null;
}

export interface DeleteCustomItlkCheckParameterList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ListOfItlkCheckParameterId` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ListOfItlkCheckParameterId: Array<string>;
}

export interface CreateTeamResponse extends CommandResponse {
}

export interface CreateTeam {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaximumUsers` |
     * | Type | `Edm.Int32` |
     */
    MaximumUsers: number | null;
}

export interface DeleteProcessToOpLinkDependencyNavigationListResponse extends CommandResponse {
}

export interface DeleteProcessToOpLinkDependencyNavigationList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ProcessId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AlternativeGroup` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    AlternativeGroup: string;
}

export interface UpdateOperationResponse extends CommandResponse {
}

export interface UpdateOperation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Operation` |
     * | Type | `Siemens.SimaticIT.U4DM.MasterData.FB_MS_BOP.MSModel.Types.OperationParameterType` |
     * | Nullable | `false` |
     */
    Operation: OperationParameterType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCollectedDocument` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCollectedDocument: boolean | null;
}

export interface CreateEquipmentTypeResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeId` |
     * | Type | `Edm.Guid` |
     */
    EquipmentTypeId: string | null;
}

export interface CreateEquipmentType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StateMachineNId` |
     * | Type | `Edm.String` |
     */
    StateMachineNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StateMachineNIds` |
     * | Type | `Collection(Edm.String)` |
     */
    StateMachineNIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LevelNId` |
     * | Type | `Edm.String` |
     */
    LevelNId: string | null;
}

export interface EditWorkOrderHumanResourceResponse extends CommandResponse {
}

export interface EditWorkOrderHumanResource {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CertificationNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    CertificationNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RequiredNumberOfHumanResource` |
     * | Type | `Edm.Int32` |
     * | Nullable | `false` |
     */
    RequiredNumberOfHumanResource: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStepId: string | null;
}

export interface AssignNonConformanceTransitionMailAddressListResponse extends CommandResponse {
}

export interface AssignNonConformanceTransitionMailAddressList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceTransitionId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NonConformanceTransitionId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MailAddressList` |
     * | Type | `Collection(Edm.String)` |
     */
    MailAddressList: Array<string>;
}

export interface SplitWorkOrderResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NewWorkOrderList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.WorkOrderIdentifiersParameterType)` |
     */
    NewWorkOrderList: Array<WorkOrderIdentifiersParameterType>;
}

export interface SplitWorkOrder {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkOrderNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SplitType` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    SplitType: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NewWorkOrderList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.NewWorkOrderForSplit)` |
     * | Nullable | `false` |
     */
    NewWorkOrderList: Array<NewWorkOrderForSplit>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceNId` |
     * | Type | `Edm.String` |
     */
    NonConformanceNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsScrap` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsScrap: boolean;
}

export interface CreateVariableCharacteristicSpecificationResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateVariableCharacteristicSpecification {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Context` |
     * | Type | `Siemens.SimaticIT.MasterData.CHR_MS.MSModel.Types.CharacteristicContext` |
     * | Nullable | `false` |
     */
    Context: CharacteristicContext;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Criticality` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Criticality: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    UId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NominalValue` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     * | Nullable | `false` |
     */
    NominalValue: QuantityParameterType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UpperTolerance` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    UpperTolerance: QuantityParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LowerTolerance` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    LowerTolerance: QuantityParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Revision: string;
}

export interface DeleteHoldResponse extends CommandResponse {
}

export interface DeleteHold {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface CreateDM_MaterialTrackingUnitHistoryListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnitHistoryIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DM_MaterialTrackingUnitHistoryIdList: Array<string>;
}

export interface CreateDM_MaterialTrackingUnitHistoryList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnitHistoryParameterTypeList` |
     * | Type | `Collection(Siemens.SimaticIT.UADM.OperationalData.FB_OP_MAT.OPModel.Types.DM_MaterialTrackingUnitHistoryParameterType)` |
     * | Nullable | `false` |
     */
    DM_MaterialTrackingUnitHistoryParameterTypeList: Array<DM_MaterialTrackingUnitHistoryParameterType>;
}

export interface DeleteSkillListResponse extends CommandResponse {
}

export interface DeleteSkillList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SkillIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    SkillIdList: Array<string>;
}

export interface CreateStatusTransitionDefinitionResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StatusTransitionDefinitionId` |
     * | Type | `Edm.Guid` |
     */
    StatusTransitionDefinitionId: string | null;
}

export interface CreateStatusTransitionDefinition {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Verb` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Verb: string;
}

export interface UnlinkCharacteristicRepresentationToStepResponse extends CommandResponse {
}

export interface UnlinkCharacteristicRepresentationToStep {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `InspectionSpecificationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    InspectionSpecificationId: string;
}

export interface DeleteActualUsedMachineResponse extends CommandResponse {
}

export interface DeleteActualUsedMachine {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface UADMCreateDocumentResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface UADMCreateDocument {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FileName` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    FileName: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MIMEType` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    MIMEType: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `File` |
     * | Type | `Edm.Binary` |
     * | Nullable | `false` |
     */
    File: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Type` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Type: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DatasetNId` |
     * | Type | `Edm.String` |
     */
    DatasetNId: string | null;
}

export interface CreateBoMItemV4_0Response extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateBoMItemV4_0 {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogicalPosition` |
     * | Type | `Edm.String` |
     */
    LogicalPosition: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsAlternativeSelected` |
     * | Type | `Edm.Boolean` |
     */
    IsAlternativeSelected: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BoMItemBoM` |
     * | Type | `Edm.Guid` |
     */
    BoMItemBoM: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `GroupType` |
     * | Type | `Edm.Guid` |
     */
    GroupType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `GroupName` |
     * | Type | `Edm.String` |
     */
    GroupName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    Quantity: QuantityParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BoM` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    BoM: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialProperties` |
     * | Type | `Siemens.SimaticIT.UADM.MasterData.FB_MS_MAT.MSModel.Types.DM_MaterialParameterType` |
     */
    MaterialProperties: DM_MaterialParameterType | null;
}

export interface RejectMaterialRequestResponse extends CommandResponse {
}

export interface RejectMaterialRequest {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialRequestIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    MaterialRequestIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
}

export interface MaterialItemSplitBatchByPartialPreviewResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SplitBatchList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.MaterialItemForSplitType)` |
     */
    SplitBatchList: Array<MaterialItemForSplitType>;
}

export interface MaterialItemSplitBatchByPartialPreview {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetQuantity` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     * | Nullable | `false` |
     */
    TargetQuantity: QuantityParameterType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItemIdFlag0` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    MaterialItemIdFlag0: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItemId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    MaterialItemId: string;
}

export interface UpdateDM_MaterialResponse extends CommandResponse {
}

export interface UpdateDM_Material {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FirstArticleInspection` |
     * | Type | `Edm.Boolean` |
     */
    FirstArticleInspection: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SerialNumberProfile` |
     * | Type | `Edm.Boolean` |
     */
    SerialNumberProfile: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsPhantom` |
     * | Type | `Edm.Boolean` |
     */
    IsPhantom: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Traceable` |
     * | Type | `Edm.Boolean` |
     */
    Traceable: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogisticClassNId` |
     * | Type | `Edm.String` |
     */
    LogisticClassNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Volume` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    Volume: QuantityParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Weight` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    Weight: QuantityParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AMPowderProperties` |
     * | Type | `Siemens.SimaticIT.UADM.MasterData.FB_MS_MAT.MSModel.Types.AMPowderPropertiesParameterType` |
     */
    AMPowderProperties: AMPowderPropertiesParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialClassNId` |
     * | Type | `Edm.String` |
     */
    MaterialClassNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Lot` |
     * | Type | `Edm.Boolean` |
     */
    Lot: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EnableAutomaticConsumptionQty` |
     * | Type | `Edm.Boolean` |
     */
    EnableAutomaticConsumptionQty: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaxQuantityConsumption` |
     * | Type | `Edm.Decimal` |
     */
    MaxQuantityConsumption: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FunctionalCodeNId` |
     * | Type | `Edm.String` |
     */
    FunctionalCodeNId: string | null;
}

export interface UADMCreateToolDefinitionResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface UADMCreateToolDefinition {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Revision: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolClassNId` |
     * | Type | `Edm.String` |
     */
    ToolClassNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SubstrateDefinitionProperties` |
     * | Type | `Siemens.SimaticIT.MasterData.MatTool.MSModel.Types.SubstrateDefinitionPropertiesParameterType` |
     */
    SubstrateDefinitionProperties: SubstrateDefinitionPropertiesParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UsageCounterMax` |
     * | Type | `Edm.Int32` |
     */
    UsageCounterMax: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UsageDurationMax` |
     * | Type | `Edm.Duration` |
     */
    UsageDurationMax: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExpirationDate` |
     * | Type | `Edm.DateTimeOffset` |
     */
    ExpirationDate: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Consumable` |
     * | Type | `Edm.Boolean` |
     */
    Consumable: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RevisionExpression` |
     * | Type | `Edm.String` |
     */
    RevisionExpression: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogisticParameter` |
     * | Type | `Siemens.SimaticIT.U4DM.ReferenceData.FB_RD_SERV.RFModel.Types.LogisticParameterType` |
     */
    LogisticParameter: LogisticParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Lockable` |
     * | Type | `Edm.Boolean` |
     */
    Lockable: boolean | null;
}

export interface DeleteTeamResponse extends CommandResponse {
}

export interface DeleteTeam {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TeamId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    TeamId: string;
}

export interface UpdateItlkCheckWOOpAssociationListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Edm.String` |
     */
    WarningMessage: string | null;
}

export interface UpdateItlkCheckWOOpAssociationList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckWOOpAssociationList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.FB_OP_ITLK.OPModel.Types.ItlkCheckWOOpAssociationUpdateParameterType)` |
     * | Nullable | `false` |
     */
    ItlkCheckWOOpAssociationList: Array<ItlkCheckWOOpAssociationUpdateParameterType>;
}

export interface ExecuteCustomItlkCheckOutboundResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CustomItlkCheckOutputList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.FB_OP_ITLK.OPModel.Types.ItlkCheckOrchestratorOutputParameterType)` |
     */
    CustomItlkCheckOutputList: Array<ItlkCheckOrchestratorOutputParameterType>;
}

export interface ExecuteCustomItlkCheckOutbound {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CustomItlkCheckInputList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.FB_OP_ITLK.OPModel.Types.ItlkCheckOrchestratorInputParameterType)` |
     * | Nullable | `false` |
     */
    CustomItlkCheckInputList: Array<ItlkCheckOrchestratorInputParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProductionTypeNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ProductionTypeNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MTUList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ItlkCheckDM_MTUParameterType)` |
     */
    DM_MTUList: Array<ItlkCheckDM_MTUParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsAutomatic` |
     * | Type | `Edm.Boolean` |
     */
    IsAutomatic: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckSessionId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ItlkCheckSessionId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStepId: string | null;
}

export interface CreateEquipmentSpecificationResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentSpecificationId` |
     * | Type | `Edm.Guid` |
     */
    EquipmentSpecificationId: string | null;
}

export interface CreateEquipmentSpecification {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentSpecification` |
     * | Type | `Siemens.SimaticIT.U4DM.MasterData.FB_MS_BOP.MSModel.Types.EquipmentSpecificationParameterType` |
     * | Nullable | `false` |
     */
    EquipmentSpecification: EquipmentSpecificationParameterType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     */
    CorrelationId: string | null;
}

export interface SetWorkProcessToBeCleanedResponse extends CommandResponse {
}

export interface SetWorkProcessToBeCleaned {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkProcessId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkProcessId: string;
}

export interface AutoGenerateSerialNumberCodesResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutoGeneratedSNCodes` |
     * | Type | `Collection(Edm.String)` |
     */
    AutoGeneratedSNCodes: Array<string>;
}

export interface AutoGenerateSerialNumberCodes {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    MaterialNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkOrderNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NumberingPatternNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NumberingPatternNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Count` |
     * | Type | `Edm.Int32` |
     * | Nullable | `false` |
     */
    Count: number;
}

export interface LinkUserToWorkOrderOperationListResponse extends CommandResponse {
}

export interface LinkUserToWorkOrderOperationList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserIdList` |
     * | Type | `Collection(Edm.String)` |
     */
    UserIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    WorkOrderOperationIdList: Array<string>;
}

export interface CreateResultTypeListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResultTypeIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ResultTypeIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Collection(Edm.String)` |
     */
    WarningMessage: Array<string>;
}

export interface CreateResultTypeList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResultTypeList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.FB_OP_Result.OPModel.Types.CreateResultTypeParameterType)` |
     * | Nullable | `false` |
     */
    ResultTypeList: Array<CreateResultTypeParameterType>;
}

export interface AssignProducedMaterialItemsResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderNId: string | null;
}

export interface AssignProducedMaterialItems {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkOrderNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SerialNumbers` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.MaterialItemParameterType)` |
     * | Nullable | `false` |
     */
    SerialNumbers: Array<MaterialItemParameterType>;
}

export interface DeleteFutureHoldAfterNonConformanceSentencingResponse extends CommandResponse {
}

export interface DeleteFutureHoldAfterNonConformanceSentencing {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DeleteFutureHoldDetails` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.DeleteFutureHoldParameterType` |
     * | Nullable | `false` |
     */
    DeleteFutureHoldDetails: DeleteFutureHoldParameterType;
}

export interface DeleteActiveUserOnMachineResponse extends CommandResponse {
}

export interface DeleteActiveUserOnMachine {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActiveUserOnMachineId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ActiveUserOnMachineId: string;
}

export interface CreateWorkInstructionDefinitionResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ParameterIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionDefinitionId` |
     * | Type | `Edm.Guid` |
     */
    WorkInstructionDefinitionId: string | null;
}

export interface CreateWorkInstructionDefinition {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Revision: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TemplateNId` |
     * | Type | `Edm.String` |
     */
    TemplateNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Parameters` |
     * | Type | `Collection(Siemens.SimaticIT.MasterData.WI_MS.MSModel.Types.WorkInstructionDefinitionParameterParameterType)` |
     */
    Parameters: Array<WorkInstructionDefinitionParameterParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UseDefaultTemplate` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    UseDefaultTemplate: boolean;
}

export interface UploadOfflineActionListResponse extends CommandResponse {
}

export interface UploadOfflineActionList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OfflineSessionIdFlag0` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    OfflineSessionIdFlag0: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OfflineSessionId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OfflineSessionId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OfflineActionList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.FB_OP_Offline.OPModel.Types.OfflineActionType)` |
     * | Nullable | `false` |
     */
    OfflineActionList: Array<OfflineActionType>;
}

export interface APSSetAlternativeSelectedResponse extends CommandResponse {
}

export interface APSSetAlternativeSelected {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeConsumedMaterialId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToBeConsumedMaterialId: string;
}

export interface UpdateDNCItemMachineMaterialAssociationResponse extends CommandResponse {
}

export interface UpdateDNCItemMachineMaterialAssociation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DNCItemMachineMaterialAssociationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    DNCItemMachineMaterialAssociationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DNCId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    DNCId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DNCMachine` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    DNCMachine: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialId` |
     * | Type | `Edm.Guid` |
     */
    DM_MaterialId: string | null;
}

export interface UADMUpdateOperationResponse extends CommandResponse {
}

export interface UADMUpdateOperation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Name: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     * | Nullable | `false` |
     */
    Sequence: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedDuration` |
     * | Type | `Edm.Duration` |
     */
    EstimatedDuration: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Optional` |
     * | Type | `Edm.Boolean` |
     */
    Optional: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreateDependency` |
     * | Type | `Edm.Boolean` |
     */
    CreateDependency: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DependencyType` |
     * | Type | `Edm.Guid` |
     */
    DependencyType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ProcessId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    UId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignatureStart` |
     * | Type | `Edm.Boolean` |
     */
    ElectronicSignatureStart: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignaturePause` |
     * | Type | `Edm.Boolean` |
     */
    ElectronicSignaturePause: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignatureComplete` |
     * | Type | `Edm.Boolean` |
     */
    ElectronicSignatureComplete: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RequiredInspectionRole` |
     * | Type | `Edm.String` |
     */
    RequiredInspectionRole: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RequiredCertificateNId` |
     * | Type | `Edm.String` |
     */
    RequiredCertificateNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCollectedDocument` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCollectedDocument: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBOPId` |
     * | Type | `Edm.Guid` |
     */
    AsPlannedBOPId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EffectivityExpression` |
     * | Type | `Edm.String` |
     */
    EffectivityExpression: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RevisionEffectivityExpression` |
     * | Type | `Edm.String` |
     */
    RevisionEffectivityExpression: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OriginalSequence` |
     * | Type | `Edm.Int32` |
     */
    OriginalSequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationStepCategoryId` |
     * | Type | `Edm.Guid` |
     */
    OperationStepCategoryId: string | null;
}

export interface TriggerPrintingOnWorkOrderResponse extends CommandResponse {
}

export interface TriggerPrintingOnWorkOrder {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderId: string;
}

export interface TCM2LinkProcessToProcessListResponse extends CommandResponse {
}

export interface TCM2LinkProcessToProcessList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LinkList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_BOP.MSModel.Types.TCM2LinkParameterType)` |
     * | Nullable | `false` |
     */
    LinkList: Array<TCM2LinkParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     */
    CorrelationId: string | null;
}

export interface AdministrativePauseResponse extends CommandResponse {
}

export interface AdministrativePause {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
}

export interface CheckInUploadDocumentsResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface CheckInUploadDocuments {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStepId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentType` |
     * | Type | `Edm.String` |
     */
    DocumentType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItemIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    MaterialItemIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OfflineActionInternalId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OfflineActionInternalId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DocumentIds: Array<string>;
}

export interface DeleteStatusBehaviorDefinitionResponse extends CommandResponse {
}

export interface DeleteStatusBehaviorDefinition {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface CreateMaterialSpecificationResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateMaterialSpecification {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialSpecification` |
     * | Type | `Siemens.SimaticIT.U4DM.MasterData.FB_MS_BOP.MSModel.Types.MaterialSpecificationParameterType` |
     * | Nullable | `false` |
     */
    MaterialSpecification: MaterialSpecificationParameterType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     */
    CorrelationId: string | null;
}

export interface UnlinkDocumentListToStepResponse extends CommandResponse {
}

export interface UnlinkDocumentListToStep {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ListOfDocumentId` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ListOfDocumentId: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StepId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    StepId: string;
}

export interface CreateWorkOrderOutMsgResponse extends CommandResponse {
}

export interface CreateWorkOrderOutMsg {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `InstanceNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    InstanceNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MsgTypeNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    MsgTypeNId: string;
}

export interface LinkSkillsToCertificateResponse extends CommandResponse {
}

export interface LinkSkillsToCertificate {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SkillIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    SkillIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CertificationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    CertificationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Level` |
     * | Type | `Edm.Int32` |
     */
    Level: number | null;
}

export interface CreateNewOperationRevisionInCatalogueResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateNewOperationRevisionInCatalogue {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    SourceOperationId: string;
}

export interface DeleteNonProductiveActivityListForUserResponse extends CommandResponse {
}

export interface DeleteNonProductiveActivityListForUser {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserNPAIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    UserNPAIds: Array<string>;
}

export interface TCM2CreateMaterialSpecificationListResponse extends CommandResponse {
}

export interface TCM2CreateMaterialSpecificationList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialSpecificationList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_BOP.MSModel.Types.TCM2MaterialSpecificationParameterType)` |
     * | Nullable | `false` |
     */
    MaterialSpecificationList: Array<TCM2MaterialSpecificationParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     */
    CorrelationId: string | null;
}

export interface TraceNonConformanceOnContainerResponse extends CommandResponse {
}

export interface TraceNonConformanceOnContainer {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContainerNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ContainerNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActionNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ActionNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NonConformanceNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Mtus` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.FB_OP_ContainerQual.OPModel.Types.MTuWithQty)` |
     */
    Mtus: Array<MTuWithQty>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReworkOrderNId` |
     * | Type | `Edm.String` |
     */
    ReworkOrderNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StatusNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    StatusNId: string;
}

export interface CreateDocumentListFormFileIdsResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentIds` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.ReferenceData.FB_RD_SERV.RFModel.Types.TCMOutputParameter)` |
     */
    DocumentIds: Array<TCMOutputParameter>;
}

export interface CreateDocumentListFormFileIds {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.String` |
     */
    CorrelationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Documents` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_BOP.MSModel.Types.DocumentFromFileParameterType)` |
     * | Nullable | `false` |
     */
    Documents: Array<DocumentFromFileParameterType>;
}

export interface TCM2CreateToolSpecificationListResponse extends CommandResponse {
}

export interface TCM2CreateToolSpecificationList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolSpecificationList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_BOP.MSModel.Types.TCM2ToolSpecificationParameterType)` |
     * | Nullable | `false` |
     */
    ToolSpecificationList: Array<TCM2ToolSpecificationParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     */
    CorrelationId: string | null;
}

export interface TCM2CreateStepDependencyListResponse extends CommandResponse {
}

export interface TCM2CreateStepDependencyList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StepDependencyList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_BOP.MSModel.Types.TCM2StepDependencyParameterType)` |
     * | Nullable | `false` |
     */
    StepDependencyList: Array<TCM2StepDependencyParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     */
    CorrelationId: string | null;
}

export interface LinkSkillsToWorkOrderStepResponse extends CommandResponse {
}

export interface LinkSkillsToWorkOrderStep {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderStepId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SkillIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    SkillIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SkillLevel` |
     * | Type | `Edm.Int32` |
     */
    SkillLevel: number | null;
}

export interface LinkItlkCheckToOperationStepCategoryListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckOperationStepCategoryAssociationIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ItlkCheckOperationStepCategoryAssociationIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Edm.String` |
     */
    WarningMessage: string | null;
}

export interface LinkItlkCheckToOperationStepCategoryList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckOperationStepCategoryAssociationList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_ITLK.MSModel.Types.ItlkCheckOperationStepCategoryAssociationParameterType)` |
     * | Nullable | `false` |
     */
    ItlkCheckOperationStepCategoryAssociationList: Array<ItlkCheckOperationStepCategoryAssociationParameterType>;
}

export interface TCM2AssociateDocumentToOperationListResponse extends CommandResponse {
}

export interface TCM2AssociateDocumentToOperationList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentAssociationList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_BOP.MSModel.Types.TCM2DocumentAssociationParameterType)` |
     * | Nullable | `false` |
     */
    DocumentAssociationList: Array<TCM2DocumentAssociationParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     */
    CorrelationId: string | null;
}

export interface StartWOStepResponse extends CommandResponse {
}

export interface StartWOStep {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepDetails` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.IdentifiersParameterType` |
     * | Nullable | `false` |
     */
    WorkOrderStepDetails: IdentifiersParameterType;
}

export interface UpdateMaterialSpecificationResponse extends CommandResponse {
}

export interface UpdateMaterialSpecification {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialSpecification` |
     * | Type | `Siemens.SimaticIT.U4DM.MasterData.FB_MS_BOP.MSModel.Types.MaterialSpecificationParameterType` |
     * | Nullable | `false` |
     */
    MaterialSpecification: MaterialSpecificationParameterType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface DeleteToolCompatibleMachineResponse extends CommandResponse {
}

export interface DeleteToolCompatibleMachine {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolId` |
     * | Type | `Edm.Guid` |
     */
    ToolId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MachineDefintionNId` |
     * | Type | `Edm.String` |
     */
    MachineDefintionNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MachineNId` |
     * | Type | `Edm.String` |
     */
    MachineNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface CreateDM_MaterialTrackingUnitHistoryResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnitHistoryId` |
     * | Type | `Edm.Guid` |
     */
    DM_MaterialTrackingUnitHistoryId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateDM_MaterialTrackingUnitHistory {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserId` |
     * | Type | `Edm.String` |
     */
    UserId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Date` |
     * | Type | `Edm.DateTimeOffset` |
     */
    Date: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Action` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Action: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MixedQuantity` |
     * | Type | `Edm.Int32` |
     */
    MixedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OldQuantity` |
     * | Type | `Edm.Decimal` |
     */
    OldQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RecycleCount` |
     * | Type | `Edm.Int32` |
     */
    RecycleCount: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnit` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    DM_MaterialTrackingUnit: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrder` |
     * | Type | `Edm.Guid` |
     */
    WorkOrder: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperation: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStep` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStep: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceDM_MaterialTrackingUnit` |
     * | Type | `Edm.Guid` |
     */
    SourceDM_MaterialTrackingUnit: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetDM_MaterialTrackingUnit` |
     * | Type | `Edm.Guid` |
     */
    TargetDM_MaterialTrackingUnit: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Code` |
     * | Type | `Edm.String` |
     */
    Code: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CodeType` |
     * | Type | `Siemens.SimaticIT.OperationalData.MAT_OP.OPModel.Types.MTUCodeType` |
     */
    CodeType: MTUCodeType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceCode` |
     * | Type | `Edm.String` |
     */
    SourceCode: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetCode` |
     * | Type | `Edm.String` |
     */
    TargetCode: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     */
    Status: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceId` |
     * | Type | `Edm.Guid` |
     */
    NonConformanceId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OldCode` |
     * | Type | `Edm.String` |
     */
    OldCode: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NewCode` |
     * | Type | `Edm.String` |
     */
    NewCode: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupPhase` |
     * | Type | `Edm.Guid` |
     */
    ExecutionGroupPhase: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DisassembleFromHistoryId` |
     * | Type | `Edm.Guid` |
     */
    DisassembleFromHistoryId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BufferNId` |
     * | Type | `Edm.String` |
     */
    BufferNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentNId` |
     * | Type | `Edm.String` |
     */
    DocumentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutioGroupPhaseNId` |
     * | Type | `Edm.String` |
     */
    ExecutioGroupPhaseNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationNId: string | null;
}

export interface DeleteAsPlannedBoPResponse extends CommandResponse {
}

export interface DeleteAsPlannedBoP {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface ChangeWorkOrderStatusToEditResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Id: Array<string>;
}

export interface ChangeWorkOrderStatusToEdit {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderId: string;
}

export interface UpdateBufferDefinitionResponse extends CommandResponse {
}

export interface UpdateBufferDefinition {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CapacityType` |
     * | Type | `Edm.String` |
     */
    CapacityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    Quantity: QuantityParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsValid` |
     * | Type | `Edm.Boolean` |
     */
    IsValid: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Name: string;
}

export interface UpdateUoMDimensionResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BaseUoMIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    BaseUoMIds: Array<string>;
}

export interface UpdateUoMDimension {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BaseUoMs` |
     * | Type | `Collection(Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.BaseUoMParameterType)` |
     */
    BaseUoMs: Array<BaseUoMParameterType>;
}

export interface DeleteWorkProcessDMMaterialTrackingUnitAssociationListResponse extends CommandResponse {
}

export interface DeleteWorkProcessDMMaterialTrackingUnitAssociationList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DeleteWorkProcessDMMaterialTrackingUnitAssociationListParameter` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.FB_OP_DMTask.OPModel.Types.DeleteWorkProcessDMMaterialTrackingUnitAssociationListParameterType` |
     * | Nullable | `false` |
     */
    DeleteWorkProcessDMMaterialTrackingUnitAssociationListParameter: DeleteWorkProcessDMMaterialTrackingUnitAssociationListParameterType;
}

export interface DeleteFailureResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NotDeletedIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    NotDeletedIds: Array<string>;
}

export interface DeleteFailure {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface LinkToolsToNonConformanceResponse extends CommandResponse {
}

export interface LinkToolsToNonConformance {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    NonConformanceId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ToolIds: Array<string>;
}

export interface UpdatePreferredProcessToOpLinkDependencyNavigationResponse extends CommandResponse {
}

export interface UpdatePreferredProcessToOpLinkDependencyNavigation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ProcessId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessToOpLinkDependecyNavigation` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_BOP.MSModel.Types.DependencyNavigationParameterType)` |
     * | Nullable | `false` |
     */
    ProcessToOpLinkDependecyNavigation: Array<DependencyNavigationParameterType>;
}

export interface DeleteToBeUsedInspectionResponse extends CommandResponse {
}

export interface DeleteToBeUsedInspection {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedInspectionId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToBeUsedInspectionId: string;
}

export interface CreateDocumentResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateDocument {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Document` |
     * | Type | `Siemens.SimaticIT.U4DM.MasterData.FB_MS_BOP.MSModel.Types.DocumentParameterType` |
     * | Nullable | `false` |
     */
    Document: DocumentParameterType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.String` |
     */
    CorrelationId: string | null;
}

export interface UADMUpdateMaterialDefinitionResponse extends CommandResponse {
}

export interface UADMUpdateMaterialDefinition {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Revision: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Name: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FirstArticleInspection` |
     * | Type | `Edm.Boolean` |
     */
    FirstArticleInspection: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SerialNumberProfile` |
     * | Type | `Edm.Boolean` |
     */
    SerialNumberProfile: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaxRecycleCount` |
     * | Type | `Edm.Int32` |
     */
    MaxRecycleCount: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MinQuantity` |
     * | Type | `Edm.Decimal` |
     */
    MinQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogisticParameterType` |
     * | Type | `Siemens.SimaticIT.U4DM.ReferenceData.FB_RD_SERV.RFModel.Types.LogisticParameterType` |
     * | Nullable | `false` |
     */
    LogisticParameterType: LogisticParameterType;
}

export interface UnLinkPJFToEquipmentSpecificationResponse extends CommandResponse {
}

export interface UnLinkPJFToEquipmentSpecification {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFile` |
     * | Type | `Edm.Guid` |
     */
    PrintJobFile: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFileExtId` |
     * | Type | `Edm.String` |
     */
    PrintJobFileExtId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFileName` |
     * | Type | `Edm.String` |
     */
    PrintJobFileName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFileSource` |
     * | Type | `Edm.String` |
     */
    PrintJobFileSource: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentSpecification` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    EquipmentSpecification: string;
}

export interface DeleteStatusResponse extends CommandResponse {
}

export interface DeleteStatus {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface UnlinkItlkCheckToOperationStepCategoryListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Edm.String` |
     */
    WarningMessage: string | null;
}

export interface UnlinkItlkCheckToOperationStepCategoryList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckOperationStepCategoryAssociationIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ItlkCheckOperationStepCategoryAssociationIdList: Array<string>;
}

export interface UpdateStatusBehaviorDefinitionResponse extends CommandResponse {
}

export interface UpdateStatusBehaviorDefinition {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
}

export interface UpdateItlkCheckToOperationToStepLinkListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Edm.String` |
     */
    WarningMessage: string | null;
}

export interface UpdateItlkCheckToOperationToStepLinkList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckOperationToStepLinkAssociationList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_ITLK.MSModel.Types.ItlkCheckOperationToStepLinkAssociationUpdateParameterType)` |
     * | Nullable | `false` |
     */
    ItlkCheckOperationToStepLinkAssociationList: Array<ItlkCheckOperationToStepLinkAssociationUpdateParameterType>;
}

export interface DeleteBufferDefinitionListResponse extends CommandResponse {
}

export interface DeleteBufferDefinitionList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface UnlinkATNInstanceParameterToSetPointItemListResponse extends CommandResponse {
}

export interface UnlinkATNInstanceParameterToSetPointItemList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointItemATNInstanceParameterAssociationList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    SetPointItemATNInstanceParameterAssociationList: Array<string>;
}

export interface StartUsingScrewingToolResponse extends CommandResponse {
}

export interface StartUsingScrewingTool {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutomationNodeInstanceNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    AutomationNodeInstanceNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActivatedOn` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ActivatedOn: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Status: string;
}

export interface DeleteToolListResponse extends CommandResponse {
}

export interface DeleteToolList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface LinkOperationStepCategoryToProcessDefinitionListResponse extends CommandResponse {
}

export interface LinkOperationStepCategoryToProcessDefinitionList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationStepCategory` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OperationStepCategory: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessDefinitionList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_BOP.MSModel.Types.ProcessDefinitionIdentifierParameterType)` |
     * | Nullable | `false` |
     */
    ProcessDefinitionList: Array<ProcessDefinitionIdentifierParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNIdList` |
     * | Type | `Collection(Edm.String)` |
     */
    EquipmentNIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DM_MaterialList: Array<string>;
}

export interface DeleteNonConformanceNotificationResponse extends CommandResponse {
}

export interface DeleteNonConformanceNotification {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NonConformanceNId: string;
}

export interface UpdateWOByBopResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOId` |
     * | Type | `Edm.Guid` |
     */
    WOId: string | null;
}

export interface UpdateWOByBop {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WODetailsForUpdate` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.WorkOrderDetailsForBoPUpdateParameterType` |
     * | Nullable | `false` |
     */
    WODetailsForUpdate: WorkOrderDetailsForBoPUpdateParameterType;
}

export interface DeleteTemplateToMaterialPlantListResponse extends CommandResponse {
}

export interface DeleteTemplateToMaterialPlantList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface UpdatePreferredWOOpDependencyNavigationResponse extends CommandResponse {
}

export interface UpdatePreferredWOOpDependencyNavigation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOpDependencyNavigation` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.WOOpDependencyNavigationParameterType)` |
     * | Nullable | `false` |
     */
    WOOpDependencyNavigation: Array<WOOpDependencyNavigationParameterType>;
}

export interface DeleteEquipmentLevelResponse extends CommandResponse {
}

export interface DeleteEquipmentLevel {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface RecycleAMPowderBatchResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AMPowderBatchStatus` |
     * | Type | `Edm.String` |
     */
    AMPowderBatchStatus: string | null;
}

export interface RecycleAMPowderBatch {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AMPowderBatchId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    AMPowderBatchId: string;
}

export interface GetDCDRuntimeWIToSaveByMachineResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    WorkOrderOperationIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    WorkOrderStepIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialId` |
     * | Type | `Edm.Guid` |
     */
    MaterialId: string | null;
}

export interface GetDCDRuntimeWIToSaveByMachine {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    WorkInstructionIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Category` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Category: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedMaterialItemList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ProductMaterialItem)` |
     * | Nullable | `false` |
     */
    ProducedMaterialItemList: Array<ProductMaterialItem>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentName` |
     * | Type | `Edm.String` |
     */
    EquipmentName: string | null;
}

export interface LinkMaterialItemsToHandlingUnitResponse extends CommandResponse {
}

export interface LinkMaterialItemsToHandlingUnit {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `HandlingUnitId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    HandlingUnitId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItemList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    MaterialItemList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
}

export interface SetOperationStepCategoryProcessDefinitionByMTUResponse extends CommandResponse {
}

export interface SetOperationStepCategoryProcessDefinitionByMTU {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    IdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ByMTU` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    ByMTU: boolean;
}

export interface UnlinkCharacteristicRepresentationToOperationResponse extends CommandResponse {
}

export interface UnlinkCharacteristicRepresentationToOperation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `InspectionSpecificationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    InspectionSpecificationId: string;
}

export interface LinkOperationToProcessResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface LinkOperationToProcess {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ProcessId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBopId` |
     * | Type | `Edm.Guid` |
     */
    AsPlannedBopId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     */
    Sequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EffectivityExpression` |
     * | Type | `Edm.String` |
     */
    EffectivityExpression: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     */
    CorrelationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlanId` |
     * | Type | `Edm.Guid` |
     */
    MasterPlanId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `InheritWIFromProcessOperation` |
     * | Type | `Edm.Boolean` |
     */
    InheritWIFromProcessOperation: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UId` |
     * | Type | `Edm.String` |
     */
    UId: string | null;
}

export interface TCM2LinkProcessToOperationListResponse extends CommandResponse {
}

export interface TCM2LinkProcessToOperationList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LinkList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_BOP.MSModel.Types.TCM2LinkParameterType)` |
     * | Nullable | `false` |
     */
    LinkList: Array<TCM2LinkParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     */
    CorrelationId: string | null;
}

export interface CreateWorkOrderAndMaterialItemHistoryResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderHistoryId` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.MaterialItemHistoryParameterType)` |
     */
    WorkOrderHistoryId: Array<MaterialItemHistoryParameterType>;
}

export interface CreateWorkOrderAndMaterialItemHistory {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrder` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrder: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    UserId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Date` |
     * | Type | `Edm.DateTimeOffset` |
     * | Nullable | `false` |
     */
    Date: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Action` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Action: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Context` |
     * | Type | `Edm.String` |
     */
    Context: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DNCItem` |
     * | Type | `Edm.String` |
     */
    DNCItem: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Document` |
     * | Type | `Edm.String` |
     */
    Document: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Equipment` |
     * | Type | `Edm.String` |
     */
    Equipment: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Message` |
     * | Type | `Edm.String` |
     */
    Message: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFile` |
     * | Type | `Edm.String` |
     */
    PrintJobFile: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessUId` |
     * | Type | `Edm.String` |
     */
    ProcessUId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItemList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.MaterialItemHistoryParameterType)` |
     */
    MaterialItemList: Array<MaterialItemHistoryParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupPhaseId` |
     * | Type | `Edm.Guid` |
     */
    ExecutionGroupPhaseId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStepId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReferencedWorkOrderHistory` |
     * | Type | `Edm.Guid` |
     */
    ReferencedWorkOrderHistory: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceWorkOrderNId` |
     * | Type | `Edm.String` |
     */
    SourceWorkOrderNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetWorkOrderNId` |
     * | Type | `Edm.String` |
     */
    TargetWorkOrderNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     */
    Status: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PartProgramName` |
     * | Type | `Edm.String` |
     */
    PartProgramName: string | null;
}

export interface ConsumeMaterialItemResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Collection(Edm.String)` |
     */
    WarningMessage: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStepId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualConsumedMaterialIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ActualConsumedMaterialIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnitHistoryIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DM_MaterialTrackingUnitHistoryIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SplitContextList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.SplitContext)` |
     */
    SplitContextList: Array<SplitContext>;
}

export interface ConsumeMaterialItem {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItemToConsumeList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.MaterialItemToConsumeParameterType)` |
     * | Nullable | `false` |
     */
    MaterialItemToConsumeList: Array<MaterialItemToConsumeParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStepId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FailAtFirstError` |
     * | Type | `Edm.Boolean` |
     */
    FailAtFirstError: boolean | null;
}

export interface CompleteWOOperationsSerializedLiteSingleWOResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessages` |
     * | Type | `Collection(Edm.String)` |
     */
    WarningMessages: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CompletedMaterialTrackingUnits` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.CompletedMTUParameterType)` |
     */
    CompletedMaterialTrackingUnits: Array<CompletedMTUParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CompletedWorkOrderOperations` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.WOOpSerializedLiteOutputParameterType)` |
     */
    CompletedWorkOrderOperations: Array<WOOpSerializedLiteOutputParameterType>;
}

export interface CompleteWOOperationsSerializedLiteSingleWO {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CompleteWOOpSerializedLiteParameters` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.CompleteWOOpSerializedLiteParameterType)` |
     * | Nullable | `false` |
     */
    CompleteWOOpSerializedLiteParameters: Array<CompleteWOOpSerializedLiteParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `User` |
     * | Type | `Edm.String` |
     */
    User: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PauseSerialNumbers` |
     * | Type | `Edm.Boolean` |
     */
    PauseSerialNumbers: boolean | null;
}

export interface DeleteEquipmentGraphConfigurationResponse extends CommandResponse {
}

export interface DeleteEquipmentGraphConfiguration {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface DeleteToBeUsedMachineResponse extends CommandResponse {
}

export interface DeleteToBeUsedMachine {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedMachineId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToBeUsedMachineId: string;
}

export interface UpdateResultListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResultIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ResultIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Collection(Edm.String)` |
     */
    WarningMessage: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UpdatedResultList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.FB_OP_Result.OPModel.Types.OnResultCreationParameterType)` |
     */
    UpdatedResultList: Array<OnResultCreationParameterType>;
}

export interface UpdateResultList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResultList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.FB_OP_Result.OPModel.Types.UpdateResultListParameterType)` |
     * | Nullable | `false` |
     */
    ResultList: Array<UpdateResultListParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActionNId` |
     * | Type | `Edm.String` |
     */
    ActionNId: string | null;
}

export interface LinkWorkInstructionsToWOOperationResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface LinkWorkInstructionsToWOOperation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionDefinitionIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    WorkInstructionDefinitionIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SerialNumbers` |
     * | Type | `Collection(Edm.String)` |
     */
    SerialNumbers: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsReEditEnabled` |
     * | Type | `Edm.Boolean` |
     */
    IsReEditEnabled: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LinkFromExecutionGroup` |
     * | Type | `Edm.Boolean` |
     */
    LinkFromExecutionGroup: boolean | null;
}

export interface LinkWOOperationListToExecutionGroupResponse extends CommandResponse {
}

export interface LinkWOOperationListToExecutionGroup {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ExecutionGroupId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupOperations` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ExecutionGroupOperationParameterType)` |
     * | Nullable | `false` |
     */
    ExecutionGroupOperations: Array<ExecutionGroupOperationParameterType>;
}

export interface SetWorkOrderForSchedulingResponse extends CommandResponse {
}

export interface SetWorkOrderForScheduling {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    UserId: string;
}

export interface UnLinkToBeUsedMachineToPartProgramResponse extends CommandResponse {
}

export interface UnLinkToBeUsedMachineToPartProgram {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PartProgram` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    PartProgram: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedMachine` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToBeUsedMachine: string;
}

export interface DeleteMasterPlanListResponse extends CommandResponse {
}

export interface DeleteMasterPlanList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface TCM2CreateOpDependencyListResponse extends CommandResponse {
}

export interface TCM2CreateOpDependencyList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationDependencyList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_BOP.MSModel.Types.TCM2OpDependencyParameterType)` |
     * | Nullable | `false` |
     */
    OperationDependencyList: Array<TCM2OpDependencyParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     */
    CorrelationId: string | null;
}

export interface DeleteNonConformanceStatusListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Edm.String` |
     */
    WarningMessage: string | null;
}

export interface DeleteNonConformanceStatusList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StatusIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    StatusIdList: Array<string>;
}

export interface TCM2AssociateDocumentToToolDefinitionListResponse extends CommandResponse {
}

export interface TCM2AssociateDocumentToToolDefinitionList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentAssociationList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_BOP.MSModel.Types.TCM2DocumentAssociationParameterType)` |
     * | Nullable | `false` |
     */
    DocumentAssociationList: Array<TCM2DocumentAssociationParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     */
    CorrelationId: string | null;
}

export interface LinkCharacteristicRepresentationToStepResponse extends CommandResponse {
}

export interface LinkCharacteristicRepresentationToStep {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CharacteristicRepresentationNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    CharacteristicRepresentationNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StepId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    StepId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBOPId` |
     * | Type | `Edm.Guid` |
     */
    AsPlannedBOPId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlanId` |
     * | Type | `Edm.Guid` |
     */
    MasterPlanId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CharacteristicRepresentationRevision` |
     * | Type | `Edm.String` |
     */
    CharacteristicRepresentationRevision: string | null;
}

export interface SetEquipmentStatusResponse extends CommandResponse {
}

export interface SetEquipmentStatus {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Verb` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Verb: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentStateMachineId` |
     * | Type | `Edm.Guid` |
     */
    EquipmentStateMachineId: string | null;
}

export interface UADMUpdateEquipmentSpecificationResponse extends CommandResponse {
}

export interface UADMUpdateEquipmentSpecification {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface CreateEquipmentSpecificationListResponse extends CommandResponse {
}

export interface CreateEquipmentSpecificationList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentSpecificationList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_BOP.MSModel.Types.EquipmentSpecificationParameterType)` |
     * | Nullable | `false` |
     */
    EquipmentSpecificationList: Array<EquipmentSpecificationParameterType>;
}

export interface DeleteMaterialDefinitionDocumentListResponse extends CommandResponse {
}

export interface DeleteMaterialDefinitionDocumentList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface DeleteDefectTypeListResponse extends CommandResponse {
}

export interface DeleteDefectTypeList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefectTypeIdentifiersList` |
     * | Type | `Collection(Siemens.SimaticIT.MasterData.MatTool.MSModel.Types.IdentifiersParameterType)` |
     * | Nullable | `false` |
     */
    DefectTypeIdentifiersList: Array<IdentifiersParameterType>;
}

export interface UpdateSubstrateTreatmentAndThicknessResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface UpdateSubstrateTreatmentAndThickness {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SubstrateId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    SubstrateId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsTreatment` |
     * | Type | `Edm.Boolean` |
     */
    IsTreatment: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsThicknessDecrease` |
     * | Type | `Edm.Boolean` |
     */
    IsThicknessDecrease: boolean | null;
}

export interface CreateMaterialAndDM_MaterialResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    DM_MaterialId: string;
}

export interface CreateMaterialAndDM_Material {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UId` |
     * | Type | `Edm.String` |
     */
    UId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoMNId` |
     * | Type | `Edm.String` |
     */
    UoMNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TemplateNId` |
     * | Type | `Edm.String` |
     */
    TemplateNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SerialNumberProfile` |
     * | Type | `Edm.Boolean` |
     */
    SerialNumberProfile: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FirstArticleInspection` |
     * | Type | `Edm.Boolean` |
     */
    FirstArticleInspection: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsPhantom` |
     * | Type | `Edm.Boolean` |
     */
    IsPhantom: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogisticClassNId` |
     * | Type | `Edm.String` |
     */
    LogisticClassNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Weight` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    Weight: QuantityParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Volume` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    Volume: QuantityParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.String` |
     */
    CorrelationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EffectivityExpression` |
     * | Type | `Edm.String` |
     */
    EffectivityExpression: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Traceble` |
     * | Type | `Edm.Boolean` |
     */
    Traceble: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AMPowderProperties` |
     * | Type | `Siemens.SimaticIT.UADM.MasterData.FB_MS_MAT.MSModel.Types.AMPowderPropertiesParameterType` |
     */
    AMPowderProperties: AMPowderPropertiesParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialClassId` |
     * | Type | `Edm.Guid` |
     */
    MaterialClassId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SupplierId` |
     * | Type | `Edm.Guid` |
     */
    SupplierId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FunctionalCodeId` |
     * | Type | `Edm.Guid` |
     */
    FunctionalCodeId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     */
    Revision: string | null;
}

export interface SetWorkOrderOperationFutureHoldResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationNId: string | null;
}

export interface SetWorkOrderOperationFutureHold {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FutureHoldDetails` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.HoldParamterType` |
     * | Nullable | `false` |
     */
    FutureHoldDetails: HoldParamterType;
}

export interface CreateWorkOrderFromMasterPlanWithQCResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface CreateWorkOrderFromMasterPlanWithQC {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Name: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     * | Nullable | `false` |
     */
    Quantity: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Plant` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Plant: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BatchId` |
     * | Type | `Edm.String` |
     */
    BatchId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DueDate` |
     * | Type | `Edm.DateTimeOffset` |
     */
    DueDate: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ERPOrder` |
     * | Type | `Edm.String` |
     */
    ERPOrder: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedStartTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedStartTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedEndTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedEndTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetProductId` |
     * | Type | `Edm.String` |
     */
    TargetProductId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FinalMaterialId` |
     * | Type | `Edm.Guid` |
     */
    FinalMaterialId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Priority` |
     * | Type | `Edm.Int32` |
     */
    Priority: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProductionTypeNId` |
     * | Type | `Edm.String` |
     */
    ProductionTypeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.String` |
     */
    CorrelationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ConfirmationType` |
     * | Type | `Edm.String` |
     */
    ConfirmationType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlanId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    MasterPlanId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BillOfFeatureNId` |
     * | Type | `Edm.String` |
     */
    BillOfFeatureNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BillOfFeatureRevision` |
     * | Type | `Edm.String` |
     */
    BillOfFeatureRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BoM` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.BoMParameterType` |
     */
    BoM: BoMParameterType | null;
}

export interface CreateStepDependencyListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface CreateStepDependencyList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StepDependencyList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_BOP.MSModel.Types.StepDependencyParameterType)` |
     * | Nullable | `false` |
     */
    StepDependencyList: Array<StepDependencyParameterType>;
}

export interface UpdateWorkOrderHistoryResponse extends CommandResponse {
}

export interface UpdateWorkOrderHistory {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Context` |
     * | Type | `Edm.String` |
     */
    Context: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Date` |
     * | Type | `Edm.DateTimeOffset` |
     */
    Date: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DNCItem` |
     * | Type | `Edm.String` |
     */
    DNCItem: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Document` |
     * | Type | `Edm.String` |
     */
    Document: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Equipment` |
     * | Type | `Edm.String` |
     */
    Equipment: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Message` |
     * | Type | `Edm.String` |
     */
    Message: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFile` |
     * | Type | `Edm.String` |
     */
    PrintJobFile: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessUId` |
     * | Type | `Edm.String` |
     */
    ProcessUId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserId` |
     * | Type | `Edm.String` |
     */
    UserId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface CreateMaterialClassResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialGroupId` |
     * | Type | `Edm.Guid` |
     */
    MaterialGroupId: string | null;
}

export interface CreateMaterialClass {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
}

export interface LinkUserToPlantResponse extends CommandResponse {
}

export interface LinkUserToPlant {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserId` |
     * | Type | `Edm.String` |
     */
    UserId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    EquipmentNId: string;
}

export interface GetToBeProducedMaterialsResultResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeProducedMaterialIdKoList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ToBeProducedMaterialIdKoList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnitIdKoList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DM_MaterialTrackingUnitIdKoList: Array<string>;
}

export interface GetToBeProducedMaterialsResult {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOpId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WOOpId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeProducedMaterialIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ToBeProducedMaterialIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnitIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DM_MaterialTrackingUnitIdList: Array<string>;
}

export interface CheckInCompleteWOOperationTransferBatchResponse extends CommandResponse {
}

export interface CheckInCompleteWOOperationTransferBatch {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CompleteWOOperationTransferBatchParameterType` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.CompleteWOOperationTransferBatchParameterType` |
     * | Nullable | `false` |
     */
    CompleteWOOperationTransferBatchParameterType: CompleteWOOperationTransferBatchParameterType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OfflineActionInternalId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OfflineActionInternalId: string;
}

export interface UpdateResultTypeListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResultTypeIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ResultTypeIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Collection(Edm.String)` |
     */
    WarningMessage: Array<string>;
}

export interface UpdateResultTypeList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResultTypeList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.FB_OP_Result.OPModel.Types.UpdateResultTypeParameterType)` |
     * | Nullable | `false` |
     */
    ResultTypeList: Array<UpdateResultTypeParameterType>;
}

export interface CompleteWOStepListResponse extends CommandResponse {
}

export interface CompleteWOStepList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepListDetails` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.IdentifiersParameterType)` |
     * | Nullable | `false` |
     */
    WorkOrderStepListDetails: Array<IdentifiersParameterType>;
}

export interface DeleteDocumentResponse extends CommandResponse {
}

export interface DeleteDocument {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface DeleteUoMFactorResponse extends CommandResponse {
}

export interface DeleteUoMFactor {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface DeleteNonConformanceSupervisorResponse extends CommandResponse {
}

export interface DeleteNonConformanceSupervisor {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface UpdateToBeUsedMachinePJFResponse extends CommandResponse {
}

export interface UpdateToBeUsedMachinePJF {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsSourcePJF` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsSourcePJF: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFile` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    PrintJobFile: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFileExternalId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    PrintJobFileExternalId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedMachineId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToBeUsedMachineId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFileName` |
     * | Type | `Edm.String` |
     */
    PrintJobFileName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFileSource` |
     * | Type | `Edm.String` |
     */
    PrintJobFileSource: string | null;
}

export interface DeleteWorkOrderHistoryMaterialItemResponse extends CommandResponse {
}

export interface DeleteWorkOrderHistoryMaterialItem {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface UADMCreateMaterialDefinitionResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface UADMCreateMaterialDefinition {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Revision: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Name: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FirstArticleInspection` |
     * | Type | `Edm.Boolean` |
     */
    FirstArticleInspection: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SerialNumberProfile` |
     * | Type | `Edm.Boolean` |
     */
    SerialNumberProfile: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UOM` |
     * | Type | `Edm.String` |
     */
    UOM: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialClassNId` |
     * | Type | `Edm.String` |
     */
    MaterialClassNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaxRecycleCount` |
     * | Type | `Edm.Int32` |
     */
    MaxRecycleCount: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MinQuantity` |
     * | Type | `Edm.Decimal` |
     */
    MinQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RevisionExpression` |
     * | Type | `Edm.String` |
     */
    RevisionExpression: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogisticParameterType` |
     * | Type | `Siemens.SimaticIT.U4DM.ReferenceData.FB_RD_SERV.RFModel.Types.LogisticParameterType` |
     */
    LogisticParameterType: LogisticParameterType | null;
}

export interface CompleteTaskAndWorkProcessListResponse extends CommandResponse {
}

export interface CompleteTaskAndWorkProcessList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CompleteTaskAndWorkProcessListParameter` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.FB_OP_DMTask.OPModel.Types.CompleteTaskAndWorkProcessListParameterType` |
     * | Nullable | `false` |
     */
    CompleteTaskAndWorkProcessListParameter: CompleteTaskAndWorkProcessListParameterType;
}

export interface LinkOfflineSessionToWorkOrderOperationListResponse extends CommandResponse {
}

export interface LinkOfflineSessionToWorkOrderOperationList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    WorkOrderOperationIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OfflineSessionIdFlag0` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    OfflineSessionIdFlag0: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OfflineSessionId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OfflineSessionId: string;
}

export interface DeleteOperationDependencyListResponse extends CommandResponse {
}

export interface DeleteOperationDependencyList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface UnlinkSubstrateToMachineResponse extends CommandResponse {
}

export interface UnlinkSubstrateToMachine {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SubstrateCompatibleMachineList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    SubstrateCompatibleMachineList: Array<string>;
}

export interface AutomaticConsumeMaterialItemResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualConsumedMaterial` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ActualConsumedMaterial: Array<string>;
}

export interface AutomaticConsumeMaterialItem {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentName` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    EquipmentName: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStepId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TimeStamp` |
     * | Type | `Edm.DateTimeOffset` |
     * | Nullable | `false` |
     */
    TimeStamp: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ConsumptionDetails` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.AutomaticConsumptionParameterType)` |
     * | Nullable | `false` |
     */
    ConsumptionDetails: Array<AutomaticConsumptionParameterType>;
}

export interface CreateWorkOperationTypeResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface CreateWorkOperationType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActiveOnlyOne` |
     * | Type | `Edm.Boolean` |
     */
    ActiveOnlyOne: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutoComplete` |
     * | Type | `Edm.Boolean` |
     */
    AutoComplete: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutoStart` |
     * | Type | `Edm.Boolean` |
     */
    AutoStart: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CNC` |
     * | Type | `Edm.Boolean` |
     */
    CNC: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MachineAutoComplete` |
     * | Type | `Edm.Boolean` |
     */
    MachineAutoComplete: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MachineAutoStart` |
     * | Type | `Edm.Boolean` |
     */
    MachineAutoStart: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MachineAutoPause` |
     * | Type | `Edm.Boolean` |
     */
    MachineAutoPause: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Milestone` |
     * | Type | `Edm.Boolean` |
     */
    Milestone: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Optional` |
     * | Type | `Edm.Boolean` |
     */
    Optional: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AM` |
     * | Type | `Edm.Boolean` |
     */
    AM: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Skippable` |
     * | Type | `Edm.Boolean` |
     */
    Skippable: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FastOperationConfirmation` |
     * | Type | `Edm.Boolean` |
     */
    FastOperationConfirmation: boolean | null;
}

export interface UADMCreateEquipmentSpecificationResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface UADMCreateEquipmentSpecification {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentSpecification` |
     * | Type | `Siemens.SimaticIT.U4DM.MasterData.FB_MS_BOP.MSModel.Types.EquipmentSpecificationParameterType` |
     * | Nullable | `false` |
     */
    EquipmentSpecification: EquipmentSpecificationParameterType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     */
    CorrelationId: string | null;
}

export interface RevertResultsStrategyResponse extends CommandResponse {
}

export interface RevertResultsStrategy {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResultList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.FB_OP_Result.OPModel.Types.RevertResultsStrategyParameterType)` |
     * | Nullable | `false` |
     */
    ResultList: Array<RevertResultsStrategyParameterType>;
}

export interface UpdateCharacteristicFailureAssociationResponse extends CommandResponse {
}

export interface UpdateCharacteristicFailureAssociation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface AutoGenerateMTUCodeResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutoGeneratedCode` |
     * | Type | `Edm.String` |
     */
    AutoGeneratedCode: string | null;
}

export interface AutoGenerateMTUCode {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    MaterialNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NumberingPatternNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NumberingPatternNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DestinationProperty` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    DestinationProperty: string;
}

export interface ExecuteItlkCheckOutboundResponse extends CommandResponse {
}

export interface ExecuteItlkCheckOutbound {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProductionTypeNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ProductionTypeNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ItlkCheckDM_MTUParameterType)` |
     */
    MaterialList: Array<ItlkCheckDM_MTUParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsAutomatic` |
     * | Type | `Edm.Boolean` |
     */
    IsAutomatic: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStepId: string | null;
}

export interface UpdateItlkCheckProcessToOpLinkAssociationListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Edm.String` |
     */
    WarningMessage: string | null;
}

export interface UpdateItlkCheckProcessToOpLinkAssociationList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckProcessToOpLinkAssociationList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_ITLK.MSModel.Types.ItlkCheckProcessToOpAssociationUpdateParameterType)` |
     * | Nullable | `false` |
     */
    ItlkCheckProcessToOpLinkAssociationList: Array<ItlkCheckProcessToOpAssociationUpdateParameterType>;
}

export interface UpdateSetPointItemResponse extends CommandResponse {
}

export interface UpdateSetPointItem {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Editable` |
     * | Type | `Edm.Boolean` |
     */
    Editable: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefaultValues` |
     * | Type | `Collection(Edm.String)` |
     */
    DefaultValues: Array<string>;
}

export interface ValidateMaterialCoProductionIsCompleteResponse extends CommandResponse {
}

export interface ValidateMaterialCoProductionIsComplete {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStepId: string | null;
}

export interface UnLinkMaterialItemsFromNonConformanceResponse extends CommandResponse {
}

export interface UnLinkMaterialItemsFromNonConformance {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    NonConformanceId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItemIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    MaterialItemIds: Array<string>;
}

export interface UnlinkAutomationNodeInstanceParameterFromDCItemListResponse extends CommandResponse {
}

export interface UnlinkAutomationNodeInstanceParameterFromDCItemList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutomationNodeInstanceWIDefinitionParameterIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    AutomationNodeInstanceWIDefinitionParameterIds: Array<string>;
}

export interface UnlinkWorkOrderHumanResourceResponse extends CommandResponse {
}

export interface UnlinkWorkOrderHumanResource {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CertificationNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    CertificationNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStepId: string | null;
}

export interface DeleteStatusTransitionDefinitionResponse extends CommandResponse {
}

export interface DeleteStatusTransitionDefinition {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface CreateSetPointResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateSetPoint {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Name: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
}

export interface DeleteBufferResponse extends CommandResponse {
}

export interface DeleteBuffer {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface AcceptChangeAddToBeConsumedMaterialResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceNId` |
     * | Type | `Edm.String` |
     */
    NonConformanceNId: string | null;
}

export interface AcceptChangeAddToBeConsumedMaterial {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChangePartId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ChangePartId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeConsumedMaterial` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ToBeConsumedMaterialParameter` |
     * | Nullable | `false` |
     */
    ToBeConsumedMaterial: ToBeConsumedMaterialParameter;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStepId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RefNumber` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    RefNumber: string;
}

export interface UADMCreateProcessInCatalogueResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface UADMCreateProcessInCatalogue {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Revision: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Plant` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Plant: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EffectivityExpression` |
     * | Type | `Edm.String` |
     */
    EffectivityExpression: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExtendedProperties` |
     * | Type | `Edm.String` |
     */
    ExtendedProperties: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FinalMaterialUID` |
     * | Type | `Edm.String` |
     */
    FinalMaterialUID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaxQuantity` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    MaxQuantity: QuantityParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MinQuantity` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    MinQuantity: QuantityParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UID` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    UID: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    Quantity: QuantityParameterType | null;
}

export interface DeleteWorkOrderResponse extends CommandResponse {
}

export interface DeleteWorkOrder {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface CreateOperationListResponse extends CommandResponse {
}

export interface CreateOperationList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_BOP.MSModel.Types.OperationParameterType)` |
     * | Nullable | `false` |
     */
    OperationList: Array<OperationParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    CorrelationId: string;
}

export interface UnLinkLogisticWhitelistResponse extends CommandResponse {
}

export interface UnLinkLogisticWhitelist {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogisticWhitelistElementList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    LogisticWhitelistElementList: Array<string>;
}

export interface CreateToBeUsedMachinePJFFromProcessResponse extends CommandResponse {
}

export interface CreateToBeUsedMachinePJFFromProcess {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessId` |
     * | Type | `Edm.Guid` |
     */
    ProcessId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedId` |
     * | Type | `Edm.Guid` |
     */
    AsPlannedId: string | null;
}

export interface DeleteActualUsedToolResponse extends CommandResponse {
}

export interface DeleteActualUsedTool {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface UnlinkSkillsFromProcessOperationResponse extends CommandResponse {
}

export interface UnlinkSkillsFromProcessOperation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationSkillIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    OperationSkillIds: Array<string>;
}

export interface CreateTemplateBlockResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateTemplateBlock {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BlockInfo` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.IdGenerate.OPModel.Types.IdTemplateBlockInfoParameterType` |
     * | Nullable | `false` |
     */
    BlockInfo: IdTemplateBlockInfoParameterType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BlockType` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    BlockType: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IdTemplate` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    IdTemplate: string;
}

export interface CreateActualUsedMachinePJFResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateActualUsedMachinePJF {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsSourcePJF` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsSourcePJF: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFile` |
     * | Type | `Edm.Guid` |
     */
    PrintJobFile: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFileExternalId` |
     * | Type | `Edm.String` |
     */
    PrintJobFileExternalId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualUsedMachineId` |
     * | Type | `Edm.Guid` |
     */
    ActualUsedMachineId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EG_PhaseId` |
     * | Type | `Edm.Guid` |
     */
    EG_PhaseId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFileName` |
     * | Type | `Edm.String` |
     */
    PrintJobFileName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFileSource` |
     * | Type | `Edm.String` |
     */
    PrintJobFileSource: string | null;
}

export interface UpdateTemplateBlockResponse extends CommandResponse {
}

export interface UpdateTemplateBlock {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BlockInfo` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.IdGenerate.OPModel.Types.IdTemplateBlockInfoParameterType` |
     * | Nullable | `false` |
     */
    BlockInfo: IdTemplateBlockInfoParameterType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface CreatePauseReasonResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreatePauseReason {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Location` |
     * | Type | `Edm.String` |
     */
    Location: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
}

export interface DeleteOperationResponse extends CommandResponse {
}

export interface DeleteOperation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface GetMaterialItemListForVerifyWorkOrderOperationResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItemForVerify` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.MaterialItemForVerify)` |
     */
    MaterialItemForVerify: Array<MaterialItemForVerify>;
}

export interface GetMaterialItemListForVerifyWorkOrderOperation {
}

export interface DeleteEquipmentConfigurationResponse extends CommandResponse {
}

export interface DeleteEquipmentConfiguration {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface UpdateNonProductiveActivityForUserResponse extends CommandResponse {
}

export interface UpdateNonProductiveActivityForUser {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserNPAId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    UserNPAId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NPAUserParameter` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.NPAUserParameterType` |
     * | Nullable | `false` |
     */
    NPAUserParameter: NPAUserParameterType;
}

export interface CreateNonConformanceStatusResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
}

export interface CreateNonConformanceStatus {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Name: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
}

export interface UpdateNonConformanceLifecycleResponse extends CommandResponse {
}

export interface UpdateNonConformanceLifecycle {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Name: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Type` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Type: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `InitialStatus` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    InitialStatus: string;
}

export interface CheckInCreateNonConformanceResponse extends CommandResponse {
}

export interface CheckInCreateNonConformance {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceProperties` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.NonConformancePropertyType` |
     * | Nullable | `false` |
     */
    NonConformanceProperties: NonConformancePropertyType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefectList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.DefectParameterType)` |
     */
    DefectList: Array<DefectParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChangeOperationProperties` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ChangeOperationParameterType` |
     */
    ChangeOperationProperties: ChangeOperationParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChangePartProperties` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ChangePartParameterType` |
     */
    ChangePartProperties: ChangePartParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChangeDataCollectionProperties` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ChangeDataCollectionParameterType` |
     */
    ChangeDataCollectionProperties: ChangeDataCollectionParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `QualityNonConformanceProperties` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.QualityNonConformancePropertiesType` |
     * | Nullable | `false` |
     */
    QualityNonConformanceProperties: QualityNonConformancePropertiesType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AttachmentList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.NonConformanceAttachmentParameterType)` |
     */
    AttachmentList: Array<NonConformanceAttachmentParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OfflineActionInternalId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OfflineActionInternalId: string;
}

export interface DeleteEquipmentGroupConfigurationResponse extends CommandResponse {
}

export interface DeleteEquipmentGroupConfiguration {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface RetrieveAllFilterQCDataResponse extends CommandResponse {
}

export interface RetrieveAllFilterQCData {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `QualifCriteriaList` |
     * | Type | `Collection(Siemens.OpcenterEX.AT.OperationalData.FB_OP_QC.OPModel.Types.QualificationCriteriaParameterType)` |
     * | Nullable | `false` |
     */
    QualifCriteriaList: Array<QualificationCriteriaParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Entities` |
     * | Type | `Collection(Edm.String)` |
     */
    Entities: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ErpOrderNId` |
     * | Type | `Edm.String` |
     */
    ErpOrderNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialInstanceNId` |
     * | Type | `Edm.String` |
     */
    MaterialInstanceNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FileIdContainerNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    FileIdContainerNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Context` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Context: string;
}

export interface DeleteSnagAndNoteNotificationListResponse extends CommandResponse {
}

export interface DeleteSnagAndNoteNotificationList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SnagAndNoteNotificationIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    SnagAndNoteNotificationIdList: Array<string>;
}

export interface DeleteStateMachineResponse extends CommandResponse {
}

export interface DeleteStateMachine {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface CopyToBeProducedFacetsResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PairFacetIds` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.CopyToBeProducedFacetsOutputParameterType)` |
     */
    PairFacetIds: Array<CopyToBeProducedFacetsOutputParameterType>;
}

export interface CopyToBeProducedFacets {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FacetIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    FacetIds: Array<string>;
}

export interface ChangeSetPointStatusResponse extends CommandResponse {
}

export interface ChangeSetPointStatus {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    SetPointId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StatusNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    StatusNId: string;
}

export interface ReleaseTransportOperationResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface ReleaseTransportOperation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TransportOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    TransportOperationId: string;
}

export interface UnlinkSkillsFromCertificateResponse extends CommandResponse {
}

export interface UnlinkSkillsFromCertificate {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SkillCertificationAssociationIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    SkillCertificationAssociationIds: Array<string>;
}

export interface CreateDefectTypeContextualizationResponse extends CommandResponse {
}

export interface CreateDefectTypeContextualization {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefectType` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    DefectType: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DM_MaterialList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationList` |
     * | Type | `Collection(Edm.String)` |
     */
    EquipmentConfigurationList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeList` |
     * | Type | `Collection(Edm.String)` |
     */
    EquipmentTypeList: Array<string>;
}

export interface UnlinkMachineDefinitionToSetPointResponse extends CommandResponse {
}

export interface UnlinkMachineDefinitionToSetPoint {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointMachineDefinitionList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    SetPointMachineDefinitionList: Array<string>;
}

export interface DeleteCharacteristicSpecificationResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NotDeletedIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    NotDeletedIds: Array<string>;
}

export interface DeleteCharacteristicSpecification {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface LinkSkillsToWorkOrderOperationResponse extends CommandResponse {
}

export interface LinkSkillsToWorkOrderOperation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SkillLevel` |
     * | Type | `Edm.Int32` |
     */
    SkillLevel: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SkillIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    SkillIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
}

export interface TCM2CreateOperationListResponse extends CommandResponse {
}

export interface TCM2CreateOperationList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_BOP.MSModel.Types.TCM2OperationParameterType)` |
     * | Nullable | `false` |
     */
    OperationList: Array<TCM2OperationParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     */
    CorrelationId: string | null;
}

export interface DeleteToolHistoryActionResponse extends CommandResponse {
}

export interface DeleteToolHistoryAction {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface Link3DPrinterToEquipmentResponse extends CommandResponse {
}

export interface Link3DPrinterToEquipment {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Link3DPrinterToEquipmentList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_AMMS.MSModel.Types.Link3DPrinterparameterType)` |
     * | Nullable | `false` |
     */
    Link3DPrinterToEquipmentList: Array<Link3DPrinterparameterType>;
}

export interface UpdateEquipmentConfigurationResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PropertyIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    PropertyIds: Array<string>;
}

export interface UpdateEquipmentConfiguration {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LevelNId` |
     * | Type | `Edm.String` |
     */
    LevelNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Properties` |
     * | Type | `Collection(Siemens.SimaticIT.MasterData.EQU_MS.MSModel.Types.PropertyParameterType)` |
     */
    Properties: Array<PropertyParameterType>;
}

export interface DeleteSnagAndNoteResponse extends CommandResponse {
}

export interface DeleteSnagAndNote {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface DeleteResultTypeListResponse extends CommandResponse {
}

export interface DeleteResultTypeList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResultIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ResultIdList: Array<string>;
}

export interface GenerateRuntimePrintJobFileResponse extends CommandResponse {
}

export interface GenerateRuntimePrintJobFile {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SerialNumberList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    SerialNumberList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFileId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    PrintJobFileId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PluginName` |
     * | Type | `Edm.String` |
     */
    PluginName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MachineId` |
     * | Type | `Edm.Guid` |
     */
    MachineId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualUsedMachineId` |
     * | Type | `Edm.Guid` |
     */
    ActualUsedMachineId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EG_PhaseId` |
     * | Type | `Edm.Guid` |
     */
    EG_PhaseId: string | null;
}

export interface UpdateNonConformanceResponse extends CommandResponse {
}

export interface UpdateNonConformance {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NonConformanceNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Severity` |
     * | Type | `Edm.String` |
     */
    Severity: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChangeOperationProperty` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ChangeOperationParameterType` |
     */
    ChangeOperationProperty: ChangeOperationParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     */
    Status: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChangeWorkInstructionProperty` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ChangeDataCollectionParameterType` |
     */
    ChangeWorkInstructionProperty: ChangeDataCollectionParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChangeRoutingProperty` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ChangeRoutingParameterType` |
     */
    ChangeRoutingProperty: ChangeRoutingParameterType | null;
}

export interface CreateWorkOrderOperationResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateWorkOrderOperation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.WorkOrderOperationParameter` |
     * | Nullable | `false` |
     */
    WorkOrderOperation: WorkOrderOperationParameter;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DependencyType` |
     * | Type | `Edm.String` |
     */
    DependencyType: string | null;
}

export interface CreateWorkOOperationDependenciesResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.String)` |
     */
    Ids: Array<string>;
}

export interface CreateWorkOOperationDependencies {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Dependencies` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.WorkOOperationDependencyParameter)` |
     * | Nullable | `false` |
     */
    Dependencies: Array<WorkOOperationDependencyParameter>;
}

export interface DeleteNonConformanceResponse extends CommandResponse {
}

export interface DeleteNonConformance {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface AcceptChangeRepeatOperationResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    WorkOrderOperationIds: Array<string>;
}

export interface AcceptChangeRepeatOperation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChangeDetails` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.RepeatOperationChangeParameter)` |
     * | Nullable | `false` |
     */
    ChangeDetails: Array<RepeatOperationChangeParameter>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AfterWorkOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    AfterWorkOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NonConformanceNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RefNumber` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    RefNumber: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CloseNotes` |
     * | Type | `Edm.String` |
     */
    CloseNotes: string | null;
}

export interface LinkPrintJobFileToMachineResponse extends CommandResponse {
}

export interface LinkPrintJobFileToMachine {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFileToMachine` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    PrintJobFileToMachine: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNIdList` |
     * | Type | `Collection(Edm.String)` |
     */
    EquipmentNIdList: Array<string>;
}

export interface LinkSkillsToTeamResponse extends CommandResponse {
}

export interface LinkSkillsToTeam {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SkillIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    SkillIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Level` |
     * | Type | `Edm.Int32` |
     */
    Level: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TeamId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    TeamId: string;
}

export interface LinkWorkInstructionsToContainerResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface LinkWorkInstructionsToContainer {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionDefinitionIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    WorkInstructionDefinitionIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContainerNIds` |
     * | Type | `Collection(Edm.String)` |
     */
    ContainerNIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStepId: string | null;
}

export interface UnlinkPartProgramFromEquipmentSpecificationResponse extends CommandResponse {
}

export interface UnlinkPartProgramFromEquipmentSpecification {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentSpecification` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    EquipmentSpecification: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PartProgram` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    PartProgram: string;
}

export interface CreateHoldReasonResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateHoldReason {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Type` |
     * | Type | `Edm.String` |
     */
    Type: string | null;
}

export interface DisassembleMaterialItemLiteResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DisassembledDMMTUIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DisassembledDMMTUIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DisassembledMaterialItemList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.DisassembledMaterialItemParameterType)` |
     */
    DisassembledMaterialItemList: Array<DisassembledMaterialItemParameterType>;
}

export interface DisassembleMaterialItemLite {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedDMMaterialTrackingUnitId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ProducedDMMaterialTrackingUnitId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `User` |
     * | Type | `Edm.String` |
     */
    User: string | null;
}

export interface StartWOStepFullQtyResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderHistoryId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderHistoryId: string | null;
}

export interface StartWOStepFullQty {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StartWOStepFullQtyParameter` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.StartWOStepFullQtyParameterType` |
     * | Nullable | `false` |
     */
    StartWOStepFullQtyParameter: StartWOStepFullQtyParameterType;
}

export interface UnlinkOperationDependencyToProcessResponse extends CommandResponse {
}

export interface UnlinkOperationDependencyToProcess {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationDependencyId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OperationDependencyId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ProcessId: string;
}

export interface UpdateWorkOStepDependencyResponse extends CommandResponse {
}

export interface UpdateWorkOStepDependency {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Dependency` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.WorkOStepDependencyParameter` |
     * | Nullable | `false` |
     */
    Dependency: WorkOStepDependencyParameter;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface CreateNonConformanceOnContainerContentResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceNId` |
     * | Type | `Edm.String` |
     */
    NonConformanceNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceHistoryIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    NonConformanceHistoryIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceId` |
     * | Type | `Edm.Guid` |
     */
    NonConformanceId: string | null;
}

export interface CreateNonConformanceOnContainerContent {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefectList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.DefectParameterType)` |
     */
    DefectList: Array<DefectParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContainerNidList` |
     * | Type | `Collection(Edm.String)` |
     */
    ContainerNidList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceProperties` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.NonConformancePropertyType` |
     * | Nullable | `false` |
     */
    NonConformanceProperties: NonConformancePropertyType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AttachmentList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.NonConformanceAttachmentParameterType)` |
     */
    AttachmentList: Array<NonConformanceAttachmentParameterType>;
}

export interface DeleteReworkCodeListResponse extends CommandResponse {
}

export interface DeleteReworkCodeList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UId` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    UId: Array<string>;
}

export interface UnlinkMaterialFromContainerTypeListResponse extends CommandResponse {
}

export interface UnlinkMaterialFromContainerTypeList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContainerTypeNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ContainerTypeNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CompatibleMaterialList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_Container.MSModel.Types.MaterialParameterType)` |
     * | Nullable | `false` |
     */
    CompatibleMaterialList: Array<MaterialParameterType>;
}

export interface CreateToBeUsedToolsResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface CreateToBeUsedTools {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedTools` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ToBeUsedToolParameter)` |
     * | Nullable | `false` |
     */
    ToBeUsedTools: Array<ToBeUsedToolParameter>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStepId: string | null;
}

export interface DiscardOfflineSessionListResponse extends CommandResponse {
}

export interface DiscardOfflineSessionList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OfflineSessionIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    OfflineSessionIds: Array<string>;
}

export interface LinkStepToOperationResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface LinkStepToOperation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StepId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    StepId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBopId` |
     * | Type | `Edm.Guid` |
     */
    AsPlannedBopId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     */
    Sequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlanId` |
     * | Type | `Edm.Guid` |
     */
    MasterPlanId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UId` |
     * | Type | `Edm.String` |
     */
    UId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     */
    CorrelationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EffectivityExpression` |
     * | Type | `Edm.String` |
     */
    EffectivityExpression: string | null;
}

export interface GetPJFsHookOnLinkToBeUsedMachineToPJFResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFileList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.FB_OP_AM.OPModel.Types.PJFIsSourceParameterType)` |
     */
    PrintJobFileList: Array<PJFIsSourceParameterType>;
}

export interface GetPJFsHookOnLinkToBeUsedMachineToPJF {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedMachineId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToBeUsedMachineId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFileList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.FB_OP_AM.OPModel.Types.PJFIsSourceParameterType)` |
     * | Nullable | `false` |
     */
    PrintJobFileList: Array<PJFIsSourceParameterType>;
}

export interface DeleteOperationStepCategoryListResponse extends CommandResponse {
}

export interface DeleteOperationStepCategoryList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface UseToolListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Edm.String` |
     */
    WarningMessage: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolHistoryIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ToolHistoryIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TimesOfToolUsage` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.TimesOfToolUsageParameterType)` |
     */
    TimesOfToolUsage: Array<TimesOfToolUsageParameterType>;
}

export interface UseToolList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolToBeUsedList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ToolToBeUsedOnSNParameterType)` |
     * | Nullable | `false` |
     */
    ToolToBeUsedList: Array<ToolToBeUsedOnSNParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderStepNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
}

export interface MixAMPowderBatchListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AMPowderBatchMixedId` |
     * | Type | `Edm.Guid` |
     */
    AMPowderBatchMixedId: string | null;
}

export interface MixAMPowderBatchList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AMPowderBatchList` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.AMPowderBatchMixParameterType` |
     * | Nullable | `false` |
     */
    AMPowderBatchList: AMPowderBatchMixParameterType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AMPowderBatchFake` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.AMPowderBatchFakeParameterType` |
     */
    AMPowderBatchFake: AMPowderBatchFakeParameterType | null;
}

export interface CreateBuyOffForActiveMTUsResponse extends CommandResponse {
}

export interface CreateBuyOffForActiveMTUs {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RuntimeCharReprNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    RuntimeCharReprNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetCodes` |
     * | Type | `Collection(Edm.String)` |
     */
    TargetCodes: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStepId: string | null;
}

export interface FilterInputResultsOnUndoRepeatWOOpStrategyResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `InputMTUsWithNoResultToSkip` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.CompletedMTUParameterType)` |
     */
    InputMTUsWithNoResultToSkip: Array<CompletedMTUParameterType>;
}

export interface FilterInputResultsOnUndoRepeatWOOpStrategy {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `InputMTUsWithNoResult` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.CompletedMTUParameterType)` |
     */
    InputMTUsWithNoResult: Array<CompletedMTUParameterType>;
}

export interface CompleteNonProductiveActivityListResponse extends CommandResponse {
}

export interface CompleteNonProductiveActivityList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserNPAIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    UserNPAIds: Array<string>;
}

export interface CreateNonConformanceV3_1Response extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceNId` |
     * | Type | `Edm.String` |
     */
    NonConformanceNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceHistoryIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    NonConformanceHistoryIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceId` |
     * | Type | `Edm.Guid` |
     */
    NonConformanceId: string | null;
}

export interface CreateNonConformanceV3_1 {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceProperties` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.NonConformancePropertyType` |
     * | Nullable | `false` |
     */
    NonConformanceProperties: NonConformancePropertyType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefectList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.DefectParameterType)` |
     */
    DefectList: Array<DefectParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChangeOperationProperties` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ChangeOperationParameterType` |
     */
    ChangeOperationProperties: ChangeOperationParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChangePartProperties` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ChangePartParameterType` |
     */
    ChangePartProperties: ChangePartParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChangeDataCollectionProperties` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ChangeDataCollectionParameterType` |
     */
    ChangeDataCollectionProperties: ChangeDataCollectionParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `QualityNonConformanceProperties` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.QualityNonConformancePropertiesType` |
     * | Nullable | `false` |
     */
    QualityNonConformanceProperties: QualityNonConformancePropertiesType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AttachmentList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.NonConformanceAttachmentParameterType)` |
     */
    AttachmentList: Array<NonConformanceAttachmentParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsAutomatic` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsAutomatic: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChangeToolProperties` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ChangeToolParameterType` |
     */
    ChangeToolProperties: ChangeToolParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChangeRoutingProperties` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ChangeRoutingParameterType` |
     */
    ChangeRoutingProperties: ChangeRoutingParameterType | null;
}

export interface CreateOperationStepCategoryResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateOperationStepCategory {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationStepCategory` |
     * | Type | `Siemens.SimaticIT.U4DM.MasterData.FB_MS_BOP.MSModel.Types.OperationStepCategoryType` |
     * | Nullable | `false` |
     */
    OperationStepCategory: OperationStepCategoryType;
}

export interface TCM2CompleteMasterPlanResponse extends CommandResponse {
}

export interface TCM2CompleteMasterPlan {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    CorrelationId: string;
}

export interface CreateStepListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Edm.String` |
     */
    WarningMessage: string | null;
}

export interface CreateStepList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Steps` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_BOP.MSModel.Types.StepCatalogueParameterType)` |
     * | Nullable | `false` |
     */
    Steps: Array<StepCatalogueParameterType>;
}

export interface GetToBeProducedMaterialsResultOpListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OpAndToBeProducedIdKoPairList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ToBeProducedIdAndOpId)` |
     */
    OpAndToBeProducedIdKoPairList: Array<ToBeProducedIdAndOpId>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OpAndDMMtuIdKoPairList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.DM_MTUIdAndOpId)` |
     */
    OpAndDMMtuIdKoPairList: Array<DM_MTUIdAndOpId>;
}

export interface GetToBeProducedMaterialsResultOpList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOpIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    WOOpIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OpAndToBeProducedIdPairList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ToBeProducedIdAndOpId)` |
     */
    OpAndToBeProducedIdPairList: Array<ToBeProducedIdAndOpId>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OpAndDMMtuIdPairList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.DM_MTUIdAndOpId)` |
     */
    OpAndDMMtuIdPairList: Array<DM_MTUIdAndOpId>;
}

export interface LinkWorkOrderHumanResourceResponse extends CommandResponse {
}

export interface LinkWorkOrderHumanResource {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CertificationNId` |
     * | Type | `Collection(Edm.String)` |
     */
    CertificationNId: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RequiredNumberOfHumanResource` |
     * | Type | `Collection(Edm.Int32)` |
     * | Nullable | `false` |
     */
    RequiredNumberOfHumanResource: Array<number>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStepId: string | null;
}

export interface CreateStatusBehaviorDefinitionResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StatusBehaviorDefinitionId` |
     * | Type | `Edm.Guid` |
     */
    StatusBehaviorDefinitionId: string | null;
}

export interface CreateStatusBehaviorDefinition {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
}

export interface UpdateAMPowderBatchResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AMPowderBatchStatus` |
     * | Type | `Edm.String` |
     */
    AMPowderBatchStatus: string | null;
}

export interface UpdateAMPowderBatch {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     * | Nullable | `false` |
     */
    Quantity: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RecycleCount` |
     * | Type | `Edm.Int32` |
     * | Nullable | `false` |
     */
    RecycleCount: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Status: string;
}

export interface SetNonConformanceStatusIsScrappedResponse extends CommandResponse {
}

export interface SetNonConformanceStatusIsScrapped {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceStatusId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    NonConformanceStatusId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceLifecycleId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    NonConformanceLifecycleId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsScrap` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsScrap: boolean;
}

export interface UpdateEquipmentConfigurationPropertyResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AttributeIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    AttributeIds: Array<string>;
}

export interface UpdateEquipmentConfigurationProperty {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PropertyValue` |
     * | Type | `Edm.String` |
     */
    PropertyValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Attributes` |
     * | Type | `Collection(Siemens.SimaticIT.MasterData.EQU_MS.MSModel.Types.PropertyParameterType)` |
     */
    Attributes: Array<PropertyParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Operational` |
     * | Type | `Edm.Boolean` |
     */
    Operational: boolean | null;
}

export interface DeleteCharacteristicFailureAssociationResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NotDeletedIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    NotDeletedIds: Array<string>;
}

export interface DeleteCharacteristicFailureAssociation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface UnlinkDocumentToStepResponse extends CommandResponse {
}

export interface UnlinkDocumentToStep {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    DocumentId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StepId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    StepId: string;
}

export interface CreateActualUsedMachineResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateActualUsedMachine {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MachineNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    MachineNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PartProgram` |
     * | Type | `Edm.String` |
     */
    PartProgram: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedMachineId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToBeUsedMachineId: string;
}

export interface UpdateCustomItlkCheckParameterListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ListOfItlkCheckParameterId` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ListOfItlkCheckParameterId: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Edm.String` |
     */
    WarningMessage: string | null;
}

export interface UpdateCustomItlkCheckParameterList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ListOfItlkCheckParameter` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_ITLK.MSModel.Types.CustomItlkCheckParamParameterType)` |
     * | Nullable | `false` |
     */
    ListOfItlkCheckParameter: Array<CustomItlkCheckParamParameterType>;
}

export interface CreateNonConformanceDefectListResponse extends CommandResponse {
}

export interface CreateNonConformanceDefectList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    NonConformanceId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefectList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.DefectParameterType)` |
     * | Nullable | `false` |
     */
    DefectList: Array<DefectParameterType>;
}

export interface CreateWorkOrderStepsResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface CreateWorkOrderSteps {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderSteps` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.WorkOrderOperationParameter)` |
     * | Nullable | `false` |
     */
    WorkOrderSteps: Array<WorkOrderOperationParameter>;
}

export interface CreateMaterialResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialId` |
     * | Type | `Edm.Guid` |
     */
    MaterialId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PropertyIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    PropertyIds: Array<string>;
}

export interface CreateMaterial {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UId` |
     * | Type | `Edm.String` |
     */
    UId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Revision: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TemplateNId` |
     * | Type | `Edm.String` |
     */
    TemplateNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoMNId` |
     * | Type | `Edm.String` |
     */
    UoMNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UseDefault` |
     * | Type | `Edm.Boolean` |
     */
    UseDefault: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Properties` |
     * | Type | `Collection(Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.PropertyParameterTypeCreate)` |
     */
    Properties: Array<PropertyParameterTypeCreate>;
}

export interface CreateProcessResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateProcess {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Process` |
     * | Type | `Siemens.SimaticIT.U4DM.MasterData.FB_MS_BOP.MSModel.Types.ProcessParameterType` |
     * | Nullable | `false` |
     */
    Process: ProcessParameterType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.String` |
     */
    CorrelationId: string | null;
}

export interface LinkMaterialSpecificationToOperationResponse extends CommandResponse {
}

export interface LinkMaterialSpecificationToOperation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialSpecificationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    MaterialSpecificationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OperationId: string;
}

export interface RemoveWorkOrderHoldResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderNId: string | null;
}

export interface RemoveWorkOrderHold {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `HoldId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    HoldId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Comment` |
     * | Type | `Edm.String` |
     */
    Comment: string | null;
}

export interface AcquireToolFromAutomationNodeInstanceParameterResponse extends CommandResponse {
}

export interface AcquireToolFromAutomationNodeInstanceParameter {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    EquipmentNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolsToBeAcquireParameterType` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.FB_OP_AGWInt.OPModel.Types.ToolToBeAcquireParameterType)` |
     * | Nullable | `false` |
     */
    ToolsToBeAcquireParameterType: Array<ToolToBeAcquireParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderStepNId: string | null;
}

export interface UpdateNonConformanceStatusResponse extends CommandResponse {
}

export interface UpdateNonConformanceStatus {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Name: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Description: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface GetWorkOrderOperationIdToStartByMachineResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderProductionType` |
     * | Type | `Edm.String` |
     */
    WorkOrderProductionType: string | null;
}

export interface GetWorkOrderOperationIdToStartByMachine {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentName` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    EquipmentName: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Category` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Category: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedMaterialItemList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ProducedMaterialItemParameterType)` |
     * | Nullable | `false` |
     */
    ProducedMaterialItemList: Array<ProducedMaterialItemParameterType>;
}

export interface LinkHumanResourceToProcessResponse extends CommandResponse {
}

export interface LinkHumanResourceToProcess {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ParentId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CertificationNId` |
     * | Type | `Collection(Edm.String)` |
     */
    CertificationNId: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RequiredNumberOfHumanResource` |
     * | Type | `Collection(Edm.Int32)` |
     * | Nullable | `false` |
     */
    RequiredNumberOfHumanResource: Array<number>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentIndicator` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ParentIndicator: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBoPId` |
     * | Type | `Edm.Guid` |
     */
    AsPlannedBoPId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlanId` |
     * | Type | `Edm.Guid` |
     */
    MasterPlanId: string | null;
}

export interface StartWOStepSerializedResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderHistoryId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderHistoryId: string | null;
}

export interface StartWOStepSerialized {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StartWOStepSerializedParameter` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.StartWOStepSerializedParameterType` |
     * | Nullable | `false` |
     */
    StartWOStepSerializedParameter: StartWOStepSerializedParameterType;
}

export interface CreateResultHistoryListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResultHistoryIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ResultHistoryIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Collection(Edm.String)` |
     */
    WarningMessage: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResultHistoryInfo` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.FB_OP_Result.OPModel.Types.ResultHistoryParamType)` |
     */
    ResultHistoryInfo: Array<ResultHistoryParamType>;
}

export interface CreateResultHistoryList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResultHistoryList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.FB_OP_Result.OPModel.Types.CreateResultHistoryListParameterType)` |
     * | Nullable | `false` |
     */
    ResultHistoryList: Array<CreateResultHistoryListParameterType>;
}

export interface UpdateExecutionGroupPhaseResponse extends CommandResponse {
}

export interface UpdateExecutionGroupPhase {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupPhaseId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ExecutionGroupPhaseId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedStartTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedStartTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedEndTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedEndTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedDuration` |
     * | Type | `Edm.Duration` |
     */
    EstimatedDuration: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PreferredMachineNId` |
     * | Type | `Edm.String` |
     */
    PreferredMachineNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCollectedDocument` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCollectedDocument: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupPhaseName` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ExecutionGroupPhaseName: string;
}

export interface CreateToBeProducedMaterialResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateToBeProducedMaterial {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     * | Nullable | `false` |
     */
    Quantity: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItemId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    MaterialItemId: string;
}

export interface CreateToolHistoryResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateToolHistory {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Date` |
     * | Type | `Edm.DateTimeOffset` |
     */
    Date: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Equipment` |
     * | Type | `Edm.String` |
     */
    Equipment: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OldThickness` |
     * | Type | `Edm.Decimal` |
     */
    OldThickness: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OldTreatmentCount` |
     * | Type | `Edm.Int32` |
     */
    OldTreatmentCount: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Thickness` |
     * | Type | `Edm.Decimal` |
     */
    Thickness: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TreatmentCount` |
     * | Type | `Edm.Int32` |
     */
    TreatmentCount: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    UserId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UsedToolCount` |
     * | Type | `Edm.Decimal` |
     * | Nullable | `false` |
     */
    UsedToolCount: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `HistoryAction` |
     * | Type | `Edm.Guid` |
     */
    HistoryAction: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UsageDuration` |
     * | Type | `Edm.Duration` |
     */
    UsageDuration: string | null;
}

export interface TransmitToolSetPointItemToAutomationNodeParameterListResponse extends CommandResponse {
}

export interface TransmitToolSetPointItemToAutomationNodeParameterList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolHistoryId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToolHistoryId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointItemsToBeTransmitted` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.SetPointParameterType` |
     * | Nullable | `false` |
     */
    SetPointItemsToBeTransmitted: SetPointParameterType;
}

export interface CreateCharacteristicRepresentationResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateCharacteristicRepresentation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CharacteristicSpecificationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    CharacteristicSpecificationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SampleSize` |
     * | Type | `Edm.Int32` |
     * | Nullable | `false` |
     */
    SampleSize: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CanBeSkipped` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    CanBeSkipped: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ScenarioNId` |
     * | Type | `Edm.String` |
     */
    ScenarioNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     */
    Revision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CharacteristicRepresentationFrequencyId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    CharacteristicRepresentationFrequencyId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CharacteristicRepresentationFrequencyValue` |
     * | Type | `Edm.Decimal` |
     */
    CharacteristicRepresentationFrequencyValue: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TimeBasedScheduleMode` |
     * | Type | `Edm.String` |
     */
    TimeBasedScheduleMode: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TimeBasedMandatoryInspectionWarningValue` |
     * | Type | `Edm.Int32` |
     */
    TimeBasedMandatoryInspectionWarningValue: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TimeBasedMandatoryInspectionWarningUoMNId` |
     * | Type | `Siemens.SimaticIT.MasterData.CHR_MS.MSModel.Types.TimeBasedUoM` |
     */
    TimeBasedMandatoryInspectionWarningUoMNId: TimeBasedUoM | null;
}

export interface CreateBoMV4_0Response extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateBoMV4_0 {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Version` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Version: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Priority` |
     * | Type | `Edm.Int32` |
     */
    Priority: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     * | Nullable | `false` |
     */
    Quantity: QuantityParameterType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ValidFrom` |
     * | Type | `Edm.DateTimeOffset` |
     */
    ValidFrom: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ValidTo` |
     * | Type | `Edm.DateTimeOffset` |
     */
    ValidTo: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialProperties` |
     * | Type | `Siemens.SimaticIT.UADM.MasterData.FB_MS_MAT.MSModel.Types.DM_MaterialParameterType` |
     */
    MaterialProperties: DM_MaterialParameterType | null;
}

export interface GetCurrentUserRolesResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `roles` |
     * | Type | `Collection(Edm.String)` |
     */
    roles: Array<string>;
}

export interface GetCurrentUserRoles {
}

export interface CreateWOOpDependencyNavigationListResponse extends CommandResponse {
}

export interface CreateWOOpDependencyNavigationList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOpDependencyNavigation` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.WOOpDependencyNavigationParameterType)` |
     * | Nullable | `false` |
     */
    WOOpDependencyNavigation: Array<WOOpDependencyNavigationParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderId: string;
}

export interface CreateActualProducedMaterialResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateActualProducedMaterial {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CompletedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    CompletedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Equipment` |
     * | Type | `Edm.String` |
     */
    Equipment: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NotWorkedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    NotWorkedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PartialWorkedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    PartialWorkedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PausedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    PausedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReopenedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    ReopenedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ScrappedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    ScrappedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SentencedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    SentencedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SplitQuantity` |
     * | Type | `Edm.Decimal` |
     */
    SplitQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    UserId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperation: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItem` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    MaterialItem: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeProducedMaterialId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToBeProducedMaterialId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupPhaseId` |
     * | Type | `Edm.Guid` |
     */
    ExecutionGroupPhaseId: string | null;
}

export interface CloseWorkProcessResponse extends CommandResponse {
}

export interface CloseWorkProcess {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkProcessId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkProcessId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActionNId` |
     * | Type | `Edm.String` |
     */
    ActionNId: string | null;
}

export interface GetEquipSpecWithPJFHookResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipSpecWithPjfList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.FB_OP_AM.OPModel.Types.EquipSpecWithPjf)` |
     */
    EquipSpecWithPjfList: Array<EquipSpecWithPjf>;
}

export interface GetEquipSpecWithPJFHook {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperatonIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    OperatonIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBoPId` |
     * | Type | `Edm.Guid` |
     */
    AsPlannedBoPId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlanId` |
     * | Type | `Edm.Guid` |
     */
    MasterPlanId: string | null;
}

export interface TCM2AssociateDocumentToMaterialDefinitionListResponse extends CommandResponse {
}

export interface TCM2AssociateDocumentToMaterialDefinitionList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentAssociationList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_BOP.MSModel.Types.TCM2DocumentAssociationParameterType)` |
     * | Nullable | `false` |
     */
    DocumentAssociationList: Array<TCM2DocumentAssociationParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     */
    CorrelationId: string | null;
}

export interface DeleteOperationDependencyResponse extends CommandResponse {
}

export interface DeleteOperationDependency {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface DeleteWorkOrderOperationResponse extends CommandResponse {
}

export interface DeleteWorkOrderOperation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface EditSkillToOperationListResponse extends CommandResponse {
}

export interface EditSkillToOperationList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationSkillIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    OperationSkillIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Level` |
     * | Type | `Edm.Int32` |
     */
    Level: number | null;
}

export interface LinkEquipmentsToBuffersResponse extends CommandResponse {
}

export interface LinkEquipmentsToBuffers {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BufferIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    BufferIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNIds` |
     * | Type | `Collection(Edm.String)` |
     */
    EquipmentNIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Priority` |
     * | Type | `Edm.Int32` |
     */
    Priority: number | null;
}

export interface CreateTemplateResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateTemplate {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IdTemplateType` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    IdTemplateType: string;
}

export interface CreateToolDefinitionDocumentListResponse extends CommandResponse {
}

export interface CreateToolDefinitionDocumentList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolDefinitionDocumentList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_BOP.MSModel.Types.ToolDefinitionDocumentParameterType)` |
     * | Nullable | `false` |
     */
    ToolDefinitionDocumentList: Array<ToolDefinitionDocumentParameterType>;
}

export interface LinkDocumentToContainerTypeListResponse extends CommandResponse {
}

export interface LinkDocumentToContainerTypeList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContainerTypeNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ContainerTypeNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DocumentIdList: Array<string>;
}

export interface DeleteDM_MaterialTrackingUnitHistoryActionResponse extends CommandResponse {
}

export interface DeleteDM_MaterialTrackingUnitHistoryAction {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface SentenceNonConformancePartiallyResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReworkOrderId` |
     * | Type | `Edm.Guid` |
     */
    ReworkOrderId: string | null;
}

export interface SentenceNonConformancePartially {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NonConformanceNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceStatusNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NonConformanceStatusNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DocumentIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NewWorkOrderList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.NewWorkOrderForSplit)` |
     * | Nullable | `false` |
     */
    NewWorkOrderList: Array<NewWorkOrderForSplit>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReworkProcessId` |
     * | Type | `Edm.Guid` |
     */
    ReworkProcessId: string | null;
}

export interface DeleteFunctionalCodeListV4_0Response extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Edm.String` |
     */
    WarningMessage: string | null;
}

export interface DeleteFunctionalCodeListV4_0 {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FunctionalCodeIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    FunctionalCodeIds: Array<string>;
}

export interface CheckInCompleteWOStepTransferBatchResponse extends CommandResponse {
}

export interface CheckInCompleteWOStepTransferBatch {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OfflineActionInternalId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OfflineActionInternalId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CompleteWOStepTransferBatchParameter` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.CompleteWOStepTransferBatchParameterType` |
     * | Nullable | `false` |
     */
    CompleteWOStepTransferBatchParameter: CompleteWOStepTransferBatchParameterType;
}

export interface CreateNewMaterialDefinitionRevisionResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateNewMaterialDefinitionRevision {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OriginalId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OriginalId: string;
}

export interface UpdateNonConformanceStatusBehaviorResponse extends CommandResponse {
}

export interface UpdateNonConformanceStatusBehavior {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceLifecycleId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    NonConformanceLifecycleId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceStatusId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    NonConformanceStatusId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsClosedOk` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsClosedOk: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsRuntimeFrozen` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsRuntimeFrozen: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsScrap` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsScrap: boolean;
}

export interface UnlinkSkillsToWorkOrderStepResponse extends CommandResponse {
}

export interface UnlinkSkillsToWorkOrderStep {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepSkillIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    WorkOrderStepSkillIds: Array<string>;
}

export interface LinkBufferDefinitionToLogisticClassListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    IdList: Array<string>;
}

export interface LinkBufferDefinitionToLogisticClassList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BufferDefinitionId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    BufferDefinitionId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogisticClassList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    LogisticClassList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Min` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    Min: QuantityParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Max` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    Max: QuantityParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Threshold` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    Threshold: QuantityParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Target` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    Target: QuantityParameterType | null;
}

export interface AbortWorkOrderResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderIdentifiers` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.WorkOrderIdentifiersParameterType` |
     */
    WorkOrderIdentifiers: WorkOrderIdentifiersParameterType | null;
}

export interface AbortWorkOrder {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderIdentifiers` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.WorkOrderIdentifiersParameterType` |
     * | Nullable | `false` |
     */
    WorkOrderIdentifiers: WorkOrderIdentifiersParameterType;
}

export interface DeleteNonConformanceLifecycleListResponse extends CommandResponse {
}

export interface DeleteNonConformanceLifecycleList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LifecycleIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    LifecycleIdList: Array<string>;
}

export interface DeleteTemplateBlocksResponse extends CommandResponse {
}

export interface DeleteTemplateBlocks {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface GetProcessWithoutOperationsListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_BOP.MSModel.Types.ProcessInfoParameterType)` |
     */
    ProcessList: Array<ProcessInfoParameterType>;
}

export interface GetProcessWithoutOperationsList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBopId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    AsPlannedBopId: string;
}

export interface DeleteToolHistoryResponse extends CommandResponse {
}

export interface DeleteToolHistory {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolHistoryId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToolHistoryId: string;
}

export interface CreateHandlingUnitResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateHandlingUnit {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LocationNId` |
     * | Type | `Edm.String` |
     */
    LocationNId: string | null;
}

export interface CreateActualConsumedMaterialResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateActualConsumedMaterial {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItemAssembledQty` |
     * | Type | `Edm.Decimal` |
     * | Nullable | `false` |
     */
    MaterialItemAssembledQty: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItem` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    MaterialItem: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeConsumedMaterial` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToBeConsumedMaterial: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedMaterialItem` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ProducedMaterialItem: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperation: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStep` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStep: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupPhase` |
     * | Type | `Edm.Guid` |
     */
    ExecutionGroupPhase: string | null;
}

export interface TCM2CreateEquipmentSpecificationListResponse extends CommandResponse {
}

export interface TCM2CreateEquipmentSpecificationList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentSpecificationList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_BOP.MSModel.Types.TCM2EquipmentSpecificationParameterType)` |
     * | Nullable | `false` |
     */
    EquipmentSpecificationList: Array<TCM2EquipmentSpecificationParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     */
    CorrelationId: string | null;
}

export interface CreateNewProcessRevisionInCatalogueResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateNewProcessRevisionInCatalogue {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceProcessId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    SourceProcessId: string;
}

export interface UnlinkAutomationNodeInstanceParameterFromToolDefinitionParameterListResponse extends CommandResponse {
}

export interface UnlinkAutomationNodeInstanceParameterFromToolDefinitionParameterList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolDefinitionAutomationNodeInstanceParameterAssociationList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ToolDefinitionAutomationNodeInstanceParameterAssociationList: Array<string>;
}

export interface RemoveEquipmentPreferencesForUserResponse extends CommandResponse {
}

export interface RemoveEquipmentPreferencesForUser {
}

export interface DeleteEquipmentSpecificationListResponse extends CommandResponse {
}

export interface DeleteEquipmentSpecificationList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface StartContainerResponse extends CommandResponse {
}

export interface StartContainer {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContainerNIdList` |
     * | Type | `Collection(Edm.String)` |
     */
    ContainerNIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.SetPointParameterType)` |
     */
    SetPointList: Array<SetPointParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStepId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MTUIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DM_MTUIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
}

export interface CreateOperationDependencyListResponse extends CommandResponse {
}

export interface CreateOperationDependencyList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationDependencyList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_BOP.MSModel.Types.OperationDependencyParameterType)` |
     * | Nullable | `false` |
     */
    OperationDependencyList: Array<OperationDependencyParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.String` |
     */
    CorrelationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBOPId` |
     * | Type | `Edm.Guid` |
     */
    AsPlannedBOPId: string | null;
}

export interface LinkEquipmentSpecificationToOperationResponse extends CommandResponse {
}

export interface LinkEquipmentSpecificationToOperation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentSpecificationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    EquipmentSpecificationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OperationId: string;
}

export interface UploadDocumentsResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UploadedFileIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    UploadedFileIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NotUploadedFileIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    NotUploadedFileIds: Array<string>;
}

export interface UploadDocuments {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FileIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    FileIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProjectName` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ProjectName: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FolderName` |
     * | Type | `Edm.String` |
     */
    FolderName: string | null;
}

export interface EditWorkOrderResponse extends CommandResponse {
}

export interface EditWorkOrder {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedStartTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedStartTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedEndTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedEndTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DueDate` |
     * | Type | `Edm.DateTimeOffset` |
     */
    DueDate: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `InitialQuantity` |
     * | Type | `Edm.Decimal` |
     */
    InitialQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Plant` |
     * | Type | `Edm.String` |
     */
    Plant: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Priority` |
     * | Type | `Edm.Int32` |
     */
    Priority: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ERPOrder` |
     * | Type | `Edm.String` |
     */
    ERPOrder: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualStartTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    ActualStartTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualEndTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    ActualEndTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentBatch` |
     * | Type | `Edm.String` |
     */
    ParentBatch: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FinalMaterialId` |
     * | Type | `Edm.Guid` |
     */
    FinalMaterialId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BatchId` |
     * | Type | `Edm.String` |
     */
    BatchId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProductionTypeNId` |
     * | Type | `Edm.String` |
     */
    ProductionTypeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PlannedTargetQuantity` |
     * | Type | `Edm.Decimal` |
     */
    PlannedTargetQuantity: number | null;
}

export interface CompleteTransportOperationResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CompleteTransportOperation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TransportOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    TransportOperationId: string;
}

export interface RegisterNonProductiveActivityForUserResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface RegisterNonProductiveActivityForUser {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NPAId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    NPAId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NPAUserParameter` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.NPAUserParameterType` |
     * | Nullable | `false` |
     */
    NPAUserParameter: NPAUserParameterType;
}

export interface GetUserDetailsListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UsersDataList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.UserDetailsParameterType)` |
     */
    UsersDataList: Array<UserDetailsParameterType>;
}

export interface GetUserDetailsList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.UserDetailsParameterType)` |
     */
    UserList: Array<UserDetailsParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    EquipmentNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ApplyPCDFilter` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    ApplyPCDFilter: boolean;
}

export interface UpdateActualProducedMaterialResponse extends CommandResponse {
}

export interface UpdateActualProducedMaterial {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CompletedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    CompletedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NotWorkedQuantiyty` |
     * | Type | `Edm.Decimal` |
     */
    NotWorkedQuantiyty: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PartialWorkedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    PartialWorkedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PausedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    PausedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReopenedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    ReopenedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ScrappedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    ScrappedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SentencedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    SentencedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SplitQuantity` |
     * | Type | `Edm.Decimal` |
     */
    SplitQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserId` |
     * | Type | `Edm.String` |
     */
    UserId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeProducedMaterialId` |
     * | Type | `Edm.Guid` |
     */
    ToBeProducedMaterialId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupPhaseId` |
     * | Type | `Edm.Guid` |
     */
    ExecutionGroupPhaseId: string | null;
}

export interface DeleteNonConformanceTransitionListResponse extends CommandResponse {
}

export interface DeleteNonConformanceTransitionList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TransitionIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    TransitionIdList: Array<string>;
}

export interface DeleteEquipmentTypePropertyAttributeResponse extends CommandResponse {
}

export interface DeleteEquipmentTypePropertyAttribute {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface UpdateStatusTransitionResponse extends CommandResponse {
}

export interface UpdateStatusTransition {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DoRaiseEvent` |
     * | Type | `Edm.Boolean` |
     */
    DoRaiseEvent: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetStatusId` |
     * | Type | `Edm.Guid` |
     */
    TargetStatusId: string | null;
}

export interface CreateReworkOrderResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReworkOrderId` |
     * | Type | `Edm.Guid` |
     */
    ReworkOrderId: string | null;
}

export interface CreateReworkOrder {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ProcessId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItemList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.MaterialItemParameterType)` |
     */
    MaterialItemList: Array<MaterialItemParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PartialQuantity` |
     * | Type | `Edm.Decimal` |
     */
    PartialQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CompletedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    CompletedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBOP_Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    AsPlannedBOP_Id: string;
}

export interface EvolveAsPlannedBOPResponse extends CommandResponse {
}

export interface EvolveAsPlannedBOP {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceAsPlannedBOPId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    SourceAsPlannedBOPId: string;
}

export interface GetActiveUserListOnWorkOrderOperationResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserIds` |
     * | Type | `Collection(Edm.String)` |
     */
    UserIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsUserActive` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsUserActive: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNIds` |
     * | Type | `Collection(Edm.String)` |
     */
    EquipmentNIds: Array<string>;
}

export interface GetActiveUserListOnWorkOrderOperation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserId` |
     * | Type | `Edm.String` |
     */
    UserId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkOrderOperationNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationId: string | null;
}

export interface CreateNonConformanceHistoryResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateNonConformanceHistory {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Date` |
     * | Type | `Edm.DateTimeOffset` |
     * | Nullable | `false` |
     */
    Date: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformance` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    NonConformance: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Status: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Transition` |
     * | Type | `Edm.String` |
     */
    Transition: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserId` |
     * | Type | `Edm.String` |
     */
    UserId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Attachments` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Attachments: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Resource` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Resource: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Action` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Action: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Severity` |
     * | Type | `Edm.String` |
     */
    Severity: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PreviousSeverity` |
     * | Type | `Edm.String` |
     */
    PreviousSeverity: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolId` |
     * | Type | `Edm.Guid` |
     */
    ToolId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefectId` |
     * | Type | `Edm.Guid` |
     */
    DefectId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItemId` |
     * | Type | `Edm.Guid` |
     */
    MaterialItemId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FailureNId` |
     * | Type | `Edm.String` |
     */
    FailureNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReasonNId` |
     * | Type | `Edm.String` |
     */
    ReasonNId: string | null;
}

export interface UADMAutomaticCompleteResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionContextData` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.WOOpExecutionParameterType` |
     */
    ExecutionContextData: WOOpExecutionParameterType | null;
}

export interface UADMAutomaticComplete {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentName` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    EquipmentName: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Category` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Category: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProductMaterialItemList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ProductMaterialItem)` |
     * | Nullable | `false` |
     */
    ProductMaterialItemList: Array<ProductMaterialItem>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualEndTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    ActualEndTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AvoidPausingOtherSerialNos` |
     * | Type | `Edm.Boolean` |
     */
    AvoidPausingOtherSerialNos: boolean | null;
}

export interface DeleteStepListResponse extends CommandResponse {
}

export interface DeleteStepList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface CreateFunctionalCodeResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialGroupId` |
     * | Type | `Edm.Guid` |
     */
    MaterialGroupId: string | null;
}

export interface CreateFunctionalCode {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
}

export interface UpdateAMPowderBatchGenealogyResponse extends CommandResponse {
}

export interface UpdateAMPowderBatchGenealogy {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnit` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    DM_MaterialTrackingUnit: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MixedQuantity` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    MixedQuantity: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OldQuantity` |
     * | Type | `Edm.Decimal` |
     * | Nullable | `false` |
     */
    OldQuantity: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     * | Nullable | `false` |
     */
    Quantity: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RecycleCount` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    RecycleCount: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Code` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Code: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CodeType` |
     * | Type | `Siemens.SimaticIT.OperationalData.MAT_OP.OPModel.Types.MTUCodeType` |
     * | Nullable | `false` |
     */
    CodeType: MTUCodeType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceCode` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    SourceCode: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetCode` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    TargetCode: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Status: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    UserId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrder` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrder: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperation: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStep` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderStep: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Date` |
     * | Type | `Edm.DateTimeOffset` |
     * | Nullable | `false` |
     */
    Date: string;
}

export interface DeleteDefectResponse extends CommandResponse {
}

export interface DeleteDefect {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface InEditingWorkInstructionResponse extends CommandResponse {
}

export interface InEditingWorkInstruction {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface LinkToBeUsedMachineToPartProgramResponse extends CommandResponse {
}

export interface LinkToBeUsedMachineToPartProgram {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PartProgram` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    PartProgram: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedMachine` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToBeUsedMachine: string;
}

export interface CreateActiveUserOnMachineResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateActiveUserOnMachine {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperation: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupPhaseId` |
     * | Type | `Edm.Guid` |
     */
    ExecutionGroupPhaseId: string | null;
}

export interface UpdateEquipmentSpecificationResponse extends CommandResponse {
}

export interface UpdateEquipmentSpecification {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PartProgram` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    PartProgram: string;
}

export interface UnlinkHumanResourceFromProcessResponse extends CommandResponse {
}

export interface UnlinkHumanResourceFromProcess {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ParentId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CertificationNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    CertificationNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentIndicator` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ParentIndicator: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBoPId` |
     * | Type | `Edm.Guid` |
     */
    AsPlannedBoPId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlanId` |
     * | Type | `Edm.Guid` |
     */
    MasterPlanId: string | null;
}

export interface PauseContainerResponse extends CommandResponse {
}

export interface PauseContainer {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContainerNIdList` |
     * | Type | `Collection(Edm.String)` |
     */
    ContainerNIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PauseWOOperationParameterType` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.PauseWOOperationParameterType` |
     * | Nullable | `false` |
     */
    PauseWOOperationParameterType: PauseWOOperationParameterType;
}

export interface UnlinkOperationToProcessResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OutputProcessId` |
     * | Type | `Edm.Guid` |
     */
    OutputProcessId: string | null;
}

export interface UnlinkOperationToProcess {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ProcessId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBOPId` |
     * | Type | `Edm.Guid` |
     */
    AsPlannedBOPId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlanId` |
     * | Type | `Edm.Guid` |
     */
    MasterPlanId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     */
    Sequence: number | null;
}

export interface CreateToolDefinitionDocumentResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateToolDefinitionDocument {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolDefinitionId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToolDefinitionId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    DocumentId: string;
}

export interface DeleteSupplierListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Edm.String` |
     */
    WarningMessage: string | null;
}

export interface DeleteSupplierList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SupplierIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    SupplierIds: Array<string>;
}

export interface CreateDefectResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface CreateDefect {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefectType` |
     * | Type | `Edm.Guid` |
     */
    DefectType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformance` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    NonConformance: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `GroupPath` |
     * | Type | `Edm.String` |
     */
    GroupPath: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FailureNId` |
     * | Type | `Edm.String` |
     */
    FailureNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Date` |
     * | Type | `Edm.DateTimeOffset` |
     */
    Date: string | null;
}

export interface CreateEquipmentGraphNodeConfigurationResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateEquipmentGraphNodeConfiguration {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGraphConfigurationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    EquipmentGraphConfigurationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationNId` |
     * | Type | `Edm.String` |
     */
    EquipmentConfigurationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGroupConfigurationNId` |
     * | Type | `Edm.String` |
     */
    EquipmentGroupConfigurationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OffsetX` |
     * | Type | `Edm.Int32` |
     */
    OffsetX: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OffsetY` |
     * | Type | `Edm.Int32` |
     */
    OffsetY: number | null;
}

export interface SetDefectGroupPathResponse extends CommandResponse {
}

export interface SetDefectGroupPath {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceGroupPaths` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.NonConformanceGroupPathParameterType)` |
     * | Nullable | `false` |
     */
    NonConformanceGroupPaths: Array<NonConformanceGroupPathParameterType>;
}

export interface LinkToolToAutomationNodeInstanceListResponse extends CommandResponse {
}

export interface LinkToolToAutomationNodeInstanceList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToolId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutomationNodeInstanceNIdList` |
     * | Type | `Collection(Edm.String)` |
     */
    AutomationNodeInstanceNIdList: Array<string>;
}

export interface GetNonConformanceTransitionRoleMailListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AuthorizedRoleList` |
     * | Type | `Collection(Edm.String)` |
     */
    AuthorizedRoleList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MailAddressList` |
     * | Type | `Collection(Edm.String)` |
     */
    MailAddressList: Array<string>;
}

export interface GetNonConformanceTransitionRoleMailList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformaceTransitionId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    NonConformaceTransitionId: string;
}

export interface ValidateMaterialConsumptionIsCompleteResponse extends CommandResponse {
}

export interface ValidateMaterialConsumptionIsComplete {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStepId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MTUIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DM_MTUIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TotalQuantity` |
     * | Type | `Edm.Decimal` |
     */
    TotalQuantity: number | null;
}

export interface UpdateDNCItemResponse extends CommandResponse {
}

export interface UpdateDNCItem {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DNCItemId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    DNCItemId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DNCId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    DNCId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Name: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Released` |
     * | Type | `Edm.Boolean` |
     */
    Released: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Trialcut` |
     * | Type | `Edm.Boolean` |
     */
    Trialcut: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Type` |
     * | Type | `Edm.String` |
     */
    Type: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Version` |
     * | Type | `Edm.String` |
     */
    Version: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DNCExternalId` |
     * | Type | `Edm.String` |
     */
    DNCExternalId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CanBeTransferred` |
     * | Type | `Edm.Boolean` |
     */
    CanBeTransferred: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CanBePreviewed` |
     * | Type | `Edm.Boolean` |
     */
    CanBePreviewed: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     */
    Status: string | null;
}

export interface CreateToolResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateTool {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolDefinitionId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToolDefinitionId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UsageCounter` |
     * | Type | `Edm.Int32` |
     */
    UsageCounter: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SubstrateProperties` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.SubstratePropertiesParameterType` |
     */
    SubstrateProperties: SubstratePropertiesParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UsageCounterMax` |
     * | Type | `Edm.Int32` |
     */
    UsageCounterMax: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UsageDuration` |
     * | Type | `Edm.Duration` |
     */
    UsageDuration: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UsageDurationMax` |
     * | Type | `Edm.Duration` |
     */
    UsageDurationMax: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExpirationDate` |
     * | Type | `Edm.DateTimeOffset` |
     */
    ExpirationDate: string | null;
}

export interface UnlinkEquipmentToSetPointResponse extends CommandResponse {
}

export interface UnlinkEquipmentToSetPoint {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointEquipmentList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    SetPointEquipmentList: Array<string>;
}

export interface CreateBoMResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateBoM {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Version` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Version: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Priority` |
     * | Type | `Edm.Int32` |
     */
    Priority: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     * | Nullable | `false` |
     */
    Quantity: QuantityParameterType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ValidFrom` |
     * | Type | `Edm.DateTimeOffset` |
     */
    ValidFrom: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ValidTo` |
     * | Type | `Edm.DateTimeOffset` |
     */
    ValidTo: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialDefinition` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    MaterialDefinition: string;
}

export interface UpdateEquipmentGraphLinkConfigurationResponse extends CommandResponse {
}

export interface UpdateEquipmentGraphLinkConfiguration {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceEquipmentGraphNodeConfigurationId` |
     * | Type | `Edm.Guid` |
     */
    SourceEquipmentGraphNodeConfigurationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DestinationEquipmentGraphNodeConfigurationId` |
     * | Type | `Edm.Guid` |
     */
    DestinationEquipmentGraphNodeConfigurationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Label` |
     * | Type | `Edm.String` |
     */
    Label: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourcePosition` |
     * | Type | `Edm.String` |
     */
    SourcePosition: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DestinationPosition` |
     * | Type | `Edm.String` |
     */
    DestinationPosition: string | null;
}

export interface CreateWorkOrderHistoryResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderHistoryId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderHistoryId: string | null;
}

export interface CreateWorkOrderHistory {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrder` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrder: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    UserId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Date` |
     * | Type | `Edm.DateTimeOffset` |
     * | Nullable | `false` |
     */
    Date: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Action` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Action: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Context` |
     * | Type | `Edm.String` |
     */
    Context: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DNCItem` |
     * | Type | `Edm.String` |
     */
    DNCItem: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Document` |
     * | Type | `Edm.String` |
     */
    Document: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Equipment` |
     * | Type | `Edm.String` |
     */
    Equipment: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Message` |
     * | Type | `Edm.String` |
     */
    Message: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFile` |
     * | Type | `Edm.String` |
     */
    PrintJobFile: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessUId` |
     * | Type | `Edm.String` |
     */
    ProcessUId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SerialNumber` |
     * | Type | `Edm.String` |
     */
    SerialNumber: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupPhaseId` |
     * | Type | `Edm.Guid` |
     */
    ExecutionGroupPhaseId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStepId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReferencedWorkOrderHistory` |
     * | Type | `Edm.Guid` |
     */
    ReferencedWorkOrderHistory: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceWorkOrderNId` |
     * | Type | `Edm.String` |
     */
    SourceWorkOrderNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetWorkOrderNId` |
     * | Type | `Edm.String` |
     */
    TargetWorkOrderNId: string | null;
}

export interface UpdateEquipmentGraphTypeResponse extends CommandResponse {
}

export interface UpdateEquipmentGraphType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
}

export interface ChangeBoMStatusResponse extends CommandResponse {
}

export interface ChangeBoMStatus {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BoMId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    BoMId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StatusNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    StatusNId: string;
}

export interface ExecuteItlkCheckInboundResponse extends CommandResponse {
}

export interface ExecuteItlkCheckInbound {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProductionTypeNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ProductionTypeNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ItlkCheckDM_MTUParameterType)` |
     */
    MaterialList: Array<ItlkCheckDM_MTUParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStepId: string | null;
}

export interface ConsumeMaterialItemOnExecutionGroupResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualConsumedMaterialIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ActualConsumedMaterialIdList: Array<string>;
}

export interface ConsumeMaterialItemOnExecutionGroup {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupPhaseId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ExecutionGroupPhaseId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialToBeConsumedList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.MaterialToBeConsumed)` |
     * | Nullable | `false` |
     */
    MaterialToBeConsumedList: Array<MaterialToBeConsumed>;
}

export interface DeleteOperationListResponse extends CommandResponse {
}

export interface DeleteOperationList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface CopyWorkInstructionDefinitionRevisionResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionDefinitionId` |
     * | Type | `Edm.Guid` |
     */
    WorkInstructionDefinitionId: string | null;
}

export interface CopyWorkInstructionDefinitionRevision {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    SourceNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceRevision` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    SourceRevision: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    TargetNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetRevision` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    TargetRevision: string;
}

export interface RemoveWorkOrderOperationFutureHoldResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationNId: string | null;
}

export interface RemoveWorkOrderOperationFutureHold {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FutureHoldId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    FutureHoldId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Comment` |
     * | Type | `Edm.String` |
     */
    Comment: string | null;
}

export interface LinkEquipmentToSetPointResponse extends CommandResponse {
}

export interface LinkEquipmentToSetPoint {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    SetPointId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentList` |
     * | Type | `Collection(Edm.String)` |
     */
    EquipmentList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsDefault` |
     * | Type | `Edm.Boolean` |
     */
    IsDefault: boolean | null;
}

export interface UpdateHierarchyEquipmentNodeConfigurationResponse extends CommandResponse {
}

export interface UpdateHierarchyEquipmentNodeConfiguration {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentEquipmentGraphNodeConfigurationId` |
     * | Type | `Edm.Guid` |
     */
    ParentEquipmentGraphNodeConfigurationId: string | null;
}

export interface CreateStatusResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StatusId` |
     * | Type | `Edm.Guid` |
     */
    StatusId: string | null;
}

export interface CreateStatus {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StatusDefinitionId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    StatusDefinitionId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StateMachineId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    StateMachineId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsInitial` |
     * | Type | `Edm.Boolean` |
     */
    IsInitial: boolean | null;
}

export interface LinkSubstrateDefinitionToMachineResponse extends CommandResponse {
}

export interface LinkSubstrateDefinitionToMachine {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SubstrateId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    SubstrateId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MachineList` |
     * | Type | `Collection(Edm.String)` |
     */
    MachineList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeList` |
     * | Type | `Collection(Edm.String)` |
     */
    EquipmentTypeList: Array<string>;
}

export interface DeleteCustomItlkCheckListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Edm.String` |
     */
    WarningMessage: string | null;
}

export interface DeleteCustomItlkCheckList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ListOfItlkCheckId` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ListOfItlkCheckId: Array<string>;
}

export interface EditHumanResourceToProcessResponse extends CommandResponse {
}

export interface EditHumanResourceToProcess {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CertificationNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    CertificationNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RequiredNumberOfHumanResource` |
     * | Type | `Edm.Int32` |
     * | Nullable | `false` |
     */
    RequiredNumberOfHumanResource: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentIndicator` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ParentIndicator: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ParentId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBOPId` |
     * | Type | `Edm.Guid` |
     */
    AsPlannedBOPId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlanId` |
     * | Type | `Edm.Guid` |
     */
    MasterPlanId: string | null;
}

export interface FilterWorkOrderOperationListByCheckCertificationResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ValidWorkOrderOperationNIdList` |
     * | Type | `Collection(Edm.String)` |
     */
    ValidWorkOrderOperationNIdList: Array<string>;
}

export interface FilterWorkOrderOperationListByCheckCertification {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    WorkOrderOperationIdList: Array<string>;
}

export interface CreateNewStepRevisionResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateNewStepRevision {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceStepId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    SourceStepId: string;
}

export interface DeleteEquipmentTypePropertyResponse extends CommandResponse {
}

export interface DeleteEquipmentTypeProperty {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface UnlinkMaterialSpecificationToOperationResponse extends CommandResponse {
}

export interface UnlinkMaterialSpecificationToOperation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialSpecificationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    MaterialSpecificationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OperationId: string;
}

export interface CreateWorkOrderOperationFromProcessOperationResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateWorkOrderOperationFromProcessOperation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.WorkOrderOperationFromOperationParameter` |
     * | Nullable | `false` |
     */
    WorkOrderOperation: WorkOrderOperationFromOperationParameter;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DependencyType` |
     * | Type | `Edm.String` |
     */
    DependencyType: string | null;
}

export interface UpdateCustomItlkCheckListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ListOfItlkCheckId` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ListOfItlkCheckId: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Edm.String` |
     */
    WarningMessage: string | null;
}

export interface UpdateCustomItlkCheckList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ListOfItlkCheck` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_ITLK.MSModel.Types.CustomItlkCheckParameterType)` |
     * | Nullable | `false` |
     */
    ListOfItlkCheck: Array<CustomItlkCheckParameterType>;
}

export interface CreateToolHistoryActionResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateToolHistoryAction {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
}

export interface UpdateVariableCharacteristicSpecificationResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FailureAssociationIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    FailureAssociationIds: Array<string>;
}

export interface UpdateVariableCharacteristicSpecification {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Context` |
     * | Type | `Siemens.SimaticIT.MasterData.CHR_MS.MSModel.Types.CharacteristicContext` |
     */
    Context: CharacteristicContext | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Criticality` |
     * | Type | `Edm.String` |
     */
    Criticality: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NominalValue` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    NominalValue: QuantityParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UpperTolerance` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    UpperTolerance: QuantityParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LowerTolerance` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    LowerTolerance: QuantityParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FailureAssociations` |
     * | Type | `Collection(Siemens.SimaticIT.MasterData.CHR_MS.MSModel.Types.CharacteristicFailureAssociation)` |
     */
    FailureAssociations: Array<CharacteristicFailureAssociation>;
}

export interface UpdateWorkOrderStepResponse extends CommandResponse {
}

export interface UpdateWorkOrderStep {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderSteps` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.WorkOrderOperationParameter)` |
     * | Nullable | `false` |
     */
    WorkOrderSteps: Array<WorkOrderOperationParameter>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface CreateEquipmentGroupConfigurationResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateEquipmentGroupConfiguration {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Category` |
     * | Type | `Edm.String` |
     */
    Category: string | null;
}

export interface UnlinkDocumentListToOperationResponse extends CommandResponse {
}

export interface UnlinkDocumentListToOperation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ListOfDocumentId` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ListOfDocumentId: Array<string>;
}

export interface UnlinkEquipmentSpecificationToOperationResponse extends CommandResponse {
}

export interface UnlinkEquipmentSpecificationToOperation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentSpecificationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    EquipmentSpecificationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OperationId: string;
}

export interface DeleteToolDefinitionsResponse extends CommandResponse {
}

export interface DeleteToolDefinitions {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface CreateDM_MaterialTrackingUnitResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnitId` |
     * | Type | `Edm.Guid` |
     */
    DM_MaterialTrackingUnitId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnitHistoryIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DM_MaterialTrackingUnitHistoryIdList: Array<string>;
}

export interface CreateDM_MaterialTrackingUnit {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialTrackingUnitId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    MaterialTrackingUnitId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsReserved` |
     * | Type | `Edm.Boolean` |
     */
    IsReserved: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Weight` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    Weight: QuantityParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Volume` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    Volume: QuantityParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActiveNonConformanceNumber` |
     * | Type | `Edm.Int32` |
     */
    ActiveNonConformanceNumber: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BufferNId` |
     * | Type | `Edm.String` |
     */
    BufferNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AMPowderProperties` |
     * | Type | `Siemens.SimaticIT.UADM.OperationalData.FB_OP_MAT.OPModel.Types.AMPowderPropertiesParameterType` |
     */
    AMPowderProperties: AMPowderPropertiesParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    DM_MaterialId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentDM_MTUId` |
     * | Type | `Edm.Guid` |
     */
    ParentDM_MTUId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsCalledFromSplitOfMTU` |
     * | Type | `Edm.Boolean` |
     */
    IsCalledFromSplitOfMTU: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Date` |
     * | Type | `Edm.DateTimeOffset` |
     */
    Date: string | null;
}

export interface SetWorkInstructionDefinitionRevisionCurrentResponse extends CommandResponse {
}

export interface SetWorkInstructionDefinitionRevisionCurrent {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface CreateExecutionGroupResponse extends CommandResponse {
}

export interface CreateExecutionGroup {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedStartTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedStartTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedEndTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedEndTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedDuration` |
     * | Type | `Edm.Duration` |
     */
    EstimatedDuration: string | null;
}

export interface MergeWOHeaderWithProcessResponse extends CommandResponse {
}

export interface MergeWOHeaderWithProcess {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MergeWOProcessParameters` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.WOHeaderParameterType` |
     * | Nullable | `false` |
     */
    MergeWOProcessParameters: WOHeaderParameterType;
}

export interface CheckInStartWOOperationSerializedResponse extends CommandResponse {
}

export interface CheckInStartWOOperationSerialized {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StartWOOperationSerializedParameterType` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.StartWOOperationSerializedParameterType` |
     * | Nullable | `false` |
     */
    StartWOOperationSerializedParameterType: StartWOOperationSerializedParameterType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OfflineActionInternalId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OfflineActionInternalId: string;
}

export interface DeleteProcessFromCatalogueResponse extends CommandResponse {
}

export interface DeleteProcessFromCatalogue {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface BeginIdTemplateEditingResponse extends CommandResponse {
}

export interface BeginIdTemplateEditing {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TemplateId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    TemplateId: string;
}

export interface UpdateEquipmentGraphConfigurationResponse extends CommandResponse {
}

export interface UpdateEquipmentGraphConfiguration {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
}

export interface CreateDNCItemResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DNCItemId` |
     * | Type | `Edm.Guid` |
     */
    DNCItemId: string | null;
}

export interface CreateDNCItem {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DNCId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    DNCId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Name: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Released` |
     * | Type | `Edm.Boolean` |
     */
    Released: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Trialcut` |
     * | Type | `Edm.Boolean` |
     */
    Trialcut: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Type` |
     * | Type | `Edm.String` |
     */
    Type: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Version` |
     * | Type | `Edm.String` |
     */
    Version: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentId` |
     * | Type | `Edm.Guid` |
     */
    ParentId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DNCExternalId` |
     * | Type | `Edm.String` |
     */
    DNCExternalId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CanBeTransferred` |
     * | Type | `Edm.Boolean` |
     */
    CanBeTransferred: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CanBePreviewed` |
     * | Type | `Edm.Boolean` |
     */
    CanBePreviewed: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     */
    Status: string | null;
}

export interface CheckInUseToolListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Edm.String` |
     */
    WarningMessage: string | null;
}

export interface CheckInUseToolList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OfflineActionInternalId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OfflineActionInternalId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolToBeUsedList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ToolToBeUsedOnSNParameterType)` |
     * | Nullable | `false` |
     */
    ToolToBeUsedList: Array<ToolToBeUsedOnSNParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderStepNId: string | null;
}

export interface DeleteWorkInstructionTemplateParameterResponse extends CommandResponse {
}

export interface DeleteWorkInstructionTemplateParameter {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IdFlag0` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IdFlag0: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface GetWorkOrderOperationNIdToCompleteByMachineResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderProductionType` |
     * | Type | `Edm.String` |
     */
    WorkOrderProductionType: string | null;
}

export interface GetWorkOrderOperationNIdToCompleteByMachine {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentName` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    EquipmentName: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Category` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Category: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProductMaterialItemList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ProductMaterialItem)` |
     * | Nullable | `false` |
     */
    ProductMaterialItemList: Array<ProductMaterialItem>;
}

export interface TCM2CreateAsPlannedBOPResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface TCM2CreateAsPlannedBOP {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBOP` |
     * | Type | `Siemens.SimaticIT.U4DM.MasterData.FB_MS_BOP.MSModel.Types.TCM2AsPlannedBOPParameterType` |
     * | Nullable | `false` |
     */
    AsPlannedBOP: TCM2AsPlannedBOPParameterType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.String` |
     */
    CorrelationId: string | null;
}

export interface VerifyWorkOrderResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItemIdentifiers` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.MaterialItemIdentifiersParameterType` |
     */
    MaterialItemIdentifiers: MaterialItemIdentifiersParameterType | null;
}

export interface VerifyWorkOrder {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItemIdentifiers` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.MaterialItemIdentifiersParameterType` |
     * | Nullable | `false` |
     */
    MaterialItemIdentifiers: MaterialItemIdentifiersParameterType;
}

export interface ReopenWorkOrderOperationSerializedResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderIdentifiers` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.IdentifiersParameterType` |
     */
    WorkOrderIdentifiers: IdentifiersParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationIdentifiers` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.IdentifiersParameterType` |
     */
    WorkOrderOperationIdentifiers: IdentifiersParameterType | null;
}

export interface ReopenWorkOrderOperationSerialized {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderIdentifiers` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.IdentifiersParameterType` |
     * | Nullable | `false` |
     */
    WorkOrderIdentifiers: IdentifiersParameterType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationIdentifiers` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.IdentifiersParameterType` |
     * | Nullable | `false` |
     */
    WorkOrderOperationIdentifiers: IdentifiersParameterType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SerialNumberToReopenList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.MaterialItemParameterType)` |
     * | Nullable | `false` |
     */
    SerialNumberToReopenList: Array<MaterialItemParameterType>;
}

export interface GetProductionProcessFromAsPlannedResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ProcessIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessWithoutPlantFound` |
     * | Type | `Edm.Boolean` |
     */
    ProcessWithoutPlantFound: boolean | null;
}

export interface GetProductionProcessFromAsPlanned {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BaselineUId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    BaselineUId: string;
}

export interface DeleteNonConformanceHistoryResponse extends CommandResponse {
}

export interface DeleteNonConformanceHistory {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface AcceptChangeAddOperationResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceNId` |
     * | Type | `Edm.String` |
     */
    NonConformanceNId: string | null;
}

export interface AcceptChangeAddOperation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChangeOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ChangeOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationName` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkOrderOperationName: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedMachine` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ToBeUsedMachineParameter` |
     * | Nullable | `false` |
     */
    ToBeUsedMachine: ToBeUsedMachineParameter;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AfterSequence` |
     * | Type | `Edm.Int32` |
     */
    AfterSequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RefNumber` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    RefNumber: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DependencyType` |
     * | Type | `Edm.String` |
     */
    DependencyType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationDescription` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationDescription: string | null;
}

export interface DeleteDocumentListResponse extends CommandResponse {
}

export interface DeleteDocumentList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface CompleteContainerResponse extends CommandResponse {
}

export interface CompleteContainer {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContainerNIdList` |
     * | Type | `Collection(Edm.String)` |
     */
    ContainerNIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStepId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MTUIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DM_MTUIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualProduceParameterType` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ActualProducedMaterialTBParameterType)` |
     */
    ActualProduceParameterType: Array<ActualProducedMaterialTBParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Results` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ResultParameterType)` |
     */
    Results: Array<ResultParameterType>;
}

export interface PauseWOOperationResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderHistoryIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    WorkOrderHistoryIds: Array<string>;
}

export interface PauseWOOperation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupPhaseId` |
     * | Type | `Edm.Guid` |
     */
    ExecutionGroupPhaseId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PauseWOOperationParameterType` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.PauseWOOperationParameterType` |
     * | Nullable | `false` |
     */
    PauseWOOperationParameterType: PauseWOOperationParameterType;
}

export interface DeleteAsPlannedBOPListResponse extends CommandResponse {
}

export interface DeleteAsPlannedBOPList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface CreateHoldResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateHold {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CloseComment` |
     * | Type | `Edm.String` |
     */
    CloseComment: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CloseTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CloseTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CloseUserId` |
     * | Type | `Edm.String` |
     */
    CloseUserId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Comment` |
     * | Type | `Edm.String` |
     */
    Comment: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FutureHold` |
     * | Type | `Edm.String` |
     */
    FutureHold: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsPresent` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsPresent: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OpenTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    OpenTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OpenUserId` |
     * | Type | `Edm.String` |
     */
    OpenUserId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PreviousState` |
     * | Type | `Edm.String` |
     */
    PreviousState: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReasonId` |
     * | Type | `Edm.Guid` |
     */
    ReasonId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Type` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Type: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TypeNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    TypeNId: string;
}

export interface LinkToBeUsedMachineToPJFResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    IdList: Array<string>;
}

export interface LinkToBeUsedMachineToPJF {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedMachineId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToBeUsedMachineId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFileList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.FB_OP_AM.OPModel.Types.PJFIsSourceParameterType)` |
     * | Nullable | `false` |
     */
    PrintJobFileList: Array<PJFIsSourceParameterType>;
}

export interface GetResultStrategyResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StrategyNId` |
     * | Type | `Edm.String` |
     */
    StrategyNId: string | null;
}

export interface GetResultStrategy {
}

export interface LinkMachineDefinitionToSetPointResponse extends CommandResponse {
}

export interface LinkMachineDefinitionToSetPoint {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    SetPointId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MachineDefinitionList` |
     * | Type | `Collection(Edm.String)` |
     */
    MachineDefinitionList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsDefault` |
     * | Type | `Edm.Boolean` |
     */
    IsDefault: boolean | null;
}

export interface UpdateTeamResponse extends CommandResponse {
}

export interface UpdateTeam {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TeamId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    TeamId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaximumUsers` |
     * | Type | `Edm.Int32` |
     */
    MaximumUsers: number | null;
}

export interface CreateNewWorkInstructionDefinitionRevisionResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionDefinitionId` |
     * | Type | `Edm.Guid` |
     */
    WorkInstructionDefinitionId: string | null;
}

export interface CreateNewWorkInstructionDefinitionRevision {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    SourceNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceRevision` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    SourceRevision: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetRevision` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    TargetRevision: string;
}

export interface DeleteTemplateResponse extends CommandResponse {
}

export interface DeleteTemplate {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface GetResultValueOnEmptyResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResultValue` |
     * | Type | `Edm.String` |
     */
    ResultValue: string | null;
}

export interface GetResultValueOnEmpty {
}

export interface TCMCreateUoMListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoMOutput` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.ReferenceData.FB_RD_SERV.RFModel.Types.TCMOutputParameter)` |
     */
    UoMOutput: Array<TCMOutputParameter>;
}

export interface TCMCreateUoMList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NIds` |
     * | Type | `Collection(Edm.String)` |
     */
    NIds: Array<string>;
}

export interface CreateNonConformanceLifecycleResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
}

export interface CreateNonConformanceLifecycle {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Name: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Type` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Type: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `InitialStatus` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    InitialStatus: string;
}

export interface SetIsOutOfDateAsPlannedBOPResponse extends CommandResponse {
}

export interface SetIsOutOfDateAsPlannedBOP {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityType` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    EntityType: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NIDList` |
     * | Type | `Collection(Edm.String)` |
     */
    NIDList: Array<string>;
}

export interface CreateActualUsedToolResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateActualUsedTool {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Tool` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Tool: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolDefinition` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToolDefinition: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UsedTimes` |
     * | Type | `Edm.Decimal` |
     * | Nullable | `false` |
     */
    UsedTimes: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStepId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedTool` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToBeUsedTool: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItemId` |
     * | Type | `Edm.Guid` |
     */
    MaterialItemId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualUsageCounter` |
     * | Type | `Edm.Decimal` |
     */
    ActualUsageCounter: number | null;
}

export interface CheckWorkOrderStatusIsInEditingResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsInEditing` |
     * | Type | `Edm.Boolean` |
     */
    IsInEditing: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderExist` |
     * | Type | `Edm.Boolean` |
     */
    WorkOrderExist: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StatusNId` |
     * | Type | `Edm.String` |
     */
    StatusNId: string | null;
}

export interface CheckWorkOrderStatusIsInEditing {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkOrderId: string;
}

export interface CreateItlkCheckHistoryListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckHistoryIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ItlkCheckHistoryIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Edm.String` |
     */
    WarningMessage: string | null;
}

export interface CreateItlkCheckHistoryList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckHistoryList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.FB_OP_ITLK.OPModel.Types.ItlkCheckHistoryParameterType)` |
     * | Nullable | `false` |
     */
    ItlkCheckHistoryList: Array<ItlkCheckHistoryParameterType>;
}

export interface UpdateDM_MaterialTrackingUnitResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnitHistoryIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DM_MaterialTrackingUnitHistoryIdList: Array<string>;
}

export interface UpdateDM_MaterialTrackingUnit {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsReserved` |
     * | Type | `Edm.Boolean` |
     */
    IsReserved: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Weight` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    Weight: QuantityParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Volume` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    Volume: QuantityParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActiveNonConformanceNumber` |
     * | Type | `Edm.Int32` |
     */
    ActiveNonConformanceNumber: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BufferNId` |
     * | Type | `Edm.String` |
     */
    BufferNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AMPowderProperties` |
     * | Type | `Siemens.SimaticIT.UADM.OperationalData.FB_OP_MAT.OPModel.Types.AMPowderPropertiesParameterType` |
     */
    AMPowderProperties: AMPowderPropertiesParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `HistoryAction` |
     * | Type | `Edm.String` |
     */
    HistoryAction: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsCalledFromSplitOfMTU` |
     * | Type | `Edm.Boolean` |
     */
    IsCalledFromSplitOfMTU: boolean | null;
}

export interface SetWaitingForInspectionResponse extends CommandResponse {
}

export interface SetWaitingForInspection {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `InspectionValue` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    InspectionValue: boolean;
}

export interface DeleteNonProductiveActivityListResponse extends CommandResponse {
}

export interface DeleteNonProductiveActivityList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonProductiveActivityList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    NonProductiveActivityList: Array<string>;
}

export interface LinkAutomationNodeInstanceParameterToDCItemListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface LinkAutomationNodeInstanceParameterToDCItemList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionDefinitionParameterIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    WorkInstructionDefinitionParameterIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ATNInstanceParameter` |
     * | Type | `Siemens.SimaticIT.U4DM.MasterData.FB_MS_AGWInt.MSModel.Types.ATNInstanceParameterType` |
     * | Nullable | `false` |
     */
    ATNInstanceParameter: ATNInstanceParameterType;
}

export interface LinkPartProgramToEquipmentSpecificationResponse extends CommandResponse {
}

export interface LinkPartProgramToEquipmentSpecification {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PartProgram` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    PartProgram: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentSpecification` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    EquipmentSpecification: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Process` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Process: string;
}

export interface UpdateActualUsedMachinePJFResponse extends CommandResponse {
}

export interface UpdateActualUsedMachinePJF {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsSourcePJF` |
     * | Type | `Edm.Boolean` |
     */
    IsSourcePJF: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFile` |
     * | Type | `Edm.Guid` |
     */
    PrintJobFile: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFileExternalId` |
     * | Type | `Edm.String` |
     */
    PrintJobFileExternalId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualUsedMachineId` |
     * | Type | `Edm.Guid` |
     */
    ActualUsedMachineId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFileName` |
     * | Type | `Edm.String` |
     */
    PrintJobFileName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFileSource` |
     * | Type | `Edm.String` |
     */
    PrintJobFileSource: string | null;
}

export interface CopyNonConformanceFromParentWorkOrderResponse extends CommandResponse {
}

export interface CopyNonConformanceFromParentWorkOrder {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderIdParent` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderIdParent: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderIdSplit` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderIdSplit: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceToExcluded` |
     * | Type | `Collection(Edm.String)` |
     */
    NonConformanceToExcluded: Array<string>;
}

export interface CreateToBeUsedInspectionResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedInspectionId` |
     * | Type | `Edm.Guid` |
     */
    ToBeUsedInspectionId: string | null;
}

export interface CreateToBeUsedInspection {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStepId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RuntimeCharacteristicRepresentationContainerNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    RuntimeCharacteristicRepresentationContainerNId: string;
}

export interface DeleteWorkOrderHistoryActionResponse extends CommandResponse {
}

export interface DeleteWorkOrderHistoryAction {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface UnlinkWOOperationsFromExecutionGroupResponse extends CommandResponse {
}

export interface UnlinkWOOperationsFromExecutionGroup {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ExecutionGroupId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperations` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    WorkOrderOperations: Array<string>;
}

export interface ChangeBufferStatusResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface ChangeBufferStatus {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BufferInstanceId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    BufferInstanceId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StatusId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    StatusId: string;
}

export interface ReleaseExecutionGroupResponse extends CommandResponse {
}

export interface ReleaseExecutionGroup {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroups` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ExecutionGroupParameterType)` |
     * | Nullable | `false` |
     */
    ExecutionGroups: Array<ExecutionGroupParameterType>;
}

export interface DeleteWorkInstructionDefinitionParameterResponse extends CommandResponse {
}

export interface DeleteWorkInstructionDefinitionParameter {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface AcceptChangeChangeToBeUsedMachineResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceNId` |
     * | Type | `Edm.String` |
     */
    NonConformanceNId: string | null;
}

export interface AcceptChangeChangeToBeUsedMachine {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChangeOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ChangeOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OldToBeUsedMachineId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OldToBeUsedMachineId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NewToBeUsedMachine` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ToBeUsedMachineParameter` |
     * | Nullable | `false` |
     */
    NewToBeUsedMachine: ToBeUsedMachineParameter;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RefNumber` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    RefNumber: string;
}

export interface ChangeHandlingUnitStatusResponse extends CommandResponse {
}

export interface ChangeHandlingUnitStatus {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Status: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LocationNId` |
     * | Type | `Edm.String` |
     */
    LocationNId: string | null;
}

export interface LinkToolToSetPointResponse extends CommandResponse {
}

export interface LinkToolToSetPoint {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    SetPointId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ToolList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsDefaultFlag0` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsDefaultFlag0: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsDefault` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsDefault: boolean;
}

export interface DeleteCertificationListResponse extends CommandResponse {
}

export interface DeleteCertificationList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DeleteCertificationParameterList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_CERT.MSModel.Types.DeleteCertificationParameterType)` |
     * | Nullable | `false` |
     */
    DeleteCertificationParameterList: Array<DeleteCertificationParameterType>;
}

export interface SetPreferredMachineResponse extends CommandResponse {
}

export interface SetPreferredMachine {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkOrderOperationNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    EquipmentNId: string;
}

export interface LinkToolDefinitionToSetPointResponse extends CommandResponse {
}

export interface LinkToolDefinitionToSetPoint {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    SetPointId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolDefinitionList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ToolDefinitionList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsDefaultFlag0` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsDefaultFlag0: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsDefault` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsDefault: boolean;
}

export interface DeleteToBeUsedMachinePJFResponse extends CommandResponse {
}

export interface DeleteToBeUsedMachinePJF {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedMachineId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToBeUsedMachineId: string;
}

export interface DeleteToolDefinitionDocumentResponse extends CommandResponse {
}

export interface DeleteToolDefinitionDocument {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface AutomaticCollectWorkInstructionResponse extends CommandResponse {
}

export interface AutomaticCollectWorkInstruction {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Category` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Category: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedMaterialItemList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ProductMaterialItem)` |
     * | Nullable | `false` |
     */
    ProducedMaterialItemList: Array<ProductMaterialItem>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WIs` |
     * | Type | `Collection(Siemens.SimaticIT.OperationalData.WI_OP.OPModel.Types.WorkInstructionParameters)` |
     * | Nullable | `false` |
     */
    WIs: Array<WorkInstructionParameters>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentName` |
     * | Type | `Edm.String` |
     */
    EquipmentName: string | null;
}

export interface CreatePrintJobFileResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreatePrintJobFile {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFile` |
     * | Type | `Siemens.SimaticIT.U4DM.MasterData.FB_MS_AMMS.MSModel.Types.PJFParameterType` |
     * | Nullable | `false` |
     */
    PrintJobFile: PJFParameterType;
}

export interface AcceptChangeReplaceToBeConsumedMaterialResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceNId` |
     * | Type | `Edm.String` |
     */
    NonConformanceNId: string | null;
}

export interface AcceptChangeReplaceToBeConsumedMaterial {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChangePartId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ChangePartId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OldToBeConsumedMaterialId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OldToBeConsumedMaterialId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NewToBeConsumedMaterialId` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ToBeConsumedMaterialParameter` |
     * | Nullable | `false` |
     */
    NewToBeConsumedMaterialId: ToBeConsumedMaterialParameter;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RefNumber` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    RefNumber: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsMaterialBehaviourOutputTypeFlag0` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsMaterialBehaviourOutputTypeFlag0: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsMaterialBehaviourOutputType` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsMaterialBehaviourOutputType: boolean;
}

export interface UploadPLMXResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FileURL` |
     * | Type | `Edm.String` |
     */
    FileURL: string | null;
}

export interface UploadPLMX {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FileId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    FileId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PackageId` |
     * | Type | `Edm.String` |
     */
    PackageId: string | null;
}

export interface UnLinkSkillsFromTeamResponse extends CommandResponse {
}

export interface UnLinkSkillsFromTeam {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TeamSkillAssociationIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    TeamSkillAssociationIds: Array<string>;
}

export interface CompleteWOStepFullQtyResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderHistoryId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderHistoryId: string | null;
}

export interface CompleteWOStepFullQty {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CompleteWOStepFullQtyParameterType` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.CompleteWOStepFullQtyParameterType` |
     * | Nullable | `false` |
     */
    CompleteWOStepFullQtyParameterType: CompleteWOStepFullQtyParameterType;
}

export interface UpdateStepResponse extends CommandResponse {
}

export interface UpdateStep {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Step` |
     * | Type | `Siemens.SimaticIT.U4DM.MasterData.FB_MS_BOP.MSModel.Types.UpdateStepParameterType` |
     * | Nullable | `false` |
     */
    Step: UpdateStepParameterType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface UnlinkPrintJobFileFromEquipmentTypeResponse extends CommandResponse {
}

export interface UnlinkPrintJobFileFromEquipmentType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AssociationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    AssociationId: string;
}

export interface SetTargetQuantityOnFlexibleWorkOrderResponse extends CommandResponse {
}

export interface SetTargetQuantityOnFlexibleWorkOrder {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkOrderNId: string;
}

export interface CreateOperationResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateOperation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Operation` |
     * | Type | `Siemens.SimaticIT.U4DM.MasterData.FB_MS_BOP.MSModel.Types.OperationParameterType` |
     * | Nullable | `false` |
     */
    Operation: OperationParameterType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.String` |
     */
    CorrelationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCollectedDocument` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCollectedDocument: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBOPId` |
     * | Type | `Edm.Guid` |
     */
    AsPlannedBOPId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlanId` |
     * | Type | `Edm.Guid` |
     */
    MasterPlanId: string | null;
}

export interface LinkPJFToEquipmentSpecificationResponse extends CommandResponse {
}

export interface LinkPJFToEquipmentSpecification {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFile` |
     * | Type | `Edm.Guid` |
     */
    PrintJobFile: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFileExtId` |
     * | Type | `Edm.String` |
     */
    PrintJobFileExtId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFileName` |
     * | Type | `Edm.String` |
     */
    PrintJobFileName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFileSource` |
     * | Type | `Edm.String` |
     */
    PrintJobFileSource: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentSpecification` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    EquipmentSpecification: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Process` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Process: string;
}

export interface CreateAndAssignProducedMaterialItemsResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderNId: string | null;
}

export interface CreateAndAssignProducedMaterialItems {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkOrderNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SerialNumberCodes` |
     * | Type | `Collection(Edm.String)` |
     */
    SerialNumberCodes: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialDefinitionId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    MaterialDefinitionId: string;
}

export interface CreateToolCompatibleMachineResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateToolCompatibleMachine {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MachineNId` |
     * | Type | `Edm.String` |
     */
    MachineNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeNId` |
     * | Type | `Edm.String` |
     */
    EquipmentTypeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToolId: string;
}

export interface LinkToBeUsedInspectionToRuntimeCharReprRefOperationAssociationListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RuntimeCharReprRefOperationAssociationIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    RuntimeCharReprRefOperationAssociationIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessages` |
     * | Type | `Collection(Edm.String)` |
     */
    WarningMessages: Array<string>;
}

export interface LinkToBeUsedInspectionToRuntimeCharReprRefOperationAssociationList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RuntimeCharReprRefOpAssParameterTypeList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.RuntimeCharReprRefOpAssParameterType)` |
     * | Nullable | `false` |
     */
    RuntimeCharReprRefOpAssParameterTypeList: Array<RuntimeCharReprRefOpAssParameterType>;
}

export interface AssociateDNCItemMachineMaterialsAssociationResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FailedId` |
     * | Type | `Edm.Guid` |
     */
    FailedId: string | null;
}

export interface AssociateDNCItemMachineMaterialsAssociation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Siemens.SimaticIT.U4DM.MasterData.FB_MS_DNC.MSModel.Types.IdsParameterType` |
     * | Nullable | `false` |
     */
    Ids: IdsParameterType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DNCItemId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    DNCItemId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MachineToDNCId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    MachineToDNCId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ManageHierarchy` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    ManageHierarchy: boolean;
}

export interface DeleteWorkInstructionTemplateResponse extends CommandResponse {
}

export interface DeleteWorkInstructionTemplate {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface ActivateMaterialTrackingUnitOnScrewingToolResponse extends CommandResponse {
}

export interface ActivateMaterialTrackingUnitOnScrewingTool {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnitId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    DM_MaterialTrackingUnitId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedToolId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToBeUsedToolId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    EquipmentNId: string;
}

export interface LinkWorkInstructionDefinitionListToStepResponse extends CommandResponse {
}

export interface LinkWorkInstructionDefinitionListToStep {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StepId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    StepId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionDefinitionList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    WorkInstructionDefinitionList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionAssociationType` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkInstructionAssociationType: string;
}

export interface UpdateTransportOperationResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface UpdateTransportOperation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TransportOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    TransportOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `HandlingUnitId` |
     * | Type | `Edm.Guid` |
     */
    HandlingUnitId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceBufferId` |
     * | Type | `Edm.Guid` |
     */
    SourceBufferId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DestinationBufferId` |
     * | Type | `Edm.Guid` |
     */
    DestinationBufferId: string | null;
}

export interface DeleteWOOperationDependencyResponse extends CommandResponse {
}

export interface DeleteWOOperationDependency {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Dependency` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.WorkOOperationDependencyParameter` |
     * | Nullable | `false` |
     */
    Dependency: WorkOOperationDependencyParameter;
}

export interface UnLoadHandlingUnitResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Edm.String` |
     */
    WarningMessage: string | null;
}

export interface UnLoadHandlingUnit {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItemIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    MaterialItemIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `HandlingUnitId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    HandlingUnitId: string;
}

export interface TCM2AssociateDocumentToStepListResponse extends CommandResponse {
}

export interface TCM2AssociateDocumentToStepList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentAssociationList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_BOP.MSModel.Types.TCM2DocumentAssociationParameterType)` |
     * | Nullable | `false` |
     */
    DocumentAssociationList: Array<TCM2DocumentAssociationParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     */
    CorrelationId: string | null;
}

export interface DisassembleMaterialItemResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialHistoryId` |
     * | Type | `Edm.Guid` |
     */
    DM_MaterialHistoryId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Collection(Edm.String)` |
     */
    WarningMessage: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DisassembledMaterialItemList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.DisassembledMaterialItemParameterType)` |
     */
    DisassembledMaterialItemList: Array<DisassembledMaterialItemParameterType>;
}

export interface DisassembleMaterialItem {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItemToDisassembleList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.MaterialItemToDisassembleParameterType)` |
     * | Nullable | `false` |
     */
    MaterialItemToDisassembleList: Array<MaterialItemToDisassembleParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsCoProduct` |
     * | Type | `Edm.Boolean` |
     */
    IsCoProduct: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStepId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderStepNId: string | null;
}

export interface EnableLocationMachineForCompleteByDifferentUserResponse extends CommandResponse {
}

export interface EnableLocationMachineForCompleteByDifferentUser {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationNId` |
     * | Type | `Collection(Edm.String)` |
     */
    EquipmentConfigurationNId: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Enabled` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    Enabled: boolean;
}

export interface UnsetWorkInstructionDefinitionRevisionCurrentResponse extends CommandResponse {
}

export interface UnsetWorkInstructionDefinitionRevisionCurrent {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface UpdateActualUsedMachineResponse extends CommandResponse {
}

export interface UpdateActualUsedMachine {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MachineNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    MachineNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedMachineId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToBeUsedMachineId: string;
}

export interface UpdateEquipmentConfigurationPropertyAttributeResponse extends CommandResponse {
}

export interface UpdateEquipmentConfigurationPropertyAttribute {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AttributeValue` |
     * | Type | `Edm.String` |
     */
    AttributeValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Operational` |
     * | Type | `Edm.Boolean` |
     */
    Operational: boolean | null;
}

export interface DeleteDefectGroupListResponse extends CommandResponse {
}

export interface DeleteDefectGroupList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefectGroupIdentifierList` |
     * | Type | `Collection(Siemens.SimaticIT.MasterData.MatTool.MSModel.Types.IdentifiersParameterType)` |
     * | Nullable | `false` |
     */
    DefectGroupIdentifierList: Array<IdentifiersParameterType>;
}

export interface AbortExecutionGroupListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessages` |
     * | Type | `Collection(Edm.String)` |
     */
    WarningMessages: Array<string>;
}

export interface AbortExecutionGroupList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupNIdList` |
     * | Type | `Collection(Edm.String)` |
     */
    ExecutionGroupNIdList: Array<string>;
}

export interface CreateTemplateToMaterialPlantResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateTemplateToMaterialPlant {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_Material` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    DM_Material: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TemplateId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    TemplateId: string;
}

export interface DeleteSetPointListResponse extends CommandResponse {
}

export interface DeleteSetPointList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    SetPointIds: Array<string>;
}

export interface CreateSkipReasonResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateSkipReason {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
}

export interface CreateWorkInstructionResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateWorkInstruction {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionDefinitionNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkInstructionDefinitionNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionDefinitionRevision` |
     * | Type | `Edm.String` |
     */
    WorkInstructionDefinitionRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterValues` |
     * | Type | `Collection(Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ParameterValueParameterType)` |
     */
    ParameterValues: Array<ParameterValueParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsReEditEnabled` |
     * | Type | `Edm.Boolean` |
     */
    IsReEditEnabled: boolean | null;
}

export interface LinkWorkInstructionsToWOStepResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface LinkWorkInstructionsToWOStep {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionDefinitionIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    WorkInstructionDefinitionIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderStepId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SerialNumbers` |
     * | Type | `Collection(Edm.String)` |
     */
    SerialNumbers: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsReEditEnabled` |
     * | Type | `Edm.Boolean` |
     */
    IsReEditEnabled: boolean | null;
}

export interface DeleteMaterialSpecificationListResponse extends CommandResponse {
}

export interface DeleteMaterialSpecificationList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface DeleteToBeProducedMaterialResponse extends CommandResponse {
}

export interface DeleteToBeProducedMaterial {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeProducedMaterialId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToBeProducedMaterialId: string;
}

export interface CreateReworkCodeListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface CreateReworkCodeList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DM_MaterialIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefectTypeId` |
     * | Type | `Edm.Guid` |
     */
    DefectTypeId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefectGroupId` |
     * | Type | `Edm.Guid` |
     */
    DefectGroupId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessIdentifiersList` |
     * | Type | `Collection(Siemens.SimaticIT.MasterData.MatTool.MSModel.Types.ProcessIdentifiersParameterType)` |
     * | Nullable | `false` |
     */
    ProcessIdentifiersList: Array<ProcessIdentifiersParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FailureNId` |
     * | Type | `Edm.String` |
     */
    FailureNId: string | null;
}

export interface LinkProcessToProcessResponse extends CommandResponse {
}

export interface LinkProcessToProcess {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FromProcessId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    FromProcessId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToProcessId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToProcessId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBopId` |
     * | Type | `Edm.Guid` |
     */
    AsPlannedBopId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     */
    Sequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EffectivityExpression` |
     * | Type | `Edm.String` |
     */
    EffectivityExpression: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     */
    CorrelationId: string | null;
}

export interface CreateEquipmentConfigurationResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationId` |
     * | Type | `Edm.Guid` |
     */
    EquipmentConfigurationId: string | null;
}

export interface CreateEquipmentConfiguration {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeNId` |
     * | Type | `Edm.String` |
     */
    EquipmentTypeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigStateMachineNids` |
     * | Type | `Collection(Edm.String)` |
     */
    EquipmentConfigStateMachineNids: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LevelNId` |
     * | Type | `Edm.String` |
     */
    LevelNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Properties` |
     * | Type | `Collection(Siemens.SimaticIT.MasterData.EQU_MS.MSModel.Types.PropertyWithAttributesParameterType)` |
     */
    Properties: Array<PropertyWithAttributesParameterType>;
}

export interface SetCheckedOutOnWorkOrderOperationListResponse extends CommandResponse {
}

export interface SetCheckedOutOnWorkOrderOperationList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CheckOutFlag0` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    CheckOutFlag0: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CheckOut` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    CheckOut: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    WorkOrderOperationIdList: Array<string>;
}

export interface UpdateExecutionGroupResponse extends CommandResponse {
}

export interface UpdateExecutionGroup {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedStartTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedStartTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedEndTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedEndTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedDuration` |
     * | Type | `Edm.Duration` |
     */
    EstimatedDuration: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     */
    Status: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface UpdateWorkInstructionTemplateParameterResponse extends CommandResponse {
}

export interface UpdateWorkInstructionTemplateParameter {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IdFlag0` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IdFlag0: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterValue` |
     * | Type | `Edm.String` |
     */
    ParameterValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterType` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.SupportedTypes` |
     */
    ParameterType: SupportedTypes | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Direction` |
     * | Type | `Siemens.SimaticIT.MasterData.WI_MS.MSModel.Types.WorkInstructionDefinitionParameterDirection` |
     */
    Direction: WorkInstructionDefinitionParameterDirection | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsReadOnly` |
     * | Type | `Edm.Boolean` |
     */
    IsReadOnly: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterUoMNId` |
     * | Type | `Edm.String` |
     */
    ParameterUoMNId: string | null;
}

export interface RemoveCertificationToMaterialListResponse extends CommandResponse {
}

export interface RemoveCertificationToMaterialList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CertificationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    CertificationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialIds` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_CERT.MSModel.Types.CertificationAssociationParameterType)` |
     * | Nullable | `false` |
     */
    MaterialIds: Array<CertificationAssociationParameterType>;
}

export interface DeleteMasterPlanResponse extends CommandResponse {
}

export interface DeleteMasterPlan {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface CreateCriticalityResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateCriticality {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Name: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Description: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsSystemDefined` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsSystemDefined: boolean;
}

export interface DeleteMaterialTrackingUnitResponse extends CommandResponse {
}

export interface DeleteMaterialTrackingUnit {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface UnLinkUsersFromTeamResponse extends CommandResponse {
}

export interface UnLinkUsersFromTeam {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TeamUserAssociationIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    TeamUserAssociationIds: Array<string>;
}

export interface UpdateOfflineActionResponse extends CommandResponse {
}

export interface UpdateOfflineAction {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OfflineActionIdFlag0` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    OfflineActionIdFlag0: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OfflineActionId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OfflineActionId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StatusTransitionVerb` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    StatusTransitionVerb: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CommandResponse` |
     * | Type | `Edm.String` |
     */
    CommandResponse: string | null;
}

export interface AcceptChangeAddWorkInstructionResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceNId` |
     * | Type | `Edm.String` |
     */
    NonConformanceNId: string | null;
}

export interface AcceptChangeAddWorkInstruction {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WIDefinitionId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WIDefinitionId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SerialNumberCodes` |
     * | Type | `Collection(Edm.String)` |
     */
    SerialNumberCodes: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RefNumber` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    RefNumber: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChangeDataCollectionId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ChangeDataCollectionId: string;
}

export interface CreateToBeUsedDocumentsResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface CreateToBeUsedDocuments {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DocumentIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStepId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentType` |
     * | Type | `Edm.String` |
     */
    DocumentType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItemIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    MaterialItemIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupPhaseId` |
     * | Type | `Edm.Guid` |
     */
    ExecutionGroupPhaseId: string | null;
}

export interface CheckInCompleteWOOperationSerializedResponse extends CommandResponse {
}

export interface CheckInCompleteWOOperationSerialized {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CompleteWOOperationSerializedParameterType` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.CompleteWOOperationSerializedParameterType` |
     * | Nullable | `false` |
     */
    CompleteWOOperationSerializedParameterType: CompleteWOOperationSerializedParameterType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OfflineActionInternalId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OfflineActionInternalId: string;
}

export interface CreateWOStepDependencyResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateWOStepDependency {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Dependency` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.WorkOStepDependencyParameter` |
     * | Nullable | `false` |
     */
    Dependency: WorkOStepDependencyParameter;
}

export interface ReleaseWorkOrderResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Id: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Edm.String` |
     */
    WarningMessage: string | null;
}

export interface ReleaseWorkOrder {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReleaseWorkOrderDetails` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ReleaseWorkOrderParameterType)` |
     * | Nullable | `false` |
     */
    ReleaseWorkOrderDetails: Array<ReleaseWorkOrderParameterType>;
}

export interface DeleteBoMItemListResponse extends CommandResponse {
}

export interface DeleteBoMItemList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface StartWOOperationsSerializedLiteSingleWOResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessages` |
     * | Type | `Collection(Edm.String)` |
     */
    WarningMessages: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StartedWorkOrderOperations` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.WOOpSerializedLiteOutputParameterType)` |
     */
    StartedWorkOrderOperations: Array<WOOpSerializedLiteOutputParameterType>;
}

export interface StartWOOperationsSerializedLiteSingleWO {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StartWOOpSerializedLiteParameters` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.WOOperationSerializedLiteParameterType)` |
     * | Nullable | `false` |
     */
    StartWOOpSerializedLiteParameters: Array<WOOperationSerializedLiteParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `User` |
     * | Type | `Edm.String` |
     */
    User: string | null;
}

export interface SendMailResponse extends CommandResponse {
}

export interface SendMail {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformance` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.NonConformanceParameterType` |
     * | Nullable | `false` |
     */
    NonConformance: NonConformanceParameterType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceTransitionNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NonConformanceTransitionNId: string;
}

export interface StartWOOperationsSerializedLiteResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessages` |
     * | Type | `Collection(Edm.String)` |
     */
    WarningMessages: Array<string>;
}

export interface StartWOOperationsSerializedLite {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StartWOOpSerializedLiteParameters` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.WOOperationSerializedLiteParameterType)` |
     * | Nullable | `false` |
     */
    StartWOOpSerializedLiteParameters: Array<WOOperationSerializedLiteParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `User` |
     * | Type | `Edm.String` |
     */
    User: string | null;
}

export interface CloneAsPlannedBOPResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CloneAsPlannedBOP {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BaselineUId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    BaselineUId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BaselineName` |
     * | Type | `Edm.String` |
     */
    BaselineName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PBOPIdentID` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    PBOPIdentID: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceAsPlannedBOPId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    SourceAsPlannedBOPId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OrderId` |
     * | Type | `Edm.String` |
     */
    OrderId: string | null;
}

export interface GenerateAndAssociateMTUCodeResponse extends CommandResponse {
}

export interface GenerateAndAssociateMTUCode {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    MaterialNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CodeType` |
     * | Type | `Siemens.SimaticIT.OperationalData.MAT_OP.OPModel.Types.MTUCodeType` |
     * | Nullable | `false` |
     */
    CodeType: MTUCodeType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MTUId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    MTUId: string;
}

export interface UpdateStatusDefinitionResponse extends CommandResponse {
}

export interface UpdateStatusDefinition {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Color` |
     * | Type | `Edm.String` |
     */
    Color: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Outcome` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.StatusesOutcome` |
     */
    Outcome: StatusesOutcome | null;
}

export interface GenerateWorkOrderNIdResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderNId: string | null;
}

export interface GenerateWorkOrderNId {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    MaterialId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Timestamp` |
     * | Type | `Edm.DateTimeOffset` |
     */
    Timestamp: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TemplateId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    TemplateId: string;
}

export interface CreateAMPowderBatchGenealogyResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateAMPowderBatchGenealogy {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Date` |
     * | Type | `Edm.DateTimeOffset` |
     * | Nullable | `false` |
     */
    Date: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnit` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    DM_MaterialTrackingUnit: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MixedQuantity` |
     * | Type | `Edm.String` |
     */
    MixedQuantity: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OldQuantity` |
     * | Type | `Edm.Decimal` |
     * | Nullable | `false` |
     */
    OldQuantity: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     * | Nullable | `false` |
     */
    Quantity: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RecycleCount` |
     * | Type | `Edm.String` |
     */
    RecycleCount: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Code` |
     * | Type | `Edm.String` |
     */
    Code: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CodeType` |
     * | Type | `Siemens.SimaticIT.OperationalData.MAT_OP.OPModel.Types.MTUCodeType` |
     */
    CodeType: MTUCodeType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceCode` |
     * | Type | `Edm.String` |
     */
    SourceCode: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetCode` |
     * | Type | `Edm.String` |
     */
    TargetCode: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Status: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    UserId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrder` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrder: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperation: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStep` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderStep: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceDM_MaterialTrackingUnit` |
     * | Type | `Edm.Guid` |
     */
    SourceDM_MaterialTrackingUnit: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetDM_MaterialTrackingUnit` |
     * | Type | `Edm.Guid` |
     */
    TargetDM_MaterialTrackingUnit: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Action` |
     * | Type | `Edm.Guid` |
     */
    Action: string | null;
}

export interface UnlinkWIDefinitionsFromEGPhaseResponse extends CommandResponse {
}

export interface UnlinkWIDefinitionsFromEGPhase {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WIDefinitionToEGPhaseAssociationIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    WIDefinitionToEGPhaseAssociationIds: Array<string>;
}

export interface UpdateFutureHoldResponse extends CommandResponse {
}

export interface UpdateFutureHold {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CloseTime` |
     * | Type | `Edm.DateTimeOffset` |
     * | Nullable | `false` |
     */
    CloseTime: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CloseUserId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    CloseUserId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Comment` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Comment: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsPresent` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsPresent: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LifeCycle` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    LifeCycle: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OpenTime` |
     * | Type | `Edm.DateTimeOffset` |
     * | Nullable | `false` |
     */
    OpenTime: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OpenUserId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    OpenUserId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PreviousStatus` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    PreviousStatus: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReasonId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ReasonId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkOrderNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkOrderOperationNId: string;
}

export interface EditPrintJobFileResponse extends CommandResponse {
}

export interface EditPrintJobFile {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFileDetails` |
     * | Type | `Siemens.SimaticIT.U4DM.MasterData.FB_MS_AMMS.MSModel.Types.PJFParameterType` |
     * | Nullable | `false` |
     */
    PrintJobFileDetails: PJFParameterType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsImport` |
     * | Type | `Edm.Boolean` |
     */
    IsImport: boolean | null;
}

export interface CheckInStartWOOperationTransferBatchResponse extends CommandResponse {
}

export interface CheckInStartWOOperationTransferBatch {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StartWOOperationTransferBatchParameterType` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.StartWOOperationTransferBatchParameterType` |
     * | Nullable | `false` |
     */
    StartWOOperationTransferBatchParameterType: StartWOOperationTransferBatchParameterType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OfflineActionInternalId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OfflineActionInternalId: string;
}

export interface DeleteBufferDefinitionResponse extends CommandResponse {
}

export interface DeleteBufferDefinition {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface UnlinkItlkCheckToWorkOrderStepListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Edm.String` |
     */
    WarningMessage: string | null;
}

export interface UnlinkItlkCheckToWorkOrderStepList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckWOStepAssociationIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ItlkCheckWOStepAssociationIdList: Array<string>;
}

export interface LinkDocumentListToDM_MaterialTrackingUnitResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnitDocumentAssociationIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DM_MaterialTrackingUnitDocumentAssociationIds: Array<string>;
}

export interface LinkDocumentListToDM_MaterialTrackingUnit {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentIdsList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DocumentIdsList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MTUId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    DM_MTUId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutioGroupPhaseId` |
     * | Type | `Edm.Guid` |
     */
    ExecutioGroupPhaseId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutioGroupPhaseNId` |
     * | Type | `Edm.String` |
     */
    ExecutioGroupPhaseNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOderOperationNId` |
     * | Type | `Edm.String` |
     */
    WorkOderOperationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AreCurrent` |
     * | Type | `Edm.Boolean` |
     */
    AreCurrent: boolean | null;
}

export interface CreateWorkOrderFromProcessResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface CreateWorkOrderFromProcess {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BatchId` |
     * | Type | `Edm.String` |
     */
    BatchId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ProcessId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProductionTypeNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ProductionTypeNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DueDate` |
     * | Type | `Edm.DateTimeOffset` |
     */
    DueDate: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedStartTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedStartTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Priority` |
     * | Type | `Edm.Int32` |
     */
    Priority: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ERPOrder` |
     * | Type | `Edm.String` |
     */
    ERPOrder: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedEndTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedEndTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedId` |
     * | Type | `Edm.Guid` |
     */
    AsPlannedId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Plant` |
     * | Type | `Edm.String` |
     */
    Plant: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FinalMaterialId` |
     * | Type | `Edm.Guid` |
     */
    FinalMaterialId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BillOfFeatureNId` |
     * | Type | `Edm.String` |
     */
    BillOfFeatureNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BillOfFeatureRevision` |
     * | Type | `Edm.String` |
     */
    BillOfFeatureRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BoM` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.BoMParameterType` |
     */
    BoM: BoMParameterType | null;
}

export interface CreateResultListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResultIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ResultIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Collection(Edm.String)` |
     */
    WarningMessage: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedResultList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.FB_OP_Result.OPModel.Types.OnResultCreationParameterType)` |
     */
    CreatedResultList: Array<OnResultCreationParameterType>;
}

export interface CreateResultList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResultList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.FB_OP_Result.OPModel.Types.CreateResultListParameterType)` |
     * | Nullable | `false` |
     */
    ResultList: Array<CreateResultListParameterType>;
}

export interface CreateMaterialDefinitionDocumentResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateMaterialDefinitionDocument {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialDefinitionId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    MaterialDefinitionId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    DocumentId: string;
}

export interface CheckOutWorkOrderOperationListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OfflineSessionId` |
     * | Type | `Edm.Guid` |
     */
    OfflineSessionId: string | null;
}

export interface CheckOutWorkOrderOperationList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DeviceId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    DeviceId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    WorkOrderOperationIdList: Array<string>;
}

export interface CreateExecutionGroupPhaseDependencyResponse extends CommandResponse {
}

export interface CreateExecutionGroupPhaseDependency {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FromEGPhaseId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    FromEGPhaseId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToEGPhaseId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToEGPhaseId: string;
}

export interface CreateWorkInstructionTemplateResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionTemplateId` |
     * | Type | `Edm.Guid` |
     */
    WorkInstructionTemplateId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ParameterIds: Array<string>;
}

export interface CreateWorkInstructionTemplate {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsDefault` |
     * | Type | `Edm.Boolean` |
     */
    IsDefault: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Parameters` |
     * | Type | `Collection(Siemens.SimaticIT.MasterData.WI_MS.MSModel.Types.WorkInstructionDefinitionParameterParameterType)` |
     */
    Parameters: Array<WorkInstructionDefinitionParameterParameterType>;
}

export interface CreateStatusDefinitionResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StatusDefinitionId` |
     * | Type | `Edm.Guid` |
     */
    StatusDefinitionId: string | null;
}

export interface CreateStatusDefinition {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Color` |
     * | Type | `Edm.String` |
     */
    Color: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Outcome` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.StatusesOutcome` |
     */
    Outcome: StatusesOutcome | null;
}

export interface LinkMaterialToContainerTypeListResponse extends CommandResponse {
}

export interface LinkMaterialToContainerTypeList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContainerTypeNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ContainerTypeNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CompatibleMaterialList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_Container.MSModel.Types.MaterialParameterType)` |
     * | Nullable | `false` |
     */
    CompatibleMaterialList: Array<MaterialParameterType>;
}

export interface CreateWorkOrderStepFromStepResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateWorkOrderStepFromStep {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StepId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    StepId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     */
    Sequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBOPId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    AsPlannedBOPId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCollectedDocument` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCollectedDocument: boolean | null;
}

export interface SubstrateMaintenanceResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface SubstrateMaintenance {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     */
    Status: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SubstrateId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    SubstrateId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Thickness` |
     * | Type | `Edm.Decimal` |
     */
    Thickness: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TreatmentCount` |
     * | Type | `Edm.Int32` |
     */
    TreatmentCount: number | null;
}

export interface UseScrewingToolResponse extends CommandResponse {
}

export interface UseScrewingTool {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutomationNodeInstanceNId` |
     * | Type | `Edm.String` |
     */
    AutomationNodeInstanceNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualAngle` |
     * | Type | `Edm.Decimal` |
     * | Nullable | `false` |
     */
    ActualAngle: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualTorque` |
     * | Type | `Edm.Decimal` |
     * | Nullable | `false` |
     */
    ActualTorque: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BoltItemNumber` |
     * | Type | `Edm.Int32` |
     * | Nullable | `false` |
     */
    BoltItemNumber: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolNId` |
     * | Type | `Edm.String` |
     */
    ToolNId: string | null;
}

export interface SetFutureHoldAfterNonConformanceCreationResponse extends CommandResponse {
}

export interface SetFutureHoldAfterNonConformanceCreation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FutureHoldDetails` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.HoldParamterType` |
     * | Nullable | `false` |
     */
    FutureHoldDetails: HoldParamterType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExtensionKey` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ExtensionKey: string;
}

export interface CreateNonConformanceAttachmentListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface CreateNonConformanceAttachmentList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    NonConformanceId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AttachmentList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    AttachmentList: Array<string>;
}

export interface DeleteWorkOrderHistoryResponse extends CommandResponse {
}

export interface DeleteWorkOrderHistory {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderHistoryId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderHistoryId: string;
}

export interface UnlinkDocumentToOperationResponse extends CommandResponse {
}

export interface UnlinkDocumentToOperation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    DocumentId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OperationId: string;
}

export interface CheckCertificationMultiMachineResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NIds` |
     * | Type | `Collection(Edm.String)` |
     */
    NIds: Array<string>;
}

export interface CheckCertificationMultiMachine {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CheckCertificationMultiMachineParameter` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.CheckCertificationMultiMachineParameterType)` |
     * | Nullable | `false` |
     */
    CheckCertificationMultiMachineParameter: Array<CheckCertificationMultiMachineParameterType>;
}

export interface CreateLogisticRequestItemResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateLogisticRequestItem {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolDefinition` |
     * | Type | `Edm.Guid` |
     */
    ToolDefinition: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialDefinition` |
     * | Type | `Edm.Guid` |
     */
    MaterialDefinition: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogisticRequest` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    LogisticRequest: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    Quantity: QuantityParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Source` |
     * | Type | `Edm.Guid` |
     */
    Source: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Type` |
     * | Type | `Edm.String` |
     */
    Type: string | null;
}

export interface CreateOperationDependencyResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateOperationDependency {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationDependency` |
     * | Type | `Siemens.SimaticIT.U4DM.MasterData.FB_MS_BOP.MSModel.Types.OperationDependencyParameterType` |
     * | Nullable | `false` |
     */
    OperationDependency: OperationDependencyParameterType;
}

export interface DeleteWorkInstructionDefinitionResponse extends CommandResponse {
}

export interface DeleteWorkInstructionDefinition {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface PunchInUsersResponse extends CommandResponse {
}

export interface PunchInUsers {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Users` |
     * | Type | `Collection(Edm.String)` |
     */
    Users: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActiveUserOnMachineParameters` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ActiveUserOnMachineParameterType)` |
     * | Nullable | `false` |
     */
    ActiveUserOnMachineParameters: Array<ActiveUserOnMachineParameterType>;
}

export interface CheckInCompleteWOStepFullQtyResponse extends CommandResponse {
}

export interface CheckInCompleteWOStepFullQty {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OfflineActionInternalId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OfflineActionInternalId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CompleteWOStepFullQtyParameter` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.CompleteWOStepFullQtyParameterType` |
     * | Nullable | `false` |
     */
    CompleteWOStepFullQtyParameter: CompleteWOStepFullQtyParameterType;
}

export interface TCM2CreateEquipmentSpecificationFullListResponse extends CommandResponse {
}

export interface TCM2CreateEquipmentSpecificationFullList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentSpecificationList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_BOP.MSModel.Types.TCM2EquipmentSpecificationParameterType)` |
     * | Nullable | `false` |
     */
    EquipmentSpecificationList: Array<TCM2EquipmentSpecificationParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     */
    CorrelationId: string | null;
}

export interface CreateWorkOrderResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateWorkOrder {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedStartTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedStartTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedEndTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedEndTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DueDate` |
     * | Type | `Edm.DateTimeOffset` |
     */
    DueDate: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FinalMaterialId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    FinalMaterialId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentOrderId` |
     * | Type | `Edm.Guid` |
     */
    ParentOrderId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReworkOfOrderId` |
     * | Type | `Edm.Guid` |
     */
    ReworkOfOrderId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `InitialQuantity` |
     * | Type | `Edm.Decimal` |
     */
    InitialQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Plant` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Plant: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessId` |
     * | Type | `Edm.Guid` |
     */
    ProcessId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProductionTypeNId` |
     * | Type | `Edm.String` |
     */
    ProductionTypeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ERPOrder` |
     * | Type | `Edm.String` |
     */
    ERPOrder: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentBatch` |
     * | Type | `Edm.String` |
     */
    ParentBatch: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BatchId` |
     * | Type | `Edm.String` |
     */
    BatchId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Priority` |
     * | Type | `Edm.Int32` |
     */
    Priority: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     */
    Sequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Enterprise` |
     * | Type | `Edm.String` |
     */
    Enterprise: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PlannedTargetQuantity` |
     * | Type | `Edm.Decimal` |
     */
    PlannedTargetQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualTargetQuantity` |
     * | Type | `Edm.Decimal` |
     */
    ActualTargetQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetQuantity` |
     * | Type | `Edm.Decimal` |
     */
    TargetQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ConfirmationType` |
     * | Type | `Edm.String` |
     */
    ConfirmationType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BillOfFeatureNId` |
     * | Type | `Edm.String` |
     */
    BillOfFeatureNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BillOfFeatureRevision` |
     * | Type | `Edm.String` |
     */
    BillOfFeatureRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BoM` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.BoMParameterType` |
     */
    BoM: BoMParameterType | null;
}

export interface UseToolResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Edm.String` |
     */
    WarningMessage: string | null;
}

export interface UseTool {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToolId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedMaterialItemId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ProducedMaterialItemId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Comments` |
     * | Type | `Edm.String` |
     */
    Comments: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UsageDuration` |
     * | Type | `Edm.Int64` |
     */
    UsageDuration: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderStepNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActiveNonConformanceNr` |
     * | Type | `Edm.Int32` |
     */
    ActiveNonConformanceNr: number | null;
}

export interface CreateToolSpecificationListResponse extends CommandResponse {
}

export interface CreateToolSpecificationList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolSpecificationList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_BOP.MSModel.Types.ToolSpecificationParameterType)` |
     * | Nullable | `false` |
     */
    ToolSpecificationList: Array<ToolSpecificationParameterType>;
}

export interface LinkSkillsToProcessOperationResponse extends CommandResponse {
}

export interface LinkSkillsToProcessOperation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SkillIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    SkillIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Level` |
     * | Type | `Edm.Int32` |
     */
    Level: number | null;
}

export interface Link3DPrinterTypeToEquipmentTypeResponse extends CommandResponse {
}

export interface Link3DPrinterTypeToEquipmentType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Link3DPrinterTypeToEquipmentTypeList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_AMMS.MSModel.Types.Link3DPrinterparameterType)` |
     * | Nullable | `false` |
     */
    Link3DPrinterTypeToEquipmentTypeList: Array<Link3DPrinterparameterType>;
}

export interface CreateOperationRevisionSubStructureResponse extends CommandResponse {
}

export interface CreateOperationRevisionSubStructure {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBOPId` |
     * | Type | `Edm.Guid` |
     */
    AsPlannedBOPId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlanId` |
     * | Type | `Edm.Guid` |
     */
    MasterPlanId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    SourceOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    TargetOperationId: string;
}

export interface LinkProcessToAsPlannedBOPResponse extends CommandResponse {
}

export interface LinkProcessToAsPlannedBOP {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ProcessId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBOPId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    AsPlannedBOPId: string;
}

export interface DeleteEquipmentGraphTypeResponse extends CommandResponse {
}

export interface DeleteEquipmentGraphType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface RemoveNonConformanceTransitionMailAddressListResponse extends CommandResponse {
}

export interface RemoveNonConformanceTransitionMailAddressList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceTransitionId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NonConformanceTransitionId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MailAddressList` |
     * | Type | `Collection(Edm.String)` |
     */
    MailAddressList: Array<string>;
}

export interface LinkItlkCheckToWorkOrderOperationListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckWOOpAssociationIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ItlkCheckWOOpAssociationIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Edm.String` |
     */
    WarningMessage: string | null;
}

export interface LinkItlkCheckToWorkOrderOperationList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckWOOpAssociationList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.FB_OP_ITLK.OPModel.Types.ItlkCheckWOOpAssociationParameterType)` |
     * | Nullable | `false` |
     */
    ItlkCheckWOOpAssociationList: Array<ItlkCheckWOOpAssociationParameterType>;
}

export interface UnloadContainerResponse extends CommandResponse {
}

export interface UnloadContainer {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UnloadContainerParameterTypeList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.FB_OP_ContainerExec.OPModel.Types.UnloadContainerParameterType)` |
     * | Nullable | `false` |
     */
    UnloadContainerParameterTypeList: Array<UnloadContainerParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
}

export interface CreateChangeResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceId` |
     * | Type | `Edm.String` |
     */
    NonConformanceId: string | null;
}

export interface CreateChange {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkOrderNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkOrderOperationNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChangeTypeId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ChangeTypeId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
}

export interface DisAssignProducedMaterialItemsResponse extends CommandResponse {
}

export interface DisAssignProducedMaterialItems {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkOrderNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItems` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.MaterialItemIdentifiersParameterType)` |
     * | Nullable | `false` |
     */
    MaterialItems: Array<MaterialItemIdentifiersParameterType>;
}

export interface UnlinkAutomationNodeInstanceParameterFromMaterialParameterListResponse extends CommandResponse {
}

export interface UnlinkAutomationNodeInstanceParameterFromMaterialParameterList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialAutomationNodeInstanceParameterAssociationList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    MaterialAutomationNodeInstanceParameterAssociationList: Array<string>;
}

export interface TCM2CreateMaterialSpecificationFullListResponse extends CommandResponse {
}

export interface TCM2CreateMaterialSpecificationFullList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialSpecificationList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_BOP.MSModel.Types.TCM2MaterialSpecificationParameterType)` |
     * | Nullable | `false` |
     */
    MaterialSpecificationList: Array<TCM2MaterialSpecificationParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     */
    CorrelationId: string | null;
}

export interface StartWOOperationFullQtyResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderHistoryId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderHistoryId: string | null;
}

export interface StartWOOperationFullQty {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupPhaseId` |
     * | Type | `Edm.Guid` |
     */
    ExecutionGroupPhaseId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StartWOOperationFullQtyParameterType` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.StartWOOperationFullQtyParameterType` |
     * | Nullable | `false` |
     */
    StartWOOperationFullQtyParameterType: StartWOOperationFullQtyParameterType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointItemParameterType` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.SetPointParameterType)` |
     */
    SetPointItemParameterType: Array<SetPointParameterType>;
}

export interface TakeOwnershipTransportOperationResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface TakeOwnershipTransportOperation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TransportOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    TransportOperationId: string;
}

export interface TraceCertificationHistoryResponse extends CommandResponse {
}

export interface TraceCertificationHistory {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CertificationActions` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_CERT.MSModel.Types.CertificationHistoryParameterType)` |
     * | Nullable | `false` |
     */
    CertificationActions: Array<CertificationHistoryParameterType>;
}

export interface CreateSupplierResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SupplierId` |
     * | Type | `Edm.Guid` |
     */
    SupplierId: string | null;
}

export interface CreateSupplier {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
}

export interface AutoGenerateWorkOrderNIdResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutoGeneratedWorkOrderNId` |
     * | Type | `Edm.String` |
     */
    AutoGeneratedWorkOrderNId: string | null;
}

export interface AutoGenerateWorkOrderNId {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    MaterialNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NumberingPatternNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NumberingPatternNId: string;
}

export interface CreateWorkOrdersFromAsPlannedBOPResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface CreateWorkOrdersFromAsPlannedBOP {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BaselineUId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    BaselineUId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProductionTypeNId` |
     * | Type | `Edm.String` |
     */
    ProductionTypeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrdersData` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.AsPlannedWorkOrder)` |
     * | Nullable | `false` |
     */
    WorkOrdersData: Array<AsPlannedWorkOrder>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ERPOrder` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ERPOrder: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Plant` |
     * | Type | `Edm.String` |
     */
    Plant: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BoM` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.BoMParameterType` |
     */
    BoM: BoMParameterType | null;
}

export interface ReserveMaterialItemsResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessages` |
     * | Type | `Collection(Edm.String)` |
     */
    WarningMessages: Array<string>;
}

export interface ReserveMaterialItems {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItemsToReserveList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.MaterialItemToReserveParamerType)` |
     * | Nullable | `false` |
     */
    MaterialItemsToReserveList: Array<MaterialItemToReserveParamerType>;
}

export interface DeleteBufferListResponse extends CommandResponse {
}

export interface DeleteBufferList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface CreateEquipmentLevelResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipConfLevelId` |
     * | Type | `Edm.Guid` |
     */
    EquipConfLevelId: string | null;
}

export interface CreateEquipmentLevel {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Level` |
     * | Type | `Edm.Int32` |
     * | Nullable | `false` |
     */
    Level: number;
}

export interface UnlinkWorkInstructionsFromWOStepResponse extends CommandResponse {
}

export interface UnlinkWorkInstructionsFromWOStep {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionWOSteps` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    WorkInstructionWOSteps: Array<string>;
}

export interface AcceptChangeChangeDependencyResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceNId` |
     * | Type | `Edm.String` |
     */
    NonConformanceNId: string | null;
}

export interface AcceptChangeChangeDependency {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChangeOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ChangeOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OldWorkOOperationDependencyId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    OldWorkOOperationDependencyId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NewWorkOOperationDependency` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.WorkOOperationDependencyParameter` |
     * | Nullable | `false` |
     */
    NewWorkOOperationDependency: WorkOOperationDependencyParameter;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RefNumber` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    RefNumber: string;
}

export interface DeleteFunctionalCodeListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Edm.String` |
     */
    WarningMessage: string | null;
}

export interface DeleteFunctionalCodeList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialGroupIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    MaterialGroupIds: Array<string>;
}

export interface StartExecutionGroupResponse extends CommandResponse {
}

export interface StartExecutionGroup {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ExecutionGroupId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StartExecutionGroupParameterType` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.StartExecutionGroupParameteType` |
     * | Nullable | `false` |
     */
    StartExecutionGroupParameterType: StartExecutionGroupParameteType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointItemParameterType` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.SetPointParameterType)` |
     */
    SetPointItemParameterType: Array<SetPointParameterType>;
}

export interface RemoveCertificationToRoleListResponse extends CommandResponse {
}

export interface RemoveCertificationToRoleList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CertificationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    CertificationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Roles` |
     * | Type | `Collection(Edm.String)` |
     */
    Roles: Array<string>;
}

export interface CreateAPSAlertResponse extends CommandResponse {
}

export interface CreateAPSAlert {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChangeInformation` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ChangeInformation: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    OperationNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OrderNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    OrderNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TraceDate` |
     * | Type | `Edm.DateTimeOffset` |
     * | Nullable | `false` |
     */
    TraceDate: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Type` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Type: string;
}

export interface CreateBufferDefinitionResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateBufferDefinition {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Name: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Version` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Version: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CapacityType` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    CapacityType: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     * | Nullable | `false` |
     */
    Quantity: QuantityParameterType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsValid` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsValid: boolean;
}

export interface ResendConfirmWorkOrderOperationResponse extends CommandResponse {
}

export interface ResendConfirmWorkOrderOperation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EventId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    EventId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PlantID` |
     * | Type | `Edm.String` |
     */
    PlantID: string | null;
}

export interface DNCTransferDNCItemsResponse extends CommandResponse {
}

export interface DNCTransferDNCItems {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DNCMachine` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    DNCMachine: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DNCIds` |
     * | Type | `Siemens.SimaticIT.U4DM.MsExt.DNCInt.OEModel.Types.IdsParameter` |
     * | Nullable | `false` |
     */
    DNCIds: IdsParameter;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MachineId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    MachineId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItemIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    MaterialItemIds: Array<string>;
}

export interface UpdateNonConformanceSupervisorResponse extends CommandResponse {
}

export interface UpdateNonConformanceSupervisor {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Defect` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Defect: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     * | Nullable | `false` |
     */
    Sequence: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Status: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `User` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    User: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrder` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrder: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface AcquireMTUFromAutomationNodeInstanceParameterResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Collection(Edm.String)` |
     */
    WarningMessage: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStepId: string | null;
}

export interface AcquireMTUFromAutomationNodeInstanceParameter {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialTrackingUnitToAcquireList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.FB_OP_AGWInt.OPModel.Types.MaterialTrackingUnitToAcquireParameterType)` |
     * | Nullable | `false` |
     */
    MaterialTrackingUnitToAcquireList: Array<MaterialTrackingUnitToAcquireParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationIdentifiers` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.IdentifiersParameterType` |
     */
    WorkOrderOperationIdentifiers: IdentifiersParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepIdentifiers` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.IdentifiersParameterType` |
     */
    WorkOrderStepIdentifiers: IdentifiersParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    EquipmentNId: string;
}

export interface CreateActualCollectedDocumentListOnContainerResponse extends CommandResponse {
}

export interface CreateActualCollectedDocumentListOnContainer {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DocumentIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStepId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContainerNIdList` |
     * | Type | `Collection(Edm.String)` |
     */
    ContainerNIdList: Array<string>;
}

export interface CreateToolDefinitionResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface CreateToolDefinition {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Revision: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.String` |
     */
    CorrelationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UId` |
     * | Type | `Edm.String` |
     */
    UId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SubstrateDefinitionProperties` |
     * | Type | `Siemens.SimaticIT.MasterData.MatTool.MSModel.Types.SubstrateDefinitionPropertiesParameterType` |
     */
    SubstrateDefinitionProperties: SubstrateDefinitionPropertiesParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolClassNId` |
     * | Type | `Edm.String` |
     */
    ToolClassNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UsageCounterMax` |
     * | Type | `Edm.Int32` |
     */
    UsageCounterMax: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UsageDurationMax` |
     * | Type | `Edm.Duration` |
     */
    UsageDurationMax: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExpirationDate` |
     * | Type | `Edm.DateTimeOffset` |
     */
    ExpirationDate: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Consumable` |
     * | Type | `Edm.Boolean` |
     */
    Consumable: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RevisionExpression` |
     * | Type | `Edm.String` |
     */
    RevisionExpression: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogisticParameter` |
     * | Type | `Siemens.SimaticIT.U4DM.ReferenceData.FB_RD_SERV.RFModel.Types.LogisticParameterType` |
     */
    LogisticParameter: LogisticParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Lockable` |
     * | Type | `Edm.Boolean` |
     */
    Lockable: boolean | null;
}

export interface DeleteEquipmentConfigurationPropertyResponse extends CommandResponse {
}

export interface DeleteEquipmentConfigurationProperty {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface CreateAsPlannedBOPResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateAsPlannedBOP {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBOP` |
     * | Type | `Siemens.SimaticIT.U4DM.MasterData.FB_MS_BOP.MSModel.Types.AsPlannedBOPParameterType` |
     * | Nullable | `false` |
     */
    AsPlannedBOP: AsPlannedBOPParameterType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    CorrelationId: string;
}

export interface DeleteTemplateToMaterialPlantResponse extends CommandResponse {
}

export interface DeleteTemplateToMaterialPlant {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface AcceptMaterialRequestResponse extends CommandResponse {
}

export interface AcceptMaterialRequest {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TransportOperationNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    TransportOperationNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogisticRequestId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    LogisticRequestId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     * | Nullable | `false` |
     */
    Quantity: QuantityParameterType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BufferSourceList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.FB_OP_IPL.OPModel.Types.BufferWithPriority)` |
     * | Nullable | `false` |
     */
    BufferSourceList: Array<BufferWithPriority>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BufferDestinationList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.FB_OP_IPL.OPModel.Types.BufferWithPriority)` |
     * | Nullable | `false` |
     */
    BufferDestinationList: Array<BufferWithPriority>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedDuration` |
     * | Type | `Edm.Duration` |
     */
    EstimatedDuration: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RoleId` |
     * | Type | `Edm.String` |
     */
    RoleId: string | null;
}

export interface UADMUpdateProcessResponse extends CommandResponse {
}

export interface UADMUpdateProcess {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Plant` |
     * | Type | `Edm.String` |
     */
    Plant: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FinalMaterialId` |
     * | Type | `Edm.Guid` |
     */
    FinalMaterialId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    Quantity: QuantityParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaxQuantity` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    MaxQuantity: QuantityParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MinQuantity` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    MinQuantity: QuantityParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     */
    Sequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EffectivityExpression` |
     * | Type | `Edm.String` |
     */
    EffectivityExpression: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBOPId` |
     * | Type | `Edm.Guid` |
     */
    AsPlannedBOPId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RevisionEffectivityExpression` |
     * | Type | `Edm.String` |
     */
    RevisionEffectivityExpression: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentProcessId` |
     * | Type | `Edm.Guid` |
     */
    ParentProcessId: string | null;
}

export interface AmendResultListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Collection(Edm.String)` |
     */
    WarningMessage: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResultIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ResultIdList: Array<string>;
}

export interface AmendResultList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResultList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.FB_OP_Result.OPModel.Types.AmendResultListParameterType)` |
     * | Nullable | `false` |
     */
    ResultList: Array<AmendResultListParameterType>;
}

export interface UpdateToBeUsedMachineResponse extends CommandResponse {
}

export interface UpdateToBeUsedMachine {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedMachineNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ToBeUsedMachineNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PartProgram` |
     * | Type | `Edm.String` |
     */
    PartProgram: string | null;
}

export interface AssociateDNCItemMachinesMaterialsAssociationResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FailedMaterialId` |
     * | Type | `Edm.Guid` |
     */
    FailedMaterialId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FailedMachineToDNCId` |
     * | Type | `Edm.Guid` |
     */
    FailedMachineToDNCId: string | null;
}

export interface AssociateDNCItemMachinesMaterialsAssociation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Siemens.SimaticIT.U4DM.MasterData.FB_MS_DNC.MSModel.Types.IdsParameterType` |
     * | Nullable | `false` |
     */
    Ids: IdsParameterType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DNCItemId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    DNCItemId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MachineToDNCIds` |
     * | Type | `Siemens.SimaticIT.U4DM.MasterData.FB_MS_DNC.MSModel.Types.IdsParameterType` |
     */
    MachineToDNCIds: IdsParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ManageHierarchy` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    ManageHierarchy: boolean;
}

export interface CreateRuntimeCharacteristicRepresentationContainerResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateRuntimeCharacteristicRepresentationContainer {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStepId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CharacteristicRepresentationInfo` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.CharacteristicRepresentationType)` |
     * | Nullable | `false` |
     */
    CharacteristicRepresentationInfo: Array<CharacteristicRepresentationType>;
}

export interface DeleteWOOpDependencyNavigationListResponse extends CommandResponse {
}

export interface DeleteWOOpDependencyNavigationList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AlternativeGroup` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    AlternativeGroup: string;
}

export interface CompleteWorkInstructionResponse extends CommandResponse {
}

export interface CompleteWorkInstruction {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface UnlockWorkInstructionDefinitionResponse extends CommandResponse {
}

export interface UnlockWorkInstructionDefinition {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface AcceptChangeRemoveToBeConsumedMaterialResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformancNId` |
     * | Type | `Edm.String` |
     */
    NonConformancNId: string | null;
}

export interface AcceptChangeRemoveToBeConsumedMaterial {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChangePartId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ChangePartId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeConsumedMaterialId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToBeConsumedMaterialId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RefNumber` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    RefNumber: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsMaterialBehaviourOutputTypeFlag0` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsMaterialBehaviourOutputTypeFlag0: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsMaterialBehaviourOutputType` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsMaterialBehaviourOutputType: boolean;
}

export interface APSSetInScheduledResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
}

export interface APSSetInScheduled {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `APSOrderOperation` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.FB_OP_APSInt.OPModel.Types.APSOrderOperationParameterType` |
     * | Nullable | `false` |
     */
    APSOrderOperation: APSOrderOperationParameterType;
}

export interface CreateLogisticClassResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateLogisticClass {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Name: string;
}

export interface Link3DPrinterTypeToMESResponse extends CommandResponse {
}

export interface Link3DPrinterTypeToMES {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Link3DPrinterTypeToMESList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_AMMS.MSModel.Types.PrinterParameterType)` |
     * | Nullable | `false` |
     */
    Link3DPrinterTypeToMESList: Array<PrinterParameterType>;
}

export interface AcceptChangeAddProcessOperationResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceNId` |
     * | Type | `Edm.String` |
     */
    NonConformanceNId: string | null;
}

export interface AcceptChangeAddProcessOperation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChangeProcessOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ChangeProcessOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RefNumber` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    RefNumber: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AfterSequence` |
     * | Type | `Edm.Int32` |
     */
    AfterSequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ProcessOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationName` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkOrderOperationName: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationSequence` |
     * | Type | `Edm.Int32` |
     * | Nullable | `false` |
     */
    WorkOrderOperationSequence: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DependencyType` |
     * | Type | `Edm.String` |
     */
    DependencyType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationId` |
     * | Type | `Edm.Guid` |
     */
    OperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBopId` |
     * | Type | `Edm.Guid` |
     */
    AsPlannedBopId: string | null;
}

export interface DeleteToolResponse extends CommandResponse {
}

export interface DeleteTool {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface LinkPJFToMaterialDefinitionResponse extends CommandResponse {
}

export interface LinkPJFToMaterialDefinition {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFile` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    PrintJobFile: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialDefinition` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    MaterialDefinition: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     * | Nullable | `false` |
     */
    Quantity: number;
}

export interface UpdateCharacteristicRepresentationResponse extends CommandResponse {
}

export interface UpdateCharacteristicRepresentation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SampleSize` |
     * | Type | `Edm.Int32` |
     */
    SampleSize: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CanBeSkipped` |
     * | Type | `Edm.Boolean` |
     */
    CanBeSkipped: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CharacteristicSpecificationId` |
     * | Type | `Edm.Guid` |
     */
    CharacteristicSpecificationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ScenarioNId` |
     * | Type | `Edm.String` |
     */
    ScenarioNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CharacteristicRepresentationFrequencyId` |
     * | Type | `Edm.Guid` |
     */
    CharacteristicRepresentationFrequencyId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CharacteristicRepresentationFrequencyValue` |
     * | Type | `Edm.Decimal` |
     */
    CharacteristicRepresentationFrequencyValue: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TimeBasedScheduleMode` |
     * | Type | `Edm.String` |
     */
    TimeBasedScheduleMode: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TimeBasedMandatoryInspectionWarningValue` |
     * | Type | `Edm.Int32` |
     */
    TimeBasedMandatoryInspectionWarningValue: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TimeBasedMandatoryInspectionWarningUoMNId` |
     * | Type | `Siemens.SimaticIT.MasterData.CHR_MS.MSModel.Types.TimeBasedUoM` |
     */
    TimeBasedMandatoryInspectionWarningUoMNId: TimeBasedUoM | null;
}

export interface DeleteDNCItemResponse extends CommandResponse {
}

export interface DeleteDNCItem {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DNCItemId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    DNCItemId: string;
}

export interface DeleteAMPowderBatchGenealogyResponse extends CommandResponse {
}

export interface DeleteAMPowderBatchGenealogy {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface CreateCustomItlkCheckParameterListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ListOfItlkCheckParameterId` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ListOfItlkCheckParameterId: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Edm.String` |
     */
    WarningMessage: string | null;
}

export interface CreateCustomItlkCheckParameterList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ListOfItlkCheckParameter` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_ITLK.MSModel.Types.CustomItlkCheckParamParameterType)` |
     * | Nullable | `false` |
     */
    ListOfItlkCheckParameter: Array<CustomItlkCheckParamParameterType>;
}

export interface SetConfigurationKeyResponse extends CommandResponse {
}

export interface SetConfigurationKey {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `KeyId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    KeyId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Val` |
     * | Type | `Edm.String` |
     */
    Val: string | null;
}

export interface CreateOperationStructureDependencyListResponse extends CommandResponse {
}

export interface CreateOperationStructureDependencyList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationStructureDependencies` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_BOP.MSModel.Types.OperationStructureDependencyParameterType)` |
     * | Nullable | `false` |
     */
    OperationStructureDependencies: Array<OperationStructureDependencyParameterType>;
}

export interface CreateAndStartWorkProcessListFromProcessDefinitionResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkProcessIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    WorkProcessIdList: Array<string>;
}

export interface CreateAndStartWorkProcessListFromProcessDefinition {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreateAndStartWorkProcessListFromProcessDefinitionParameter` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.FB_OP_DMTask.OPModel.Types.CreateAndStartWorkProcessListFromProcessDefinitionParameterType` |
     * | Nullable | `false` |
     */
    CreateAndStartWorkProcessListFromProcessDefinitionParameter: CreateAndStartWorkProcessListFromProcessDefinitionParameterType;
}

export interface CreateDM_MaterialTrackingUnitHistoryActionResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateDM_MaterialTrackingUnitHistoryAction {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
}

export interface TCM2CreateToolDefinitionListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface TCM2CreateToolDefinitionList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolList` |
     * | Type | `Collection(Siemens.SimaticIT.MasterData.MatTool.MSModel.Types.TCM2ToolDefinitionParameterTypeCreate)` |
     * | Nullable | `false` |
     */
    ToolList: Array<TCM2ToolDefinitionParameterTypeCreate>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     */
    CorrelationId: string | null;
}

export interface UnlinkStepToOperationResponse extends CommandResponse {
}

export interface UnlinkStepToOperation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationToStepLinkIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    OperationToStepLinkIds: Array<string>;
}

export interface CreateNonConformanceSupervisorResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateNonConformanceSupervisor {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Defect` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Defect: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     * | Nullable | `false` |
     */
    Sequence: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Status: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `User` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    User: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrder` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrder: string;
}

export interface CoProduceMaterialTrackingUnitResponse extends CommandResponse {
}

export interface CoProduceMaterialTrackingUnit {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStepId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCoProducedMaterials` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ToBeCoProducedMaterialParameterType)` |
     * | Nullable | `false` |
     */
    ToBeCoProducedMaterials: Array<ToBeCoProducedMaterialParameterType>;
}

export interface GetInputResultTypeResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResultsWithType` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ResultWithTypeParameterType)` |
     */
    ResultsWithType: Array<ResultWithTypeParameterType>;
}

export interface GetInputResultType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Results` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ResultParameterType)` |
     * | Nullable | `false` |
     */
    Results: Array<ResultParameterType>;
}

export interface LinkPrintJobFileToEquipmentTypeResponse extends CommandResponse {
}

export interface LinkPrintJobFileToEquipmentType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFile` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    PrintJobFile: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeNIdList` |
     * | Type | `Collection(Edm.String)` |
     */
    EquipmentTypeNIdList: Array<string>;
}

export interface LinkTransferPluginTo3DPrinterResponse extends CommandResponse {
}

export interface LinkTransferPluginTo3DPrinter {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TransferPlugin` |
     * | Type | `Edm.String` |
     */
    TransferPlugin: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeNId` |
     * | Type | `Edm.String` |
     */
    EquipmentTypeNId: string | null;
}

export interface CreateSnagAndNoteListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface CreateSnagAndNoteList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Messages` |
     * | Type | `Collection(Edm.String)` |
     */
    Messages: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Status: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsWorkOrderLevel` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsWorkOrderLevel: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsAutomatic` |
     * | Type | `Edm.Boolean` |
     */
    IsAutomatic: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TimeStampAutomatic` |
     * | Type | `Edm.DateTimeOffset` |
     */
    TimeStampAutomatic: string | null;
}

export interface LinkSuppliersToMaterialV4_0Response extends CommandResponse {
}

export interface LinkSuppliersToMaterialV4_0 {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Material` |
     * | Type | `Siemens.SimaticIT.UADM.MasterData.FB_MS_MAT.MSModel.Types.MaterialValueParameterType` |
     * | Nullable | `false` |
     */
    Material: MaterialValueParameterType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SupplierNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    SupplierNId: string;
}

export interface UpdateStateMachineResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StatusIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    StatusIdList: Array<string>;
}

export interface UpdateStateMachine {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StatusList` |
     * | Type | `Collection(Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.StatusParameterType)` |
     */
    StatusList: Array<StatusParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
}

export interface DeleteCertificationResponse extends CommandResponse {
}

export interface DeleteCertification {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DeleteCertificationParameter` |
     * | Type | `Siemens.SimaticIT.U4DM.MasterData.FB_MS_CERT.MSModel.Types.DeleteCertificationParameterType` |
     * | Nullable | `false` |
     */
    DeleteCertificationParameter: DeleteCertificationParameterType;
}

export interface EditWorkOrderOperationResponse extends CommandResponse {
}

export interface EditWorkOrderOperation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedStartTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedStartTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedEndTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedEndTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOperationTypeId` |
     * | Type | `Edm.Guid` |
     */
    WorkOperationTypeId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Optional` |
     * | Type | `Edm.Boolean` |
     */
    Optional: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RequiredCertificateNId` |
     * | Type | `Edm.String` |
     */
    RequiredCertificateNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RequiredInspectionRole` |
     * | Type | `Edm.String` |
     */
    RequiredInspectionRole: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignatureStart` |
     * | Type | `Edm.Boolean` |
     */
    ElectronicSignatureStart: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignaturePause` |
     * | Type | `Edm.Boolean` |
     */
    ElectronicSignaturePause: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignatureComplete` |
     * | Type | `Edm.Boolean` |
     */
    ElectronicSignatureComplete: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedDuration` |
     * | Type | `Edm.Duration` |
     */
    EstimatedDuration: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCollectedDocument` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCollectedDocument: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActiveNonConformanceNr` |
     * | Type | `Edm.Int32` |
     */
    ActiveNonConformanceNr: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationStepCategoryId` |
     * | Type | `Edm.Guid` |
     */
    OperationStepCategoryId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     */
    Sequence: number | null;
}

export interface LinkWorkInstructionsToEGPhaseResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface LinkWorkInstructionsToEGPhase {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionDefinitionIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    WorkInstructionDefinitionIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionPhaseId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ExecutionPhaseId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SerialNumbers` |
     * | Type | `Collection(Edm.String)` |
     */
    SerialNumbers: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsReEditEnabled` |
     * | Type | `Edm.Boolean` |
     */
    IsReEditEnabled: boolean | null;
}

export interface SkipWOOperationFullQtyResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationNId: string | null;
}

export interface SkipWOOperationFullQty {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReasonNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ReasonNId: string;
}

export interface APSSetInSchedulingResponse extends CommandResponse {
}

export interface APSSetInScheduling {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NIds` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.FB_OP_APSInt.OPModel.Types.NIdsParameterType` |
     * | Nullable | `false` |
     */
    NIds: NIdsParameterType;
}

export interface AssignCertificationToSkillListResponse extends CommandResponse {
}

export interface AssignCertificationToSkillList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CertificationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    CertificationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SkillIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    SkillIds: Array<string>;
}

export interface SetDueDateOnExecGroupResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DueDate` |
     * | Type | `Edm.DateTimeOffset` |
     */
    DueDate: string | null;
}

export interface SetDueDateOnExecGroup {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecGroupNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ExecGroupNId: string;
}

export interface DeleteOperationListFromCatalogueResponse extends CommandResponse {
}

export interface DeleteOperationListFromCatalogue {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface TCM2DeleteLinkProcessToOperationListResponse extends CommandResponse {
}

export interface TCM2DeleteLinkProcessToOperationList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface SentenceNonConformanceV3_1Response extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReworkOrderId` |
     * | Type | `Edm.Guid` |
     */
    ReworkOrderId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CurrentStatus` |
     * | Type | `Edm.String` |
     */
    CurrentStatus: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceHistoryIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    NonConformanceHistoryIds: Array<string>;
}

export interface SentenceNonConformanceV3_1 {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NonConformanceNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceStatusNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NonConformanceStatusNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DocumentIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReworkProcessId` |
     * | Type | `Edm.Guid` |
     */
    ReworkProcessId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformancePartialWOOpQuantities` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.NonConformanceQuantities4PartialSentenceParameterType` |
     */
    NonConformancePartialWOOpQuantities: NonConformanceQuantities4PartialSentenceParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsAutomaticallyInvoked` |
     * | Type | `Edm.Boolean` |
     */
    IsAutomaticallyInvoked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNIdList` |
     * | Type | `Collection(Edm.String)` |
     */
    EquipmentNIdList: Array<string>;
}

export interface DeleteStepDependencyListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Edm.String` |
     */
    WarningMessage: string | null;
}

export interface DeleteStepDependencyList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface GetOfflineWorkInstructionsResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructions` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.FB_OP_Offline.OPModel.Types.OfflineWorkInstruction)` |
     */
    WorkInstructions: Array<OfflineWorkInstruction>;
}

export interface GetOfflineWorkInstructions {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    WorkOrderOperationIds: Array<string>;
}

export interface UnlinkOperationListToProcessResponse extends CommandResponse {
}

export interface UnlinkOperationListToProcess {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OprationIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    OprationIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ProcessId: string;
}

export interface DeleteEquipmentGraphLinkConfigurationResponse extends CommandResponse {
}

export interface DeleteEquipmentGraphLinkConfiguration {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface CompleteScrewingWOOpOnToolDeactivationResponse extends CommandResponse {
}

export interface CompleteScrewingWOOpOnToolDeactivation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutomationNodeInstanceNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    AutomationNodeInstanceNId: string;
}

export interface CheckInStartWOStepTransferBatchResponse extends CommandResponse {
}

export interface CheckInStartWOStepTransferBatch {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StartWOStepTransferBatchParameter` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.StartWOStepTransferBatchParameterType` |
     * | Nullable | `false` |
     */
    StartWOStepTransferBatchParameter: StartWOStepTransferBatchParameterType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OfflineActionInternalId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OfflineActionInternalId: string;
}

export interface CreateNonConformanceNotificationResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface CreateNonConformanceNotification {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NonConformanceNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceType` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NonConformanceType: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserRole` |
     * | Type | `Edm.String` |
     */
    UserRole: string | null;
}

export interface LinkDocumentListToOperationResponse extends CommandResponse {
}

export interface LinkDocumentListToOperation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ListOfDocumentId` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ListOfDocumentId: Array<string>;
}

export interface LoadHandlingUnitResponse extends CommandResponse {
}

export interface LoadHandlingUnit {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `HandlingUnit` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    HandlingUnit: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItem` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    MaterialItem: Array<string>;
}

export interface ConsumeMaterialItemOnContainerResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Collection(Edm.String)` |
     */
    WarningMessage: Array<string>;
}

export interface ConsumeMaterialItemOnContainer {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStepId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItemToConsumeOnContainerList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.FB_OP_ContainerExec.OPModel.Types.MaterialItemToConsumeOnContainerParameterType)` |
     * | Nullable | `false` |
     */
    MaterialItemToConsumeOnContainerList: Array<MaterialItemToConsumeOnContainerParameterType>;
}

export interface SetEquipmentPropertyValueResponse extends CommandResponse {
}

export interface SetEquipmentPropertyValue {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentPropertyId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    EquipmentPropertyId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentPropertyValue` |
     * | Type | `Edm.String` |
     */
    EquipmentPropertyValue: string | null;
}

export interface CheckInConsumeMaterialItemResponse extends CommandResponse {
}

export interface CheckInConsumeMaterialItem {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItemToConsumeList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.MaterialItemToConsumeParameterType)` |
     * | Nullable | `false` |
     */
    MaterialItemToConsumeList: Array<MaterialItemToConsumeParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStepId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OfflineActionInternalId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OfflineActionInternalId: string;
}

export interface UADMCreateNewToolDefinitionRevisionResponse extends CommandResponse {
}

export interface UADMCreateNewToolDefinitionRevision {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface AcceptChangeChangeToBeConsumedMaterialQuantityResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceNId` |
     * | Type | `Edm.String` |
     */
    NonConformanceNId: string | null;
}

export interface AcceptChangeChangeToBeConsumedMaterialQuantity {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChangePartId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ChangePartId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeConsumedMaterialId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToBeConsumedMaterialId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NewQuantity` |
     * | Type | `Edm.Decimal` |
     * | Nullable | `false` |
     */
    NewQuantity: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RefNumber` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    RefNumber: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsMaterialBehaviourOutputTypeFlag0` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsMaterialBehaviourOutputTypeFlag0: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsMaterialBehaviourOutputType` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsMaterialBehaviourOutputType: boolean;
}

export interface DeletePauseReasonResponse extends CommandResponse {
}

export interface DeletePauseReason {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface ManageResultListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResultIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ResultIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Collection(Edm.String)` |
     */
    WarningMessage: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ManagedResultList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.FB_OP_Result.OPModel.Types.OnResultCreationParameterType)` |
     */
    ManagedResultList: Array<OnResultCreationParameterType>;
}

export interface ManageResultList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResultList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.FB_OP_Result.OPModel.Types.ManageResultListParameterType)` |
     * | Nullable | `false` |
     */
    ResultList: Array<ManageResultListParameterType>;
}

export interface AutomaticSentenceNonConformanceResponse extends CommandResponse {
}

export interface AutomaticSentenceNonConformance {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentName` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    EquipmentName: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NonConformanceNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TimeStamp` |
     * | Type | `Edm.DateTimeOffset` |
     */
    TimeStamp: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetStatus` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    TargetStatus: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Int32` |
     */
    Quantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SerialNumberCodeList` |
     * | Type | `Collection(Edm.String)` |
     */
    SerialNumberCodeList: Array<string>;
}

export interface UnlinkUserToWorkOrderOperationListResponse extends CommandResponse {
}

export interface UnlinkUserToWorkOrderOperationList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserToWorkOrderOperationList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    UserToWorkOrderOperationList: Array<string>;
}

export interface CreateNonConformanceResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceNId` |
     * | Type | `Edm.String` |
     */
    NonConformanceNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceGroupPathList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.NonConformanceGroupPathParameterType)` |
     */
    NonConformanceGroupPathList: Array<NonConformanceGroupPathParameterType>;
}

export interface CreateNonConformance {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceDetail` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.NonConformanceParameterType` |
     * | Nullable | `false` |
     */
    NonConformanceDetail: NonConformanceParameterType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceHistoryDetail` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.NonConformanceHistoryParameterType` |
     * | Nullable | `false` |
     */
    NonConformanceHistoryDetail: NonConformanceHistoryParameterType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefectsDetails` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.DefectParameterType)` |
     */
    DefectsDetails: Array<DefectParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExtensionKey` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ExtensionKey: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Context` |
     * | Type | `Edm.String` |
     */
    Context: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChangeOperationProperties` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ChangeOperationParameterType` |
     */
    ChangeOperationProperties: ChangeOperationParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChangePartProperties` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ChangePartParameterType` |
     */
    ChangePartProperties: ChangePartParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChangeDataCollectionProperties` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ChangeDataCollectionParameterType` |
     */
    ChangeDataCollectionProperties: ChangeDataCollectionParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChangeToolProperties` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ChangeToolParameterType` |
     */
    ChangeToolProperties: ChangeToolParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChangeRoutingProperties` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ChangeRoutingParameterType` |
     */
    ChangeRoutingProperties: ChangeRoutingParameterType | null;
}

export interface TCM2CreateProcessListResponse extends CommandResponse {
}

export interface TCM2CreateProcessList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_BOP.MSModel.Types.TCM2ProcessParameterType)` |
     * | Nullable | `false` |
     */
    ProcessList: Array<TCM2ProcessParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     */
    CorrelationId: string | null;
}

export interface CreateEquipmentSpecificationWithPrintJobFileResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentSpecificationId` |
     * | Type | `Edm.Guid` |
     */
    EquipmentSpecificationId: string | null;
}

export interface CreateEquipmentSpecificationWithPrintJobFile {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentSpecification` |
     * | Type | `Siemens.SimaticIT.U4DM.MasterData.FB_MS_BOP.MSModel.Types.EquipmentSpecificationParameterType` |
     * | Nullable | `false` |
     */
    EquipmentSpecification: EquipmentSpecificationParameterType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFile` |
     * | Type | `Edm.Guid` |
     */
    PrintJobFile: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFileExtId` |
     * | Type | `Edm.String` |
     */
    PrintJobFileExtId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFileName` |
     * | Type | `Edm.String` |
     */
    PrintJobFileName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFileSource` |
     * | Type | `Edm.String` |
     */
    PrintJobFileSource: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Process` |
     * | Type | `Edm.Guid` |
     */
    Process: string | null;
}

export interface UpdateOperationDependencyResponse extends CommandResponse {
}

export interface UpdateOperationDependency {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationDependency` |
     * | Type | `Siemens.SimaticIT.U4DM.MasterData.FB_MS_BOP.MSModel.Types.OperationDependencyParameterType` |
     * | Nullable | `false` |
     */
    OperationDependency: OperationDependencyParameterType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface SkipWOOperationSerializedResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationNId: string | null;
}

export interface SkipWOOperationSerialized {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MTUIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DM_MTUIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReasonNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ReasonNId: string;
}

export interface DeleteSkipReasonResponse extends CommandResponse {
}

export interface DeleteSkipReason {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface UpdateCertificationResponse extends CommandResponse {
}

export interface UpdateCertification {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
}

export interface LinkWIDefinitionsToWOOperationResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface LinkWIDefinitionsToWOOperation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionDefinitionIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    WorkInstructionDefinitionIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionAssociationType` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkInstructionAssociationType: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `HideOnExecGroup` |
     * | Type | `Edm.Boolean` |
     */
    HideOnExecGroup: boolean | null;
}

export interface CreateSkill_BOPResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateSkill_BOP {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Name: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Color` |
     * | Type | `Edm.String` |
     */
    Color: string | null;
}

export interface SetEquipmentPreferencesForUserResponse extends CommandResponse {
}

export interface SetEquipmentPreferencesForUser {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    EquipmentNId: string;
}

export interface AcceptChangeRemoveDependencyResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceNId` |
     * | Type | `Edm.String` |
     */
    NonConformanceNId: string | null;
}

export interface AcceptChangeRemoveDependency {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChangeOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ChangeOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOOperationDependencyId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOOperationDependencyId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RefNumber` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    RefNumber: string;
}

export interface UnlinkPrintJobFileToMachineResponse extends CommandResponse {
}

export interface UnlinkPrintJobFileToMachine {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFileToMachine` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    PrintJobFileToMachine: string;
}

export interface DeleteFutureHoldResponse extends CommandResponse {
}

export interface DeleteFutureHold {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface DeleteEquipmentConfigurationPropertyAttributeResponse extends CommandResponse {
}

export interface DeleteEquipmentConfigurationPropertyAttribute {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface CreateMaterialSpecificationListResponse extends CommandResponse {
}

export interface CreateMaterialSpecificationList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialSpecificationList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_BOP.MSModel.Types.MaterialSpecificationParameterType)` |
     * | Nullable | `false` |
     */
    MaterialSpecificationList: Array<MaterialSpecificationParameterType>;
}

export interface ValidateDataCollectionIsCompleteResponse extends CommandResponse {
}

export interface ValidateDataCollectionIsComplete {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStepId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MTUIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DM_MTUIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupPhaseId` |
     * | Type | `Edm.Guid` |
     */
    ExecutionGroupPhaseId: string | null;
}

export interface TCM2CreateToolSpecificationFullListResponse extends CommandResponse {
}

export interface TCM2CreateToolSpecificationFullList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolSpecificationList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_BOP.MSModel.Types.TCM2ToolSpecificationParameterType)` |
     * | Nullable | `false` |
     */
    ToolSpecificationList: Array<TCM2ToolSpecificationParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     */
    CorrelationId: string | null;
}

export interface DeleteCharacteristicRepresentationResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NotDeletedIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    NotDeletedIds: Array<string>;
}

export interface DeleteCharacteristicRepresentation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface AutomaticUseToolListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Edm.String` |
     */
    WarningMessage: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UsedToolList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.UsedToolParameterType)` |
     */
    UsedToolList: Array<UsedToolParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TimesOfToolUsage` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.TimesOfToolUsageParameterType)` |
     */
    TimesOfToolUsage: Array<TimesOfToolUsageParameterType>;
}

export interface AutomaticUseToolList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderStepNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentName` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    EquipmentName: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TimeStamp` |
     * | Type | `Edm.DateTimeOffset` |
     * | Nullable | `false` |
     */
    TimeStamp: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolToBeUsedList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ToolToBeUsedOnSNParameterType)` |
     * | Nullable | `false` |
     */
    ToolToBeUsedList: Array<ToolToBeUsedOnSNParameterType>;
}

export interface SetConfigurationKeyListResponse extends CommandResponse {
}

export interface SetConfigurationKeyList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `KeyId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    KeyId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ValueList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.RD.FB.ReferenceData.ConfigKey.RFModel.Types.KeyMultiValueParameterType)` |
     */
    ValueList: Array<KeyMultiValueParameterType>;
}

export interface UpdateLinkStepToOperationResponse extends CommandResponse {
}

export interface UpdateLinkStepToOperation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBOPId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    AsPlannedBOPId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StepId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    StepId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OldSequence` |
     * | Type | `Edm.Int32` |
     * | Nullable | `false` |
     */
    OldSequence: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NewSequence` |
     * | Type | `Edm.Int32` |
     * | Nullable | `false` |
     */
    NewSequence: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCollectedDocument` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCollectedDocument: boolean | null;
}

export interface UpdateWorkOrderOperationActualExecutionTimesResponse extends CommandResponse {
}

export interface UpdateWorkOrderOperationActualExecutionTimes {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualStartTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    ActualStartTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualEndTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    ActualEndTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionDuration` |
     * | Type | `Edm.Duration` |
     */
    ExecutionDuration: string | null;
}

export interface CreateSkillResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateSkill {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
}

export interface UADMUpdateMaterialSpecificationResponse extends CommandResponse {
}

export interface UADMUpdateMaterialSpecification {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    Quantity: QuantityParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogicalPosition` |
     * | Type | `Edm.String` |
     */
    LogicalPosition: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `GroupId` |
     * | Type | `Edm.String` |
     */
    GroupId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AlternativeSelected` |
     * | Type | `Edm.Boolean` |
     */
    AlternativeSelected: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EffectivityExpression` |
     * | Type | `Edm.String` |
     */
    EffectivityExpression: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OccurrenceId` |
     * | Type | `Edm.String` |
     */
    OccurrenceId: string | null;
}

export interface DNCGetMachineDNCItemAssociationResponse extends CommandResponse {
}

export interface DNCGetMachineDNCItemAssociation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsDeltaImport` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsDeltaImport: boolean;
}

export interface MaterialItemSplitBatchResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SplitContextList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.SplitContext)` |
     */
    SplitContextList: Array<SplitContext>;
}

export interface MaterialItemSplitBatch {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SplitBatchList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.MaterialItemForSplitType)` |
     */
    SplitBatchList: Array<MaterialItemForSplitType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItemId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    MaterialItemId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsCalledFromConsumeOfMTU` |
     * | Type | `Edm.Boolean` |
     */
    IsCalledFromConsumeOfMTU: boolean | null;
}

export interface UnlinkSetPointItemToSetPointResponse extends CommandResponse {
}

export interface UnlinkSetPointItemToSetPoint {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    SetPointId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointItemList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    SetPointItemList: Array<string>;
}

export interface ConfirmSnagAndNoteListResponse extends CommandResponse {
}

export interface ConfirmSnagAndNoteList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SnagAndNoteIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    SnagAndNoteIds: Array<string>;
}

export interface ConfirmWorkOrderResponse extends CommandResponse {
}

export interface ConfirmWorkOrder {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OrderID` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    OrderID: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PlantID` |
     * | Type | `Edm.String` |
     */
    PlantID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EventId` |
     * | Type | `Edm.Guid` |
     */
    EventId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `completion` |
     * | Type | `Edm.Boolean` |
     */
    completion: boolean | null;
}

export interface ScheduleExecutionGroupResponse extends CommandResponse {
}

export interface ScheduleExecutionGroup {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ExecutionGroupId: string;
}

export interface AssociateContainerToWorkOrderResponse extends CommandResponse {
}

export interface AssociateContainerToWorkOrder {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContainerNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ContainerNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkOrderNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationNId: string | null;
}

export interface CreateProcessListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedProcesses` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_BOP.MSModel.Types.OutputProcessParameterType)` |
     */
    CreatedProcesses: Array<OutputProcessParameterType>;
}

export interface CreateProcessList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Processes` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_BOP.MSModel.Types.ProcessParameterType)` |
     * | Nullable | `false` |
     */
    Processes: Array<ProcessParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    CorrelationId: string;
}

export interface TCM2DeleteLinkOperationToStepListResponse extends CommandResponse {
}

export interface TCM2DeleteLinkOperationToStepList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface AcceptChangeAddToBeUsedToolResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceNId` |
     * | Type | `Edm.String` |
     */
    NonConformanceNId: string | null;
}

export interface AcceptChangeAddToBeUsedTool {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RefNumber` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    RefNumber: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogicalPosition` |
     * | Type | `Edm.String` |
     */
    LogicalPosition: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolDefinitionNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ToolDefinitionNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolUsage` |
     * | Type | `Edm.Decimal` |
     * | Nullable | `false` |
     */
    ToolUsage: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChangeToolId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ChangeToolId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolDefinitionId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToolDefinitionId: string;
}

export interface DeassociateDNCItemMachineMaterialAssociationResponse extends CommandResponse {
}

export interface DeassociateDNCItemMachineMaterialAssociation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DNCItemId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    DNCItemId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MachineToDNCId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    MachineToDNCId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    DM_MaterialId: string;
}

export interface DeleteUoMDimensionResponse extends CommandResponse {
}

export interface DeleteUoMDimension {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface CompleteWOOperationTransferBatchResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderHistoryId` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    WorkOrderHistoryId: Array<string>;
}

export interface CompleteWOOperationTransferBatch {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupPhaseId` |
     * | Type | `Edm.Guid` |
     */
    ExecutionGroupPhaseId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CompleteWOOperationTransferBatchParameterType` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.CompleteWOOperationTransferBatchParameterType` |
     * | Nullable | `false` |
     */
    CompleteWOOperationTransferBatchParameterType: CompleteWOOperationTransferBatchParameterType;
}

export interface LinkSetPointItemToSetPointResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface LinkSetPointItemToSetPoint {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Name: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DataType` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    DataType: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Editable` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    Editable: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefaultValues` |
     * | Type | `Collection(Edm.String)` |
     */
    DefaultValues: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    SetPointId: string;
}

export interface SaveResultQuantitiesOnWorkOrderOperationListResponse extends CommandResponse {
}

export interface SaveResultQuantitiesOnWorkOrderOperationList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    WorkOrderOperationIdList: Array<string>;
}

export interface CreateWIResultListResponse extends CommandResponse {
}

export interface CreateWIResultList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WIResultList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.FB_OP_Result.OPModel.Types.WIResult)` |
     * | Nullable | `false` |
     */
    WIResultList: Array<WIResult>;
}

export interface UnLinkToolsFromNonConformanceResponse extends CommandResponse {
}

export interface UnLinkToolsFromNonConformance {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    NonConformanceId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ToolIds: Array<string>;
}

export interface AssignCertificationToUserListResponse extends CommandResponse {
}

export interface AssignCertificationToUserList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CertificationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    CertificationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Users` |
     * | Type | `Collection(Edm.String)` |
     */
    Users: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExpiryDate` |
     * | Type | `Edm.DateTimeOffset` |
     * | Nullable | `false` |
     */
    ExpiryDate: string;
}

export interface EndIdTemplateEditingResponse extends CommandResponse {
}

export interface EndIdTemplateEditing {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TemplateId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    TemplateId: string;
}

export interface LinkDocumentListToEGPhaseResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface LinkDocumentListToEGPhase {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupPhaseId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ExecutionGroupPhaseId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DocumentIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItemIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    MaterialItemIds: Array<string>;
}

export interface ManageRepeatResultForScrappedMTUResponse extends CommandResponse {
}

export interface ManageRepeatResultForScrappedMTU {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MTUNIdList` |
     * | Type | `Collection(Edm.String)` |
     */
    MTUNIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkOrderNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NonConformanceNId: string;
}

export interface DeleteProducedMaterialUnderReworkResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Edm.String` |
     */
    WarningMessage: string | null;
}

export interface DeleteProducedMaterialUnderRework {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedMaterialItemUnderReworkId` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ProducedMaterialItemUnderReworkId: Array<string>;
}

export interface DeleteWorkOrderNotificationListResponse extends CommandResponse {
}

export interface DeleteWorkOrderNotificationList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderNotificationIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    WorkOrderNotificationIdList: Array<string>;
}

export interface DeleteWorkOStepDependencyResponse extends CommandResponse {
}

export interface DeleteWorkOStepDependency {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Dependency` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.WorkOStepDependencyParameter` |
     * | Nullable | `false` |
     */
    Dependency: WorkOStepDependencyParameter;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface DeleteHoldReasonResponse extends CommandResponse {
}

export interface DeleteHoldReason {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface LinkCharacteristicRepresentationToOperationResponse extends CommandResponse {
}

export interface LinkCharacteristicRepresentationToOperation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CharacteristicRepresentationNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    CharacteristicRepresentationNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBOPId` |
     * | Type | `Edm.Guid` |
     */
    AsPlannedBOPId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlanId` |
     * | Type | `Edm.Guid` |
     */
    MasterPlanId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CharacteristicRepresentationRevision` |
     * | Type | `Edm.String` |
     */
    CharacteristicRepresentationRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReferencedOperation` |
     * | Type | `Edm.String` |
     */
    ReferencedOperation: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsWOSpecific` |
     * | Type | `Edm.Boolean` |
     */
    IsWOSpecific: boolean | null;
}

export interface ManageToBeConsumedMaterialDisassembleResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OpenNonConformance` |
     * | Type | `Edm.Boolean` |
     */
    OpenNonConformance: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsStep` |
     * | Type | `Edm.Boolean` |
     */
    IsStep: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Edm.String` |
     */
    WarningMessage: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnitHistoryIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DM_MaterialTrackingUnitHistoryIdList: Array<string>;
}

export interface ManageToBeConsumedMaterialDisassemble {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeConsumedMaterialId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToBeConsumedMaterialId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItemIdentifiersList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.MaterialItemIdentifiersParameterType)` |
     */
    MaterialItemIdentifiersList: Array<MaterialItemIdentifiersParameterType>;
}

export interface LinkMaterialTrackingUnitToContainerListResponse extends CommandResponse {
}

export interface LinkMaterialTrackingUnitToContainerList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContainerNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ContainerNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialTrackingUnitNIdList` |
     * | Type | `Collection(Edm.String)` |
     */
    MaterialTrackingUnitNIdList: Array<string>;
}

export interface AssignNonConformanceTransitionRoleListResponse extends CommandResponse {
}

export interface AssignNonConformanceTransitionRoleList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceTransitionId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NonConformanceTransitionId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RoleList` |
     * | Type | `Collection(Edm.String)` |
     */
    RoleList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LifeCycle` |
     * | Type | `Edm.String` |
     */
    LifeCycle: string | null;
}

export interface CheckInPauseWOOperationResponse extends CommandResponse {
}

export interface CheckInPauseWOOperation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OfflineActionInternalId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OfflineActionInternalId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PauseWOOperationParameterType` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.PauseWOOperationParameterType` |
     * | Nullable | `false` |
     */
    PauseWOOperationParameterType: PauseWOOperationParameterType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupPhaseId` |
     * | Type | `Edm.Guid` |
     */
    ExecutionGroupPhaseId: string | null;
}

export interface CreateOperationStructureDependencyResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateOperationStructureDependency {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationStructureDependency` |
     * | Type | `Siemens.SimaticIT.U4DM.MasterData.FB_MS_BOP.MSModel.Types.OperationStructureDependencyParameterType` |
     * | Nullable | `false` |
     */
    OperationStructureDependency: OperationStructureDependencyParameterType;
}

export interface CreateStateMachineResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StateMachineId` |
     * | Type | `Edm.Guid` |
     */
    StateMachineId: string | null;
}

export interface CreateStateMachine {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
}

export interface DeleteStatusTransitionResponse extends CommandResponse {
}

export interface DeleteStatusTransition {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface UnLinkWorkInstructionDefinitionListFromStepResponse extends CommandResponse {
}

export interface UnLinkWorkInstructionDefinitionListFromStep {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StepId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    StepId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionDefinitionList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    WorkInstructionDefinitionList: Array<string>;
}

export interface StartWOStepTransferBatchResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderHistoryId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderHistoryId: string | null;
}

export interface StartWOStepTransferBatch {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StartWOStepTransferBatchParameter` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.StartWOStepTransferBatchParameterType` |
     * | Nullable | `false` |
     */
    StartWOStepTransferBatchParameter: StartWOStepTransferBatchParameterType;
}

export interface CreateWorkOrderNotificationResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderNotificationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderNotificationId: string | null;
}

export interface CreateWorkOrderNotification {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkOrderNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStatus` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkOrderStatus: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderFinalMaterial` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkOrderFinalMaterial: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderEstimatedStartTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    WorkOrderEstimatedStartTime: string | null;
}

export interface UnlinkUserToPlantResponse extends CommandResponse {
}

export interface UnlinkUserToPlant {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserId` |
     * | Type | `Edm.String` |
     */
    UserId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    EquipmentNId: string;
}

export interface CreateDefectGroupResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateDefectGroup {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Name: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Description: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChildrenIdentifiersList` |
     * | Type | `Collection(Siemens.SimaticIT.MasterData.MatTool.MSModel.Types.IdentifiersParameterType)` |
     */
    ChildrenIdentifiersList: Array<IdentifiersParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentIdentifiersList` |
     * | Type | `Collection(Siemens.SimaticIT.MasterData.MatTool.MSModel.Types.IdentifiersParameterType)` |
     */
    ParentIdentifiersList: Array<IdentifiersParameterType>;
}

export interface CheckMaterialConsumptionResponse extends CommandResponse {
}

export interface CheckMaterialConsumption {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedMaterialItems` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ProducedMaterialItemQuantity)` |
     * | Nullable | `false` |
     */
    ProducedMaterialItems: Array<ProducedMaterialItemQuantity>;
}

export interface GetResolvedToBeUsedMachinesOnWOOperationListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResolvedToBeUsedMachinesOnWOOperationList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.FB_OP_Offline.OPModel.Types.ResolvedToBeUsedMachinesOnWOOpParameterType)` |
     */
    ResolvedToBeUsedMachinesOnWOOperationList: Array<ResolvedToBeUsedMachinesOnWOOpParameterType>;
}

export interface GetResolvedToBeUsedMachinesOnWOOperationList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    WorkOrderOperationIdList: Array<string>;
}

export interface LinkAutomationNodeInstanceParameterToMaterialParameterListResponse extends CommandResponse {
}

export interface LinkAutomationNodeInstanceParameterToMaterialParameterList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ATNInstanceParameter` |
     * | Type | `Siemens.SimaticIT.U4DM.MasterData.FB_MS_AGWInt.MSModel.Types.ATNInstanceParameterType` |
     * | Nullable | `false` |
     */
    ATNInstanceParameter: ATNInstanceParameterType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialIdentifierList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    MaterialIdentifierList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialParameterNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    MaterialParameterNId: string;
}

export interface CreateUoMFactorResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoMFactorId` |
     * | Type | `Edm.Guid` |
     */
    UoMFactorId: string | null;
}

export interface CreateUoMFactor {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `K0Multiplier` |
     * | Type | `Edm.Decimal` |
     */
    K0Multiplier: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Addend` |
     * | Type | `Edm.Decimal` |
     */
    Addend: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `K1Multiplier` |
     * | Type | `Edm.Decimal` |
     */
    K1Multiplier: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Exponent` |
     * | Type | `Edm.Int16` |
     */
    Exponent: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetUoMId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    TargetUoMId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceUoMId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    SourceUoMId: string;
}

export interface CreateWorkOrderHistoryActionResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateWorkOrderHistoryAction {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
}

export interface CreateContainerTypeResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContainerTypeId` |
     * | Type | `Edm.Guid` |
     */
    ContainerTypeId: string | null;
}

export interface CreateContainerType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsReusable` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsReusable: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CompatibleMaterialList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_Container.MSModel.Types.MaterialParameterType)` |
     */
    CompatibleMaterialList: Array<MaterialParameterType>;
}

export interface CreateHierarchyEquipmentNodeConfigurationsResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGraphNodeConfigurationIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    EquipmentGraphNodeConfigurationIds: Array<string>;
}

export interface CreateHierarchyEquipmentNodeConfigurations {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentEquipmentGraphNodeConfigurationId` |
     * | Type | `Edm.Guid` |
     */
    ParentEquipmentGraphNodeConfigurationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurations` |
     * | Type | `Collection(Edm.String)` |
     */
    EquipmentConfigurations: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentGraphConfigurationId` |
     * | Type | `Edm.Guid` |
     */
    EquipmentGraphConfigurationId: string | null;
}

export interface UADMCreateNewProcessRevisionMasterPlanResponse extends CommandResponse {
}

export interface UADMCreateNewProcessRevisionMasterPlan {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlanId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    MasterPlanId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ProcessId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentProcessId` |
     * | Type | `Edm.Guid` |
     */
    ParentProcessId: string | null;
}

export interface AssignCertificationToLocationListResponse extends CommandResponse {
}

export interface AssignCertificationToLocationList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CertificationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    CertificationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LocationNIds` |
     * | Type | `Collection(Edm.String)` |
     */
    LocationNIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentType` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    EquipmentType: string;
}

export interface CompleteWOStepTransferBatchResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderHistoryId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderHistoryId: string | null;
}

export interface CompleteWOStepTransferBatch {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CompleteWOStepTransferBatchParameterType` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.CompleteWOStepTransferBatchParameterType` |
     * | Nullable | `false` |
     */
    CompleteWOStepTransferBatchParameterType: CompleteWOStepTransferBatchParameterType;
}

export interface DeleteMaterialListResponse extends CommandResponse {
}

export interface DeleteMaterialList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DM_MaterialIds: Array<string>;
}

export interface StartNonProductiveActivityListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface StartNonProductiveActivityList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NPAIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    NPAIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NPAContextId` |
     * | Type | `Edm.Guid` |
     */
    NPAContextId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NPAContextValue` |
     * | Type | `Edm.Guid` |
     */
    NPAContextValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NPAEquipmentNIdValue` |
     * | Type | `Edm.String` |
     */
    NPAEquipmentNIdValue: string | null;
}

export interface DeleteToBeConsumedMaterialResponse extends CommandResponse {
}

export interface DeleteToBeConsumedMaterial {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeConsumedMaterialId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToBeConsumedMaterialId: string;
}

export interface UpdateEquipmentLevelResponse extends CommandResponse {
}

export interface UpdateEquipmentLevel {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Level` |
     * | Type | `Edm.Int32` |
     */
    Level: number | null;
}

export interface LinkItlkCheckToProcessToOpLinkListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckProcessToOpLinkAssociationIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ItlkCheckProcessToOpLinkAssociationIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Edm.String` |
     */
    WarningMessage: string | null;
}

export interface LinkItlkCheckToProcessToOpLinkList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckProcessToOpLinkAssociationList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_ITLK.MSModel.Types.ItlkCheckProcessToOpLinkAssociationParameterType)` |
     * | Nullable | `false` |
     */
    ItlkCheckProcessToOpLinkAssociationList: Array<ItlkCheckProcessToOpLinkAssociationParameterType>;
}

export interface CreateFailureResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentId` |
     * | Type | `Edm.Guid` |
     */
    ParentId: string | null;
}

export interface CreateFailure {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentId` |
     * | Type | `Edm.Guid` |
     */
    ParentId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Revision: string;
}

export interface DeleteDNCItemMachineMaterialAssociationResponse extends CommandResponse {
}

export interface DeleteDNCItemMachineMaterialAssociation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DNCItemMachineMaterialAssociationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    DNCItemMachineMaterialAssociationId: string;
}

export interface SentenceNonConformanceSetLocationHoldResponse extends CommandResponse {
}

export interface SentenceNonConformanceSetLocationHold {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NonConformanceNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `HoldReasonNIdList` |
     * | Type | `Collection(Edm.String)` |
     */
    HoldReasonNIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Comment` |
     * | Type | `Edm.String` |
     */
    Comment: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNIdList` |
     * | Type | `Collection(Edm.String)` |
     */
    EquipmentNIdList: Array<string>;
}

export interface RemoveWorkOrderScrapResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderId: string | null;
}

export interface RemoveWorkOrderScrap {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Notes: string;
}

export interface UpdateDM_MaterialTrackingUnitHistoryResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnitHistoryId` |
     * | Type | `Edm.Guid` |
     */
    DM_MaterialTrackingUnitHistoryId: string | null;
}

export interface UpdateDM_MaterialTrackingUnitHistory {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserId` |
     * | Type | `Edm.String` |
     */
    UserId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Date` |
     * | Type | `Edm.DateTimeOffset` |
     */
    Date: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Action` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Action: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MixedQuantity` |
     * | Type | `Edm.Int32` |
     */
    MixedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OldQuantity` |
     * | Type | `Edm.Decimal` |
     */
    OldQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RecycleCount` |
     * | Type | `Edm.Int32` |
     */
    RecycleCount: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnit` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    DM_MaterialTrackingUnit: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrder` |
     * | Type | `Edm.Guid` |
     */
    WorkOrder: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperation: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStep` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStep: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceDM_MaterialTrackingUnit` |
     * | Type | `Edm.Guid` |
     */
    SourceDM_MaterialTrackingUnit: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetDM_MaterialTrackingUnit` |
     * | Type | `Edm.Guid` |
     */
    TargetDM_MaterialTrackingUnit: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Code` |
     * | Type | `Edm.String` |
     */
    Code: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CodeType` |
     * | Type | `Siemens.SimaticIT.OperationalData.MAT_OP.OPModel.Types.MTUCodeType` |
     */
    CodeType: MTUCodeType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceCode` |
     * | Type | `Edm.String` |
     */
    SourceCode: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetCode` |
     * | Type | `Edm.String` |
     */
    TargetCode: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     */
    Status: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnitHistoryId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    DM_MaterialTrackingUnitHistoryId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OldCode` |
     * | Type | `Edm.String` |
     */
    OldCode: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NewCode` |
     * | Type | `Edm.String` |
     */
    NewCode: string | null;
}

export interface CreateStatusTransitionResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StatusTransitionId` |
     * | Type | `Edm.Guid` |
     */
    StatusTransitionId: string | null;
}

export interface CreateStatusTransition {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceStatusId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    SourceStatusId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetStatusId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    TargetStatusId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DoRaiseEvent` |
     * | Type | `Edm.Boolean` |
     */
    DoRaiseEvent: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StatusTransitionDefinitionVerb` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    StatusTransitionDefinitionVerb: string;
}

export interface SetEquipmentPropertyAttributeValueResponse extends CommandResponse {
}

export interface SetEquipmentPropertyAttributeValue {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentPropertyAttributeId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    EquipmentPropertyAttributeId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentPropertyAttributeValue` |
     * | Type | `Edm.String` |
     */
    EquipmentPropertyAttributeValue: string | null;
}

export interface ReopenWorkOrderOperationTransferBatchResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderIdentifiers` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.IdentifiersParameterType` |
     */
    WorkOrderIdentifiers: IdentifiersParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationIdentifiers` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.IdentifiersParameterType` |
     */
    WorkOrderOperationIdentifiers: IdentifiersParameterType | null;
}

export interface ReopenWorkOrderOperationTransferBatch {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderIdentifiers` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.IdentifiersParameterType` |
     * | Nullable | `false` |
     */
    WorkOrderIdentifiers: IdentifiersParameterType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationIdentifiers` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.IdentifiersParameterType` |
     * | Nullable | `false` |
     */
    WorkOrderOperationIdentifiers: IdentifiersParameterType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `QuantityToReopen` |
     * | Type | `Edm.Decimal` |
     */
    QuantityToReopen: number | null;
}

export interface ManageToBeConsumedMaterialDisassembleOnContainerResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Edm.String` |
     */
    WarningMessage: string | null;
}

export interface ManageToBeConsumedMaterialDisassembleOnContainer {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeConsumedMaterialId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToBeConsumedMaterialId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContainerNIdList` |
     * | Type | `Collection(Edm.String)` |
     */
    ContainerNIdList: Array<string>;
}

export interface UnlinkWorkInstructionsFromWOOperationResponse extends CommandResponse {
}

export interface UnlinkWorkInstructionsFromWOOperation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    WorkInstructionIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
}

export interface SetLocationHoldResponse extends CommandResponse {
}

export interface SetLocationHold {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentIdentifiers` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    EquipmentIdentifiers: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `HoldReasonNIdList` |
     * | Type | `Collection(Edm.String)` |
     */
    HoldReasonNIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Comment` |
     * | Type | `Edm.String` |
     */
    Comment: string | null;
}

export interface LinkToolSpecificationToOperationResponse extends CommandResponse {
}

export interface LinkToolSpecificationToOperation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolSpecificationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToolSpecificationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OperationId: string;
}

export interface RemoveCertificationToSkillListResponse extends CommandResponse {
}

export interface RemoveCertificationToSkillList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CertificationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    CertificationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SkillIds` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_CERT.MSModel.Types.CertificationAssociationParameterType)` |
     * | Nullable | `false` |
     */
    SkillIds: Array<CertificationAssociationParameterType>;
}

export interface LinkMaterialItemToBufferResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Edm.String` |
     */
    WarningMessage: string | null;
}

export interface LinkMaterialItemToBuffer {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BufferId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    BufferId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItemList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    MaterialItemList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    Quantity: QuantityParameterType | null;
}

export interface GetOfflineWorkInstructionDefinitionsResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OfflineWorkInstructionAssociations` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.FB_OP_Offline.OPModel.Types.OfflineWorkInstructionDefinitionAssociation)` |
     */
    OfflineWorkInstructionAssociations: Array<OfflineWorkInstructionDefinitionAssociation>;
}

export interface GetOfflineWorkInstructionDefinitions {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    WorkOrderOperationIds: Array<string>;
}

export interface UADMCreateProcessResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface UADMCreateProcess {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Name: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Revision: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Plant` |
     * | Type | `Edm.String` |
     */
    Plant: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FinalMaterialId` |
     * | Type | `Edm.Guid` |
     */
    FinalMaterialId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    Quantity: QuantityParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaxQuantity` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    MaxQuantity: QuantityParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MinQuantity` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    MinQuantity: QuantityParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     */
    Sequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentProcessId` |
     * | Type | `Edm.Guid` |
     */
    ParentProcessId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBOPId` |
     * | Type | `Edm.Guid` |
     */
    AsPlannedBOPId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EffectivityExpression` |
     * | Type | `Edm.String` |
     */
    EffectivityExpression: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RevisionEffectivityExpression` |
     * | Type | `Edm.String` |
     */
    RevisionEffectivityExpression: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlanId` |
     * | Type | `Edm.Guid` |
     */
    MasterPlanId: string | null;
}

export interface UpdateStatusResponse extends CommandResponse {
}

export interface UpdateStatus {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Color` |
     * | Type | `Edm.String` |
     */
    Color: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsInitial` |
     * | Type | `Edm.Boolean` |
     */
    IsInitial: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Outcome` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.StatusesOutcome` |
     */
    Outcome: StatusesOutcome | null;
}

export interface ManageNullResultOnKoWOOperationListResponse extends CommandResponse {
}

export interface ManageNullResultOnKoWOOperationList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ManageNullResultParameterList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.FB_OP_Result.OPModel.Types.ManageNullResultParameterType)` |
     * | Nullable | `false` |
     */
    ManageNullResultParameterList: Array<ManageNullResultParameterType>;
}

export interface CreateDNCItemMachineMaterialAssociationResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DNCItemMachineMaterialAssociationId` |
     * | Type | `Edm.Guid` |
     */
    DNCItemMachineMaterialAssociationId: string | null;
}

export interface CreateDNCItemMachineMaterialAssociation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DNCId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    DNCId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DNCMachine` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    DNCMachine: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialId` |
     * | Type | `Edm.Guid` |
     */
    DM_MaterialId: string | null;
}

export interface GenerateMaterialBatchIdResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialBatchId` |
     * | Type | `Edm.String` |
     */
    MaterialBatchId: string | null;
}

export interface GenerateMaterialBatchId {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    MaterialId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OrderId` |
     * | Type | `Edm.String` |
     */
    OrderId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Timestamp` |
     * | Type | `Edm.DateTimeOffset` |
     */
    Timestamp: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TemplateId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    TemplateId: string;
}

export interface DeleteHierarchyEquipmentNodeConfigurationResponse extends CommandResponse {
}

export interface DeleteHierarchyEquipmentNodeConfiguration {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface LinkWorkInstructionDefinitionListToOperationResponse extends CommandResponse {
}

export interface LinkWorkInstructionDefinitionListToOperation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionDefinitionList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    WorkInstructionDefinitionList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionAssociationType` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkInstructionAssociationType: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StopPropagationToProcessOp` |
     * | Type | `Edm.Boolean` |
     */
    StopPropagationToProcessOp: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `HideOnExecGroup` |
     * | Type | `Edm.Boolean` |
     */
    HideOnExecGroup: boolean | null;
}

export interface UpdateNonConformanceHistoryResponse extends CommandResponse {
}

export interface UpdateNonConformanceHistory {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Date` |
     * | Type | `Edm.DateTimeOffset` |
     * | Nullable | `false` |
     */
    Date: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Status: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Transition` |
     * | Type | `Edm.String` |
     */
    Transition: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    UserId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Action` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Action: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FailureNId` |
     * | Type | `Edm.String` |
     */
    FailureNId: string | null;
}

export interface DeleteEquipmentConfigurationStateMachineResponse extends CommandResponse {
}

export interface DeleteEquipmentConfigurationStateMachine {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    EquipmentConfigurationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationStateMachineId` |
     * | Type | `Edm.Guid` |
     */
    EquipmentConfigurationStateMachineId: string | null;
}

export interface TCM2CreateStepListResponse extends CommandResponse {
}

export interface TCM2CreateStepList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StepList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_BOP.MSModel.Types.TCM2StepParameterType)` |
     * | Nullable | `false` |
     */
    StepList: Array<TCM2StepParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     */
    CorrelationId: string | null;
}

export interface DeleteActualConsumedMaterialResponse extends CommandResponse {
}

export interface DeleteActualConsumedMaterial {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualConsumedMaterialIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ActualConsumedMaterialIds: Array<string>;
}

export interface DeleteNonConformanceResourceResponse extends CommandResponse {
}

export interface DeleteNonConformanceResource {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface SentencingChangeNonConformanceResponse extends CommandResponse {
}

export interface SentencingChangeNonConformance {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NonConformanceNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceUser` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NonConformanceUser: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CloseNotes` |
     * | Type | `Edm.String` |
     */
    CloseNotes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Status: string;
}

export interface DeleteWorkOperationTypeListResponse extends CommandResponse {
}

export interface DeleteWorkOperationTypeList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface CreateMaterialGroupResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialGroupId` |
     * | Type | `Edm.Guid` |
     */
    MaterialGroupId: string | null;
}

export interface CreateMaterialGroup {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
}

export interface CheckInDataCollectionResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DataCollectionCheckedInList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.FB_OP_Offline.OPModel.Types.OfflineDataCollectionCheckedIn)` |
     */
    DataCollectionCheckedInList: Array<OfflineDataCollectionCheckedIn>;
}

export interface CheckInDataCollection {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DataCollectionList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.FB_OP_Offline.OPModel.Types.OfflineDataCollection)` |
     * | Nullable | `false` |
     */
    DataCollectionList: Array<OfflineDataCollection>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OfflineActionInternalId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OfflineActionInternalId: string;
}

export interface DeleteToBeUsedToolResponse extends CommandResponse {
}

export interface DeleteToBeUsedTool {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedToolId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToBeUsedToolId: string;
}

export interface DeleteNonConformanceAttachmentListResponse extends CommandResponse {
}

export interface DeleteNonConformanceAttachmentList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceAttachmentIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    NonConformanceAttachmentIdList: Array<string>;
}

export interface UpdateSerialNumberListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FailedMaterialItemIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    FailedMaterialItemIdList: Array<string>;
}

export interface UpdateSerialNumberList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SerialNumbersToBeUpdatedList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.UpdateSerialNumberParameterType)` |
     * | Nullable | `false` |
     */
    SerialNumbersToBeUpdatedList: Array<UpdateSerialNumberParameterType>;
}

export interface UpdateDefectTypeResponse extends CommandResponse {
}

export interface UpdateDefectType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Name: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Description: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `GroupIdentifiersList` |
     * | Type | `Collection(Siemens.SimaticIT.MasterData.MatTool.MSModel.Types.IdentifiersParameterType)` |
     */
    GroupIdentifiersList: Array<IdentifiersParameterType>;
}

export interface GenerateSerialNumberCodeResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SerialNumberCode` |
     * | Type | `Edm.String` |
     */
    SerialNumberCode: string | null;
}

export interface GenerateSerialNumberCode {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    MaterialId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OrderId` |
     * | Type | `Edm.String` |
     */
    OrderId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Timestamp` |
     * | Type | `Edm.DateTimeOffset` |
     */
    Timestamp: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TemplateId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    TemplateId: string;
}

export interface AssignCertificationToMaterialListResponse extends CommandResponse {
}

export interface AssignCertificationToMaterialList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CertificationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    CertificationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    MaterialIds: Array<string>;
}

export interface CreateDM_MaterialResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    DM_MaterialId: string;
}

export interface CreateDM_Material {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SerialNumberProfile` |
     * | Type | `Edm.Boolean` |
     */
    SerialNumberProfile: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FirstArticleInspection` |
     * | Type | `Edm.Boolean` |
     */
    FirstArticleInspection: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsPhantom` |
     * | Type | `Edm.Boolean` |
     */
    IsPhantom: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogisticClassNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    LogisticClassNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.String` |
     */
    CorrelationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EffectivityExpression` |
     * | Type | `Edm.String` |
     */
    EffectivityExpression: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Traceable` |
     * | Type | `Edm.Boolean` |
     */
    Traceable: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Volume` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    Volume: QuantityParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Weight` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    Weight: QuantityParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    MaterialId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AMPowderProperties` |
     * | Type | `Siemens.SimaticIT.UADM.MasterData.FB_MS_MAT.MSModel.Types.AMPowderPropertiesParameterType` |
     */
    AMPowderProperties: AMPowderPropertiesParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialClassId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    MaterialClassId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SupplierId` |
     * | Type | `Edm.Guid` |
     */
    SupplierId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FunctionalCodeId` |
     * | Type | `Edm.Guid` |
     */
    FunctionalCodeId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Lot` |
     * | Type | `Edm.Boolean` |
     */
    Lot: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EnableAutomaticConsumptionQty` |
     * | Type | `Edm.Boolean` |
     */
    EnableAutomaticConsumptionQty: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaxQuantityConsumption` |
     * | Type | `Edm.Decimal` |
     */
    MaxQuantityConsumption: number | null;
}

export interface UpdateDefectGroupResponse extends CommandResponse {
}

export interface UpdateDefectGroup {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Name: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Description: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentIdentifiersList` |
     * | Type | `Collection(Siemens.SimaticIT.MasterData.MatTool.MSModel.Types.IdentifiersParameterType)` |
     */
    ParentIdentifiersList: Array<IdentifiersParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChildrenIdentifiersList` |
     * | Type | `Collection(Siemens.SimaticIT.MasterData.MatTool.MSModel.Types.IdentifiersParameterType)` |
     */
    ChildrenIdentifiersList: Array<IdentifiersParameterType>;
}

export interface UpdateHoldResponse extends CommandResponse {
}

export interface UpdateHold {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CloseComment` |
     * | Type | `Edm.String` |
     */
    CloseComment: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CloseTime` |
     * | Type | `Edm.DateTimeOffset` |
     * | Nullable | `false` |
     */
    CloseTime: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CloseUserId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    CloseUserId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Comment` |
     * | Type | `Edm.String` |
     */
    Comment: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FutureHold` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    FutureHold: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsPresent` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsPresent: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OpenTime` |
     * | Type | `Edm.DateTimeOffset` |
     * | Nullable | `false` |
     */
    OpenTime: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OpenUserId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    OpenUserId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PreviousState` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    PreviousState: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReasonId` |
     * | Type | `Edm.Guid` |
     */
    ReasonId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Type` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Type: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TypeNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    TypeNId: string;
}

export interface DeleteProcessNotificationListResponse extends CommandResponse {
}

export interface DeleteProcessNotificationList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessNotificationIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ProcessNotificationIdList: Array<string>;
}

export interface TriggerPrintingOnWorkOrderStepResponse extends CommandResponse {
}

export interface TriggerPrintingOnWorkOrderStep {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderStepId: string;
}

export interface UADMDeleteEquipmentSpecificationListResponse extends CommandResponse {
}

export interface UADMDeleteEquipmentSpecificationList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface CreateProducedMaterialUnderReworkResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface CreateProducedMaterialUnderRework {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReworkOrderId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ReworkOrderId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItemUnderReworkParameterType` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.MaterialItemUnderReworkParameterType)` |
     * | Nullable | `false` |
     */
    MaterialItemUnderReworkParameterType: Array<MaterialItemUnderReworkParameterType>;
}

export interface UpdateWorkInstructionDefinitionResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ParameterIds: Array<string>;
}

export interface UpdateWorkInstructionDefinition {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Parameters` |
     * | Type | `Collection(Siemens.SimaticIT.MasterData.WI_MS.MSModel.Types.WorkInstructionDefinitionParameterParameterType)` |
     */
    Parameters: Array<WorkInstructionDefinitionParameterParameterType>;
}

export interface LinkMaterialToContainerListResponse extends CommandResponse {
}

export interface LinkMaterialToContainerList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContainerNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ContainerNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CompatibleMaterialList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_Container.MSModel.Types.MaterialParameterType)` |
     * | Nullable | `false` |
     */
    CompatibleMaterialList: Array<MaterialParameterType>;
}

export interface UpdateUoMFactorResponse extends CommandResponse {
}

export interface UpdateUoMFactor {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `K0Multiplier` |
     * | Type | `Edm.Decimal` |
     */
    K0Multiplier: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Addend` |
     * | Type | `Edm.Decimal` |
     */
    Addend: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `K1Multiplier` |
     * | Type | `Edm.Decimal` |
     */
    K1Multiplier: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Exponent` |
     * | Type | `Edm.Int16` |
     */
    Exponent: number | null;
}

export interface UnVerifyWorkOrderResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItemIdentifiers` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.MaterialItemIdentifiersParameterType` |
     */
    MaterialItemIdentifiers: MaterialItemIdentifiersParameterType | null;
}

export interface UnVerifyWorkOrder {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItemIdentifiers` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.MaterialItemIdentifiersParameterType` |
     * | Nullable | `false` |
     */
    MaterialItemIdentifiers: MaterialItemIdentifiersParameterType;
}

export interface StartWOOperationTransferBatchResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderHistoryId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderHistoryId: string | null;
}

export interface StartWOOperationTransferBatch {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupPhaseId` |
     * | Type | `Edm.Guid` |
     */
    ExecutionGroupPhaseId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StartWOOperationTransferBatchParameterType` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.StartWOOperationTransferBatchParameterType` |
     * | Nullable | `false` |
     */
    StartWOOperationTransferBatchParameterType: StartWOOperationTransferBatchParameterType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointItemParameterType` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.SetPointParameterType)` |
     */
    SetPointItemParameterType: Array<SetPointParameterType>;
}

export interface CreateEquipmentConfigurationByDefaultEquipmentTypeResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationId` |
     * | Type | `Edm.Guid` |
     */
    EquipmentConfigurationId: string | null;
}

export interface CreateEquipmentConfigurationByDefaultEquipmentType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeNId` |
     * | Type | `Edm.String` |
     */
    EquipmentTypeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Properties` |
     * | Type | `Collection(Siemens.SimaticIT.MasterData.EQU_MS.MSModel.Types.PropertyWithAttributesParameterType)` |
     */
    Properties: Array<PropertyWithAttributesParameterType>;
}

export interface LinkUsersToTeamResponse extends CommandResponse {
}

export interface LinkUsersToTeam {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TeamId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    TeamId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Users` |
     * | Type | `Collection(Edm.String)` |
     */
    Users: Array<string>;
}

export interface CreateBufferResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateBuffer {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Name: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BufferDefinition` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    BufferDefinition: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LocationNId` |
     * | Type | `Edm.String` |
     */
    LocationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Status: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ValidFrom` |
     * | Type | `Edm.DateTimeOffset` |
     */
    ValidFrom: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ValidTo` |
     * | Type | `Edm.DateTimeOffset` |
     */
    ValidTo: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     * | Nullable | `false` |
     */
    Quantity: QuantityParameterType;
}

export interface UnlinkToolDefinitionToAutomationNodeTypeListResponse extends CommandResponse {
}

export interface UnlinkToolDefinitionToAutomationNodeTypeList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolDefinitionATNTypeAssociationIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ToolDefinitionATNTypeAssociationIdList: Array<string>;
}

export interface CreateEquipmentGraphTypeResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateEquipmentGraphType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
}

export interface SaveDocumentForPreviewResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FileName` |
     * | Type | `Edm.String` |
     */
    FileName: string | null;
}

export interface SaveDocumentForPreview {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    DocumentId: string;
}

export interface CreateVisualCharacteristicSpecificationResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateVisualCharacteristicSpecification {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Criticality` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Criticality: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Context` |
     * | Type | `Siemens.SimaticIT.MasterData.CHR_MS.MSModel.Types.CharacteristicContext` |
     * | Nullable | `false` |
     */
    Context: CharacteristicContext;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    UId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Revision: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sketch` |
     * | Type | `Edm.Binary` |
     */
    Sketch: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SketchRows` |
     * | Type | `Edm.Int32` |
     */
    SketchRows: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SketchColumns` |
     * | Type | `Edm.Int32` |
     */
    SketchColumns: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SketchMimeType` |
     * | Type | `Edm.String` |
     */
    SketchMimeType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SketchName` |
     * | Type | `Edm.String` |
     */
    SketchName: string | null;
}

export interface SentenceBuyOffResponse extends CommandResponse {
}

export interface SentenceBuyOff {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NonConformanceNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StatusNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    StatusNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ScenarioInstanceId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ScenarioInstanceId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `InspectionSampleId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    InspectionSampleId: string;
}

export interface CreateOfflineSessionResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OfflineSessionId` |
     * | Type | `Edm.Guid` |
     */
    OfflineSessionId: string | null;
}

export interface CreateOfflineSession {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DeviceId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    DeviceId: string;
}

export interface CreateStepRevisionSubStructureResponse extends CommandResponse {
}

export interface CreateStepRevisionSubStructure {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBOPId` |
     * | Type | `Edm.Guid` |
     */
    AsPlannedBOPId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlanId` |
     * | Type | `Edm.Guid` |
     */
    MasterPlanId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceStepId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    SourceStepId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetStepId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    TargetStepId: string;
}

export interface SkipWOOperationTransferBatchResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationNId: string | null;
}

export interface SkipWOOperationTransferBatch {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Int32` |
     * | Nullable | `false` |
     */
    Quantity: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReasonNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ReasonNId: string;
}

export interface UpdateContainerTypeResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface UpdateContainerType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsReusable` |
     * | Type | `Edm.Boolean` |
     */
    IsReusable: boolean | null;
}

export interface CreateAttributiveCharacteristicSpecificationResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateAttributiveCharacteristicSpecification {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Criticality` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Criticality: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Context` |
     * | Type | `Siemens.SimaticIT.MasterData.CHR_MS.MSModel.Types.CharacteristicContext` |
     * | Nullable | `false` |
     */
    Context: CharacteristicContext;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    UId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NOKDescription` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NOKDescription: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OKDescription` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    OKDescription: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Revision: string;
}

export interface GetPJFsHookOnLinkActualUsedMachinePJFResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFileList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.FB_OP_AM.OPModel.Types.PJFIsSourceParameterType)` |
     */
    PrintJobFileList: Array<PJFIsSourceParameterType>;
}

export interface GetPJFsHookOnLinkActualUsedMachinePJF {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFileList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.FB_OP_AM.OPModel.Types.PJFIsSourceParameterType)` |
     * | Nullable | `false` |
     */
    PrintJobFileList: Array<PJFIsSourceParameterType>;
}

export interface DeleteEquipmentTypeResponse extends CommandResponse {
}

export interface DeleteEquipmentType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface UpdateMaterialAndDM_MaterialResponse extends CommandResponse {
}

export interface UpdateMaterialAndDM_Material {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FirstArticleInspection` |
     * | Type | `Edm.Boolean` |
     */
    FirstArticleInspection: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SerialNumberProfile` |
     * | Type | `Edm.Boolean` |
     */
    SerialNumberProfile: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsPhantom` |
     * | Type | `Edm.Boolean` |
     */
    IsPhantom: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Traceable` |
     * | Type | `Edm.Boolean` |
     */
    Traceable: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogisticClassNId` |
     * | Type | `Edm.String` |
     */
    LogisticClassNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Volume` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    Volume: QuantityParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Weight` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    Weight: QuantityParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AMPowderProperties` |
     * | Type | `Siemens.SimaticIT.UADM.MasterData.FB_MS_MAT.MSModel.Types.AMPowderPropertiesParameterType` |
     */
    AMPowderProperties: AMPowderPropertiesParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoMNId` |
     * | Type | `Edm.String` |
     */
    UoMNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    DM_MaterialId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialClassNId` |
     * | Type | `Edm.String` |
     */
    MaterialClassNId: string | null;
}

export interface LinkBufferDefinitionToMaterialDefListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    IdList: Array<string>;
}

export interface LinkBufferDefinitionToMaterialDefList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BufferDefinitionId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    BufferDefinitionId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialDefList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    MaterialDefList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Min` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    Min: QuantityParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Threshold` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    Threshold: QuantityParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Target` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    Target: QuantityParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Max` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    Max: QuantityParameterType | null;
}

export interface LinkBufferDefinitionToToolDefListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    IdList: Array<string>;
}

export interface LinkBufferDefinitionToToolDefList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BufferDefinitionId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    BufferDefinitionId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolDefList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ToolDefList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Min` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    Min: QuantityParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Max` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    Max: QuantityParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Threshold` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    Threshold: QuantityParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Target` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    Target: QuantityParameterType | null;
}

export interface TCM2LinkProcessToOperationFullListResponse extends CommandResponse {
}

export interface TCM2LinkProcessToOperationFullList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LinkList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_BOP.MSModel.Types.TCM2LinkParameterType)` |
     * | Nullable | `false` |
     */
    LinkList: Array<TCM2LinkParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     */
    CorrelationId: string | null;
}

export interface CreateHandlingUnitHistoryResponse extends CommandResponse {
}

export interface CreateHandlingUnitHistory {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `HandlingUnitId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    HandlingUnitId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActionId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ActionId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SerialNumber` |
     * | Type | `Edm.String` |
     */
    SerialNumber: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BatchId` |
     * | Type | `Edm.String` |
     */
    BatchId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceBufferNId` |
     * | Type | `Edm.String` |
     */
    SourceBufferNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DestinationBufferNId` |
     * | Type | `Edm.String` |
     */
    DestinationBufferNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TransportOperationNId` |
     * | Type | `Edm.String` |
     */
    TransportOperationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItemQuantity` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    MaterialItemQuantity: QuantityParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     */
    Status: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LocationNId` |
     * | Type | `Edm.String` |
     */
    LocationNId: string | null;
}

export interface UnlinkToBeUsedMachineToPJFResponse extends CommandResponse {
}

export interface UnlinkToBeUsedMachineToPJF {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedEquipmentConfigurationPJFList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ToBeUsedEquipmentConfigurationPJFList: Array<string>;
}

export interface CreateNonProductiveActivityResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface CreateNonProductiveActivity {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
}

export interface CompleteCheckInResponse extends CommandResponse {
}

export interface CompleteCheckIn {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OfflineSessionIdFlag0` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    OfflineSessionIdFlag0: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OfflineSessionId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OfflineSessionId: string;
}

export interface UpdateOperationStepCategoryResponse extends CommandResponse {
}

export interface UpdateOperationStepCategory {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationStepCategory` |
     * | Type | `Siemens.SimaticIT.U4DM.MasterData.FB_MS_BOP.MSModel.Types.OperationStepCategoryType` |
     * | Nullable | `false` |
     */
    OperationStepCategory: OperationStepCategoryType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface LinkWIDefinitionsToEGPhaseResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface LinkWIDefinitionsToEGPhase {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EGPhaseId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    EGPhaseId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionDefinitionIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    WorkInstructionDefinitionIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionAssociationType` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkInstructionAssociationType: string;
}

export interface UpdateCharacteristicSpecificationResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FailureAssociationIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    FailureAssociationIds: Array<string>;
}

export interface UpdateCharacteristicSpecification {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Context` |
     * | Type | `Siemens.SimaticIT.MasterData.CHR_MS.MSModel.Types.CharacteristicContext` |
     */
    Context: CharacteristicContext | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Criticality` |
     * | Type | `Edm.String` |
     */
    Criticality: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FailureAssociations` |
     * | Type | `Collection(Siemens.SimaticIT.MasterData.CHR_MS.MSModel.Types.CharacteristicFailureAssociation)` |
     */
    FailureAssociations: Array<CharacteristicFailureAssociation>;
}

export interface GetWIParameterValuesResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterValueList` |
     * | Type | `Collection(Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.ParameterValueParameterType)` |
     */
    ParameterValueList: Array<ParameterValueParameterType>;
}

export interface GetWIParameterValues {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MTUIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DM_MTUIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStep_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStep_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupPhase_Id` |
     * | Type | `Edm.Guid` |
     */
    ExecutionGroupPhase_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionDefinition_Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkInstructionDefinition_Id: string;
}

export interface SetOperationStepCategoryProcessDefinitionActiveStatusResponse extends CommandResponse {
}

export interface SetOperationStepCategoryProcessDefinitionActiveStatus {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    IdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Active` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    Active: boolean;
}

export interface CreateToBeConsumedMaterialsResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedToBeConsumedMaterials` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ToBeConsumedMaterialInfo)` |
     */
    CreatedToBeConsumedMaterials: Array<ToBeConsumedMaterialInfo>;
}

export interface CreateToBeConsumedMaterials {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStepId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeConsumedMaterials` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ToBeConsumedMaterialParameter)` |
     * | Nullable | `false` |
     */
    ToBeConsumedMaterials: Array<ToBeConsumedMaterialParameter>;
}

export interface DeleteActualProducedMaterialResponse extends CommandResponse {
}

export interface DeleteActualProducedMaterial {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface UnlinkProcessToAsPlannedBOPResponse extends CommandResponse {
}

export interface UnlinkProcessToAsPlannedBOP {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ProcessId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBOPId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    AsPlannedBOPId: string;
}

export interface UADMCreateOperationResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface UADMCreateOperation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Name: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     * | Nullable | `false` |
     */
    Sequence: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedDuration` |
     * | Type | `Edm.Duration` |
     */
    EstimatedDuration: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Optional` |
     * | Type | `Edm.Boolean` |
     */
    Optional: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreateDependency` |
     * | Type | `Edm.Boolean` |
     */
    CreateDependency: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DependencyType` |
     * | Type | `Edm.Guid` |
     */
    DependencyType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessId` |
     * | Type | `Edm.Guid` |
     */
    ProcessId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignatureStart` |
     * | Type | `Edm.Boolean` |
     */
    ElectronicSignatureStart: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignaturePause` |
     * | Type | `Edm.Boolean` |
     */
    ElectronicSignaturePause: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignatureComplete` |
     * | Type | `Edm.Boolean` |
     */
    ElectronicSignatureComplete: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RequiredInspectionRole` |
     * | Type | `Edm.String` |
     */
    RequiredInspectionRole: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RequiredCertificateNId` |
     * | Type | `Edm.String` |
     */
    RequiredCertificateNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCollectedDocument` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCollectedDocument: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PredecessorId` |
     * | Type | `Edm.Guid` |
     */
    PredecessorId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EffectivityExpression` |
     * | Type | `Edm.String` |
     */
    EffectivityExpression: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBOPId` |
     * | Type | `Edm.Guid` |
     */
    AsPlannedBOPId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RevisionEffectivityExpression` |
     * | Type | `Edm.String` |
     */
    RevisionEffectivityExpression: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationStepCategoryId` |
     * | Type | `Edm.Guid` |
     */
    OperationStepCategoryId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlanId` |
     * | Type | `Edm.Guid` |
     */
    MasterPlanId: string | null;
}

export interface UnlinkSkillsFromWOOperationResponse extends CommandResponse {
}

export interface UnlinkSkillsFromWOOperation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOperationSkillIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    WOOperationSkillIds: Array<string>;
}

export interface DeleteMachineToDNCResponse extends CommandResponse {
}

export interface DeleteMachineToDNC {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MachineToDNCId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    MachineToDNCId: string;
}

export interface DeleteResultsFromWOOperationsResponse extends CommandResponse {
}

export interface DeleteResultsFromWOOperations {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNIdList` |
     * | Type | `Collection(Edm.String)` |
     */
    WorkOrderOperationNIdList: Array<string>;
}

export interface CreateNewProcessRevisionResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateNewProcessRevision {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ProcessId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentProcessId` |
     * | Type | `Edm.Guid` |
     */
    ParentProcessId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBOPId` |
     * | Type | `Edm.Guid` |
     */
    AsPlannedBOPId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetProcessId` |
     * | Type | `Edm.Guid` |
     */
    TargetProcessId: string | null;
}

export interface CheckIdTemplateEditingResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Editing` |
     * | Type | `Edm.Boolean` |
     */
    Editing: boolean | null;
}

export interface CheckIdTemplateEditing {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TemplateId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    TemplateId: string;
}

export interface TCM2CompleteAsPlannedBOPResponse extends CommandResponse {
}

export interface TCM2CompleteAsPlannedBOP {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    CorrelationId: string;
}

export interface CreateCharacteristicSpecificationResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateCharacteristicSpecification {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Criticality` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Criticality: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Context` |
     * | Type | `Siemens.SimaticIT.MasterData.CHR_MS.MSModel.Types.CharacteristicContext` |
     * | Nullable | `false` |
     */
    Context: CharacteristicContext;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Type` |
     * | Type | `Siemens.SimaticIT.MasterData.CHR_MS.MSModel.Types.CharacteristicType` |
     * | Nullable | `false` |
     */
    Type: CharacteristicType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    UId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Revision: string;
}

export interface ConfirmWorkOrderOperationResponse extends CommandResponse {
}

export interface ConfirmWorkOrderOperation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ERPOrderID` |
     * | Type | `Edm.String` |
     */
    ERPOrderID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `operationId` |
     * | Type | `Edm.String` |
     */
    operationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PlantID` |
     * | Type | `Edm.String` |
     */
    PlantID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `confirmationId` |
     * | Type | `Edm.String` |
     */
    confirmationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EventId` |
     * | Type | `Edm.Guid` |
     */
    EventId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `completion` |
     * | Type | `Edm.Boolean` |
     */
    completion: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FastOperationConfirmation` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    FastOperationConfirmation: boolean;
}

export interface DeleteEquipmentTypeStateMachineResponse extends CommandResponse {
}

export interface DeleteEquipmentTypeStateMachine {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    EquipmentTypeId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeStateMachineId` |
     * | Type | `Edm.Guid` |
     */
    EquipmentTypeStateMachineId: string | null;
}

export interface CreateBufferDefinitionRevisionResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateBufferDefinitionRevision {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OriginalBufferId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OriginalBufferId: string;
}

export interface DNCPreviewDNCItemResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DNCPreview` |
     * | Type | `Edm.Binary` |
     */
    DNCPreview: string | null;
}

export interface DNCPreviewDNCItem {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DNCId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    DNCId: string;
}

export interface ReopenWorkOrderOperationListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationIdentifiers` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.IdentifiersParameterType` |
     */
    WorkOrderOperationIdentifiers: IdentifiersParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderIdentifiers` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.IdentifiersParameterType` |
     */
    WorkOrderIdentifiers: IdentifiersParameterType | null;
}

export interface ReopenWorkOrderOperationList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderIdentifiers` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.IdentifiersParameterType` |
     * | Nullable | `false` |
     */
    WorkOrderIdentifiers: IdentifiersParameterType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationIdentifiersList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.IdentifiersParameterType)` |
     * | Nullable | `false` |
     */
    WorkOrderOperationIdentifiersList: Array<IdentifiersParameterType>;
}

export interface ManageNullResultOnKoWorkOrderOperationResponse extends CommandResponse {
}

export interface ManageNullResultOnKoWorkOrderOperation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnitWithResultList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.CompletedMTUParameterType)` |
     */
    DM_MaterialTrackingUnitWithResultList: Array<CompletedMTUParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutomaticEquipmentNId` |
     * | Type | `Edm.String` |
     */
    AutomaticEquipmentNId: string | null;
}

export interface ExecuteCustomItlkCheckInboundResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CustomItlkCheckOutputList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.FB_OP_ITLK.OPModel.Types.ItlkCheckOrchestratorOutputParameterType)` |
     */
    CustomItlkCheckOutputList: Array<ItlkCheckOrchestratorOutputParameterType>;
}

export interface ExecuteCustomItlkCheckInbound {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CustomItlkCheckInputList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.FB_OP_ITLK.OPModel.Types.ItlkCheckOrchestratorInputParameterType)` |
     * | Nullable | `false` |
     */
    CustomItlkCheckInputList: Array<ItlkCheckOrchestratorInputParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStepId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProductionTypeNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ProductionTypeNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MTUList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ItlkCheckDM_MTUParameterType)` |
     */
    DM_MTUList: Array<ItlkCheckDM_MTUParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsAutomatic` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsAutomatic: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckSessionId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ItlkCheckSessionId: string;
}

export interface UnlinkProcessToProcessResponse extends CommandResponse {
}

export interface UnlinkProcessToProcess {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FromProcessId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    FromProcessId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToProcessId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToProcessId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBOPId` |
     * | Type | `Edm.Guid` |
     */
    AsPlannedBOPId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlanId` |
     * | Type | `Edm.Guid` |
     */
    MasterPlanId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     */
    Sequence: number | null;
}

export interface UnLinkMaterialItemFromBufferResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Edm.String` |
     */
    WarningMessage: string | null;
}

export interface UnLinkMaterialItemFromBuffer {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BufferId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    BufferId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItemList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    MaterialItemList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FromPage` |
     * | Type | `Edm.String` |
     */
    FromPage: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MTUQtyToUnlink` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.FB_OP_IPL.OPModel.Types.ToUnlinkQtyParameterType)` |
     */
    MTUQtyToUnlink: Array<ToUnlinkQtyParameterType>;
}

export interface LinkItlkCheckToWorkOrderStepListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckWOStepIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ItlkCheckWOStepIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Edm.String` |
     */
    WarningMessage: string | null;
}

export interface LinkItlkCheckToWorkOrderStepList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckWOStepList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.FB_OP_ITLK.OPModel.Types.ItlkCheckWOStepAssociationParameterType)` |
     * | Nullable | `false` |
     */
    ItlkCheckWOStepList: Array<ItlkCheckWOStepAssociationParameterType>;
}

export interface LinkSkillsToStepResponse extends CommandResponse {
}

export interface LinkSkillsToStep {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StepId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    StepId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SkillIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    SkillIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Level` |
     * | Type | `Edm.Int32` |
     */
    Level: number | null;
}

export interface AmendOfflineActionResponse extends CommandResponse {
}

export interface AmendOfflineAction {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CommandPayload` |
     * | Type | `Edm.Binary` |
     */
    CommandPayload: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActionId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ActionId: string;
}

export interface UpdateEquipmentTypeResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PropertyIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    PropertyIds: Array<string>;
}

export interface UpdateEquipmentType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StateMachineNId` |
     * | Type | `Edm.String` |
     */
    StateMachineNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LevelNId` |
     * | Type | `Edm.String` |
     */
    LevelNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Properties` |
     * | Type | `Collection(Siemens.SimaticIT.MasterData.EQU_MS.MSModel.Types.PropertyParameterType)` |
     */
    Properties: Array<PropertyParameterType>;
}

export interface TCM2LinkProcessToProcessFullListResponse extends CommandResponse {
}

export interface TCM2LinkProcessToProcessFullList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LinkList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_BOP.MSModel.Types.TCM2LinkParameterType)` |
     * | Nullable | `false` |
     */
    LinkList: Array<TCM2LinkParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     */
    CorrelationId: string | null;
}

export interface UpdateNonProductiveActivityResponse extends CommandResponse {
}

export interface UpdateNonProductiveActivity {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
}

export interface LinkAutomationNodeInstanceParameterToToolDefinitionParameterListResponse extends CommandResponse {
}

export interface LinkAutomationNodeInstanceParameterToToolDefinitionParameterList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ATNInstanceParameter` |
     * | Type | `Siemens.SimaticIT.U4DM.MasterData.FB_MS_AGWInt.MSModel.Types.ATNInstanceParameterType` |
     * | Nullable | `false` |
     */
    ATNInstanceParameter: ATNInstanceParameterType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolDefinitionIdentifierList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ToolDefinitionIdentifierList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolDefinitionParameterNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ToolDefinitionParameterNId: string;
}

export interface LinkToolDefinitionToAutomationNodeTypeListResponse extends CommandResponse {
}

export interface LinkToolDefinitionToAutomationNodeTypeList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolDefinitionId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToolDefinitionId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutomationNodeTypeNIdList` |
     * | Type | `Collection(Edm.String)` |
     */
    AutomationNodeTypeNIdList: Array<string>;
}

export interface CreateMaterialDefinitionDocumentListResponse extends CommandResponse {
}

export interface CreateMaterialDefinitionDocumentList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialDefinitionDocumentList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_BOP.MSModel.Types.MaterialDefinitionDocumentParameterType)` |
     * | Nullable | `false` |
     */
    MaterialDefinitionDocumentList: Array<MaterialDefinitionDocumentParameterType>;
}

export interface UnlinkItlkCheckToWorkOrderOperationListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Edm.String` |
     */
    WarningMessage: string | null;
}

export interface UnlinkItlkCheckToWorkOrderOperationList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckWOOpAssociationIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ItlkCheckWOOpAssociationIdList: Array<string>;
}

export interface SetWorkInstructionTemplateAsDefaultResponse extends CommandResponse {
}

export interface SetWorkInstructionTemplateAsDefault {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IdFlag0` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IdFlag0: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface SetNonConformanceStatusIsClosedOkResponse extends CommandResponse {
}

export interface SetNonConformanceStatusIsClosedOk {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceLifecycleId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    NonConformanceLifecycleId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceStatusId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    NonConformanceStatusId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsClosedOk` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsClosedOk: boolean;
}

export interface UnlinkToolToSetPointResponse extends CommandResponse {
}

export interface UnlinkToolToSetPoint {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointToolAssociationList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    SetPointToolAssociationList: Array<string>;
}

export interface RemoveDefectGroupContextualizationResponse extends CommandResponse {
}

export interface RemoveDefectGroupContextualization {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefectGroupId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    DefectGroupId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DM_MaterialList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationList` |
     * | Type | `Collection(Edm.String)` |
     */
    EquipmentConfigurationList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeList` |
     * | Type | `Collection(Edm.String)` |
     */
    EquipmentTypeList: Array<string>;
}

export interface ManageResultsForSkippedOperationsResponse extends CommandResponse {
}

export interface ManageResultsForSkippedOperations {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationAndMTUsToSkip` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.WorkOrderOperationAndMTUsToSkipType` |
     * | Nullable | `false` |
     */
    WorkOrderOperationAndMTUsToSkip: WorkOrderOperationAndMTUsToSkipType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MTUsWithKOList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DM_MTUsWithKOList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProductionType` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ProductionType: string;
}

export interface ManageRepeatOfKoWorkOrderOperationResponse extends CommandResponse {
}

export interface ManageRepeatOfKoWorkOrderOperation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MTUWithResultList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.FB_OP_Result.OPModel.Types.DMMTUWithResultParameterType)` |
     * | Nullable | `false` |
     */
    DM_MTUWithResultList: Array<DMMTUWithResultParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProductionType` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ProductionTypeEnum` |
     * | Nullable | `false` |
     */
    ProductionType: ProductionTypeEnum;
}

export interface ConsumeMaterialItemLiteResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualConsumedMaterialId` |
     * | Type | `Edm.Guid` |
     */
    ActualConsumedMaterialId: string | null;
}

export interface ConsumeMaterialItemLite {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedDMMaterialTrackingUnitId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ProducedDMMaterialTrackingUnitId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeConsumedDmMaterialId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToBeConsumedDmMaterialId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeConsumedCode` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ToBeConsumedCode: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `User` |
     * | Type | `Edm.String` |
     */
    User: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    EquipmentNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeConsumedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    ToBeConsumedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ApplySNUniquenessCheckByMaterial` |
     * | Type | `Edm.Boolean` |
     */
    ApplySNUniquenessCheckByMaterial: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SkipActivityValidation` |
     * | Type | `Edm.Boolean` |
     */
    SkipActivityValidation: boolean | null;
}

export interface CreateCertificationResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateCertification {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
}

export interface CheckCertificationResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NIds` |
     * | Type | `Collection(Edm.String)` |
     */
    NIds: Array<string>;
}

export interface CheckCertification {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CheckCertificationParameter` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.CheckCertificationParameterType)` |
     * | Nullable | `false` |
     */
    CheckCertificationParameter: Array<CheckCertificationParameterType>;
}

export interface CreateTransportOperationResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateTransportOperation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogisticRequestId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    LogisticRequestId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     * | Nullable | `false` |
     */
    Quantity: QuantityParameterType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BufferSourceList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.FB_OP_IPL.OPModel.Types.BufferWithPriority)` |
     * | Nullable | `false` |
     */
    BufferSourceList: Array<BufferWithPriority>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BufferDestinationList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.FB_OP_IPL.OPModel.Types.BufferWithPriority)` |
     * | Nullable | `false` |
     */
    BufferDestinationList: Array<BufferWithPriority>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedDuration` |
     * | Type | `Edm.Duration` |
     */
    EstimatedDuration: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RoleId` |
     * | Type | `Edm.String` |
     */
    RoleId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogisticRequestItemId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    LogisticRequestItemId: string;
}

export interface UpdateToolDefinitionResponse extends CommandResponse {
}

export interface UpdateToolDefinition {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SubstrateDefinitionProperties` |
     * | Type | `Siemens.SimaticIT.MasterData.MatTool.MSModel.Types.SubstrateDefinitionPropertiesParameterType` |
     */
    SubstrateDefinitionProperties: SubstrateDefinitionPropertiesParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UsageCounterMax` |
     * | Type | `Edm.Int32` |
     */
    UsageCounterMax: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UsageDurationMax` |
     * | Type | `Edm.Duration` |
     */
    UsageDurationMax: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExpirationDate` |
     * | Type | `Edm.DateTimeOffset` |
     */
    ExpirationDate: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Consumable` |
     * | Type | `Edm.Boolean` |
     */
    Consumable: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogisticParameter` |
     * | Type | `Siemens.SimaticIT.U4DM.ReferenceData.FB_RD_SERV.RFModel.Types.LogisticParameterType` |
     */
    LogisticParameter: LogisticParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Lockable` |
     * | Type | `Edm.Boolean` |
     */
    Lockable: boolean | null;
}

export interface CreateWorkOrderStepFromMPProcessStepResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateWorkOrderStepFromMPProcessStep {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlanId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    MasterPlanId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StepId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    StepId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     */
    Sequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCollectedDocument` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCollectedDocument: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SkipMaterialsCreation` |
     * | Type | `Edm.Boolean` |
     */
    SkipMaterialsCreation: boolean | null;
}

export interface ManageResultWorkOrderOperationNIdForSplitWorkOrderResponse extends CommandResponse {
}

export interface ManageResultWorkOrderOperationNIdForSplitWorkOrder {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationPairIdList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.WorkOrderOperationPairParameterType)` |
     * | Nullable | `false` |
     */
    WorkOrderOperationPairIdList: Array<WorkOrderOperationPairParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SplitType` |
     * | Type | `Edm.String` |
     */
    SplitType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentWorkOrderId` |
     * | Type | `Edm.Guid` |
     */
    ParentWorkOrderId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NewWorkOrderList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.WorkOrderIdentifiersParameterType)` |
     */
    NewWorkOrderList: Array<WorkOrderIdentifiersParameterType>;
}

export interface AmendOfResultToRepeatMaterialConsumptionResponse extends CommandResponse {
}

export interface AmendOfResultToRepeatMaterialConsumption {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MTUWithResultList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.FB_OP_Result.OPModel.Types.DMMTUWithResultParameterType)` |
     * | Nullable | `false` |
     */
    DM_MTUWithResultList: Array<DMMTUWithResultParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProductionType` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ProductionTypeEnum` |
     * | Nullable | `false` |
     */
    ProductionType: ProductionTypeEnum;
}

export interface UnlinkWorkInstructionDefinitionListFromOperationResponse extends CommandResponse {
}

export interface UnlinkWorkInstructionDefinitionListFromOperation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionDefinitionList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    WorkInstructionDefinitionList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StopPropagationToProcessOp` |
     * | Type | `Edm.Boolean` |
     */
    StopPropagationToProcessOp: boolean | null;
}

export interface CreateToolSpecificationResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateToolSpecification {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolSpecification` |
     * | Type | `Siemens.SimaticIT.U4DM.MasterData.FB_MS_BOP.MSModel.Types.ToolSpecificationParameterType` |
     * | Nullable | `false` |
     */
    ToolSpecification: ToolSpecificationParameterType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     */
    CorrelationId: string | null;
}

export interface DeleteToBeUsedDocumentResponse extends CommandResponse {
}

export interface DeleteToBeUsedDocument {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedDocumentId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToBeUsedDocumentId: string;
}

export interface RemoveCertificationToLocationListResponse extends CommandResponse {
}

export interface RemoveCertificationToLocationList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CertificationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    CertificationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LocationNIds` |
     * | Type | `Collection(Edm.String)` |
     */
    LocationNIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentType` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    EquipmentType: string;
}

export interface CreateExecutionGroupPhaseResponse extends CommandResponse {
}

export interface CreateExecutionGroupPhase {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupPhaseDetails` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ExecutionGroupPhaseParameterType)` |
     * | Nullable | `false` |
     */
    ExecutionGroupPhaseDetails: Array<ExecutionGroupPhaseParameterType>;
}

export interface UnlinkATNTypeParameterFromToolDefinitionSetPointItemListResponse extends CommandResponse {
}

export interface UnlinkATNTypeParameterFromToolDefinitionSetPointItemList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointItemToolDefinitionATNTypeParameterAssociationIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    SetPointItemToolDefinitionATNTypeParameterAssociationIds: Array<string>;
}

export interface UpdateMaterialTrackingUnitAndDM_MaterialTrackingUnitResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnitHistoryIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DM_MaterialTrackingUnitHistoryIdList: Array<string>;
}

export interface UpdateMaterialTrackingUnitAndDM_MaterialTrackingUnit {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.StatusTypeParameterType` |
     */
    Status: StatusTypeParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    Quantity: QuantityParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TemplateNId` |
     * | Type | `Edm.String` |
     */
    TemplateNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Code` |
     * | Type | `Edm.String` |
     */
    Code: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CodeType` |
     * | Type | `Siemens.SimaticIT.OperationalData.MAT_OP.OPModel.Types.MTUCodeType` |
     */
    CodeType: MTUCodeType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsReserved` |
     * | Type | `Edm.Boolean` |
     */
    IsReserved: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Weight` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    Weight: QuantityParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Volume` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    Volume: QuantityParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActiveNonConformanceNumber` |
     * | Type | `Edm.Int32` |
     */
    ActiveNonConformanceNumber: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BufferNId` |
     * | Type | `Edm.String` |
     */
    BufferNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AMPowderProperties` |
     * | Type | `Siemens.SimaticIT.UADM.OperationalData.FB_OP_MAT.OPModel.Types.AMPowderPropertiesParameterType` |
     */
    AMPowderProperties: AMPowderPropertiesParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnitId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    DM_MaterialTrackingUnitId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `HistoryAction` |
     * | Type | `Edm.String` |
     */
    HistoryAction: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsCalledFromSplitOfMTU` |
     * | Type | `Edm.Boolean` |
     */
    IsCalledFromSplitOfMTU: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Date` |
     * | Type | `Edm.DateTimeOffset` |
     */
    Date: string | null;
}

export interface UnlinkToolSpecificationToOperationResponse extends CommandResponse {
}

export interface UnlinkToolSpecificationToOperation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolSpecificationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToolSpecificationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OperationId: string;
}

export interface UnlinkToBeUsedMachineToPJFFromLogicalKeyResponse extends CommandResponse {
}

export interface UnlinkToBeUsedMachineToPJFFromLogicalKey {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedMachineId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToBeUsedMachineId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFileId` |
     * | Type | `Edm.Guid` |
     */
    PrintJobFileId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFileExternalId` |
     * | Type | `Edm.String` |
     */
    PrintJobFileExternalId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFileName` |
     * | Type | `Edm.String` |
     */
    PrintJobFileName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFileSource` |
     * | Type | `Edm.String` |
     */
    PrintJobFileSource: string | null;
}

export interface PunchOutUsersResponse extends CommandResponse {
}

export interface PunchOutUsers {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Users` |
     * | Type | `Collection(Edm.String)` |
     */
    Users: Array<string>;
}

export interface SetWorkOrderOperationEstimatedTimesResponse extends CommandResponse {
}

export interface SetWorkOrderOperationEstimatedTimes {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedStartTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedStartTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedEndTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedEndTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Priority` |
     * | Type | `Edm.Int32` |
     */
    Priority: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DueDate` |
     * | Type | `Edm.DateTimeOffset` |
     */
    DueDate: string | null;
}

export interface DeletePrintJobFileListResponse extends CommandResponse {
}

export interface DeletePrintJobFileList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFileList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    PrintJobFileList: Array<string>;
}

export interface DeleteContainerTypeListResponse extends CommandResponse {
}

export interface DeleteContainerTypeList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    IdList: Array<string>;
}

export interface LinkActualUsedMachineToPJFResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    IdList: Array<string>;
}

export interface LinkActualUsedMachineToPJF {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualUsedMachineId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ActualUsedMachineId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFileList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.FB_OP_AM.OPModel.Types.PJFIsSourceParameterType)` |
     * | Nullable | `false` |
     */
    PrintJobFileList: Array<PJFIsSourceParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EG_PhaseId` |
     * | Type | `Edm.Guid` |
     */
    EG_PhaseId: string | null;
}

export interface GetValidMachinesWOOpIdsResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessages` |
     * | Type | `Collection(Edm.String)` |
     */
    WarningMessages: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOpWithValidMachineIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    WOOpWithValidMachineIdList: Array<string>;
}

export interface GetValidMachinesWOOpIds {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `GetValidMachineInputParameter` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.GetValidMachineWOOpIdsParameterType)` |
     * | Nullable | `false` |
     */
    GetValidMachineInputParameter: Array<GetValidMachineWOOpIdsParameterType>;
}

export interface SelectMTUForPartBasedInspectionResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SelectedDM_MTUList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.DM_MaterialTrackingUnitIdentifierParameterType)` |
     */
    SelectedDM_MTUList: Array<DM_MaterialTrackingUnitIdentifierParameterType>;
}

export interface SelectMTUForPartBasedInspection {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MTUList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.DM_MaterialTrackingUnitIdentifierParameterType)` |
     * | Nullable | `false` |
     */
    DM_MTUList: Array<DM_MaterialTrackingUnitIdentifierParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SelectionsRequired` |
     * | Type | `Edm.Int32` |
     * | Nullable | `false` |
     */
    SelectionsRequired: number;
}

export interface CreateNonConformanceItemResponse extends CommandResponse {
}

export interface CreateNonConformanceItem {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Equipment` |
     * | Type | `Collection(Edm.String)` |
     */
    Equipment: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItem` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    MaterialItem: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Tool` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Tool: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformance` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    NonConformance: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceSupervisor` |
     * | Type | `Edm.Guid` |
     */
    NonConformanceSupervisor: string | null;
}

export interface CreateNonConformanceResourceResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateNonConformanceResource {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Operation` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Operation: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResourceId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ResourceId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Type` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Type: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Resources` |
     * | Type | `Edm.Guid` |
     */
    Resources: string | null;
}

export interface EditMaterialItemsLinkedToHandlingUnitResponse extends CommandResponse {
}

export interface EditMaterialItemsLinkedToHandlingUnit {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `HandlingUnitId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    HandlingUnitId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialTrackingUnitIdQuantityList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.FB_OP_IPL.OPModel.Types.MaterialTrackingUnitIdQuantityParameterType)` |
     * | Nullable | `false` |
     */
    MaterialTrackingUnitIdQuantityList: Array<MaterialTrackingUnitIdQuantityParameterType>;
}

export interface CreateDefectGroupContextualizationResponse extends CommandResponse {
}

export interface CreateDefectGroupContextualization {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefectGroup` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    DefectGroup: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeList` |
     * | Type | `Collection(Edm.String)` |
     */
    EquipmentTypeList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationList` |
     * | Type | `Collection(Edm.String)` |
     */
    EquipmentConfigurationList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DM_MaterialList: Array<string>;
}

export interface LinkATNTypeParameterToToolDefinitionSetPointItemListResponse extends CommandResponse {
}

export interface LinkATNTypeParameterToToolDefinitionSetPointItemList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessOperationUId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ProcessOperationUId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolDefinitionId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToolDefinitionId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutomationNodeTypeNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    AutomationNodeTypeNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutomationNodeTypeParameterNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    AutomationNodeTypeParameterNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointItemParameter` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_AGWInt.MSModel.Types.SetPointItemParameterType)` |
     * | Nullable | `false` |
     */
    SetPointItemParameter: Array<SetPointItemParameterType>;
}

export interface UnlinkToolToAutomationNodeInstanceListResponse extends CommandResponse {
}

export interface UnlinkToolToAutomationNodeInstanceList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolATNInstanceAssociationIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ToolATNInstanceAssociationIdList: Array<string>;
}

export interface CreateProcessRevisionSubStructureResponse extends CommandResponse {
}

export interface CreateProcessRevisionSubStructure {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBOPId` |
     * | Type | `Edm.Guid` |
     */
    AsPlannedBOPId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlanId` |
     * | Type | `Edm.Guid` |
     */
    MasterPlanId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceProcessId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    SourceProcessId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetProcessId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    TargetProcessId: string;
}

export interface CreateWorkOrderOperationsResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface CreateWorkOrderOperations {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperations` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.WorkOrderOperationParameter)` |
     * | Nullable | `false` |
     */
    WorkOrderOperations: Array<WorkOrderOperationParameter>;
}

export interface CreateCustomItlkCheckListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ListOfItlkCheckId` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ListOfItlkCheckId: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Edm.String` |
     */
    WarningMessage: string | null;
}

export interface CreateCustomItlkCheckList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ListOfItlkCheck` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_ITLK.MSModel.Types.CustomItlkCheckParameterType)` |
     * | Nullable | `false` |
     */
    ListOfItlkCheck: Array<CustomItlkCheckParameterType>;
}

export interface UnlinkPJFToMaterialDefinitionResponse extends CommandResponse {
}

export interface UnlinkPJFToMaterialDefinition {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFileToMaterialDefinition` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    PrintJobFileToMaterialDefinition: string;
}

export interface UnlinkItlkCheckToOperationToStepLinkListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Edm.String` |
     */
    WarningMessage: string | null;
}

export interface UnlinkItlkCheckToOperationToStepLinkList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckOperationToStepLinkAssociationIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ItlkCheckOperationToStepLinkAssociationIdList: Array<string>;
}

export interface UnlinkMaterialTrackingUnitFromContainerListResponse extends CommandResponse {
}

export interface UnlinkMaterialTrackingUnitFromContainerList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContainerNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ContainerNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialTrackingUnitNIdList` |
     * | Type | `Collection(Edm.String)` |
     */
    MaterialTrackingUnitNIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
}

export interface UpdateEquipmentTypePropertyAttributeResponse extends CommandResponse {
}

export interface UpdateEquipmentTypePropertyAttribute {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AttributeType` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.SupportedTypes` |
     */
    AttributeType: SupportedTypes | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AttributeValue` |
     * | Type | `Edm.String` |
     */
    AttributeValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Operational` |
     * | Type | `Edm.Boolean` |
     */
    Operational: boolean | null;
}

export interface SetIsValidResponse extends CommandResponse {
}

export interface SetIsValid {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsValid` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsValid: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface TCM2DeleteLinkProcessToProcessListResponse extends CommandResponse {
}

export interface TCM2DeleteLinkProcessToProcessList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface UnLinkMaterialItemsFromHandlingUnitResponse extends CommandResponse {
}

export interface UnLinkMaterialItemsFromHandlingUnit {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `HandlingUnitId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    HandlingUnitId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItemList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    MaterialItemList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
}

export interface CreateDM_MaterialTrackingUnitandMaterialTrackingUnitResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnitId` |
     * | Type | `Edm.Guid` |
     */
    DM_MaterialTrackingUnitId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialTrackingUnitId` |
     * | Type | `Edm.Guid` |
     */
    MaterialTrackingUnitId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnitHistoryIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DM_MaterialTrackingUnitHistoryIdList: Array<string>;
}

export interface CreateDM_MaterialTrackingUnitandMaterialTrackingUnit {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Name: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StateMachineNId` |
     * | Type | `Edm.String` |
     */
    StateMachineNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    Quantity: QuantityParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TemplateNId` |
     * | Type | `Edm.String` |
     */
    TemplateNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Code` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Code: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CodeType` |
     * | Type | `Siemens.SimaticIT.OperationalData.MAT_OP.OPModel.Types.MTUCodeType` |
     */
    CodeType: MTUCodeType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsReserved` |
     * | Type | `Edm.Boolean` |
     */
    IsReserved: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Weight` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    Weight: QuantityParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Volume` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    Volume: QuantityParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActiveNonConformanceNumber` |
     * | Type | `Edm.Int32` |
     */
    ActiveNonConformanceNumber: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BufferNId` |
     * | Type | `Edm.String` |
     */
    BufferNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AMPowderProperties` |
     * | Type | `Siemens.SimaticIT.UADM.OperationalData.FB_OP_MAT.OPModel.Types.AMPowderPropertiesParameterType` |
     */
    AMPowderProperties: AMPowderPropertiesParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    DM_MaterialId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentDM_MTUId` |
     * | Type | `Edm.Guid` |
     */
    ParentDM_MTUId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsCalledFromSplitOfMTU` |
     * | Type | `Edm.Boolean` |
     */
    IsCalledFromSplitOfMTU: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Date` |
     * | Type | `Edm.DateTimeOffset` |
     */
    Date: string | null;
}

export interface ChangeSubstrateStatusByThresholdsResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NewStatus` |
     * | Type | `Edm.String` |
     */
    NewStatus: string | null;
}

export interface ChangeSubstrateStatusByThresholds {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SubstrateNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    SubstrateNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Status: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SubstrateDetails` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.SubstratePropertiesParameterType` |
     * | Nullable | `false` |
     */
    SubstrateDetails: SubstratePropertiesParameterType;
}

export interface DeleteMaterialGroupResponse extends CommandResponse {
}

export interface DeleteMaterialGroup {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface UseToolListOnContainerResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Edm.String` |
     */
    WarningMessage: string | null;
}

export interface UseToolListOnContainer {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolToBeUsedList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.FB_OP_ContainerExec.OPModel.Types.ToolToBeUsedOnContainerParameterType)` |
     * | Nullable | `false` |
     */
    ToolToBeUsedList: Array<ToolToBeUsedOnContainerParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderStepNId: string | null;
}

export interface CreateProcessToOpLinkDependencyNavigationListResponse extends CommandResponse {
}

export interface CreateProcessToOpLinkDependencyNavigationList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessToOpLinkDependecyNavigation` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_BOP.MSModel.Types.DependencyNavigationParameterType)` |
     * | Nullable | `false` |
     */
    ProcessToOpLinkDependecyNavigation: Array<DependencyNavigationParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ProcessId: string;
}

export interface DeactivateMaterialTrackingUnitOnScrewingToolResponse extends CommandResponse {
}

export interface DeactivateMaterialTrackingUnitOnScrewingTool {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnitId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    DM_MaterialTrackingUnitId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedToolId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToBeUsedToolId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    EquipmentNId: string;
}

export interface CreateNewOperationRevisionResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateNewOperationRevision {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ProcessId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBOPId` |
     * | Type | `Edm.Guid` |
     */
    AsPlannedBOPId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetOperationId` |
     * | Type | `Edm.Guid` |
     */
    TargetOperationId: string | null;
}

export interface DeleteWorkOrderStepResponse extends CommandResponse {
}

export interface DeleteWorkOrderStep {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface DeleteExecutionGroupsResponse extends CommandResponse {
}

export interface DeleteExecutionGroups {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface RemoveLocationHoldResponse extends CommandResponse {
}

export interface RemoveLocationHold {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Comment` |
     * | Type | `Edm.String` |
     */
    Comment: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `HoldId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    HoldId: string;
}

export interface UnlinkProcessToProcessListResponse extends CommandResponse {
}

export interface UnlinkProcessToProcessList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Links` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_BOP.MSModel.Types.LinkParameterType)` |
     * | Nullable | `false` |
     */
    Links: Array<LinkParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBOPId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    AsPlannedBOPId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlanId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    MasterPlanId: string;
}

export interface UpdateEquipmentGroupConfigurationResponse extends CommandResponse {
}

export interface UpdateEquipmentGroupConfiguration {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Category` |
     * | Type | `Edm.String` |
     */
    Category: string | null;
}

export interface UpdateWorkInstructionTemplateResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ParameterIds: Array<string>;
}

export interface UpdateWorkInstructionTemplate {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Parameters` |
     * | Type | `Collection(Siemens.SimaticIT.MasterData.WI_MS.MSModel.Types.WorkInstructionDefinitionParameterParameterType)` |
     */
    Parameters: Array<WorkInstructionDefinitionParameterParameterType>;
}

export interface UADMCreateOperationInCatalogueResponse extends CommandResponse {
}

export interface UADMCreateOperationInCatalogue {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UID` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    UID: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Revision: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedDuration` |
     * | Type | `Edm.Int64` |
     */
    EstimatedDuration: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RequiredInspectionRole` |
     * | Type | `Edm.String` |
     */
    RequiredInspectionRole: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignatureStart` |
     * | Type | `Edm.Boolean` |
     */
    ElectronicSignatureStart: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignaturePause` |
     * | Type | `Edm.Boolean` |
     */
    ElectronicSignaturePause: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignatureComplete` |
     * | Type | `Edm.Boolean` |
     */
    ElectronicSignatureComplete: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RequiredCertificateNId` |
     * | Type | `Edm.String` |
     */
    RequiredCertificateNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EffectivityExpression` |
     * | Type | `Edm.String` |
     */
    EffectivityExpression: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOperationTypeNId` |
     * | Type | `Edm.String` |
     */
    WorkOperationTypeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCollectedDocument` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCollectedDocument: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationStepCategoryId` |
     * | Type | `Edm.Guid` |
     */
    OperationStepCategoryId: string | null;
}

export interface UnLinkEquipmentsToBuffersResponse extends CommandResponse {
}

export interface UnLinkEquipmentsToBuffers {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BufferIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    BufferIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNIds` |
     * | Type | `Collection(Edm.String)` |
     */
    EquipmentNIds: Array<string>;
}

export interface UpdateSetPointResponse extends CommandResponse {
}

export interface UpdateSetPoint {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
}

export interface UpdateToolResponse extends CommandResponse {
}

export interface UpdateTool {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SubstrateProperties` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.SubstratePropertiesParameterType` |
     */
    SubstrateProperties: SubstratePropertiesParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UsageCounterMax` |
     * | Type | `Edm.Int32` |
     */
    UsageCounterMax: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UsageDurationMax` |
     * | Type | `Edm.Duration` |
     */
    UsageDurationMax: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExpirationDate` |
     * | Type | `Edm.DateTimeOffset` |
     */
    ExpirationDate: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActiveNonConformanceNr` |
     * | Type | `Edm.Int32` |
     */
    ActiveNonConformanceNr: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     */
    Status: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsScrap` |
     * | Type | `Edm.Boolean` |
     */
    IsScrap: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLock` |
     * | Type | `Edm.Boolean` |
     */
    IsLock: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Lockable` |
     * | Type | `Edm.Boolean` |
     */
    Lockable: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsRuntimeFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsRuntimeFrozen: boolean | null;
}

export interface CreateStepInOperationResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateStepInOperation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Step` |
     * | Type | `Siemens.SimaticIT.U4DM.MasterData.FB_MS_BOP.MSModel.Types.StepInOperationParameterType` |
     * | Nullable | `false` |
     */
    Step: StepInOperationParameterType;
}

export interface SplitAndLinkMaterialItemsToHandlingUnitResponse extends CommandResponse {
}

export interface SplitAndLinkMaterialItemsToHandlingUnit {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnitIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DM_MaterialTrackingUnitIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `HandlingUnit_Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    HandlingUnit_Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
}

export interface LinkToBeUsedMachineToPJFForEGPhaseResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    IdList: Array<string>;
}

export interface LinkToBeUsedMachineToPJFForEGPhase {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MachineNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    MachineNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFileList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.FB_OP_AM.OPModel.Types.PJFIsSourceParameterType)` |
     * | Nullable | `false` |
     */
    PrintJobFileList: Array<PJFIsSourceParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EG_PhaseId` |
     * | Type | `Edm.Guid` |
     */
    EG_PhaseId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedMachineId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToBeUsedMachineId: string;
}

export interface CreateLogisticRequestResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateLogisticRequest {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     * | Nullable | `false` |
     */
    Quantity: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Destination` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Destination: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Source` |
     * | Type | `Edm.Guid` |
     */
    Source: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DueDate` |
     * | Type | `Edm.DateTimeOffset` |
     */
    DueDate: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `User` |
     * | Type | `Edm.String` |
     */
    User: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Buffer` |
     * | Type | `Edm.Guid` |
     */
    Buffer: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialDefinition` |
     * | Type | `Edm.Guid` |
     */
    MaterialDefinition: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolDefinition` |
     * | Type | `Edm.Guid` |
     */
    ToolDefinition: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Uom` |
     * | Type | `Edm.String` |
     */
    Uom: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogisticRequestType` |
     * | Type | `Edm.String` |
     */
    LogisticRequestType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Priority` |
     * | Type | `Edm.Int32` |
     */
    Priority: number | null;
}

export interface LinkMaterialItemsToNonConformanceResponse extends CommandResponse {
}

export interface LinkMaterialItemsToNonConformance {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    NonConformanceId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItemIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    MaterialItemIds: Array<string>;
}

export interface PauseExecutionGroupPhaseResponse extends CommandResponse {
}

export interface PauseExecutionGroupPhase {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupPhaseId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ExecutionGroupPhaseId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReasonId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ReasonId: string;
}

export interface UpdateEquipmentTypePropertyResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AttributeIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    AttributeIds: Array<string>;
}

export interface UpdateEquipmentTypeProperty {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PropertyType` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.SupportedTypes` |
     */
    PropertyType: SupportedTypes | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PropertyValue` |
     * | Type | `Edm.String` |
     */
    PropertyValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Attributes` |
     * | Type | `Collection(Siemens.SimaticIT.MasterData.EQU_MS.MSModel.Types.PropertyParameterType)` |
     */
    Attributes: Array<PropertyParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Operational` |
     * | Type | `Edm.Boolean` |
     */
    Operational: boolean | null;
}

export interface CreateUoMDimensionResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoMDimensionId` |
     * | Type | `Edm.Guid` |
     */
    UoMDimensionId: string | null;
}

export interface CreateUoMDimension {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
}

export interface StartTransportOperationResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface StartTransportOperation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TransportOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    TransportOperationId: string;
}

export interface UpdateWOOpQuantityAssociatedToEGResponse extends CommandResponse {
}

export interface UpdateWOOpQuantityAssociatedToEG {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ExecutionGroupId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupOperations` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ExecutionGroupOperationParameterType)` |
     * | Nullable | `false` |
     */
    ExecutionGroupOperations: Array<ExecutionGroupOperationParameterType>;
}

export interface CompleteExecutionGroupPhaseResponse extends CommandResponse {
}

export interface CompleteExecutionGroupPhase {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupPhaseId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ExecutionGroupPhaseId: string;
}

export interface UpdateBufferResponse extends CommandResponse {
}

export interface UpdateBuffer {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BufferId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    BufferId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Name: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ValidFrom` |
     * | Type | `Edm.DateTimeOffset` |
     */
    ValidFrom: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ValidTo` |
     * | Type | `Edm.DateTimeOffset` |
     */
    ValidTo: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LocationNId` |
     * | Type | `Edm.String` |
     */
    LocationNId: string | null;
}

export interface UpdateStepDependencyResponse extends CommandResponse {
}

export interface UpdateStepDependency {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StepDependency` |
     * | Type | `Siemens.SimaticIT.U4DM.MasterData.FB_MS_BOP.MSModel.Types.StepDependencyParameterType` |
     * | Nullable | `false` |
     */
    StepDependency: StepDependencyParameterType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface AmendOfResultToRepeatResponse extends CommandResponse {
}

export interface AmendOfResultToRepeat {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MTUWithResultList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.FB_OP_Result.OPModel.Types.DMMTUWithResultParameterType)` |
     * | Nullable | `false` |
     */
    DM_MTUWithResultList: Array<DMMTUWithResultParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProductionType` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ProductionTypeEnum` |
     * | Nullable | `false` |
     */
    ProductionType: ProductionTypeEnum;
}

export interface CompleteAsPlannedBOPResponse extends CommandResponse {
}

export interface CompleteAsPlannedBOP {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface TransmitEquipmentSetPointToAutomationNodeParametersResponse extends CommandResponse {
}

export interface TransmitEquipmentSetPointToAutomationNodeParameters {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    EquipmentNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    SetPointId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    UserId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointItemId` |
     * | Type | `Edm.Guid` |
     */
    SetPointItemId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointValue` |
     * | Type | `Edm.String` |
     */
    SetPointValue: string | null;
}

export interface AcquireDCItemValueFromAutomationNodeInstanceParameterResponse extends CommandResponse {
}

export interface AcquireDCItemValueFromAutomationNodeInstanceParameter {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    EquipmentNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionStepItemIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    WorkInstructionStepItemIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsConfirm` |
     * | Type | `Edm.Boolean` |
     */
    IsConfirm: boolean | null;
}

export interface UpdateUoMResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MultipleOrSubmultipleUoMIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    MultipleOrSubmultipleUoMIdList: Array<string>;
}

export interface UpdateUoM {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MultipleOrSubmultipleUoMList` |
     * | Type | `Collection(Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.MultipleOrSubmultipleUoMParameterType)` |
     */
    MultipleOrSubmultipleUoMList: Array<MultipleOrSubmultipleUoMParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
}

export interface UnlinkItlkCheckToProcessToOpLinkListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Edm.String` |
     */
    WarningMessage: string | null;
}

export interface UnlinkItlkCheckToProcessToOpLinkList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckProcessToOpLinkAssociationIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ItlkCheckProcessToOpLinkAssociationIdList: Array<string>;
}

export interface UpdateAttributiveCharacteristicSpecificationResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FailureAssociationIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    FailureAssociationIds: Array<string>;
}

export interface UpdateAttributiveCharacteristicSpecification {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Context` |
     * | Type | `Siemens.SimaticIT.MasterData.CHR_MS.MSModel.Types.CharacteristicContext` |
     */
    Context: CharacteristicContext | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Criticality` |
     * | Type | `Edm.String` |
     */
    Criticality: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NOKDescription` |
     * | Type | `Edm.String` |
     */
    NOKDescription: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OKDescription` |
     * | Type | `Edm.String` |
     */
    OKDescription: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FailureAssociations` |
     * | Type | `Collection(Siemens.SimaticIT.MasterData.CHR_MS.MSModel.Types.CharacteristicFailureAssociation)` |
     */
    FailureAssociations: Array<CharacteristicFailureAssociation>;
}

export interface UpdateVisualCharacteristicSpecificationResponse extends CommandResponse {
}

export interface UpdateVisualCharacteristicSpecification {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Context` |
     * | Type | `Siemens.SimaticIT.MasterData.CHR_MS.MSModel.Types.CharacteristicContext` |
     */
    Context: CharacteristicContext | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Criticality` |
     * | Type | `Edm.String` |
     */
    Criticality: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SketchRows` |
     * | Type | `Edm.Int32` |
     */
    SketchRows: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SketchColumns` |
     * | Type | `Edm.Int32` |
     */
    SketchColumns: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sketch` |
     * | Type | `Edm.Binary` |
     */
    Sketch: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SketchMimeType` |
     * | Type | `Edm.String` |
     */
    SketchMimeType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SketchName` |
     * | Type | `Edm.String` |
     */
    SketchName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SketchId` |
     * | Type | `Edm.Guid` |
     */
    SketchId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MarkForDeletion` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    MarkForDeletion: boolean;
}

export interface UpdateMachineToDNCResponse extends CommandResponse {
}

export interface UpdateMachineToDNC {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MachineToDNCId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    MachineToDNCId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DNCMachine` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    DNCMachine: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
}

export interface GenerateSerialNumberCodesResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SerialNumberCodes` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.IdGenerate.OPModel.Types.SerialNumberCodesParameterType` |
     */
    SerialNumberCodes: SerialNumberCodesParameterType | null;
}

export interface GenerateSerialNumberCodes {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Count` |
     * | Type | `Edm.Int32` |
     * | Nullable | `false` |
     */
    Count: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    MaterialId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OrderId` |
     * | Type | `Edm.String` |
     */
    OrderId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Timestamp` |
     * | Type | `Edm.DateTimeOffset` |
     */
    Timestamp: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TemplateId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    TemplateId: string;
}

export interface DeleteActualUsedMachinePJFResponse extends CommandResponse {
}

export interface DeleteActualUsedMachinePJF {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface CheckInCompleteWOStepSerializedResponse extends CommandResponse {
}

export interface CheckInCompleteWOStepSerialized {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OfflineActionInternalId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OfflineActionInternalId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CompleteWOStepSerializedParameter` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.CompleteWOStepSerializedParameterType` |
     * | Nullable | `false` |
     */
    CompleteWOStepSerializedParameter: CompleteWOStepSerializedParameterType;
}

export interface DeassociateDNCItemMachineMaterialsAssociationResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FailedId` |
     * | Type | `Edm.Guid` |
     */
    FailedId: string | null;
}

export interface DeassociateDNCItemMachineMaterialsAssociation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Siemens.SimaticIT.U4DM.MasterData.FB_MS_DNC.MSModel.Types.IdsParameterType` |
     * | Nullable | `false` |
     */
    Ids: IdsParameterType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DNCItemId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    DNCItemId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MachineToDNCId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    MachineToDNCId: string;
}

export interface CreateWorkOrderHistoryMaterialItemResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateWorkOrderHistoryMaterialItem {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItem` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    MaterialItem: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderHistory` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderHistory: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
}

export interface UnlinkDocumentFromContainerTypeListResponse extends CommandResponse {
}

export interface UnlinkDocumentFromContainerTypeList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContainerTypeNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ContainerTypeNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DocumentIdList: Array<string>;
}

export interface LinkDocumentToOperationResponse extends CommandResponse {
}

export interface LinkDocumentToOperation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    DocumentId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OperationId: string;
}

export interface DeleteMaterialClassListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Edm.String` |
     */
    WarningMessage: string | null;
}

export interface DeleteMaterialClassList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialGroupIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    MaterialGroupIds: Array<string>;
}

export interface LinkSubstrateToMachineResponse extends CommandResponse {
}

export interface LinkSubstrateToMachine {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SubstrateId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    SubstrateId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MachineList` |
     * | Type | `Collection(Edm.String)` |
     */
    MachineList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeList` |
     * | Type | `Collection(Edm.String)` |
     */
    EquipmentTypeList: Array<string>;
}

export interface UnlinkSkillsToStepResponse extends CommandResponse {
}

export interface UnlinkSkillsToStep {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StepSkillIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    StepSkillIds: Array<string>;
}

export interface UADMUpdateToolSpecificationResponse extends CommandResponse {
}

export interface UADMUpdateToolSpecification {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UsageNumber` |
     * | Type | `Edm.Int32` |
     */
    UsageNumber: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UsageDuration` |
     * | Type | `Edm.Duration` |
     */
    UsageDuration: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EffectivityExpression` |
     * | Type | `Edm.String` |
     */
    EffectivityExpression: string | null;
}

export interface CreateWorkOrderHeaderResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface CreateWorkOrderHeader {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Name: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     * | Nullable | `false` |
     */
    Quantity: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Plant` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Plant: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BatchId` |
     * | Type | `Edm.String` |
     */
    BatchId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DueDate` |
     * | Type | `Edm.DateTimeOffset` |
     */
    DueDate: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ERPOrder` |
     * | Type | `Edm.String` |
     */
    ERPOrder: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedStartTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedStartTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedEndTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedEndTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ConfigurationParameter` |
     * | Type | `Edm.String` |
     */
    ConfigurationParameter: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RoutingID` |
     * | Type | `Edm.String` |
     */
    RoutingID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetProductID` |
     * | Type | `Edm.String` |
     */
    TargetProductID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FinalMaterialId` |
     * | Type | `Edm.Guid` |
     */
    FinalMaterialId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Priority` |
     * | Type | `Edm.Int32` |
     */
    Priority: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProductionTypeNId` |
     * | Type | `Edm.String` |
     */
    ProductionTypeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.String` |
     */
    CorrelationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ConfirmationType` |
     * | Type | `Edm.String` |
     */
    ConfirmationType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PBOPIdentID` |
     * | Type | `Edm.String` |
     */
    PBOPIdentID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BillOfFeatureNId` |
     * | Type | `Edm.String` |
     */
    BillOfFeatureNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BillOfFeatureRevision` |
     * | Type | `Edm.String` |
     */
    BillOfFeatureRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BoM` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.BoMParameterType` |
     */
    BoM: BoMParameterType | null;
}

export interface DeleteEquipmentGraphNodeConfigurationResponse extends CommandResponse {
}

export interface DeleteEquipmentGraphNodeConfiguration {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface UADMAutomaticStartResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Edm.String` |
     */
    WarningMessage: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionContextData` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.WOOpExecutionParameterType` |
     */
    ExecutionContextData: WOOpExecutionParameterType | null;
}

export interface UADMAutomaticStart {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentName` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    EquipmentName: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Category` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Category: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProductMaterialItemList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ProducedMaterialItemParameterType)` |
     * | Nullable | `false` |
     */
    ProductMaterialItemList: Array<ProducedMaterialItemParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualStartTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    ActualStartTime: string | null;
}

export interface CreateNewStepRevisionInOperationResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateNewStepRevisionInOperation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StepId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    StepId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBOPId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    AsPlannedBOPId: string;
}

export interface CreateNonConformanceTransitionResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
}

export interface CreateNonConformanceTransition {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Name: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Lifecycle` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Lifecycle: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FromStatus` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    FromStatus: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToStatus` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ToStatus: string;
}

export interface UpdateWorkOOperationDependencyResponse extends CommandResponse {
}

export interface UpdateWorkOOperationDependency {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Dependency` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.WorkOOperationDependencyParameter` |
     * | Nullable | `false` |
     */
    Dependency: WorkOOperationDependencyParameter;
}

export interface CompleteWOOperationFullQtyResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Collection(Edm.String)` |
     */
    WarningMessage: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CompletedMaterialTrackingUnitList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.CompletedMTUParameterType)` |
     */
    CompletedMaterialTrackingUnitList: Array<CompletedMTUParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderHistoryId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderHistoryId: string | null;
}

export interface CompleteWOOperationFullQty {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupPhaseId` |
     * | Type | `Edm.Guid` |
     */
    ExecutionGroupPhaseId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CompleteWOOperationFullQtyParameterType` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.CompleteWOOperationFullQtyParameterType` |
     * | Nullable | `false` |
     */
    CompleteWOOperationFullQtyParameterType: CompleteWOOperationFullQtyParameterType;
}

export interface CompleteWOStepSerializedResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderHistoryId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderHistoryId: string | null;
}

export interface CompleteWOStepSerialized {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CompleteWOStepSerializedParameterType` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.CompleteWOStepSerializedParameterType` |
     * | Nullable | `false` |
     */
    CompleteWOStepSerializedParameterType: CompleteWOStepSerializedParameterType;
}

export interface AcceptChangeRemoveOperationResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceNId` |
     * | Type | `Edm.String` |
     */
    NonConformanceNId: string | null;
}

export interface AcceptChangeRemoveOperation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChangeOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ChangeOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RefNumber` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    RefNumber: string;
}

export interface CompleteWOOperationsSerializedLiteResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessages` |
     * | Type | `Collection(Edm.String)` |
     */
    WarningMessages: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CompletedMaterialTrackingUnits` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.CompletedMTUParameterType)` |
     */
    CompletedMaterialTrackingUnits: Array<CompletedMTUParameterType>;
}

export interface CompleteWOOperationsSerializedLite {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CompleteWOOpSerializedLiteParameters` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.CompleteWOOpSerializedLiteParameterType)` |
     * | Nullable | `false` |
     */
    CompleteWOOpSerializedLiteParameters: Array<CompleteWOOpSerializedLiteParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `User` |
     * | Type | `Edm.String` |
     */
    User: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PauseSerialNumbers` |
     * | Type | `Edm.Boolean` |
     */
    PauseSerialNumbers: boolean | null;
}

export interface LinkAMMachineToMESResponse extends CommandResponse {
}

export interface LinkAMMachineToMES {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AMMachine` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    AMMachine: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TransferPlugin` |
     * | Type | `Edm.String` |
     */
    TransferPlugin: string | null;
}

export interface DNCTransferDNCItemResponse extends CommandResponse {
}

export interface DNCTransferDNCItem {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DNCMachine` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    DNCMachine: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DNCId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    DNCId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsPickerTransfer` |
     * | Type | `Edm.Boolean` |
     */
    IsPickerTransfer: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkOrderNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkOrderOperationNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MachineNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    MachineNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItemIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    MaterialItemIds: Array<string>;
}

export interface TCM2CreateDocumentListResponse extends CommandResponse {
}

export interface TCM2CreateDocumentList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_BOP.MSModel.Types.TCM2DocumentParameterType)` |
     * | Nullable | `false` |
     */
    DocumentList: Array<TCM2DocumentParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     */
    CorrelationId: string | null;
}

export interface UpdateDefectResponse extends CommandResponse {
}

export interface UpdateDefect {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefectType` |
     * | Type | `Edm.Guid` |
     */
    DefectType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformance` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    NonConformance: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `GroupPath` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    GroupPath: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FailureNId` |
     * | Type | `Edm.String` |
     */
    FailureNId: string | null;
}

export interface RemoveNonConformanceTransitionRoleListResponse extends CommandResponse {
}

export interface RemoveNonConformanceTransitionRoleList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceTransitionId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NonConformanceTransitionId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RoleList` |
     * | Type | `Collection(Edm.String)` |
     */
    RoleList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LifeCycle` |
     * | Type | `Edm.String` |
     */
    LifeCycle: string | null;
}

export interface DeleteStatusDefinitionResponse extends CommandResponse {
}

export interface DeleteStatusDefinition {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface UnlinkOperationStepCategoryFromProcessDefinitionListResponse extends CommandResponse {
}

export interface UnlinkOperationStepCategoryFromProcessDefinitionList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    IdList: Array<string>;
}

export interface UpdateItlkCheckWOStepAssociationListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Edm.String` |
     */
    WarningMessage: string | null;
}

export interface UpdateItlkCheckWOStepAssociationList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckWOStepAssociationList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.FB_OP_ITLK.OPModel.Types.ItlkCheckWOStepAssociationUpdateParameterType)` |
     * | Nullable | `false` |
     */
    ItlkCheckWOStepAssociationList: Array<ItlkCheckWOStepAssociationUpdateParameterType>;
}

export interface CreateProcessNotificationResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessNotificationId` |
     * | Type | `Edm.Guid` |
     */
    ProcessNotificationId: string | null;
}

export interface CreateProcessNotification {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ProcessId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ProcessNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessRevision` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ProcessRevision: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessUId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ProcessUId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessName` |
     * | Type | `Edm.String` |
     */
    ProcessName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBOPId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    AsPlannedBOPId: string;
}

export interface CreateFutureHoldResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateFutureHold {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CloseTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CloseTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CloseUserId` |
     * | Type | `Edm.String` |
     */
    CloseUserId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Comment` |
     * | Type | `Edm.String` |
     */
    Comment: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsPresent` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsPresent: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LifeCycle` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    LifeCycle: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OpenTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    OpenTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OpenUserId` |
     * | Type | `Edm.String` |
     */
    OpenUserId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PreviousStatus` |
     * | Type | `Edm.String` |
     */
    PreviousStatus: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReasonId` |
     * | Type | `Edm.String` |
     */
    ReasonId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkOrderNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkOrderOperationNId: string;
}

export interface CreateEquipmentGraphLinkConfigurationResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateEquipmentGraphLinkConfiguration {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceEquipmentGraphNodeConfigurationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    SourceEquipmentGraphNodeConfigurationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DestinationEquipmentGraphNodeConfigurationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    DestinationEquipmentGraphNodeConfigurationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Label` |
     * | Type | `Edm.String` |
     */
    Label: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourcePosition` |
     * | Type | `Edm.String` |
     */
    SourcePosition: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DestinationPosition` |
     * | Type | `Edm.String` |
     */
    DestinationPosition: string | null;
}

export interface DeleteProcessListResponse extends CommandResponse {
}

export interface DeleteProcessList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Ids: Array<string>;
}

export interface UpdateActualUsedToolResponse extends CommandResponse {
}

export interface UpdateActualUsedTool {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UsedTimes` |
     * | Type | `Edm.Decimal` |
     * | Nullable | `false` |
     */
    UsedTimes: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedTool` |
     * | Type | `Edm.Guid` |
     */
    ToBeUsedTool: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualUsageCounter` |
     * | Type | `Edm.Decimal` |
     */
    ActualUsageCounter: number | null;
}

export interface DeleteOperationFromCatalogueResponse extends CommandResponse {
}

export interface DeleteOperationFromCatalogue {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface CompleteWOOperationSerializedResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Collection(Edm.String)` |
     */
    WarningMessage: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CompletedMaterialTrackingUnits` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.CompletedMTUParameterType)` |
     */
    CompletedMaterialTrackingUnits: Array<CompletedMTUParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderHistoryId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderHistoryId: string | null;
}

export interface CompleteWOOperationSerialized {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupPhaseId` |
     * | Type | `Edm.Guid` |
     */
    ExecutionGroupPhaseId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CompleteWOOperationSerializedParameterType` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.CompleteWOOperationSerializedParameterType` |
     * | Nullable | `false` |
     */
    CompleteWOOperationSerializedParameterType: CompleteWOOperationSerializedParameterType;
}

export interface UpdateItlkCheckOperationStepCategoryAssociationListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Edm.String` |
     */
    WarningMessage: string | null;
}

export interface UpdateItlkCheckOperationStepCategoryAssociationList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckOperationStepCategoryAssociationList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_ITLK.MSModel.Types.ItlkCheckOperationStepCategoryAssociationUpdateParameterType)` |
     * | Nullable | `false` |
     */
    ItlkCheckOperationStepCategoryAssociationList: Array<ItlkCheckOperationStepCategoryAssociationUpdateParameterType>;
}

export interface DeleteTemplateBlockResponse extends CommandResponse {
}

export interface DeleteTemplateBlock {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface SetExecGroupListInEditStatusResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessages` |
     * | Type | `Collection(Edm.String)` |
     */
    WarningMessages: Array<string>;
}

export interface SetExecGroupListInEditStatus {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupNIdList` |
     * | Type | `Collection(Edm.String)` |
     */
    ExecutionGroupNIdList: Array<string>;
}

export interface DeleteMaterialDefinitionDocumentResponse extends CommandResponse {
}

export interface DeleteMaterialDefinitionDocument {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface UnLinkToBeUsedMachineToPJFForEGPhaseResponse extends CommandResponse {
}

export interface UnLinkToBeUsedMachineToPJFForEGPhase {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EGPhase_Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    EGPhase_Id: string;
}

export interface UpdateWorkInstructionDefinitionParameterResponse extends CommandResponse {
}

export interface UpdateWorkInstructionDefinitionParameter {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterType` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.SupportedTypes` |
     */
    ParameterType: SupportedTypes | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterValue` |
     * | Type | `Edm.String` |
     */
    ParameterValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterUoMNId` |
     * | Type | `Edm.String` |
     */
    ParameterUoMNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Direction` |
     * | Type | `Siemens.SimaticIT.MasterData.WI_MS.MSModel.Types.WorkInstructionDefinitionParameterDirection` |
     */
    Direction: WorkInstructionDefinitionParameterDirection | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsReadOnly` |
     * | Type | `Edm.Boolean` |
     */
    IsReadOnly: boolean | null;
}

export interface TCM2LinkOperationToStepFullListResponse extends CommandResponse {
}

export interface TCM2LinkOperationToStepFullList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LinkList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_BOP.MSModel.Types.TCM2LinkParameterType)` |
     * | Nullable | `false` |
     */
    LinkList: Array<TCM2LinkParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     */
    CorrelationId: string | null;
}

export interface TCM2CreateMasterPlanResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface TCM2CreateMasterPlan {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlan` |
     * | Type | `Siemens.SimaticIT.U4DM.MasterData.FB_MS_BOP.MSModel.Types.TCM2MasterPlanParameterType` |
     * | Nullable | `false` |
     */
    MasterPlan: TCM2MasterPlanParameterType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     */
    CorrelationId: string | null;
}

export interface CreateWorkOrderOperationFromMPProcessOperationResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateWorkOrderOperationFromMPProcessOperation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DependencyType` |
     * | Type | `Edm.String` |
     */
    DependencyType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationData` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.WorkOrderOperationParameter` |
     * | Nullable | `false` |
     */
    WorkOrderOperationData: WorkOrderOperationParameter;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlanId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    MasterPlanId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SkipStepsCreation` |
     * | Type | `Edm.Boolean` |
     */
    SkipStepsCreation: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SkipMaterialsCreation` |
     * | Type | `Edm.Boolean` |
     */
    SkipMaterialsCreation: boolean | null;
}

export interface CheckInStartWOStepSerializedResponse extends CommandResponse {
}

export interface CheckInStartWOStepSerialized {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StartWOStepSerializedParameter` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.StartWOStepSerializedParameterType` |
     * | Nullable | `false` |
     */
    StartWOStepSerializedParameter: StartWOStepSerializedParameterType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OfflineActionInternalId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OfflineActionInternalId: string;
}

export interface UADMCreateMaterialSpecificationResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface UADMCreateMaterialSpecification {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialSpecification` |
     * | Type | `Siemens.SimaticIT.U4DM.MasterData.FB_MS_BOP.MSModel.Types.MaterialSpecificationParameterType` |
     * | Nullable | `false` |
     */
    MaterialSpecification: MaterialSpecificationParameterType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.Guid` |
     */
    CorrelationId: string | null;
}

export interface CreateWOOpDependencyNavigationMTUAssociationResponse extends CommandResponse {
}

export interface CreateWOOpDependencyNavigationMTUAssociation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MTUList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    MTUList: Array<string>;
}

export interface CreateDefectTypeResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface CreateDefectType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Name: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Description: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `GroupIdentifiersList` |
     * | Type | `Collection(Siemens.SimaticIT.MasterData.MatTool.MSModel.Types.IdentifiersParameterType)` |
     */
    GroupIdentifiersList: Array<IdentifiersParameterType>;
}

export interface CreateToBeUsedMachineResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedMachineId` |
     * | Type | `Edm.Guid` |
     */
    ToBeUsedMachineId: string | null;
}

export interface CreateToBeUsedMachine {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkOrderOperationNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeNId` |
     * | Type | `Edm.String` |
     */
    EquipmentTypeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PartProgram` |
     * | Type | `Edm.String` |
     */
    PartProgram: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFile` |
     * | Type | `Edm.Guid` |
     */
    PrintJobFile: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsForEgPhase` |
     * | Type | `Edm.Boolean` |
     */
    IsForEgPhase: boolean | null;
}

export interface UnlinkToolDefinitionToSetPointResponse extends CommandResponse {
}

export interface UnlinkToolDefinitionToSetPoint {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointToolDefinitionAssociationList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    SetPointToolDefinitionAssociationList: Array<string>;
}

export interface ToolMaintenanceResponse extends CommandResponse {
}

export interface ToolMaintenance {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Tool` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Tool: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UsageCounter` |
     * | Type | `Edm.Int32` |
     */
    UsageCounter: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UsageDuration` |
     * | Type | `Edm.Duration` |
     */
    UsageDuration: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExpirationDate` |
     * | Type | `Edm.DateTimeOffset` |
     */
    ExpirationDate: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Locked` |
     * | Type | `Edm.Boolean` |
     */
    Locked: boolean | null;
}

export interface LinkATNInstanceParameterToSetPointItemListResponse extends CommandResponse {
}

export interface LinkATNInstanceParameterToSetPointItemList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutomationNodeInstanceNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    AutomationNodeInstanceNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutomationNodeInstanceParameterNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    AutomationNodeInstanceParameterNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Equipment` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Equipment: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessOperation` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ProcessOperation: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointItemList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    SetPointItemList: Array<string>;
}

export interface AssignCertificationToRoleListResponse extends CommandResponse {
}

export interface AssignCertificationToRoleList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CertificationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    CertificationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Roles` |
     * | Type | `Collection(Edm.String)` |
     */
    Roles: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExpiryDate` |
     * | Type | `Edm.DateTimeOffset` |
     * | Nullable | `false` |
     */
    ExpiryDate: string;
}

export interface LinkOperationDependencyToProcessResponse extends CommandResponse {
}

export interface LinkOperationDependencyToProcess {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationDependencyId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OperationDependencyId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ProcessId: string;
}

export interface CheckInStartWOStepFullQtyResponse extends CommandResponse {
}

export interface CheckInStartWOStepFullQty {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StartWOStepFullQtyParameter` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.StartWOStepFullQtyParameterType` |
     * | Nullable | `false` |
     */
    StartWOStepFullQtyParameter: StartWOStepFullQtyParameterType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OfflineActionInternalId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OfflineActionInternalId: string;
}

export interface DeleteNonConformanceItemResponse extends CommandResponse {
}

export interface DeleteNonConformanceItem {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `GenericItems` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    GenericItems: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    NonConformanceId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNIds` |
     * | Type | `Collection(Edm.String)` |
     */
    EquipmentNIds: Array<string>;
}

export interface LinkDocumentListToStepResponse extends CommandResponse {
}

export interface LinkDocumentListToStep {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ListOfDocumentId` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ListOfDocumentId: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StepId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    StepId: string;
}

export interface RemoveDefectTypeContextualizationResponse extends CommandResponse {
}

export interface RemoveDefectTypeContextualization {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefectTypeId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    DefectTypeId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DM_MaterialList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationList` |
     * | Type | `Collection(Edm.String)` |
     */
    EquipmentConfigurationList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeList` |
     * | Type | `Collection(Edm.String)` |
     */
    EquipmentTypeList: Array<string>;
}

export interface LoadContainerResponse extends CommandResponse {
}

export interface LoadContainer {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContainerNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ContainerNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkOrderNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkOrderOperationNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MTUNIdList` |
     * | Type | `Collection(Edm.String)` |
     */
    MTUNIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
}

export interface CreateMachineToDNCResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MachineToDNCId` |
     * | Type | `Edm.Guid` |
     */
    MachineToDNCId: string | null;
}

export interface CreateMachineToDNC {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DNCMachine` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    DNCMachine: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
}

export interface RemoveCertificationToUserListResponse extends CommandResponse {
}

export interface RemoveCertificationToUserList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CertificationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    CertificationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Users` |
     * | Type | `Collection(Edm.String)` |
     */
    Users: Array<string>;
}

export interface ChangeOfflineSessionStatusResponse extends CommandResponse {
}

export interface ChangeOfflineSessionStatus {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OfflineSessionIdFlag0` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    OfflineSessionIdFlag0: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OfflineSessionId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OfflineSessionId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TransitionVerb` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    TransitionVerb: string;
}

export interface RepairWorkInstructionResponse extends CommandResponse {
}

export interface RepairWorkInstruction {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RepairContext` |
     * | Type | `Siemens.OpcenterEX.DS.OperationalData.FB_OP_RuntimeQG.OPModel.Types.RepairActivityParameterType` |
     * | Nullable | `false` |
     */
    RepairContext: RepairActivityParameterType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionRepair` |
     * | Type | `Siemens.OpcenterEX.DS.OperationalData.FB_OP_RuntimeQG.OPModel.Types.RepairWorkInstructionActivityParameterType` |
     * | Nullable | `false` |
     */
    WorkInstructionRepair: RepairWorkInstructionActivityParameterType;
}

export interface CreateActivityListResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActivityIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ActivityIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Collection(Edm.String)` |
     */
    WarningMessage: Array<string>;
}

export interface CreateActivityList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Activities` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.FB_OP_Result.OPModel.Types.Activity)` |
     * | Nullable | `false` |
     */
    Activities: Array<Activity>;
}

export interface RepairMaterialConsumptionResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RepairResult` |
     * | Type | `Siemens.OpcenterEX.DS.OperationalData.FB_OP_RuntimeQG.OPModel.Types.RepairResultParameterType` |
     */
    RepairResult: RepairResultParameterType | null;
}

export interface RepairMaterialConsumption {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RepairContext` |
     * | Type | `Siemens.OpcenterEX.DS.OperationalData.FB_OP_RuntimeQG.OPModel.Types.RepairActivityParameterType` |
     * | Nullable | `false` |
     */
    RepairContext: RepairActivityParameterType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialConsumption` |
     * | Type | `Siemens.OpcenterEX.DS.OperationalData.FB_OP_RuntimeQG.OPModel.Types.RepairMaterialActivityParameterType` |
     * | Nullable | `false` |
     */
    MaterialConsumption: RepairMaterialActivityParameterType;
}

export interface MarkForCleaningToolListResponse extends CommandResponse {
}

export interface MarkForCleaningToolList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ToolIdList: Array<string>;
}

export interface CreateCustomActivityResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActivityIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ActivityIdList: Array<string>;
}

export interface CreateCustomActivity {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Activities` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.FB_OP_Result.OPModel.Types.Activity)` |
     * | Nullable | `false` |
     */
    Activities: Array<Activity>;
}

export interface MarkForCleaningWorkOrderListResponse extends CommandResponse {
}

export interface MarkForCleaningWorkOrderList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    WorkOrderIdList: Array<string>;
}

export interface RepairToolUsageResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Edm.String` |
     */
    WarningMessage: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RepairResult` |
     * | Type | `Siemens.OpcenterEX.DS.OperationalData.FB_OP_RuntimeQG.OPModel.Types.RepairResultParameterType` |
     */
    RepairResult: RepairResultParameterType | null;
}

export interface RepairToolUsage {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RepairContext` |
     * | Type | `Siemens.OpcenterEX.DS.OperationalData.FB_OP_RuntimeQG.OPModel.Types.RepairActivityParameterType` |
     * | Nullable | `false` |
     */
    RepairContext: RepairActivityParameterType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolUsage` |
     * | Type | `Siemens.OpcenterEX.DS.OperationalData.FB_OP_RuntimeQG.OPModel.Types.RepairToolActivityParameterType` |
     * | Nullable | `false` |
     */
    ToolUsage: RepairToolActivityParameterType;
}

export interface UpdateWorkOrderStatusAndPropertiesCommandResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StatusNId` |
     * | Type | `Edm.String` |
     */
    StatusNId: string | null;
}

export interface UpdateWorkOrderStatusAndPropertiesCommand {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualTime` |
     * | Type | `Edm.DateTimeOffset` |
     * | Nullable | `false` |
     */
    ActualTime: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MtuIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DM_MtuIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
}

export interface MarkForCleaningMTUListResponse extends CommandResponse {
}

export interface MarkForCleaningMTUList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MTUIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    MTUIdList: Array<string>;
}

export interface MarkForCleaningExecutionGroupListResponse extends CommandResponse {
}

export interface MarkForCleaningExecutionGroupList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ExecutionGroupIdList: Array<string>;
}

export interface RepairQualityInspectionResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RepairResult` |
     * | Type | `Siemens.OpcenterEX.DS.OperationalData.FB_OP_RuntimeQG.OPModel.Types.RepairResultParameterType` |
     */
    RepairResult: RepairResultParameterType | null;
}

export interface RepairQualityInspection {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RepairContext` |
     * | Type | `Siemens.OpcenterEX.DS.OperationalData.FB_OP_RuntimeQG.OPModel.Types.RepairActivityParameterType` |
     * | Nullable | `false` |
     */
    RepairContext: RepairActivityParameterType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `QualityInspection` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.AutomaticAcquireQualityCharactersticsParameterType)` |
     * | Nullable | `false` |
     */
    QualityInspection: Array<AutomaticAcquireQualityCharactersticsParameterType>;
}

export interface RepairScrewingToolUsageResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RepairResult` |
     * | Type | `Siemens.OpcenterEX.DS.OperationalData.FB_OP_RuntimeQG.OPModel.Types.RepairResultParameterType` |
     */
    RepairResult: RepairResultParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WarningMessage` |
     * | Type | `Edm.String` |
     */
    WarningMessage: string | null;
}

export interface RepairScrewingToolUsage {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RepairContext` |
     * | Type | `Siemens.OpcenterEX.DS.OperationalData.FB_OP_RuntimeQG.OPModel.Types.RepairActivityParameterType` |
     * | Nullable | `false` |
     */
    RepairContext: RepairActivityParameterType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ScrewingContext` |
     * | Type | `Siemens.OpcenterEX.DS.OperationalData.FB_OP_RuntimeQG.OPModel.Types.RepairScrewingToolActivityParameterType` |
     * | Nullable | `false` |
     */
    ScrewingContext: RepairScrewingToolActivityParameterType;
}

export interface GroupWoOpsTotallyInExecGroupByTypeResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupNIds` |
     * | Type | `Collection(Edm.String)` |
     */
    ExecutionGroupNIds: Array<string>;
}

export interface GroupWoOpsTotallyInExecGroupByType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrders` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.WorkOrderToBeGrouped)` |
     * | Nullable | `false` |
     */
    WorkOrders: Array<WorkOrderToBeGrouped>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EgToBeCreated` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.WoTypeAndEgNId)` |
     * | Nullable | `false` |
     */
    EgToBeCreated: Array<WoTypeAndEgNId>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EGFinalStatus` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    EGFinalStatus: string;
}

export interface SetToBeCollectedDocumentOnStepResponse extends CommandResponse {
}

export interface SetToBeCollectedDocumentOnStep {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StepId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    StepId: string;
}

export interface ItlkCheckStepAssociationParameterValueParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckParameterId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ItlkCheckParameterId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckParameterNId` |
     * | Type | `Edm.String` |
     */
    ItlkCheckParameterNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterValue` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ParameterValue: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DataType` |
     * | Type | `Siemens.SimaticIT.U4DM.MasterData.FB_MS_ITLK.MSModel.Types.ItlkCheckParameterDataTypeEnum` |
     */
    DataType: ItlkCheckParameterDataTypeEnum | null;
}

export interface ItlkCheckOperationToStepLinkAssociationParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ItlkCheckId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationToStepLinkId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OperationToStepLinkId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsInbound` |
     * | Type | `Edm.Boolean` |
     */
    IsInbound: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsOutbound` |
     * | Type | `Edm.Boolean` |
     */
    IsOutbound: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckOperationToStepLinkAssociationParameterValueList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_ITLK.MSModel.Types.ItlkCheckStepAssociationParameterValueParameterType)` |
     */
    ItlkCheckOperationToStepLinkAssociationParameterValueList: Array<ItlkCheckStepAssociationParameterValueParameterType>;
}

export interface ItlkCheckOpAssociationParameterValueParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckParameterId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ItlkCheckParameterId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckParameterNId` |
     * | Type | `Edm.String` |
     */
    ItlkCheckParameterNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterValue` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ParameterValue: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DataType` |
     * | Type | `Siemens.SimaticIT.U4DM.MasterData.FB_MS_ITLK.MSModel.Types.ItlkCheckParameterDataTypeEnum` |
     */
    DataType: ItlkCheckParameterDataTypeEnum | null;
}

export interface ItlkCheckOperationStepCategoryAssociationParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ItlkCheckId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationStepCategoryId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OperationStepCategoryId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsInbound` |
     * | Type | `Edm.Boolean` |
     */
    IsInbound: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsOutbound` |
     * | Type | `Edm.Boolean` |
     */
    IsOutbound: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StepRelevant` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    StepRelevant: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationRelevant` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    OperationRelevant: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckOperationStepCategoryAssociationParameterValueList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_ITLK.MSModel.Types.ItlkCheckOpAssociationParameterValueParameterType)` |
     */
    ItlkCheckOperationStepCategoryAssociationParameterValueList: Array<ItlkCheckOpAssociationParameterValueParameterType>;
}

export interface ItlkCheckOperationToStepLinkAssociationUpdateParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckOperationToStepLinkAssociationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ItlkCheckOperationToStepLinkAssociationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsInbound` |
     * | Type | `Edm.Boolean` |
     */
    IsInbound: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsOutbound` |
     * | Type | `Edm.Boolean` |
     */
    IsOutbound: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckOperationToStepAssociationParameterValueList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_ITLK.MSModel.Types.ItlkCheckStepAssociationParameterValueParameterType)` |
     */
    ItlkCheckOperationToStepAssociationParameterValueList: Array<ItlkCheckStepAssociationParameterValueParameterType>;
}

export interface ItlkCheckProcessToOpAssociationUpdateParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckProcessToOpAssociationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ItlkCheckProcessToOpAssociationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsInbound` |
     * | Type | `Edm.Boolean` |
     */
    IsInbound: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsOutbound` |
     * | Type | `Edm.Boolean` |
     */
    IsOutbound: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckProcessToOpAssociationParameterValueList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_ITLK.MSModel.Types.ItlkCheckOpAssociationParameterValueParameterType)` |
     */
    ItlkCheckProcessToOpAssociationParameterValueList: Array<ItlkCheckOpAssociationParameterValueParameterType>;
}

export interface CustomItlkCheckParamParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DataType` |
     * | Type | `Siemens.SimaticIT.U4DM.MasterData.FB_MS_ITLK.MSModel.Types.ItlkCheckParameterDataTypeEnum` |
     * | Nullable | `false` |
     */
    DataType: ItlkCheckParameterDataTypeEnum;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsMandatory` |
     * | Type | `Edm.Boolean` |
     */
    IsMandatory: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsList` |
     * | Type | `Edm.Boolean` |
     */
    IsList: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ItlkCheckId: string;
}

export interface CustomItlkCheckParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsInbound` |
     * | Type | `Edm.Boolean` |
     */
    IsInbound: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsOutbound` |
     * | Type | `Edm.Boolean` |
     */
    IsOutbound: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StepRelevant` |
     * | Type | `Edm.Boolean` |
     */
    StepRelevant: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationRelevant` |
     * | Type | `Edm.Boolean` |
     */
    OperationRelevant: boolean | null;
}

export interface ItlkCheckProcessToOpLinkAssociationParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ItlkCheckId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessToOperationLinkId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ProcessToOperationLinkId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsInbound` |
     * | Type | `Edm.Boolean` |
     */
    IsInbound: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsOutbound` |
     * | Type | `Edm.Boolean` |
     */
    IsOutbound: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckProcessToOpLinkAssociationParameterValueList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_ITLK.MSModel.Types.ItlkCheckOpAssociationParameterValueParameterType)` |
     */
    ItlkCheckProcessToOpLinkAssociationParameterValueList: Array<ItlkCheckOpAssociationParameterValueParameterType>;
}

export interface ItlkCheckOperationStepCategoryAssociationUpdateParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckOperationStepCategoryAssociationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ItlkCheckOperationStepCategoryAssociationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsInbound` |
     * | Type | `Edm.Boolean` |
     */
    IsInbound: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsOutbound` |
     * | Type | `Edm.Boolean` |
     */
    IsOutbound: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StepRelevant` |
     * | Type | `Edm.Boolean` |
     */
    StepRelevant: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationRelevant` |
     * | Type | `Edm.Boolean` |
     */
    OperationRelevant: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckOperationStepCategoryAssociationParameterValueList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_ITLK.MSModel.Types.ItlkCheckOpAssociationParameterValueParameterType)` |
     */
    ItlkCheckOperationStepCategoryAssociationParameterValueList: Array<ItlkCheckOpAssociationParameterValueParameterType>;
}

export interface InitializeCreatedTaskParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    TaskId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `User` |
     * | Type | `Edm.String` |
     */
    User: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChainId` |
     * | Type | `Edm.Guid` |
     */
    ChainId: string | null;
}

export interface DeleteWorkProcessDMMaterialTrackingUnitAssociationListParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNIdList` |
     * | Type | `Collection(Edm.String)` |
     */
    EquipmentNIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStepId: string | null;
}

export interface CompleteTaskAndWorkProcessListParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStepId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNIdList` |
     * | Type | `Collection(Edm.String)` |
     */
    EquipmentNIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MTUIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DM_MTUIdList: Array<string>;
}

export interface CreateAndStartWorkProcessListFromProcessDefinitionParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStepId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MTUIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DM_MTUIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupPhaseId` |
     * | Type | `Edm.Guid` |
     */
    ExecutionGroupPhaseId: string | null;
}

export interface OutputBufferActualQuantityType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ids` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Ids: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualQuantity` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    ActualQuantity: QuantityParameterType | null;
}

export interface BufferWithPriority {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BufferId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    BufferId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Priority` |
     * | Type | `Edm.Int32` |
     */
    Priority: number | null;
}

export interface ToUnlinkQtyParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MTUId` |
     * | Type | `Edm.Guid` |
     */
    DM_MTUId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    Quantity: QuantityParameterType | null;
}

export interface MaterialTrackingUnitIdQuantityParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialTrackingUnitId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    MaterialTrackingUnitId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     * | Nullable | `false` |
     */
    Quantity: number;
}

export interface WI_ESScenerioParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WIElement_NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WIElement_NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WIElement_Type` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WIElement_Type: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ScenarioNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ScenarioNId: string;
}

export interface WorkInstructionDefinitionParameterParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Direction` |
     * | Type | `Siemens.SimaticIT.MasterData.WI_MS.MSModel.Types.WorkInstructionDefinitionParameterDirection` |
     * | Nullable | `false` |
     */
    Direction: WorkInstructionDefinitionParameterDirection;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsReadOnly` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsReadOnly: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterType` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.SupportedTypes` |
     * | Nullable | `false` |
     */
    ParameterType: SupportedTypes;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterUoMNId` |
     * | Type | `Edm.String` |
     */
    ParameterUoMNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterValue` |
     * | Type | `Edm.String` |
     */
    ParameterValue: string | null;
}

export interface DM_MaterialParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    MaterialNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialUId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    MaterialUId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialRevision` |
     * | Type | `Edm.String` |
     */
    MaterialRevision: string | null;
}

export interface AMPowderPropertiesParameterType2 {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MinQuantity` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    MinQuantity: QuantityParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaxRecycleCount` |
     * | Type | `Edm.Int32` |
     */
    MaxRecycleCount: number | null;
}

export interface MaterialValueParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    MaterialNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialUId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    MaterialUId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialRevision` |
     * | Type | `Edm.String` |
     */
    MaterialRevision: string | null;
}

export interface ItlkCheckWOOpAssociationUpdateParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckWOOpAssociationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ItlkCheckWOOpAssociationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsInbound` |
     * | Type | `Edm.Boolean` |
     */
    IsInbound: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsOutbound` |
     * | Type | `Edm.Boolean` |
     */
    IsOutbound: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckWOOpAssociationParameterValueList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_ITLK.MSModel.Types.ItlkCheckOpAssociationParameterValueParameterType)` |
     */
    ItlkCheckWOOpAssociationParameterValueList: Array<ItlkCheckOpAssociationParameterValueParameterType>;
}

export interface ItlkCheckOrchestratorOutputParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckWOOpAssociationId` |
     * | Type | `Edm.Guid` |
     */
    ItlkCheckWOOpAssociationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckParameterList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_ITLK.MSModel.Types.ItlkCheckOpAssociationParameterValueParameterType)` |
     */
    ItlkCheckParameterList: Array<ItlkCheckOpAssociationParameterValueParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    EquipmentNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MTUId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    DM_MTUId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MTUCodeType` |
     * | Type | `Siemens.SimaticIT.OperationalData.MAT_OP.OPModel.Types.MTUCodeType` |
     * | Nullable | `false` |
     */
    MTUCodeType: MTUCodeType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MTUCode` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    MTUCode: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckResult` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    ItlkCheckResult: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckWOStepAssociationId` |
     * | Type | `Edm.Guid` |
     */
    ItlkCheckWOStepAssociationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckOpStepCategoryAssociationId` |
     * | Type | `Edm.Guid` |
     */
    ItlkCheckOpStepCategoryAssociationId: string | null;
}

export interface ItlkCheckOrchestratorInputParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckWOOpAssociationId` |
     * | Type | `Edm.Guid` |
     */
    ItlkCheckWOOpAssociationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ItlkCheckId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ItlkCheckNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsInbound` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsInbound: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsOutbound` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsOutbound: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckParameterList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_ITLK.MSModel.Types.ItlkCheckOpAssociationParameterValueParameterType)` |
     */
    ItlkCheckParameterList: Array<ItlkCheckOpAssociationParameterValueParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckWOStepAssociationId` |
     * | Type | `Edm.Guid` |
     */
    ItlkCheckWOStepAssociationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckOpStepCategoryAssociationId` |
     * | Type | `Edm.Guid` |
     */
    ItlkCheckOpStepCategoryAssociationId: string | null;
}

export interface ItlkCheckHistoryParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckWOOpAssociationId` |
     * | Type | `Edm.Guid` |
     */
    ItlkCheckWOOpAssociationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckWOStepAssociationId` |
     * | Type | `Edm.Guid` |
     */
    ItlkCheckWOStepAssociationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStepId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderStepNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MTUId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    DM_MTUId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MTUCodeType` |
     * | Type | `Siemens.SimaticIT.OperationalData.MAT_OP.OPModel.Types.MTUCodeType` |
     * | Nullable | `false` |
     */
    MTUCodeType: MTUCodeType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MTUCode` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    MTUCode: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckSessionId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ItlkCheckSessionId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckResult` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    ItlkCheckResult: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `User` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    User: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Date` |
     * | Type | `Edm.DateTimeOffset` |
     * | Nullable | `false` |
     */
    Date: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckHistoryParameterValueList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_ITLK.MSModel.Types.ItlkCheckOpAssociationParameterValueParameterType)` |
     */
    ItlkCheckHistoryParameterValueList: Array<ItlkCheckOpAssociationParameterValueParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationStepCategoryId` |
     * | Type | `Edm.Guid` |
     */
    OperationStepCategoryId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationStepCategoryNId` |
     * | Type | `Edm.String` |
     */
    OperationStepCategoryNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckOpStepCategoryAssociationId` |
     * | Type | `Edm.Guid` |
     */
    ItlkCheckOpStepCategoryAssociationId: string | null;
}

export interface ItlkCheckWOOpAssociationParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ItlkCheckId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsInbound` |
     * | Type | `Edm.Boolean` |
     */
    IsInbound: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsOutbound` |
     * | Type | `Edm.Boolean` |
     */
    IsOutbound: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckWOOpAssociationParameterValueList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_ITLK.MSModel.Types.ItlkCheckOpAssociationParameterValueParameterType)` |
     */
    ItlkCheckWOOpAssociationParameterValueList: Array<ItlkCheckOpAssociationParameterValueParameterType>;
}

export interface ItlkCheckWOStepAssociationParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ItlkCheckId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderStepId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsInbound` |
     * | Type | `Edm.Boolean` |
     */
    IsInbound: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsOutbound` |
     * | Type | `Edm.Boolean` |
     */
    IsOutbound: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckWOStepAssociationParameterValueList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_ITLK.MSModel.Types.ItlkCheckStepAssociationParameterValueParameterType)` |
     */
    ItlkCheckWOStepAssociationParameterValueList: Array<ItlkCheckStepAssociationParameterValueParameterType>;
}

export interface ItlkCheckWOStepAssociationUpdateParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckWOStepAssociationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ItlkCheckWOStepAssociationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsInbound` |
     * | Type | `Edm.Boolean` |
     */
    IsInbound: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsOutbound` |
     * | Type | `Edm.Boolean` |
     */
    IsOutbound: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckWOStepAssociationParameterValueList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.MasterData.FB_MS_ITLK.MSModel.Types.ItlkCheckStepAssociationParameterValueParameterType)` |
     */
    ItlkCheckWOStepAssociationParameterValueList: Array<ItlkCheckStepAssociationParameterValueParameterType>;
}

export interface CreateResultTypeParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResultValue` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ResultValue: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsKO` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsKO: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsDefault` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsDefault: boolean;
}

export interface OnResultCreationParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderStepNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialTrackingUnitNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    MaterialTrackingUnitNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResultId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ResultId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnitId` |
     * | Type | `Edm.Guid` |
     */
    DM_MaterialTrackingUnitId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResultValue` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ResultValue: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResultIsKo` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    ResultIsKo: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResultStrategyNId` |
     * | Type | `Edm.String` |
     */
    ResultStrategyNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResultHistoryId` |
     * | Type | `Edm.Guid` |
     */
    ResultHistoryId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActivityNId` |
     * | Type | `Edm.String` |
     */
    ActivityNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActivityType` |
     * | Type | `Edm.String` |
     */
    ActivityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsPartial` |
     * | Type | `Edm.Boolean` |
     */
    IsPartial: boolean | null;
}

export interface UpdateResultListParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResultId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ResultId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResultStrategyNId` |
     * | Type | `Edm.String` |
     */
    ResultStrategyNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResultValue` |
     * | Type | `Edm.String` |
     */
    ResultValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsPartial` |
     * | Type | `Edm.Boolean` |
     */
    IsPartial: boolean | null;
}

export interface UpdateResultTypeParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResultTypeId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ResultTypeId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsKo` |
     * | Type | `Edm.Boolean` |
     */
    IsKo: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsDefault` |
     * | Type | `Edm.Boolean` |
     */
    IsDefault: boolean | null;
}

export interface RevertResultsStrategyParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResultId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ResultId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StrategyNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    StrategyNId: string;
}

export interface ResultHistoryParamType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResultId` |
     * | Type | `Edm.Guid` |
     */
    ResultId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResultHistoryId` |
     * | Type | `Edm.Guid` |
     */
    ResultHistoryId: string | null;
}

export interface CreateResultHistoryListParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResultId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ResultId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserId` |
     * | Type | `Edm.String` |
     */
    UserId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Date` |
     * | Type | `Edm.DateTimeOffset` |
     */
    Date: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceNId` |
     * | Type | `Edm.String` |
     */
    NonConformanceNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActionNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ActionNId: string;
}

export interface CreateResultListParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderStepNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialTrackingUnitNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    MaterialTrackingUnitNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResultStrategyNId` |
     * | Type | `Edm.String` |
     */
    ResultStrategyNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResultValue` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ResultValue: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActivityNId` |
     * | Type | `Edm.String` |
     */
    ActivityNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActivityType` |
     * | Type | `Edm.String` |
     */
    ActivityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsPartial` |
     * | Type | `Edm.Boolean` |
     */
    IsPartial: boolean | null;
}

export interface AmendResultListParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResultId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ResultId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResultValue` |
     * | Type | `Edm.String` |
     */
    ResultValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResultStrategyNId` |
     * | Type | `Edm.String` |
     */
    ResultStrategyNId: string | null;
}

export interface ManageResultListParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Result` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.FB_OP_Result.OPModel.Types.CreateResultListParameterType` |
     */
    Result: CreateResultListParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOHistoryMaterialItemId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WOHistoryMaterialItemId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOperationId` |
     * | Type | `Edm.Guid` |
     */
    WOOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnitId` |
     * | Type | `Edm.Guid` |
     */
    DM_MaterialTrackingUnitId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProductionType` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.ProductionTypeEnum` |
     * | Nullable | `false` |
     */
    ProductionType: ProductionTypeEnum;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOOperationTargetQuantity` |
     * | Type | `Edm.Decimal` |
     * | Nullable | `false` |
     */
    WOOperationTargetQuantity: number;
}

export interface WIResult {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkInstructionId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsKo` |
     * | Type | `Edm.Boolean` |
     */
    IsKo: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsRepeat` |
     * | Type | `Edm.Boolean` |
     */
    IsRepeat: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CanBeRepeated` |
     * | Type | `Edm.Boolean` |
     */
    CanBeRepeated: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface ManageNullResultParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnitWithResultList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.CompletedMTUParameterType)` |
     */
    DM_MaterialTrackingUnitWithResultList: Array<CompletedMTUParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutomaticEquipmentNId` |
     * | Type | `Edm.String` |
     */
    AutomaticEquipmentNId: string | null;
}

export interface DMMTUWithResultParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MTUId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    DM_MTUId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsKo` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsKo: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StrategyNId` |
     * | Type | `Edm.String` |
     */
    StrategyNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResultId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ResultId: string;
}

export interface Activity {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActivityNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ActivityNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SpecificationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    SpecificationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefaultResultValue` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    DefaultResultValue: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefaultResultStrategy` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    DefaultResultStrategy: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SpecificationType` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    SpecificationType: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
}

export interface OfflineActionType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Name: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CommandName` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    CommandName: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CommandApp` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    CommandApp: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CommandPayload` |
     * | Type | `Edm.Binary` |
     * | Nullable | `false` |
     */
    CommandPayload: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    UserId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Date` |
     * | Type | `Edm.DateTimeOffset` |
     * | Nullable | `false` |
     */
    Date: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `InternalId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    InternalId: string;
}

export interface OfflineWIStepItem {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SectionNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    SectionNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StepNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    StepNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CompletedBy` |
     * | Type | `Edm.String` |
     */
    CompletedBy: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItemValue` |
     * | Type | `Edm.String` |
     */
    ItemValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsCompleted` |
     * | Type | `Edm.Boolean` |
     */
    IsCompleted: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastValueUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastValueUpdatedOn: string | null;
}

export interface OfflineWorkInstruction {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionDefinitionNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkInstructionDefinitionNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StepItems` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.FB_OP_Offline.OPModel.Types.OfflineWIStepItem)` |
     */
    StepItems: Array<OfflineWIStepItem>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStepId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnitId` |
     * | Type | `Edm.Guid` |
     */
    DM_MaterialTrackingUnitId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionDefinitionRevision` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkInstructionDefinitionRevision: string;
}

export interface ResolvedToBeUsedMachinesOnWOOpParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNIdList` |
     * | Type | `Collection(Edm.String)` |
     */
    EquipmentNIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkOrderOperationNId: string;
}

export interface OfflineStepItem {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SectionNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    SectionNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StepNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    StepNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StepSequence` |
     * | Type | `Edm.Int32` |
     * | Nullable | `false` |
     */
    StepSequence: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsRequired` |
     * | Type | `Edm.Boolean` |
     */
    IsRequired: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Caption` |
     * | Type | `Edm.String` |
     */
    Caption: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Title` |
     * | Type | `Edm.String` |
     */
    Title: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DataType` |
     * | Type | `Edm.String` |
     */
    DataType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Instructions` |
     * | Type | `Edm.String` |
     */
    Instructions: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Format` |
     * | Type | `Edm.String` |
     */
    Format: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefaultValue` |
     * | Type | `Edm.String` |
     */
    DefaultValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Label` |
     * | Type | `Edm.String` |
     */
    Label: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoM` |
     * | Type | `Edm.String` |
     */
    UoM: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StepType` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    StepType: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsReadOnly` |
     * | Type | `Edm.Boolean` |
     */
    IsReadOnly: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LowLimit` |
     * | Type | `Edm.String` |
     */
    LowLimit: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `HighLimit` |
     * | Type | `Edm.String` |
     */
    HighLimit: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Target` |
     * | Type | `Edm.String` |
     */
    Target: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SectionSequence` |
     * | Type | `Edm.Int32` |
     * | Nullable | `false` |
     */
    SectionSequence: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Length` |
     * | Type | `Edm.Int32` |
     */
    Length: number | null;
}

export interface OfflineWorkInstructionDefinition {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Revision: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StepItems` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.FB_OP_Offline.OPModel.Types.OfflineStepItem)` |
     */
    StepItems: Array<OfflineStepItem>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface OfflineWorkInstructionDefinitionAssociation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AssociationType` |
     * | Type | `Edm.String` |
     */
    AssociationType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStepId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionDefinition` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.FB_OP_Offline.OPModel.Types.OfflineWorkInstructionDefinition` |
     */
    WorkInstructionDefinition: OfflineWorkInstructionDefinition | null;
}

export interface WIStepItemValueOfflineHistory {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Value` |
     * | Type | `Edm.String` |
     */
    Value: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OfflineDate` |
     * | Type | `Edm.DateTimeOffset` |
     */
    OfflineDate: string | null;
}

export interface OfflineDataCollection {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStepId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnitId` |
     * | Type | `Edm.Guid` |
     */
    DM_MaterialTrackingUnitId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WIDefinitionNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WIDefinitionNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WIDefinitionRevision` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WIDefinitionRevision: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WISectionNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WISectionNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WIStepNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WIStepNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WIStepItemNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WIStepItemNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsWIStepConfirmed` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsWIStepConfirmed: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WIStepItemValueList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.FB_OP_Offline.OPModel.Types.WIStepItemValueOfflineHistory)` |
     */
    WIStepItemValueList: Array<WIStepItemValueOfflineHistory>;
}

export interface OfflineDataCollectionOutput {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionStepId` |
     * | Type | `Edm.Guid` |
     */
    WorkInstructionStepId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionStepItemId` |
     * | Type | `Edm.Guid` |
     */
    WorkInstructionStepItemId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsDataCollectionCheckedIn` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsDataCollectionCheckedIn: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionId` |
     * | Type | `Edm.Guid` |
     */
    WorkInstructionId: string | null;
}

export interface OfflineDataCollectionCheckedIn {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OfflineDataCollection` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.FB_OP_Offline.OPModel.Types.OfflineDataCollection` |
     */
    OfflineDataCollection: OfflineDataCollection | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OnlineDataCollection` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.FB_OP_Offline.OPModel.Types.OfflineDataCollectionOutput` |
     */
    OnlineDataCollection: OfflineDataCollectionOutput | null;
}

export interface MTuWithQty {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MTuNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    MTuNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     * | Nullable | `false` |
     */
    Quantity: number;
}

export interface IdTemplateBlockInfoParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExtendedYear` |
     * | Type | `Edm.Boolean` |
     */
    ExtendedYear: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NextValue` |
     * | Type | `Edm.Int32` |
     */
    NextValue: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NumDigits` |
     * | Type | `Edm.Int32` |
     */
    NumDigits: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Separator` |
     * | Type | `Edm.String` |
     */
    Separator: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ZeroPadding` |
     * | Type | `Edm.Boolean` |
     */
    ZeroPadding: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     * | Nullable | `false` |
     */
    Sequence: number;
}

export interface SerialNumberCodesParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Values` |
     * | Type | `Collection(Edm.String)` |
     */
    Values: Array<string>;
}

export interface QualificationCriteriaParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Rule` |
     * | Type | `Edm.String` |
     */
    Rule: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface PropertyParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PropertyType` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.SupportedTypes` |
     * | Nullable | `false` |
     */
    PropertyType: SupportedTypes;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PropertyValue` |
     * | Type | `Edm.String` |
     */
    PropertyValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Operational` |
     * | Type | `Edm.Boolean` |
     */
    Operational: boolean | null;
}

export interface PropertyWithAttributesParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PropertyType` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.SupportedTypes` |
     * | Nullable | `false` |
     */
    PropertyType: SupportedTypes;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PropertyValue` |
     * | Type | `Edm.String` |
     */
    PropertyValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Attributes` |
     * | Type | `Collection(Siemens.SimaticIT.MasterData.EQU_MS.MSModel.Types.PropertyParameterType)` |
     */
    Attributes: Array<PropertyParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Operational` |
     * | Type | `Edm.Boolean` |
     */
    Operational: boolean | null;
}

export interface MaterialParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     */
    Revision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaxQuantity` |
     * | Type | `Edm.Decimal` |
     */
    MaxQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UId` |
     * | Type | `Edm.String` |
     */
    UId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoMNId` |
     * | Type | `Edm.String` |
     */
    UoMNId: string | null;
}

export interface PJFIsSourceParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsSource` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsSource: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFileId` |
     * | Type | `Edm.Guid` |
     */
    PrintJobFileId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFileSource` |
     * | Type | `Edm.String` |
     */
    PrintJobFileSource: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFileName` |
     * | Type | `Edm.String` |
     */
    PrintJobFileName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFileExternalId` |
     * | Type | `Edm.String` |
     */
    PrintJobFileExternalId: string | null;
}

export interface EquipSpecWithPjf {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PjfExternalId` |
     * | Type | `Edm.String` |
     */
    PjfExternalId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PjfFileName` |
     * | Type | `Edm.String` |
     */
    PjfFileName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PjfSource` |
     * | Type | `Edm.String` |
     */
    PjfSource: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EqSpecParentOpId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    EqSpecParentOpId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipNId` |
     * | Type | `Edm.String` |
     */
    EquipNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipTypeNId` |
     * | Type | `Edm.String` |
     */
    EquipTypeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PjfId` |
     * | Type | `Edm.Guid` |
     */
    PjfId: string | null;
}

export interface ToolToBeAcquireParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UsageDuration` |
     * | Type | `Edm.Duration` |
     */
    UsageDuration: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolDefinitionId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToolDefinitionId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolNId` |
     * | Type | `Edm.String` |
     */
    ToolNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TimesToBeUsed` |
     * | Type | `Edm.Decimal` |
     */
    TimesToBeUsed: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedMaterialItemId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ProducedMaterialItemId: string;
}

export interface MaterialTrackingUnitParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialId` |
     * | Type | `Edm.Guid` |
     */
    MaterialId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Code` |
     * | Type | `Edm.String` |
     */
    Code: string | null;
}

export interface ToBeAcquireMaterialTrackingUnitParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualQuantity` |
     * | Type | `Edm.Decimal` |
     * | Nullable | `false` |
     */
    ActualQuantity: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    MaterialId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Code` |
     * | Type | `Edm.String` |
     */
    Code: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeConsumedMaterialName` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ToBeConsumedMaterialName: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeConsumedMaterialSequence` |
     * | Type | `Edm.Int32` |
     * | Nullable | `false` |
     */
    ToBeConsumedMaterialSequence: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TotalQuantity` |
     * | Type | `Edm.Decimal` |
     * | Nullable | `false` |
     */
    TotalQuantity: number;
}

export interface MaterialTrackingUnitToAcquireParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetMaterialTrackingUnit` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.FB_OP_AGWInt.OPModel.Types.MaterialTrackingUnitParameterType` |
     */
    TargetMaterialTrackingUnit: MaterialTrackingUnitParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeAcquireMaterialTrackingUnitList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.FB_OP_AGWInt.OPModel.Types.ToBeAcquireMaterialTrackingUnitParameterType)` |
     */
    ToBeAcquireMaterialTrackingUnitList: Array<ToBeAcquireMaterialTrackingUnitParameterType>;
}

export interface CharacteristicFailureAssociation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
}

export interface ATNInstanceParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    EquipmentNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ATNInstanceParameterNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ATNInstanceParameterNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ATNInstanceNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ATNInstanceNId: string;
}

export interface SetPointItemParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointItemNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    SetPointItemNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Editable` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    Editable: boolean;
}

export interface DeleteCertificationParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
}

export interface CertificationAssociationParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
}

export interface CertificationHistoryParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Date` |
     * | Type | `Edm.DateTimeOffset` |
     * | Nullable | `false` |
     */
    Date: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReferenceRoleId` |
     * | Type | `Edm.String` |
     */
    ReferenceRoleId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReferenceUserId` |
     * | Type | `Edm.String` |
     */
    ReferenceUserId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    UserId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialId` |
     * | Type | `Edm.Guid` |
     */
    MaterialId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SkillId` |
     * | Type | `Edm.Guid` |
     */
    SkillId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeNId` |
     * | Type | `Edm.String` |
     */
    EquipmentTypeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialNId` |
     * | Type | `Edm.String` |
     */
    MaterialNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SkillNId` |
     * | Type | `Edm.String` |
     */
    SkillNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CertificationNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    CertificationNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActionNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ActionNId: string;
}

export interface WorkInstructionParameters {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsReadOnly` |
     * | Type | `Edm.Boolean` |
     */
    IsReadOnly: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Direction` |
     * | Type | `Siemens.SimaticIT.MasterData.WI_MS.MSModel.Types.WorkInstructionDefinitionParameterDirection` |
     */
    Direction: WorkInstructionDefinitionParameterDirection | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterType` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.SupportedTypes` |
     */
    ParameterType: SupportedTypes | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterValue` |
     * | Type | `Edm.String` |
     */
    ParameterValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterUoMNId` |
     * | Type | `Edm.String` |
     */
    ParameterUoMNId: string | null;
}

export interface StepItemValueType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItemId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ItemId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItemValue` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ItemValue: string;
}

export interface IdsParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Values` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    Values: Array<string>;
}

export interface IdsParameter {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Values` |
     * | Type | `Collection(Edm.String)` |
     */
    Values: Array<string>;
}

export interface KeyMultiValueParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Key` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Key: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Val` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Val: string;
}

export interface ToolAGW_DisassociateAutomationNodeInstancesFromEquipmentConfigurationResponse extends CommandResponse {
}

export interface ToolAGW_DisassociateAutomationNodeInstancesFromEquipmentConfiguration {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    EquipmentConfigurationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutomationNodeInstanceNIds` |
     * | Type | `Collection(Edm.String)` |
     */
    AutomationNodeInstanceNIds: Array<string>;
}

export interface ToolAGW_AssociateAutomationNodeInstancesWithEquipmentConfigurationResponse extends CommandResponse {
}

export interface ToolAGW_AssociateAutomationNodeInstancesWithEquipmentConfiguration {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigurationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    EquipmentConfigurationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutomationNodeInstanceNIds` |
     * | Type | `Collection(Edm.String)` |
     */
    AutomationNodeInstanceNIds: Array<string>;
}

export interface APPMain_GF_ImportLOIPROResponse extends CommandResponse {
}

export interface APPMain_GF_ImportLOIPRO {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RawIdocXml` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    RawIdocXml: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CNMOMMessageId` |
     * | Type | `Edm.Int64` |
     */
    CNMOMMessageId: number | null;
}

export interface APPMain_GF_ImportMATMASResponse extends CommandResponse {
}

export interface APPMain_GF_ImportMATMAS {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RawIdocXml` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    RawIdocXml: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CNMOMMessageId` |
     * | Type | `Edm.Int64` |
     */
    CNMOMMessageId: number | null;
}

export interface APPMain_GF_KeepWorkerAlive_1Response extends CommandResponse {
}

export interface APPMain_GF_KeepWorkerAlive_1 {
}

export interface APPMain_GF_KeepWorkerAlive_2Response extends CommandResponse {
}

export interface APPMain_GF_KeepWorkerAlive_2 {
}

export interface APPMain_GF_KeepWorkerAlive_3Response extends CommandResponse {
}

export interface APPMain_GF_KeepWorkerAlive_3 {
}

export interface APPMain_GF_KeepWorkerAlive_4Response extends CommandResponse {
}

export interface APPMain_GF_KeepWorkerAlive_4 {
}

export interface APPMain_GF_KeepWorkerAlive_5Response extends CommandResponse {
}

export interface APPMain_GF_KeepWorkerAlive_5 {
}

export interface APPMain_GF_CreateKeepAliveWorkerTimerResponse extends CommandResponse {
}

export interface APPMain_GF_CreateKeepAliveWorkerTimer {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EndTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EndTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CheckTimeMinutes` |
     * | Type | `Edm.Int32` |
     * | Nullable | `false` |
     */
    CheckTimeMinutes: number;
}

export interface APPMain_GF_HandleScanFromShopfloorResponse extends CommandResponse {
}

export interface APPMain_GF_HandleScanFromShopfloor {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RawXml` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    RawXml: string;
}

export interface APPMain_GF_ImportMATMAS_CNMOMResponse extends CommandResponse {
}

export interface APPMain_GF_ImportMATMAS_CNMOM {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RawIdocXml` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    RawIdocXml: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CNMOMMessageIdFlag0` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    CNMOMMessageIdFlag0: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CNMOMMessageId` |
     * | Type | `Edm.Int64` |
     * | Nullable | `false` |
     */
    CNMOMMessageId: number;
}

export interface APPMain_GF_ImportLOIPRO_CNMOMResponse extends CommandResponse {
}

export interface APPMain_GF_ImportLOIPRO_CNMOM {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RawIdocXml` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    RawIdocXml: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CNMOMMessageIdFlag0` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    CNMOMMessageIdFlag0: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CNMOMMessageId` |
     * | Type | `Edm.Int64` |
     * | Nullable | `false` |
     */
    CNMOMMessageId: number;
}

export interface APPMain_GF_ClassificationDataImportResponse extends CommandResponse {
}

export interface APPMain_GF_ClassificationDataImport {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RawCharacteristicsJSON` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    RawCharacteristicsJSON: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderIdFlag0` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    WorkOrderIdFlag0: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderId: string;
}

export interface APPMain_GF_ClassificationDataRequestResponse extends CommandResponse {
}

export interface APPMain_GF_ClassificationDataRequest {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    WorkOrderIds: Array<string>;
}

export interface APPMain_GF_DownloadAndAddDocumentsResponse extends CommandResponse {
}

export interface APPMain_GF_DownloadAndAddDocuments {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SAPDocumentJSON` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    SAPDocumentJSON: string;
}

export interface APPMain_GF_HandleWorkOrderIdScanFromShopfloorResponse extends CommandResponse {
}

export interface APPMain_GF_HandleWorkOrderIdScanFromShopfloor {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RawXml` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    RawXml: string;
}

export interface APPMain_GF_ActivateAndStartTaskResponse extends CommandResponse {
}

export interface APPMain_GF_ActivateAndStartTask {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    TaskId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserName` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    UserName: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChainId` |
     * | Type | `Edm.Guid` |
     */
    ChainId: string | null;
}

export interface APPMain_GF_InsertLineRoutingEntryResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UId` |
     * | Type | `Edm.Guid` |
     */
    UId: string | null;
}

export interface APPMain_GF_InsertLineRoutingEntry {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNIdFlag0` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    EquipmentNIdFlag0: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    EquipmentNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FEVOR` |
     * | Type | `Edm.String` |
     */
    FEVOR: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DISPO` |
     * | Type | `Edm.String` |
     */
    DISPO: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WERKS` |
     * | Type | `Edm.String` |
     */
    WERKS: string | null;
}

export interface APPMain_GF_InsertScanDiagnosticResponse extends CommandResponse {
}

export interface APPMain_GF_InsertScanDiagnostic {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkCenter` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkCenter: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SerialNumber` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    SerialNumber: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Type` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Type: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Timestamp` |
     * | Type | `Edm.DateTimeOffset` |
     * | Nullable | `false` |
     */
    Timestamp: string;
}

export interface APPMain_GF_CreateMaterialResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NewGUID` |
     * | Type | `Edm.Guid` |
     */
    NewGUID: string | null;
}

export interface APPMain_GF_CreateMaterial {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Plant` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Plant: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsSerializedFlag0` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsSerializedFlag0: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsSerialized` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsSerialized: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsPhantomFlag0` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsPhantomFlag0: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsPhantom` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsPhantom: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoM` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    UoM: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BasicDataText` |
     * | Type | `Edm.String` |
     */
    BasicDataText: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialMemo` |
     * | Type | `Edm.String` |
     */
    MaterialMemo: string | null;
}

export interface APPMain_GF_OnEngraverHandshakeSentResponse extends CommandResponse {
}

export interface APPMain_GF_OnEngraverHandshakeSent {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NodeInstance` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NodeInstance: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProductId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ProductId: string;
}

export interface APPMain_GF_DeleteProductWaitingForValidationResponse extends CommandResponse {
}

export interface APPMain_GF_DeleteProductWaitingForValidation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProductId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ProductId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkcenterNId` |
     * | Type | `Edm.String` |
     */
    WorkcenterNId: string | null;
}

export interface APPMain_GF_ManageWetTestResultResponse extends CommandResponse {
}

export interface APPMain_GF_ManageWetTestResult {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NodeInstance` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NodeInstance: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProductId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ProductId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Result` |
     * | Type | `Edm.Int16` |
     * | Nullable | `false` |
     */
    Result: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CommandFlag` |
     * | Type | `Edm.Int16` |
     */
    CommandFlag: number | null;
}

export interface APPMain_GF_CreateWorkOrderFromLOIPROResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderNId: string | null;
}

export interface APPMain_GF_CreateWorkOrderFromLOIPRO {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RawIdocXml` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    RawIdocXml: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationBoMItems` |
     * | Type | `Collection(Grundfos.Opcenter.OperationalData.FBERPOP.OPModel.Types.GF_OperationBoMItemParameterType)` |
     */
    OperationBoMItems: Array<GF_OperationBoMItemParameterType>;
}

export interface APPMain_GF_UpdateLineRoutingEntryResponse extends CommandResponse {
}

export interface APPMain_GF_UpdateLineRoutingEntry {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNIdFlag0` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    EquipmentNIdFlag0: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    EquipmentNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FEVOR` |
     * | Type | `Edm.String` |
     */
    FEVOR: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DISPO` |
     * | Type | `Edm.String` |
     */
    DISPO: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WERKS` |
     * | Type | `Edm.String` |
     */
    WERKS: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UIdFlag0` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    UIdFlag0: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    UId: string;
}

export interface APPMain_GF_DeleteRunningScanResponse extends CommandResponse {
}

export interface APPMain_GF_DeleteRunningScan {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RawXml` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    RawXml: string;
}

export interface APPMain_GF_ManageScanFromShopfloorResponse extends CommandResponse {
}

export interface APPMain_GF_ManageScanFromShopfloor {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RawXml` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    RawXml: string;
}

export interface APPMain_GF_UpsertOperationExtensionsResponse extends CommandResponse {
}

export interface APPMain_GF_UpsertOperationExtensions {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Mandatory` |
     * | Type | `Edm.Boolean` |
     */
    Mandatory: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `InclusionRule` |
     * | Type | `Edm.String` |
     */
    InclusionRule: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationGuidFlag0` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    OperationGuidFlag0: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationGuid` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OperationGuid: string;
}

export interface APPMain_GF_SendMessageToHALPResponse extends CommandResponse {
}

export interface APPMain_GF_SendMessageToHALP {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkcenterNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkcenterNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProductId` |
     * | Type | `Edm.String` |
     */
    ProductId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Message` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Message: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Level` |
     * | Type | `Grundfos.Opcenter.OperationalData.FBRuntimeOP.OPModel.Types.GF_MessageToHALPLevels` |
     * | Nullable | `false` |
     */
    Level: GF_MessageToHALPLevels;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Param1` |
     * | Type | `Edm.String` |
     */
    Param1: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Param2` |
     * | Type | `Edm.String` |
     */
    Param2: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Param3` |
     * | Type | `Edm.String` |
     */
    Param3: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Param4` |
     * | Type | `Edm.String` |
     */
    Param4: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Param5` |
     * | Type | `Edm.String` |
     */
    Param5: string | null;
}

export interface APPMain_GF_DeleteLineRoutingEntryResponse extends CommandResponse {
}

export interface APPMain_GF_DeleteLineRoutingEntry {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UIdFlag0` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    UIdFlag0: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    UId: string;
}

export interface APPMain_GF_CreateUoMResponse extends CommandResponse {
}

export interface APPMain_GF_CreateUoM {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoMNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    UoMNId: string;
}

export interface APPMain_GF_OnPackagingHandshakeSentResponse extends CommandResponse {
}

export interface APPMain_GF_OnPackagingHandshakeSent {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NodeInstance` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NodeInstance: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProductId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ProductId: string;
}

export interface APPMain_GF_UpdateProductWaitingForValidationResponse extends CommandResponse {
}

export interface APPMain_GF_UpdateProductWaitingForValidation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProductId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ProductId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkcenterNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkcenterNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ValidatedProductId` |
     * | Type | `Edm.String` |
     */
    ValidatedProductId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ValidationOK` |
     * | Type | `Edm.Boolean` |
     */
    ValidationOK: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Handshaken` |
     * | Type | `Edm.Boolean` |
     */
    Handshaken: boolean | null;
}

export interface APPMain_GF_StartRequestDocumentsResponse extends CommandResponse {
}

export interface APPMain_GF_StartRequestDocuments {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RawIdocXml` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    RawIdocXml: string;
}

export interface APPMain_GF_InsertProductWaitingForValidationResponse extends CommandResponse {
}

export interface APPMain_GF_InsertProductWaitingForValidation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProductId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ProductId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkcenterNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkcenterNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskId` |
     * | Type | `Edm.Guid` |
     */
    TaskId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ValidationOK` |
     * | Type | `Edm.Boolean` |
     */
    ValidationOK: boolean | null;
}

export interface APPMain_GF_SendEngraverPrinterDataResponse extends CommandResponse {
}

export interface APPMain_GF_SendEngraverPrinterData {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProductId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ProductId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkCenter` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkCenter: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskId` |
     * | Type | `Edm.Guid` |
     */
    TaskId: string | null;
}

export interface APPMain_GF_CloseOperationSignalHandlerResponse extends CommandResponse {
}

export interface APPMain_GF_CloseOperationSignalHandler {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NodeInstance` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NodeInstance: string;
}

export interface APPMain_GF_UpdateMaterialResponse extends CommandResponse {
}

export interface APPMain_GF_UpdateMaterial {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Plant` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Plant: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BasicDataText` |
     * | Type | `Edm.String` |
     */
    BasicDataText: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsSerialized` |
     * | Type | `Edm.Boolean` |
     */
    IsSerialized: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialMemo` |
     * | Type | `Edm.String` |
     */
    MaterialMemo: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoM` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    UoM: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsPhantomFlag0` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsPhantomFlag0: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsPhantom` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsPhantom: boolean;
}

export interface APPMain_GF_GetUoMResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoMValue` |
     * | Type | `Edm.String` |
     */
    UoMValue: string | null;
}

export interface APPMain_GF_GetUoM {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoMNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    UoMNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreateIfNotExisting` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    CreateIfNotExisting: boolean;
}

export interface APPMain_GF_CreateBoMResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BoMId` |
     * | Type | `Edm.Guid` |
     */
    BoMId: string | null;
}

export interface APPMain_GF_CreateBoM {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Plant` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Plant: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    MaterialNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     * | Nullable | `false` |
     */
    Quantity: QuantityParameterType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BoMItems` |
     * | Type | `Collection(Grundfos.Opcenter.MasterData.FBCommonMS.MSModel.Types.GF_BoMItemParameterType)` |
     * | Nullable | `false` |
     */
    BoMItems: Array<GF_BoMItemParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkOrderNId: string;
}

export interface APPMain_GF_InsertRunningScanResponse extends CommandResponse {
}

export interface APPMain_GF_InsertRunningScan {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RawXml` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    RawXml: string;
}

export interface APPMain_GF_AllowKWAChecksExecutionResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionAllowed` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    ExecutionAllowed: boolean;
}

export interface APPMain_GF_AllowKWAChecksExecution {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CommandName` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    CommandName: string;
}

export interface APPMain_GF_SendPackagingPrinterDataResponse extends CommandResponse {
}

export interface APPMain_GF_SendPackagingPrinterData {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProductId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ProductId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkCenter` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkCenter: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskId` |
     * | Type | `Edm.Guid` |
     */
    TaskId: string | null;
}

export interface APPMain_DeleteMaterialResponse extends CommandResponse {
}

export interface APPMain_DeleteMaterial {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface APPMain_GF_OnAssistedPickingCompleteWorkOrderOperationSerializedResponse extends CommandResponse {
}

export interface APPMain_GF_OnAssistedPickingCompleteWorkOrderOperationSerialized {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    EquipmentNId: string;
}

export interface APPMain_GF_CompleteEquipmentPLCTaskResponse extends CommandResponse {
}

export interface APPMain_GF_CompleteEquipmentPLCTask {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NodeInstance` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NodeInstance: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProductId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ProductId: string;
}

export interface APPMain_GF_OnAssistedPickingStoppedResponse extends CommandResponse {
}

export interface APPMain_GF_OnAssistedPickingStopped {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentName` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    EquipmentName: string;
}

export interface APPMain_GF_OnAssistedPickingStartWorkOrderOperationSerializedResponse extends CommandResponse {
}

export interface APPMain_GF_OnAssistedPickingStartWorkOrderOperationSerialized {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    EquipmentNId: string;
}

export interface APPMain_GF_DeleteReworkProcessAssignmentEntryResponse extends CommandResponse {
}

export interface APPMain_GF_DeleteReworkProcessAssignmentEntry {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    UId: string;
}

export interface APPMain_GF_OnEPLCStartWorkOrderOperationSerializedResponse extends CommandResponse {
}

export interface APPMain_GF_OnEPLCStartWorkOrderOperationSerialized {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    EquipmentNId: string;
}

export interface APPMain_GF_InsertReworkProcessAssignmentEntryResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UId` |
     * | Type | `Edm.Guid` |
     */
    UId: string | null;
}

export interface APPMain_GF_InsertReworkProcessAssignmentEntry {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FailureId` |
     * | Type | `Grundfos.Opcenter.MasterData.FBERPMS.MSModel.Types.GF_FailureIdType` |
     * | Nullable | `false` |
     */
    FailureId: GF_FailureIdType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigId` |
     * | Type | `Grundfos.Opcenter.MasterData.FBERPMS.MSModel.Types.GF_EquipmentConfigIdType` |
     * | Nullable | `false` |
     */
    EquipmentConfigId: GF_EquipmentConfigIdType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessId` |
     * | Type | `Grundfos.Opcenter.MasterData.FBERPMS.MSModel.Types.GF_ProcessIdType` |
     * | Nullable | `false` |
     */
    ProcessId: GF_ProcessIdType;
}

export interface APPMain_GF_SendMESDataToEquipmentPLCResponse extends CommandResponse {
}

export interface APPMain_GF_SendMESDataToEquipmentPLC {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NodeInstance` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NodeInstance: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProductId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ProductId: string;
}

export interface APPMain_GF_UpdateReworkProcessAssignmentEntryResponse extends CommandResponse {
}

export interface APPMain_GF_UpdateReworkProcessAssignmentEntry {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FailureId` |
     * | Type | `Grundfos.Opcenter.MasterData.FBERPMS.MSModel.Types.GF_FailureIdType` |
     * | Nullable | `false` |
     */
    FailureId: GF_FailureIdType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentConfigId` |
     * | Type | `Grundfos.Opcenter.MasterData.FBERPMS.MSModel.Types.GF_EquipmentConfigIdType` |
     * | Nullable | `false` |
     */
    EquipmentConfigId: GF_EquipmentConfigIdType;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    UId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessId` |
     * | Type | `Grundfos.Opcenter.MasterData.FBERPMS.MSModel.Types.GF_ProcessIdType` |
     * | Nullable | `false` |
     */
    ProcessId: GF_ProcessIdType;
}

export interface APPMain_GF_OnEPLCCompleteWorkOrderOperationSerializedResponse extends CommandResponse {
}

export interface APPMain_GF_OnEPLCCompleteWorkOrderOperationSerialized {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    EquipmentNId: string;
}

export interface APPMain_GF_ResetTagResponse extends CommandResponse {
}

export interface APPMain_GF_ResetTag {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NodeInstance` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NodeInstance: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TagName` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    TagName: string;
}

export interface APPMain_GF_StartEquipmentPLCOperationResponse extends CommandResponse {
}

export interface APPMain_GF_StartEquipmentPLCOperation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NodeInstance` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NodeInstance: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProductId` |
     * | Type | `Edm.String` |
     */
    ProductId: string | null;
}

export interface APPMain_GF_CompleteEquipmentPLCOperationResponse extends CommandResponse {
}

export interface APPMain_GF_CompleteEquipmentPLCOperation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NodeInstance` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NodeInstance: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProductId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ProductId: string;
}

export interface APPMain_GF_OnCarrierArrivedResponse extends CommandResponse {
}

export interface APPMain_GF_OnCarrierArrived {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NodeInstance` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NodeInstance: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceCarrierId` |
     * | Type | `Edm.Int32` |
     */
    SourceCarrierId: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DestinationCarrierId` |
     * | Type | `Edm.Int32` |
     */
    DestinationCarrierId: number | null;
}

export interface APPMain_GF_StartLineControllerOperationResponse extends CommandResponse {
}

export interface APPMain_GF_StartLineControllerOperation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NodeInstance` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NodeInstance: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SourceCarrierId` |
     * | Type | `Edm.Int32` |
     */
    SourceCarrierId: number | null;
}

export interface APPMain_GF_OnChangeNonConformanceEntityResponse extends CommandResponse {
}

export interface APPMain_GF_OnChangeNonConformanceEntity {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NonConformanceNId: string;
}

export interface APPMain_GF_OnLineControllerCompleteWorkOrderOperationSerializedResponse extends CommandResponse {
}

export interface APPMain_GF_OnLineControllerCompleteWorkOrderOperationSerialized {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    EquipmentNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SerialNumberCodeList` |
     * | Type | `Collection(Edm.String)` |
     */
    SerialNumberCodeList: Array<string>;
}

export interface APPMain_GF_CompleteLineControllerOperationResponse extends CommandResponse {
}

export interface APPMain_GF_CompleteLineControllerOperation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NodeInstance` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NodeInstance: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CompleteStrategy` |
     * | Type | `Edm.Int32` |
     * | Nullable | `false` |
     */
    CompleteStrategy: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsParking` |
     * | Type | `Edm.Int32` |
     * | Nullable | `false` |
     */
    IsParking: number;
}

export interface APPMain_GF_ResetAutomationNodeTagsResponse extends CommandResponse {
}

export interface APPMain_GF_ResetAutomationNodeTags {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NodeInstance` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NodeInstance: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TagNames` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    TagNames: string;
}

export interface APPMain_GF_SendCarrierToStationResponse extends CommandResponse {
}

export interface APPMain_GF_SendCarrierToStation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NodeInstance` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NodeInstance: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogicalAction` |
     * | Type | `Edm.Int32` |
     * | Nullable | `false` |
     */
    LogicalAction: number;
}

export interface APPMain_GF_CreateGFFileResponse extends CommandResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FileId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    FileId: string;
}

export interface APPMain_GF_CreateGFFile {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FileType` |
     * | Type | `Edm.String` |
     */
    FileType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FileContent` |
     * | Type | `Edm.Binary` |
     * | Nullable | `false` |
     */
    FileContent: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FileName` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    FileName: string;
}

export interface APPMain_GF_ManageMarkingResponse extends CommandResponse {
}

export interface APPMain_GF_ManageMarking {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NodeInstance` |
     * | Type | `Edm.String` |
     */
    NodeInstance: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskId` |
     * | Type | `Edm.Guid` |
     */
    TaskId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PLCHandshake` |
     * | Type | `Edm.Int32` |
     */
    PLCHandshake: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PCHandshake` |
     * | Type | `Edm.Int32` |
     */
    PCHandshake: number | null;
}

export interface APPMain_GF_ManageWorkOrderIdScanFromShopfloorResponse extends CommandResponse {
}

export interface APPMain_GF_ManageWorkOrderIdScanFromShopfloor {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RawXml` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    RawXml: string;
}

export interface GF_OperationBoMItemParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    MaterialNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PositionNumber` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    PositionNumber: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsPhantom` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsPhantom: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     * | Nullable | `false` |
     */
    Quantity: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoM` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    UoM: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OrderLevel` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    OrderLevel: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OrderPath` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    OrderPath: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AssemblyOrderLevel` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    AssemblyOrderLevel: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AssemblyOrderPath` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    AssemblyOrderPath: string;
}

export interface GF_BoMItemParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BoMItemNid` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    BoMItemNid: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `QuantityAndUoM` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    QuantityAndUoM: QuantityParameterType | null;
}

export interface GF_FailureIdType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
}

export interface GF_EquipmentConfigIdType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface GF_ProcessIdType_Quantity {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoMNId` |
     * | Type | `Edm.String` |
     */
    UoMNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `QuantityValue` |
     * | Type | `Edm.Decimal` |
     */
    QuantityValue: number | null;
}

export interface GF_ProcessIdType_DiscreteStatus {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StatusMachineNId` |
     * | Type | `Edm.String` |
     */
    StatusMachineNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StatusNId` |
     * | Type | `Edm.String` |
     */
    StatusNId: string | null;
}

export interface GF_ProcessIdType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaxQuantity` |
     * | Type | `Grundfos.Opcenter.MasterData.FBERPMS.MSModel.Types.GF_ProcessIdType_Quantity` |
     */
    MaxQuantity: GF_ProcessIdType_Quantity | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Grundfos.Opcenter.MasterData.FBERPMS.MSModel.Types.GF_ProcessIdType_Quantity` |
     */
    Quantity: GF_ProcessIdType_Quantity | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MinQuantity` |
     * | Type | `Grundfos.Opcenter.MasterData.FBERPMS.MSModel.Types.GF_ProcessIdType_Quantity` |
     */
    MinQuantity: GF_ProcessIdType_Quantity | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DiscreteStatus` |
     * | Type | `Grundfos.Opcenter.MasterData.FBERPMS.MSModel.Types.GF_ProcessIdType_DiscreteStatus` |
     */
    DiscreteStatus: GF_ProcessIdType_DiscreteStatus | null;
}

export interface RepairActivityParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `QGWorkOrderOperationNId` |
     * | Type | `Edm.String` |
     */
    QGWorkOrderOperationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActivityNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ActivityNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `QGEquipmentNId` |
     * | Type | `Edm.String` |
     */
    QGEquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `QualityGateNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    QualityGateNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnitId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    DM_MaterialTrackingUnitId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkOrderOperationNId: string;
}

export interface WorkInstructionStepParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionStepId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkInstructionStepId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionStepType` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkInstructionStepType: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionStepItems` |
     * | Type | `Collection(Siemens.SimaticIT.OperationalData.WI_OP.OPModel.Types.StepItemValueType)` |
     */
    WorkInstructionStepItems: Array<StepItemValueType>;
}

export interface RepairWorkInstructionActivityParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkInstructionId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionSteps` |
     * | Type | `Collection(Siemens.OpcenterEX.DS.OperationalData.FB_OP_RuntimeQG.OPModel.Types.WorkInstructionStepParameterType)` |
     */
    WorkInstructionSteps: Array<WorkInstructionStepParameterType>;
}

export interface RepairResultParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResultValue` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ResultValue: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsKo` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsKo: boolean;
}

export interface RepairMaterialActivityParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItemToConsume` |
     * | Type | `Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.MaterialItemToConsumeParameterType` |
     */
    MaterialItemToConsume: MaterialItemToConsumeParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderOperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Notes` |
     * | Type | `Edm.String` |
     */
    Notes: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FailAtFirstError` |
     * | Type | `Edm.Boolean` |
     */
    FailAtFirstError: boolean | null;
}

export interface RepairToolActivityParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ToolNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TimesToBeUsed` |
     * | Type | `Edm.Decimal` |
     */
    TimesToBeUsed: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UsageDuration` |
     * | Type | `Edm.Duration` |
     */
    UsageDuration: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolDefinitionId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToolDefinitionId: string;
}

export interface RepairScrewingToolActivityParameterType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsRepaired` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsRepaired: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolUsage` |
     * | Type | `Siemens.OpcenterEX.DS.OperationalData.FB_OP_RuntimeQG.OPModel.Types.RepairToolActivityParameterType` |
     */
    ToolUsage: RepairToolActivityParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ResultValue` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ResultValue: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StrategyNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    StrategyNId: string;
}

export interface UADMGetAllReasonsResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Type` |
     * | Type | `Edm.String` |
     */
    Type: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Location` |
     * | Type | `Edm.String` |
     */
    Location: string | null;
}

export interface UADMGetAllReasons {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReasonId` |
     * | Type | `Edm.Guid` |
     */
    ReasonId: string | null;
}

export interface UADMGetExecutionGroupListResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TotalQuantity` |
     * | Type | `Edm.Decimal` |
     */
    TotalQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedStartTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedStartTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedEndTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedEndTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedDuration` |
     * | Type | `Edm.Duration` |
     */
    EstimatedDuration: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     */
    Status: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DueDate` |
     * | Type | `Edm.DateTimeOffset` |
     */
    DueDate: string | null;
}

export interface UADMGetExecutionGroupList {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupId` |
     * | Type | `Edm.Guid` |
     */
    ExecutionGroupId: string | null;
}

export interface UADMGetExecutionGroupHistoryResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupNId` |
     * | Type | `Edm.String` |
     */
    ExecutionGroupNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActionNId` |
     * | Type | `Edm.String` |
     */
    ActionNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `User` |
     * | Type | `Edm.String` |
     */
    User: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationName` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationSeqence` |
     * | Type | `Edm.Int32` |
     */
    WorkOrderOperationSeqence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Date` |
     * | Type | `Edm.DateTimeOffset` |
     */
    Date: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OldQuantity` |
     * | Type | `Edm.Decimal` |
     */
    OldQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NewQuantity` |
     * | Type | `Edm.Decimal` |
     */
    NewQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MachineNId` |
     * | Type | `Edm.String` |
     */
    MachineNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionNId` |
     * | Type | `Edm.String` |
     */
    WorkInstructionNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupPhaseNId` |
     * | Type | `Edm.String` |
     */
    ExecutionGroupPhaseNId: string | null;
}

export interface UADMGetExecutionGroupHistory {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupId` |
     * | Type | `Edm.Guid` |
     */
    ExecutionGroupId: string | null;
}

export interface UADMGetAllExecutionGroupPhasesWithLinkedPJFResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     */
    Sequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedStartTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedStartTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedEndTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedEndTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedDuration` |
     * | Type | `Edm.Duration` |
     */
    EstimatedDuration: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     */
    Status: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LinkedMachine` |
     * | Type | `Edm.String` |
     */
    LinkedMachine: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LinkedPJF` |
     * | Type | `Edm.String` |
     */
    LinkedPJF: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PreferredMachineNId` |
     * | Type | `Edm.String` |
     */
    PreferredMachineNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCollectedDocument` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCollectedDocument: boolean | null;
}

export interface UADMGetAllExecutionGroupPhasesWithLinkedPJF {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ExecutionGroupId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupPhaseId` |
     * | Type | `Edm.Guid` |
     */
    ExecutionGroupPhaseId: string | null;
}

export interface UADMGetAllToBeUsedMachineForSetWKCHoldResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeNId` |
     * | Type | `Edm.String` |
     */
    EquipmentTypeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sorting` |
     * | Type | `Edm.Int32` |
     */
    Sorting: number | null;
}

export interface UADMGetAllToBeUsedMachineForSetWKCHold {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
}

export interface UADMGetDefectOrFailureResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `GroupPath` |
     * | Type | `Edm.String` |
     */
    GroupPath: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsDefect` |
     * | Type | `Edm.Boolean` |
     */
    IsDefect: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface UADMGetDefectOrFailure {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    NonConformanceId: string;
}

export interface UADMGetNonConformanceContainerMTUResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnit_Ids` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DM_MaterialTrackingUnit_Ids: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsContainer` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsContainer: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `svgIcon` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.Types.SvgIcon` |
     * | Nullable | `false` |
     */
    svgIcon: SvgIcon;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialNId` |
     * | Type | `Edm.String` |
     */
    MaterialNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialRevision` |
     * | Type | `Edm.String` |
     */
    MaterialRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Code` |
     * | Type | `Edm.String` |
     */
    Code: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsReusable` |
     * | Type | `Edm.Boolean` |
     */
    IsReusable: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CodeType` |
     * | Type | `Edm.String` |
     */
    CodeType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContainerType` |
     * | Type | `Edm.String` |
     */
    ContainerType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     */
    Status: string | null;
}

export interface UADMGetNonConformanceContainerMTU {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface UADMGetContainerToWorkOrderLinkResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContainerNId` |
     * | Type | `Edm.String` |
     */
    ContainerNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContainerName` |
     * | Type | `Edm.String` |
     */
    ContainerName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Code` |
     * | Type | `Edm.String` |
     */
    Code: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     */
    Status: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Equipment` |
     * | Type | `Edm.String` |
     */
    Equipment: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContainerType` |
     * | Type | `Edm.String` |
     */
    ContainerType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsContainerReusable` |
     * | Type | `Edm.Boolean` |
     */
    IsContainerReusable: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
}

export interface UADMGetContainerToWorkOrderLink {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderNId: string | null;
}

export interface UADMGetAllDM_MaterialTrackingUnitToAssignWorkOrderResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Code` |
     * | Type | `Edm.String` |
     */
    Code: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialNId` |
     * | Type | `Edm.String` |
     */
    MaterialNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     */
    Status: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsReserved` |
     * | Type | `Edm.Boolean` |
     */
    IsReserved: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsResultKo` |
     * | Type | `Edm.Boolean` |
     */
    IsResultKo: boolean | null;
}

export interface UADMGetAllDM_MaterialTrackingUnitToAssignWorkOrder {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderId: string;
}

export interface UADMGetExecutionGroupsForWorkOrderResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TotalQuantity` |
     * | Type | `Edm.Decimal` |
     */
    TotalQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedStartTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedStartTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedEndTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedEndTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedDuration` |
     * | Type | `Edm.Duration` |
     */
    EstimatedDuration: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     */
    Status: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface UADMGetExecutionGroupsForWorkOrder {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderId: string;
}

export interface UADMGetEquipmentAndRelatedOperationsResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    EquipmentNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    OperationNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationName` |
     * | Type | `Edm.String` |
     */
    OperationName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationStatus` |
     * | Type | `Edm.String` |
     */
    OperationStatus: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedStart` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedStart: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedEnd` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedEnd: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualStart` |
     * | Type | `Edm.DateTimeOffset` |
     */
    ActualStart: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualEnd` |
     * | Type | `Edm.DateTimeOffset` |
     */
    ActualEnd: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedDuration` |
     * | Type | `Edm.Int64` |
     */
    EstimatedDuration: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     */
    Sequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStatus` |
     * | Type | `Edm.String` |
     */
    WorkOrderStatus: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Skills` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.Types.SkillParameterType)` |
     */
    Skills: Array<SkillParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Users` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.OperationalData.Runtime.OPModel.Types.IdentifiersParameterType)` |
     */
    Users: Array<IdentifiersParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FinalMaterialNId` |
     * | Type | `Edm.String` |
     */
    FinalMaterialNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Preferred` |
     * | Type | `Edm.Boolean` |
     */
    Preferred: boolean | null;
}

export interface UADMGetEquipmentAndRelatedOperations {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `GetReadyOps` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    GetReadyOps: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `GetOpenOps` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    GetOpenOps: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `GetCompleteOps` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    GetCompleteOps: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    EquipmentNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `GetActiveOps` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    GetActiveOps: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `GetPartialOps` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    GetPartialOps: boolean;
}

export interface UADMGetAllEquipmentsAndRelatedOperationsResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Level` |
     * | Type | `Edm.String` |
     */
    Level: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeNId` |
     * | Type | `Edm.String` |
     */
    EquipmentTypeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CompleteByDifferentUser` |
     * | Type | `Edm.String` |
     */
    CompleteByDifferentUser: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `QueueOperations` |
     * | Type | `Edm.Int32` |
     */
    QueueOperations: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActiveOperations` |
     * | Type | `Edm.Int32` |
     */
    ActiveOperations: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OpenOperations` |
     * | Type | `Edm.Int32` |
     */
    OpenOperations: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActiveOpenQueue` |
     * | Type | `Edm.String` |
     */
    ActiveOpenQueue: string | null;
}

export interface UADMGetAllEquipmentsAndRelatedOperations {
}

export interface UADMGetWorkOrderOutMsgFileResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `File` |
     * | Type | `Siemens.OpcenterEX.FN.MasterData.DEF_MS.MSModel.Types.FileType` |
     */
    File: FileType | null;
}

export interface UADMGetWorkOrderOutMsgFile {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FileId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    FileId: string;
}

export interface UADMGetBuyoffNonConformancesResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Severity` |
     * | Type | `Edm.String` |
     */
    Severity: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StartDate` |
     * | Type | `Edm.DateTimeOffset` |
     */
    StartDate: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EndDate` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EndDate: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `User` |
     * | Type | `Edm.String` |
     */
    User: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MTUCode` |
     * | Type | `Edm.String` |
     */
    MTUCode: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FinalMaterial` |
     * | Type | `Edm.String` |
     */
    FinalMaterial: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationName` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepName` |
     * | Type | `Edm.String` |
     */
    WorkOrderStepName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Signers` |
     * | Type | `Edm.String` |
     */
    Signers: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     */
    Status: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderStepNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FinalMaterialUId` |
     * | Type | `Edm.String` |
     */
    FinalMaterialUId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStepId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface UADMGetBuyoffNonConformances {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FilterByUserAndRole` |
     * | Type | `Edm.Boolean` |
     */
    FilterByUserAndRole: boolean | null;
}

export interface UADMGetSignersFromBuyOffHistoryResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StatusTransitionId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    StatusTransitionId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StatusTransitionNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    StatusTransitionNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Signers` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.Types.SignerParameterType)` |
     * | Nullable | `false` |
     */
    Signers: Array<SignerParameterType>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TimeStamp` |
     * | Type | `Edm.DateTimeOffset` |
     */
    TimeStamp: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CharacteristicRepresentationNId` |
     * | Type | `Edm.String` |
     */
    CharacteristicRepresentationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BuyOffId` |
     * | Type | `Edm.Guid` |
     */
    BuyOffId: string | null;
}

export interface UADMGetSignersFromBuyOffHistory {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStepId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MTUCode` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    MTUCode: string;
}

export interface UADMGetWIDetailsForWorkOrderOperationAndStepResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionDefinitionId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkInstructionDefinitionId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionDefinitionNId` |
     * | Type | `Edm.String` |
     */
    WorkInstructionDefinitionNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionDefinitionName` |
     * | Type | `Edm.String` |
     */
    WorkInstructionDefinitionName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionDefinitionRevision` |
     * | Type | `Edm.String` |
     */
    WorkInstructionDefinitionRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SectionName` |
     * | Type | `Edm.String` |
     */
    SectionName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StepName` |
     * | Type | `Edm.String` |
     */
    StepName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StepType` |
     * | Type | `Edm.String` |
     */
    StepType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DCName` |
     * | Type | `Edm.String` |
     */
    DCName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DCValue` |
     * | Type | `Edm.String` |
     */
    DCValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DCDefaultValue` |
     * | Type | `Edm.String` |
     */
    DCDefaultValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DCLowerLimit` |
     * | Type | `Edm.String` |
     */
    DCLowerLimit: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DCUpperLimit` |
     * | Type | `Edm.String` |
     */
    DCUpperLimit: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DCUOM` |
     * | Type | `Edm.String` |
     */
    DCUOM: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AssociationType` |
     * | Type | `Edm.String` |
     */
    AssociationType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `HideOnExecGroup` |
     * | Type | `Edm.Boolean` |
     */
    HideOnExecGroup: boolean | null;
}

export interface UADMGetWIDetailsForWorkOrderOperationAndStep {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStepId: string | null;
}

export interface UADMGetContainerTobeConsumedMTUsResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    Quantity: QuantityParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialNId` |
     * | Type | `Edm.String` |
     */
    MaterialNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MTUId` |
     * | Type | `Edm.Guid` |
     */
    MTUId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MTUNId` |
     * | Type | `Edm.String` |
     */
    MTUNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CodeType` |
     * | Type | `Siemens.SimaticIT.OperationalData.MAT_OP.OPModel.Types.MTUCodeType` |
     */
    CodeType: MTUCodeType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Code` |
     * | Type | `Edm.String` |
     */
    Code: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `InternalWarningMessages` |
     * | Type | `Collection(Edm.String)` |
     */
    InternalWarningMessages: Array<string>;
}

export interface UADMGetContainerTobeConsumedMTUs {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContainerNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ContainerNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialNIds` |
     * | Type | `Collection(Edm.String)` |
     */
    MaterialNIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkOrderNId: string;
}

export interface UADMGetMTUFromBufferForToBeConsumedBatchMaterialsResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MTUCode` |
     * | Type | `Edm.String` |
     */
    MTUCode: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialDefinitionNId` |
     * | Type | `Edm.String` |
     */
    MaterialDefinitionNId: string | null;
}

export interface UADMGetMTUFromBufferForToBeConsumedBatchMaterials {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialQuantityList` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.Types.MaterialQuantityList)` |
     */
    MaterialQuantityList: Array<MaterialQuantityList>;
}

export interface UADMGetActualConsumedMaterialForGenealogyResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedMaterialItem_Id` |
     * | Type | `Edm.Guid` |
     */
    ProducedMaterialItem_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnit_Id` |
     * | Type | `Edm.Guid` |
     */
    DM_MaterialTrackingUnit_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedMaterialItemActualQty` |
     * | Type | `Edm.Decimal` |
     */
    ProducedMaterialItemActualQty: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialItemAssembledQty` |
     * | Type | `Edm.Decimal` |
     */
    MaterialItemAssembledQty: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ConsumptionDateTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    ConsumptionDateTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStep_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStep_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnit` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.Types.DM_MTUGenealogyType` |
     */
    DM_MaterialTrackingUnit: DM_MTUGenealogyType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedMaterialItem` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.Types.ProducedMTUGenealogyType` |
     */
    ProducedMaterialItem: ProducedMTUGenealogyType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeConsumedMaterial` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.Types.ToBeConsumedMaterialGenealogyType` |
     */
    ToBeConsumedMaterial: ToBeConsumedMaterialGenealogyType | null;
}

export interface UADMGetActualConsumedMaterialForGenealogy {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MTU_Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    DM_MTU_Id: string;
}

export interface UADMGetEventLogsResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrder` |
     * | Type | `Edm.String` |
     */
    WorkOrder: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperation: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CompletedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    CompletedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ERPOrder` |
     * | Type | `Edm.String` |
     */
    ERPOrder: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     */
    Status: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ErrorMessage` |
     * | Type | `Edm.String` |
     */
    ErrorMessage: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdate` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdate: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EventEntityType` |
     * | Type | `Edm.String` |
     */
    EventEntityType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EventID` |
     * | Type | `Edm.Guid` |
     */
    EventID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PlantID` |
     * | Type | `Edm.String` |
     */
    PlantID: string | null;
}

export interface UADMGetEventLogs {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Source` |
     * | Type | `Edm.String` |
     */
    Source: string | null;
}

export interface UADMGetAllMaterialDefinitionDocumentsResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FileName` |
     * | Type | `Edm.String` |
     */
    FileName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MIMEType` |
     * | Type | `Edm.String` |
     */
    MIMEType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `File_Id_Id` |
     * | Type | `Edm.Guid` |
     */
    File_Id_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DatasetNId` |
     * | Type | `Edm.String` |
     */
    DatasetNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Type` |
     * | Type | `Edm.String` |
     */
    Type: string | null;
}

export interface UADMGetAllMaterialDefinitionDocuments {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStep_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStep_Id: string | null;
}

export interface UADMGetDataFromFeaturesResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FeatureNId` |
     * | Type | `Edm.String` |
     */
    FeatureNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FeatureValueNId` |
     * | Type | `Edm.String` |
     */
    FeatureValueNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsOption` |
     * | Type | `Edm.Boolean` |
     */
    IsOption: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FeatureName` |
     * | Type | `Edm.String` |
     */
    FeatureName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FeatureDescription` |
     * | Type | `Edm.String` |
     */
    FeatureDescription: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FeatureValueName` |
     * | Type | `Edm.String` |
     */
    FeatureValueName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FeatureValueDescription` |
     * | Type | `Edm.String` |
     */
    FeatureValueDescription: string | null;
}

export interface UADMGetDataFromFeatures {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BillOfFeaturesNId` |
     * | Type | `Edm.String` |
     */
    BillOfFeaturesNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BillOfFeaturesRevision` |
     * | Type | `Edm.String` |
     */
    BillOfFeaturesRevision: string | null;
}

export interface UADMGetAllTasksResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     * | Nullable | `false` |
     */
    CreatedOn: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     * | Nullable | `false` |
     */
    LastUpdatedOn: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Name: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Description: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskTypeNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    TaskTypeNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskUI` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    TaskUI: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskDefinitionNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    TaskDefinitionNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskTypeIcon` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    TaskTypeIcon: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    EquipmentNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.Types.StateMachineStatusNIdParameterType` |
     */
    Status: StateMachineStatusNIdParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Contexts` |
     * | Type | `Collection(Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.Types.TaskContextParameterType)` |
     */
    Contexts: Array<TaskContextParameterType>;
}

export interface UADMGetAllTasks {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkOrderOperationNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkOrderNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderStepNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialUId` |
     * | Type | `Edm.String` |
     */
    DM_MaterialUId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskId` |
     * | Type | `Edm.Guid` |
     */
    TaskId: string | null;
}

export interface UADMGetWIDetailsForEgPhaseResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionDefinitionId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkInstructionDefinitionId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionDefinitionNId` |
     * | Type | `Edm.String` |
     */
    WorkInstructionDefinitionNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionDefinitionName` |
     * | Type | `Edm.String` |
     */
    WorkInstructionDefinitionName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkInstructionDefinitionRevision` |
     * | Type | `Edm.String` |
     */
    WorkInstructionDefinitionRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SectionName` |
     * | Type | `Edm.String` |
     */
    SectionName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StepName` |
     * | Type | `Edm.String` |
     */
    StepName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StepType` |
     * | Type | `Edm.String` |
     */
    StepType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DCName` |
     * | Type | `Edm.String` |
     */
    DCName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DCValue` |
     * | Type | `Edm.String` |
     */
    DCValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DCDefaultValue` |
     * | Type | `Edm.String` |
     */
    DCDefaultValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DCLowerLimit` |
     * | Type | `Edm.String` |
     */
    DCLowerLimit: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DCUpperLimit` |
     * | Type | `Edm.String` |
     */
    DCUpperLimit: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DCUOM` |
     * | Type | `Edm.String` |
     */
    DCUOM: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AssociationType` |
     * | Type | `Edm.String` |
     */
    AssociationType: string | null;
}

export interface UADMGetWIDetailsForEgPhase {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EgPhaseId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    EgPhaseId: string;
}

export interface UADMGetScrewingDetailsResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ScrewingDetails` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.Types.ScrewingDetailsParameterType` |
     */
    ScrewingDetails: ScrewingDetailsParameterType | null;
}

export interface UADMGetScrewingDetails {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedToolIdList` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    ToBeUsedToolIdList: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    EquipmentNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialTrackingUnitNId` |
     * | Type | `Edm.String` |
     */
    MaterialTrackingUnitNId: string | null;
}

export interface UADMGetScrewingHistoryFromMaterialTrackingUnitResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ScrewingData` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.Types.ScrewingDataParameterType` |
     */
    ScrewingData: ScrewingDataParameterType | null;
}

export interface UADMGetScrewingHistoryFromMaterialTrackingUnit {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialTrackingUnitNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    MaterialTrackingUnitNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolNId` |
     * | Type | `Edm.String` |
     */
    ToolNId: string | null;
}

export interface UADMGetAllDocumentsFromNonConformanceIdResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MIMEType` |
     * | Type | `Edm.String` |
     */
    MIMEType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LocalFileId` |
     * | Type | `Edm.Guid` |
     */
    LocalFileId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentId` |
     * | Type | `Edm.Guid` |
     */
    DocumentId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IconId` |
     * | Type | `Edm.Guid` |
     */
    IconId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentName` |
     * | Type | `Edm.String` |
     */
    DocumentName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentNId` |
     * | Type | `Edm.String` |
     */
    DocumentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentCategory` |
     * | Type | `Edm.String` |
     */
    DocumentCategory: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentDescription` |
     * | Type | `Edm.String` |
     */
    DocumentDescription: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RepositoryType` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.Types.DocumentRepositoryType` |
     */
    RepositoryType: DocumentRepositoryType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FileName` |
     * | Type | `Edm.String` |
     */
    FileName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IconName` |
     * | Type | `Edm.String` |
     */
    IconName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EntityLinkId` |
     * | Type | `Edm.Guid` |
     */
    EntityLinkId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentRevision` |
     * | Type | `Edm.String` |
     */
    DocumentRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NonConformanceHistory` |
     * | Type | `Edm.Guid` |
     */
    NonConformanceHistory: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
}

export interface UADMGetAllDocumentsFromNonConformanceId {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NCId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    NCId: string;
}

export interface UADMGetExecutionGroupListWithEstimatedDurationResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TotalQuantity` |
     * | Type | `Edm.Decimal` |
     */
    TotalQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedStartTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedStartTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedEndTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedEndTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedDuration` |
     * | Type | `Edm.String` |
     */
    EstimatedDuration: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     */
    Status: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DueDate` |
     * | Type | `Edm.DateTimeOffset` |
     */
    DueDate: string | null;
}

export interface UADMGetExecutionGroupListWithEstimatedDuration {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupId` |
     * | Type | `Edm.Guid` |
     */
    ExecutionGroupId: string | null;
}

export interface UADMGetAllMaterialForPrekitResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AlternativeSelected` |
     * | Type | `Edm.Boolean` |
     */
    AlternativeSelected: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogicalPosition` |
     * | Type | `Edm.String` |
     */
    LogicalPosition: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SerialNumberProfile` |
     * | Type | `Edm.Boolean` |
     */
    SerialNumberProfile: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialSpecificationType` |
     * | Type | `Edm.String` |
     */
    MaterialSpecificationType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialDefinitionNId` |
     * | Type | `Edm.String` |
     */
    MaterialDefinitionNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrekitSerialNumber` |
     * | Type | `Edm.String` |
     */
    PrekitSerialNumber: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationName` |
     * | Type | `Edm.String` |
     */
    WorkOrderOperationName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationSequence` |
     * | Type | `Edm.Int32` |
     */
    WorkOrderOperationSequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderStepNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepName` |
     * | Type | `Edm.String` |
     */
    WorkOrderStepName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepSequence` |
     * | Type | `Edm.Int32` |
     */
    WorkOrderStepSequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     */
    Sequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStepId: string | null;
}

export interface UADMGetAllMaterialForPrekit {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `woId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    woId: string;
}

export interface UADMGetItlkParametersDetailsResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterName` |
     * | Type | `Edm.String` |
     */
    ParameterName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterDataType` |
     * | Type | `Edm.String` |
     */
    ParameterDataType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterValue` |
     * | Type | `Edm.String` |
     */
    ParameterValue: string | null;
}

export interface UADMGetItlkParametersDetails {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AssociationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    AssociationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsWoOp` |
     * | Type | `Edm.Boolean` |
     */
    IsWoOp: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsProcOp` |
     * | Type | `Edm.Boolean` |
     */
    IsProcOp: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsOpStepCategory` |
     * | Type | `Edm.Boolean` |
     */
    IsOpStepCategory: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsWoStep` |
     * | Type | `Edm.Boolean` |
     */
    IsWoStep: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsProcStep` |
     * | Type | `Edm.Boolean` |
     */
    IsProcStep: boolean | null;
}

export interface DM_MaterialAndMaterialResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialClass` |
     * | Type | `Edm.String` |
     */
    MaterialClass: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     */
    Revision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SerialNumberProfile` |
     * | Type | `Edm.Boolean` |
     */
    SerialNumberProfile: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoMNId` |
     * | Type | `Edm.String` |
     */
    UoMNId: string | null;
}

export interface DM_MaterialAndMaterial {
}

export interface UADMGetItlkCheckHistoryParamValuesResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterName` |
     * | Type | `Edm.String` |
     */
    ParameterName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterDataType` |
     * | Type | `Edm.String` |
     */
    ParameterDataType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParameterValue` |
     * | Type | `Edm.String` |
     */
    ParameterValue: string | null;
}

export interface UADMGetItlkCheckHistoryParamValues {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ItlkCheckHistoryId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ItlkCheckHistoryId: string;
}

export interface UADMGetFullEquipmentResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AssociatedPrintJobFileId` |
     * | Type | `Edm.Guid` |
     */
    AssociatedPrintJobFileId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AssociatedPrintJobFileNId` |
     * | Type | `Edm.String` |
     */
    AssociatedPrintJobFileNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsWorkOperationAM` |
     * | Type | `Edm.Boolean` |
     */
    IsWorkOperationAM: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsWorkOperationCNC` |
     * | Type | `Edm.Boolean` |
     */
    IsWorkOperationCNC: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LevelNId` |
     * | Type | `Edm.String` |
     */
    LevelNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Locked` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    Locked: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PartProgram` |
     * | Type | `Edm.String` |
     */
    PartProgram: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Plant` |
     * | Type | `Edm.String` |
     */
    Plant: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Preferred` |
     * | Type | `Edm.Boolean` |
     */
    Preferred: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedMachineId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToBeUsedMachineId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Type` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Type: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AssociatedPrintJobFileNIdRuntimeOnly` |
     * | Type | `Edm.Boolean` |
     */
    AssociatedPrintJobFileNIdRuntimeOnly: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AssociatedPrintJobFileProductSerializable` |
     * | Type | `Edm.Boolean` |
     */
    AssociatedPrintJobFileProductSerializable: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AssociatedPrintJobFileProductSerialManagement` |
     * | Type | `Edm.String` |
     */
    AssociatedPrintJobFileProductSerialManagement: string | null;
}

export interface UADMGetFullEquipment {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OperationId: string;
}

export interface UADMGetAllProcessMachinesResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `result` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.Types.ProcessMachinesParameterType` |
     */
    result: ProcessMachinesParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface UADMGetAllProcessMachines {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBOP_Id` |
     * | Type | `Edm.Guid` |
     */
    AsPlannedBOP_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlan_Id` |
     * | Type | `Edm.Guid` |
     */
    MasterPlan_Id: string | null;
}

export interface UADMGetAllItlkCheckWOOpAssociationResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsStandard` |
     * | Type | `Edm.Boolean` |
     */
    IsStandard: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsInbound` |
     * | Type | `Edm.Boolean` |
     */
    IsInbound: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsOutbound` |
     * | Type | `Edm.Boolean` |
     */
    IsOutbound: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AssociationId` |
     * | Type | `Edm.Guid` |
     */
    AssociationId: string | null;
}

export interface UADMGetAllItlkCheckWOOpAssociation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OperationId: string;
}

export interface UADMGetAllItlkCheckProcessToOpLinkAssociationResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsStandard` |
     * | Type | `Edm.Boolean` |
     */
    IsStandard: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsInbound` |
     * | Type | `Edm.Boolean` |
     */
    IsInbound: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsOutbound` |
     * | Type | `Edm.Boolean` |
     */
    IsOutbound: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessToOperationLinkId` |
     * | Type | `Edm.Guid` |
     */
    ProcessToOperationLinkId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AssociationId` |
     * | Type | `Edm.Guid` |
     */
    AssociationId: string | null;
}

export interface UADMGetAllItlkCheckProcessToOpLinkAssociation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `linkId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    linkId: string;
}

export interface UADMGetEquipmentForToBeUsedMachineResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentToBeLinked` |
     * | Type | `Edm.String` |
     */
    EquipmentToBeLinked: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentToBeLinkedId` |
     * | Type | `Edm.Guid` |
     */
    EquipmentToBeLinkedId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentToBeLinkedName` |
     * | Type | `Edm.String` |
     */
    EquipmentToBeLinkedName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentToBeLinkedLevel` |
     * | Type | `Edm.String` |
     */
    EquipmentToBeLinkedLevel: string | null;
}

export interface UADMGetEquipmentForToBeUsedMachine {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LevelNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    LevelNId: string;
}

export interface UADMGetEquipmentForEqSpecificationResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentToBeLinked` |
     * | Type | `Edm.String` |
     */
    EquipmentToBeLinked: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentToBeLinkedId` |
     * | Type | `Edm.Guid` |
     */
    EquipmentToBeLinkedId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentToBeLinkedName` |
     * | Type | `Edm.String` |
     */
    EquipmentToBeLinkedName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentToBeLinkedLevel` |
     * | Type | `Edm.String` |
     */
    EquipmentToBeLinkedLevel: string | null;
}

export interface UADMGetEquipmentForEqSpecification {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LevelNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    LevelNId: string;
}

export interface UADM_DMMaterialTrackingUnitAndMTUResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CodeType` |
     * | Type | `Edm.String` |
     */
    CodeType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Code` |
     * | Type | `Edm.String` |
     */
    Code: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialDefinition` |
     * | Type | `Edm.String` |
     */
    MaterialDefinition: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StatusNId` |
     * | Type | `Edm.String` |
     */
    StatusNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsResultKo` |
     * | Type | `Edm.Boolean` |
     */
    IsResultKo: boolean | null;
}

export interface UADM_DMMaterialTrackingUnitAndMTU {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrder` |
     * | Type | `Edm.Guid` |
     */
    WorkOrder: string | null;
}

export interface UADMGetAllToolCompatibleMachinesResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolCompatibleMachineParameter` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.Types.ToolCompatibleMachineParameterType` |
     */
    ToolCompatibleMachineParameter: ToolCompatibleMachineParameterType | null;
}

export interface UADMGetAllToolCompatibleMachines {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToolId: string;
}

export interface UADMGetLinkableEquipmentResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LevelNId` |
     * | Type | `Edm.String` |
     */
    LevelNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeNId` |
     * | Type | `Edm.String` |
     */
    EquipmentTypeNId: string | null;
}

export interface UADMGetLinkableEquipment {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Plant` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Plant: string;
}

export interface UADMGetAllToolDefinitionCompatibleMachineResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolDefinitionCompatibleMachineParameterType` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.Types.RF_ToolDefinitionCompatibleMachineParameterType` |
     */
    ToolDefinitionCompatibleMachineParameterType: RF_ToolDefinitionCompatibleMachineParameterType | null;
}

export interface UADMGetAllToolDefinitionCompatibleMachine {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolDefinitionId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToolDefinitionId: string;
}

export interface UADMGetAllItlkCheckWOStepAssociationResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsStandard` |
     * | Type | `Edm.Boolean` |
     */
    IsStandard: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsInbound` |
     * | Type | `Edm.Boolean` |
     */
    IsInbound: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsOutbound` |
     * | Type | `Edm.Boolean` |
     */
    IsOutbound: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStepId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AssociationId` |
     * | Type | `Edm.Guid` |
     */
    AssociationId: string | null;
}

export interface UADMGetAllItlkCheckWOStepAssociation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StepId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    StepId: string;
}

export interface UADMGetDefectGroupSpecificationsResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContextNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ContextNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SpecificationType` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    SpecificationType: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SpecificationTypeCode` |
     * | Type | `Edm.Int32` |
     * | Nullable | `false` |
     */
    SpecificationTypeCode: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SpecificationNId` |
     * | Type | `Edm.String` |
     */
    SpecificationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_Material` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.Types.UADMMaterialParameterType` |
     */
    DM_Material: UADMMaterialParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Equipment` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.Types.UADMEquipmentSpecificationParameterType` |
     */
    Equipment: UADMEquipmentSpecificationParameterType | null;
}

export interface UADMGetDefectGroupSpecifications {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DefectGroupId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    DefectGroupId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IncludeEquipmentConfigurations` |
     * | Type | `Edm.Boolean` |
     */
    IncludeEquipmentConfigurations: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IncludeEquipmentTypes` |
     * | Type | `Edm.Boolean` |
     */
    IncludeEquipmentTypes: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IncludeMaterials` |
     * | Type | `Edm.Boolean` |
     */
    IncludeMaterials: boolean | null;
}

export interface UADMGetUnitsFromWorkCenterResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Units` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.Types.ProcessMachinesParameterType` |
     * | Nullable | `false` |
     */
    Units: ProcessMachinesParameterType;
}

export interface UADMGetUnitsFromWorkCenter {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CellNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    CellNId: string;
}

export interface UADMGetUnitsFromBufferLocationResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UnitNId` |
     * | Type | `Edm.String` |
     */
    UnitNId: string | null;
}

export interface UADMGetUnitsFromBufferLocation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BufferId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    BufferId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LocationNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    LocationNId: string;
}

export interface UADMGetCharacteristicRepresentationResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SampleSize` |
     * | Type | `Edm.Int32` |
     */
    SampleSize: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CanBeSkipped` |
     * | Type | `Edm.Boolean` |
     */
    CanBeSkipped: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeUsedInspectionId` |
     * | Type | `Edm.Guid` |
     */
    ToBeUsedInspectionId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     */
    Revision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReferencedOperationNId` |
     * | Type | `Edm.String` |
     */
    ReferencedOperationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReferencedOperationName` |
     * | Type | `Edm.String` |
     */
    ReferencedOperationName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReferencedOperationSequence` |
     * | Type | `Edm.Int32` |
     */
    ReferencedOperationSequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Frequency` |
     * | Type | `Edm.String` |
     */
    Frequency: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FrequencyValue` |
     * | Type | `Edm.Decimal` |
     */
    FrequencyValue: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsWOSpecific` |
     * | Type | `Edm.Boolean` |
     */
    IsWOSpecific: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TimeBasedScheduleMode` |
     * | Type | `Edm.String` |
     */
    TimeBasedScheduleMode: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TimeBasedMandatoryInspectionWarningValue` |
     * | Type | `Edm.Int32` |
     */
    TimeBasedMandatoryInspectionWarningValue: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TimeBasedMandatoryInspectionWarningUoM` |
     * | Type | `Edm.String` |
     */
    TimeBasedMandatoryInspectionWarningUoM: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TimeBasedMandatoryInspectionWarningUoMValue` |
     * | Type | `Edm.Int32` |
     */
    TimeBasedMandatoryInspectionWarningUoMValue: number | null;
}

export interface UADMGetCharacteristicRepresentation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationID` |
     * | Type | `Edm.Guid` |
     */
    OperationID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `GetFromContainer` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    GetFromContainer: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StepID` |
     * | Type | `Edm.Guid` |
     */
    StepID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBOPId` |
     * | Type | `Edm.Guid` |
     */
    AsPlannedBOPId: string | null;
}

export interface UADMGetAlternativeGroupsFromWorkOrderIdResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AlternativeGroup` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    AlternativeGroup: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentWOOpId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ParentWOOpId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentWOOpNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ParentWOOpNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PreferredWOOpId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    PreferredWOOpId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PreferredWOOpNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    PreferredWOOpNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface UADMGetAlternativeGroupsFromWorkOrderId {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderId: string;
}

export interface UADMGetQualityInspectionSamplesResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `QualityInspectionData` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.Types.QualityInspectionDataType` |
     * | Nullable | `false` |
     */
    QualityInspectionData: QualityInspectionDataType;
}

export interface UADMGetQualityInspectionSamples {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MTUNId` |
     * | Type | `Edm.String` |
     */
    MTUNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrder_Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrder_Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStep_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStep_Id: string | null;
}

export interface UADMGetUnitsFromPlantResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsLocked` |
     * | Type | `Edm.Boolean` |
     */
    IsLocked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeNId` |
     * | Type | `Edm.String` |
     */
    EquipmentTypeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
}

export interface UADMGetUnitsFromPlant {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Plant` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Plant: string;
}

export interface UADMGetQualityForGenealogyResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `QualityInspectionData` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.Types.QualityInspectionDataType` |
     * | Nullable | `false` |
     */
    QualityInspectionData: QualityInspectionDataType;
}

export interface UADMGetQualityForGenealogy {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperation_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperation_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MTUNId` |
     * | Type | `Edm.String` |
     */
    MTUNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStep_Id` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStep_Id: string | null;
}

export interface UADMGetStartableItemsOnWOStepResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnitId` |
     * | Type | `Edm.Guid` |
     */
    DM_MaterialTrackingUnitId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProductionType` |
     * | Type | `Edm.String` |
     */
    ProductionType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialTrackingUnit_MaterialNId` |
     * | Type | `Edm.String` |
     */
    MaterialTrackingUnit_MaterialNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialTrackingUnit_Quantity_UoM` |
     * | Type | `Edm.String` |
     */
    MaterialTrackingUnit_Quantity_UoM: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialTrackingUnit_Quantity_Quantity` |
     * | Type | `Edm.Decimal` |
     */
    MaterialTrackingUnit_Quantity_Quantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialTrackingUnit_Status_StateMachine` |
     * | Type | `Edm.String` |
     */
    MaterialTrackingUnit_Status_StateMachine: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialTrackingUnit_Status_Status` |
     * | Type | `Edm.String` |
     */
    MaterialTrackingUnit_Status_Status: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialTrackingUnit_Code` |
     * | Type | `Edm.String` |
     */
    MaterialTrackingUnit_Code: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialTrackingUnit_Name` |
     * | Type | `Edm.String` |
     */
    MaterialTrackingUnit_Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialTrackingUnit_NId` |
     * | Type | `Edm.String` |
     */
    MaterialTrackingUnit_NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Equipment_Name` |
     * | Type | `Edm.String` |
     */
    Equipment_Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Equipment_Type` |
     * | Type | `Edm.String` |
     */
    Equipment_Type: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Equipment_IsCbduEnabled` |
     * | Type | `Edm.Boolean` |
     */
    Equipment_IsCbduEnabled: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Equipment_Level` |
     * | Type | `Edm.String` |
     */
    Equipment_Level: string | null;
}

export interface UADMGetStartableItemsOnWOStep {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderStepId: string;
}

export interface UADMGetCompletableItemsOnWOStepResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialTrackingUnitId` |
     * | Type | `Edm.Guid` |
     */
    DM_MaterialTrackingUnitId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProductionType` |
     * | Type | `Edm.String` |
     */
    ProductionType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialTrackingUnit_MaterialNId` |
     * | Type | `Edm.String` |
     */
    MaterialTrackingUnit_MaterialNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialTrackingUnit_Quantity_UoM` |
     * | Type | `Edm.String` |
     */
    MaterialTrackingUnit_Quantity_UoM: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialTrackingUnit_Quantity_Quantity` |
     * | Type | `Edm.Decimal` |
     */
    MaterialTrackingUnit_Quantity_Quantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialTrackingUnit_Status_StateMachine` |
     * | Type | `Edm.String` |
     */
    MaterialTrackingUnit_Status_StateMachine: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialTrackingUnit_Status_Status` |
     * | Type | `Edm.String` |
     */
    MaterialTrackingUnit_Status_Status: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialTrackingUnit_Code` |
     * | Type | `Edm.String` |
     */
    MaterialTrackingUnit_Code: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialTrackingUnit_Name` |
     * | Type | `Edm.String` |
     */
    MaterialTrackingUnit_Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialTrackingUnit_NId` |
     * | Type | `Edm.String` |
     */
    MaterialTrackingUnit_NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Equipment_Name` |
     * | Type | `Edm.String` |
     */
    Equipment_Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Equipment_Type` |
     * | Type | `Edm.String` |
     */
    Equipment_Type: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Equipment_IsCbduEnabled` |
     * | Type | `Edm.Boolean` |
     */
    Equipment_IsCbduEnabled: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Equipment_Level` |
     * | Type | `Edm.String` |
     */
    Equipment_Level: string | null;
}

export interface UADMGetCompletableItemsOnWOStep {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    WorkOrderStepId: string;
}

export interface UADMGetAllPrintJobFilesResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsEditable` |
     * | Type | `Edm.Boolean` |
     * | Nullable | `false` |
     */
    IsEditable: boolean;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BuildtrayLayout` |
     * | Type | `Edm.String` |
     */
    BuildtrayLayout: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExternalId` |
     * | Type | `Edm.String` |
     */
    ExternalId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FileName` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    FileName: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProductSerializable` |
     * | Type | `Edm.Boolean` |
     */
    ProductSerializable: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProductSerialNumberManagement` |
     * | Type | `Edm.String` |
     */
    ProductSerialNumberManagement: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RunTimeOnly` |
     * | Type | `Edm.Boolean` |
     */
    RunTimeOnly: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Source` |
     * | Type | `Edm.String` |
     */
    Source: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TestBars` |
     * | Type | `Edm.Boolean` |
     */
    TestBars: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TestBarsNumber` |
     * | Type | `Edm.Int32` |
     */
    TestBarsNumber: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TestBarsSerializable` |
     * | Type | `Edm.Boolean` |
     */
    TestBarsSerializable: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TestBarsSerialNumberManagement` |
     * | Type | `Edm.String` |
     */
    TestBarsSerialNumberManagement: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProductionPrinter` |
     * | Type | `Edm.String` |
     */
    ProductionPrinter: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedMaterialConsumption` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    EstimatedMaterialConsumption: QuantityParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaxProducedHeight` |
     * | Type | `Siemens.SimaticIT.ReferenceData.UDM_RF.RFModel.Types.QuantityParameterType` |
     */
    MaxProducedHeight: QuantityParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedPrintDurationHours` |
     * | Type | `Edm.Int32` |
     */
    EstimatedPrintDurationHours: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedPrintDurationMinutes` |
     * | Type | `Edm.Int32` |
     */
    EstimatedPrintDurationMinutes: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedPrintDurationSeconds` |
     * | Type | `Edm.Int32` |
     */
    EstimatedPrintDurationSeconds: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedBuildProcessDurationHours` |
     * | Type | `Edm.Int32` |
     */
    EstimatedBuildProcessDurationHours: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedBuildProcessDurationMinutes` |
     * | Type | `Edm.Int32` |
     */
    EstimatedBuildProcessDurationMinutes: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedBuildProcessDurationSeconds` |
     * | Type | `Edm.Int32` |
     */
    EstimatedBuildProcessDurationSeconds: number | null;
}

export interface UADMGetAllPrintJobFiles {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface UADMGetAlternativeGroupsFromProcessIdResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AlternativeGroup` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    AlternativeGroup: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentProcessToOpLinkId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ParentProcessToOpLinkId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentProcessToOpLinkNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ParentProcessToOpLinkNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PreferredProcessToOpLinkId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    PreferredProcessToOpLinkId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PreferredProcessToOpLinkNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    PreferredProcessToOpLinkNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
}

export interface UADMGetAlternativeGroupsFromProcessId {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ProcessId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBOP_Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    AsPlannedBOP_Id: string;
}

export interface UADMGetPrintJobFilesFromAssociationsResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExternalId` |
     * | Type | `Edm.String` |
     */
    ExternalId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsSourcePJF` |
     * | Type | `Edm.Boolean` |
     */
    IsSourcePJF: boolean | null;
}

export interface UADMGetPrintJobFilesFromAssociations {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentTypeNId` |
     * | Type | `Edm.String` |
     */
    EquipmentTypeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialNId` |
     * | Type | `Edm.String` |
     */
    DM_MaterialNId: string | null;
}

export interface UADMGetWOByProcessRevisionResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreationDate` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreationDate: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Process` |
     * | Type | `Edm.String` |
     */
    Process: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessName` |
     * | Type | `Edm.String` |
     */
    ProcessName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessRevision` |
     * | Type | `Edm.String` |
     */
    ProcessRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PBOPIdentID` |
     * | Type | `Edm.String` |
     */
    PBOPIdentID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     */
    Status: string | null;
}

export interface UADMGetWOByProcessRevision {
}

export interface UADMGetStepForCatalogResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UID` |
     * | Type | `Edm.String` |
     */
    UID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     */
    Revision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedDurationHours` |
     * | Type | `Edm.Int32` |
     */
    EstimatedDurationHours: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedDurationMinutes` |
     * | Type | `Edm.Int32` |
     */
    EstimatedDurationMinutes: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedDurationSeconds` |
     * | Type | `Edm.Int32` |
     */
    EstimatedDurationSeconds: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignatureComplete` |
     * | Type | `Edm.Boolean` |
     */
    ElectronicSignatureComplete: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     */
    Sequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationStepCategoryNId` |
     * | Type | `Edm.String` |
     */
    OperationStepCategoryNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationStepCategoryId` |
     * | Type | `Edm.Guid` |
     */
    OperationStepCategoryId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCollectedDocument` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCollectedDocument: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Optional` |
     * | Type | `Edm.Boolean` |
     */
    Optional: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RequiredInspectionRole` |
     * | Type | `Edm.String` |
     */
    RequiredInspectionRole: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignatureStart` |
     * | Type | `Edm.Boolean` |
     */
    ElectronicSignatureStart: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignaturePause` |
     * | Type | `Edm.Boolean` |
     */
    ElectronicSignaturePause: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RequiredCertificateNId` |
     * | Type | `Edm.String` |
     */
    RequiredCertificateNId: string | null;
}

export interface UADMGetStepForCatalog {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface UADMGetAllEquipmentFor3DPrinterResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Equipment3DPrinter` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.Types.Equipment3DPrinterParameterType` |
     */
    Equipment3DPrinter: Equipment3DPrinterParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface UADMGetAllEquipmentFor3DPrinter {
}

export interface UADMGetAllToolDefinitionAutomationNodeTypeResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutomationNodeTypeParameterType` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.Types.AutomationNodeTypeParameterType` |
     */
    AutomationNodeTypeParameterType: AutomationNodeTypeParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface UADMGetAllToolDefinitionAutomationNodeType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolDefinitionId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToolDefinitionId: string;
}

export interface UADMGetAllToolAutomationNodeInstanceResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutomationNodeInstanceParameterType` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.Types.AutomationNodeInstanceParameterType` |
     */
    AutomationNodeInstanceParameterType: AutomationNodeInstanceParameterType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface UADMGetAllToolAutomationNodeInstance {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToolId: string;
}

export interface UADMGetToolDefinationsBySetPointResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Version` |
     * | Type | `Edm.String` |
     */
    Version: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UId` |
     * | Type | `Edm.String` |
     */
    UId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Consumable` |
     * | Type | `Edm.Boolean` |
     */
    Consumable: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Lockable` |
     * | Type | `Edm.Boolean` |
     */
    Lockable: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RevisionExpression` |
     * | Type | `Edm.String` |
     */
    RevisionExpression: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Volume` |
     * | Type | `Edm.Decimal` |
     */
    Volume: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `VolumeUoM` |
     * | Type | `Edm.String` |
     */
    VolumeUoM: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Weight` |
     * | Type | `Edm.Decimal` |
     */
    Weight: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WeightUoM` |
     * | Type | `Edm.String` |
     */
    WeightUoM: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogisticClass` |
     * | Type | `Edm.String` |
     */
    LogisticClass: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     */
    Status: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsDefault` |
     * | Type | `Edm.Boolean` |
     */
    IsDefault: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface UADMGetToolDefinationsBySetPoint {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    SetPointId: string;
}

export interface UADMGetToolBySetPointResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UsageCounter` |
     * | Type | `Edm.Decimal` |
     */
    UsageCounter: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Lockable` |
     * | Type | `Edm.Boolean` |
     */
    Lockable: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Locked` |
     * | Type | `Edm.Boolean` |
     */
    Locked: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     */
    Status: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsScrapped` |
     * | Type | `Edm.Boolean` |
     */
    IsScrapped: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsFrozen` |
     * | Type | `Edm.Boolean` |
     */
    IsFrozen: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Volume` |
     * | Type | `Edm.Decimal` |
     */
    Volume: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `VolumeUoM` |
     * | Type | `Edm.String` |
     */
    VolumeUoM: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Weight` |
     * | Type | `Edm.Decimal` |
     */
    Weight: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WeightUoM` |
     * | Type | `Edm.String` |
     */
    WeightUoM: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogisticClass` |
     * | Type | `Edm.String` |
     */
    LogisticClass: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Definition` |
     * | Type | `Edm.String` |
     */
    Definition: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     */
    Revision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsDefault` |
     * | Type | `Edm.Boolean` |
     */
    IsDefault: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface UADMGetToolBySetPoint {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    SetPointId: string;
}

export interface UADMGetDNCItemsFromAssociationsResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DNCItemId` |
     * | Type | `Edm.Guid` |
     */
    DNCItemId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DNCId` |
     * | Type | `Edm.String` |
     */
    DNCId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DNCExternalId` |
     * | Type | `Edm.String` |
     */
    DNCExternalId: string | null;
}

export interface UADMGetDNCItemsFromAssociations {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialNId` |
     * | Type | `Edm.String` |
     */
    DM_MaterialNId: string | null;
}

export interface UADMGetOperationToStepLinkResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UID` |
     * | Type | `Edm.String` |
     */
    UID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     */
    Revision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedDurationHours` |
     * | Type | `Edm.Int32` |
     */
    EstimatedDurationHours: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedDurationMinutes` |
     * | Type | `Edm.Int32` |
     */
    EstimatedDurationMinutes: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedDurationSeconds` |
     * | Type | `Edm.Int32` |
     */
    EstimatedDurationSeconds: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignatureComplete` |
     * | Type | `Edm.Boolean` |
     */
    ElectronicSignatureComplete: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     */
    Sequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationStepCategoryNId` |
     * | Type | `Edm.String` |
     */
    OperationStepCategoryNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationStepCategoryId` |
     * | Type | `Edm.Guid` |
     */
    OperationStepCategoryId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBOPId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    AsPlannedBOPId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCollectedDocument` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCollectedDocument: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChildStepId` |
     * | Type | `Edm.Guid` |
     */
    ChildStepId: string | null;
}

export interface UADMGetOperationToStepLink {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StepId` |
     * | Type | `Edm.Guid` |
     */
    StepId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationId` |
     * | Type | `Edm.Guid` |
     */
    OperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBOPId` |
     * | Type | `Edm.Guid` |
     */
    AsPlannedBOPId: string | null;
}

export interface UADMGetWOStepsResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UID` |
     * | Type | `Edm.String` |
     */
    UID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     */
    Revision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedDurationHours` |
     * | Type | `Edm.Int32` |
     */
    EstimatedDurationHours: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedDurationMinutes` |
     * | Type | `Edm.Int32` |
     */
    EstimatedDurationMinutes: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedDurationSeconds` |
     * | Type | `Edm.Int32` |
     */
    EstimatedDurationSeconds: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignatureComplete` |
     * | Type | `Edm.Boolean` |
     */
    ElectronicSignatureComplete: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     */
    Sequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationStepCategoryNId` |
     * | Type | `Edm.String` |
     */
    OperationStepCategoryNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationStepCategoryId` |
     * | Type | `Edm.Guid` |
     */
    OperationStepCategoryId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCollectedDocument` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCollectedDocument: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NextSequence` |
     * | Type | `Edm.Int32` |
     */
    NextSequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     */
    Status: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualStartTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    ActualStartTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualEndTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    ActualEndTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedDuration` |
     * | Type | `Edm.Duration` |
     */
    EstimatedDuration: string | null;
}

export interface UADMGetWOSteps {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StepId` |
     * | Type | `Edm.Guid` |
     */
    StepId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WOId` |
     * | Type | `Edm.Guid` |
     */
    WOId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `GetNextSequence` |
     * | Type | `Edm.Boolean` |
     */
    GetNextSequence: boolean | null;
}

export interface UADMGetAllWorkOrderPrintJobFileAssociationResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderPrintJobFileParameter` |
     * | Type | `Siemens.SimaticIT.U4DM.AppU4DM.AppU4DM.DMPOMModel.Types.PrintJobFileWorkOrderParameterType` |
     */
    WorkOrderPrintJobFileParameter: PrintJobFileWorkOrderParameterType | null;
}

export interface UADMGetAllWorkOrderPrintJobFileAssociation {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrintJobFileId` |
     * | Type | `Edm.Guid` |
     */
    PrintJobFileId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FileName` |
     * | Type | `Edm.String` |
     */
    FileName: string | null;
}

export interface UADMGetBufferHistoryResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserId` |
     * | Type | `Edm.String` |
     */
    UserId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Date` |
     * | Type | `Edm.DateTimeOffset` |
     */
    Date: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActionNId` |
     * | Type | `Edm.String` |
     */
    ActionNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MTUCode` |
     * | Type | `Edm.String` |
     */
    MTUCode: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoMNId` |
     * | Type | `Edm.String` |
     */
    UoMNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MTUNId` |
     * | Type | `Edm.String` |
     */
    MTUNId: string | null;
}

export interface UADMGetBufferHistory {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
}

export interface UADMGetAllMaterialDefinitionsForAllMaterialSpecificationTypesResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialSpecificationType` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    MaterialSpecificationType: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogicalPosition` |
     * | Type | `Edm.String` |
     */
    LogicalPosition: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Behaviour` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Behaviour: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialDefinitionId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    MaterialDefinitionId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStepId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PrekitSerialNumber` |
     * | Type | `Edm.String` |
     */
    PrekitSerialNumber: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     */
    Sequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `GroupName` |
     * | Type | `Edm.String` |
     */
    GroupName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AlternativeSelected` |
     * | Type | `Edm.Boolean` |
     */
    AlternativeSelected: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SerialNumberProfile` |
     * | Type | `Edm.Boolean` |
     */
    SerialNumberProfile: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     */
    Revision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoMNId` |
     * | Type | `Edm.String` |
     */
    UoMNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `HasPrekit` |
     * | Type | `Edm.Boolean` |
     */
    HasPrekit: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OccurrenceId` |
     * | Type | `Edm.String` |
     */
    OccurrenceId: string | null;
}

export interface UADMGetAllMaterialDefinitionsForAllMaterialSpecificationTypes {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Type` |
     * | Type | `Edm.String` |
     */
    Type: string | null;
}

export interface UADMGetCertificationDetailsResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NumberOfUsers` |
     * | Type | `Edm.Int32` |
     */
    NumberOfUsers: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationId` |
     * | Type | `Edm.Guid` |
     */
    OperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StepId` |
     * | Type | `Edm.Guid` |
     */
    StepId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CertificationNId` |
     * | Type | `Edm.String` |
     */
    CertificationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CertificationName` |
     * | Type | `Edm.String` |
     */
    CertificationName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CertificationDesc` |
     * | Type | `Edm.String` |
     */
    CertificationDesc: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBoPId` |
     * | Type | `Edm.Guid` |
     */
    AsPlannedBoPId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MasterPlanId` |
     * | Type | `Edm.Guid` |
     */
    MasterPlanId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UId` |
     * | Type | `Edm.String` |
     */
    UId: string | null;
}

export interface UADMGetCertificationDetails {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentID` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ParentID: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBOPId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    AsPlannedBOPId: string;
}

export interface UADMGetWorkOrderHumanResourceDetailsResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NumberOfUsers` |
     * | Type | `Edm.Int32` |
     */
    NumberOfUsers: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationId` |
     * | Type | `Edm.Guid` |
     */
    OperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StepId` |
     * | Type | `Edm.Guid` |
     */
    StepId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CertificationNId` |
     * | Type | `Edm.String` |
     */
    CertificationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CertificationName` |
     * | Type | `Edm.String` |
     */
    CertificationName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CertificationDesc` |
     * | Type | `Edm.String` |
     */
    CertificationDesc: string | null;
}

export interface UADMGetWorkOrderHumanResourceDetails {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationID` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationID: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepID` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStepID: string | null;
}

export interface UADMGetOfflineSessionWOOperationAssociationsResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignatureComplete` |
     * | Type | `Edm.Boolean` |
     */
    ElectronicSignatureComplete: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignaturePause` |
     * | Type | `Edm.Boolean` |
     */
    ElectronicSignaturePause: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ElectronicSignatureStart` |
     * | Type | `Edm.Boolean` |
     */
    ElectronicSignatureStart: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedEndTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedEndTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedStartTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    EstimatedStartTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationId` |
     * | Type | `Edm.Guid` |
     */
    OperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Priority` |
     * | Type | `Edm.Int32` |
     */
    Priority: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RequiredCertificateNId` |
     * | Type | `Edm.String` |
     */
    RequiredCertificateNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `RequiredInspectionRole` |
     * | Type | `Edm.String` |
     */
    RequiredInspectionRole: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     * | Nullable | `false` |
     */
    Sequence: number;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToBeCollectedDocument` |
     * | Type | `Edm.Boolean` |
     */
    ToBeCollectedDocument: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOperationTypeId` |
     * | Type | `Edm.Guid` |
     */
    WorkOperationTypeId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationStepCategoryId` |
     * | Type | `Edm.Guid` |
     */
    OperationStepCategoryId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ERPConfirmationId` |
     * | Type | `Edm.String` |
     */
    ERPConfirmationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkOrderNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderName` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    WorkOrderName: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderProductionTypeNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderProductionTypeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     */
    Status: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PreviousStatus` |
     * | Type | `Edm.String` |
     */
    PreviousStatus: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TargetQuantity` |
     * | Type | `Edm.Decimal` |
     */
    TargetQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AvailableQuantity` |
     * | Type | `Edm.Decimal` |
     */
    AvailableQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ReworkedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    ReworkedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsReady` |
     * | Type | `Edm.Boolean` |
     */
    IsReady: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationNId` |
     * | Type | `Edm.String` |
     */
    OperationNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOperationTypeNId` |
     * | Type | `Edm.String` |
     */
    WorkOperationTypeNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PartialWorkedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    PartialWorkedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedDurationHours` |
     * | Type | `Edm.Int32` |
     */
    EstimatedDurationHours: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedDurationMinutes` |
     * | Type | `Edm.Int32` |
     */
    EstimatedDurationMinutes: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EstimatedDurationSeconds` |
     * | Type | `Edm.Int32` |
     */
    EstimatedDurationSeconds: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationStepCategoryNId` |
     * | Type | `Edm.String` |
     */
    OperationStepCategoryNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActiveNonConformanceNr` |
     * | Type | `Edm.Int32` |
     */
    ActiveNonConformanceNr: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualStartTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    ActualStartTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualEndTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    ActualEndTime: string | null;
}

export interface UADMGetOfflineSessionWOOperationAssociations {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OfflineSessionId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OfflineSessionId: string;
}

export interface UADMGetMaterialSpecificationTypeIndicatorResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationId` |
     * | Type | `Edm.Guid` |
     */
    OperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StepId` |
     * | Type | `Edm.Guid` |
     */
    StepId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AlternativeSelected` |
     * | Type | `Edm.Boolean` |
     */
    AlternativeSelected: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialDefinitionNId` |
     * | Type | `Edm.String` |
     */
    MaterialDefinitionNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LogicalPosition` |
     * | Type | `Edm.String` |
     */
    LogicalPosition: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Behaviour` |
     * | Type | `Edm.String` |
     */
    Behaviour: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialSpecificationType` |
     * | Type | `Edm.String` |
     */
    MaterialSpecificationType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SerialNumberprofile` |
     * | Type | `Edm.Boolean` |
     */
    SerialNumberprofile: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `GroupName` |
     * | Type | `Edm.String` |
     */
    GroupName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoMNId` |
     * | Type | `Edm.String` |
     */
    UoMNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     */
    Revision: string | null;
}

export interface UADMGetMaterialSpecificationTypeIndicator {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Type` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Type: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBOP_Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    AsPlannedBOP_Id: string;
}

export interface UADMGetAllOfflineSessionsResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UserId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    UserId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DownloadDate` |
     * | Type | `Edm.DateTimeOffset` |
     */
    DownloadDate: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UploadDate` |
     * | Type | `Edm.DateTimeOffset` |
     */
    UploadDate: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CheckInDate` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CheckInDate: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DeviceId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    DeviceId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status_StateMachineNId` |
     * | Type | `Edm.String` |
     */
    Status_StateMachineNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status_StatusNId` |
     * | Type | `Edm.String` |
     */
    Status_StatusNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActionCheckedIn` |
     * | Type | `Edm.String` |
     */
    ActionCheckedIn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    LastUpdatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
}

export interface UADMGetAllOfflineSessions {
}

export interface UADMGetProcessOperationDetailsResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessOperationNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ProcessOperationNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessOperationName` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ProcessOperationName: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessToOperationLinkId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ProcessToOperationLinkId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessOperationSequence` |
     * | Type | `Edm.Int32` |
     */
    ProcessOperationSequence: number | null;
}

export interface UADMGetProcessOperationDetails {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ProcessId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBOPId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    AsPlannedBOPId: string;
}

export interface UADMGetProcessStepDetailsResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessStepNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ProcessStepNId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessStepName` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    ProcessStepName: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProcessStepId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ProcessStepId: string;
}

export interface UADMGetProcessStepDetails {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `OperationId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    OperationId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AsPlannedBOPId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    AsPlannedBOPId: string;
}

export interface UADMGetAllDocumentsFromDM_MaterialTrackingUnitIdsResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MIMEType` |
     * | Type | `Edm.String` |
     */
    MIMEType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `File_Id_Id` |
     * | Type | `Edm.Guid` |
     */
    File_Id_Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    Id: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    AId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    CreatedOn: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LastUpdatedOn` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    LastUpdatedOn: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FileName` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    FileName: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    NId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CorrelationId` |
     * | Type | `Edm.String` |
     */
    CorrelationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DatasetNId` |
     * | Type | `Edm.String` |
     */
    DatasetNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Type` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Type: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    UId: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Category` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    Category: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
}

export interface UADMGetAllDocumentsFromDM_MaterialTrackingUnitIds {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MTUIds` |
     * | Type | `Collection(Edm.Guid)` |
     * | Nullable | `false` |
     */
    DM_MTUIds: Array<string>;
}

export interface UADMGetSerialNumberStatusForGenealogyResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Status` |
     * | Type | `Edm.String` |
     */
    Status: string | null;
}

export interface UADMGetSerialNumberStatusForGenealogy {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MTUNId` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    MTUNId: string;
}

export interface UADMGetAllConsumedDM_MTUForProducedDM_MTUResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedDM_MTUId` |
     * | Type | `Edm.Guid` |
     */
    ProducedDM_MTUId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedMTUId` |
     * | Type | `Edm.Guid` |
     */
    ProducedMTUId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedMTUCode` |
     * | Type | `Edm.String` |
     */
    ProducedMTUCode: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedMTUNId` |
     * | Type | `Edm.String` |
     */
    ProducedMTUNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedMTUCodeType` |
     * | Type | `Edm.String` |
     */
    ProducedMTUCodeType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedDM_MTUQuantity` |
     * | Type | `Edm.Decimal` |
     */
    ProducedDM_MTUQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MTUId` |
     * | Type | `Edm.Guid` |
     */
    DM_MTUId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MTUId` |
     * | Type | `Edm.Guid` |
     */
    MTUId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MTUCode` |
     * | Type | `Edm.String` |
     */
    MTUCode: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MTUNId` |
     * | Type | `Edm.String` |
     */
    MTUNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MTUCodeType` |
     * | Type | `Edm.String` |
     */
    MTUCodeType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedMaterialNId` |
     * | Type | `Edm.String` |
     */
    ProducedMaterialNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedMaterialRevision` |
     * | Type | `Edm.String` |
     */
    ProducedMaterialRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ConsumedQuantity` |
     * | Type | `Edm.Decimal` |
     */
    ConsumedQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActualQuantity` |
     * | Type | `Edm.Decimal` |
     */
    ActualQuantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ConsumptionDateTime` |
     * | Type | `Edm.DateTimeOffset` |
     */
    ConsumptionDateTime: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ExecutionGroupPhaseId` |
     * | Type | `Edm.Guid` |
     */
    ExecutionGroupPhaseId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderOperationId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderOperationId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderStepId` |
     * | Type | `Edm.Guid` |
     */
    WorkOrderStepId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MTUStateMachine` |
     * | Type | `Edm.String` |
     */
    MTUStateMachine: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MTUStatus` |
     * | Type | `Edm.String` |
     */
    MTUStatus: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentDM_MTUId` |
     * | Type | `Edm.Guid` |
     */
    ParentDM_MTUId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CurrentLocation` |
     * | Type | `Edm.String` |
     */
    CurrentLocation: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialSpecificationType` |
     * | Type | `Edm.String` |
     */
    MaterialSpecificationType: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DM_MaterialId` |
     * | Type | `Edm.Guid` |
     */
    DM_MaterialId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialId` |
     * | Type | `Edm.Guid` |
     */
    MaterialId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialNId` |
     * | Type | `Edm.String` |
     */
    MaterialNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialRevision` |
     * | Type | `Edm.String` |
     */
    MaterialRevision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedMaterialItemId` |
     * | Type | `Edm.Guid` |
     */
    ProducedMaterialItemId: string | null;
}

export interface UADMGetAllConsumedDM_MTUForProducedDM_MTU {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedDM_MTUId` |
     * | Type | `Edm.Guid` |
     */
    ProducedDM_MTUId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedMTUCode` |
     * | Type | `Edm.String` |
     */
    ProducedMTUCode: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedMaterialNId` |
     * | Type | `Edm.String` |
     */
    ProducedMaterialNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ProducedMaterialRevision` |
     * | Type | `Edm.String` |
     */
    ProducedMaterialRevision: string | null;
}

export interface IQueryable {
}

export interface APPMain_GF_GetBomItemsResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DocumentId` |
     * | Type | `Edm.Guid` |
     */
    DocumentId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Material` |
     * | Type | `Edm.String` |
     */
    Material: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BOMItem` |
     * | Type | `Edm.String` |
     */
    BOMItem: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoM` |
     * | Type | `Edm.String` |
     */
    UoM: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Traceable` |
     * | Type | `Edm.Boolean` |
     */
    Traceable: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Description` |
     * | Type | `Edm.String` |
     */
    Description: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentBOM` |
     * | Type | `Edm.Guid` |
     */
    ParentBOM: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `CreatedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    CreatedOn: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaterialId` |
     * | Type | `Edm.Guid` |
     */
    MaterialId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BOM` |
     * | Type | `Edm.String` |
     */
    BOM: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FinalMaterial` |
     * | Type | `Edm.String` |
     */
    FinalMaterial: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FinalMaterialId` |
     * | Type | `Edm.Guid` |
     */
    FinalMaterialId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IsRoot` |
     * | Type | `Edm.Boolean` |
     */
    IsRoot: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `BomId` |
     * | Type | `Edm.Guid` |
     */
    BomId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SubBomId` |
     * | Type | `Edm.Guid` |
     */
    SubBomId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `PositionNumber` |
     * | Type | `Edm.String` |
     */
    PositionNumber: string | null;
}

export interface APPMain_GF_GetBomItems {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkOrderNId` |
     * | Type | `Edm.String` |
     */
    WorkOrderNId: string | null;
}

export interface FileType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `contents` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    contents: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `type` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    type: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `name` |
     * | Type | `Edm.String` |
     * | Nullable | `false` |
     */
    name: string;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `data` |
     * | Type | `Edm.String` |
     */
    data: string | null;
}

export interface ToolAGW_ToolOnWorkplaceResponse {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkplaceNId` |
     * | Type | `Edm.String` |
     */
    WorkplaceNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkplaceName` |
     * | Type | `Edm.String` |
     */
    WorkplaceName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkplaceDescription` |
     * | Type | `Edm.String` |
     */
    WorkplaceDescription: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolDefinitionNId` |
     * | Type | `Edm.String` |
     */
    ToolDefinitionNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolDefinitionLogisticClass` |
     * | Type | `Edm.String` |
     */
    ToolDefinitionLogisticClass: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AutomationNodeInstanceNIds` |
     * | Type | `Collection(Edm.String)` |
     */
    AutomationNodeInstanceNIds: Array<string>;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `WorkplaceId` |
     * | Type | `Edm.Guid` |
     */
    WorkplaceId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.Guid` |
     */
    Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `LevelNId` |
     * | Type | `Edm.String` |
     */
    LevelNId: string | null;
}

export interface ToolAGW_ToolOnWorkplace {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ToolId` |
     * | Type | `Edm.Guid` |
     * | Nullable | `false` |
     */
    ToolId: string;
}

export interface BaseResponse extends CommandResponse {
}

export interface SignerValueType_Siemens_SimaticIT_MasterData_ES_MS_MSModel_Types {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Type` |
     * | Type | `Siemens.SimaticIT.MasterData.ES_MS.MSModel.Types.ReadingModel.SignatureTypeEnum` |
     */
    Type: SignatureTypeEnum | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.String` |
     */
    Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FullName` |
     * | Type | `Edm.String` |
     */
    FullName: string | null;
}

export interface ScenarioConfigurationValueType_Siemens_SimaticIT_MasterData_ES_MS_MSModel_Types {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ActionLabel` |
     * | Type | `Edm.String` |
     */
    ActionLabel: string | null;
}

export interface MaterialValueType_Siemens_SimaticIT_UADM_MasterData_FB_MS_MAT_MSModel_Types {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UId` |
     * | Type | `Edm.String` |
     */
    UId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     */
    Revision: string | null;
}

export interface ActivationStatus_Siemens_SimaticIT_MasterData_ATN_MS_MSModel_Types {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Dirty` |
     * | Type | `Edm.Boolean` |
     */
    Dirty: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Activated` |
     * | Type | `Edm.Boolean` |
     */
    Activated: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Ready` |
     * | Type | `Edm.Boolean` |
     */
    Ready: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Dismissed` |
     * | Type | `Edm.Boolean` |
     */
    Dismissed: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ConfirmedOn` |
     * | Type | `Edm.DateTimeOffset` |
     */
    ConfirmedOn: string | null;
}

export interface TagAspectType_Siemens_SimaticIT_MasterData_ATN_MS_MSModel_Types {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ChannelNId` |
     * | Type | `Edm.String` |
     */
    ChannelNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Address` |
     * | Type | `Edm.String` |
     */
    Address: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AcquisitionCycleNId` |
     * | Type | `Edm.String` |
     */
    AcquisitionCycleNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DeltaValue` |
     * | Type | `Edm.Int64` |
     */
    DeltaValue: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SmoothingMode` |
     * | Type | `Siemens.SimaticIT.MasterData.ATN_MS.MSModel.Types.ReadingModel.TagSmoothingMode` |
     */
    SmoothingMode: TagSmoothingMode | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AcquisitionMode` |
     * | Type | `Siemens.SimaticIT.MasterData.ATN_MS.MSModel.Types.ReadingModel.TagAcquisitionMode` |
     */
    AcquisitionMode: TagAcquisitionMode | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AddressType` |
     * | Type | `Siemens.SimaticIT.MasterData.ATN_MS.MSModel.Types.ReadingModel.TagAddressType` |
     */
    AddressType: TagAddressType | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Delta` |
     * | Type | `Edm.Decimal` |
     */
    Delta: number | null;
}

export interface WorkInstructionDesignValueType_Siemens_SimaticIT_MasterData_WI_MS_MSModel_Types {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Model` |
     * | Type | `Edm.String` |
     */
    Model: string | null;
}

export interface DesignValueType_Siemens_SimaticIT_MasterData_BPF_MS_MSModel_Types {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Model` |
     * | Type | `Edm.String` |
     */
    Model: string | null;
}

export interface ATNInstanceValueType_Siemens_SimaticIT_U4DM_MasterData_FB_MS_AGWInt_MSModel_Types {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `EquipmentNId` |
     * | Type | `Edm.String` |
     */
    EquipmentNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ATNInstanceNId` |
     * | Type | `Edm.String` |
     */
    ATNInstanceNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ATNInstanceParameterNId` |
     * | Type | `Edm.String` |
     */
    ATNInstanceParameterNId: string | null;
}

export interface ToolDefinitionValueType_Siemens_SimaticIT_U4DM_MasterData_FB_MS_AGWInt_MSModel_Types {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     */
    Revision: string | null;
}

export interface MaterialType_Siemens_SimaticIT_U4DM_MasterData_FB_MS_Container_MSModel_Types {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Revision` |
     * | Type | `Edm.String` |
     */
    Revision: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UId` |
     * | Type | `Edm.String` |
     */
    UId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoMNId` |
     * | Type | `Edm.String` |
     */
    UoMNId: string | null;
}

export interface BoMType_Siemens_SimaticIT_U4DM_OperationalData_Runtime_OPModel_Types {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Version` |
     * | Type | `Edm.String` |
     */
    Version: string | null;
}

export interface TaskFlowType_Siemens_SimaticIT_OperationalData_TSK_OP_OPModel_Types {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Sequence` |
     * | Type | `Edm.Int32` |
     */
    Sequence: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MaxIterations` |
     * | Type | `Edm.Int32` |
     */
    MaxIterations: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `IterationGroupId` |
     * | Type | `Edm.Guid` |
     */
    IterationGroupId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContinueOnSuccess` |
     * | Type | `Edm.Boolean` |
     */
    ContinueOnSuccess: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ContinueOnFailure` |
     * | Type | `Edm.Boolean` |
     */
    ContinueOnFailure: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TaskFlow` |
     * | Type | `Edm.String` |
     */
    TaskFlow: string | null;
}

export interface ATNAcquisitionHistoryAssociationValueType_Siemens_SimaticIT_U4DM_OperationalData_FB_OP_AGWInt_OPModel_Types {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ATNNodeId` |
     * | Type | `Edm.String` |
     */
    ATNNodeId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ATNParameterName` |
     * | Type | `Edm.String` |
     */
    ATNParameterName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ATNParameterQualityStatus` |
     * | Type | `Edm.String` |
     */
    ATNParameterQualityStatus: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ATNParameterTimestamp` |
     * | Type | `Edm.DateTimeOffset` |
     */
    ATNParameterTimestamp: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ATNParameterValue` |
     * | Type | `Edm.String` |
     */
    ATNParameterValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `DSParameterNId` |
     * | Type | `Edm.String` |
     */
    DSParameterNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `AcquiredFromShopfloorDate` |
     * | Type | `Edm.DateTimeOffset` |
     */
    AcquiredFromShopfloorDate: string | null;
}

export interface ATNTransmissionHistoryAssociationValueType_Siemens_SimaticIT_U4DM_OperationalData_FB_OP_AGWInt_OPModel_Types {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ATNNodeId` |
     * | Type | `Edm.String` |
     */
    ATNNodeId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ATNParameterName` |
     * | Type | `Edm.String` |
     */
    ATNParameterName: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointItemNId` |
     * | Type | `Edm.String` |
     */
    SetPointItemNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointItemValue` |
     * | Type | `Edm.String` |
     */
    SetPointItemValue: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `TransmissionSucceeded` |
     * | Type | `Edm.Boolean` |
     */
    TransmissionSucceeded: boolean | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ATNParameterTimestamp` |
     * | Type | `Edm.DateTimeOffset` |
     */
    ATNParameterTimestamp: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ATNParameterQualityStatus` |
     * | Type | `Edm.String` |
     */
    ATNParameterQualityStatus: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `SetPointNId` |
     * | Type | `Edm.String` |
     */
    SetPointNId: string | null;
}

export interface MTUAggregateContent_Siemens_SimaticIT_U4DM_OperationalData_FB_OP_Container_OPModel_Types {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MTUNId` |
     * | Type | `Edm.String` |
     */
    MTUNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Quantity` |
     * | Type | `Edm.Decimal` |
     */
    Quantity: number | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `ParentMTUNId` |
     * | Type | `Edm.String` |
     */
    ParentMTUNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MTUCode` |
     * | Type | `Edm.String` |
     */
    MTUCode: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `MTUName` |
     * | Type | `Edm.String` |
     */
    MTUName: string | null;
}

export interface QuantityType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `UoMNId` |
     * | Type | `Edm.String` |
     */
    UoMNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `QuantityValue` |
     * | Type | `Edm.Decimal` |
     */
    QuantityValue: number | null;
}

export interface StatusType {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StateMachineNId` |
     * | Type | `Edm.String` |
     */
    StateMachineNId: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `StatusNId` |
     * | Type | `Edm.String` |
     */
    StatusNId: string | null;
}

export interface SignerIdentityType_Siemens_SimaticIT_SystemData_ES_SD_SDModel_Types {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Id` |
     * | Type | `Edm.String` |
     */
    Id: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `Name` |
     * | Type | `Edm.String` |
     */
    Name: string | null;
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `FullName` |
     * | Type | `Edm.String` |
     */
    FullName: string | null;
}

export interface ScenarioInstanceValueType_Siemens_SimaticIT_SystemData_ES_SD_SDModel_Types {
    /**
     *
     * OData Attributes:
     * |Attribute Name | Attribute Value |
     * | --- | ---|
     * | Name | `NId` |
     * | Type | `Edm.String` |
     */
    NId: string | null;
}

export interface UADMGetAllReasons2Params {
    function?: UADMGetAllReasons | null;
}

export interface UADMGetExecutionGroupList2Params {
    function?: UADMGetExecutionGroupList | null;
}

export interface UADMGetExecutionGroupHistory2Params {
    function?: UADMGetExecutionGroupHistory | null;
}

export interface UADMGetAllExecutionGroupPhasesWithLinkedPJF2Params {
    function?: UADMGetAllExecutionGroupPhasesWithLinkedPJF | null;
}

export interface UADMGetAllToBeUsedMachineForSetWKCHold2Params {
    function?: UADMGetAllToBeUsedMachineForSetWKCHold | null;
}

export interface APPMain_GF_GetBomItems2Params {
    function?: APPMain_GF_GetBomItems | null;
}

export interface UADMGetDefectOrFailure2Params {
    function?: UADMGetDefectOrFailure | null;
}

export interface UADMGetNonConformanceContainerMTU2Params {
    function?: UADMGetNonConformanceContainerMTU | null;
}

export interface UADMGetContainerToWorkOrderLink2Params {
    function?: UADMGetContainerToWorkOrderLink | null;
}

export interface UADMGetAllDM_MaterialTrackingUnitToAssignWorkOrder2Params {
    function?: UADMGetAllDM_MaterialTrackingUnitToAssignWorkOrder | null;
}

export interface UADMGetExecutionGroupsForWorkOrder2Params {
    function?: UADMGetExecutionGroupsForWorkOrder | null;
}

export interface UADMGetEquipmentAndRelatedOperations2Params {
    function?: UADMGetEquipmentAndRelatedOperations | null;
}

export interface UADMGetAllEquipmentsAndRelatedOperations2Params {
    function?: UADMGetAllEquipmentsAndRelatedOperations | null;
}

export interface UADMGetWorkOrderOutMsgFile2Params {
    function?: UADMGetWorkOrderOutMsgFile | null;
}

export interface UADMGetBuyoffNonConformances2Params {
    function?: UADMGetBuyoffNonConformances | null;
}

export interface UADMGetSignersFromBuyOffHistory2Params {
    function?: UADMGetSignersFromBuyOffHistory | null;
}

export interface UADMGetWIDetailsForWorkOrderOperationAndStep2Params {
    function?: UADMGetWIDetailsForWorkOrderOperationAndStep | null;
}

export interface UADMGetContainerTobeConsumedMTUs2Params {
    function?: UADMGetContainerTobeConsumedMTUs | null;
}

export interface UADMGetMTUFromBufferForToBeConsumedBatchMaterials2Params {
    function?: UADMGetMTUFromBufferForToBeConsumedBatchMaterials | null;
}

export interface UADMGetActualConsumedMaterialForGenealogy2Params {
    function?: UADMGetActualConsumedMaterialForGenealogy | null;
}

export interface UADMGetEventLogs2Params {
    function?: UADMGetEventLogs | null;
}

export interface UADMGetAllMaterialDefinitionDocuments2Params {
    function?: UADMGetAllMaterialDefinitionDocuments | null;
}

export interface UADMGetDataFromFeatures2Params {
    function?: UADMGetDataFromFeatures | null;
}

export interface UADMGetAllTasks2Params {
    function?: UADMGetAllTasks | null;
}

export interface UADMGetWIDetailsForEgPhase2Params {
    function?: UADMGetWIDetailsForEgPhase | null;
}

export interface UADMGetScrewingDetails2Params {
    function?: UADMGetScrewingDetails | null;
}

export interface UADMGetScrewingHistoryFromMaterialTrackingUnit2Params {
    function?: UADMGetScrewingHistoryFromMaterialTrackingUnit | null;
}

export interface UADMGetAllDocumentsFromNonConformanceId2Params {
    function?: UADMGetAllDocumentsFromNonConformanceId | null;
}

export interface UADMGetExecutionGroupListWithEstimatedDuration2Params {
    function?: UADMGetExecutionGroupListWithEstimatedDuration | null;
}

export interface UADMGetAllMaterialForPrekit2Params {
    function?: UADMGetAllMaterialForPrekit | null;
}

export interface UADMGetItlkParametersDetails2Params {
    function?: UADMGetItlkParametersDetails | null;
}

export interface DM_MaterialAndMaterial2Params {
    function?: DM_MaterialAndMaterial | null;
}

export interface UADMGetItlkCheckHistoryParamValues2Params {
    function?: UADMGetItlkCheckHistoryParamValues | null;
}

export interface UADMGetFullEquipment2Params {
    function?: UADMGetFullEquipment | null;
}

export interface UADMGetAllProcessMachines2Params {
    function?: UADMGetAllProcessMachines | null;
}

export interface UADMGetAllItlkCheckWOOpAssociation2Params {
    function?: UADMGetAllItlkCheckWOOpAssociation | null;
}

export interface UADMGetAllItlkCheckProcessToOpLinkAssociation2Params {
    function?: UADMGetAllItlkCheckProcessToOpLinkAssociation | null;
}

export interface UADMGetEquipmentForToBeUsedMachine2Params {
    function?: UADMGetEquipmentForToBeUsedMachine | null;
}

export interface UADMGetEquipmentForEqSpecification2Params {
    function?: UADMGetEquipmentForEqSpecification | null;
}

export interface UADM_DMMaterialTrackingUnitAndMTU2Params {
    function?: UADM_DMMaterialTrackingUnitAndMTU | null;
}

export interface UADMGetAllToolCompatibleMachines2Params {
    function?: UADMGetAllToolCompatibleMachines | null;
}

export interface UADMGetLinkableEquipment2Params {
    function?: UADMGetLinkableEquipment | null;
}

export interface UADMGetAllToolDefinitionCompatibleMachine2Params {
    function?: UADMGetAllToolDefinitionCompatibleMachine | null;
}

export interface UADMGetAllItlkCheckWOStepAssociation2Params {
    function?: UADMGetAllItlkCheckWOStepAssociation | null;
}

export interface UADMGetDefectGroupSpecifications2Params {
    function?: UADMGetDefectGroupSpecifications | null;
}

export interface UADMGetUnitsFromWorkCenter2Params {
    function?: UADMGetUnitsFromWorkCenter | null;
}

export interface UADMGetUnitsFromBufferLocation2Params {
    function?: UADMGetUnitsFromBufferLocation | null;
}

export interface UADMGetCharacteristicRepresentation2Params {
    function?: UADMGetCharacteristicRepresentation | null;
}

export interface UADMGetAlternativeGroupsFromWorkOrderId2Params {
    function?: UADMGetAlternativeGroupsFromWorkOrderId | null;
}

export interface UADMGetQualityInspectionSamples2Params {
    function?: UADMGetQualityInspectionSamples | null;
}

export interface UADMGetUnitsFromPlant2Params {
    function?: UADMGetUnitsFromPlant | null;
}

export interface UADMGetQualityForGenealogy2Params {
    function?: UADMGetQualityForGenealogy | null;
}

export interface UADMGetStartableItemsOnWOStep2Params {
    function?: UADMGetStartableItemsOnWOStep | null;
}

export interface UADMGetCompletableItemsOnWOStep2Params {
    function?: UADMGetCompletableItemsOnWOStep | null;
}

export interface UADMGetAllPrintJobFiles2Params {
    function?: UADMGetAllPrintJobFiles | null;
}

export interface UADMGetAlternativeGroupsFromProcessId2Params {
    function?: UADMGetAlternativeGroupsFromProcessId | null;
}

export interface UADMGetPrintJobFilesFromAssociations2Params {
    function?: UADMGetPrintJobFilesFromAssociations | null;
}

export interface UADMGetWOByProcessRevision2Params {
    function?: UADMGetWOByProcessRevision | null;
}

export interface UADMGetStepForCatalog2Params {
    function?: UADMGetStepForCatalog | null;
}

export interface UADMGetAllEquipmentFor3DPrinter2Params {
    function?: UADMGetAllEquipmentFor3DPrinter | null;
}

export interface UADMGetAllToolDefinitionAutomationNodeType2Params {
    function?: UADMGetAllToolDefinitionAutomationNodeType | null;
}

export interface UADMGetAllToolAutomationNodeInstance2Params {
    function?: UADMGetAllToolAutomationNodeInstance | null;
}

export interface UADMGetToolDefinationsBySetPoint2Params {
    function?: UADMGetToolDefinationsBySetPoint | null;
}

export interface UADMGetToolBySetPoint2Params {
    function?: UADMGetToolBySetPoint | null;
}

export interface UADMGetDNCItemsFromAssociations2Params {
    function?: UADMGetDNCItemsFromAssociations | null;
}

export interface UADMGetOperationToStepLink2Params {
    function?: UADMGetOperationToStepLink | null;
}

export interface UADMGetWOSteps2Params {
    function?: UADMGetWOSteps | null;
}

export interface UADMGetAllWorkOrderPrintJobFileAssociation2Params {
    function?: UADMGetAllWorkOrderPrintJobFileAssociation | null;
}

export interface UADMGetBufferHistory2Params {
    function?: UADMGetBufferHistory | null;
}

export interface UADMGetAllMaterialDefinitionsForAllMaterialSpecificationTypes2Params {
    function?: UADMGetAllMaterialDefinitionsForAllMaterialSpecificationTypes | null;
}

export interface UADMGetCertificationDetails2Params {
    function?: UADMGetCertificationDetails | null;
}

export interface UADMGetWorkOrderHumanResourceDetails2Params {
    function?: UADMGetWorkOrderHumanResourceDetails | null;
}

export interface UADMGetOfflineSessionWOOperationAssociations2Params {
    function?: UADMGetOfflineSessionWOOperationAssociations | null;
}

export interface UADMGetMaterialSpecificationTypeIndicator2Params {
    function?: UADMGetMaterialSpecificationTypeIndicator | null;
}

export interface UADMGetAllOfflineSessions2Params {
    function?: UADMGetAllOfflineSessions | null;
}

export interface UADMGetProcessOperationDetails2Params {
    function?: UADMGetProcessOperationDetails | null;
}

export interface UADMGetProcessStepDetails2Params {
    function?: UADMGetProcessStepDetails | null;
}

export interface UADMGetAllDocumentsFromDM_MaterialTrackingUnitIds2Params {
    function?: UADMGetAllDocumentsFromDM_MaterialTrackingUnitIds | null;
}

export interface UADMGetSerialNumberStatusForGenealogy2Params {
    function?: UADMGetSerialNumberStatusForGenealogy | null;
}

export interface UADMGetAllConsumedDM_MTUForProducedDM_MTU2Params {
    function?: UADMGetAllConsumedDM_MTUForProducedDM_MTU | null;
}

export interface ToolAGW_ToolOnWorkplace2Params {
    function?: ToolAGW_ToolOnWorkplace | null;
}

export interface UADMDeleteWorkOperationTypeList2Params {
    command?: UADMDeleteWorkOperationTypeList | null;
}

export interface UADMStartOperation2Params {
    command?: UADMStartOperation | null;
}

export interface UADMUpdateWOByBoPList2Params {
    command?: UADMUpdateWOByBoPList | null;
}

export interface UADMStartWOOperationTransferBatchList2Params {
    command?: UADMStartWOOperationTransferBatchList | null;
}

export interface UADMConsumeMaterialItemList2Params {
    command?: UADMConsumeMaterialItemList | null;
}

export interface UADMSentenceNonConformance2Params {
    command?: UADMSentenceNonConformance | null;
}

export interface UADMCreateNonConformance2Params {
    command?: UADMCreateNonConformance | null;
}

export interface AcceptBuyOff2Params {
    command?: AcceptBuyOff | null;
}

export interface RejectBuyOff2Params {
    command?: RejectBuyOff | null;
}

export interface UADMCreateWorkOrdersFromAsPlannedBOP2Params {
    command?: UADMCreateWorkOrdersFromAsPlannedBOP | null;
}

export interface UADMCreateTravellingWork2Params {
    command?: UADMCreateTravellingWork | null;
}

export interface UADMTakeOwnershipTravellingWork2Params {
    command?: UADMTakeOwnershipTravellingWork | null;
}

export interface UADMAcceptTravellingWork2Params {
    command?: UADMAcceptTravellingWork | null;
}

export interface UADMStartWOOperationSerializedList2Params {
    command?: UADMStartWOOperationSerializedList | null;
}

export interface UADMSetWorkOrderOperationFutureHoldList2Params {
    command?: UADMSetWorkOrderOperationFutureHoldList | null;
}

export interface UADMCreateChangeNonConformance2Params {
    command?: UADMCreateChangeNonConformance | null;
}

export interface UADMAbortWorkOrder2Params {
    command?: UADMAbortWorkOrder | null;
}

export interface UADMVerifyWorkOrder2Params {
    command?: UADMVerifyWorkOrder | null;
}

export interface UADMSetWorkOrderHoldList2Params {
    command?: UADMSetWorkOrderHoldList | null;
}

export interface UADMRemoveWorkOrderOperationFutureHoldList2Params {
    command?: UADMRemoveWorkOrderOperationFutureHoldList | null;
}

export interface UADMCompleteWOOperationSerializedList2Params {
    command?: UADMCompleteWOOperationSerializedList | null;
}

export interface UADMUnVerifyWorkOrder2Params {
    command?: UADMUnVerifyWorkOrder | null;
}

export interface UADMCreateAndAssignProducedMaterialItems2Params {
    command?: UADMCreateAndAssignProducedMaterialItems | null;
}

export interface UADMCompleteWOStepList2Params {
    command?: UADMCompleteWOStepList | null;
}

export interface UADMStartWOStep2Params {
    command?: UADMStartWOStep | null;
}

export interface UADMAcceptChangeRepeatOperation2Params {
    command?: UADMAcceptChangeRepeatOperation | null;
}

export interface UADMAcceptChangeAddToBeConsumedMaterial2Params {
    command?: UADMAcceptChangeAddToBeConsumedMaterial | null;
}

export interface UADMAcceptChangeAddDCDRuntimeTask2Params {
    command?: UADMAcceptChangeAddDCDRuntimeTask | null;
}

export interface UADMAcceptChangeAddOperation2Params {
    command?: UADMAcceptChangeAddOperation | null;
}

export interface UADMAcceptChangeChangeDependency2Params {
    command?: UADMAcceptChangeChangeDependency | null;
}

export interface UADMAcceptChangeChangeToBeConsumedMaterialQuantity2Params {
    command?: UADMAcceptChangeChangeToBeConsumedMaterialQuantity | null;
}

export interface UADMAcceptChangeChangeToBeUsedMachine2Params {
    command?: UADMAcceptChangeChangeToBeUsedMachine | null;
}

export interface UADMAcceptChangeRemoveDependency2Params {
    command?: UADMAcceptChangeRemoveDependency | null;
}

export interface UADMAcceptChangeRemoveOperation2Params {
    command?: UADMAcceptChangeRemoveOperation | null;
}

export interface UADMAcceptChangeRemoveToBeConsumedMaterial2Params {
    command?: UADMAcceptChangeRemoveToBeConsumedMaterial | null;
}

export interface UADMAcceptChangeReplaceToBeConsumedMaterial2Params {
    command?: UADMAcceptChangeReplaceToBeConsumedMaterial | null;
}

export interface UADMRejectChangeNonConformance2Params {
    command?: UADMRejectChangeNonConformance | null;
}

export interface UADMCreateReworkCodeList2Params {
    command?: UADMCreateReworkCodeList | null;
}

export interface UADMSentenceNonConformanceSetLocationHold2Params {
    command?: UADMSentenceNonConformanceSetLocationHold | null;
}

export interface UADMManageToBeConsumedMaterialDisassemble2Params {
    command?: UADMManageToBeConsumedMaterialDisassemble | null;
}

export interface UADMSplitWorkOrder2Params {
    command?: UADMSplitWorkOrder | null;
}

export interface UADMSkipWOOperationFullQty2Params {
    command?: UADMSkipWOOperationFullQty | null;
}

export interface UADMSkipWOOperationTransferBatch2Params {
    command?: UADMSkipWOOperationTransferBatch | null;
}

export interface UADMSkipWOOperationSerialized2Params {
    command?: UADMSkipWOOperationSerialized | null;
}

export interface UADMSentenceNonConformancePartially2Params {
    command?: UADMSentenceNonConformancePartially | null;
}

export interface UADMGetActiveUserListOnWorkOrderOperation2Params {
    command?: UADMGetActiveUserListOnWorkOrderOperation | null;
}

export interface UADMCreateSnagAndNoteList2Params {
    command?: UADMCreateSnagAndNoteList | null;
}

export interface UADMConfirmSnagAndNoteList2Params {
    command?: UADMConfirmSnagAndNoteList | null;
}

export interface UADMUseTool2Params {
    command?: UADMUseTool | null;
}

export interface UADMSaveDCDRuntimeTaskValues2Params {
    command?: UADMSaveDCDRuntimeTaskValues | null;
}

export interface UADMCheckDCDRuntimeValues2Params {
    command?: UADMCheckDCDRuntimeValues | null;
}

export interface UADMSetLocationHold2Params {
    command?: UADMSetLocationHold | null;
}

export interface UADMDisassembleMaterialItem2Params {
    command?: UADMDisassembleMaterialItem | null;
}

export interface UADMExportGenealogy2Params {
    command?: UADMExportGenealogy | null;
}

export interface UADMCreateNewMaterialDefinitionRevision2Params {
    command?: UADMCreateNewMaterialDefinitionRevision | null;
}

export interface UADMDisAssignProducedMaterialitems2Params {
    command?: UADMDisAssignProducedMaterialitems | null;
}

export interface UADMImportLifecycle2Params {
    command?: UADMImportLifecycle | null;
}

export interface UADMSaveDocumentForPreview2Params {
    command?: UADMSaveDocumentForPreview | null;
}

export interface UADMAcceptChangeAddProcessOperation2Params {
    command?: UADMAcceptChangeAddProcessOperation | null;
}

export interface UADMDeleteEquipment2Params {
    command?: UADMDeleteEquipment | null;
}

export interface UADMRemoveWorkOrderScrap2Params {
    command?: UADMRemoveWorkOrderScrap | null;
}

export interface UADMEnableLocationMachineForCompleteByDifferentUser2Params {
    command?: UADMEnableLocationMachineForCompleteByDifferentUser | null;
}

export interface UADMCreateWorkOrderOperationFromProcessOperation2Params {
    command?: UADMCreateWorkOrderOperationFromProcessOperation | null;
}

export interface UADMCreateNonConformanceDefectList2Params {
    command?: UADMCreateNonConformanceDefectList | null;
}

export interface UADMCreateDefectTypeContextualization2Params {
    command?: UADMCreateDefectTypeContextualization | null;
}

export interface UADMCreateDefectGroupContextualization2Params {
    command?: UADMCreateDefectGroupContextualization | null;
}

export interface UADMAssignNonConformanceTransitionRoleList2Params {
    command?: UADMAssignNonConformanceTransitionRoleList | null;
}

export interface UADMRemoveNonConformanceTransitionRoleList2Params {
    command?: UADMRemoveNonConformanceTransitionRoleList | null;
}

export interface UADMRemoveDefectGroupContextualization2Params {
    command?: UADMRemoveDefectGroupContextualization | null;
}

export interface UADMRemoveDefectTypeContextualization2Params {
    command?: UADMRemoveDefectTypeContextualization | null;
}

export interface UADMAssignNonConformanceTransitionMailAddressList2Params {
    command?: UADMAssignNonConformanceTransitionMailAddressList | null;
}

export interface UADMRemoveNonConformanceTransitionMailAddressList2Params {
    command?: UADMRemoveNonConformanceTransitionMailAddressList | null;
}

export interface UADMCreatePrintJobFile2Params {
    command?: UADMCreatePrintJobFile | null;
}

export interface UADMImportAMPrintJobFile2Params {
    command?: UADMImportAMPrintJobFile | null;
}

export interface UADMCreateEquipmentSpecificationWithPrintJobFile2Params {
    command?: UADMCreateEquipmentSpecificationWithPrintJobFile | null;
}

export interface UADMEditPrintJobFile2Params {
    command?: UADMEditPrintJobFile | null;
}

export interface UADMTransferAMData2Params {
    command?: UADMTransferAMData | null;
}

export interface UADMAutoTransferAMData2Params {
    command?: UADMAutoTransferAMData | null;
}

export interface UADMCompleteWOOperationTransferBatchMultiMachineList2Params {
    command?: UADMCompleteWOOperationTransferBatchMultiMachineList | null;
}

export interface UADMDeletePrintJobFileList2Params {
    command?: UADMDeletePrintJobFileList | null;
}

export interface UADMCreatePrintJobFileList2Params {
    command?: UADMCreatePrintJobFileList | null;
}

export interface ImportAMPrintJobFile2Params {
    command?: ImportAMPrintJobFile | null;
}

export interface UADMPauseWorkOrderOperationMultiMachineList2Params {
    command?: UADMPauseWorkOrderOperationMultiMachineList | null;
}

export interface UADMCompleteWOOperationFullQtyMultiMachineList2Params {
    command?: UADMCompleteWOOperationFullQtyMultiMachineList | null;
}

export interface UADMDeleteToolDefinitionList2Params {
    command?: UADMDeleteToolDefinitionList | null;
}

export interface UADMCreateForm2Params {
    command?: UADMCreateForm | null;
}

export interface UADMGetPMI2Params {
    command?: UADMGetPMI | null;
}

export interface UADMSaveAsWorkInstruction2Params {
    command?: UADMSaveAsWorkInstruction | null;
}

export interface UADMAssociateFormsToTcM2Params {
    command?: UADMAssociateFormsToTcM | null;
}

export interface UADMChangeWorkInstructionStatus2Params {
    command?: UADMChangeWorkInstructionStatus | null;
}

export interface UADMCreateNewProcessRevision2Params {
    command?: UADMCreateNewProcessRevision | null;
}

export interface UADMUpdateNonConformance2Params {
    command?: UADMUpdateNonConformance | null;
}

export interface UADMSetWorkOrderForScheduling2Params {
    command?: UADMSetWorkOrderForScheduling | null;
}

export interface UADMReleaseWorkOrder2Params {
    command?: UADMReleaseWorkOrder | null;
}

export interface UADMAcceptChangeAddToBeUsedTool2Params {
    command?: UADMAcceptChangeAddToBeUsedTool | null;
}

export interface PLMCreateIssueReport2Params {
    command?: PLMCreateIssueReport | null;
}

export interface PLMCreateMasterPlan2Params {
    command?: PLMCreateMasterPlan | null;
}

export interface PLMCreateOperationList2Params {
    command?: PLMCreateOperationList | null;
}

export interface PLMCreateProcessList2Params {
    command?: PLMCreateProcessList | null;
}

export interface PLMCreateDocumentList2Params {
    command?: PLMCreateDocumentList | null;
}

export interface PLMCreateMaterialDefinitionList2Params {
    command?: PLMCreateMaterialDefinitionList | null;
}

export interface PLMCreateToolDefinitionList2Params {
    command?: PLMCreateToolDefinitionList | null;
}

export interface PLMCreateStepList2Params {
    command?: PLMCreateStepList | null;
}

export interface PLMAssociateDocumentToMaterialDefinitionList2Params {
    command?: PLMAssociateDocumentToMaterialDefinitionList | null;
}

export interface PLMAssociateDocumentToToolDefinitionList2Params {
    command?: PLMAssociateDocumentToToolDefinitionList | null;
}

export interface PLMAssociateDocumentToOperationList2Params {
    command?: PLMAssociateDocumentToOperationList | null;
}

export interface PLMAssociateDocumentToStepList2Params {
    command?: PLMAssociateDocumentToStepList | null;
}

export interface PLMCreateAsPlannedBoP2Params {
    command?: PLMCreateAsPlannedBoP | null;
}

export interface PLMLinkProcessToProcessFullList2Params {
    command?: PLMLinkProcessToProcessFullList | null;
}

export interface PLMLinkProcessToOperationFullList2Params {
    command?: PLMLinkProcessToOperationFullList | null;
}

export interface PLMLinkOperationToStepFullList2Params {
    command?: PLMLinkOperationToStepFullList | null;
}

export interface PLMCreateStepMaterialSpecificationFullList2Params {
    command?: PLMCreateStepMaterialSpecificationFullList | null;
}

export interface PLMCreateStepToolSpecificationFullList2Params {
    command?: PLMCreateStepToolSpecificationFullList | null;
}

export interface PLMCreateStepDependencyList2Params {
    command?: PLMCreateStepDependencyList | null;
}

export interface PLMCreateOperationEquipmentSpecLocationFullList2Params {
    command?: PLMCreateOperationEquipmentSpecLocationFullList | null;
}

export interface PLMCreateOperationMaterialSpecificationFullList2Params {
    command?: PLMCreateOperationMaterialSpecificationFullList | null;
}

export interface PLMCreateOperationToolSpecificationFullList2Params {
    command?: PLMCreateOperationToolSpecificationFullList | null;
}

export interface PLMCreateOpDependencyList2Params {
    command?: PLMCreateOpDependencyList | null;
}

export interface PLMSubmit2Params {
    command?: PLMSubmit | null;
}

export interface PLMSubmitMasterPlan2Params {
    command?: PLMSubmitMasterPlan | null;
}

export interface PLMRollback2Params {
    command?: PLMRollback | null;
}

export interface PLMRollbackMasterPlan2Params {
    command?: PLMRollbackMasterPlan | null;
}

export interface PLMCreateIssueReportResult2Params {
    command?: PLMCreateIssueReportResult | null;
}

export interface PLMCreateWorkOrderHeader2Params {
    command?: PLMCreateWorkOrderHeader | null;
}

export interface PLMCreateWorkOrderFromMasterPlanBOMResolution2Params {
    command?: PLMCreateWorkOrderFromMasterPlanBOMResolution | null;
}

export interface UADMCompleteAsPlannedBOP2Params {
    command?: UADMCompleteAsPlannedBOP | null;
}

export interface UpdateMaterialDefinition2Params {
    command?: UpdateMaterialDefinition | null;
}

export interface UADMDeleteBufferDefinitionList2Params {
    command?: UADMDeleteBufferDefinitionList | null;
}

export interface CopyToolDefinition2Params {
    command?: CopyToolDefinition | null;
}

export interface UADMUpdateToolDefinition2Params {
    command?: UADMUpdateToolDefinition | null;
}

export interface UADMDeleteMaterialDefinitions2Params {
    command?: UADMDeleteMaterialDefinitions | null;
}

export interface UADMDeleteAsPlannedBOPList2Params {
    command?: UADMDeleteAsPlannedBOPList | null;
}

export interface UADMLinkMaterialItemsToHandlingUnit2Params {
    command?: UADMLinkMaterialItemsToHandlingUnit | null;
}

export interface UADMLinkGenericItemsToNonConformance2Params {
    command?: UADMLinkGenericItemsToNonConformance | null;
}

export interface UADMUnLinkGenericItemsFromNonConformance2Params {
    command?: UADMUnLinkGenericItemsFromNonConformance | null;
}

export interface UADMCreateExecutionGroup2Params {
    command?: UADMCreateExecutionGroup | null;
}

export interface UADMCreateWorkOrderFromProcess2Params {
    command?: UADMCreateWorkOrderFromProcess | null;
}

export interface UADMLinkMaterialItemsToBuffer2Params {
    command?: UADMLinkMaterialItemsToBuffer | null;
}

export interface UADMAcceptChangeAddWorkInstruction2Params {
    command?: UADMAcceptChangeAddWorkInstruction | null;
}

export interface UADMDeleteSkillList2Params {
    command?: UADMDeleteSkillList | null;
}

export interface UADMStartNonProductiveActivityList2Params {
    command?: UADMStartNonProductiveActivityList | null;
}

export interface UADMCompleteNonProductiveActivityList2Params {
    command?: UADMCompleteNonProductiveActivityList | null;
}

export interface UADMDeleteNonProductiveActivityList2Params {
    command?: UADMDeleteNonProductiveActivityList | null;
}

export interface UADMDeleteOperationStepCategoryList2Params {
    command?: UADMDeleteOperationStepCategoryList | null;
}

export interface UADMLinkSkillsToTeam2Params {
    command?: UADMLinkSkillsToTeam | null;
}

export interface UADMCopyDM_Material2Params {
    command?: UADMCopyDM_Material | null;
}

export interface UADMUnLinkUsersFromTeam2Params {
    command?: UADMUnLinkUsersFromTeam | null;
}

export interface UADMLinkUsersToTeam2Params {
    command?: UADMLinkUsersToTeam | null;
}

export interface UADMDeleteDM_MaterialList2Params {
    command?: UADMDeleteDM_MaterialList | null;
}

export interface UADMDeleteCustomItlkCheckList2Params {
    command?: UADMDeleteCustomItlkCheckList | null;
}

export interface UADMDeleteCustomItlkCheckParameterList2Params {
    command?: UADMDeleteCustomItlkCheckParameterList | null;
}

export interface UADMRemoveHoldList2Params {
    command?: UADMRemoveHoldList | null;
}

export interface PLMCreateOperationDCDList2Params {
    command?: PLMCreateOperationDCDList | null;
}

export interface PLMCreateStepDCDList2Params {
    command?: PLMCreateStepDCDList | null;
}

export interface UADMRegisterNonProductiveActivityForUser2Params {
    command?: UADMRegisterNonProductiveActivityForUser | null;
}

export interface UADMDeleteNonProductiveActivityListForUser2Params {
    command?: UADMDeleteNonProductiveActivityListForUser | null;
}

export interface UADMUpdateNonProductiveActivityForUser2Params {
    command?: UADMUpdateNonProductiveActivityForUser | null;
}

export interface CancelScheduling2Params {
    command?: CancelScheduling | null;
}

export interface SetInScheduling2Params {
    command?: SetInScheduling | null;
}

export interface SetInScheduled2Params {
    command?: SetInScheduled | null;
}

export interface SetAlternativeSelected2Params {
    command?: SetAlternativeSelected | null;
}

export interface UADMAutomaticCreateNonConformanceOnMTUList2Params {
    command?: UADMAutomaticCreateNonConformanceOnMTUList | null;
}

export interface UADMAutomaticCreateNonConformanceOnWOOperation2Params {
    command?: UADMAutomaticCreateNonConformanceOnWOOperation | null;
}

export interface UADMAutomaticCreateNonConformanceOnEquipment2Params {
    command?: UADMAutomaticCreateNonConformanceOnEquipment | null;
}

export interface UADMAutomaticUseToolList2Params {
    command?: UADMAutomaticUseToolList | null;
}

export interface UADMAutomaticConsumeMaterialTrackingUnit2Params {
    command?: UADMAutomaticConsumeMaterialTrackingUnit | null;
}

export interface UADMCreateNonConformanceV3_12Params {
    command?: UADMCreateNonConformanceV3_1 | null;
}

export interface UADMSentenceNonConformanceV3_12Params {
    command?: UADMSentenceNonConformanceV3_1 | null;
}

export interface UADMAutomaticSentenceNonConformance2Params {
    command?: UADMAutomaticSentenceNonConformance | null;
}

export interface UADMCreateToBeUsedMachinePJF2Params {
    command?: UADMCreateToBeUsedMachinePJF | null;
}

export interface UADMDeleteStepList2Params {
    command?: UADMDeleteStepList | null;
}

export interface UADMAbruptlyCloseFlexibleWorkOrder2Params {
    command?: UADMAbruptlyCloseFlexibleWorkOrder | null;
}

export interface UADMLinkHumanResourceToProcess2Params {
    command?: UADMLinkHumanResourceToProcess | null;
}

export interface UADMUnlinkHumanResourceFromProcess2Params {
    command?: UADMUnlinkHumanResourceFromProcess | null;
}

export interface PLMCreateCertificationWithSkillList2Params {
    command?: PLMCreateCertificationWithSkillList | null;
}

export interface PLMCreateOperationHRSpecificationFullList2Params {
    command?: PLMCreateOperationHRSpecificationFullList | null;
}

export interface PLMCreateStepHRSpecificationFullList2Params {
    command?: PLMCreateStepHRSpecificationFullList | null;
}

export interface UADMDeleteDefectGroupList2Params {
    command?: UADMDeleteDefectGroupList | null;
}

export interface UADMDeleteDefectTypeList2Params {
    command?: UADMDeleteDefectTypeList | null;
}

export interface PLMCreateDM_MaterialTrackingUnitandMaterialTrackingUnitList2Params {
    command?: PLMCreateDM_MaterialTrackingUnitandMaterialTrackingUnitList | null;
}

export interface PLMChangeStatusEventLog2Params {
    command?: PLMChangeStatusEventLog | null;
}

export interface PLMDeleteEventLogList2Params {
    command?: PLMDeleteEventLogList | null;
}

export interface PLMChangeStatusEventLogList2Params {
    command?: PLMChangeStatusEventLogList | null;
}

export interface SetInScheduledNoBulk2Params {
    command?: SetInScheduledNoBulk | null;
}

export interface PLMCreateOperationDCDWI2Params {
    command?: PLMCreateOperationDCDWI | null;
}

export interface PLMCreateStepDCDWI2Params {
    command?: PLMCreateStepDCDWI | null;
}

export interface UADMAutomaticAcquireQualityInspectionData2Params {
    command?: UADMAutomaticAcquireQualityInspectionData | null;
}

export interface UADMAutomaticCreateSnagAndNote2Params {
    command?: UADMAutomaticCreateSnagAndNote | null;
}

export interface UADMConsumeMaterialItemOnContainer2Params {
    command?: UADMConsumeMaterialItemOnContainer | null;
}

export interface UADMReleaseWorkOrderList2Params {
    command?: UADMReleaseWorkOrderList | null;
}

export interface CreateBoMItem2Params {
    command?: CreateBoMItem | null;
}

export interface SentenceNonConformance2Params {
    command?: SentenceNonConformance | null;
}

export interface UpdateSkill2Params {
    command?: UpdateSkill | null;
}

export interface SetWorkOrderHold2Params {
    command?: SetWorkOrderHold | null;
}

export interface TriggerPrintingOnWorkOrderOperation2Params {
    command?: TriggerPrintingOnWorkOrderOperation | null;
}

export interface SetNonConformanceStatusIsFrozen2Params {
    command?: SetNonConformanceStatusIsFrozen | null;
}

export interface DeleteMaterialsTrackingUnit2Params {
    command?: DeleteMaterialsTrackingUnit | null;
}

export interface DeleteToolSpecificationList2Params {
    command?: DeleteToolSpecificationList | null;
}

export interface UnlinkAMMachineToMES2Params {
    command?: UnlinkAMMachineToMES | null;
}

export interface CreateToBeUsedMachinePJF2Params {
    command?: CreateToBeUsedMachinePJF | null;
}

export interface LinkItlkCheckToOperationToStepLinkList2Params {
    command?: LinkItlkCheckToOperationToStepLinkList | null;
}

export interface DeleteUoM2Params {
    command?: DeleteUoM | null;
}

export interface SetToBeCollectedDocument2Params {
    command?: SetToBeCollectedDocument | null;
}

export interface InitializeCreatedTask2Params {
    command?: InitializeCreatedTask | null;
}

export interface StartWOOperationSerialized2Params {
    command?: StartWOOperationSerialized | null;
}

export interface UnlinkDocumentListToDM_MaterialTrackingUnit2Params {
    command?: UnlinkDocumentListToDM_MaterialTrackingUnit | null;
}

export interface TCM2CreateResourceDefinitionList2Params {
    command?: TCM2CreateResourceDefinitionList | null;
}

export interface GetBufferWithActualQuantity2Params {
    command?: GetBufferWithActualQuantity | null;
}

export interface DeleteToolDefinitionDocumentList2Params {
    command?: DeleteToolDefinitionDocumentList | null;
}

export interface SaveWorkInstructionDesign2Params {
    command?: SaveWorkInstructionDesign | null;
}

export interface UnlinkSubstrateDefinitionToMachine2Params {
    command?: UnlinkSubstrateDefinitionToMachine | null;
}

export interface LinkWIDefinitionsToWOStep2Params {
    command?: LinkWIDefinitionsToWOStep | null;
}

export interface LockWorkInstructionDefinition2Params {
    command?: LockWorkInstructionDefinition | null;
}

export interface CreateEquipmentGraphConfiguration2Params {
    command?: CreateEquipmentGraphConfiguration | null;
}

export interface AssociateDNCItemMachineMaterialAssociation2Params {
    command?: AssociateDNCItemMachineMaterialAssociation | null;
}

export interface TCM2LinkOperationToStepList2Params {
    command?: TCM2LinkOperationToStepList | null;
}

export interface DeleteCustomItlkCheckParameterList2Params {
    command?: DeleteCustomItlkCheckParameterList | null;
}

export interface CreateTeam2Params {
    command?: CreateTeam | null;
}

export interface DeleteProcessToOpLinkDependencyNavigationList2Params {
    command?: DeleteProcessToOpLinkDependencyNavigationList | null;
}

export interface UpdateOperation2Params {
    command?: UpdateOperation | null;
}

export interface CreateEquipmentType2Params {
    command?: CreateEquipmentType | null;
}

export interface EditWorkOrderHumanResource2Params {
    command?: EditWorkOrderHumanResource | null;
}

export interface AssignNonConformanceTransitionMailAddressList2Params {
    command?: AssignNonConformanceTransitionMailAddressList | null;
}

export interface SplitWorkOrder2Params {
    command?: SplitWorkOrder | null;
}

export interface CreateVariableCharacteristicSpecification2Params {
    command?: CreateVariableCharacteristicSpecification | null;
}

export interface DeleteHold2Params {
    command?: DeleteHold | null;
}

export interface CreateDM_MaterialTrackingUnitHistoryList2Params {
    command?: CreateDM_MaterialTrackingUnitHistoryList | null;
}

export interface DeleteSkillList2Params {
    command?: DeleteSkillList | null;
}

export interface CreateStatusTransitionDefinition2Params {
    command?: CreateStatusTransitionDefinition | null;
}

export interface UnlinkCharacteristicRepresentationToStep2Params {
    command?: UnlinkCharacteristicRepresentationToStep | null;
}

export interface DeleteActualUsedMachine2Params {
    command?: DeleteActualUsedMachine | null;
}

export interface UADMCreateDocument2Params {
    command?: UADMCreateDocument | null;
}

export interface CreateBoMItemV4_02Params {
    command?: CreateBoMItemV4_0 | null;
}

export interface RejectMaterialRequest2Params {
    command?: RejectMaterialRequest | null;
}

export interface MaterialItemSplitBatchByPartialPreview2Params {
    command?: MaterialItemSplitBatchByPartialPreview | null;
}

export interface UpdateDM_Material2Params {
    command?: UpdateDM_Material | null;
}

export interface UADMCreateToolDefinition2Params {
    command?: UADMCreateToolDefinition | null;
}

export interface DeleteTeam2Params {
    command?: DeleteTeam | null;
}

export interface UpdateItlkCheckWOOpAssociationList2Params {
    command?: UpdateItlkCheckWOOpAssociationList | null;
}

export interface ExecuteCustomItlkCheckOutbound2Params {
    command?: ExecuteCustomItlkCheckOutbound | null;
}

export interface CreateEquipmentSpecification2Params {
    command?: CreateEquipmentSpecification | null;
}

export interface SetWorkProcessToBeCleaned2Params {
    command?: SetWorkProcessToBeCleaned | null;
}

export interface AutoGenerateSerialNumberCodes2Params {
    command?: AutoGenerateSerialNumberCodes | null;
}

export interface LinkUserToWorkOrderOperationList2Params {
    command?: LinkUserToWorkOrderOperationList | null;
}

export interface CreateResultTypeList2Params {
    command?: CreateResultTypeList | null;
}

export interface AssignProducedMaterialItems2Params {
    command?: AssignProducedMaterialItems | null;
}

export interface DeleteFutureHoldAfterNonConformanceSentencing2Params {
    command?: DeleteFutureHoldAfterNonConformanceSentencing | null;
}

export interface DeleteActiveUserOnMachine2Params {
    command?: DeleteActiveUserOnMachine | null;
}

export interface CreateWorkInstructionDefinition2Params {
    command?: CreateWorkInstructionDefinition | null;
}

export interface UploadOfflineActionList2Params {
    command?: UploadOfflineActionList | null;
}

export interface APSSetAlternativeSelected2Params {
    command?: APSSetAlternativeSelected | null;
}

export interface UpdateDNCItemMachineMaterialAssociation2Params {
    command?: UpdateDNCItemMachineMaterialAssociation | null;
}

export interface UADMUpdateOperation2Params {
    command?: UADMUpdateOperation | null;
}

export interface TriggerPrintingOnWorkOrder2Params {
    command?: TriggerPrintingOnWorkOrder | null;
}

export interface TCM2LinkProcessToProcessList2Params {
    command?: TCM2LinkProcessToProcessList | null;
}

export interface AdministrativePause2Params {
    command?: AdministrativePause | null;
}

export interface CheckInUploadDocuments2Params {
    command?: CheckInUploadDocuments | null;
}

export interface DeleteStatusBehaviorDefinition2Params {
    command?: DeleteStatusBehaviorDefinition | null;
}

export interface CreateMaterialSpecification2Params {
    command?: CreateMaterialSpecification | null;
}

export interface UnlinkDocumentListToStep2Params {
    command?: UnlinkDocumentListToStep | null;
}

export interface CreateWorkOrderOutMsg2Params {
    command?: CreateWorkOrderOutMsg | null;
}

export interface LinkSkillsToCertificate2Params {
    command?: LinkSkillsToCertificate | null;
}

export interface CreateNewOperationRevisionInCatalogue2Params {
    command?: CreateNewOperationRevisionInCatalogue | null;
}

export interface DeleteNonProductiveActivityListForUser2Params {
    command?: DeleteNonProductiveActivityListForUser | null;
}

export interface TCM2CreateMaterialSpecificationList2Params {
    command?: TCM2CreateMaterialSpecificationList | null;
}

export interface TraceNonConformanceOnContainer2Params {
    command?: TraceNonConformanceOnContainer | null;
}

export interface CreateDocumentListFormFileIds2Params {
    command?: CreateDocumentListFormFileIds | null;
}

export interface TCM2CreateToolSpecificationList2Params {
    command?: TCM2CreateToolSpecificationList | null;
}

export interface TCM2CreateStepDependencyList2Params {
    command?: TCM2CreateStepDependencyList | null;
}

export interface LinkSkillsToWorkOrderStep2Params {
    command?: LinkSkillsToWorkOrderStep | null;
}

export interface LinkItlkCheckToOperationStepCategoryList2Params {
    command?: LinkItlkCheckToOperationStepCategoryList | null;
}

export interface TCM2AssociateDocumentToOperationList2Params {
    command?: TCM2AssociateDocumentToOperationList | null;
}

export interface StartWOStep2Params {
    command?: StartWOStep | null;
}

export interface UpdateMaterialSpecification2Params {
    command?: UpdateMaterialSpecification | null;
}

export interface DeleteToolCompatibleMachine2Params {
    command?: DeleteToolCompatibleMachine | null;
}

export interface CreateDM_MaterialTrackingUnitHistory2Params {
    command?: CreateDM_MaterialTrackingUnitHistory | null;
}

export interface DeleteAsPlannedBoP2Params {
    command?: DeleteAsPlannedBoP | null;
}

export interface ChangeWorkOrderStatusToEdit2Params {
    command?: ChangeWorkOrderStatusToEdit | null;
}

export interface UpdateBufferDefinition2Params {
    command?: UpdateBufferDefinition | null;
}

export interface UpdateUoMDimension2Params {
    command?: UpdateUoMDimension | null;
}

export interface DeleteWorkProcessDMMaterialTrackingUnitAssociationList2Params {
    command?: DeleteWorkProcessDMMaterialTrackingUnitAssociationList | null;
}

export interface DeleteFailure2Params {
    command?: DeleteFailure | null;
}

export interface LinkToolsToNonConformance2Params {
    command?: LinkToolsToNonConformance | null;
}

export interface UpdatePreferredProcessToOpLinkDependencyNavigation2Params {
    command?: UpdatePreferredProcessToOpLinkDependencyNavigation | null;
}

export interface DeleteToBeUsedInspection2Params {
    command?: DeleteToBeUsedInspection | null;
}

export interface CreateDocument2Params {
    command?: CreateDocument | null;
}

export interface UADMUpdateMaterialDefinition2Params {
    command?: UADMUpdateMaterialDefinition | null;
}

export interface UnLinkPJFToEquipmentSpecification2Params {
    command?: UnLinkPJFToEquipmentSpecification | null;
}

export interface DeleteStatus2Params {
    command?: DeleteStatus | null;
}

export interface UnlinkItlkCheckToOperationStepCategoryList2Params {
    command?: UnlinkItlkCheckToOperationStepCategoryList | null;
}

export interface UpdateStatusBehaviorDefinition2Params {
    command?: UpdateStatusBehaviorDefinition | null;
}

export interface UpdateItlkCheckToOperationToStepLinkList2Params {
    command?: UpdateItlkCheckToOperationToStepLinkList | null;
}

export interface DeleteBufferDefinitionList2Params {
    command?: DeleteBufferDefinitionList | null;
}

export interface UnlinkATNInstanceParameterToSetPointItemList2Params {
    command?: UnlinkATNInstanceParameterToSetPointItemList | null;
}

export interface StartUsingScrewingTool2Params {
    command?: StartUsingScrewingTool | null;
}

export interface DeleteToolList2Params {
    command?: DeleteToolList | null;
}

export interface LinkOperationStepCategoryToProcessDefinitionList2Params {
    command?: LinkOperationStepCategoryToProcessDefinitionList | null;
}

export interface DeleteNonConformanceNotification2Params {
    command?: DeleteNonConformanceNotification | null;
}

export interface UpdateWOByBop2Params {
    command?: UpdateWOByBop | null;
}

export interface DeleteTemplateToMaterialPlantList2Params {
    command?: DeleteTemplateToMaterialPlantList | null;
}

export interface UpdatePreferredWOOpDependencyNavigation2Params {
    command?: UpdatePreferredWOOpDependencyNavigation | null;
}

export interface DeleteEquipmentLevel2Params {
    command?: DeleteEquipmentLevel | null;
}

export interface RecycleAMPowderBatch2Params {
    command?: RecycleAMPowderBatch | null;
}

export interface GetDCDRuntimeWIToSaveByMachine2Params {
    command?: GetDCDRuntimeWIToSaveByMachine | null;
}

export interface LinkMaterialItemsToHandlingUnit2Params {
    command?: LinkMaterialItemsToHandlingUnit | null;
}

export interface SetOperationStepCategoryProcessDefinitionByMTU2Params {
    command?: SetOperationStepCategoryProcessDefinitionByMTU | null;
}

export interface UnlinkCharacteristicRepresentationToOperation2Params {
    command?: UnlinkCharacteristicRepresentationToOperation | null;
}

export interface LinkOperationToProcess2Params {
    command?: LinkOperationToProcess | null;
}

export interface TCM2LinkProcessToOperationList2Params {
    command?: TCM2LinkProcessToOperationList | null;
}

export interface CreateWorkOrderAndMaterialItemHistory2Params {
    command?: CreateWorkOrderAndMaterialItemHistory | null;
}

export interface ConsumeMaterialItem2Params {
    command?: ConsumeMaterialItem | null;
}

export interface CompleteWOOperationsSerializedLiteSingleWO2Params {
    command?: CompleteWOOperationsSerializedLiteSingleWO | null;
}

export interface DeleteEquipmentGraphConfiguration2Params {
    command?: DeleteEquipmentGraphConfiguration | null;
}

export interface DeleteToBeUsedMachine2Params {
    command?: DeleteToBeUsedMachine | null;
}

export interface UpdateResultList2Params {
    command?: UpdateResultList | null;
}

export interface LinkWorkInstructionsToWOOperation2Params {
    command?: LinkWorkInstructionsToWOOperation | null;
}

export interface LinkWOOperationListToExecutionGroup2Params {
    command?: LinkWOOperationListToExecutionGroup | null;
}

export interface SetWorkOrderForScheduling2Params {
    command?: SetWorkOrderForScheduling | null;
}

export interface UnLinkToBeUsedMachineToPartProgram2Params {
    command?: UnLinkToBeUsedMachineToPartProgram | null;
}

export interface DeleteMasterPlanList2Params {
    command?: DeleteMasterPlanList | null;
}

export interface TCM2CreateOpDependencyList2Params {
    command?: TCM2CreateOpDependencyList | null;
}

export interface DeleteNonConformanceStatusList2Params {
    command?: DeleteNonConformanceStatusList | null;
}

export interface TCM2AssociateDocumentToToolDefinitionList2Params {
    command?: TCM2AssociateDocumentToToolDefinitionList | null;
}

export interface LinkCharacteristicRepresentationToStep2Params {
    command?: LinkCharacteristicRepresentationToStep | null;
}

export interface SetEquipmentStatus2Params {
    command?: SetEquipmentStatus | null;
}

export interface UADMUpdateEquipmentSpecification2Params {
    command?: UADMUpdateEquipmentSpecification | null;
}

export interface CreateEquipmentSpecificationList2Params {
    command?: CreateEquipmentSpecificationList | null;
}

export interface DeleteMaterialDefinitionDocumentList2Params {
    command?: DeleteMaterialDefinitionDocumentList | null;
}

export interface DeleteDefectTypeList2Params {
    command?: DeleteDefectTypeList | null;
}

export interface UpdateSubstrateTreatmentAndThickness2Params {
    command?: UpdateSubstrateTreatmentAndThickness | null;
}

export interface CreateMaterialAndDM_Material2Params {
    command?: CreateMaterialAndDM_Material | null;
}

export interface SetWorkOrderOperationFutureHold2Params {
    command?: SetWorkOrderOperationFutureHold | null;
}

export interface CreateWorkOrderFromMasterPlanWithQC2Params {
    command?: CreateWorkOrderFromMasterPlanWithQC | null;
}

export interface CreateStepDependencyList2Params {
    command?: CreateStepDependencyList | null;
}

export interface UpdateWorkOrderHistory2Params {
    command?: UpdateWorkOrderHistory | null;
}

export interface CreateMaterialClass2Params {
    command?: CreateMaterialClass | null;
}

export interface LinkUserToPlant2Params {
    command?: LinkUserToPlant | null;
}

export interface GetToBeProducedMaterialsResult2Params {
    command?: GetToBeProducedMaterialsResult | null;
}

export interface CheckInCompleteWOOperationTransferBatch2Params {
    command?: CheckInCompleteWOOperationTransferBatch | null;
}

export interface UpdateResultTypeList2Params {
    command?: UpdateResultTypeList | null;
}

export interface CompleteWOStepList2Params {
    command?: CompleteWOStepList | null;
}

export interface DeleteDocument2Params {
    command?: DeleteDocument | null;
}

export interface DeleteUoMFactor2Params {
    command?: DeleteUoMFactor | null;
}

export interface DeleteNonConformanceSupervisor2Params {
    command?: DeleteNonConformanceSupervisor | null;
}

export interface UpdateToBeUsedMachinePJF2Params {
    command?: UpdateToBeUsedMachinePJF | null;
}

export interface DeleteWorkOrderHistoryMaterialItem2Params {
    command?: DeleteWorkOrderHistoryMaterialItem | null;
}

export interface UADMCreateMaterialDefinition2Params {
    command?: UADMCreateMaterialDefinition | null;
}

export interface CompleteTaskAndWorkProcessList2Params {
    command?: CompleteTaskAndWorkProcessList | null;
}

export interface LinkOfflineSessionToWorkOrderOperationList2Params {
    command?: LinkOfflineSessionToWorkOrderOperationList | null;
}

export interface DeleteOperationDependencyList2Params {
    command?: DeleteOperationDependencyList | null;
}

export interface UnlinkSubstrateToMachine2Params {
    command?: UnlinkSubstrateToMachine | null;
}

export interface AutomaticConsumeMaterialItem2Params {
    command?: AutomaticConsumeMaterialItem | null;
}

export interface CreateWorkOperationType2Params {
    command?: CreateWorkOperationType | null;
}

export interface UADMCreateEquipmentSpecification2Params {
    command?: UADMCreateEquipmentSpecification | null;
}

export interface RevertResultsStrategy2Params {
    command?: RevertResultsStrategy | null;
}

export interface UpdateCharacteristicFailureAssociation2Params {
    command?: UpdateCharacteristicFailureAssociation | null;
}

export interface AutoGenerateMTUCode2Params {
    command?: AutoGenerateMTUCode | null;
}

export interface ExecuteItlkCheckOutbound2Params {
    command?: ExecuteItlkCheckOutbound | null;
}

export interface UpdateItlkCheckProcessToOpLinkAssociationList2Params {
    command?: UpdateItlkCheckProcessToOpLinkAssociationList | null;
}

export interface UpdateSetPointItem2Params {
    command?: UpdateSetPointItem | null;
}

export interface ValidateMaterialCoProductionIsComplete2Params {
    command?: ValidateMaterialCoProductionIsComplete | null;
}

export interface UnLinkMaterialItemsFromNonConformance2Params {
    command?: UnLinkMaterialItemsFromNonConformance | null;
}

export interface UnlinkAutomationNodeInstanceParameterFromDCItemList2Params {
    command?: UnlinkAutomationNodeInstanceParameterFromDCItemList | null;
}

export interface UnlinkWorkOrderHumanResource2Params {
    command?: UnlinkWorkOrderHumanResource | null;
}

export interface DeleteStatusTransitionDefinition2Params {
    command?: DeleteStatusTransitionDefinition | null;
}

export interface CreateSetPoint2Params {
    command?: CreateSetPoint | null;
}

export interface DeleteBuffer2Params {
    command?: DeleteBuffer | null;
}

export interface AcceptChangeAddToBeConsumedMaterial2Params {
    command?: AcceptChangeAddToBeConsumedMaterial | null;
}

export interface UADMCreateProcessInCatalogue2Params {
    command?: UADMCreateProcessInCatalogue | null;
}

export interface DeleteWorkOrder2Params {
    command?: DeleteWorkOrder | null;
}

export interface CreateOperationList2Params {
    command?: CreateOperationList | null;
}

export interface UnLinkLogisticWhitelist2Params {
    command?: UnLinkLogisticWhitelist | null;
}

export interface CreateToBeUsedMachinePJFFromProcess2Params {
    command?: CreateToBeUsedMachinePJFFromProcess | null;
}

export interface DeleteActualUsedTool2Params {
    command?: DeleteActualUsedTool | null;
}

export interface UnlinkSkillsFromProcessOperation2Params {
    command?: UnlinkSkillsFromProcessOperation | null;
}

export interface CreateTemplateBlock2Params {
    command?: CreateTemplateBlock | null;
}

export interface CreateActualUsedMachinePJF2Params {
    command?: CreateActualUsedMachinePJF | null;
}

export interface UpdateTemplateBlock2Params {
    command?: UpdateTemplateBlock | null;
}

export interface CreatePauseReason2Params {
    command?: CreatePauseReason | null;
}

export interface DeleteOperation2Params {
    command?: DeleteOperation | null;
}

export interface GetMaterialItemListForVerifyWorkOrderOperation2Params {
    command?: GetMaterialItemListForVerifyWorkOrderOperation | null;
}

export interface DeleteEquipmentConfiguration2Params {
    command?: DeleteEquipmentConfiguration | null;
}

export interface UpdateNonProductiveActivityForUser2Params {
    command?: UpdateNonProductiveActivityForUser | null;
}

export interface CreateNonConformanceStatus2Params {
    command?: CreateNonConformanceStatus | null;
}

export interface UpdateNonConformanceLifecycle2Params {
    command?: UpdateNonConformanceLifecycle | null;
}

export interface CheckInCreateNonConformance2Params {
    command?: CheckInCreateNonConformance | null;
}

export interface DeleteEquipmentGroupConfiguration2Params {
    command?: DeleteEquipmentGroupConfiguration | null;
}

export interface RetrieveAllFilterQCData2Params {
    command?: RetrieveAllFilterQCData | null;
}

export interface DeleteSnagAndNoteNotificationList2Params {
    command?: DeleteSnagAndNoteNotificationList | null;
}

export interface DeleteStateMachine2Params {
    command?: DeleteStateMachine | null;
}

export interface CopyToBeProducedFacets2Params {
    command?: CopyToBeProducedFacets | null;
}

export interface ChangeSetPointStatus2Params {
    command?: ChangeSetPointStatus | null;
}

export interface ReleaseTransportOperation2Params {
    command?: ReleaseTransportOperation | null;
}

export interface UnlinkSkillsFromCertificate2Params {
    command?: UnlinkSkillsFromCertificate | null;
}

export interface CreateDefectTypeContextualization2Params {
    command?: CreateDefectTypeContextualization | null;
}

export interface UnlinkMachineDefinitionToSetPoint2Params {
    command?: UnlinkMachineDefinitionToSetPoint | null;
}

export interface DeleteCharacteristicSpecification2Params {
    command?: DeleteCharacteristicSpecification | null;
}

export interface LinkSkillsToWorkOrderOperation2Params {
    command?: LinkSkillsToWorkOrderOperation | null;
}

export interface TCM2CreateOperationList2Params {
    command?: TCM2CreateOperationList | null;
}

export interface DeleteToolHistoryAction2Params {
    command?: DeleteToolHistoryAction | null;
}

export interface Link3DPrinterToEquipment2Params {
    command?: Link3DPrinterToEquipment | null;
}

export interface UpdateEquipmentConfiguration2Params {
    command?: UpdateEquipmentConfiguration | null;
}

export interface DeleteSnagAndNote2Params {
    command?: DeleteSnagAndNote | null;
}

export interface DeleteResultTypeList2Params {
    command?: DeleteResultTypeList | null;
}

export interface GenerateRuntimePrintJobFile2Params {
    command?: GenerateRuntimePrintJobFile | null;
}

export interface UpdateNonConformance2Params {
    command?: UpdateNonConformance | null;
}

export interface CreateWorkOrderOperation2Params {
    command?: CreateWorkOrderOperation | null;
}

export interface CreateWorkOOperationDependencies2Params {
    command?: CreateWorkOOperationDependencies | null;
}

export interface DeleteNonConformance2Params {
    command?: DeleteNonConformance | null;
}

export interface AcceptChangeRepeatOperation2Params {
    command?: AcceptChangeRepeatOperation | null;
}

export interface LinkPrintJobFileToMachine2Params {
    command?: LinkPrintJobFileToMachine | null;
}

export interface LinkSkillsToTeam2Params {
    command?: LinkSkillsToTeam | null;
}

export interface LinkWorkInstructionsToContainer2Params {
    command?: LinkWorkInstructionsToContainer | null;
}

export interface UnlinkPartProgramFromEquipmentSpecification2Params {
    command?: UnlinkPartProgramFromEquipmentSpecification | null;
}

export interface CreateHoldReason2Params {
    command?: CreateHoldReason | null;
}

export interface DisassembleMaterialItemLite2Params {
    command?: DisassembleMaterialItemLite | null;
}

export interface StartWOStepFullQty2Params {
    command?: StartWOStepFullQty | null;
}

export interface UnlinkOperationDependencyToProcess2Params {
    command?: UnlinkOperationDependencyToProcess | null;
}

export interface UpdateWorkOStepDependency2Params {
    command?: UpdateWorkOStepDependency | null;
}

export interface CreateNonConformanceOnContainerContent2Params {
    command?: CreateNonConformanceOnContainerContent | null;
}

export interface DeleteReworkCodeList2Params {
    command?: DeleteReworkCodeList | null;
}

export interface UnlinkMaterialFromContainerTypeList2Params {
    command?: UnlinkMaterialFromContainerTypeList | null;
}

export interface CreateToBeUsedTools2Params {
    command?: CreateToBeUsedTools | null;
}

export interface DiscardOfflineSessionList2Params {
    command?: DiscardOfflineSessionList | null;
}

export interface LinkStepToOperation2Params {
    command?: LinkStepToOperation | null;
}

export interface GetPJFsHookOnLinkToBeUsedMachineToPJF2Params {
    command?: GetPJFsHookOnLinkToBeUsedMachineToPJF | null;
}

export interface DeleteOperationStepCategoryList2Params {
    command?: DeleteOperationStepCategoryList | null;
}

export interface UseToolList2Params {
    command?: UseToolList | null;
}

export interface MixAMPowderBatchList2Params {
    command?: MixAMPowderBatchList | null;
}

export interface CreateBuyOffForActiveMTUs2Params {
    command?: CreateBuyOffForActiveMTUs | null;
}

export interface FilterInputResultsOnUndoRepeatWOOpStrategy2Params {
    command?: FilterInputResultsOnUndoRepeatWOOpStrategy | null;
}

export interface CompleteNonProductiveActivityList2Params {
    command?: CompleteNonProductiveActivityList | null;
}

export interface CreateNonConformanceV3_12Params {
    command?: CreateNonConformanceV3_1 | null;
}

export interface CreateOperationStepCategory2Params {
    command?: CreateOperationStepCategory | null;
}

export interface TCM2CompleteMasterPlan2Params {
    command?: TCM2CompleteMasterPlan | null;
}

export interface CreateStepList2Params {
    command?: CreateStepList | null;
}

export interface GetToBeProducedMaterialsResultOpList2Params {
    command?: GetToBeProducedMaterialsResultOpList | null;
}

export interface LinkWorkOrderHumanResource2Params {
    command?: LinkWorkOrderHumanResource | null;
}

export interface CreateStatusBehaviorDefinition2Params {
    command?: CreateStatusBehaviorDefinition | null;
}

export interface UpdateAMPowderBatch2Params {
    command?: UpdateAMPowderBatch | null;
}

export interface SetNonConformanceStatusIsScrapped2Params {
    command?: SetNonConformanceStatusIsScrapped | null;
}

export interface UpdateEquipmentConfigurationProperty2Params {
    command?: UpdateEquipmentConfigurationProperty | null;
}

export interface DeleteCharacteristicFailureAssociation2Params {
    command?: DeleteCharacteristicFailureAssociation | null;
}

export interface UnlinkDocumentToStep2Params {
    command?: UnlinkDocumentToStep | null;
}

export interface CreateActualUsedMachine2Params {
    command?: CreateActualUsedMachine | null;
}

export interface UpdateCustomItlkCheckParameterList2Params {
    command?: UpdateCustomItlkCheckParameterList | null;
}

export interface CreateNonConformanceDefectList2Params {
    command?: CreateNonConformanceDefectList | null;
}

export interface CreateWorkOrderSteps2Params {
    command?: CreateWorkOrderSteps | null;
}

export interface CreateMaterial2Params {
    command?: CreateMaterial | null;
}

export interface CreateProcess2Params {
    command?: CreateProcess | null;
}

export interface LinkMaterialSpecificationToOperation2Params {
    command?: LinkMaterialSpecificationToOperation | null;
}

export interface RemoveWorkOrderHold2Params {
    command?: RemoveWorkOrderHold | null;
}

export interface AcquireToolFromAutomationNodeInstanceParameter2Params {
    command?: AcquireToolFromAutomationNodeInstanceParameter | null;
}

export interface UpdateNonConformanceStatus2Params {
    command?: UpdateNonConformanceStatus | null;
}

export interface GetWorkOrderOperationIdToStartByMachine2Params {
    command?: GetWorkOrderOperationIdToStartByMachine | null;
}

export interface LinkHumanResourceToProcess2Params {
    command?: LinkHumanResourceToProcess | null;
}

export interface StartWOStepSerialized2Params {
    command?: StartWOStepSerialized | null;
}

export interface CreateResultHistoryList2Params {
    command?: CreateResultHistoryList | null;
}

export interface UpdateExecutionGroupPhase2Params {
    command?: UpdateExecutionGroupPhase | null;
}

export interface CreateToBeProducedMaterial2Params {
    command?: CreateToBeProducedMaterial | null;
}

export interface CreateToolHistory2Params {
    command?: CreateToolHistory | null;
}

export interface TransmitToolSetPointItemToAutomationNodeParameterList2Params {
    command?: TransmitToolSetPointItemToAutomationNodeParameterList | null;
}

export interface CreateCharacteristicRepresentation2Params {
    command?: CreateCharacteristicRepresentation | null;
}

export interface CreateBoMV4_02Params {
    command?: CreateBoMV4_0 | null;
}

export interface GetCurrentUserRoles2Params {
    command?: GetCurrentUserRoles | null;
}

export interface CreateWOOpDependencyNavigationList2Params {
    command?: CreateWOOpDependencyNavigationList | null;
}

export interface CreateActualProducedMaterial2Params {
    command?: CreateActualProducedMaterial | null;
}

export interface CloseWorkProcess2Params {
    command?: CloseWorkProcess | null;
}

export interface GetEquipSpecWithPJFHook2Params {
    command?: GetEquipSpecWithPJFHook | null;
}

export interface TCM2AssociateDocumentToMaterialDefinitionList2Params {
    command?: TCM2AssociateDocumentToMaterialDefinitionList | null;
}

export interface DeleteOperationDependency2Params {
    command?: DeleteOperationDependency | null;
}

export interface DeleteWorkOrderOperation2Params {
    command?: DeleteWorkOrderOperation | null;
}

export interface EditSkillToOperationList2Params {
    command?: EditSkillToOperationList | null;
}

export interface LinkEquipmentsToBuffers2Params {
    command?: LinkEquipmentsToBuffers | null;
}

export interface CreateTemplate2Params {
    command?: CreateTemplate | null;
}

export interface CreateToolDefinitionDocumentList2Params {
    command?: CreateToolDefinitionDocumentList | null;
}

export interface LinkDocumentToContainerTypeList2Params {
    command?: LinkDocumentToContainerTypeList | null;
}

export interface DeleteDM_MaterialTrackingUnitHistoryAction2Params {
    command?: DeleteDM_MaterialTrackingUnitHistoryAction | null;
}

export interface SentenceNonConformancePartially2Params {
    command?: SentenceNonConformancePartially | null;
}

export interface DeleteFunctionalCodeListV4_02Params {
    command?: DeleteFunctionalCodeListV4_0 | null;
}

export interface CheckInCompleteWOStepTransferBatch2Params {
    command?: CheckInCompleteWOStepTransferBatch | null;
}

export interface CreateNewMaterialDefinitionRevision2Params {
    command?: CreateNewMaterialDefinitionRevision | null;
}

export interface UpdateNonConformanceStatusBehavior2Params {
    command?: UpdateNonConformanceStatusBehavior | null;
}

export interface UnlinkSkillsToWorkOrderStep2Params {
    command?: UnlinkSkillsToWorkOrderStep | null;
}

export interface LinkBufferDefinitionToLogisticClassList2Params {
    command?: LinkBufferDefinitionToLogisticClassList | null;
}

export interface AbortWorkOrder2Params {
    command?: AbortWorkOrder | null;
}

export interface DeleteNonConformanceLifecycleList2Params {
    command?: DeleteNonConformanceLifecycleList | null;
}

export interface DeleteTemplateBlocks2Params {
    command?: DeleteTemplateBlocks | null;
}

export interface GetProcessWithoutOperationsList2Params {
    command?: GetProcessWithoutOperationsList | null;
}

export interface DeleteToolHistory2Params {
    command?: DeleteToolHistory | null;
}

export interface CreateHandlingUnit2Params {
    command?: CreateHandlingUnit | null;
}

export interface CreateActualConsumedMaterial2Params {
    command?: CreateActualConsumedMaterial | null;
}

export interface TCM2CreateEquipmentSpecificationList2Params {
    command?: TCM2CreateEquipmentSpecificationList | null;
}

export interface CreateNewProcessRevisionInCatalogue2Params {
    command?: CreateNewProcessRevisionInCatalogue | null;
}

export interface UnlinkAutomationNodeInstanceParameterFromToolDefinitionParameterList2Params {
    command?: UnlinkAutomationNodeInstanceParameterFromToolDefinitionParameterList | null;
}

export interface RemoveEquipmentPreferencesForUser2Params {
    command?: RemoveEquipmentPreferencesForUser | null;
}

export interface DeleteEquipmentSpecificationList2Params {
    command?: DeleteEquipmentSpecificationList | null;
}

export interface StartContainer2Params {
    command?: StartContainer | null;
}

export interface CreateOperationDependencyList2Params {
    command?: CreateOperationDependencyList | null;
}

export interface LinkEquipmentSpecificationToOperation2Params {
    command?: LinkEquipmentSpecificationToOperation | null;
}

export interface UploadDocuments2Params {
    command?: UploadDocuments | null;
}

export interface EditWorkOrder2Params {
    command?: EditWorkOrder | null;
}

export interface CompleteTransportOperation2Params {
    command?: CompleteTransportOperation | null;
}

export interface RegisterNonProductiveActivityForUser2Params {
    command?: RegisterNonProductiveActivityForUser | null;
}

export interface GetUserDetailsList2Params {
    command?: GetUserDetailsList | null;
}

export interface UpdateActualProducedMaterial2Params {
    command?: UpdateActualProducedMaterial | null;
}

export interface DeleteNonConformanceTransitionList2Params {
    command?: DeleteNonConformanceTransitionList | null;
}

export interface DeleteEquipmentTypePropertyAttribute2Params {
    command?: DeleteEquipmentTypePropertyAttribute | null;
}

export interface UpdateStatusTransition2Params {
    command?: UpdateStatusTransition | null;
}

export interface CreateReworkOrder2Params {
    command?: CreateReworkOrder | null;
}

export interface EvolveAsPlannedBOP2Params {
    command?: EvolveAsPlannedBOP | null;
}

export interface GetActiveUserListOnWorkOrderOperation2Params {
    command?: GetActiveUserListOnWorkOrderOperation | null;
}

export interface CreateNonConformanceHistory2Params {
    command?: CreateNonConformanceHistory | null;
}

export interface UADMAutomaticComplete2Params {
    command?: UADMAutomaticComplete | null;
}

export interface DeleteStepList2Params {
    command?: DeleteStepList | null;
}

export interface CreateFunctionalCode2Params {
    command?: CreateFunctionalCode | null;
}

export interface UpdateAMPowderBatchGenealogy2Params {
    command?: UpdateAMPowderBatchGenealogy | null;
}

export interface DeleteDefect2Params {
    command?: DeleteDefect | null;
}

export interface InEditingWorkInstruction2Params {
    command?: InEditingWorkInstruction | null;
}

export interface LinkToBeUsedMachineToPartProgram2Params {
    command?: LinkToBeUsedMachineToPartProgram | null;
}

export interface CreateActiveUserOnMachine2Params {
    command?: CreateActiveUserOnMachine | null;
}

export interface UpdateEquipmentSpecification2Params {
    command?: UpdateEquipmentSpecification | null;
}

export interface UnlinkHumanResourceFromProcess2Params {
    command?: UnlinkHumanResourceFromProcess | null;
}

export interface PauseContainer2Params {
    command?: PauseContainer | null;
}

export interface UnlinkOperationToProcess2Params {
    command?: UnlinkOperationToProcess | null;
}

export interface CreateToolDefinitionDocument2Params {
    command?: CreateToolDefinitionDocument | null;
}

export interface DeleteSupplierList2Params {
    command?: DeleteSupplierList | null;
}

export interface CreateDefect2Params {
    command?: CreateDefect | null;
}

export interface CreateEquipmentGraphNodeConfiguration2Params {
    command?: CreateEquipmentGraphNodeConfiguration | null;
}

export interface SetDefectGroupPath2Params {
    command?: SetDefectGroupPath | null;
}

export interface LinkToolToAutomationNodeInstanceList2Params {
    command?: LinkToolToAutomationNodeInstanceList | null;
}

export interface GetNonConformanceTransitionRoleMailList2Params {
    command?: GetNonConformanceTransitionRoleMailList | null;
}

export interface ValidateMaterialConsumptionIsComplete2Params {
    command?: ValidateMaterialConsumptionIsComplete | null;
}

export interface UpdateDNCItem2Params {
    command?: UpdateDNCItem | null;
}

export interface CreateTool2Params {
    command?: CreateTool | null;
}

export interface UnlinkEquipmentToSetPoint2Params {
    command?: UnlinkEquipmentToSetPoint | null;
}

export interface CreateBoM2Params {
    command?: CreateBoM | null;
}

export interface UpdateEquipmentGraphLinkConfiguration2Params {
    command?: UpdateEquipmentGraphLinkConfiguration | null;
}

export interface CreateWorkOrderHistory2Params {
    command?: CreateWorkOrderHistory | null;
}

export interface UpdateEquipmentGraphType2Params {
    command?: UpdateEquipmentGraphType | null;
}

export interface ChangeBoMStatus2Params {
    command?: ChangeBoMStatus | null;
}

export interface ExecuteItlkCheckInbound2Params {
    command?: ExecuteItlkCheckInbound | null;
}

export interface ConsumeMaterialItemOnExecutionGroup2Params {
    command?: ConsumeMaterialItemOnExecutionGroup | null;
}

export interface DeleteOperationList2Params {
    command?: DeleteOperationList | null;
}

export interface CopyWorkInstructionDefinitionRevision2Params {
    command?: CopyWorkInstructionDefinitionRevision | null;
}

export interface RemoveWorkOrderOperationFutureHold2Params {
    command?: RemoveWorkOrderOperationFutureHold | null;
}

export interface LinkEquipmentToSetPoint2Params {
    command?: LinkEquipmentToSetPoint | null;
}

export interface UpdateHierarchyEquipmentNodeConfiguration2Params {
    command?: UpdateHierarchyEquipmentNodeConfiguration | null;
}

export interface CreateStatus2Params {
    command?: CreateStatus | null;
}

export interface LinkSubstrateDefinitionToMachine2Params {
    command?: LinkSubstrateDefinitionToMachine | null;
}

export interface DeleteCustomItlkCheckList2Params {
    command?: DeleteCustomItlkCheckList | null;
}

export interface EditHumanResourceToProcess2Params {
    command?: EditHumanResourceToProcess | null;
}

export interface FilterWorkOrderOperationListByCheckCertification2Params {
    command?: FilterWorkOrderOperationListByCheckCertification | null;
}

export interface CreateNewStepRevision2Params {
    command?: CreateNewStepRevision | null;
}

export interface DeleteEquipmentTypeProperty2Params {
    command?: DeleteEquipmentTypeProperty | null;
}

export interface UnlinkMaterialSpecificationToOperation2Params {
    command?: UnlinkMaterialSpecificationToOperation | null;
}

export interface CreateWorkOrderOperationFromProcessOperation2Params {
    command?: CreateWorkOrderOperationFromProcessOperation | null;
}

export interface UpdateCustomItlkCheckList2Params {
    command?: UpdateCustomItlkCheckList | null;
}

export interface CreateToolHistoryAction2Params {
    command?: CreateToolHistoryAction | null;
}

export interface UpdateVariableCharacteristicSpecification2Params {
    command?: UpdateVariableCharacteristicSpecification | null;
}

export interface UpdateWorkOrderStep2Params {
    command?: UpdateWorkOrderStep | null;
}

export interface CreateEquipmentGroupConfiguration2Params {
    command?: CreateEquipmentGroupConfiguration | null;
}

export interface UnlinkDocumentListToOperation2Params {
    command?: UnlinkDocumentListToOperation | null;
}

export interface UnlinkEquipmentSpecificationToOperation2Params {
    command?: UnlinkEquipmentSpecificationToOperation | null;
}

export interface DeleteToolDefinitions2Params {
    command?: DeleteToolDefinitions | null;
}

export interface CreateDM_MaterialTrackingUnit2Params {
    command?: CreateDM_MaterialTrackingUnit | null;
}

export interface SetWorkInstructionDefinitionRevisionCurrent2Params {
    command?: SetWorkInstructionDefinitionRevisionCurrent | null;
}

export interface CreateExecutionGroup2Params {
    command?: CreateExecutionGroup | null;
}

export interface MergeWOHeaderWithProcess2Params {
    command?: MergeWOHeaderWithProcess | null;
}

export interface CheckInStartWOOperationSerialized2Params {
    command?: CheckInStartWOOperationSerialized | null;
}

export interface DeleteProcessFromCatalogue2Params {
    command?: DeleteProcessFromCatalogue | null;
}

export interface BeginIdTemplateEditing2Params {
    command?: BeginIdTemplateEditing | null;
}

export interface UpdateEquipmentGraphConfiguration2Params {
    command?: UpdateEquipmentGraphConfiguration | null;
}

export interface CreateDNCItem2Params {
    command?: CreateDNCItem | null;
}

export interface CheckInUseToolList2Params {
    command?: CheckInUseToolList | null;
}

export interface DeleteWorkInstructionTemplateParameter2Params {
    command?: DeleteWorkInstructionTemplateParameter | null;
}

export interface GetWorkOrderOperationNIdToCompleteByMachine2Params {
    command?: GetWorkOrderOperationNIdToCompleteByMachine | null;
}

export interface TCM2CreateAsPlannedBOP2Params {
    command?: TCM2CreateAsPlannedBOP | null;
}

export interface VerifyWorkOrder2Params {
    command?: VerifyWorkOrder | null;
}

export interface ReopenWorkOrderOperationSerialized2Params {
    command?: ReopenWorkOrderOperationSerialized | null;
}

export interface GetProductionProcessFromAsPlanned2Params {
    command?: GetProductionProcessFromAsPlanned | null;
}

export interface DeleteNonConformanceHistory2Params {
    command?: DeleteNonConformanceHistory | null;
}

export interface AcceptChangeAddOperation2Params {
    command?: AcceptChangeAddOperation | null;
}

export interface DeleteDocumentList2Params {
    command?: DeleteDocumentList | null;
}

export interface CompleteContainer2Params {
    command?: CompleteContainer | null;
}

export interface PauseWOOperation2Params {
    command?: PauseWOOperation | null;
}

export interface DeleteAsPlannedBOPList2Params {
    command?: DeleteAsPlannedBOPList | null;
}

export interface CreateHold2Params {
    command?: CreateHold | null;
}

export interface LinkToBeUsedMachineToPJF2Params {
    command?: LinkToBeUsedMachineToPJF | null;
}

export interface GetResultStrategy2Params {
    command?: GetResultStrategy | null;
}

export interface LinkMachineDefinitionToSetPoint2Params {
    command?: LinkMachineDefinitionToSetPoint | null;
}

export interface UpdateTeam2Params {
    command?: UpdateTeam | null;
}

export interface CreateNewWorkInstructionDefinitionRevision2Params {
    command?: CreateNewWorkInstructionDefinitionRevision | null;
}

export interface DeleteTemplate2Params {
    command?: DeleteTemplate | null;
}

export interface GetResultValueOnEmpty2Params {
    command?: GetResultValueOnEmpty | null;
}

export interface TCMCreateUoMList2Params {
    command?: TCMCreateUoMList | null;
}

export interface CreateNonConformanceLifecycle2Params {
    command?: CreateNonConformanceLifecycle | null;
}

export interface SetIsOutOfDateAsPlannedBOP2Params {
    command?: SetIsOutOfDateAsPlannedBOP | null;
}

export interface CreateActualUsedTool2Params {
    command?: CreateActualUsedTool | null;
}

export interface CheckWorkOrderStatusIsInEditing2Params {
    command?: CheckWorkOrderStatusIsInEditing | null;
}

export interface CreateItlkCheckHistoryList2Params {
    command?: CreateItlkCheckHistoryList | null;
}

export interface UpdateDM_MaterialTrackingUnit2Params {
    command?: UpdateDM_MaterialTrackingUnit | null;
}

export interface SetWaitingForInspection2Params {
    command?: SetWaitingForInspection | null;
}

export interface DeleteNonProductiveActivityList2Params {
    command?: DeleteNonProductiveActivityList | null;
}

export interface LinkAutomationNodeInstanceParameterToDCItemList2Params {
    command?: LinkAutomationNodeInstanceParameterToDCItemList | null;
}

export interface LinkPartProgramToEquipmentSpecification2Params {
    command?: LinkPartProgramToEquipmentSpecification | null;
}

export interface UpdateActualUsedMachinePJF2Params {
    command?: UpdateActualUsedMachinePJF | null;
}

export interface CopyNonConformanceFromParentWorkOrder2Params {
    command?: CopyNonConformanceFromParentWorkOrder | null;
}

export interface CreateToBeUsedInspection2Params {
    command?: CreateToBeUsedInspection | null;
}

export interface DeleteWorkOrderHistoryAction2Params {
    command?: DeleteWorkOrderHistoryAction | null;
}

export interface UnlinkWOOperationsFromExecutionGroup2Params {
    command?: UnlinkWOOperationsFromExecutionGroup | null;
}

export interface ChangeBufferStatus2Params {
    command?: ChangeBufferStatus | null;
}

export interface ReleaseExecutionGroup2Params {
    command?: ReleaseExecutionGroup | null;
}

export interface DeleteWorkInstructionDefinitionParameter2Params {
    command?: DeleteWorkInstructionDefinitionParameter | null;
}

export interface AcceptChangeChangeToBeUsedMachine2Params {
    command?: AcceptChangeChangeToBeUsedMachine | null;
}

export interface ChangeHandlingUnitStatus2Params {
    command?: ChangeHandlingUnitStatus | null;
}

export interface LinkToolToSetPoint2Params {
    command?: LinkToolToSetPoint | null;
}

export interface DeleteCertificationList2Params {
    command?: DeleteCertificationList | null;
}

export interface SetPreferredMachine2Params {
    command?: SetPreferredMachine | null;
}

export interface LinkToolDefinitionToSetPoint2Params {
    command?: LinkToolDefinitionToSetPoint | null;
}

export interface DeleteToBeUsedMachinePJF2Params {
    command?: DeleteToBeUsedMachinePJF | null;
}

export interface DeleteToolDefinitionDocument2Params {
    command?: DeleteToolDefinitionDocument | null;
}

export interface AutomaticCollectWorkInstruction2Params {
    command?: AutomaticCollectWorkInstruction | null;
}

export interface CreatePrintJobFile2Params {
    command?: CreatePrintJobFile | null;
}

export interface AcceptChangeReplaceToBeConsumedMaterial2Params {
    command?: AcceptChangeReplaceToBeConsumedMaterial | null;
}

export interface UploadPLMX2Params {
    command?: UploadPLMX | null;
}

export interface UnLinkSkillsFromTeam2Params {
    command?: UnLinkSkillsFromTeam | null;
}

export interface CompleteWOStepFullQty2Params {
    command?: CompleteWOStepFullQty | null;
}

export interface UpdateStep2Params {
    command?: UpdateStep | null;
}

export interface UnlinkPrintJobFileFromEquipmentType2Params {
    command?: UnlinkPrintJobFileFromEquipmentType | null;
}

export interface SetTargetQuantityOnFlexibleWorkOrder2Params {
    command?: SetTargetQuantityOnFlexibleWorkOrder | null;
}

export interface CreateOperation2Params {
    command?: CreateOperation | null;
}

export interface LinkPJFToEquipmentSpecification2Params {
    command?: LinkPJFToEquipmentSpecification | null;
}

export interface CreateAndAssignProducedMaterialItems2Params {
    command?: CreateAndAssignProducedMaterialItems | null;
}

export interface CreateToolCompatibleMachine2Params {
    command?: CreateToolCompatibleMachine | null;
}

export interface LinkToBeUsedInspectionToRuntimeCharReprRefOperationAssociationList2Params {
    command?: LinkToBeUsedInspectionToRuntimeCharReprRefOperationAssociationList | null;
}

export interface AssociateDNCItemMachineMaterialsAssociation2Params {
    command?: AssociateDNCItemMachineMaterialsAssociation | null;
}

export interface DeleteWorkInstructionTemplate2Params {
    command?: DeleteWorkInstructionTemplate | null;
}

export interface ActivateMaterialTrackingUnitOnScrewingTool2Params {
    command?: ActivateMaterialTrackingUnitOnScrewingTool | null;
}

export interface LinkWorkInstructionDefinitionListToStep2Params {
    command?: LinkWorkInstructionDefinitionListToStep | null;
}

export interface UpdateTransportOperation2Params {
    command?: UpdateTransportOperation | null;
}

export interface DeleteWOOperationDependency2Params {
    command?: DeleteWOOperationDependency | null;
}

export interface UnLoadHandlingUnit2Params {
    command?: UnLoadHandlingUnit | null;
}

export interface TCM2AssociateDocumentToStepList2Params {
    command?: TCM2AssociateDocumentToStepList | null;
}

export interface DisassembleMaterialItem2Params {
    command?: DisassembleMaterialItem | null;
}

export interface EnableLocationMachineForCompleteByDifferentUser2Params {
    command?: EnableLocationMachineForCompleteByDifferentUser | null;
}

export interface UnsetWorkInstructionDefinitionRevisionCurrent2Params {
    command?: UnsetWorkInstructionDefinitionRevisionCurrent | null;
}

export interface UpdateActualUsedMachine2Params {
    command?: UpdateActualUsedMachine | null;
}

export interface UpdateEquipmentConfigurationPropertyAttribute2Params {
    command?: UpdateEquipmentConfigurationPropertyAttribute | null;
}

export interface DeleteDefectGroupList2Params {
    command?: DeleteDefectGroupList | null;
}

export interface AbortExecutionGroupList2Params {
    command?: AbortExecutionGroupList | null;
}

export interface CreateTemplateToMaterialPlant2Params {
    command?: CreateTemplateToMaterialPlant | null;
}

export interface DeleteSetPointList2Params {
    command?: DeleteSetPointList | null;
}

export interface CreateSkipReason2Params {
    command?: CreateSkipReason | null;
}

export interface CreateWorkInstruction2Params {
    command?: CreateWorkInstruction | null;
}

export interface LinkWorkInstructionsToWOStep2Params {
    command?: LinkWorkInstructionsToWOStep | null;
}

export interface DeleteMaterialSpecificationList2Params {
    command?: DeleteMaterialSpecificationList | null;
}

export interface DeleteToBeProducedMaterial2Params {
    command?: DeleteToBeProducedMaterial | null;
}

export interface CreateReworkCodeList2Params {
    command?: CreateReworkCodeList | null;
}

export interface LinkProcessToProcess2Params {
    command?: LinkProcessToProcess | null;
}

export interface CreateEquipmentConfiguration2Params {
    command?: CreateEquipmentConfiguration | null;
}

export interface SetCheckedOutOnWorkOrderOperationList2Params {
    command?: SetCheckedOutOnWorkOrderOperationList | null;
}

export interface UpdateExecutionGroup2Params {
    command?: UpdateExecutionGroup | null;
}

export interface UpdateWorkInstructionTemplateParameter2Params {
    command?: UpdateWorkInstructionTemplateParameter | null;
}

export interface RemoveCertificationToMaterialList2Params {
    command?: RemoveCertificationToMaterialList | null;
}

export interface DeleteMasterPlan2Params {
    command?: DeleteMasterPlan | null;
}

export interface CreateCriticality2Params {
    command?: CreateCriticality | null;
}

export interface DeleteMaterialTrackingUnit2Params {
    command?: DeleteMaterialTrackingUnit | null;
}

export interface UnLinkUsersFromTeam2Params {
    command?: UnLinkUsersFromTeam | null;
}

export interface UpdateOfflineAction2Params {
    command?: UpdateOfflineAction | null;
}

export interface AcceptChangeAddWorkInstruction2Params {
    command?: AcceptChangeAddWorkInstruction | null;
}

export interface CreateToBeUsedDocuments2Params {
    command?: CreateToBeUsedDocuments | null;
}

export interface CheckInCompleteWOOperationSerialized2Params {
    command?: CheckInCompleteWOOperationSerialized | null;
}

export interface CreateWOStepDependency2Params {
    command?: CreateWOStepDependency | null;
}

export interface ReleaseWorkOrder2Params {
    command?: ReleaseWorkOrder | null;
}

export interface DeleteBoMItemList2Params {
    command?: DeleteBoMItemList | null;
}

export interface StartWOOperationsSerializedLiteSingleWO2Params {
    command?: StartWOOperationsSerializedLiteSingleWO | null;
}

export interface SendMail2Params {
    command?: SendMail | null;
}

export interface StartWOOperationsSerializedLite2Params {
    command?: StartWOOperationsSerializedLite | null;
}

export interface CloneAsPlannedBOP2Params {
    command?: CloneAsPlannedBOP | null;
}

export interface GenerateAndAssociateMTUCode2Params {
    command?: GenerateAndAssociateMTUCode | null;
}

export interface UpdateStatusDefinition2Params {
    command?: UpdateStatusDefinition | null;
}

export interface GenerateWorkOrderNId2Params {
    command?: GenerateWorkOrderNId | null;
}

export interface CreateAMPowderBatchGenealogy2Params {
    command?: CreateAMPowderBatchGenealogy | null;
}

export interface UnlinkWIDefinitionsFromEGPhase2Params {
    command?: UnlinkWIDefinitionsFromEGPhase | null;
}

export interface UpdateFutureHold2Params {
    command?: UpdateFutureHold | null;
}

export interface EditPrintJobFile2Params {
    command?: EditPrintJobFile | null;
}

export interface CheckInStartWOOperationTransferBatch2Params {
    command?: CheckInStartWOOperationTransferBatch | null;
}

export interface DeleteBufferDefinition2Params {
    command?: DeleteBufferDefinition | null;
}

export interface UnlinkItlkCheckToWorkOrderStepList2Params {
    command?: UnlinkItlkCheckToWorkOrderStepList | null;
}

export interface LinkDocumentListToDM_MaterialTrackingUnit2Params {
    command?: LinkDocumentListToDM_MaterialTrackingUnit | null;
}

export interface CreateWorkOrderFromProcess2Params {
    command?: CreateWorkOrderFromProcess | null;
}

export interface CreateResultList2Params {
    command?: CreateResultList | null;
}

export interface CreateMaterialDefinitionDocument2Params {
    command?: CreateMaterialDefinitionDocument | null;
}

export interface CheckOutWorkOrderOperationList2Params {
    command?: CheckOutWorkOrderOperationList | null;
}

export interface CreateExecutionGroupPhaseDependency2Params {
    command?: CreateExecutionGroupPhaseDependency | null;
}

export interface CreateWorkInstructionTemplate2Params {
    command?: CreateWorkInstructionTemplate | null;
}

export interface CreateStatusDefinition2Params {
    command?: CreateStatusDefinition | null;
}

export interface LinkMaterialToContainerTypeList2Params {
    command?: LinkMaterialToContainerTypeList | null;
}

export interface CreateWorkOrderStepFromStep2Params {
    command?: CreateWorkOrderStepFromStep | null;
}

export interface SubstrateMaintenance2Params {
    command?: SubstrateMaintenance | null;
}

export interface UseScrewingTool2Params {
    command?: UseScrewingTool | null;
}

export interface SetFutureHoldAfterNonConformanceCreation2Params {
    command?: SetFutureHoldAfterNonConformanceCreation | null;
}

export interface CreateNonConformanceAttachmentList2Params {
    command?: CreateNonConformanceAttachmentList | null;
}

export interface DeleteWorkOrderHistory2Params {
    command?: DeleteWorkOrderHistory | null;
}

export interface UnlinkDocumentToOperation2Params {
    command?: UnlinkDocumentToOperation | null;
}

export interface CheckCertificationMultiMachine2Params {
    command?: CheckCertificationMultiMachine | null;
}

export interface CreateLogisticRequestItem2Params {
    command?: CreateLogisticRequestItem | null;
}

export interface CreateOperationDependency2Params {
    command?: CreateOperationDependency | null;
}

export interface DeleteWorkInstructionDefinition2Params {
    command?: DeleteWorkInstructionDefinition | null;
}

export interface PunchInUsers2Params {
    command?: PunchInUsers | null;
}

export interface CheckInCompleteWOStepFullQty2Params {
    command?: CheckInCompleteWOStepFullQty | null;
}

export interface TCM2CreateEquipmentSpecificationFullList2Params {
    command?: TCM2CreateEquipmentSpecificationFullList | null;
}

export interface CreateWorkOrder2Params {
    command?: CreateWorkOrder | null;
}

export interface UseTool2Params {
    command?: UseTool | null;
}

export interface CreateToolSpecificationList2Params {
    command?: CreateToolSpecificationList | null;
}

export interface LinkSkillsToProcessOperation2Params {
    command?: LinkSkillsToProcessOperation | null;
}

export interface Link3DPrinterTypeToEquipmentType2Params {
    command?: Link3DPrinterTypeToEquipmentType | null;
}

export interface CreateOperationRevisionSubStructure2Params {
    command?: CreateOperationRevisionSubStructure | null;
}

export interface LinkProcessToAsPlannedBOP2Params {
    command?: LinkProcessToAsPlannedBOP | null;
}

export interface DeleteEquipmentGraphType2Params {
    command?: DeleteEquipmentGraphType | null;
}

export interface RemoveNonConformanceTransitionMailAddressList2Params {
    command?: RemoveNonConformanceTransitionMailAddressList | null;
}

export interface LinkItlkCheckToWorkOrderOperationList2Params {
    command?: LinkItlkCheckToWorkOrderOperationList | null;
}

export interface UnloadContainer2Params {
    command?: UnloadContainer | null;
}

export interface CreateChange2Params {
    command?: CreateChange | null;
}

export interface DisAssignProducedMaterialItems2Params {
    command?: DisAssignProducedMaterialItems | null;
}

export interface UnlinkAutomationNodeInstanceParameterFromMaterialParameterList2Params {
    command?: UnlinkAutomationNodeInstanceParameterFromMaterialParameterList | null;
}

export interface TCM2CreateMaterialSpecificationFullList2Params {
    command?: TCM2CreateMaterialSpecificationFullList | null;
}

export interface StartWOOperationFullQty2Params {
    command?: StartWOOperationFullQty | null;
}

export interface TakeOwnershipTransportOperation2Params {
    command?: TakeOwnershipTransportOperation | null;
}

export interface TraceCertificationHistory2Params {
    command?: TraceCertificationHistory | null;
}

export interface CreateSupplier2Params {
    command?: CreateSupplier | null;
}

export interface AutoGenerateWorkOrderNId2Params {
    command?: AutoGenerateWorkOrderNId | null;
}

export interface CreateWorkOrdersFromAsPlannedBOP2Params {
    command?: CreateWorkOrdersFromAsPlannedBOP | null;
}

export interface ReserveMaterialItems2Params {
    command?: ReserveMaterialItems | null;
}

export interface DeleteBufferList2Params {
    command?: DeleteBufferList | null;
}

export interface CreateEquipmentLevel2Params {
    command?: CreateEquipmentLevel | null;
}

export interface UnlinkWorkInstructionsFromWOStep2Params {
    command?: UnlinkWorkInstructionsFromWOStep | null;
}

export interface AcceptChangeChangeDependency2Params {
    command?: AcceptChangeChangeDependency | null;
}

export interface DeleteFunctionalCodeList2Params {
    command?: DeleteFunctionalCodeList | null;
}

export interface StartExecutionGroup2Params {
    command?: StartExecutionGroup | null;
}

export interface RemoveCertificationToRoleList2Params {
    command?: RemoveCertificationToRoleList | null;
}

export interface CreateAPSAlert2Params {
    command?: CreateAPSAlert | null;
}

export interface CreateBufferDefinition2Params {
    command?: CreateBufferDefinition | null;
}

export interface ResendConfirmWorkOrderOperation2Params {
    command?: ResendConfirmWorkOrderOperation | null;
}

export interface DNCTransferDNCItems2Params {
    command?: DNCTransferDNCItems | null;
}

export interface UpdateNonConformanceSupervisor2Params {
    command?: UpdateNonConformanceSupervisor | null;
}

export interface AcquireMTUFromAutomationNodeInstanceParameter2Params {
    command?: AcquireMTUFromAutomationNodeInstanceParameter | null;
}

export interface CreateActualCollectedDocumentListOnContainer2Params {
    command?: CreateActualCollectedDocumentListOnContainer | null;
}

export interface CreateToolDefinition2Params {
    command?: CreateToolDefinition | null;
}

export interface DeleteEquipmentConfigurationProperty2Params {
    command?: DeleteEquipmentConfigurationProperty | null;
}

export interface CreateAsPlannedBOP2Params {
    command?: CreateAsPlannedBOP | null;
}

export interface DeleteTemplateToMaterialPlant2Params {
    command?: DeleteTemplateToMaterialPlant | null;
}

export interface AcceptMaterialRequest2Params {
    command?: AcceptMaterialRequest | null;
}

export interface UADMUpdateProcess2Params {
    command?: UADMUpdateProcess | null;
}

export interface AmendResultList2Params {
    command?: AmendResultList | null;
}

export interface UpdateToBeUsedMachine2Params {
    command?: UpdateToBeUsedMachine | null;
}

export interface AssociateDNCItemMachinesMaterialsAssociation2Params {
    command?: AssociateDNCItemMachinesMaterialsAssociation | null;
}

export interface CreateRuntimeCharacteristicRepresentationContainer2Params {
    command?: CreateRuntimeCharacteristicRepresentationContainer | null;
}

export interface DeleteWOOpDependencyNavigationList2Params {
    command?: DeleteWOOpDependencyNavigationList | null;
}

export interface CompleteWorkInstruction2Params {
    command?: CompleteWorkInstruction | null;
}

export interface UnlockWorkInstructionDefinition2Params {
    command?: UnlockWorkInstructionDefinition | null;
}

export interface AcceptChangeRemoveToBeConsumedMaterial2Params {
    command?: AcceptChangeRemoveToBeConsumedMaterial | null;
}

export interface APSSetInScheduled2Params {
    command?: APSSetInScheduled | null;
}

export interface CreateLogisticClass2Params {
    command?: CreateLogisticClass | null;
}

export interface Link3DPrinterTypeToMES2Params {
    command?: Link3DPrinterTypeToMES | null;
}

export interface AcceptChangeAddProcessOperation2Params {
    command?: AcceptChangeAddProcessOperation | null;
}

export interface DeleteTool2Params {
    command?: DeleteTool | null;
}

export interface LinkPJFToMaterialDefinition2Params {
    command?: LinkPJFToMaterialDefinition | null;
}

export interface UpdateCharacteristicRepresentation2Params {
    command?: UpdateCharacteristicRepresentation | null;
}

export interface DeleteDNCItem2Params {
    command?: DeleteDNCItem | null;
}

export interface DeleteAMPowderBatchGenealogy2Params {
    command?: DeleteAMPowderBatchGenealogy | null;
}

export interface CreateCustomItlkCheckParameterList2Params {
    command?: CreateCustomItlkCheckParameterList | null;
}

export interface SetConfigurationKey2Params {
    command?: SetConfigurationKey | null;
}

export interface CreateOperationStructureDependencyList2Params {
    command?: CreateOperationStructureDependencyList | null;
}

export interface CreateAndStartWorkProcessListFromProcessDefinition2Params {
    command?: CreateAndStartWorkProcessListFromProcessDefinition | null;
}

export interface CreateDM_MaterialTrackingUnitHistoryAction2Params {
    command?: CreateDM_MaterialTrackingUnitHistoryAction | null;
}

export interface TCM2CreateToolDefinitionList2Params {
    command?: TCM2CreateToolDefinitionList | null;
}

export interface UnlinkStepToOperation2Params {
    command?: UnlinkStepToOperation | null;
}

export interface CreateNonConformanceSupervisor2Params {
    command?: CreateNonConformanceSupervisor | null;
}

export interface CoProduceMaterialTrackingUnit2Params {
    command?: CoProduceMaterialTrackingUnit | null;
}

export interface GetInputResultType2Params {
    command?: GetInputResultType | null;
}

export interface LinkPrintJobFileToEquipmentType2Params {
    command?: LinkPrintJobFileToEquipmentType | null;
}

export interface LinkTransferPluginTo3DPrinter2Params {
    command?: LinkTransferPluginTo3DPrinter | null;
}

export interface CreateSnagAndNoteList2Params {
    command?: CreateSnagAndNoteList | null;
}

export interface LinkSuppliersToMaterialV4_02Params {
    command?: LinkSuppliersToMaterialV4_0 | null;
}

export interface UpdateStateMachine2Params {
    command?: UpdateStateMachine | null;
}

export interface DeleteCertification2Params {
    command?: DeleteCertification | null;
}

export interface EditWorkOrderOperation2Params {
    command?: EditWorkOrderOperation | null;
}

export interface LinkWorkInstructionsToEGPhase2Params {
    command?: LinkWorkInstructionsToEGPhase | null;
}

export interface SkipWOOperationFullQty2Params {
    command?: SkipWOOperationFullQty | null;
}

export interface APSSetInScheduling2Params {
    command?: APSSetInScheduling | null;
}

export interface AssignCertificationToSkillList2Params {
    command?: AssignCertificationToSkillList | null;
}

export interface SetDueDateOnExecGroup2Params {
    command?: SetDueDateOnExecGroup | null;
}

export interface DeleteOperationListFromCatalogue2Params {
    command?: DeleteOperationListFromCatalogue | null;
}

export interface TCM2DeleteLinkProcessToOperationList2Params {
    command?: TCM2DeleteLinkProcessToOperationList | null;
}

export interface SentenceNonConformanceV3_12Params {
    command?: SentenceNonConformanceV3_1 | null;
}

export interface DeleteStepDependencyList2Params {
    command?: DeleteStepDependencyList | null;
}

export interface GetOfflineWorkInstructions2Params {
    command?: GetOfflineWorkInstructions | null;
}

export interface UnlinkOperationListToProcess2Params {
    command?: UnlinkOperationListToProcess | null;
}

export interface DeleteEquipmentGraphLinkConfiguration2Params {
    command?: DeleteEquipmentGraphLinkConfiguration | null;
}

export interface CompleteScrewingWOOpOnToolDeactivation2Params {
    command?: CompleteScrewingWOOpOnToolDeactivation | null;
}

export interface CheckInStartWOStepTransferBatch2Params {
    command?: CheckInStartWOStepTransferBatch | null;
}

export interface CreateNonConformanceNotification2Params {
    command?: CreateNonConformanceNotification | null;
}

export interface LinkDocumentListToOperation2Params {
    command?: LinkDocumentListToOperation | null;
}

export interface LoadHandlingUnit2Params {
    command?: LoadHandlingUnit | null;
}

export interface ConsumeMaterialItemOnContainer2Params {
    command?: ConsumeMaterialItemOnContainer | null;
}

export interface SetEquipmentPropertyValue2Params {
    command?: SetEquipmentPropertyValue | null;
}

export interface CheckInConsumeMaterialItem2Params {
    command?: CheckInConsumeMaterialItem | null;
}

export interface UADMCreateNewToolDefinitionRevision2Params {
    command?: UADMCreateNewToolDefinitionRevision | null;
}

export interface AcceptChangeChangeToBeConsumedMaterialQuantity2Params {
    command?: AcceptChangeChangeToBeConsumedMaterialQuantity | null;
}

export interface DeletePauseReason2Params {
    command?: DeletePauseReason | null;
}

export interface ManageResultList2Params {
    command?: ManageResultList | null;
}

export interface AutomaticSentenceNonConformance2Params {
    command?: AutomaticSentenceNonConformance | null;
}

export interface UnlinkUserToWorkOrderOperationList2Params {
    command?: UnlinkUserToWorkOrderOperationList | null;
}

export interface CreateNonConformance2Params {
    command?: CreateNonConformance | null;
}

export interface TCM2CreateProcessList2Params {
    command?: TCM2CreateProcessList | null;
}

export interface CreateEquipmentSpecificationWithPrintJobFile2Params {
    command?: CreateEquipmentSpecificationWithPrintJobFile | null;
}

export interface UpdateOperationDependency2Params {
    command?: UpdateOperationDependency | null;
}

export interface SkipWOOperationSerialized2Params {
    command?: SkipWOOperationSerialized | null;
}

export interface DeleteSkipReason2Params {
    command?: DeleteSkipReason | null;
}

export interface UpdateCertification2Params {
    command?: UpdateCertification | null;
}

export interface LinkWIDefinitionsToWOOperation2Params {
    command?: LinkWIDefinitionsToWOOperation | null;
}

export interface CreateSkill_BOP2Params {
    command?: CreateSkill_BOP | null;
}

export interface SetEquipmentPreferencesForUser2Params {
    command?: SetEquipmentPreferencesForUser | null;
}

export interface AcceptChangeRemoveDependency2Params {
    command?: AcceptChangeRemoveDependency | null;
}

export interface UnlinkPrintJobFileToMachine2Params {
    command?: UnlinkPrintJobFileToMachine | null;
}

export interface DeleteFutureHold2Params {
    command?: DeleteFutureHold | null;
}

export interface DeleteEquipmentConfigurationPropertyAttribute2Params {
    command?: DeleteEquipmentConfigurationPropertyAttribute | null;
}

export interface CreateMaterialSpecificationList2Params {
    command?: CreateMaterialSpecificationList | null;
}

export interface ValidateDataCollectionIsComplete2Params {
    command?: ValidateDataCollectionIsComplete | null;
}

export interface TCM2CreateToolSpecificationFullList2Params {
    command?: TCM2CreateToolSpecificationFullList | null;
}

export interface DeleteCharacteristicRepresentation2Params {
    command?: DeleteCharacteristicRepresentation | null;
}

export interface AutomaticUseToolList2Params {
    command?: AutomaticUseToolList | null;
}

export interface SetConfigurationKeyList2Params {
    command?: SetConfigurationKeyList | null;
}

export interface UpdateLinkStepToOperation2Params {
    command?: UpdateLinkStepToOperation | null;
}

export interface UpdateWorkOrderOperationActualExecutionTimes2Params {
    command?: UpdateWorkOrderOperationActualExecutionTimes | null;
}

export interface CreateSkill2Params {
    command?: CreateSkill | null;
}

export interface UADMUpdateMaterialSpecification2Params {
    command?: UADMUpdateMaterialSpecification | null;
}

export interface DNCGetMachineDNCItemAssociation2Params {
    command?: DNCGetMachineDNCItemAssociation | null;
}

export interface MaterialItemSplitBatch2Params {
    command?: MaterialItemSplitBatch | null;
}

export interface UnlinkSetPointItemToSetPoint2Params {
    command?: UnlinkSetPointItemToSetPoint | null;
}

export interface ConfirmSnagAndNoteList2Params {
    command?: ConfirmSnagAndNoteList | null;
}

export interface ConfirmWorkOrder2Params {
    command?: ConfirmWorkOrder | null;
}

export interface ScheduleExecutionGroup2Params {
    command?: ScheduleExecutionGroup | null;
}

export interface AssociateContainerToWorkOrder2Params {
    command?: AssociateContainerToWorkOrder | null;
}

export interface CreateProcessList2Params {
    command?: CreateProcessList | null;
}

export interface TCM2DeleteLinkOperationToStepList2Params {
    command?: TCM2DeleteLinkOperationToStepList | null;
}

export interface AcceptChangeAddToBeUsedTool2Params {
    command?: AcceptChangeAddToBeUsedTool | null;
}

export interface DeassociateDNCItemMachineMaterialAssociation2Params {
    command?: DeassociateDNCItemMachineMaterialAssociation | null;
}

export interface DeleteUoMDimension2Params {
    command?: DeleteUoMDimension | null;
}

export interface CompleteWOOperationTransferBatch2Params {
    command?: CompleteWOOperationTransferBatch | null;
}

export interface LinkSetPointItemToSetPoint2Params {
    command?: LinkSetPointItemToSetPoint | null;
}

export interface SaveResultQuantitiesOnWorkOrderOperationList2Params {
    command?: SaveResultQuantitiesOnWorkOrderOperationList | null;
}

export interface CreateWIResultList2Params {
    command?: CreateWIResultList | null;
}

export interface UnLinkToolsFromNonConformance2Params {
    command?: UnLinkToolsFromNonConformance | null;
}

export interface AssignCertificationToUserList2Params {
    command?: AssignCertificationToUserList | null;
}

export interface EndIdTemplateEditing2Params {
    command?: EndIdTemplateEditing | null;
}

export interface LinkDocumentListToEGPhase2Params {
    command?: LinkDocumentListToEGPhase | null;
}

export interface ManageRepeatResultForScrappedMTU2Params {
    command?: ManageRepeatResultForScrappedMTU | null;
}

export interface DeleteProducedMaterialUnderRework2Params {
    command?: DeleteProducedMaterialUnderRework | null;
}

export interface DeleteWorkOrderNotificationList2Params {
    command?: DeleteWorkOrderNotificationList | null;
}

export interface DeleteWorkOStepDependency2Params {
    command?: DeleteWorkOStepDependency | null;
}

export interface DeleteHoldReason2Params {
    command?: DeleteHoldReason | null;
}

export interface LinkCharacteristicRepresentationToOperation2Params {
    command?: LinkCharacteristicRepresentationToOperation | null;
}

export interface ManageToBeConsumedMaterialDisassemble2Params {
    command?: ManageToBeConsumedMaterialDisassemble | null;
}

export interface LinkMaterialTrackingUnitToContainerList2Params {
    command?: LinkMaterialTrackingUnitToContainerList | null;
}

export interface AssignNonConformanceTransitionRoleList2Params {
    command?: AssignNonConformanceTransitionRoleList | null;
}

export interface CheckInPauseWOOperation2Params {
    command?: CheckInPauseWOOperation | null;
}

export interface CreateOperationStructureDependency2Params {
    command?: CreateOperationStructureDependency | null;
}

export interface CreateStateMachine2Params {
    command?: CreateStateMachine | null;
}

export interface DeleteStatusTransition2Params {
    command?: DeleteStatusTransition | null;
}

export interface UnLinkWorkInstructionDefinitionListFromStep2Params {
    command?: UnLinkWorkInstructionDefinitionListFromStep | null;
}

export interface StartWOStepTransferBatch2Params {
    command?: StartWOStepTransferBatch | null;
}

export interface CreateWorkOrderNotification2Params {
    command?: CreateWorkOrderNotification | null;
}

export interface UnlinkUserToPlant2Params {
    command?: UnlinkUserToPlant | null;
}

export interface CreateDefectGroup2Params {
    command?: CreateDefectGroup | null;
}

export interface CheckMaterialConsumption2Params {
    command?: CheckMaterialConsumption | null;
}

export interface GetResolvedToBeUsedMachinesOnWOOperationList2Params {
    command?: GetResolvedToBeUsedMachinesOnWOOperationList | null;
}

export interface LinkAutomationNodeInstanceParameterToMaterialParameterList2Params {
    command?: LinkAutomationNodeInstanceParameterToMaterialParameterList | null;
}

export interface CreateUoMFactor2Params {
    command?: CreateUoMFactor | null;
}

export interface CreateWorkOrderHistoryAction2Params {
    command?: CreateWorkOrderHistoryAction | null;
}

export interface CreateContainerType2Params {
    command?: CreateContainerType | null;
}

export interface CreateHierarchyEquipmentNodeConfigurations2Params {
    command?: CreateHierarchyEquipmentNodeConfigurations | null;
}

export interface UADMCreateNewProcessRevisionMasterPlan2Params {
    command?: UADMCreateNewProcessRevisionMasterPlan | null;
}

export interface AssignCertificationToLocationList2Params {
    command?: AssignCertificationToLocationList | null;
}

export interface CompleteWOStepTransferBatch2Params {
    command?: CompleteWOStepTransferBatch | null;
}

export interface DeleteMaterialList2Params {
    command?: DeleteMaterialList | null;
}

export interface StartNonProductiveActivityList2Params {
    command?: StartNonProductiveActivityList | null;
}

export interface DeleteToBeConsumedMaterial2Params {
    command?: DeleteToBeConsumedMaterial | null;
}

export interface UpdateEquipmentLevel2Params {
    command?: UpdateEquipmentLevel | null;
}

export interface LinkItlkCheckToProcessToOpLinkList2Params {
    command?: LinkItlkCheckToProcessToOpLinkList | null;
}

export interface CreateFailure2Params {
    command?: CreateFailure | null;
}

export interface DeleteDNCItemMachineMaterialAssociation2Params {
    command?: DeleteDNCItemMachineMaterialAssociation | null;
}

export interface SentenceNonConformanceSetLocationHold2Params {
    command?: SentenceNonConformanceSetLocationHold | null;
}

export interface RemoveWorkOrderScrap2Params {
    command?: RemoveWorkOrderScrap | null;
}

export interface UpdateDM_MaterialTrackingUnitHistory2Params {
    command?: UpdateDM_MaterialTrackingUnitHistory | null;
}

export interface CreateStatusTransition2Params {
    command?: CreateStatusTransition | null;
}

export interface SetEquipmentPropertyAttributeValue2Params {
    command?: SetEquipmentPropertyAttributeValue | null;
}

export interface ReopenWorkOrderOperationTransferBatch2Params {
    command?: ReopenWorkOrderOperationTransferBatch | null;
}

export interface ManageToBeConsumedMaterialDisassembleOnContainer2Params {
    command?: ManageToBeConsumedMaterialDisassembleOnContainer | null;
}

export interface UnlinkWorkInstructionsFromWOOperation2Params {
    command?: UnlinkWorkInstructionsFromWOOperation | null;
}

export interface SetLocationHold2Params {
    command?: SetLocationHold | null;
}

export interface LinkToolSpecificationToOperation2Params {
    command?: LinkToolSpecificationToOperation | null;
}

export interface RemoveCertificationToSkillList2Params {
    command?: RemoveCertificationToSkillList | null;
}

export interface LinkMaterialItemToBuffer2Params {
    command?: LinkMaterialItemToBuffer | null;
}

export interface GetOfflineWorkInstructionDefinitions2Params {
    command?: GetOfflineWorkInstructionDefinitions | null;
}

export interface UADMCreateProcess2Params {
    command?: UADMCreateProcess | null;
}

export interface UpdateStatus2Params {
    command?: UpdateStatus | null;
}

export interface ManageNullResultOnKoWOOperationList2Params {
    command?: ManageNullResultOnKoWOOperationList | null;
}

export interface CreateDNCItemMachineMaterialAssociation2Params {
    command?: CreateDNCItemMachineMaterialAssociation | null;
}

export interface GenerateMaterialBatchId2Params {
    command?: GenerateMaterialBatchId | null;
}

export interface DeleteHierarchyEquipmentNodeConfiguration2Params {
    command?: DeleteHierarchyEquipmentNodeConfiguration | null;
}

export interface LinkWorkInstructionDefinitionListToOperation2Params {
    command?: LinkWorkInstructionDefinitionListToOperation | null;
}

export interface UpdateNonConformanceHistory2Params {
    command?: UpdateNonConformanceHistory | null;
}

export interface DeleteEquipmentConfigurationStateMachine2Params {
    command?: DeleteEquipmentConfigurationStateMachine | null;
}

export interface TCM2CreateStepList2Params {
    command?: TCM2CreateStepList | null;
}

export interface DeleteActualConsumedMaterial2Params {
    command?: DeleteActualConsumedMaterial | null;
}

export interface DeleteNonConformanceResource2Params {
    command?: DeleteNonConformanceResource | null;
}

export interface SentencingChangeNonConformance2Params {
    command?: SentencingChangeNonConformance | null;
}

export interface DeleteWorkOperationTypeList2Params {
    command?: DeleteWorkOperationTypeList | null;
}

export interface CreateMaterialGroup2Params {
    command?: CreateMaterialGroup | null;
}

export interface CheckInDataCollection2Params {
    command?: CheckInDataCollection | null;
}

export interface DeleteToBeUsedTool2Params {
    command?: DeleteToBeUsedTool | null;
}

export interface DeleteNonConformanceAttachmentList2Params {
    command?: DeleteNonConformanceAttachmentList | null;
}

export interface UpdateSerialNumberList2Params {
    command?: UpdateSerialNumberList | null;
}

export interface UpdateDefectType2Params {
    command?: UpdateDefectType | null;
}

export interface GenerateSerialNumberCode2Params {
    command?: GenerateSerialNumberCode | null;
}

export interface AssignCertificationToMaterialList2Params {
    command?: AssignCertificationToMaterialList | null;
}

export interface CreateDM_Material2Params {
    command?: CreateDM_Material | null;
}

export interface UpdateDefectGroup2Params {
    command?: UpdateDefectGroup | null;
}

export interface UpdateHold2Params {
    command?: UpdateHold | null;
}

export interface DeleteProcessNotificationList2Params {
    command?: DeleteProcessNotificationList | null;
}

export interface TriggerPrintingOnWorkOrderStep2Params {
    command?: TriggerPrintingOnWorkOrderStep | null;
}

export interface UADMDeleteEquipmentSpecificationList2Params {
    command?: UADMDeleteEquipmentSpecificationList | null;
}

export interface CreateProducedMaterialUnderRework2Params {
    command?: CreateProducedMaterialUnderRework | null;
}

export interface UpdateWorkInstructionDefinition2Params {
    command?: UpdateWorkInstructionDefinition | null;
}

export interface LinkMaterialToContainerList2Params {
    command?: LinkMaterialToContainerList | null;
}

export interface UpdateUoMFactor2Params {
    command?: UpdateUoMFactor | null;
}

export interface UnVerifyWorkOrder2Params {
    command?: UnVerifyWorkOrder | null;
}

export interface StartWOOperationTransferBatch2Params {
    command?: StartWOOperationTransferBatch | null;
}

export interface CreateEquipmentConfigurationByDefaultEquipmentType2Params {
    command?: CreateEquipmentConfigurationByDefaultEquipmentType | null;
}

export interface LinkUsersToTeam2Params {
    command?: LinkUsersToTeam | null;
}

export interface CreateBuffer2Params {
    command?: CreateBuffer | null;
}

export interface UnlinkToolDefinitionToAutomationNodeTypeList2Params {
    command?: UnlinkToolDefinitionToAutomationNodeTypeList | null;
}

export interface CreateEquipmentGraphType2Params {
    command?: CreateEquipmentGraphType | null;
}

export interface SaveDocumentForPreview2Params {
    command?: SaveDocumentForPreview | null;
}

export interface CreateVisualCharacteristicSpecification2Params {
    command?: CreateVisualCharacteristicSpecification | null;
}

export interface SentenceBuyOff2Params {
    command?: SentenceBuyOff | null;
}

export interface CreateOfflineSession2Params {
    command?: CreateOfflineSession | null;
}

export interface CreateStepRevisionSubStructure2Params {
    command?: CreateStepRevisionSubStructure | null;
}

export interface SkipWOOperationTransferBatch2Params {
    command?: SkipWOOperationTransferBatch | null;
}

export interface UpdateContainerType2Params {
    command?: UpdateContainerType | null;
}

export interface CreateAttributiveCharacteristicSpecification2Params {
    command?: CreateAttributiveCharacteristicSpecification | null;
}

export interface GetPJFsHookOnLinkActualUsedMachinePJF2Params {
    command?: GetPJFsHookOnLinkActualUsedMachinePJF | null;
}

export interface DeleteEquipmentType2Params {
    command?: DeleteEquipmentType | null;
}

export interface UpdateMaterialAndDM_Material2Params {
    command?: UpdateMaterialAndDM_Material | null;
}

export interface LinkBufferDefinitionToMaterialDefList2Params {
    command?: LinkBufferDefinitionToMaterialDefList | null;
}

export interface LinkBufferDefinitionToToolDefList2Params {
    command?: LinkBufferDefinitionToToolDefList | null;
}

export interface TCM2LinkProcessToOperationFullList2Params {
    command?: TCM2LinkProcessToOperationFullList | null;
}

export interface CreateHandlingUnitHistory2Params {
    command?: CreateHandlingUnitHistory | null;
}

export interface UnlinkToBeUsedMachineToPJF2Params {
    command?: UnlinkToBeUsedMachineToPJF | null;
}

export interface CreateNonProductiveActivity2Params {
    command?: CreateNonProductiveActivity | null;
}

export interface CompleteCheckIn2Params {
    command?: CompleteCheckIn | null;
}

export interface UpdateOperationStepCategory2Params {
    command?: UpdateOperationStepCategory | null;
}

export interface LinkWIDefinitionsToEGPhase2Params {
    command?: LinkWIDefinitionsToEGPhase | null;
}

export interface UpdateCharacteristicSpecification2Params {
    command?: UpdateCharacteristicSpecification | null;
}

export interface GetWIParameterValues2Params {
    command?: GetWIParameterValues | null;
}

export interface SetOperationStepCategoryProcessDefinitionActiveStatus2Params {
    command?: SetOperationStepCategoryProcessDefinitionActiveStatus | null;
}

export interface CreateToBeConsumedMaterials2Params {
    command?: CreateToBeConsumedMaterials | null;
}

export interface DeleteActualProducedMaterial2Params {
    command?: DeleteActualProducedMaterial | null;
}

export interface UnlinkProcessToAsPlannedBOP2Params {
    command?: UnlinkProcessToAsPlannedBOP | null;
}

export interface UADMCreateOperation2Params {
    command?: UADMCreateOperation | null;
}

export interface UnlinkSkillsFromWOOperation2Params {
    command?: UnlinkSkillsFromWOOperation | null;
}

export interface DeleteMachineToDNC2Params {
    command?: DeleteMachineToDNC | null;
}

export interface DeleteResultsFromWOOperations2Params {
    command?: DeleteResultsFromWOOperations | null;
}

export interface CreateNewProcessRevision2Params {
    command?: CreateNewProcessRevision | null;
}

export interface CheckIdTemplateEditing2Params {
    command?: CheckIdTemplateEditing | null;
}

export interface TCM2CompleteAsPlannedBOP2Params {
    command?: TCM2CompleteAsPlannedBOP | null;
}

export interface CreateCharacteristicSpecification2Params {
    command?: CreateCharacteristicSpecification | null;
}

export interface ConfirmWorkOrderOperation2Params {
    command?: ConfirmWorkOrderOperation | null;
}

export interface DeleteEquipmentTypeStateMachine2Params {
    command?: DeleteEquipmentTypeStateMachine | null;
}

export interface CreateBufferDefinitionRevision2Params {
    command?: CreateBufferDefinitionRevision | null;
}

export interface DNCPreviewDNCItem2Params {
    command?: DNCPreviewDNCItem | null;
}

export interface ReopenWorkOrderOperationList2Params {
    command?: ReopenWorkOrderOperationList | null;
}

export interface ManageNullResultOnKoWorkOrderOperation2Params {
    command?: ManageNullResultOnKoWorkOrderOperation | null;
}

export interface ExecuteCustomItlkCheckInbound2Params {
    command?: ExecuteCustomItlkCheckInbound | null;
}

export interface UnlinkProcessToProcess2Params {
    command?: UnlinkProcessToProcess | null;
}

export interface UnLinkMaterialItemFromBuffer2Params {
    command?: UnLinkMaterialItemFromBuffer | null;
}

export interface LinkItlkCheckToWorkOrderStepList2Params {
    command?: LinkItlkCheckToWorkOrderStepList | null;
}

export interface LinkSkillsToStep2Params {
    command?: LinkSkillsToStep | null;
}

export interface AmendOfflineAction2Params {
    command?: AmendOfflineAction | null;
}

export interface UpdateEquipmentType2Params {
    command?: UpdateEquipmentType | null;
}

export interface TCM2LinkProcessToProcessFullList2Params {
    command?: TCM2LinkProcessToProcessFullList | null;
}

export interface UpdateNonProductiveActivity2Params {
    command?: UpdateNonProductiveActivity | null;
}

export interface LinkAutomationNodeInstanceParameterToToolDefinitionParameterList2Params {
    command?: LinkAutomationNodeInstanceParameterToToolDefinitionParameterList | null;
}

export interface LinkToolDefinitionToAutomationNodeTypeList2Params {
    command?: LinkToolDefinitionToAutomationNodeTypeList | null;
}

export interface CreateMaterialDefinitionDocumentList2Params {
    command?: CreateMaterialDefinitionDocumentList | null;
}

export interface UnlinkItlkCheckToWorkOrderOperationList2Params {
    command?: UnlinkItlkCheckToWorkOrderOperationList | null;
}

export interface SetWorkInstructionTemplateAsDefault2Params {
    command?: SetWorkInstructionTemplateAsDefault | null;
}

export interface SetNonConformanceStatusIsClosedOk2Params {
    command?: SetNonConformanceStatusIsClosedOk | null;
}

export interface UnlinkToolToSetPoint2Params {
    command?: UnlinkToolToSetPoint | null;
}

export interface RemoveDefectGroupContextualization2Params {
    command?: RemoveDefectGroupContextualization | null;
}

export interface ManageResultsForSkippedOperations2Params {
    command?: ManageResultsForSkippedOperations | null;
}

export interface ManageRepeatOfKoWorkOrderOperation2Params {
    command?: ManageRepeatOfKoWorkOrderOperation | null;
}

export interface ConsumeMaterialItemLite2Params {
    command?: ConsumeMaterialItemLite | null;
}

export interface CreateCertification2Params {
    command?: CreateCertification | null;
}

export interface CheckCertification2Params {
    command?: CheckCertification | null;
}

export interface CreateTransportOperation2Params {
    command?: CreateTransportOperation | null;
}

export interface UpdateToolDefinition2Params {
    command?: UpdateToolDefinition | null;
}

export interface CreateWorkOrderStepFromMPProcessStep2Params {
    command?: CreateWorkOrderStepFromMPProcessStep | null;
}

export interface ManageResultWorkOrderOperationNIdForSplitWorkOrder2Params {
    command?: ManageResultWorkOrderOperationNIdForSplitWorkOrder | null;
}

export interface AmendOfResultToRepeatMaterialConsumption2Params {
    command?: AmendOfResultToRepeatMaterialConsumption | null;
}

export interface UnlinkWorkInstructionDefinitionListFromOperation2Params {
    command?: UnlinkWorkInstructionDefinitionListFromOperation | null;
}

export interface CreateToolSpecification2Params {
    command?: CreateToolSpecification | null;
}

export interface DeleteToBeUsedDocument2Params {
    command?: DeleteToBeUsedDocument | null;
}

export interface RemoveCertificationToLocationList2Params {
    command?: RemoveCertificationToLocationList | null;
}

export interface CreateExecutionGroupPhase2Params {
    command?: CreateExecutionGroupPhase | null;
}

export interface UnlinkATNTypeParameterFromToolDefinitionSetPointItemList2Params {
    command?: UnlinkATNTypeParameterFromToolDefinitionSetPointItemList | null;
}

export interface UpdateMaterialTrackingUnitAndDM_MaterialTrackingUnit2Params {
    command?: UpdateMaterialTrackingUnitAndDM_MaterialTrackingUnit | null;
}

export interface UnlinkToolSpecificationToOperation2Params {
    command?: UnlinkToolSpecificationToOperation | null;
}

export interface UnlinkToBeUsedMachineToPJFFromLogicalKey2Params {
    command?: UnlinkToBeUsedMachineToPJFFromLogicalKey | null;
}

export interface PunchOutUsers2Params {
    command?: PunchOutUsers | null;
}

export interface SetWorkOrderOperationEstimatedTimes2Params {
    command?: SetWorkOrderOperationEstimatedTimes | null;
}

export interface DeletePrintJobFileList2Params {
    command?: DeletePrintJobFileList | null;
}

export interface DeleteContainerTypeList2Params {
    command?: DeleteContainerTypeList | null;
}

export interface LinkActualUsedMachineToPJF2Params {
    command?: LinkActualUsedMachineToPJF | null;
}

export interface GetValidMachinesWOOpIds2Params {
    command?: GetValidMachinesWOOpIds | null;
}

export interface SelectMTUForPartBasedInspection2Params {
    command?: SelectMTUForPartBasedInspection | null;
}

export interface CreateNonConformanceItem2Params {
    command?: CreateNonConformanceItem | null;
}

export interface CreateNonConformanceResource2Params {
    command?: CreateNonConformanceResource | null;
}

export interface EditMaterialItemsLinkedToHandlingUnit2Params {
    command?: EditMaterialItemsLinkedToHandlingUnit | null;
}

export interface CreateDefectGroupContextualization2Params {
    command?: CreateDefectGroupContextualization | null;
}

export interface LinkATNTypeParameterToToolDefinitionSetPointItemList2Params {
    command?: LinkATNTypeParameterToToolDefinitionSetPointItemList | null;
}

export interface UnlinkToolToAutomationNodeInstanceList2Params {
    command?: UnlinkToolToAutomationNodeInstanceList | null;
}

export interface CreateProcessRevisionSubStructure2Params {
    command?: CreateProcessRevisionSubStructure | null;
}

export interface CreateWorkOrderOperations2Params {
    command?: CreateWorkOrderOperations | null;
}

export interface CreateCustomItlkCheckList2Params {
    command?: CreateCustomItlkCheckList | null;
}

export interface UnlinkPJFToMaterialDefinition2Params {
    command?: UnlinkPJFToMaterialDefinition | null;
}

export interface UnlinkItlkCheckToOperationToStepLinkList2Params {
    command?: UnlinkItlkCheckToOperationToStepLinkList | null;
}

export interface UnlinkMaterialTrackingUnitFromContainerList2Params {
    command?: UnlinkMaterialTrackingUnitFromContainerList | null;
}

export interface UpdateEquipmentTypePropertyAttribute2Params {
    command?: UpdateEquipmentTypePropertyAttribute | null;
}

export interface SetIsValid2Params {
    command?: SetIsValid | null;
}

export interface TCM2DeleteLinkProcessToProcessList2Params {
    command?: TCM2DeleteLinkProcessToProcessList | null;
}

export interface UnLinkMaterialItemsFromHandlingUnit2Params {
    command?: UnLinkMaterialItemsFromHandlingUnit | null;
}

export interface CreateDM_MaterialTrackingUnitandMaterialTrackingUnit2Params {
    command?: CreateDM_MaterialTrackingUnitandMaterialTrackingUnit | null;
}

export interface ChangeSubstrateStatusByThresholds2Params {
    command?: ChangeSubstrateStatusByThresholds | null;
}

export interface DeleteMaterialGroup2Params {
    command?: DeleteMaterialGroup | null;
}

export interface UseToolListOnContainer2Params {
    command?: UseToolListOnContainer | null;
}

export interface CreateProcessToOpLinkDependencyNavigationList2Params {
    command?: CreateProcessToOpLinkDependencyNavigationList | null;
}

export interface DeactivateMaterialTrackingUnitOnScrewingTool2Params {
    command?: DeactivateMaterialTrackingUnitOnScrewingTool | null;
}

export interface CreateNewOperationRevision2Params {
    command?: CreateNewOperationRevision | null;
}

export interface DeleteWorkOrderStep2Params {
    command?: DeleteWorkOrderStep | null;
}

export interface DeleteExecutionGroups2Params {
    command?: DeleteExecutionGroups | null;
}

export interface RemoveLocationHold2Params {
    command?: RemoveLocationHold | null;
}

export interface UnlinkProcessToProcessList2Params {
    command?: UnlinkProcessToProcessList | null;
}

export interface UpdateEquipmentGroupConfiguration2Params {
    command?: UpdateEquipmentGroupConfiguration | null;
}

export interface UpdateWorkInstructionTemplate2Params {
    command?: UpdateWorkInstructionTemplate | null;
}

export interface UADMCreateOperationInCatalogue2Params {
    command?: UADMCreateOperationInCatalogue | null;
}

export interface UnLinkEquipmentsToBuffers2Params {
    command?: UnLinkEquipmentsToBuffers | null;
}

export interface UpdateSetPoint2Params {
    command?: UpdateSetPoint | null;
}

export interface UpdateTool2Params {
    command?: UpdateTool | null;
}

export interface CreateStepInOperation2Params {
    command?: CreateStepInOperation | null;
}

export interface SplitAndLinkMaterialItemsToHandlingUnit2Params {
    command?: SplitAndLinkMaterialItemsToHandlingUnit | null;
}

export interface LinkToBeUsedMachineToPJFForEGPhase2Params {
    command?: LinkToBeUsedMachineToPJFForEGPhase | null;
}

export interface CreateLogisticRequest2Params {
    command?: CreateLogisticRequest | null;
}

export interface LinkMaterialItemsToNonConformance2Params {
    command?: LinkMaterialItemsToNonConformance | null;
}

export interface PauseExecutionGroupPhase2Params {
    command?: PauseExecutionGroupPhase | null;
}

export interface UpdateEquipmentTypeProperty2Params {
    command?: UpdateEquipmentTypeProperty | null;
}

export interface CreateUoMDimension2Params {
    command?: CreateUoMDimension | null;
}

export interface StartTransportOperation2Params {
    command?: StartTransportOperation | null;
}

export interface UpdateWOOpQuantityAssociatedToEG2Params {
    command?: UpdateWOOpQuantityAssociatedToEG | null;
}

export interface CompleteExecutionGroupPhase2Params {
    command?: CompleteExecutionGroupPhase | null;
}

export interface UpdateBuffer2Params {
    command?: UpdateBuffer | null;
}

export interface UpdateStepDependency2Params {
    command?: UpdateStepDependency | null;
}

export interface AmendOfResultToRepeat2Params {
    command?: AmendOfResultToRepeat | null;
}

export interface CompleteAsPlannedBOP2Params {
    command?: CompleteAsPlannedBOP | null;
}

export interface TransmitEquipmentSetPointToAutomationNodeParameters2Params {
    command?: TransmitEquipmentSetPointToAutomationNodeParameters | null;
}

export interface AcquireDCItemValueFromAutomationNodeInstanceParameter2Params {
    command?: AcquireDCItemValueFromAutomationNodeInstanceParameter | null;
}

export interface UpdateUoM2Params {
    command?: UpdateUoM | null;
}

export interface UnlinkItlkCheckToProcessToOpLinkList2Params {
    command?: UnlinkItlkCheckToProcessToOpLinkList | null;
}

export interface UpdateAttributiveCharacteristicSpecification2Params {
    command?: UpdateAttributiveCharacteristicSpecification | null;
}

export interface UpdateVisualCharacteristicSpecification2Params {
    command?: UpdateVisualCharacteristicSpecification | null;
}

export interface UpdateMachineToDNC2Params {
    command?: UpdateMachineToDNC | null;
}

export interface GenerateSerialNumberCodes2Params {
    command?: GenerateSerialNumberCodes | null;
}

export interface DeleteActualUsedMachinePJF2Params {
    command?: DeleteActualUsedMachinePJF | null;
}

export interface CheckInCompleteWOStepSerialized2Params {
    command?: CheckInCompleteWOStepSerialized | null;
}

export interface DeassociateDNCItemMachineMaterialsAssociation2Params {
    command?: DeassociateDNCItemMachineMaterialsAssociation | null;
}

export interface CreateWorkOrderHistoryMaterialItem2Params {
    command?: CreateWorkOrderHistoryMaterialItem | null;
}

export interface UnlinkDocumentFromContainerTypeList2Params {
    command?: UnlinkDocumentFromContainerTypeList | null;
}

export interface LinkDocumentToOperation2Params {
    command?: LinkDocumentToOperation | null;
}

export interface DeleteMaterialClassList2Params {
    command?: DeleteMaterialClassList | null;
}

export interface LinkSubstrateToMachine2Params {
    command?: LinkSubstrateToMachine | null;
}

export interface UnlinkSkillsToStep2Params {
    command?: UnlinkSkillsToStep | null;
}

export interface UADMUpdateToolSpecification2Params {
    command?: UADMUpdateToolSpecification | null;
}

export interface CreateWorkOrderHeader2Params {
    command?: CreateWorkOrderHeader | null;
}

export interface DeleteEquipmentGraphNodeConfiguration2Params {
    command?: DeleteEquipmentGraphNodeConfiguration | null;
}

export interface UADMAutomaticStart2Params {
    command?: UADMAutomaticStart | null;
}

export interface CreateNewStepRevisionInOperation2Params {
    command?: CreateNewStepRevisionInOperation | null;
}

export interface CreateNonConformanceTransition2Params {
    command?: CreateNonConformanceTransition | null;
}

export interface UpdateWorkOOperationDependency2Params {
    command?: UpdateWorkOOperationDependency | null;
}

export interface CompleteWOOperationFullQty2Params {
    command?: CompleteWOOperationFullQty | null;
}

export interface CompleteWOStepSerialized2Params {
    command?: CompleteWOStepSerialized | null;
}

export interface AcceptChangeRemoveOperation2Params {
    command?: AcceptChangeRemoveOperation | null;
}

export interface CompleteWOOperationsSerializedLite2Params {
    command?: CompleteWOOperationsSerializedLite | null;
}

export interface LinkAMMachineToMES2Params {
    command?: LinkAMMachineToMES | null;
}

export interface DNCTransferDNCItem2Params {
    command?: DNCTransferDNCItem | null;
}

export interface TCM2CreateDocumentList2Params {
    command?: TCM2CreateDocumentList | null;
}

export interface UpdateDefect2Params {
    command?: UpdateDefect | null;
}

export interface RemoveNonConformanceTransitionRoleList2Params {
    command?: RemoveNonConformanceTransitionRoleList | null;
}

export interface DeleteStatusDefinition2Params {
    command?: DeleteStatusDefinition | null;
}

export interface UnlinkOperationStepCategoryFromProcessDefinitionList2Params {
    command?: UnlinkOperationStepCategoryFromProcessDefinitionList | null;
}

export interface UpdateItlkCheckWOStepAssociationList2Params {
    command?: UpdateItlkCheckWOStepAssociationList | null;
}

export interface CreateProcessNotification2Params {
    command?: CreateProcessNotification | null;
}

export interface CreateFutureHold2Params {
    command?: CreateFutureHold | null;
}

export interface CreateEquipmentGraphLinkConfiguration2Params {
    command?: CreateEquipmentGraphLinkConfiguration | null;
}

export interface DeleteProcessList2Params {
    command?: DeleteProcessList | null;
}

export interface UpdateActualUsedTool2Params {
    command?: UpdateActualUsedTool | null;
}

export interface DeleteOperationFromCatalogue2Params {
    command?: DeleteOperationFromCatalogue | null;
}

export interface CompleteWOOperationSerialized2Params {
    command?: CompleteWOOperationSerialized | null;
}

export interface UpdateItlkCheckOperationStepCategoryAssociationList2Params {
    command?: UpdateItlkCheckOperationStepCategoryAssociationList | null;
}

export interface DeleteTemplateBlock2Params {
    command?: DeleteTemplateBlock | null;
}

export interface SetExecGroupListInEditStatus2Params {
    command?: SetExecGroupListInEditStatus | null;
}

export interface DeleteMaterialDefinitionDocument2Params {
    command?: DeleteMaterialDefinitionDocument | null;
}

export interface UnLinkToBeUsedMachineToPJFForEGPhase2Params {
    command?: UnLinkToBeUsedMachineToPJFForEGPhase | null;
}

export interface UpdateWorkInstructionDefinitionParameter2Params {
    command?: UpdateWorkInstructionDefinitionParameter | null;
}

export interface TCM2LinkOperationToStepFullList2Params {
    command?: TCM2LinkOperationToStepFullList | null;
}

export interface TCM2CreateMasterPlan2Params {
    command?: TCM2CreateMasterPlan | null;
}

export interface CreateWorkOrderOperationFromMPProcessOperation2Params {
    command?: CreateWorkOrderOperationFromMPProcessOperation | null;
}

export interface CheckInStartWOStepSerialized2Params {
    command?: CheckInStartWOStepSerialized | null;
}

export interface UADMCreateMaterialSpecification2Params {
    command?: UADMCreateMaterialSpecification | null;
}

export interface CreateWOOpDependencyNavigationMTUAssociation2Params {
    command?: CreateWOOpDependencyNavigationMTUAssociation | null;
}

export interface CreateDefectType2Params {
    command?: CreateDefectType | null;
}

export interface CreateToBeUsedMachine2Params {
    command?: CreateToBeUsedMachine | null;
}

export interface UnlinkToolDefinitionToSetPoint2Params {
    command?: UnlinkToolDefinitionToSetPoint | null;
}

export interface ToolMaintenance2Params {
    command?: ToolMaintenance | null;
}

export interface LinkATNInstanceParameterToSetPointItemList2Params {
    command?: LinkATNInstanceParameterToSetPointItemList | null;
}

export interface AssignCertificationToRoleList2Params {
    command?: AssignCertificationToRoleList | null;
}

export interface LinkOperationDependencyToProcess2Params {
    command?: LinkOperationDependencyToProcess | null;
}

export interface CheckInStartWOStepFullQty2Params {
    command?: CheckInStartWOStepFullQty | null;
}

export interface DeleteNonConformanceItem2Params {
    command?: DeleteNonConformanceItem | null;
}

export interface LinkDocumentListToStep2Params {
    command?: LinkDocumentListToStep | null;
}

export interface RemoveDefectTypeContextualization2Params {
    command?: RemoveDefectTypeContextualization | null;
}

export interface LoadContainer2Params {
    command?: LoadContainer | null;
}

export interface CreateMachineToDNC2Params {
    command?: CreateMachineToDNC | null;
}

export interface RemoveCertificationToUserList2Params {
    command?: RemoveCertificationToUserList | null;
}

export interface ChangeOfflineSessionStatus2Params {
    command?: ChangeOfflineSessionStatus | null;
}

export interface ToolAGW_DisassociateAutomationNodeInstancesFromEquipmentConfiguration2Params {
    command?: ToolAGW_DisassociateAutomationNodeInstancesFromEquipmentConfiguration | null;
}

export interface ToolAGW_AssociateAutomationNodeInstancesWithEquipmentConfiguration2Params {
    command?: ToolAGW_AssociateAutomationNodeInstancesWithEquipmentConfiguration | null;
}

export interface APPMain_GF_ImportLOIPRO2Params {
    command?: APPMain_GF_ImportLOIPRO | null;
}

export interface APPMain_GF_ImportMATMAS2Params {
    command?: APPMain_GF_ImportMATMAS | null;
}

export interface APPMain_GF_KeepWorkerAlive_12Params {
    command?: APPMain_GF_KeepWorkerAlive_1 | null;
}

export interface APPMain_GF_KeepWorkerAlive_22Params {
    command?: APPMain_GF_KeepWorkerAlive_2 | null;
}

export interface APPMain_GF_KeepWorkerAlive_32Params {
    command?: APPMain_GF_KeepWorkerAlive_3 | null;
}

export interface APPMain_GF_KeepWorkerAlive_42Params {
    command?: APPMain_GF_KeepWorkerAlive_4 | null;
}

export interface APPMain_GF_KeepWorkerAlive_52Params {
    command?: APPMain_GF_KeepWorkerAlive_5 | null;
}

export interface APPMain_GF_CreateKeepAliveWorkerTimer2Params {
    command?: APPMain_GF_CreateKeepAliveWorkerTimer | null;
}

export interface APPMain_GF_HandleScanFromShopfloor2Params {
    command?: APPMain_GF_HandleScanFromShopfloor | null;
}

export interface APPMain_GF_ImportMATMAS_CNMOM2Params {
    command?: APPMain_GF_ImportMATMAS_CNMOM | null;
}

export interface APPMain_GF_ImportLOIPRO_CNMOM2Params {
    command?: APPMain_GF_ImportLOIPRO_CNMOM | null;
}

export interface APPMain_GF_ActivateAndStartTask2Params {
    command?: APPMain_GF_ActivateAndStartTask | null;
}

export interface APPMain_GF_InsertLineRoutingEntry2Params {
    command?: APPMain_GF_InsertLineRoutingEntry | null;
}

export interface APPMain_GF_InsertScanDiagnostic2Params {
    command?: APPMain_GF_InsertScanDiagnostic | null;
}

export interface APPMain_GF_CreateMaterial2Params {
    command?: APPMain_GF_CreateMaterial | null;
}

export interface APPMain_GF_OnEngraverHandshakeSent2Params {
    command?: APPMain_GF_OnEngraverHandshakeSent | null;
}

export interface APPMain_GF_DeleteProductWaitingForValidation2Params {
    command?: APPMain_GF_DeleteProductWaitingForValidation | null;
}

export interface APPMain_GF_ManageWetTestResult2Params {
    command?: APPMain_GF_ManageWetTestResult | null;
}

export interface APPMain_GF_CreateWorkOrderFromLOIPRO2Params {
    command?: APPMain_GF_CreateWorkOrderFromLOIPRO | null;
}

export interface APPMain_GF_UpdateLineRoutingEntry2Params {
    command?: APPMain_GF_UpdateLineRoutingEntry | null;
}

export interface APPMain_GF_DeleteRunningScan2Params {
    command?: APPMain_GF_DeleteRunningScan | null;
}

export interface APPMain_GF_ManageScanFromShopfloor2Params {
    command?: APPMain_GF_ManageScanFromShopfloor | null;
}

export interface APPMain_GF_UpsertOperationExtensions2Params {
    command?: APPMain_GF_UpsertOperationExtensions | null;
}

export interface APPMain_GF_SendMessageToHALP2Params {
    command?: APPMain_GF_SendMessageToHALP | null;
}

export interface APPMain_GF_DeleteLineRoutingEntry2Params {
    command?: APPMain_GF_DeleteLineRoutingEntry | null;
}

export interface APPMain_GF_CreateUoM2Params {
    command?: APPMain_GF_CreateUoM | null;
}

export interface APPMain_GF_OnPackagingHandshakeSent2Params {
    command?: APPMain_GF_OnPackagingHandshakeSent | null;
}

export interface APPMain_GF_UpdateProductWaitingForValidation2Params {
    command?: APPMain_GF_UpdateProductWaitingForValidation | null;
}

export interface APPMain_GF_StartRequestDocuments2Params {
    command?: APPMain_GF_StartRequestDocuments | null;
}

export interface APPMain_GF_InsertProductWaitingForValidation2Params {
    command?: APPMain_GF_InsertProductWaitingForValidation | null;
}

export interface APPMain_GF_SendEngraverPrinterData2Params {
    command?: APPMain_GF_SendEngraverPrinterData | null;
}

export interface APPMain_GF_CloseOperationSignalHandler2Params {
    command?: APPMain_GF_CloseOperationSignalHandler | null;
}

export interface APPMain_GF_UpdateMaterial2Params {
    command?: APPMain_GF_UpdateMaterial | null;
}

export interface APPMain_GF_GetUoM2Params {
    command?: APPMain_GF_GetUoM | null;
}

export interface APPMain_GF_CreateBoM2Params {
    command?: APPMain_GF_CreateBoM | null;
}

export interface APPMain_GF_InsertRunningScan2Params {
    command?: APPMain_GF_InsertRunningScan | null;
}

export interface APPMain_GF_AllowKWAChecksExecution2Params {
    command?: APPMain_GF_AllowKWAChecksExecution | null;
}

export interface APPMain_GF_SendPackagingPrinterData2Params {
    command?: APPMain_GF_SendPackagingPrinterData | null;
}

export interface APPMain_DeleteMaterial2Params {
    command?: APPMain_DeleteMaterial | null;
}

export interface APPMain_GF_ClassificationDataImport2Params {
    command?: APPMain_GF_ClassificationDataImport | null;
}

export interface APPMain_GF_ClassificationDataRequest2Params {
    command?: APPMain_GF_ClassificationDataRequest | null;
}

export interface APPMain_GF_OnAssistedPickingCompleteWorkOrderOperationSerialized2Params {
    command?: APPMain_GF_OnAssistedPickingCompleteWorkOrderOperationSerialized | null;
}

export interface APPMain_GF_CompleteEquipmentPLCTask2Params {
    command?: APPMain_GF_CompleteEquipmentPLCTask | null;
}

export interface APPMain_GF_OnAssistedPickingStopped2Params {
    command?: APPMain_GF_OnAssistedPickingStopped | null;
}

export interface APPMain_GF_OnAssistedPickingStartWorkOrderOperationSerialized2Params {
    command?: APPMain_GF_OnAssistedPickingStartWorkOrderOperationSerialized | null;
}

export interface APPMain_GF_DeleteReworkProcessAssignmentEntry2Params {
    command?: APPMain_GF_DeleteReworkProcessAssignmentEntry | null;
}

export interface APPMain_GF_OnEPLCStartWorkOrderOperationSerialized2Params {
    command?: APPMain_GF_OnEPLCStartWorkOrderOperationSerialized | null;
}

export interface APPMain_GF_InsertReworkProcessAssignmentEntry2Params {
    command?: APPMain_GF_InsertReworkProcessAssignmentEntry | null;
}

export interface APPMain_GF_SendMESDataToEquipmentPLC2Params {
    command?: APPMain_GF_SendMESDataToEquipmentPLC | null;
}

export interface APPMain_GF_UpdateReworkProcessAssignmentEntry2Params {
    command?: APPMain_GF_UpdateReworkProcessAssignmentEntry | null;
}

export interface APPMain_GF_OnEPLCCompleteWorkOrderOperationSerialized2Params {
    command?: APPMain_GF_OnEPLCCompleteWorkOrderOperationSerialized | null;
}

export interface APPMain_GF_ResetTag2Params {
    command?: APPMain_GF_ResetTag | null;
}

export interface APPMain_GF_StartEquipmentPLCOperation2Params {
    command?: APPMain_GF_StartEquipmentPLCOperation | null;
}

export interface APPMain_GF_CompleteEquipmentPLCOperation2Params {
    command?: APPMain_GF_CompleteEquipmentPLCOperation | null;
}

export interface APPMain_GF_OnCarrierArrived2Params {
    command?: APPMain_GF_OnCarrierArrived | null;
}

export interface APPMain_GF_StartLineControllerOperation2Params {
    command?: APPMain_GF_StartLineControllerOperation | null;
}

export interface APPMain_GF_OnChangeNonConformanceEntity2Params {
    command?: APPMain_GF_OnChangeNonConformanceEntity | null;
}

export interface APPMain_GF_OnLineControllerCompleteWorkOrderOperationSerialized2Params {
    command?: APPMain_GF_OnLineControllerCompleteWorkOrderOperationSerialized | null;
}

export interface APPMain_GF_CompleteLineControllerOperation2Params {
    command?: APPMain_GF_CompleteLineControllerOperation | null;
}

export interface APPMain_GF_ResetAutomationNodeTags2Params {
    command?: APPMain_GF_ResetAutomationNodeTags | null;
}

export interface APPMain_GF_SendCarrierToStation2Params {
    command?: APPMain_GF_SendCarrierToStation | null;
}

export interface APPMain_GF_CreateGFFile2Params {
    command?: APPMain_GF_CreateGFFile | null;
}

export interface APPMain_GF_ManageMarking2Params {
    command?: APPMain_GF_ManageMarking | null;
}

export interface RepairWorkInstruction2Params {
    command?: RepairWorkInstruction | null;
}

export interface CreateActivityList2Params {
    command?: CreateActivityList | null;
}

export interface RepairMaterialConsumption2Params {
    command?: RepairMaterialConsumption | null;
}

export interface MarkForCleaningToolList2Params {
    command?: MarkForCleaningToolList | null;
}

export interface CreateCustomActivity2Params {
    command?: CreateCustomActivity | null;
}

export interface MarkForCleaningWorkOrderList2Params {
    command?: MarkForCleaningWorkOrderList | null;
}

export interface RepairToolUsage2Params {
    command?: RepairToolUsage | null;
}

export interface UpdateWorkOrderStatusAndPropertiesCommand2Params {
    command?: UpdateWorkOrderStatusAndPropertiesCommand | null;
}

export interface MarkForCleaningMTUList2Params {
    command?: MarkForCleaningMTUList | null;
}

export interface MarkForCleaningExecutionGroupList2Params {
    command?: MarkForCleaningExecutionGroupList | null;
}

export interface RepairQualityInspection2Params {
    command?: RepairQualityInspection | null;
}

export interface RepairScrewingToolUsage2Params {
    command?: RepairScrewingToolUsage | null;
}

export interface GroupWoOpsTotallyInExecGroupByType2Params {
    command?: GroupWoOpsTotallyInExecGroupByType | null;
}

export interface SetToBeCollectedDocumentOnStep2Params {
    command?: SetToBeCollectedDocumentOnStep | null;
}

export interface APPMain_GF_DownloadAndAddDocuments2Params {
    command?: APPMain_GF_DownloadAndAddDocuments | null;
}

export interface APPMain_GF_HandleWorkOrderIdScanFromShopfloor2Params {
    command?: APPMain_GF_HandleWorkOrderIdScanFromShopfloor | null;
}

export interface APPMain_GF_ManageWorkOrderIdScanFromShopfloor2Params {
    command?: APPMain_GF_ManageWorkOrderIdScanFromShopfloor | null;
}
